export const personen = [
    {
        "ID": "10001",
        "NAME": "Habsburg, Ferdinand\u00a0III. (1608\u20131657), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1608 Jul 13",
        "DATEOFDEATH": "1657 Apr 02",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "10002",
        "NAME": "Thun, Christoph Simon (1582\u20131635), Gro\u00dfprior des Malteserordens in Ungarn",
        "DATEOFBIRTH": "1582 Sep 12",
        "DATEOFDEATH": "1635 Mar 27",
        "PLACEOFBIRTH": "Kastelpfund",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10003",
        "NAME": "Trauttmansdorff, Maximilian (1584\u20131650), Obersthofmeister",
        "DATEOFBIRTH": "1584 Mai 23",
        "DATEOFDEATH": "1650 Jun 08",
        "PLACEOFBIRTH": "Gleichenberg in der Steiermark",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "10004",
        "NAME": "Auersperg, Johann Weikhard (1615\u20131677), Obersthofmeister",
        "DATEOFBIRTH": "1615 Mar 11",
        "DATEOFDEATH": "1677 Nov 13",
        "PLACEOFBIRTH": "Seisenberg in der Krain",
        "PLACEOFDEATH": "Laibach:Franziskanerkirche"
    },
    {
        "ID": "10005",
        "NAME": "Dietrichstein, Siegmund Ludwig (1600\u20131653), Hofkammerpr\u00e4sident von Inner\u00f6sterreich",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1653 Okt 18",
        "PLACEOFBIRTH": "Weixelst\u00e4tten",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10006",
        "NAME": "Habsburg, Leopold Wilhelm (1614\u20131662), Statthalter der Spanischen Niederlande",
        "DATEOFBIRTH": "1614 Jan 05",
        "DATEOFDEATH": "1662 Nov 20",
        "PLACEOFBIRTH": "Neustadt im Steinfeld",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "10007",
        "NAME": "Thun, Johann Siegmund (1594\u20131646), Statthalter von B\u00f6hmen",
        "DATEOFBIRTH": "1594 Sep 20",
        "DATEOFDEATH": "1646 Jun 29",
        "PLACEOFBIRTH": "Kastelpfund",
        "PLACEOFDEATH": "Tetschen"
    },
    {
        "ID": "10008",
        "NAME": "Bubna, Heinrich Johann (1596\u20131653), Landeshauptmann von Glatz",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1653 Apr 13",
        "PLACEOFBIRTH": "Litice im Adlergebirge",
        "PLACEOFDEATH": "Glatz"
    },
    {
        "ID": "10009",
        "NAME": "Breunner, Siegfried Christoph (1569\u20131651), Statthalter von Nieder\u00f6sterreich",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1651 Aug 22",
        "PLACEOFBIRTH": "Staatz im Weinviertel",
        "PLACEOFDEATH": "Asparn an der Zaya"
    },
    {
        "ID": "10010",
        "NAME": "Kuefstein, Johann Ludwig (1582\u20131656), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1582 Jun 11",
        "DATEOFDEATH": "1656 Sep 27",
        "PLACEOFBIRTH": "Greillenstein",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "10011",
        "NAME": "Kurtz von Senftenau, Ferdinand Siegmund (1592\u20131659), Reichsvizekanzler",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1659 Mar 24",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10012",
        "NAME": "Habsburg, Ferdinand\u00a0II. (1578\u20131637), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1578 Jul 09",
        "DATEOFDEATH": "1637 Feb 15",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10013",
        "NAME": "Lippay, Georg (1600\u20131666), Erzbischof von Gran",
        "DATEOFBIRTH": "1600 Okt 09",
        "DATEOFDEATH": "1666 Jan 30",
        "PLACEOFBIRTH": "Pressburg",
        "PLACEOFDEATH": "Tyrnau"
    },
    {
        "ID": "10014",
        "NAME": "Mannagetta, Johann Wilhelm (1588\u20131666), Hofarzt",
        "DATEOFBIRTH": "1588 Mai 01",
        "DATEOFDEATH": "1666 Mai 31",
        "PLACEOFBIRTH": "Wilhelmsburg an der Traisen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10015",
        "NAME": "Mansfeld, Bruno (1576\u20131644), Oberstj\u00e4germeister",
        "DATEOFBIRTH": "1576 Sep 18",
        "DATEOFDEATH": "1644 Sep 16",
        "PLACEOFBIRTH": "Bornstedt im Harz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10016",
        "NAME": "Marradas, Balthasar (1560\u20131638), Statthalter von B\u00f6hmen",
        "DATEOFBIRTH": "1560 Nov 28",
        "DATEOFDEATH": "1638 Aug 12",
        "PLACEOFBIRTH": "Valencia",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10017",
        "NAME": "Martinitz, Jaroslaus (1582\u20131649), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1582 Jan 06",
        "DATEOFDEATH": "1649 Nov 21",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10018",
        "NAME": "Meggau, Franziska (1609\u20131676), Obersthofmeisterin",
        "DATEOFBIRTH": "1609 Okt 28",
        "DATEOFDEATH": "1676 Okt 22",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10019",
        "NAME": "Oettingen, Ernst (1594\u20131670), Reichshofratspr\u00e4sident",
        "DATEOFBIRTH": "1594 Aug 15",
        "DATEOFDEATH": "1670 Mar 02",
        "PLACEOFBIRTH": "Wallerstein",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10020",
        "NAME": "Oettingen, Wolfgang (1629\u20131708), Obersthofmeister",
        "DATEOFBIRTH": "1629 Feb 01",
        "DATEOFDEATH": "1708 Okt 06",
        "PLACEOFBIRTH": "Wallerstein",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10021",
        "NAME": "Dietrichstein, Maximilian (1596\u20131655), Obersthofmeister",
        "DATEOFBIRTH": "1596 Jun 27",
        "DATEOFDEATH": "1655 Nov 06",
        "PLACEOFBIRTH": "Nikolsburg in M\u00e4hren",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10022",
        "NAME": "Wolfradt, Anton (1581\u20131639), Bischof von Wien",
        "DATEOFBIRTH": "1581 Jul 09",
        "DATEOFDEATH": "1639 Apr 01",
        "PLACEOFBIRTH": "K\u00f6ln am Rhein",
        "PLACEOFDEATH": "Wien:Stephansdom"
    },
    {
        "ID": "10023",
        "NAME": "Slavata, Wilhelm (1572\u20131652), Oberstkanzler von B\u00f6hmen",
        "DATEOFBIRTH": "1572 Dez 01",
        "DATEOFDEATH": "1652 Jan 19",
        "PLACEOFBIRTH": "\u010cest\u00edn",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10024",
        "NAME": "Meggau, Leonhard Helfried (1577\u20131644), Obersthofmeister",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1644 Apr 23",
        "PLACEOFBIRTH": "Kreuzen im M\u00fchlviertel",
        "PLACEOFDEATH": "Greinburg"
    },
    {
        "ID": "10025",
        "NAME": "Thun, Christoph Simon (1615\u20131643), Mundschenk",
        "DATEOFBIRTH": "1615 Nov 17",
        "DATEOFDEATH": "1643 Nov 14",
        "PLACEOFBIRTH": "Kastelpfund",
        "PLACEOFDEATH": "Brieg"
    },
    {
        "ID": "10026",
        "NAME": "Mansfeld, Wolfgang (1575\u20131638), Geheimer Rat",
        "DATEOFBIRTH": "1575 Dez 22",
        "DATEOFDEATH": "1638 Mai 15",
        "PLACEOFBIRTH": "Bornstedt im Harz",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "10027",
        "NAME": "Leslie, Walter (1606\u20131667), Geheimer Rat",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1667 Mar 04",
        "PLACEOFBIRTH": "Balquhain",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "10028",
        "NAME": "Hohenzollern, Georg Friedrich (1604\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1633 Dez 06",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Uttenweiler"
    },
    {
        "ID": "10029",
        "NAME": "P\u00e1lffy, Johann (1588\u20131646), Ungarischer Kronh\u00fcter",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1646 Mai 29",
        "PLACEOFBIRTH": "Bibersburg",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "10030",
        "NAME": "Waldstein, Albrecht (1583\u20131634), Oberbefehlshaber der Streitkr\u00e4fte",
        "DATEOFBIRTH": "1583 Sep 24",
        "DATEOFDEATH": "1634 Feb 25",
        "PLACEOFBIRTH": "Hermanitz an der Elbe",
        "PLACEOFDEATH": "Eger in B\u00f6hmen"
    },
    {
        "ID": "10031",
        "NAME": "Waldstein, Maximilian (1598\u20131655), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1655 Feb 19",
        "PLACEOFBIRTH": "Znaim",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "10032",
        "NAME": "P\u00e1lffy, Stephan (1586\u20131646), Ungarischer Kronh\u00fcter",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1646 Mar 06",
        "PLACEOFBIRTH": "Bibersburg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10033",
        "NAME": "P\u00e1lffy, Niklas (1593\u20131621), K\u00e4mmerer",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "Bibersburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10034",
        "NAME": "P\u00e1lffy, Paul (1592\u20131653), Palatin von Ungarn",
        "DATEOFBIRTH": "1592 Jan 19",
        "DATEOFDEATH": "1653 Nov 26",
        "PLACEOFBIRTH": "Bibersburg",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "10035",
        "NAME": "P\u00e1lffy, Niklas (1552\u20131600), Geheimer Rat",
        "DATEOFBIRTH": "1552 Dez 07",
        "DATEOFDEATH": "1600 Apr 23",
        "PLACEOFBIRTH": "Cs\u00e1br\u00e1g",
        "PLACEOFDEATH": "Bibersburg"
    },
    {
        "ID": "10036",
        "NAME": "P\u00e1lffy, Niklas (1620\u20131679), Ungarischer Kronh\u00fcter",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1679 Aug 12",
        "PLACEOFBIRTH": "Pressburg",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "10037",
        "NAME": "Stralendorff, Peter Heinrich (1577\u20131637), Reichsvizekanzler",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1637 Okt 19",
        "PLACEOFBIRTH": "Heiligenstadt im Eichsfeld",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "10038",
        "NAME": "Stralendorff, Leopold (1545\u20131626), Reichsvizekanzler",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1626 Sep 04",
        "PLACEOFBIRTH": "Goldebee",
        "PLACEOFDEATH": "Heiligenstadt im Eichsfeld"
    },
    {
        "ID": "10039",
        "NAME": "M\u00f6rsperg, Julius Neidhard (1590\u20131642), Geheimer Rat",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10040",
        "NAME": "Habsburg, Ferdinand\u00a0IV. (1633\u20131654), K\u00f6nig des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1633 Sep 08",
        "DATEOFDEATH": "1654 Jul 09",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "10041",
        "NAME": "Waldstein, Adam (1569\u20131638), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1569 Jun 08",
        "DATEOFDEATH": "1638 Aug 24",
        "PLACEOFBIRTH": "Perutz",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10042",
        "NAME": "Carretto, Franz (1593\u20131651), Markgraf von Grana",
        "DATEOFBIRTH": "1593 Mar 01",
        "DATEOFDEATH": "1651 Nov 09",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "10043",
        "NAME": "Gallas, Matthias (1588\u20131647), Geheimer Rat",
        "DATEOFBIRTH": "1588 Okt 17",
        "DATEOFDEATH": "1647 Apr 25",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10044",
        "NAME": "Reck, Johann (1584\u20131647), Reichshofratspr\u00e4sident",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1647 Dez 11",
        "PLACEOFBIRTH": "Steinfurt im Dreingau",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "10045",
        "NAME": "Schwarzenberg, Johann Adolf (1615\u20131683), Obersthofmeister",
        "DATEOFBIRTH": "1615 Sep 20",
        "DATEOFDEATH": "1683 Mai 26",
        "PLACEOFBIRTH": "Waibelskirchen in Lothringen",
        "PLACEOFDEATH": "Laxenburg"
    },
    {
        "ID": "10046",
        "NAME": "Teuffenbach, Rudolf (1582\u20131653), Geheimer Rat",
        "DATEOFBIRTH": "1582 Nov 26",
        "DATEOFDEATH": "1653 Mar 04",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10047",
        "NAME": "Khevenh\u00fcller, Franz Christoph (1588\u20131650), Geheimer Rat",
        "DATEOFBIRTH": "1588 Feb 21",
        "DATEOFDEATH": "1650 Jun 12",
        "PLACEOFBIRTH": "Landskron in K\u00e4rnten",
        "PLACEOFDEATH": "Baden am Gebirge"
    },
    {
        "ID": "10048",
        "NAME": "Trautson, Johann Franz (1605\u20131663), Statthalter von Nieder\u00f6sterreich",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1663 Mai 26",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "10049",
        "NAME": "Schlick, Heinrich (1583\u20131650), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1650 Jan 05",
        "PLACEOFBIRTH": "Eger in B\u00f6hmen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10050",
        "NAME": "Habsburg, Leopold\u00a0I. (1640\u20131705), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1640 Jun 09",
        "DATEOFDEATH": "1705 Mai 05",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10051",
        "NAME": "Liechtenstein von Nikolsburg, Karl (1569\u20131627), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1569 Jun 30",
        "DATEOFDEATH": "1627 Feb 12",
        "PLACEOFBIRTH": "Feldsberg im Weinviertel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10052",
        "NAME": "Liechtenstein von Nikolsburg, Maximilian (1578\u20131643), Oberststallmeister",
        "DATEOFBIRTH": "1578 Nov 06",
        "DATEOFDEATH": "1643 Apr 28",
        "PLACEOFBIRTH": "Feldsberg im Weinviertel",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "10053",
        "NAME": "Liechtenstein von Nikolsburg, Gundaker (1580\u20131658), Obersthofmeister",
        "DATEOFBIRTH": "1580 Jan 30",
        "DATEOFDEATH": "1658 Aug 05",
        "PLACEOFBIRTH": "Eisgrub in M\u00e4hren",
        "PLACEOFDEATH": "Wilfersdorf im Weinviertel"
    },
    {
        "ID": "10054",
        "NAME": "Savelli, Friedrich (1585\u20131649)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1649 Dez 19",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "10055",
        "NAME": "Colloredo, Johann Baptist (1598\u20131649)",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1649 Okt 13",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": "Heraklion"
    },
    {
        "ID": "10056",
        "NAME": "Beck von Beaufort, Johann (1588\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1648 Aug 30",
        "PLACEOFBIRTH": "Stadtgrund in Luxemburg",
        "PLACEOFDEATH": "Atrecht"
    },
    {
        "ID": "10057",
        "NAME": "Lobkowicz, Ulrich Adam (1610\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1610 Okt 16",
        "DATEOFDEATH": "1649 Okt 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10058",
        "NAME": "Lobkowicz, Wenzel Euseb (1609\u20131677), Obersthofmeister",
        "DATEOFBIRTH": "1609 Jan 20",
        "DATEOFDEATH": "1677 Apr 22",
        "PLACEOFBIRTH": "Raudnitz an der Elbe",
        "PLACEOFDEATH": "Raudnitz an der Elbe"
    },
    {
        "ID": "10059",
        "NAME": "Lobkowicz, Christoph Ferdinand (1614\u20131658), Statthalter von Schlesien",
        "DATEOFBIRTH": "1614 Okt 09",
        "DATEOFDEATH": "1658 Jul 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10060",
        "NAME": "Habsburg, Maximilian\u00a0II. (1527\u20131576), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1527 Jul 31",
        "DATEOFDEATH": "1576 Okt 12",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "10061",
        "NAME": "Waldstein, Ferdinand Ernst (1624\u20131657), Oberstlandk\u00e4mmerer von B\u00f6hmen",
        "DATEOFBIRTH": "1624",
        "DATEOFDEATH": "1657 Feb 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10062",
        "NAME": "Waldstein, Berthold (1604\u20131632), K\u00e4mmerer",
        "DATEOFBIRTH": "1604 Nov 08",
        "DATEOFDEATH": "1632 Nov 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "L\u00fctzen"
    },
    {
        "ID": "10063",
        "NAME": "Waldstein, Maximilian Adam (1627\u20131706), Reichshofrat",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1706 Nov 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10064",
        "NAME": "Waldstein, Burian Lassel (1596\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1645 Okt 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10065",
        "NAME": "Waldstein, Johann Viktorin (1616\u20131673), K\u00e4mmerer",
        "DATEOFBIRTH": "1616 Apr 01",
        "DATEOFDEATH": "1673",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10066",
        "NAME": "Waldstein, Karl Ferdinand (1634\u20131702), Obersthofmeister",
        "DATEOFBIRTH": "1634",
        "DATEOFDEATH": "1702 Apr 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10067",
        "NAME": "Waldstein, Adam Franz (1625\u20131666), K\u00e4mmerer",
        "DATEOFBIRTH": "1625",
        "DATEOFDEATH": "1666",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10068",
        "NAME": "Marschall von Pappenheim, Gottfried Heinrich (1594\u20131632), Reichshofrat",
        "DATEOFBIRTH": "1594 Jun 08",
        "DATEOFDEATH": "1632 Nov 16",
        "PLACEOFBIRTH": "Treuchtlingen",
        "PLACEOFDEATH": "L\u00fctzen"
    },
    {
        "ID": "10069",
        "NAME": "Marschall von Pappenheim, Wolfgang Adam (1618\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1618 Nov 11",
        "DATEOFDEATH": "1647 Jun 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10070",
        "NAME": "Tserclaes von Tilly, Johann (1559\u20131632), Hofkriegsrat",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1632 Apr 30",
        "PLACEOFBIRTH": "Tilly in Brabant",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "10071",
        "NAME": "Sinzendorf, Rudolf (1625\u20131677), Reichshofrat",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1677 Nov 29",
        "PLACEOFBIRTH": "Ernstbrunn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10072",
        "NAME": "Piccolomini, Oktavius (1599\u20131656), Geheimer Rat",
        "DATEOFBIRTH": "1599 Nov 09",
        "DATEOFDEATH": "1656 Aug 10",
        "PLACEOFBIRTH": "Pisa",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10073",
        "NAME": "Esterh\u00e1zy, Niklas (1583\u20131645), Palatin von Ungarn",
        "DATEOFBIRTH": "1583 Apr 08",
        "DATEOFDEATH": "1645 Sep 11",
        "PLACEOFBIRTH": "Gallandau",
        "PLACEOFDEATH": "Eisenstadt im Burgenland"
    },
    {
        "ID": "10074",
        "NAME": "Thurn, Heinrich Matthias (1567\u20131640), Burggraf von Karlstein",
        "DATEOFBIRTH": "1567 Feb 24",
        "DATEOFDEATH": "1640 Feb 07",
        "PLACEOFBIRTH": "Lipnitz an der Sasau",
        "PLACEOFDEATH": "Pernau in Livland"
    },
    {
        "ID": "10075",
        "NAME": "Khlesl, Melchior (1552\u20131630), Bischof von Wien",
        "DATEOFBIRTH": "1552 Feb 19",
        "DATEOFDEATH": "1630 Sep 18",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "10076",
        "NAME": "Puchheim, Johann Rudolf (1600\u20131651), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1651 Jan 17",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "10077",
        "NAME": "Puchheim, Johann Christoph (1605\u20131657), Geheimer Rat",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1657",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10078",
        "NAME": "Gonzaga, Hannibal (1602\u20131668), Obersthofmeister",
        "DATEOFBIRTH": "1602",
        "DATEOFDEATH": "1668 Aug 02",
        "PLACEOFBIRTH": "Bozzolo",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "10079",
        "NAME": "Salm, Maximilian (1563\u2013\u00a0\u00a0\u00a0\u00a0), Oberststallmeister",
        "DATEOFBIRTH": "1563 Apr 14",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neuburg am Inn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10080",
        "NAME": "Habsburg, Rudolf\u00a0II. (1552\u20131612), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1552 Jul 18",
        "DATEOFDEATH": "1612 Jan 20",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10081",
        "NAME": "Khisl von Kaltenbrunn, Johann Jakob (1565\u20131638), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1565",
        "DATEOFDEATH": "1638 Feb 15",
        "PLACEOFBIRTH": "Kaltenbrunn an der Laibach",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10082",
        "NAME": "Eggenberg, Johann Ulrich (1568\u20131634), Obersthofmeister",
        "DATEOFBIRTH": "1568 Jun 16",
        "DATEOFDEATH": "1634 Okt 18",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "10083",
        "NAME": "Porcia, Johann Ferdinand (1605\u20131665), Obersthofmeister",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1665 Feb 19",
        "PLACEOFBIRTH": "Venedig",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10084",
        "NAME": "Lamberg, Johann Maximilian (1608\u20131682), Obersthofmeister",
        "DATEOFBIRTH": "1608 Nov 21",
        "DATEOFDEATH": "1682 Dez 13",
        "PLACEOFBIRTH": "Br\u00fcnn in M\u00e4hren",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10085",
        "NAME": "Dietrichstein, Ferdinand (1628\u20131698), Obersthofmeister",
        "DATEOFBIRTH": "1628 Jul 05",
        "DATEOFDEATH": "1698 Nov 28",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10086",
        "NAME": "Auersperg, Volkhard (1530\u20131591), Oberststallmeister",
        "DATEOFBIRTH": "1530",
        "DATEOFDEATH": "1591 Mai 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Baden am Gebirge"
    },
    {
        "ID": "10087",
        "NAME": "Khuen von Belasi, Rudolf (1533\u20131581), Oberststallmeister",
        "DATEOFBIRTH": "1533 Jun 27",
        "DATEOFDEATH": "1581 Jun 29",
        "PLACEOFBIRTH": "Lichtenberg im Pinzgau",
        "PLACEOFDEATH": "Wien:Dorotheerkirche"
    },
    {
        "ID": "10088",
        "NAME": "F\u00fcrstenberg, Albrecht (1557\u20131599), Oberststallmeister",
        "DATEOFBIRTH": "1557 Mar 15",
        "DATEOFDEATH": "1599 Sep 13",
        "PLACEOFBIRTH": "Blumberg in der Baar",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10089",
        "NAME": "Fugger, Johann Ernst (1590\u20131639), Reichshofratspr\u00e4sident",
        "DATEOFBIRTH": "1590 Jul 24",
        "DATEOFDEATH": "1639 Dez 20",
        "PLACEOFBIRTH": "Stettenfels",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "10090",
        "NAME": "Habsburg, Matthias\u00a0I. (1557\u20131619), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1557 Feb 24",
        "DATEOFDEATH": "1619 Mar 20",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "10091",
        "NAME": "Starhemberg, Heinrich Wilhelm (1593\u20131675), Obersthofmarschall",
        "DATEOFBIRTH": "1593 Feb 28",
        "DATEOFDEATH": "1675 Apr 02",
        "PLACEOFBIRTH": "Riedegg im M\u00fchlviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10092",
        "NAME": "Starhemberg, Ernst Rudger (1638\u20131701), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1638 Jan 12",
        "DATEOFDEATH": "1701 Jun 04",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Konradsw\u00f6rth auf der Wieden"
    },
    {
        "ID": "10093",
        "NAME": "Losenstein, Georg Achaz (1597\u20131653), Oberststallmeister",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1653 Nov 25",
        "PLACEOFBIRTH": "Gschwendt an der Krems",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "10094",
        "NAME": "Paar, Rudolf (1577\u20131626), Oberststallmeister",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1626 Apr 30",
        "PLACEOFBIRTH": "Hartberg in der Steiermark",
        "PLACEOFDEATH": "Karlstadt in Kroatien"
    },
    {
        "ID": "10095",
        "NAME": "Nostitz, Johann Hartwig (1610\u20131683), Oberstkanzler von B\u00f6hmen",
        "DATEOFBIRTH": "1610",
        "DATEOFDEATH": "1683 Mar 23",
        "PLACEOFBIRTH": "Kunzendorf unter dem Walde",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10096",
        "NAME": "Harrach, Franz Albrecht (1614\u20131666), Oberststallmeister",
        "DATEOFBIRTH": "1614 Nov 25",
        "DATEOFDEATH": "1666 Mai 23",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "10097",
        "NAME": "Sprinzenstein, Simon Hieronym (1594\u20131639), Reichshofrat",
        "DATEOFBIRTH": "1594 Okt 24",
        "DATEOFDEATH": "1639 Jul 30",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "10098",
        "NAME": "Trivulzio, Klaudius (1538\u20131591), Oberststallmeister",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1591 Apr 02",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Prag:Thomaskirche"
    },
    {
        "ID": "10099",
        "NAME": "Cavriani, Oktavian (1560\u20131618), Oberststallmeister",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1618 Jan 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10100",
        "NAME": "Habsburg, Karl (1540\u20131590), Landesherr von Inner\u00f6sterreich",
        "DATEOFBIRTH": "1540 Jun 03",
        "DATEOFDEATH": "1590 Jul 10",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10101",
        "NAME": "Aldringen, Johann (1588\u20131634), Hofkriegsrat",
        "DATEOFBIRTH": "1588 Dez 10",
        "DATEOFDEATH": "1634 Jul 22",
        "PLACEOFBIRTH": "Diedenhofen",
        "PLACEOFDEATH": "Landshut in Niederbayern"
    },
    {
        "ID": "10102",
        "NAME": "Althan, Michael Adolf (1574\u20131636), Hofkriegsrat",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1636 Mai 07",
        "PLACEOFBIRTH": "Murstetten",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10103",
        "NAME": "Breunner, Jakob (1566\u20131606), Obersthofmarschall",
        "DATEOFBIRTH": "1566 Feb 28",
        "DATEOFDEATH": "1606 Sep 01",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10104",
        "NAME": "Breunner, Maximilian (1593\u20131635), Geheimer Rat",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1635 Feb 06",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Oedenburg"
    },
    {
        "ID": "10105",
        "NAME": "Collalto, Reimbald (1579\u20131630), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1579 Sep 21",
        "DATEOFDEATH": "1630 Nov 18",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Chur in Graub\u00fcnden"
    },
    {
        "ID": "10106",
        "NAME": "Colloredo, Rudolf (1585\u20131657), Gro\u00dfprior des Malteserordens in B\u00f6hmen",
        "DATEOFBIRTH": "1585 Nov 02",
        "DATEOFDEATH": "1657 Jan 24",
        "PLACEOFBIRTH": "Budweis in B\u00f6hmen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10107",
        "NAME": "Dietrichstein, Franz (1570\u20131636), Bischof von Olm\u00fctz",
        "DATEOFBIRTH": "1570 Aug 22",
        "DATEOFDEATH": "1636 Sep 19",
        "PLACEOFBIRTH": "Madrid",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "10108",
        "NAME": "Gonzaga, Eleonora (1598\u20131655), Kaiserin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1598 Sep 23",
        "DATEOFDEATH": "1655 Jun 27",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10109",
        "NAME": "Habsburg, Maria Anna (1606\u20131646), Kaiserin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1606 Aug 18",
        "DATEOFDEATH": "1646 Mai 13",
        "PLACEOFBIRTH": "San Lorenzo de El Escorial",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "10110",
        "NAME": "Habsburg, Z\u00e4zilia Renata (1611\u20131644), K\u00f6nigin von Polen",
        "DATEOFBIRTH": "1611 Jul 16",
        "DATEOFDEATH": "1644 Mar 24",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Vilnius"
    },
    {
        "ID": "10111",
        "NAME": "Habsburg, Maria Anna (1610\u20131665), Herzogin in Bayern",
        "DATEOFBIRTH": "1610 Jan 13",
        "DATEOFDEATH": "1665 Sep 25",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "10112",
        "NAME": "Harrach, Ernst Albrecht (1598\u20131667), Erzbischof von Prag",
        "DATEOFBIRTH": "1598 Nov 04",
        "DATEOFDEATH": "1667 Okt 25",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10113",
        "NAME": "Harrach, Karl (1570\u20131628), Geheimer Rat",
        "DATEOFBIRTH": "1570",
        "DATEOFDEATH": "1628 Mai 16",
        "PLACEOFBIRTH": "Rohrau an der Leitha",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10114",
        "NAME": "Harrach, Leonhard Karl (1594\u20131645), Obersthofmeister",
        "DATEOFBIRTH": "1594 Jun 04",
        "DATEOFDEATH": "1645 Jun 30",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10115",
        "NAME": "Herberstein, Bernhard (1566\u20131624), Oberststallmeister",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "1624 Jul 30",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10116",
        "NAME": "Valmarana, Margarita (1580\u20131644), Obersthofmeisterin",
        "DATEOFBIRTH": "1580",
        "DATEOFDEATH": "1644 Apr 24",
        "PLACEOFBIRTH": "Vicenza",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10117",
        "NAME": "Hoyos, Johann Balthasar (1583\u20131632), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1632 Apr 12",
        "PLACEOFBIRTH": "Stixenstein",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10118",
        "NAME": "Khevenh\u00fcller, Johann (1538\u20131606), K\u00e4mmerer",
        "DATEOFBIRTH": "1538 Apr 16",
        "DATEOFDEATH": "1606 Mai 04",
        "PLACEOFBIRTH": "Spittal an der Drau",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "10119",
        "NAME": "Kollonitz, Ernst (1582\u20131638), Hofkriegsrat",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1638 Dez 12",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "10120",
        "NAME": "Sinzendorf, Georg Ludwig (1616\u20131680), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1616 Jun 17",
        "DATEOFDEATH": "1680 Dez 14",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10121",
        "NAME": "Martinitz, Georg Adam (1602\u20131651), Oberstkanzler von B\u00f6hmen",
        "DATEOFBIRTH": "1602 Mar 29",
        "DATEOFDEATH": "1651 Nov 12",
        "PLACEOFBIRTH": "Smetschna",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10122",
        "NAME": "Kolowrat, Ulrich Franz (1607\u20131650), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1607 Jul 28",
        "DATEOFDEATH": "1650 Jan 03",
        "PLACEOFBIRTH": "Schichowitz",
        "PLACEOFDEATH": "Budweis in B\u00f6hmen"
    },
    {
        "ID": "10123",
        "NAME": "Michna von Waizenhofen, Paul (1580\u20131632), Geheimer Rat",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1632 Aug 26",
        "PLACEOFBIRTH": "Budin an der Eger",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "10124",
        "NAME": "Rottal, Johann (1605\u20131674), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1674 Dez 04",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10125",
        "NAME": "Gonzaga, Karl (1616\u20131680), F\u00fcrst von Castiglione",
        "DATEOFBIRTH": "1616 Mai 03",
        "DATEOFDEATH": "1680 Mai 21",
        "PLACEOFBIRTH": "Castiglione delle Stiviere",
        "PLACEOFDEATH": "Solferino"
    },
    {
        "ID": "10126",
        "NAME": "Unterholzer von Kranichberg, Johann Baptist (1561\u20131632), Hofkammerrat",
        "DATEOFBIRTH": "1561",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kranichberg am Wechsel"
    },
    {
        "ID": "10127",
        "NAME": "Polheim, Gundaker (1575\u20131644), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1575 Apr 04",
        "DATEOFDEATH": "1644 Jan 08",
        "PLACEOFBIRTH": "Lichtenegg im Hausruckviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10128",
        "NAME": "Wrzesowitz, Wilhelm (1572\u20131640), Oberstm\u00fcnzmeister in B\u00f6hmen",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1640",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10129",
        "NAME": "Trauttmansdorff, Johann Friedrich (1619\u20131696), Statthalter von B\u00f6hmen",
        "DATEOFBIRTH": "1619 Dez 11",
        "DATEOFDEATH": "1696 Feb 04",
        "PLACEOFBIRTH": "Feldbach in der Steiermark",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10130",
        "NAME": "Schwarzenberg, Georg Ludwig (1586\u20131646), Obersthofmarschall",
        "DATEOFBIRTH": "1586 Dez 24",
        "DATEOFDEATH": "1646 Jul 21",
        "PLACEOFBIRTH": "Straubing",
        "PLACEOFDEATH": "Freudenau in der Krain"
    },
    {
        "ID": "10131",
        "NAME": "Kraft von Lamersdorf, Ignaz (1592\u20131638), Abt von Lilienfeld",
        "DATEOFBIRTH": "1592 Feb 20",
        "DATEOFDEATH": "1638 Sep 29",
        "PLACEOFBIRTH": "Aachen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10132",
        "NAME": "Lobkowicz, Sidonius Albrecht (1568\u20131628), Oberstkanzler von B\u00f6hmen",
        "DATEOFBIRTH": "1568 Aug 15",
        "DATEOFDEATH": "1628 Jun 16",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10133",
        "NAME": "Germain von Lamormain, Wilhelm (1570\u20131648), Ordensoberer der Jesuiten in \u00d6sterreich",
        "DATEOFBIRTH": "1570 Dez 29",
        "DATEOFDEATH": "1648 Feb 22",
        "PLACEOFBIRTH": "Lamorm\u00e9nil",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10134",
        "NAME": "G\u00f6tz, Leonhard (1561\u20131640), Bischof von Lavant",
        "DATEOFBIRTH": "1561",
        "DATEOFDEATH": "1640 Nov 26",
        "PLACEOFBIRTH": "Feldkirch in Vorarlberg",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10135",
        "NAME": "Teufel von Guntersdorf, Johann Christoph (1567\u20131624), K\u00e4mmerer",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1624 Aug 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "10136",
        "NAME": "Teufel von Guntersdorf, Christoph Adolf (1599\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1650 Dez 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10137",
        "NAME": "Losenstein, Wolfgang Siegmund (1567\u20131626), Obersthofmarschall",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1626 Mar 19",
        "PLACEOFBIRTH": "Gschwendt an der Krems",
        "PLACEOFDEATH": "Gschwendt an der Krems"
    },
    {
        "ID": "10138",
        "NAME": "Muschinger, Vinzenz (1570\u20131628), Hofkammervizepr\u00e4sident",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1628 Nov 18",
        "PLACEOFBIRTH": "Gumpendorf",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "10139",
        "NAME": "Trauttmansdorff, Siegmund Friedrich (1571\u20131631), Hofkriegsrat",
        "DATEOFBIRTH": "1571 Mar 15",
        "DATEOFDEATH": "1631 Mai 05",
        "PLACEOFBIRTH": "Trautmannsdorf in der Steiermark",
        "PLACEOFDEATH": "Graz:Jesuitenkirche"
    },
    {
        "ID": "10140",
        "NAME": "Hase von Hasenburg, Jaroslaus (1614\u20131663), K\u00e4mmerer",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "Rade\u0161\u00edn",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10141",
        "NAME": "Verda von Verdenberg, Johann Baptist (1582\u20131648), Geheimer Rat",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1648 Sep 16",
        "PLACEOFBIRTH": "Campione am Luganersee",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "10142",
        "NAME": "Verda von Verdenberg, Johann Ferdinand (1626\u20131666), K\u00e4mmerer",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1666 Mar 27",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "10143",
        "NAME": "Wagen von Wagensperg, Johann Siegmund (1574\u20131640), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1574 Jan 18",
        "DATEOFDEATH": "1640 Nov 28",
        "PLACEOFBIRTH": "Pr\u00e4wald in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10144",
        "NAME": "Walderode, Johann Baptist (1593\u20131674), Reichshofrat",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1674 Jan 17",
        "PLACEOFBIRTH": "Sankt Vith",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10145",
        "NAME": "W\u00fcrben, Wenzel (1589\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1589 Okt 02",
        "DATEOFDEATH": "1649 Jul 29",
        "PLACEOFBIRTH": "Troppau",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "10146",
        "NAME": "Mansfeld, Philipp (1589\u20131657), Geheimer Rat",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1657 Apr 08",
        "PLACEOFBIRTH": "Bornstedt im Harz",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "10147",
        "NAME": "Sinzendorf, Johann Joachim (1620\u20131665), Hofkanzler",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1665 Nov 11",
        "PLACEOFBIRTH": "Ernstbrunn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10148",
        "NAME": "Thun, Johann Arbogast (1614\u20131646), St\u00e4belmeister",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "1646 Jan 28",
        "PLACEOFBIRTH": "Kastelpfund",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "10149",
        "NAME": "Wrzesowitz, Johann Weikhard (1624\u20131656), K\u00e4mmerer",
        "DATEOFBIRTH": "1624",
        "DATEOFDEATH": "1656 Aug 28",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": "Liebenau an der Warthe"
    },
    {
        "ID": "10150",
        "NAME": "Trautson, Paul Sixt (1548\u20131621), Obersthofmarschall",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1621 Jul 28",
        "PLACEOFBIRTH": "Stein am Gallian",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "10151",
        "NAME": "Hohenfeld, Otto Achaz (1614\u20131685), Mundschenk",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "1685 Mai 06",
        "PLACEOFBIRTH": "Aistersheim",
        "PLACEOFDEATH": "Aistersheim"
    },
    {
        "ID": "10152",
        "NAME": "Quiroga, Jakob (1574\u20131649), Mundschenk",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10153",
        "NAME": "Glauchau, Johann Matthias (1575\u20131633), Rentmeister in B\u00f6hmen",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1633 Jul 30",
        "PLACEOFBIRTH": "Glauchau",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10154",
        "NAME": "Trauttmansdorff, Ehrenreich Adam (1595\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1664 Okt 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10155",
        "NAME": "Manrique de Lara, Georg (1610\u20131651), St\u00e4belmeister",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1651",
        "PLACEOFBIRTH": "Desio in der Lombardei",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10156",
        "NAME": "Trauttmansdorff, Franz Anton (1630\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1630",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10157",
        "NAME": "Trauttmansdorff, Otto Ehrenreich (1586\u20131664), Hofkriegsrat",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "Frauenstein in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10158",
        "NAME": "Trauttmansdorff, Adam Matthias (1617\u20131684), Geheimer Rat",
        "DATEOFBIRTH": "1617",
        "DATEOFDEATH": "1684 Nov 02",
        "PLACEOFBIRTH": "Teinitz an der Radbusa",
        "PLACEOFDEATH": "Teinitz an der Radbusa"
    },
    {
        "ID": "10159",
        "NAME": "Trauttmansdorff, Siegmund Friedrich (1623\u20131675), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1623 Jan 05",
        "DATEOFDEATH": "1675 Okt 08",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10160",
        "NAME": "Trautson, Paul Sixt (1635\u20131678), K\u00e4mmerer",
        "DATEOFBIRTH": "1635 Feb 27",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "10161",
        "NAME": "Trautson, Franz Euseb (1642\u20131718), Geheimer Rat",
        "DATEOFBIRTH": "1642 Jan 30",
        "DATEOFDEATH": "1718",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "10162",
        "NAME": "Trautson, Johann Leopold (1659\u20131724), Obersthofmeister",
        "DATEOFBIRTH": "1659 Mai 21",
        "DATEOFDEATH": "1724 Okt 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "10163",
        "NAME": "Zinzendorf, Johann Joachim (1570\u20131626), K\u00e4mmerer",
        "DATEOFBIRTH": "1570 Dez 27",
        "DATEOFDEATH": "1626 Jan 29",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Karlsbach im M\u00fchlkreis"
    },
    {
        "ID": "10164",
        "NAME": "Zinzendorf, Johann Albrecht (1619\u20131683), Obersthofmeister",
        "DATEOFBIRTH": "1619 Aug 24",
        "DATEOFDEATH": "1683 Okt 06",
        "PLACEOFBIRTH": "Karlsbach im M\u00fchlkreis",
        "PLACEOFDEATH": "Oedenburg"
    },
    {
        "ID": "10165",
        "NAME": "Ungnad von Weissenwolff, David (1604\u20131672), Prinzipalkommissar",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1672 Mar 06",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "10166",
        "NAME": "Ungnad von Weissenwolff, Helmhard Christoph (1634\u20131702), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1634 Jan 02",
        "DATEOFDEATH": "1702 Feb 20",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "10167",
        "NAME": "Dohna, Maximilian Ernst (1615\u20131641), St\u00e4belmeister",
        "DATEOFBIRTH": "1615 Sep 10",
        "DATEOFDEATH": "1641 Jun 25",
        "PLACEOFBIRTH": "Wartenberg an der Weide",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10168",
        "NAME": "F\u00fcrstenberg, Ferdinand Friedrich (1623\u20131663), Geheimer Rat",
        "DATEOFBIRTH": "1623 Feb 06",
        "DATEOFDEATH": "1662 Aug 28",
        "PLACEOFBIRTH": "Konstanz im Hegau",
        "PLACEOFDEATH": "Donaueschingen"
    },
    {
        "ID": "10169",
        "NAME": "Cavriani, Friedrich (1597\u20131662), Obersthofmeister",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1662 Nov 06",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10170",
        "NAME": "Hohenfeld, Ferdinand (1612\u20131675), Hofkammervizepr\u00e4sident",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1675 Jan 04",
        "PLACEOFBIRTH": "Aistersheim",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10171",
        "NAME": "P\u0103tra\u0219cu, Michael (1615\u20131655), Erbprinz der Walachei",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1655 Sep 25",
        "PLACEOFBIRTH": "Fagreschmarkt",
        "PLACEOFDEATH": "Ja\u00dfenmarkt"
    },
    {
        "ID": "10172",
        "NAME": "Teufel von Guntersdorf, Ferdinand Viktor (1630\u20131665), St\u00e4belmeister",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "Guntersdorf im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10173",
        "NAME": "Zr\u00ednyi, Niklas (1620\u20131664), Ban von Kroatien",
        "DATEOFBIRTH": "1620 Mai 01",
        "DATEOFDEATH": "1664 Nov 18",
        "PLACEOFBIRTH": "Osail",
        "PLACEOFDEATH": "Kur\u0161anec"
    },
    {
        "ID": "10174",
        "NAME": "Zr\u00ednyi, Peter (1621\u20131671), Ban von Kroatien",
        "DATEOFBIRTH": "1621 Jun 06",
        "DATEOFDEATH": "1671 Apr 30",
        "PLACEOFBIRTH": "Vrbovec",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "10175",
        "NAME": "Hohenzollern, Leopold (1608\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1659 Jun 19",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "10176",
        "NAME": "Martinitz, Bernhard Ignaz (1615\u20131685), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1615 Aug 20",
        "DATEOFDEATH": "1685 Jan 07",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag:Veitsdom"
    },
    {
        "ID": "10177",
        "NAME": "Truchsess von Waldburg, Johann Jakob (1602\u20131674), K\u00e4mmerer",
        "DATEOFBIRTH": "1602 Aug 02",
        "DATEOFDEATH": "1674 Apr 18",
        "PLACEOFBIRTH": "Zeil in Schwaben",
        "PLACEOFDEATH": "Zeil in Schwaben"
    },
    {
        "ID": "10178",
        "NAME": "Truchsess von Waldburg, Otto (1615\u20131663), K\u00e4mmerer",
        "DATEOFBIRTH": "1615 Mar 11",
        "DATEOFDEATH": "1663 Jul 13",
        "PLACEOFBIRTH": "Ulm an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10179",
        "NAME": "Pilca Koryci\u0144ski, Stephan (1617\u20131658), M\u00fcnzverwalter in Lemberg",
        "DATEOFBIRTH": "1617",
        "DATEOFDEATH": "1658 Jul 04",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": "Peskenstein"
    },
    {
        "ID": "10180",
        "NAME": "Martinitz, Maximilian Valentin (1621\u20131677), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1621 Mar 21",
        "DATEOFDEATH": "1677 Dez 20",
        "PLACEOFBIRTH": "Passau",
        "PLACEOFDEATH": "Prag:Veitsdom"
    },
    {
        "ID": "10181",
        "NAME": "Khevenh\u00fcller, Georg Augustin (1615\u20131653), K\u00e4mmerer",
        "DATEOFBIRTH": "1615 Sep 19",
        "DATEOFDEATH": "1653 Mar 18",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10182",
        "NAME": "Talmberg, Franz Wilhelm (1610\u20131665), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10183",
        "NAME": "Alvernia di Clavesana, Michael (1617\u20131678), K\u00e4mmerer",
        "DATEOFBIRTH": "1617",
        "DATEOFDEATH": "1678 Aug 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Chrudim"
    },
    {
        "ID": "10184",
        "NAME": "Bonacossi, Franz (1615\u2013\u00a0\u00a0\u00a0\u00a0), Mundschenk",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ferrara",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10185",
        "NAME": "Thurn, Johann Ambros (1616\u20131656), K\u00e4mmerer",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1656 Mai 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10186",
        "NAME": "Mollard, Franz Ernst (1612\u20131670), Oberstk\u00fcchenmeister",
        "DATEOFBIRTH": "1612 Mar 15",
        "DATEOFDEATH": "1670 Jan 21",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10187",
        "NAME": "Breunner, Karl Gottfried (1619\u20131675), Hofkammerpr\u00e4sident von Inner\u00f6sterreich",
        "DATEOFBIRTH": "1619 Okt 28",
        "DATEOFDEATH": "1675 Jul 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10188",
        "NAME": "Hauslaib, Lorenz (1568\u20131625), Munitionsverwalter",
        "DATEOFBIRTH": "1568 Apr 29",
        "DATEOFDEATH": "1625 Aug 03",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "10189",
        "NAME": "Rabatta, Joseph (1620\u20131683), Bischof von Laibach",
        "DATEOFBIRTH": "1620",
        "DATEOFDEATH": "1683 Feb 28",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "10190",
        "NAME": "Meggau, Elisabeth (1610\u20131684)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1684 Apr 18",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10191",
        "NAME": "Wratislaw von Mitrowitz, Georg Sidonius (1619\u20131655), Mundschenk",
        "DATEOFBIRTH": "1619",
        "DATEOFDEATH": "1655 Dez 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Poritschen an der Bradava"
    },
    {
        "ID": "10192",
        "NAME": "Kaunitz, Leopold Wilhelm (1614\u20131655), K\u00e4mmerer",
        "DATEOFBIRTH": "1614 Jan 16",
        "DATEOFDEATH": "1655 Okt 31",
        "PLACEOFBIRTH": "Austerlitz in M\u00e4hren",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "10193",
        "NAME": "Auersperg, Herbert (1613\u20131669), K\u00e4mmerer",
        "DATEOFBIRTH": "1613 Nov 08",
        "DATEOFDEATH": "1669 Apr 28",
        "PLACEOFBIRTH": "Seisenberg in der Krain",
        "PLACEOFDEATH": "Agram"
    },
    {
        "ID": "10194",
        "NAME": "Waldstein, Rudolf (1592\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1592 Jan 12",
        "DATEOFDEATH": "1649 Jun 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10195",
        "NAME": "Forg\u00e1ch, Franz (1620\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1647 Jun 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Landshut in M\u00e4hren"
    },
    {
        "ID": "10196",
        "NAME": "Forg\u00e1ch, Niklas (1586\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1635 Sep 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "10197",
        "NAME": "Forg\u00e1ch, Siegmund (1605\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1645 Aug 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10198",
        "NAME": "Forg\u00e1ch, Adam (1601\u20131681), K\u00e4mmerer",
        "DATEOFBIRTH": "1601",
        "DATEOFDEATH": "1681 Jun 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Tyrnau"
    },
    {
        "ID": "10199",
        "NAME": "N\u00e1dasdy, Franz (1623\u20131671), Geheimer Rat",
        "DATEOFBIRTH": "1623 Jan 14",
        "DATEOFDEATH": "1671 Apr 30",
        "PLACEOFBIRTH": "Sch\u00e4chtitz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10200",
        "NAME": "Habsburg, Ferdinand\u00a0I. (1503\u20131564), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1503 Mar 10",
        "DATEOFDEATH": "1564 Jul 25",
        "PLACEOFBIRTH": "Alcal\u00e1 de Henares",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10201",
        "NAME": "Erd\u0151dy, Wolfgang (1620\u20131647), Mundschenk",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1647 Mai 21",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10202",
        "NAME": "Erd\u0151dy, Georg (1625\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10203",
        "NAME": "Erd\u0151dy, Georg (1614\u20131663), K\u00e4mmerer",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "1663 Mai 26",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10204",
        "NAME": "Erd\u0151dy, Emmerich (1618\u20131690), K\u00e4mmerer",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1690 Apr 13",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": "Kanizsa"
    },
    {
        "ID": "10205",
        "NAME": "Balassa, Emmerich (1626\u20131683), K\u00e4mmerer",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1683",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "T\u00e1llya"
    },
    {
        "ID": "10206",
        "NAME": "Balassa, Valentin (1626\u20131684), K\u00e4mmerer",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1684 Jan 02",
        "PLACEOFBIRTH": "Blauenstein",
        "PLACEOFDEATH": "Sohl an der Gran"
    },
    {
        "ID": "10207",
        "NAME": "Herzan von Harras, Johann Adam (1625\u20131681), K\u00e4mmerer",
        "DATEOFBIRTH": "1625",
        "DATEOFDEATH": "1681 Jan 22",
        "PLACEOFBIRTH": "Rothenhaus im Erzgebirge",
        "PLACEOFDEATH": "Rothenhaus im Erzgebirge"
    },
    {
        "ID": "10208",
        "NAME": "Wagen von Wagensperg, Adolf (1626\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10209",
        "NAME": "Thun, Johann Arbogast (1565\u20131633), Geheimer Rat",
        "DATEOFBIRTH": "1565 Jul 22",
        "DATEOFDEATH": "1633 Okt 03",
        "PLACEOFBIRTH": "Kalteis im Sulztal",
        "PLACEOFDEATH": "Kalteis im Sulztal"
    },
    {
        "ID": "10210",
        "NAME": "Thun, Michael Oswald (1631\u20131694), Statthalter von B\u00f6hmen",
        "DATEOFBIRTH": "1631 Okt 13",
        "DATEOFDEATH": "1694 Jan 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10211",
        "NAME": "Thun, Rudolf (1597\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1597 Feb 10",
        "DATEOFDEATH": "1636 Mar 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Brixen am Eisack"
    },
    {
        "ID": "10212",
        "NAME": "Fuchs von Fuchsberg, Karl (1585\u20131648), Reichshofratsvizepr\u00e4sident",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1648",
        "PLACEOFBIRTH": "Lebenberg im Etschtal",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10213",
        "NAME": "Notthafft, Johann Heinrich (1604\u20131665), Reichshofratsvizepr\u00e4sident",
        "DATEOFBIRTH": "1604 Feb 04",
        "DATEOFDEATH": "1665 Jul 02",
        "PLACEOFBIRTH": "Blaibach am Regen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10214",
        "NAME": "Kuefstein, Anna Elisabeth (1603\u20131673)",
        "DATEOFBIRTH": "1603",
        "DATEOFDEATH": "1673",
        "PLACEOFBIRTH": "Greillenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10215",
        "NAME": "Kuefstein, Johann Jakob (1577\u20131633), Reichshofrat",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1633 Aug 31",
        "PLACEOFBIRTH": "Greillenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10216",
        "NAME": "Kuefstein, Johann Georg (1543\u20131603)",
        "DATEOFBIRTH": "1543 Feb 28",
        "DATEOFDEATH": "1603 Jul 05",
        "PLACEOFBIRTH": "Greillenstein",
        "PLACEOFDEATH": "Maria Laach am Jauerling"
    },
    {
        "ID": "10217",
        "NAME": "Waldstein, Maximiliana (1625\u20131658)",
        "DATEOFBIRTH": "1625",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10218",
        "NAME": "Muschinger, Martha Elisabeth (1605\u20131639)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Gumpendorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10219",
        "NAME": "Hase von Hasenburg, Johann Sbigneus (1560\u20131616)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Budin an der Eger",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10220",
        "NAME": "F\u00fcrstenberg, Barzel (1584\u20131631), Reichshofratspr\u00e4sident",
        "DATEOFBIRTH": "1584 Jan 31",
        "DATEOFDEATH": "1631 Jul 10",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10221",
        "NAME": "F\u00fcrstenberg, Barzel (1601\u20131642), K\u00e4mmerer",
        "DATEOFBIRTH": "1601",
        "DATEOFDEATH": "1642 Mai 27",
        "PLACEOFBIRTH": "Blumberg in der Baar",
        "PLACEOFDEATH": "Neufra an der Donau"
    },
    {
        "ID": "10222",
        "NAME": "F\u00fcrstenberg, Franz Christoph (1625\u20131671), K\u00e4mmerer",
        "DATEOFBIRTH": "1625 Jul 28",
        "DATEOFDEATH": "1671 Sep 22",
        "PLACEOFBIRTH": "Blumberg in der Baar",
        "PLACEOFDEATH": "H\u00fcfingen"
    },
    {
        "ID": "10223",
        "NAME": "F\u00fcrstenberg, Frowin Maria (1627\u20131685), Geheimer Rat",
        "DATEOFBIRTH": "1627 Aug 24",
        "DATEOFDEATH": "1685 Mai 07",
        "PLACEOFBIRTH": "Blumberg in der Baar",
        "PLACEOFDEATH": "Me\u00dfkirch an der Ablach"
    },
    {
        "ID": "10224",
        "NAME": "F\u00fcrstenberg, Friedrich (1496\u20131559)",
        "DATEOFBIRTH": "1496 Jul 19",
        "DATEOFDEATH": "1559 Mar 08",
        "PLACEOFBIRTH": "Wolfach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10225",
        "NAME": "F\u00fcrstenberg, Christoph (1534\u20131559)",
        "DATEOFBIRTH": "1534 Aug 24",
        "DATEOFDEATH": "1559 Aug 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Heiligenberg im Linzgau"
    },
    {
        "ID": "10226",
        "NAME": "F\u00fcrstenberg, Christoph (1580\u20131614)",
        "DATEOFBIRTH": "1580 Nov 16",
        "DATEOFDEATH": "1614 Jan 05",
        "PLACEOFBIRTH": "Blumberg in der Baar",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "10227",
        "NAME": "F\u00fcrstenberg, Joachim (1538\u20131598)",
        "DATEOFBIRTH": "1538 Jan 25",
        "DATEOFDEATH": "1598 Okt 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Heiligenberg im Linzgau"
    },
    {
        "ID": "10228",
        "NAME": "F\u00fcrstenberg, Friedrich (1563\u20131617), Obersthofmeister",
        "DATEOFBIRTH": "1563 Mai 09",
        "DATEOFDEATH": "1617 Aug 08",
        "PLACEOFBIRTH": "Heiligenberg im Linzgau",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "10229",
        "NAME": "F\u00fcrstenberg, Eginhard (1588\u20131635), Geheimer Rat",
        "DATEOFBIRTH": "1588 Mar 21",
        "DATEOFDEATH": "1635 Aug 24",
        "PLACEOFBIRTH": "Speyer",
        "PLACEOFDEATH": "Konstanz im Hegau"
    },
    {
        "ID": "10230",
        "NAME": "Lobkowicz, Johann (1510\u20131570), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1510 Nov 08",
        "DATEOFDEATH": "1570 Apr 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10231",
        "NAME": "Thun, Zyprian (1501\u20131573), K\u00e4mmerer",
        "DATEOFBIRTH": "1501 Aug 14",
        "DATEOFDEATH": "1573 Apr 20",
        "PLACEOFBIRTH": "Thun in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10232",
        "NAME": "Thun, Siegmund (1537\u20131596), K\u00e4mmerer",
        "DATEOFBIRTH": "1537 Jul 29",
        "DATEOFDEATH": "1596 Jun 19",
        "PLACEOFBIRTH": "Thun in Tirol",
        "PLACEOFDEATH": "Kastelpfund"
    },
    {
        "ID": "10233",
        "NAME": "Thun, Johann Zyprian (1569\u20131630), K\u00e4mmerer",
        "DATEOFBIRTH": "1569 Aug 26",
        "DATEOFDEATH": "1630 Dez 15",
        "PLACEOFBIRTH": "Kastelpfund",
        "PLACEOFDEATH": "Tetschen"
    },
    {
        "ID": "10234",
        "NAME": "Thun, Jakob (1494\u20131559)",
        "DATEOFBIRTH": "1494 Apr 02",
        "DATEOFDEATH": "1559 Nov 25",
        "PLACEOFBIRTH": "Thun in Tirol",
        "PLACEOFDEATH": "Kalteis im Sulztal"
    },
    {
        "ID": "10235",
        "NAME": "Thun, Anton Jakob (1537\u20131569), Mundschenk",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1569 Jan 31",
        "PLACEOFBIRTH": "Bragher",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "10236",
        "NAME": "Thun, Lauk (1485\u20131559)",
        "DATEOFBIRTH": "1485 Okt 17",
        "DATEOFDEATH": "1559",
        "PLACEOFBIRTH": "Thun in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10237",
        "NAME": "Thun, Viktor (1530\u20131572), K\u00e4mmerer",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1572 Jul 13",
        "PLACEOFBIRTH": "Thun in Tirol",
        "PLACEOFDEATH": "Vigo"
    },
    {
        "ID": "10238",
        "NAME": "Thun, Herkules (1561\u20131615), K\u00e4mmerer",
        "DATEOFBIRTH": "1561",
        "DATEOFDEATH": "1615 Dez 20",
        "PLACEOFBIRTH": "Thun in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10239",
        "NAME": "Thun, Georg Siegmund (1573\u20131651), K\u00e4mmerer",
        "DATEOFBIRTH": "1573 Feb 23",
        "DATEOFDEATH": "1651 Apr 26",
        "PLACEOFBIRTH": "Kastelpfund",
        "PLACEOFDEATH": "Bragher"
    },
    {
        "ID": "10240",
        "NAME": "Thun, Anton (1450\u20131522)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1522 Mai 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Thun in Tirol"
    },
    {
        "ID": "10241",
        "NAME": "Erd\u0151dy, Thomas (1558\u20131624), Ban von Kroatien",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1624 Jan 17",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": "Krapina"
    },
    {
        "ID": "10242",
        "NAME": "Erd\u0151dy, Elisabeth (1598\u20131652)",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1652",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10243",
        "NAME": "Erd\u0151dy, Peter (1560\u20131613)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10244",
        "NAME": "Erd\u0151dy, Wolfgang (1588\u20131645)",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10245",
        "NAME": "Erd\u0151dy, Peter (1504\u20131567), Ban von Kroatien",
        "DATEOFBIRTH": "1504",
        "DATEOFDEATH": "1567 Apr 26",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": "Jaska"
    },
    {
        "ID": "10246",
        "NAME": "Auersperg, Theoderich (1578\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1578 Jun 02",
        "DATEOFDEATH": "1634 Aug 25",
        "PLACEOFBIRTH": "Laibach",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "10247",
        "NAME": "Auersperg, Volkhard (1443\u20131508)",
        "DATEOFBIRTH": "1443 Nov 17",
        "DATEOFDEATH": "1508 Okt 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10248",
        "NAME": "Auersperg, Siegmund (1482\u20131541)",
        "DATEOFBIRTH": "1482",
        "DATEOFDEATH": "1541",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10249",
        "NAME": "Auersperg, Engelhard (1404\u20131466)",
        "DATEOFBIRTH": "1404 Okt 29",
        "DATEOFDEATH": "1466 Nov 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10250",
        "NAME": "Savoyen, Eugen (1663\u20131736), Geheimer Rat",
        "DATEOFBIRTH": "1663 Okt 18",
        "DATEOFDEATH": "1736 Apr 21",
        "PLACEOFBIRTH": "Paris",
        "PLACEOFDEATH": "Wien:Stephansdom"
    },
    {
        "ID": "10251",
        "NAME": "Gonzaga, Ferdinand (1544\u20131586), F\u00fcrst von Castiglione",
        "DATEOFBIRTH": "1544 Jul 28",
        "DATEOFDEATH": "1586 Feb 13",
        "PLACEOFBIRTH": "Castel Goffredo",
        "PLACEOFDEATH": "Castiglione delle Stiviere"
    },
    {
        "ID": "10252",
        "NAME": "Gonzaga, Christian (1580\u20131630), Markgraf von Solferino",
        "DATEOFBIRTH": "1580 Sep 30",
        "DATEOFDEATH": "1630 Sep 10",
        "PLACEOFBIRTH": "Castiglione delle Stiviere",
        "PLACEOFDEATH": "Solferino"
    },
    {
        "ID": "10253",
        "NAME": "Gonzaga, Franz (1577\u20131616), F\u00fcrst von Castiglione",
        "DATEOFBIRTH": "1577 Apr 27",
        "DATEOFDEATH": "1616 Okt 23",
        "PLACEOFBIRTH": "Castiglione delle Stiviere",
        "PLACEOFDEATH": "Maderno"
    },
    {
        "ID": "10254",
        "NAME": "Gonzaga, Johanna (1612\u20131688)",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1688",
        "PLACEOFBIRTH": "Castiglione delle Stiviere",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10255",
        "NAME": "Canossa, Theodoald (1600\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1650~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10256",
        "NAME": "Slavata, Joachim Ulrich (1606\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1645 Mai 04",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Bruck an der Mur"
    },
    {
        "ID": "10257",
        "NAME": "Mansfeld, Anna Franziska (1608\u20131654)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1654 Sep 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10258",
        "NAME": "Liechtenstein von Nikolsburg, Hartmann (1544\u20131585), Geheimer Rat",
        "DATEOFBIRTH": "1544 Mai 06",
        "DATEOFDEATH": "1585 Okt 11",
        "PLACEOFBIRTH": "Feldsberg im Weinviertel",
        "PLACEOFDEATH": "Eisgrub in M\u00e4hren"
    },
    {
        "ID": "10259",
        "NAME": "Liechtenstein von Nikolsburg, Judith (1575\u20131621)",
        "DATEOFBIRTH": "1575 Apr 18",
        "DATEOFDEATH": "1621 Mar 06",
        "PLACEOFBIRTH": "Feldsberg im Weinviertel",
        "PLACEOFDEATH": "Karlsbach im M\u00fchlkreis"
    },
    {
        "ID": "10260",
        "NAME": "Dietrichstein, Gundaker (1623\u20131690), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1623 Dez 09",
        "DATEOFDEATH": "1690 Jan 25",
        "PLACEOFBIRTH": "Hollenburg an der Drau",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "10261",
        "NAME": "Dietrichstein, Pankraz (1446\u20131508)",
        "DATEOFBIRTH": "1446",
        "DATEOFDEATH": "1508 Sep 04",
        "PLACEOFBIRTH": "Dietrichstein in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10262",
        "NAME": "Dietrichstein, Siegmund (1484\u20131533), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1484 Feb 13",
        "DATEOFDEATH": "1533 Mai 19",
        "PLACEOFBIRTH": "Hartneidstein im Lavanttal",
        "PLACEOFDEATH": "Finkenstein am Faakersee"
    },
    {
        "ID": "10263",
        "NAME": "Dietrichstein, Franz (1476\u20131548)",
        "DATEOFBIRTH": "1476",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Weixelst\u00e4tten"
    },
    {
        "ID": "10264",
        "NAME": "Dietrichstein, Adam (1527\u20131590), Obersthofmeister",
        "DATEOFBIRTH": "1527 Okt 06",
        "DATEOFDEATH": "1590 Feb 05",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Nikolsburg in M\u00e4hren"
    },
    {
        "ID": "10265",
        "NAME": "Dietrichstein, Siegmund (1560\u20131602), K\u00e4mmerer",
        "DATEOFBIRTH": "1560",
        "DATEOFDEATH": "1602 Jan 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10266",
        "NAME": "Dietrichstein, Leonhard (1510\u20131559)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1559",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Weixelst\u00e4tten"
    },
    {
        "ID": "10267",
        "NAME": "Dietrichstein, Siegfried (1538\u20131583)",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1583",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Weixelst\u00e4tten"
    },
    {
        "ID": "10268",
        "NAME": "Dietrichstein, Erasam (1570\u20131621), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "Weixelst\u00e4tten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10269",
        "NAME": "Dietrichstein, Susanna Polyxena (1634\u20131706)",
        "DATEOFBIRTH": "1634",
        "DATEOFDEATH": "1706 Jun 20",
        "PLACEOFBIRTH": "Hollenburg an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10270",
        "NAME": "Marschall von Pappenheim, Ursula Katharina (1625\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10271",
        "NAME": "Forg\u00e1ch, Simon (1526\u20131598)",
        "DATEOFBIRTH": "1526",
        "DATEOFDEATH": "1598 Sep 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hertnecht"
    },
    {
        "ID": "10272",
        "NAME": "Forg\u00e1ch, Franz (1566\u20131615), Erzbischof von Gran",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "1615 Okt 16",
        "PLACEOFBIRTH": "Hertnecht",
        "PLACEOFDEATH": "Heiligenkreuz an der Gran"
    },
    {
        "ID": "10273",
        "NAME": "Forg\u00e1ch, Siegmund (1559\u20131621), Palatin von Ungarn",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1621 Jun 11",
        "PLACEOFBIRTH": "Hertnecht",
        "PLACEOFDEATH": "Tyrnau"
    },
    {
        "ID": "10274",
        "NAME": "Forg\u00e1ch, Peter (1445\u20131519)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1519 Nov 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10275",
        "NAME": "Forg\u00e1ch, Lassel (1490\u20131550)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1550",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10276",
        "NAME": "Forg\u00e1ch, Gregor (1540\u20131593)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1593",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10277",
        "NAME": "Forg\u00e1ch, Gregor (1450\u20131515)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1515",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10278",
        "NAME": "Forg\u00e1ch, Siegmund (1490\u20131563)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1563",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10279",
        "NAME": "Forg\u00e1ch, Johann (1403\u20131465)",
        "DATEOFBIRTH": "1403",
        "DATEOFDEATH": "1465",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10280",
        "NAME": "Trauttmansdorff, Johann Friedrich (1542\u20131614), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1614 Apr 14",
        "PLACEOFBIRTH": "Totzenbach am Haspelwald",
        "PLACEOFDEATH": "Trautmannsdorf in der Steiermark"
    },
    {
        "ID": "10281",
        "NAME": "Althan, Michaela Elisabeth (1622\u20131670)",
        "DATEOFBIRTH": "1622",
        "DATEOFDEATH": "1670",
        "PLACEOFBIRTH": "Murstetten",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10282",
        "NAME": "Lobkowicz, Johann (1490\u20131569)",
        "DATEOFBIRTH": "1490",
        "DATEOFDEATH": "1569 Jun 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Libochowitz"
    },
    {
        "ID": "10283",
        "NAME": "Trauttmansdorff, Ehrenreich (1474\u20131535)",
        "DATEOFBIRTH": "1474",
        "DATEOFDEATH": "1535",
        "PLACEOFBIRTH": "Leutschach an der Weinstra\u00dfe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10284",
        "NAME": "Trauttmansdorff, Joachim (1518\u20131571)",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1571 Okt 13",
        "PLACEOFBIRTH": "Leutschach an der Weinstra\u00dfe",
        "PLACEOFDEATH": "Leibnitz in der Steiermark"
    },
    {
        "ID": "10285",
        "NAME": "Trauttmansdorff, Georg Adam (1560\u20131599)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10286",
        "NAME": "Trauttmansdorff, Ehrenreich (1550\u20131598), Vorschneider",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10287",
        "NAME": "Mansfeld, Christina Elisabeth (1621\u20131648)",
        "DATEOFBIRTH": "1621",
        "DATEOFDEATH": "1648 Jul 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "10288",
        "NAME": "Trauttmansdorff, Johann David (1573\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1573 Dez 27",
        "DATEOFDEATH": "1627 Jun 11",
        "PLACEOFBIRTH": "Trautmannsdorf in der Steiermark",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10289",
        "NAME": "Trauttmansdorff, David (1480\u20131545)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1545 Jun 15",
        "PLACEOFBIRTH": "Leutschach an der Weinstra\u00dfe",
        "PLACEOFDEATH": "Totzenbach am Haspelwald"
    },
    {
        "ID": "10290",
        "NAME": "Lobkowicz, Ferdinand (1655\u20131715), Prinzipalkommissar",
        "DATEOFBIRTH": "1655 Sep 07",
        "DATEOFDEATH": "1715 Okt 03",
        "PLACEOFBIRTH": "Neustadt an der Waldnaab",
        "PLACEOFDEATH": "Raudnitz an der Elbe"
    },
    {
        "ID": "10291",
        "NAME": "Lobkowicz, Johann (1425\u20131470)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "1470",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Krumau in B\u00f6hmen"
    },
    {
        "ID": "10292",
        "NAME": "Lobkowicz, Theobald (1465\u20131527)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1527 Apr 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bilina in B\u00f6hmen"
    },
    {
        "ID": "10293",
        "NAME": "Lobkowicz, Christoph (1515\u20131590)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1590 Mar 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bilina in B\u00f6hmen"
    },
    {
        "ID": "10294",
        "NAME": "Lobkowicz, Ulrich Felix (1545\u20131604)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1604 Mar 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bilina in B\u00f6hmen"
    },
    {
        "ID": "10295",
        "NAME": "Lobkowicz, Wilhelm (1575\u20131647), Landj\u00e4germeister von B\u00f6hmen",
        "DATEOFBIRTH": "1575 Jul 22",
        "DATEOFDEATH": "1647 Jan 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10296",
        "NAME": "Lobkowicz, Lassel (1460\u20131505)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1505",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10297",
        "NAME": "Lobkowicz, Lassel (1502\u20131584), Obersthofmeister",
        "DATEOFBIRTH": "1502",
        "DATEOFDEATH": "1584 Dez 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10298",
        "NAME": "Lobkowicz, Franz Wilhelm (1616\u20131670), K\u00e4mmerer",
        "DATEOFBIRTH": "1616 Aug 14",
        "DATEOFDEATH": "1670 Feb 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10299",
        "NAME": "Lobkowicz, Christoph (1549\u20131609), K\u00e4mmerer",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1609 Mai 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10300",
        "NAME": "Habsburg, Maximilian\u00a0I. (1459\u20131519), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1459 Mar 22",
        "DATEOFDEATH": "1519 Jan 12",
        "PLACEOFBIRTH": "Neustadt im Steinfeld",
        "PLACEOFDEATH": "Wels"
    },
    {
        "ID": "10301",
        "NAME": "Zr\u00ednyi, Georg (1590\u20131626), Ban von Kroatien",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1626 Dez 18",
        "PLACEOFBIRTH": "Zr\u00ednyiv\u00e1r am Cs\u00e1ktornya",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "10302",
        "NAME": "Hatzfeldt, Melchior (1593\u20131658), Geheimer Rat",
        "DATEOFBIRTH": "1593 Okt 20",
        "DATEOFDEATH": "1658 Jan 09",
        "PLACEOFBIRTH": "Krottorf im Westerwald",
        "PLACEOFDEATH": "Trachenberg in Schlesien"
    },
    {
        "ID": "10303",
        "NAME": "Hatzfeldt, Hermann (1603\u20131673), K\u00e4mmerer",
        "DATEOFBIRTH": "1603 Jul 12",
        "DATEOFDEATH": "1673 Okt 23",
        "PLACEOFBIRTH": "Krottorf im Westerwald",
        "PLACEOFDEATH": "Rothenburg ob der Tauber"
    },
    {
        "ID": "10304",
        "NAME": "Hatzfeldt, Heinrich (1641\u20131683), K\u00e4mmerer",
        "DATEOFBIRTH": "1641",
        "DATEOFDEATH": "1683 Aug 15",
        "PLACEOFBIRTH": "Stetten im Vorbachtal",
        "PLACEOFDEATH": "Reutnitz"
    },
    {
        "ID": "10305",
        "NAME": "Kronegg, Georg Andreas (1602\u20131665), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1602",
        "DATEOFDEATH": "1665 Okt 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Moosburg in K\u00e4rnten"
    },
    {
        "ID": "10306",
        "NAME": "Kronegg, Christoph (1507\u20131587)",
        "DATEOFBIRTH": "1507",
        "DATEOFDEATH": "1587",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10307",
        "NAME": "Kronegg, Anton (1553\u20131616), Mundschenk",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10308",
        "NAME": "Kronegg, Karl Christoph (1540\u20131631), Oberstk\u00fcchenmeister",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1631",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10309",
        "NAME": "Kronegg, Ferdinand (1585\u20131653)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1653",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10310",
        "NAME": "Schlick, Franz Ernst (1623\u20131675), Reichshofrat",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1675 Aug 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "10311",
        "NAME": "Schlick, Kaspar (1451\u20131516)",
        "DATEOFBIRTH": "1451",
        "DATEOFDEATH": "1516",
        "PLACEOFBIRTH": "Elbogen an der Eger",
        "PLACEOFDEATH": "Schlackenwerth"
    },
    {
        "ID": "10312",
        "NAME": "Schlick, Lorenz (1495\u20131585)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1585",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10313",
        "NAME": "Schlick, Christoph (1525\u20131578)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1578 Jul 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neudek an der Rohlau"
    },
    {
        "ID": "10314",
        "NAME": "Schlick, Wilhelm (1556\u20131604)",
        "DATEOFBIRTH": "1556",
        "DATEOFDEATH": "1604",
        "PLACEOFBIRTH": "Neudek an der Rohlau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10315",
        "NAME": "Schlick, Heinrich (1590\u20131630)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1630",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10316",
        "NAME": "Schlick, Heinrich Wilhelm (1620\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1660~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10317",
        "NAME": "Schlick, Heinrich (1480\u20131528)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10318",
        "NAME": "Schlick, Heinrich (1508\u20131569)",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10319",
        "NAME": "Schlick, Georg Ernst (1550\u20131612)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10320",
        "NAME": "Wittelsbach, Maximilian Emanuel (1662\u20131726), Statthalter der Spanischen Niederlande",
        "DATEOFBIRTH": "1662 Jul 11",
        "DATEOFDEATH": "1726 Feb 26",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "M\u00fcnchen:Theatinerkirche"
    },
    {
        "ID": "10321",
        "NAME": "Marradas, Franz (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Valencia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10322",
        "NAME": "Marradas, Georg (1565\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Valencia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10323",
        "NAME": "Kronberg, Adam Philipp (1588\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1634 Aug 03",
        "PLACEOFBIRTH": "Kronberg im Taunus",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "10324",
        "NAME": "Kronberg, Kraft Adolf (1629\u20131692), K\u00e4mmerer",
        "DATEOFBIRTH": "1629 Jan 29",
        "DATEOFDEATH": "1692 Apr 01",
        "PLACEOFBIRTH": "W\u00f6rth am Main",
        "PLACEOFDEATH": "Poritschen im Schwihauer Bergland"
    },
    {
        "ID": "10325",
        "NAME": "Coronini von Cronberg, Ludwig (1628\u20131694), Truchsess",
        "DATEOFBIRTH": "1628 Mai 18",
        "DATEOFDEATH": "1694 Jun 15",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "G\u00f6rz"
    },
    {
        "ID": "10326",
        "NAME": "Hiserle von Chodau, Bernhard (1584\u20131652)",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1652",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10327",
        "NAME": "Hiserle von Chodau, Franz Christoph (1622\u20131666), K\u00e4mmerer",
        "DATEOFBIRTH": "1622",
        "DATEOFDEATH": "1666",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10328",
        "NAME": "Hiserle von Chodau, Ferdinand Ernst (1625\u20131692), K\u00e4mmerer",
        "DATEOFBIRTH": "1625",
        "DATEOFDEATH": "1692",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10329",
        "NAME": "Trauttmansdorff, Johann (1437\u20131493)",
        "DATEOFBIRTH": "1437",
        "DATEOFDEATH": "1493",
        "PLACEOFBIRTH": "Kirchberg am Walde",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10330",
        "NAME": "Carretto, Otto Heinrich (1639\u20131685), Statthalter der Spanischen Niederlande",
        "DATEOFBIRTH": "1639 Apr 05",
        "DATEOFDEATH": "1685 Jun 19",
        "PLACEOFBIRTH": "K\u00f6ln am Rhein",
        "PLACEOFDEATH": "Mariemont im Hennegau"
    },
    {
        "ID": "10331",
        "NAME": "Waldstein, Johann (1435\u20131506)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1506 Jul 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10332",
        "NAME": "Waldstein, Wilhelm (1475\u20131557)",
        "DATEOFBIRTH": "1475 Jan 05",
        "DATEOFDEATH": "1557",
        "PLACEOFBIRTH": "Turnau in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10333",
        "NAME": "Waldstein, Johann (1508\u20131576), Statthalter von B\u00f6hmen",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "1576 Jun 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10334",
        "NAME": "Waldstein, Sidonius (1470\u20131525)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1525 Aug 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Arnau in B\u00f6hmen"
    },
    {
        "ID": "10335",
        "NAME": "Waldstein, Georg (1519\u20131584)",
        "DATEOFBIRTH": "1519 Apr 24",
        "DATEOFDEATH": "1584 Mai 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Arnau in B\u00f6hmen"
    },
    {
        "ID": "10336",
        "NAME": "Waldstein, Wilhelm (1547\u20131595)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1595 Feb 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hermanitz an der Elbe"
    },
    {
        "ID": "10337",
        "NAME": "Waldstein, Ignaz (1430\u20131482)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1482",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10338",
        "NAME": "Waldstein, Bernhard (1465\u20131517)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1517 Sep 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10339",
        "NAME": "Waldstein, Albrecht (1495\u20131545)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1545",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10340",
        "NAME": "Waldstein, Johann (1525\u20131597)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10341",
        "NAME": "Waldstein, Adam (1560\u20131615)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1615 Feb 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10342",
        "NAME": "Waldstein, Heinrich (1400\u20131452)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1452",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10343",
        "NAME": "Balassa, Siegmund (1565\u20131623)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10344",
        "NAME": "Balassa, Andreas (1595\u20131649)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10345",
        "NAME": "Balassa, Andreas (1535\u20131576)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10346",
        "NAME": "Balassa, Emmerich (1575\u20131633)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1633",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10347",
        "NAME": "Dietrichstein, Siegmund (1526\u20131593), K\u00e4mmerer",
        "DATEOFBIRTH": "1526 Sep 02",
        "DATEOFDEATH": "1593 Jul 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hollenburg an der Drau"
    },
    {
        "ID": "10348",
        "NAME": "Dietrichstein, Bartlome (1579\u20131635)",
        "DATEOFBIRTH": "1579 Apr 07",
        "DATEOFDEATH": "1635 Mar 08",
        "PLACEOFBIRTH": "Hollenburg an der Drau",
        "PLACEOFDEATH": "Hanau am Main"
    },
    {
        "ID": "10349",
        "NAME": "Esterh\u00e1zy, Julia (1630\u20131669)",
        "DATEOFBIRTH": "1630 Feb 28",
        "DATEOFDEATH": "1669 Jan 22",
        "PLACEOFBIRTH": "Forchtenstein",
        "PLACEOFDEATH": "Pottendorf"
    },
    {
        "ID": "10350",
        "NAME": "Z\u00e4hringen, Leopold Wilhelm (1626\u20131671), K\u00e4mmerer",
        "DATEOFBIRTH": "1626 Sep 17",
        "DATEOFDEATH": "1671 Mar 01",
        "PLACEOFBIRTH": "Baden in Baden",
        "PLACEOFDEATH": "Warasdin an der Drau"
    },
    {
        "ID": "10351",
        "NAME": "Starhemberg, Erasam (1503\u20131560), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1503 Jul 10",
        "DATEOFDEATH": "1560 Sep 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10352",
        "NAME": "Starhemberg, Heinrich (1540\u20131575), Reichshofrat",
        "DATEOFBIRTH": "1540 Jul 06",
        "DATEOFDEATH": "1575 Dez 23",
        "PLACEOFBIRTH": "Riedegg im M\u00fchlviertel",
        "PLACEOFDEATH": "Wildberg im M\u00fchlviertel"
    },
    {
        "ID": "10353",
        "NAME": "Starhemberg, Richard (1570\u20131613), Hofkammerrat",
        "DATEOFBIRTH": "1570 Mar 01",
        "DATEOFDEATH": "1613 Feb 08",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10354",
        "NAME": "Starhemberg, Rudger (1534\u20131582)",
        "DATEOFBIRTH": "1534 Dez 10",
        "DATEOFDEATH": "1582 Dez 05",
        "PLACEOFBIRTH": "Eferding",
        "PLACEOFDEATH": "Sch\u00f6nb\u00fchel an der Donau"
    },
    {
        "ID": "10355",
        "NAME": "Starhemberg, Paul Jakob (1560\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1560 Dez 11",
        "DATEOFDEATH": "1635 Okt 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10356",
        "NAME": "Starhemberg, Konrad Balthasar (1612\u20131687), Statthalter von Nieder\u00f6sterreich",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1687 Apr 03",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10357",
        "NAME": "Starhemberg, Helena Dorothea (1634\u20131688)",
        "DATEOFBIRTH": "1634",
        "DATEOFDEATH": "1688 Dez 19",
        "PLACEOFBIRTH": "Wildberg im M\u00fchlviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10358",
        "NAME": "Starhemberg, Gundaker (1594\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1594 Mai 07",
        "DATEOFDEATH": "1638 Okt 03",
        "PLACEOFBIRTH": "Riedegg im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10359",
        "NAME": "Starhemberg, Bartlome (1625\u20131676), K\u00e4mmerer",
        "DATEOFBIRTH": "1625",
        "DATEOFDEATH": "1676 Mar 22",
        "PLACEOFBIRTH": "Riedegg im M\u00fchlviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10360",
        "NAME": "Hatzfeldt, Sebastian (1566\u20131630)",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "1630",
        "PLACEOFBIRTH": "Wildenburg im Westerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10361",
        "NAME": "Tserclaes von Tilly, Ernst Emmerich (1635\u20131675), K\u00e4mmerer",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1675 Apr 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Holnstein im Tal der Wei\u00dfen Laaber"
    },
    {
        "ID": "10362",
        "NAME": "Tserclaes von Tilly, Werner (1599\u20131653), K\u00e4mmerer",
        "DATEOFBIRTH": "1599 Mai 12",
        "DATEOFDEATH": "1653 Jun 15",
        "PLACEOFBIRTH": "Tilly in Brabant",
        "PLACEOFDEATH": "Wei\u00dfenberg an der Krems"
    },
    {
        "ID": "10363",
        "NAME": "Tserclaes von Tilly, Jakob (1564\u20131624)",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1624 Okt 11",
        "PLACEOFBIRTH": "Tilly in Brabant",
        "PLACEOFDEATH": "Tilly in Brabant"
    },
    {
        "ID": "10364",
        "NAME": "Tserclaes von Tilly, Martin (1530\u20131597), Hofkriegsrat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "Tilly in Brabant",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10365",
        "NAME": "Wratislaw von Mitrowitz, Alexander Ferdinand (1616\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1672 Feb 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10366",
        "NAME": "Wratislaw von Mitrowitz, Adam (1584\u20131624)",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1624 Feb 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10367",
        "NAME": "Wratislaw von Mitrowitz, Christoph (1628\u20131664)",
        "DATEOFBIRTH": "1628",
        "DATEOFDEATH": "1664 Okt 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Nei\u00dfe"
    },
    {
        "ID": "10368",
        "NAME": "Wratislaw von Mitrowitz, Adam (1611\u20131666), Gro\u00dfprior des Malteserordens in B\u00f6hmen",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1666 Okt 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10369",
        "NAME": "Wratislaw von Mitrowitz, Christoph (1584\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1584 Jan 01",
        "DATEOFDEATH": "1645 Sep 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10370",
        "NAME": "Wratislaw von Mitrowitz, Wilhelm (1575\u20131637), Gro\u00dfprior des Malteserordens in B\u00f6hmen",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1637 Jan 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10371",
        "NAME": "Auersperg, Pankraz (1441\u20131496), Truchsess",
        "DATEOFBIRTH": "1441 Feb 24",
        "DATEOFDEATH": "1496 Apr 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Auersperg in der Krain"
    },
    {
        "ID": "10372",
        "NAME": "Auersperg, Trajan (1495\u20131541)",
        "DATEOFBIRTH": "1495 Okt 24",
        "DATEOFDEATH": "1541 Sep 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "10373",
        "NAME": "Auersperg, Herbert (1528\u20131575), Landeshauptmann von Krain",
        "DATEOFBIRTH": "1528 Jun 15",
        "DATEOFDEATH": "1575 Sep 22",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Donji Buda\u010dki"
    },
    {
        "ID": "10374",
        "NAME": "Auersperg, Christoph (1550\u20131592)",
        "DATEOFBIRTH": "1550 Okt 27",
        "DATEOFDEATH": "1592 Mai 14",
        "PLACEOFBIRTH": "Laibach",
        "PLACEOFDEATH": "Lublin"
    },
    {
        "ID": "10375",
        "NAME": "Hohenfeld, Achaz (1551\u20131603)",
        "DATEOFBIRTH": "1551 Jan 31",
        "DATEOFDEATH": "1603 Okt 10",
        "PLACEOFBIRTH": "Aistersheim",
        "PLACEOFDEATH": "Peuerbach im Hausruckviertel"
    },
    {
        "ID": "10376",
        "NAME": "Hohenfeld, Mark (1577\u20131618)",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1618 Jul 15",
        "PLACEOFBIRTH": "Aistersheim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10377",
        "NAME": "Hohenfeld, Otto (1578\u20131620)",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1620 Apr 06",
        "PLACEOFBIRTH": "Aistersheim",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "10378",
        "NAME": "Slavata, Ferdinand Wilhelm (1630\u20131673), Geheimer Rat",
        "DATEOFBIRTH": "1630 Sep 01",
        "DATEOFDEATH": "1673 Apr 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10379",
        "NAME": "Slavata, Johann Joachim (1638\u20131689), Oberstlandrichter von B\u00f6hmen",
        "DATEOFBIRTH": "1638",
        "DATEOFDEATH": "1689 Jul 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Velvary"
    },
    {
        "ID": "10380",
        "NAME": "Porcia, Johann Sforza (1576\u20131624), Landeshauptmann von G\u00f6rz",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10381",
        "NAME": "Starhemberg, Johann Ludwig (1616\u20131666), K\u00e4mmerer",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1666 Sep 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10382",
        "NAME": "Starhemberg, Gotthard (1628\u2013\u00a0\u00a0\u00a0\u00a0), Vorschneider",
        "DATEOFBIRTH": "1628 Mai 12",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Riedegg im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10383",
        "NAME": "Starhemberg, Georg Ludwig (1602\u20131651), Landeshauptmann von Schweidnitz und Jauer",
        "DATEOFBIRTH": "1602 Okt 30",
        "DATEOFDEATH": "1651 Mai 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10384",
        "NAME": "Starhemberg, Johann Richard (1608\u20131661), K\u00e4mmerer",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1661 Sep 04",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": "Sathmar"
    },
    {
        "ID": "10385",
        "NAME": "Starhemberg, Ludwig (1564\u20131620), K\u00e4mmerer",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1620 Dez 12",
        "PLACEOFBIRTH": "Eferding",
        "PLACEOFDEATH": "Znaim"
    },
    {
        "ID": "10386",
        "NAME": "Starhemberg, Erasam (1575\u20131648)",
        "DATEOFBIRTH": "1575 Apr 04",
        "DATEOFDEATH": "1648 Jul 14",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Gst\u00f6ttenau"
    },
    {
        "ID": "10387",
        "NAME": "Wratislaw von Mitrowitz, Wenzel (1576\u20131635)",
        "DATEOFBIRTH": "1576 Jun 19",
        "DATEOFDEATH": "1635 Nov 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Knin in B\u00f6hmen:Franziskanerkirche"
    },
    {
        "ID": "10388",
        "NAME": "Collalto, Klaudius (1628\u20131661), Reichshofrat",
        "DATEOFBIRTH": "1628 Feb 17",
        "DATEOFDEATH": "1661 Mar 07",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "10389",
        "NAME": "Trauttmansdorff, Adam (1579\u20131617), Hofkriegsrat",
        "DATEOFBIRTH": "1579 Mar 08",
        "DATEOFDEATH": "1617 Jun 07",
        "PLACEOFBIRTH": "Trautmannsdorf in der Steiermark",
        "PLACEOFDEATH": "Rubia auf dem Karst"
    },
    {
        "ID": "10390",
        "NAME": "Meggau, Ferdinand Helfried (1533\u20131585), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1585 Jul 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "10391",
        "NAME": "Wratislaw von Mitrowitz, Lassel (1580\u20131624)",
        "DATEOFBIRTH": "1580",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Chlum im Seltschaner Becken"
    },
    {
        "ID": "10392",
        "NAME": "Wratislaw von Mitrowitz, Stephan (1540\u20131601)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1601",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10393",
        "NAME": "Wratislaw von Mitrowitz, Georg (1545\u20131603)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1603 Apr 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Zal\u0161\u00ed"
    },
    {
        "ID": "10394",
        "NAME": "Wratislaw von Mitrowitz, Wenzel (1510\u20131554)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1554 Feb 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sk\u0159ipel"
    },
    {
        "ID": "10395",
        "NAME": "Wratislaw von Mitrowitz, Johann (1588\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10396",
        "NAME": "Wratislaw von Mitrowitz, Johann Georg (1620\u20131660), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1660",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10397",
        "NAME": "Wratislaw von Mitrowitz, Wenzel (1615\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1660",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10398",
        "NAME": "Carretto, Ferdinand (1616\u20131651), Reichshofrat",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1651 Dez 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10399",
        "NAME": "Carretto, Leopold (1618\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1648 Aug 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lens in Flandern"
    },
    {
        "ID": "10400",
        "NAME": "Habsburg, Philipp\u00a0I. (1478\u20131506), K\u00f6nig von Kastilien",
        "DATEOFBIRTH": "1478 Jul 22",
        "DATEOFDEATH": "1506 Sep 25",
        "PLACEOFBIRTH": "Br\u00fcgge",
        "PLACEOFDEATH": "Burgos"
    },
    {
        "ID": "10401",
        "NAME": "Thurn, Anton (1440\u20131512)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10402",
        "NAME": "Thurn, Veit (1471\u20131547)",
        "DATEOFBIRTH": "1471 Jun 15",
        "DATEOFDEATH": "1547 Feb 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10403",
        "NAME": "Thurn, Franz (1508\u20131586), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "1586 Feb 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10404",
        "NAME": "Thurn, Andreas (1475\u20131541)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1541",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10405",
        "NAME": "Thurn, Anton (1500\u20131569)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1569 Sep 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10406",
        "NAME": "Thurn, Achaz (1529\u20131595)",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1595",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10407",
        "NAME": "Thurn, Johann Ludwig (1579\u20131635)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1635 Jul 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "10408",
        "NAME": "Thurn, Heinrich Ludwig (1605\u20131676), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1676",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10409",
        "NAME": "Sauermann, Jaroslaus Ferdinand (1630\u20131672), Hofdiener",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10410",
        "NAME": "Trczka von Leipa, Johann Rudolf (1557\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1634 Sep 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Brod an der Sasau"
    },
    {
        "ID": "10411",
        "NAME": "Trczka von Leipa, Adam Erdmann (1599\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1634 Feb 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Eger in B\u00f6hmen"
    },
    {
        "ID": "10412",
        "NAME": "Lamberg, Siegmund Friedrich (1625\u20131662), Truchsess",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1662",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10413",
        "NAME": "Khuen von Belasi, Jakob (1476\u20131562), Obersthofmeister",
        "DATEOFBIRTH": "1476",
        "DATEOFDEATH": "1562 Apr 11",
        "PLACEOFBIRTH": "Belasi im Nonstal",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "10414",
        "NAME": "Khuen von Belasi, Johann Baptist (1516\u20131578)",
        "DATEOFBIRTH": "1516 Sep 24",
        "DATEOFDEATH": "1578 Jan 29",
        "PLACEOFBIRTH": "Telfan im Suganertal",
        "PLACEOFDEATH": "Lichtenberg im Pinzgau"
    },
    {
        "ID": "10415",
        "NAME": "Khuen von Belasi, Johann Jakob (1549\u20131608), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1549 Mai 10",
        "DATEOFDEATH": "1608 Mar 26",
        "PLACEOFBIRTH": "Nauders",
        "PLACEOFDEATH": "Lichtenberg im Pinzgau"
    },
    {
        "ID": "10416",
        "NAME": "Khuen von Belasi, Jakob (1589\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1589 Feb 28",
        "DATEOFDEATH": "1639 Sep 21",
        "PLACEOFBIRTH": "Lichtenberg im Pinzgau",
        "PLACEOFDEATH": "Landstein in B\u00f6hmen"
    },
    {
        "ID": "10417",
        "NAME": "Khuen von Belasi, Matthias (1617\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1617",
        "DATEOFDEATH": "1659 Okt 26",
        "PLACEOFBIRTH": "Lichtenberg im Pinzgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10418",
        "NAME": "Thurn, Johann Ambros (1537\u20131621), Landeshauptmann von Krain",
        "DATEOFBIRTH": "1537 Dez 04",
        "DATEOFDEATH": "1621 Sep 14",
        "PLACEOFBIRTH": "Lack an der Zeyer",
        "PLACEOFDEATH": "Bleiburg in K\u00e4rnten"
    },
    {
        "ID": "10419",
        "NAME": "Schad von Bellmont, Rudolf (1590\u20131660), Reichshofrat",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1660~",
        "PLACEOFBIRTH": "Mainz",
        "PLACEOFDEATH": "Weingarten auf dem Martinsberg"
    },
    {
        "ID": "10420",
        "NAME": "W\u00fcrben, Bernhard (1475\u20131529)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1529 Dez 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Herlitz"
    },
    {
        "ID": "10421",
        "NAME": "W\u00fcrben, Stephan (1515\u20131567)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1567 Dez 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10422",
        "NAME": "W\u00fcrben, Johann (1545\u20131620), Truchsess",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1620 Sep 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10423",
        "NAME": "W\u00fcrben, Albrecht (1555\u20131597), Edelknabe",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10424",
        "NAME": "W\u00fcrben, Bernhard (1590\u20131652), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1652 Dez 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10425",
        "NAME": "W\u00fcrben, Johann Karl (1630\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10426",
        "NAME": "W\u00fcrben, Johann Franz (1634\u20131705), Geheimer Rat",
        "DATEOFBIRTH": "1634 Nov 03",
        "DATEOFDEATH": "1705 Aug 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10427",
        "NAME": "W\u00fcrben, Johann (1505\u20131559)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1559 Jan 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Freudenthal in Schlesien"
    },
    {
        "ID": "10428",
        "NAME": "W\u00fcrben, Ignaz (1534\u20131596), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1596 Apr 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10429",
        "NAME": "W\u00fcrben, Georg (1565\u20131625), K\u00e4mmerer",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1625 Mai 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10430",
        "NAME": "Rabatta, Joseph (1555\u20131601)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1601 Dez 31",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "Zengg"
    },
    {
        "ID": "10431",
        "NAME": "Rabatta, Anton (1590\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1650 Aug 02",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10432",
        "NAME": "Rabatta, Michael (1635\u20131665), Mundschenk",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1665 Jun 17",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "Montes Claros jenseits des Tejo"
    },
    {
        "ID": "10433",
        "NAME": "Rabatta, Johann Baptist (1625\u20131681), K\u00e4mmerer",
        "DATEOFBIRTH": "1625 Feb 06",
        "DATEOFDEATH": "1681 Mai 24",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10434",
        "NAME": "Rabatta, Ludwig (1624\u20131664), Landeshauptmann von G\u00f6rz",
        "DATEOFBIRTH": "1624",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10435",
        "NAME": "Rabatta, Rudolf (1640\u20131688), Hofkriegsrat",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1688",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "10436",
        "NAME": "Rabatta, Ferdinand (1630\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10437",
        "NAME": "Rabatta, Hieronym (1638\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1638",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10438",
        "NAME": "Rabatta, Anton (1656\u20131741), Geheimer Rat",
        "DATEOFBIRTH": "1656",
        "DATEOFDEATH": "1741",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "G\u00f6rz"
    },
    {
        "ID": "10439",
        "NAME": "Rabatta, Joseph (1661\u20131731), K\u00e4mmerer",
        "DATEOFBIRTH": "1661",
        "DATEOFDEATH": "1731",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "Karlstadt in Kroatien"
    },
    {
        "ID": "10440",
        "NAME": "Scherffenberg, Johann Wilhelm (1610\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1610",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10441",
        "NAME": "Breunner, Friedrich (1460\u20131528)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "Prein an der Rax",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10442",
        "NAME": "Breunner, Christoph (1495\u20131559)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1559",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10443",
        "NAME": "Breunner, Kaspar (1530\u20131570), Geheimer Rat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1570",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10444",
        "NAME": "Breunner, Philipp (1498\u20131556), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1498",
        "DATEOFDEATH": "1556 Apr 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10445",
        "NAME": "Breunner, Siegfried (1538\u20131594), Statthalter von Nieder\u00f6sterreich",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1594 Jun 27",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "10446",
        "NAME": "Breunner, Johann Baptist (1570\u20131633), Hofkriegsrat",
        "DATEOFBIRTH": "1570",
        "DATEOFDEATH": "1633 Okt 03",
        "PLACEOFBIRTH": "Staatz im Weinviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10447",
        "NAME": "Breunner, Philipp Friedrich (1597\u20131669), Bischof von Wien",
        "DATEOFBIRTH": "1597 Sep 06",
        "DATEOFDEATH": "1669 Mai 22",
        "PLACEOFBIRTH": "Jauer an der Raab",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10448",
        "NAME": "Breunner, Siegfried Leonhard (1596\u20131667), Geheimer Rat",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1667 Feb 01",
        "PLACEOFBIRTH": "Staatz im Weinviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10449",
        "NAME": "Breunner, Philipp Friedrich (1601\u20131638)",
        "DATEOFBIRTH": "1601",
        "DATEOFDEATH": "1638 Mar 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Warnem\u00fcnde"
    },
    {
        "ID": "10450",
        "NAME": "Truchsess von Waldburg, Maria Johanna (1627\u20131691)",
        "DATEOFBIRTH": "1627 Apr 24",
        "DATEOFDEATH": "1691 Nov 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10451",
        "NAME": "Rabatta, Ludwig (1690\u20131721), K\u00e4mmerer",
        "DATEOFBIRTH": "1690~",
        "DATEOFDEATH": "1721 Jun 02",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "Karlstadt in Kroatien"
    },
    {
        "ID": "10452",
        "NAME": "Rabatta, Philipp (1663\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1663",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10453",
        "NAME": "Kaunitz, Ulrich (1569\u20131617)",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1617 Feb 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10454",
        "NAME": "Kaunitz, Friedrich (1597\u20131627), Mundschenk",
        "DATEOFBIRTH": "1597 Jul 26",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Austerlitz in M\u00e4hren",
        "PLACEOFDEATH": "Lomnitz in Schlesien"
    },
    {
        "ID": "10455",
        "NAME": "Kaunitz, Rudolf (1620\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1664 Apr 21",
        "PLACEOFBIRTH": "Austerlitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10456",
        "NAME": "Bonacossi, Scipio (1620\u2013\u00a0\u00a0\u00a0\u00a0), Vorschneider",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ferrara",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10457",
        "NAME": "Bonacossi, Albrecht (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ferrara",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10458",
        "NAME": "Colloredo, Hotze (1568\u20131646)",
        "DATEOFBIRTH": "1568 Sep 29",
        "DATEOFDEATH": "1646",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10459",
        "NAME": "Colloredo, Ludwig (1540\u20131598), K\u00e4mmerer",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10460",
        "NAME": "Waldstein, Katharina (1624\u20131647)",
        "DATEOFBIRTH": "1624",
        "DATEOFDEATH": "1647",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Senftenberg im Adlergebirge"
    },
    {
        "ID": "10461",
        "NAME": "Carretto, Johann Baptist (1620\u20131667), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1667",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10462",
        "NAME": "Carretto, Karl (1620\u20131689), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1689",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10463",
        "NAME": "Carretto, Otto (1375\u20131426)",
        "DATEOFBIRTH": "1375~",
        "DATEOFDEATH": "1426",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10464",
        "NAME": "Carretto, Otto (1410\u20131465)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1465 Jan 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "10465",
        "NAME": "Carretto, Oktavian (1440\u20131499)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1499 Aug 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10466",
        "NAME": "Carretto, Niklas (1470\u20131536)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1536",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10467",
        "NAME": "Carretto, Oktavian (1500\u20131559)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1559",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10468",
        "NAME": "Carretto, Galeas (1520\u20131591)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1591 Dez 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10469",
        "NAME": "Carretto, Prosper (1558\u20131596)",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "Pavia",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "10470",
        "NAME": "Carretto, Georg (1345\u20131390)",
        "DATEOFBIRTH": "1345~",
        "DATEOFDEATH": "1390 Jun 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10471",
        "NAME": "Carretto, Konrad (1385\u20131452)",
        "DATEOFBIRTH": "1385~",
        "DATEOFDEATH": "1452",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Jerusalem"
    },
    {
        "ID": "10472",
        "NAME": "Carretto, Theoderich (1420\u20131475)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1475",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10473",
        "NAME": "Carretto, Albrecht (1458\u20131505)",
        "DATEOFBIRTH": "1458",
        "DATEOFDEATH": "1505 Jun 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Casale Monferrato"
    },
    {
        "ID": "10474",
        "NAME": "Carretto, Vinzenz (1490\u20131575)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1575 Jul 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10475",
        "NAME": "Breunner, Ferdinand (1607\u20131666), Oberststallmeister",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1666 Mar 25",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10476",
        "NAME": "Breunner, Maximilian (1572\u20131614), K\u00e4mmerer",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1614",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10477",
        "NAME": "Breunner, Georg Siegfried (1602\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1602",
        "DATEOFDEATH": "1654 Dez 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10478",
        "NAME": "Breunner, Siegfried Christoph (1635\u20131698), Geheimer Rat",
        "DATEOFBIRTH": "1635",
        "DATEOFDEATH": "1698 Mai 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10479",
        "NAME": "Breunner, Siegfried Wenzel (1670\u20131716)",
        "DATEOFBIRTH": "1670 Okt 05",
        "DATEOFDEATH": "1716 Aug 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wardein an der Donau"
    },
    {
        "ID": "10480",
        "NAME": "Reifferscheid, Ernst Friedrich (1583\u20131639)",
        "DATEOFBIRTH": "1583 Mai 29",
        "DATEOFDEATH": "1639 Sep 13",
        "PLACEOFBIRTH": "Reifferscheid in der Eifel",
        "PLACEOFDEATH": "Dyck am Niederrhein"
    },
    {
        "ID": "10481",
        "NAME": "Carretto, Niklas (1537\u20131591)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1591 Dez 12",
        "PLACEOFBIRTH": "Millesimo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10482",
        "NAME": "Carretto, Stephan (1575\u20131635), Edelknabe",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "10483",
        "NAME": "Carretto, Silvia (1607\u20131664)",
        "DATEOFBIRTH": "1607 Feb 06",
        "DATEOFDEATH": "1664 Feb 26",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "10484",
        "NAME": "Kronegg, Johann Wilhelm (1580\u20131650), Hofkammerrat",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1650~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10485",
        "NAME": "Waldstein, Elisabeth (1624\u20131662)",
        "DATEOFBIRTH": "1624",
        "DATEOFDEATH": "1662 Sep 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10486",
        "NAME": "Gersdorff, Johann Siegmund (1620\u20131653), Mundschenk",
        "DATEOFBIRTH": "1620",
        "DATEOFDEATH": "1653",
        "PLACEOFBIRTH": "Hermsdorf an der Ochel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10487",
        "NAME": "Trautson, Maria Z\u00e4zilia (1636\u20131670)",
        "DATEOFBIRTH": "1636 Apr 05",
        "DATEOFDEATH": "1670 Aug 04",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "10488",
        "NAME": "Harrach, Elisabeth (1601\u20131654)",
        "DATEOFBIRTH": "1601 Sep 28",
        "DATEOFDEATH": "1654 Mar 23",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Neuschloss in der Steiermark"
    },
    {
        "ID": "10489",
        "NAME": "Harrach, Katharina (1599\u20131640)",
        "DATEOFBIRTH": "1599 Nov 10",
        "DATEOFDEATH": "1640 Aug 22",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10490",
        "NAME": "Eggenberg, Franziska (1602\u20131676)",
        "DATEOFBIRTH": "1602",
        "DATEOFDEATH": "1676 Feb 04",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10491",
        "NAME": "Marradas, Bartlome (1618\u20131670), Obersthofmeister",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1670 Aug 26",
        "PLACEOFBIRTH": "Valencia",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10492",
        "NAME": "Marradas, Franz (1590\u20131656), Obersthofmeister",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1656 Feb 03",
        "PLACEOFBIRTH": "Valencia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10493",
        "NAME": "Kolowrat, Franz Karl (1620\u20131700), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1620 Mai 13",
        "DATEOFDEATH": "1700 Mai 04",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "10494",
        "NAME": "Kolowrat, Sidonius Leopold (1562\u20131640)",
        "DATEOFBIRTH": "1562",
        "DATEOFDEATH": "1640 Feb 24",
        "PLACEOFBIRTH": "Altsattler B\u00fcrgel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10495",
        "NAME": "Kolowrat, Wilhelm Albrecht (1600\u20131688), K\u00e4mmerer",
        "DATEOFBIRTH": "1600 Feb 18",
        "DATEOFDEATH": "1688 Feb 09",
        "PLACEOFBIRTH": "Rothschlo\u00df",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10496",
        "NAME": "Kolowrat, Johann (1552\u20131616), K\u00e4mmerer",
        "DATEOFBIRTH": "1552 Dez 18",
        "DATEOFDEATH": "1616 Aug 14",
        "PLACEOFBIRTH": "Altsattler B\u00fcrgel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10497",
        "NAME": "Kolowrat, Albrecht (1525\u20131586)",
        "DATEOFBIRTH": "1525",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "Liebstein in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10498",
        "NAME": "Kolowrat, Heinrich (1569\u20131646), Obersthofmeister",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1646 Mar 06",
        "PLACEOFBIRTH": "Altsattler B\u00fcrgel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10499",
        "NAME": "Kolowrat, Albrecht (1583\u20131648), Reichshofrat",
        "DATEOFBIRTH": "1583 Sep 16",
        "DATEOFDEATH": "1648 Aug 12",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10500",
        "NAME": "Habsburg, Karl\u00a0V. (1500\u20131558), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1500 Feb 24",
        "DATEOFDEATH": "1558 Sep 21",
        "PLACEOFBIRTH": "Gent in Flandern",
        "PLACEOFDEATH": "San Jer\u00f3nimo de Yuste"
    },
    {
        "ID": "10501",
        "NAME": "Fugger, Anton (1493\u20131560)",
        "DATEOFBIRTH": "1493 Jun 10",
        "DATEOFDEATH": "1560 Sep 14",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "10502",
        "NAME": "Fugger, Mark (1529\u20131597)",
        "DATEOFBIRTH": "1529 Feb 14",
        "DATEOFDEATH": "1597 Jun 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "10503",
        "NAME": "Fugger, Philipp (1567\u20131601)",
        "DATEOFBIRTH": "1567 Jun 19",
        "DATEOFDEATH": "1601 Jun 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "10504",
        "NAME": "Fugger, Markward (1595\u20131655), Obersthofmeister",
        "DATEOFBIRTH": "1595 Nov 04",
        "DATEOFDEATH": "1655 Aug 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ebersdorf an der Schwechat"
    },
    {
        "ID": "10505",
        "NAME": "Fugger, Johann (1531\u20131598)",
        "DATEOFBIRTH": "1531 Sep 04",
        "DATEOFDEATH": "1598 Apr 15",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "10506",
        "NAME": "Fugger, Mark (1564\u20131614)",
        "DATEOFBIRTH": "1564 Apr 26",
        "DATEOFDEATH": "1614 Dez 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "10507",
        "NAME": "Fugger, Johann (1591\u20131638)",
        "DATEOFBIRTH": "1591 Feb 18",
        "DATEOFDEATH": "1638 Apr 15",
        "PLACEOFBIRTH": "Speyer",
        "PLACEOFDEATH": "Kirchheim in Schwaben"
    },
    {
        "ID": "10508",
        "NAME": "Fugger, Johann Euseb (1617\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1617 Jul 03",
        "DATEOFDEATH": "1672 Mar 11",
        "PLACEOFBIRTH": "Kirchheim in Schwaben",
        "PLACEOFDEATH": "Kirchheim in Schwaben"
    },
    {
        "ID": "10509",
        "NAME": "Fugger, Christoph (1566\u20131615), K\u00e4mmerer",
        "DATEOFBIRTH": "1566 Nov 11",
        "DATEOFDEATH": "1615 Dez 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Augsburg:Ulrichsbasilika"
    },
    {
        "ID": "10510",
        "NAME": "Fugger, Christoph Rudolf (1615\u20131673), K\u00e4mmerer",
        "DATEOFBIRTH": "1615 Feb 08",
        "DATEOFDEATH": "1673 Nov 05",
        "PLACEOFBIRTH": "Speyer",
        "PLACEOFDEATH": "Gl\u00f6tt in Schwaben"
    },
    {
        "ID": "10511",
        "NAME": "Fugger, Jakob (1542\u20131598)",
        "DATEOFBIRTH": "1542 Mar 30",
        "DATEOFDEATH": "1598 Feb 07",
        "PLACEOFBIRTH": "Babenhausen in Schwaben",
        "PLACEOFDEATH": "Babenhausen in Schwaben"
    },
    {
        "ID": "10512",
        "NAME": "Fugger, Johann (1583\u20131633)",
        "DATEOFBIRTH": "1583 Jun 01",
        "DATEOFDEATH": "1633 Apr 28",
        "PLACEOFBIRTH": "Babenhausen in Schwaben",
        "PLACEOFDEATH": "Telfs"
    },
    {
        "ID": "10513",
        "NAME": "Fugger, Johann Franz (1613\u20131668), K\u00e4mmerer",
        "DATEOFBIRTH": "1613 Apr 05",
        "DATEOFDEATH": "1668 Dez 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Babenhausen in Schwaben"
    },
    {
        "ID": "10514",
        "NAME": "Fugger, Katharina (1532\u20131585)",
        "DATEOFBIRTH": "1532 Nov 06",
        "DATEOFDEATH": "1585 Feb 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10515",
        "NAME": "Esterh\u00e1zy, Franz (1533\u20131604)",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1604",
        "PLACEOFBIRTH": "Pressburg",
        "PLACEOFDEATH": "Gallandau"
    },
    {
        "ID": "10516",
        "NAME": "Esterh\u00e1zy, Paul (1587\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1587 Feb 01",
        "DATEOFDEATH": "1645 Jan 17",
        "PLACEOFBIRTH": "Gallandau",
        "PLACEOFDEATH": "Neuh\u00e4usel im Donautiefland"
    },
    {
        "ID": "10517",
        "NAME": "Fugger, Sibylla (1572\u20131616)",
        "DATEOFBIRTH": "1572 Okt 04",
        "DATEOFDEATH": "1616 Apr 14",
        "PLACEOFBIRTH": "Babenhausen in Schwaben",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10518",
        "NAME": "Guyard von Saint Julien, Heinrich (1590\u20131642), Hofkriegsrat",
        "DATEOFBIRTH": "1590 Apr 18",
        "DATEOFDEATH": "1642 Okt 20",
        "PLACEOFBIRTH": "Beauregard an der Ouv\u00e8ze",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "10519",
        "NAME": "Esterh\u00e1zy, Lassel (1626\u20131652), K\u00e4mmerer",
        "DATEOFBIRTH": "1626 Dez 31",
        "DATEOFDEATH": "1652 Aug 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Vezek\u00e9ny"
    },
    {
        "ID": "10520",
        "NAME": "Eggenberg, Ulrich (1400\u20131448)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1448 Mai 22",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10521",
        "NAME": "Eggenberg, Johann (1440\u20131481)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1481 Okt 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Radkersburg"
    },
    {
        "ID": "10522",
        "NAME": "Eggenberg, Andreas (1475\u20131517)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1517",
        "PLACEOFBIRTH": "Radkersburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10523",
        "NAME": "Eggenberg, Christoph (1510\u20131553)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1553 Feb 21",
        "PLACEOFBIRTH": "Radkersburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10524",
        "NAME": "Eggenberg, Bartlome (1547\u20131585)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1585 Mai 05",
        "PLACEOFBIRTH": "Ehrenhausen in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10525",
        "NAME": "Eggenberg, Balthasar (1430\u20131493), M\u00fcnzmeister in Graz",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1493",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10526",
        "NAME": "Eggenberg, Wolfgang (1475\u20131536)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1536 Sep 11",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10527",
        "NAME": "Eggenberg, Siegfried (1526\u20131594)",
        "DATEOFBIRTH": "1526",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10528",
        "NAME": "Hohenzollern, Karl (1516\u20131576), Reichshofratspr\u00e4sident",
        "DATEOFBIRTH": "1516",
        "DATEOFDEATH": "1576 Mar 08",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Sigmaringen"
    },
    {
        "ID": "10529",
        "NAME": "Hohenzollern, Eitel Friedrich (1545\u20131605), Reichshofrat",
        "DATEOFBIRTH": "1545 Sep 07",
        "DATEOFDEATH": "1605 Jan 16",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": "Hechingen"
    },
    {
        "ID": "10530",
        "NAME": "Hohenzollern, Johann Georg (1577\u20131623), Reichshofratspr\u00e4sident",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1623 Sep 28",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Hechingen"
    },
    {
        "ID": "10531",
        "NAME": "Czernin von Chudenitz, Johann (1545\u20131580)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1580 Aug 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10532",
        "NAME": "Fugger, Maria (1566\u20131646)",
        "DATEOFBIRTH": "1566 Apr 30",
        "DATEOFDEATH": "1646 Mai 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bibersburg"
    },
    {
        "ID": "10533",
        "NAME": "Dietrichstein, Maximilian (1638\u20131692), K\u00e4mmerer",
        "DATEOFBIRTH": "1638 Apr 14",
        "DATEOFDEATH": "1692 Dez 04",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Iglau in M\u00e4hren"
    },
    {
        "ID": "10534",
        "NAME": "Eggenberg, Ruprecht (1545\u20131611)",
        "DATEOFBIRTH": "1545",
        "DATEOFDEATH": "1611 Feb 07",
        "PLACEOFBIRTH": "Ehrenhausen in der Steiermark",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10535",
        "NAME": "R\u00e9vay, Franz (1590\u20131656)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "Sklabinia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10536",
        "NAME": "R\u00e9vay, Daniel (1625\u20131676), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1676",
        "PLACEOFBIRTH": "Sklabinia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10537",
        "NAME": "R\u00e9vay, Emmerich (1630\u20131688), Truchsess",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1688 Okt 24",
        "PLACEOFBIRTH": "Sklabinia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10538",
        "NAME": "Czernin von Chudenitz, Hermann (1576\u20131651), K\u00e4mmerer",
        "DATEOFBIRTH": "1576 Jul 24",
        "DATEOFDEATH": "1651 Feb 06",
        "PLACEOFBIRTH": "Nedrahovice",
        "PLACEOFDEATH": "Kost im B\u00f6hmischen Paradies"
    },
    {
        "ID": "10539",
        "NAME": "Czernin von Chudenitz, Dionys (1568\u20131621)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1621 Jun 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10540",
        "NAME": "Czernin von Chudenitz, Humprecht (1570\u20131632), K\u00e4mmerer",
        "DATEOFBIRTH": "1570 Apr 15",
        "DATEOFDEATH": "1632 Mai 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Raden\u00edn"
    },
    {
        "ID": "10541",
        "NAME": "Puchheim, Adolf Ehrenreich (1628\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1628",
        "DATEOFDEATH": "1664 Okt 27",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10542",
        "NAME": "Proskau, Johann Christoph (1569\u20131625), K\u00e4mmerer",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1625 Sep 19",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10543",
        "NAME": "Bark\u00f3czy, Lassel (1601\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1601",
        "DATEOFDEATH": "1659 Jan 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "B\u00e1tka"
    },
    {
        "ID": "10544",
        "NAME": "R\u00e1k\u00f3czi, Lassel (1633\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1633",
        "DATEOFDEATH": "1664 Mai 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wardein an der Schnellen Kreisch"
    },
    {
        "ID": "10545",
        "NAME": "Nogarola, Franz (1620\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10546",
        "NAME": "Zastrizl, Ulrich Desider (1615\u20131664), Truchsess",
        "DATEOFBIRTH": "1615",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "Morkovice",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10547",
        "NAME": "Trautson, Ernst (1633\u20131702), Bischof von Wien",
        "DATEOFBIRTH": "1633 Dez 26",
        "DATEOFDEATH": "1702 Jan 07",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Stephansdom"
    },
    {
        "ID": "10548",
        "NAME": "Escher von Binningen, Johann Werner (1582\u20131652)",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1652 Dez 26",
        "PLACEOFBIRTH": "Binningen im Leimental",
        "PLACEOFDEATH": "Waldkirch im Breisgau"
    },
    {
        "ID": "10549",
        "NAME": "Escher von Binningen, Gravis Franz (1618\u20131669), K\u00e4mmerer",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1669",
        "PLACEOFBIRTH": "Binningen im Leimental",
        "PLACEOFDEATH": "B\u00fcningen im Breisgau"
    },
    {
        "ID": "10550",
        "NAME": "P\u00e1lffy, Sophia (1596\u20131668)",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1668 Mar 22",
        "PLACEOFBIRTH": "Bibersburg",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10551",
        "NAME": "Desfours, Niklas (1588\u20131661), K\u00e4mmerer",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1661 Dez 05",
        "PLACEOFBIRTH": "Athienville",
        "PLACEOFDEATH": "Hrub\u00fd Rohozec"
    },
    {
        "ID": "10552",
        "NAME": "Desfours, Albrecht Maximilian (1629\u20131683), K\u00e4mmerer",
        "DATEOFBIRTH": "1629 Aug 03",
        "DATEOFDEATH": "1683 Jan 15",
        "PLACEOFBIRTH": "Hrub\u00fd Rohozec",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10553",
        "NAME": "Czernin von Chudenitz, Humprecht (1618\u20131666), Truchsess",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1666 Apr 25",
        "PLACEOFBIRTH": "Schwihau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10554",
        "NAME": "Czernin von Chudenitz, Johann (1597\u20131642), Edelknabe",
        "DATEOFBIRTH": "1597 Aug 16",
        "DATEOFDEATH": "1642 Nov 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Raden\u00edn"
    },
    {
        "ID": "10555",
        "NAME": "Czernin von Chudenitz, Humprecht Johann (1628\u20131682), Geheimer Rat",
        "DATEOFBIRTH": "1628 Feb 17",
        "DATEOFDEATH": "1682 Mar 03",
        "PLACEOFBIRTH": "Choustn\u00edk",
        "PLACEOFDEATH": "Kosmonosy"
    },
    {
        "ID": "10556",
        "NAME": "Czernin von Chudenitz, Hermann Jakob (1659\u20131710), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1659 Jul 25",
        "DATEOFDEATH": "1710 Aug 08",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10557",
        "NAME": "Czernin von Chudenitz, Dionys (1500\u20131548)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10558",
        "NAME": "Czernin von Chudenitz, Humprecht (1540\u20131601), Oberstkanzler von B\u00f6hmen",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1601",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10559",
        "NAME": "Czernin von Chudenitz, Heinrich (1580\u20131640), Edelknabe",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1640 Jun 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Schwihau"
    },
    {
        "ID": "10560",
        "NAME": "Korybut, Michael Thomas (1638\u20131673), K\u00f6nig von Polen",
        "DATEOFBIRTH": "1638 Jun 18",
        "DATEOFDEATH": "1673 Nov 10",
        "PLACEOFBIRTH": "Wei\u00dfenstein in Galizien",
        "PLACEOFDEATH": "Lemberg in Galizien"
    },
    {
        "ID": "10561",
        "NAME": "Khevenh\u00fcller, Christoph (1503\u20131557), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1503 Dez 24",
        "DATEOFDEATH": "1557 Apr 03",
        "PLACEOFBIRTH": "Stra\u00dfburg in K\u00e4rnten",
        "PLACEOFDEATH": "Landskron in K\u00e4rnten"
    },
    {
        "ID": "10562",
        "NAME": "Khevenh\u00fcller, Bartlome (1539\u20131613), Oberststallmeister",
        "DATEOFBIRTH": "1539 Aug 22",
        "DATEOFDEATH": "1613 Aug 16",
        "PLACEOFBIRTH": "Spittal an der Drau",
        "PLACEOFDEATH": "Spittal an der Drau"
    },
    {
        "ID": "10563",
        "NAME": "Khevenh\u00fcller, Augustin (1580\u20131625)",
        "DATEOFBIRTH": "1580 Jul 06",
        "DATEOFDEATH": "1625 Jul 26",
        "PLACEOFBIRTH": "Spittal an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10564",
        "NAME": "Khevenh\u00fcller, Moritz (1549\u20131596), K\u00e4mmerer",
        "DATEOFBIRTH": "1549 Nov 24",
        "DATEOFDEATH": "1596 Aug 07",
        "PLACEOFBIRTH": "Landskron in K\u00e4rnten",
        "PLACEOFDEATH": "Sankt Johann im Pongau"
    },
    {
        "ID": "10565",
        "NAME": "Khevenh\u00fcller, Augustin (1460\u20131519), Reichshofrat",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1519 Mar 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10566",
        "NAME": "Khevenh\u00fcller, Matthias (1617\u20131636), Mundschenk",
        "DATEOFBIRTH": "1617 Apr 28",
        "DATEOFDEATH": "1636 Jul 22",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": "Boffalora am Tessin"
    },
    {
        "ID": "10567",
        "NAME": "Verdugo, Franz (1537\u20131595)",
        "DATEOFBIRTH": "1537 Mar 13",
        "DATEOFDEATH": "1595 Sep 22",
        "PLACEOFBIRTH": "Talavera de la Reina",
        "PLACEOFDEATH": "Clausen in Luxemburg"
    },
    {
        "ID": "10568",
        "NAME": "Verdugo, Wilhelm (1578\u20131629), K\u00e4mmerer",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1629 Jan 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kreuznach"
    },
    {
        "ID": "10569",
        "NAME": "Verdugo, Franz (1583\u20131650)",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1650 Jul 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Duppau"
    },
    {
        "ID": "10570",
        "NAME": "Hatzfeldt, Franz (1596\u20131642), Bischof von W\u00fcrzburg",
        "DATEOFBIRTH": "1596 Sep 13",
        "DATEOFDEATH": "1642 Jul 30",
        "PLACEOFBIRTH": "Krottorf im Westerwald",
        "PLACEOFDEATH": "W\u00fcrzburg"
    },
    {
        "ID": "10571",
        "NAME": "Hatzfeldt, Friedrich (1480\u20131531)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1531 Okt 10",
        "PLACEOFBIRTH": "Wildenburg im Westerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10572",
        "NAME": "Hatzfeldt, Wilhelm (1520\u20131570)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1570 Jul 17",
        "PLACEOFBIRTH": "Wildenburg im Westerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10573",
        "NAME": "Hatzfeldt, Georg (1525\u20131593)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1593",
        "PLACEOFBIRTH": "Wildenburg im Westerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10574",
        "NAME": "Hatzfeldt, Bernhard (1555\u20131603)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "Wildenburg im Westerwald",
        "PLACEOFDEATH": "Rhade an der Volme"
    },
    {
        "ID": "10575",
        "NAME": "Hatzfeldt, Heinrich Ludwig (1585\u20131631)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1631 Feb 01",
        "PLACEOFBIRTH": "Wildenburg im Westerwald",
        "PLACEOFDEATH": "Rostock"
    },
    {
        "ID": "10576",
        "NAME": "Hatzfeldt, Wolfgang Heinrich (1615\u20131636), Mundschenk",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1636 Okt 04",
        "PLACEOFBIRTH": "Wildenburg im Westerwald",
        "PLACEOFDEATH": "Wittstock an der Dosse"
    },
    {
        "ID": "10577",
        "NAME": "Hoyos, Ludwig (1551\u20131600), Reichshofrat",
        "DATEOFBIRTH": "1551",
        "DATEOFDEATH": "1600 Jan 14",
        "PLACEOFBIRTH": "Stixenstein",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10578",
        "NAME": "Wolkenstein, Georg Ulrich (1598\u20131663), Reichshofratsvizepr\u00e4sident",
        "DATEOFBIRTH": "1598 Nov 02",
        "DATEOFDEATH": "1663 Apr 24",
        "PLACEOFBIRTH": "Rodenegg",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "10579",
        "NAME": "Questenberg, Gerhard (1540\u20131587)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1587",
        "PLACEOFBIRTH": "K\u00f6ln am Rhein",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "10580",
        "NAME": "Questenberg, Hermann (1581\u20131651), Reichshofrat",
        "DATEOFBIRTH": "1581",
        "DATEOFDEATH": "1651 Jan 21",
        "PLACEOFBIRTH": "K\u00f6ln am Rhein",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "10581",
        "NAME": "Questenberg, Kaspar (1571\u20131640), Generalvisitator der Pr\u00e4monstratenser",
        "DATEOFBIRTH": "1571",
        "DATEOFDEATH": "1640 Jun 28",
        "PLACEOFBIRTH": "K\u00f6ln am Rhein",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10582",
        "NAME": "Questenberg, Gerhard (1586\u20131646), Hofkriegsrat",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1646 Jun 01",
        "PLACEOFBIRTH": "K\u00f6ln am Rhein",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10583",
        "NAME": "Questenberg, Johann (1587\u20131624)",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "K\u00f6ln am Rhein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10584",
        "NAME": "Questenberg, Johann Anton (1633\u20131686), K\u00e4mmerer",
        "DATEOFBIRTH": "1633 Aug 08",
        "DATEOFDEATH": "1686 Okt 14",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Jarmeritz"
    },
    {
        "ID": "10585",
        "NAME": "Questenberg, Johann Adam (1678\u20131752), Reichshofrat",
        "DATEOFBIRTH": "1678 Feb 23",
        "DATEOFDEATH": "1752 Mai 10",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Jarmeritz"
    },
    {
        "ID": "10586",
        "NAME": "Marschall von Pappenheim, Heinrich (1380\u20131438)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1438",
        "PLACEOFBIRTH": "Pappenheim an der Altm\u00fchl",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10587",
        "NAME": "Marschall von Pappenheim, Georg (1430\u20131485)",
        "DATEOFBIRTH": "1430",
        "DATEOFDEATH": "1485",
        "PLACEOFBIRTH": "Pappenheim an der Altm\u00fchl",
        "PLACEOFDEATH": "Treuchtlingen"
    },
    {
        "ID": "10588",
        "NAME": "Marschall von Pappenheim, Georg (1465\u20131529)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1529",
        "PLACEOFBIRTH": "Treuchtlingen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10589",
        "NAME": "Marschall von Pappenheim, Georg (1519\u20131553)",
        "DATEOFBIRTH": "1519 Mar 08",
        "DATEOFDEATH": "1553 Apr 26",
        "PLACEOFBIRTH": "Treuchtlingen",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "10590",
        "NAME": "Marschall von Pappenheim, Ulrich (1500\u20131539)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1539",
        "PLACEOFBIRTH": "Treuchtlingen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10591",
        "NAME": "Marschall von Pappenheim, Veit (1535\u20131600)",
        "DATEOFBIRTH": "1535 Jun 16",
        "DATEOFDEATH": "1600 Jun 08",
        "PLACEOFBIRTH": "Schwindegg",
        "PLACEOFDEATH": "Wemding"
    },
    {
        "ID": "10592",
        "NAME": "Marschall von Pappenheim, Siegmund (1434\u20131496)",
        "DATEOFBIRTH": "1434",
        "DATEOFDEATH": "1496",
        "PLACEOFBIRTH": "Pappenheim an der Altm\u00fchl",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10593",
        "NAME": "Marschall von Pappenheim, Siegmund (1470\u20131536)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1536",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10594",
        "NAME": "Marschall von Pappenheim, Heinrich (1510\u20131559)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1559 Mai 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10595",
        "NAME": "Marschall von Pappenheim, Veit (1550\u20131621)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1621 Okt 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10596",
        "NAME": "Marschall von Pappenheim, Georg Wilhelm (1595\u20131622)",
        "DATEOFBIRTH": "1595",
        "DATEOFDEATH": "1622 Jan 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10597",
        "NAME": "Marschall von Pappenheim, Heinrich (1413\u20131484)",
        "DATEOFBIRTH": "1413",
        "DATEOFDEATH": "1484",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10598",
        "NAME": "Marschall von Pappenheim, Alexander (1435\u20131511)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1511",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Gr\u00f6nenbach im Allg\u00e4u"
    },
    {
        "ID": "10599",
        "NAME": "Marschall von Pappenheim, Heinrich (1480\u20131547)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1547 Feb 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pappenheim an der Altm\u00fchl"
    },
    {
        "ID": "10600",
        "NAME": "Habsburg, Karl\u00a0VI. (1685\u20131740), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1685 Okt 01",
        "DATEOFDEATH": "1740 Okt 20",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "10601",
        "NAME": "Oettingen, Wilhelm (1544\u20131602)",
        "DATEOFBIRTH": "1544",
        "DATEOFDEATH": "1602 Okt 14",
        "PLACEOFBIRTH": "Wallerstein",
        "PLACEOFDEATH": "Wallerstein"
    },
    {
        "ID": "10602",
        "NAME": "Oettingen, Wolfgang (1573\u20131598)",
        "DATEOFBIRTH": "1573 Mar 21",
        "DATEOFDEATH": "1598 Sep 05",
        "PLACEOFBIRTH": "Wallerstein",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10603",
        "NAME": "Oettingen, Ernst (1584\u20131626), K\u00e4mmerer",
        "DATEOFBIRTH": "1584 Okt 24",
        "DATEOFDEATH": "1626 Mai 18",
        "PLACEOFBIRTH": "Wallerstein",
        "PLACEOFDEATH": "Baldern"
    },
    {
        "ID": "10604",
        "NAME": "Oettingen, Martin Franz (1611\u20131653), K\u00e4mmerer",
        "DATEOFBIRTH": "1611 Aug 28",
        "DATEOFDEATH": "1653 Sep 11",
        "PLACEOFBIRTH": "Katzenstein an der Egau",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "10605",
        "NAME": "Oettingen, Friedrich Wilhelm (1618\u20131677), K\u00e4mmerer",
        "DATEOFBIRTH": "1618 Mai 07",
        "DATEOFDEATH": "1677 Okt 20",
        "PLACEOFBIRTH": "Katzenstein an der Egau",
        "PLACEOFDEATH": "Katzenstein an der Egau"
    },
    {
        "ID": "10606",
        "NAME": "Hoyos, Johann Ludwig (1615\u20131658), K\u00e4mmerer",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1658 Mar 13",
        "PLACEOFBIRTH": "Stixenstein",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "10607",
        "NAME": "Hoyos, Johann Balthasar (1626\u20131681), Geheimer Rat",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1681 Okt 09",
        "PLACEOFBIRTH": "Stixenstein",
        "PLACEOFDEATH": "Stixenstein"
    },
    {
        "ID": "10608",
        "NAME": "Hoyos, Karl Franz (1666\u20131706), Reichshofrat",
        "DATEOFBIRTH": "1666",
        "DATEOFDEATH": "1706 Jan 18",
        "PLACEOFBIRTH": "Stixenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10609",
        "NAME": "Sprinzenstein, Ferdinand Maximilian (1625\u20131678), Geheimer Rat",
        "DATEOFBIRTH": "1625",
        "DATEOFDEATH": "1678 Mai 17",
        "PLACEOFBIRTH": "Neuhaus im M\u00fchlviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10610",
        "NAME": "Sprinzenstein, Paul (1480\u20131542)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1542",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "10611",
        "NAME": "Sprinzenstein, Hieronym (1510\u20131570), Obersthofmeister",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1570 Feb 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neuhaus im M\u00fchlviertel"
    },
    {
        "ID": "10612",
        "NAME": "Sprinzenstein, Alexander (1540\u20131597), Reichshofrat",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1597 Jun 07",
        "PLACEOFBIRTH": "Neuhaus im M\u00fchlviertel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10613",
        "NAME": "Sprinzenstein, Johann Rudolf (1593\u20131632)",
        "DATEOFBIRTH": "1593 Apr 17",
        "DATEOFDEATH": "1632 Jul 20",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10614",
        "NAME": "Sprinzenstein, Wenzel Richard (1595\u20131651)",
        "DATEOFBIRTH": "1595 Feb 12",
        "DATEOFDEATH": "1651 Aug 16",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10615",
        "NAME": "Sprinzenstein, Franz Ignaz (1638\u20131705), K\u00e4mmerer",
        "DATEOFBIRTH": "1638 Sep 05",
        "DATEOFDEATH": "1705",
        "PLACEOFBIRTH": "Neuhaus im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10616",
        "NAME": "Sprinzenstein, Johann Sekund (1625\u20131691), K\u00e4mmerer",
        "DATEOFBIRTH": "1625 Dez 15",
        "DATEOFDEATH": "1691 Apr 21",
        "PLACEOFBIRTH": "Neuhaus im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10617",
        "NAME": "Sprinzenstein, Johann Ehrenreich (1667\u20131729), K\u00e4mmerer",
        "DATEOFBIRTH": "1667 Aug 25",
        "DATEOFDEATH": "1729 Mai 18",
        "PLACEOFBIRTH": "Neuhaus im M\u00fchlviertel",
        "PLACEOFDEATH": "Bruck an der Aschach"
    },
    {
        "ID": "10618",
        "NAME": "Frangipane di Veglia, Wolfgang (1587\u20131652), K\u00e4mmerer",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1652 Mai 13",
        "PLACEOFBIRTH": "Tersat am Flaum",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10619",
        "NAME": "Gonzaga, Ludwig (1611\u20131636), F\u00fcrst von Castiglione",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1636 Feb 22",
        "PLACEOFBIRTH": "Castiglione delle Stiviere",
        "PLACEOFDEATH": "Palermo"
    },
    {
        "ID": "10620",
        "NAME": "Verdugo, Ferdinand (1633\u20131672), Truchsess",
        "DATEOFBIRTH": "1633",
        "DATEOFDEATH": "1672 Sep 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Duppau"
    },
    {
        "ID": "10621",
        "NAME": "Wessel\u00e9nyi, Franz (1554\u20131594)",
        "DATEOFBIRTH": "1554",
        "DATEOFDEATH": "1594 Jul 26",
        "PLACEOFBIRTH": "Vegles",
        "PLACEOFDEATH": "Krakau:Franziskanerkirche"
    },
    {
        "ID": "10622",
        "NAME": "Wessel\u00e9nyi, Paul (1585\u20131621)",
        "DATEOFBIRTH": "1585",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "Trentschin im Waagtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10623",
        "NAME": "Wessel\u00e9nyi, Elisabeth (1582\u20131615)",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "Trentschin im Waagtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10624",
        "NAME": "Wessel\u00e9nyi, Anna (1584\u20131649)",
        "DATEOFBIRTH": "1584 Jun 03",
        "DATEOFDEATH": "1649 Aug 05",
        "PLACEOFBIRTH": "Trentschin im Waagtal",
        "PLACEOFDEATH": "Szendr\u0151"
    },
    {
        "ID": "10625",
        "NAME": "Wessel\u00e9nyi, Helena (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Trentschin im Waagtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10626",
        "NAME": "Pinell, Johann Baptist (1600\u20131658), Hofkammerrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10627",
        "NAME": "Panizol, Oktavian (1575\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10628",
        "NAME": "K\u00e9ry, Johann (1600\u20131660), Ungarischer Kronh\u00fcter",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1660",
        "PLACEOFBIRTH": "Ipolyk\u00e9r",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10629",
        "NAME": "K\u00e9ry, Johann (1637\u20131685), Bischof von Waitzen",
        "DATEOFBIRTH": "1637 Sep 04",
        "DATEOFDEATH": "1685 Mar 05",
        "PLACEOFBIRTH": "Ipolyk\u00e9r",
        "PLACEOFDEATH": "Tyrnau"
    },
    {
        "ID": "10630",
        "NAME": "Montfort, Jakob (1530\u20131572)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1572",
        "PLACEOFBIRTH": "Tettnang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10631",
        "NAME": "Proskau, Georg Christoph (1595\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1595 Jun 14",
        "DATEOFDEATH": "1633 Mai 12",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": "Z\u00fclz"
    },
    {
        "ID": "10632",
        "NAME": "Proskau, Johann Christoph (1626\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Br\u00fcnn in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10633",
        "NAME": "Proskau, Georg Christoph (1629\u20131701), K\u00e4mmerer",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1701 Sep 15",
        "PLACEOFBIRTH": "Br\u00fcnn in M\u00e4hren",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10634",
        "NAME": "Teuffenbach, Bernhard (1520\u20131576)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1576 Sep 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10635",
        "NAME": "Teuffenbach, Rudolf (1550\u20131625)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1625 Mai 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10636",
        "NAME": "Saurau, Karl (1587\u20131648), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1648 Jun 09",
        "PLACEOFBIRTH": "Ligist",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10637",
        "NAME": "N\u00e1chod, Georg (1589\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1634 Okt 29",
        "PLACEOFBIRTH": "Lichtenburg im Eisengebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10638",
        "NAME": "N\u00e1chod, Ferdinand Leopold (1625\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "Lichtenburg im Eisengebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10639",
        "NAME": "Saurau, Georg Christian (1624\u20131686), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1624 Mar 18",
        "DATEOFDEATH": "1686 Okt 31",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10640",
        "NAME": "Longueval de Buquoy, Karl Bonaventura (1571\u20131621), K\u00e4mmerer",
        "DATEOFBIRTH": "1571 Jan 09",
        "DATEOFDEATH": "1621 Jul 10",
        "PLACEOFBIRTH": "Atrecht",
        "PLACEOFDEATH": "Neuh\u00e4usel im Donautiefland"
    },
    {
        "ID": "10641",
        "NAME": "Teuffenbach, Susanna Katharina (1593\u20131647)",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1647 Nov 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10642",
        "NAME": "Teuffenbach, Christoph (1528\u20131598), Hofkriegsrat",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1598 Okt 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10643",
        "NAME": "Herberstein, Johann Friedrich (1626\u20131701), K\u00e4mmerer",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1701 Apr 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Arnsdorf an der Nei\u00dfe"
    },
    {
        "ID": "10644",
        "NAME": "Herberstein, Adam (1577\u20131626), K\u00e4mmerer",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1626 Mai 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10645",
        "NAME": "Herberstein, Johann Bernhard (1597\u20131663), K\u00e4mmerer",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "Salzburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10646",
        "NAME": "Herberstein, Georg (1529\u20131580), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1529 Jan 28",
        "DATEOFDEATH": "1580 Dez 12",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": "Stubenberg am See"
    },
    {
        "ID": "10647",
        "NAME": "Herberstein, Karl Euseb (1605\u20131643)",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1643 Mar 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10648",
        "NAME": "Herberstein, Adam Quintin (1625\u20131694), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1694",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10649",
        "NAME": "Herberstein, Ferdinand Ernst (1630\u20131691), Geheimer Rat",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1691 Mar 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10650",
        "NAME": "Herberstein, Bernhard (1490\u20131554)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1554 Mar 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10651",
        "NAME": "Herberstein, Karl (1538\u20131590), K\u00e4mmerer",
        "DATEOFBIRTH": "1538 Mai 28",
        "DATEOFDEATH": "1590 Nov 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10652",
        "NAME": "Herberstein, Wilhelm (1489\u20131560), Oberststallmeister",
        "DATEOFBIRTH": "1489",
        "DATEOFDEATH": "1560 Mar 09",
        "PLACEOFBIRTH": "Wippach in der Krain",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10653",
        "NAME": "Herberstein, Leonhard (1440\u20131511)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1511 Jan 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10654",
        "NAME": "Herberstein, Friedrich (1455\u20131508)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1508",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10655",
        "NAME": "Herberstein, Georg (1412\u20131458)",
        "DATEOFBIRTH": "1412",
        "DATEOFDEATH": "1458",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10656",
        "NAME": "Herberstein, Andreas (1413\u20131442)",
        "DATEOFBIRTH": "1413",
        "DATEOFDEATH": "1442",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10657",
        "NAME": "Herberstein, Otto (1378\u20131425)",
        "DATEOFBIRTH": "1378",
        "DATEOFDEATH": "1425",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10658",
        "NAME": "Herberstein, Andreas (1560\u20131605)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "T\u00fc\u00dfling",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "10659",
        "NAME": "Herberstein, Johann Bernhard (1630\u20131685), K\u00e4mmerer",
        "DATEOFBIRTH": "1630",
        "DATEOFDEATH": "1685",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Glogau in Niederschlesien"
    },
    {
        "ID": "10660",
        "NAME": "Herberstein, Georg (1469\u20131528), Hofkriegsrat",
        "DATEOFBIRTH": "1469",
        "DATEOFDEATH": "1528 Mar 04",
        "PLACEOFBIRTH": "Wippach in der Krain",
        "PLACEOFDEATH": "Bruck an der Leitha:Augustinerkirche"
    },
    {
        "ID": "10661",
        "NAME": "Herberstein, Siegmund (1518\u20131578), Hofkriegsrat",
        "DATEOFBIRTH": "1518 Jul 18",
        "DATEOFDEATH": "1578 Feb 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10662",
        "NAME": "Herberstein, Johann Friedrich (1551\u20131615), K\u00e4mmerer",
        "DATEOFBIRTH": "1551",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10663",
        "NAME": "Herberstein, Gundaker (1594\u20131655), K\u00e4mmerer",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1655 Aug 01",
        "PLACEOFBIRTH": "Gutenhag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10664",
        "NAME": "Herberstein, Georg Gundaker (1635\u20131667), K\u00e4mmerer",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1667",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10665",
        "NAME": "Herberstein, Georg Christoph (1556\u20131613)",
        "DATEOFBIRTH": "1556 Jan 14",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wildhaus an der Drau"
    },
    {
        "ID": "10666",
        "NAME": "Herberstein, Jakob Franz (1554\u20131629)",
        "DATEOFBIRTH": "1554 Nov 06",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10667",
        "NAME": "Herberstein, Wolfgang Jakob (1585\u20131627), Mundschenk",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10668",
        "NAME": "Herberstein, Georg Jakob (1620\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10669",
        "NAME": "Herberstein, Veit Siegmund (1590\u20131637)",
        "DATEOFBIRTH": "1590",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "Wildhaus an der Drau",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10670",
        "NAME": "Herberstein, Ernst Friedrich (1618\u20131666), Landeshauptmann von G\u00f6rz",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1666 Mai 04",
        "PLACEOFBIRTH": "Wildhaus an der Drau",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10671",
        "NAME": "Herberstein, Johann Ludwig (1625\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1625",
        "DATEOFDEATH": "1654",
        "PLACEOFBIRTH": "Wildhaus an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10672",
        "NAME": "Herberstein, Georg Siegmund (1594\u20131663), Obersthofmeister",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10673",
        "NAME": "Herberstein, Siegmund Friedrich (1549\u20131620), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1549 Okt 07",
        "DATEOFDEATH": "1620 Mai 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10674",
        "NAME": "Herberstein, Siegmund (1486\u20131566)",
        "DATEOFBIRTH": "1486 Aug 23",
        "DATEOFDEATH": "1566 Mar 28",
        "PLACEOFBIRTH": "Wippach in der Krain",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "10675",
        "NAME": "Herberstein, Johann Maximilian (1602\u20131679), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1602",
        "DATEOFDEATH": "1679 Mai 19",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": "Graz:Karmeliterkloster"
    },
    {
        "ID": "10676",
        "NAME": "Herberstein, Johann Maximilian (1631\u20131680), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1631 Okt 26",
        "DATEOFDEATH": "1680 Feb 02",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": "M\u00fchlhausen an der Raab"
    },
    {
        "ID": "10677",
        "NAME": "Herberstein, Georg (1501\u20131560), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1501 Jul 18",
        "DATEOFDEATH": "1560 Sep 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10678",
        "NAME": "Herberstein, Wolfgang Andreas (1614\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10679",
        "NAME": "Hofkirchen, Karl Ludwig (1625\u20131692), Geheimer Rat",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1692 Mar 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "10680",
        "NAME": "Montfort, Johann (1557\u20131619), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1619 Feb 21",
        "PLACEOFBIRTH": "Tettnang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10681",
        "NAME": "Marschall von Pappenheim, Wolfgang Philipp (1618\u20131671), K\u00e4mmerer",
        "DATEOFBIRTH": "1618 Aug 27",
        "DATEOFDEATH": "1671 Mai 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10682",
        "NAME": "Talmberg, Friedrich (1580\u20131643), Landk\u00e4mmerer in B\u00f6hmen",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1643 Okt 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10683",
        "NAME": "Lobkowicz, Wenzel (1520\u20131574)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1574",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10684",
        "NAME": "Lobkowicz, Johann Wenzel (1561\u20131608)",
        "DATEOFBIRTH": "1561 Feb 28",
        "DATEOFDEATH": "1608 Dez 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10685",
        "NAME": "Lobkowicz, Maria Benigna (1585\u20131634)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1634 Dez 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10686",
        "NAME": "Lobkowicz, Anna (1560\u20131604)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1604 Jan 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "10687",
        "NAME": "Haubitz, Tobias (1590\u20131648), Reichshofratsvizepr\u00e4sident",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1648 Nov 15",
        "PLACEOFBIRTH": "Leipnitz in Mei\u00dfen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10688",
        "NAME": "Marschall von Pappenheim, Alexander (1530\u20131612), Reichshofrat",
        "DATEOFBIRTH": "1530 Mai 17",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "Rothenstein im Allg\u00e4u",
        "PLACEOFDEATH": "Gr\u00f6nenbach im Allg\u00e4u"
    },
    {
        "ID": "10689",
        "NAME": "Lobkowicz, Niklas (1528\u20131598)",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1598 Okt 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10690",
        "NAME": "Nassau, Johann Franz (1627\u20131699), K\u00e4mmerer",
        "DATEOFBIRTH": "1627 Jul 28",
        "DATEOFDEATH": "1699 Dez 17",
        "PLACEOFBIRTH": "Nozeroy",
        "PLACEOFDEATH": "Roermond"
    },
    {
        "ID": "10691",
        "NAME": "Paradis de Lasaga, Bartlome (1625\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1654",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10692",
        "NAME": "Paradis de Lasaga, Heinrich (1590\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1638 Jun 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10693",
        "NAME": "Haugwitz, Wenzel Heinrich (1609\u20131693), Truchsess",
        "DATEOFBIRTH": "1609",
        "DATEOFDEATH": "1693",
        "PLACEOFBIRTH": "Piszkowice",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10694",
        "NAME": "Cavriani, Franz (1637\u20131696), K\u00e4mmerer",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1696 Apr 18",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10695",
        "NAME": "Herberstein, Andreas (1514\u20131543)",
        "DATEOFBIRTH": "1514 Apr 03",
        "DATEOFDEATH": "1543 Jan 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10696",
        "NAME": "Herberstein, Felizian (1540\u20131590), Hofkriegsrat",
        "DATEOFBIRTH": "1540",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10697",
        "NAME": "Leipa, Berthold (1580\u20131643), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Skalitz"
    },
    {
        "ID": "10699",
        "NAME": "J\u00f6rger von Tollet, Johann Quintin (1624\u20131705), Geheimer Rat",
        "DATEOFBIRTH": "1624",
        "DATEOFDEATH": "1705 Feb 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10700",
        "NAME": "Wittelsbach, Karl\u00a0VII. (1697\u20131745), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1697 Aug 06",
        "DATEOFDEATH": "1745 Jan 20",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "M\u00fcnchen:Theatinerkirche"
    },
    {
        "ID": "10701",
        "NAME": "Truchsess von Waldburg, Johann (1362\u20131424)",
        "DATEOFBIRTH": "1362",
        "DATEOFDEATH": "1424 Mar 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Waldburg in Oberschwaben"
    },
    {
        "ID": "10702",
        "NAME": "Truchsess von Waldburg, Jakob (1390\u20131460)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1460 Mai 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10703",
        "NAME": "Truchsess von Waldburg, Johann (1438\u20131507)",
        "DATEOFBIRTH": "1438",
        "DATEOFDEATH": "1507 Dez 28",
        "PLACEOFBIRTH": "Scheer an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10704",
        "NAME": "Truchsess von Waldburg, Wilhelm (1469\u20131557), Statthalter von W\u00fcrttemberg",
        "DATEOFBIRTH": "1469",
        "DATEOFDEATH": "1557 Mar 17",
        "PLACEOFBIRTH": "Scheer an der Donau",
        "PLACEOFDEATH": "Scheer an der Donau"
    },
    {
        "ID": "10705",
        "NAME": "Truchsess von Waldburg, Wilhelm (1518\u20131566), K\u00e4mmerer",
        "DATEOFBIRTH": "1518 Mar 06",
        "DATEOFDEATH": "1566 Sep 03",
        "PLACEOFBIRTH": "Scheer an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10706",
        "NAME": "Truchsess von Waldburg, Christoph (1551\u20131612)",
        "DATEOFBIRTH": "1551 Aug 24",
        "DATEOFDEATH": "1612 Feb 28",
        "PLACEOFBIRTH": "Scheer an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10707",
        "NAME": "Truchsess von Waldburg, Wilhelm (1580\u20131652), K\u00e4mmerer",
        "DATEOFBIRTH": "1580 Jan 26",
        "DATEOFDEATH": "1652 Mai 07",
        "PLACEOFBIRTH": "Scheer an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10708",
        "NAME": "Truchsess von Waldburg, Georg (1400\u20131467)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1467 Mar 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Zeil in Schwaben"
    },
    {
        "ID": "10709",
        "NAME": "Truchsess von Waldburg, Georg (1430\u20131482)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1482",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Waldsee in Schwaben"
    },
    {
        "ID": "10710",
        "NAME": "Truchsess von Waldburg, Johann (1460\u20131511)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1511 Okt 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10711",
        "NAME": "Truchsess von Waldburg, Georg (1488\u20131531)",
        "DATEOFBIRTH": "1488 Jan 25",
        "DATEOFDEATH": "1531 Mai 29",
        "PLACEOFBIRTH": "Waldsee in Schwaben",
        "PLACEOFDEATH": "Waldsee in Schwaben"
    },
    {
        "ID": "10712",
        "NAME": "Truchsess von Waldburg, Georg (1523\u20131569)",
        "DATEOFBIRTH": "1523",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "Waldsee in Schwaben",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10713",
        "NAME": "Truchsess von Waldburg, Jakob (1546\u20131589)",
        "DATEOFBIRTH": "1546 Dez 06",
        "DATEOFDEATH": "1589 Mai 22",
        "PLACEOFBIRTH": "Waldsee in Schwaben",
        "PLACEOFDEATH": "Me\u00dfkirch an der Ablach"
    },
    {
        "ID": "10714",
        "NAME": "Truchsess von Waldburg, Frowin (1569\u20131614)",
        "DATEOFBIRTH": "1569 Aug 19",
        "DATEOFDEATH": "1614 Mai 05",
        "PLACEOFBIRTH": "Waldsee in Schwaben",
        "PLACEOFDEATH": "Zeil in Schwaben"
    },
    {
        "ID": "10715",
        "NAME": "Truchsess von Waldburg, Sebastian Wunibald (1636\u20131700), Reichshofratsvizepr\u00e4sident",
        "DATEOFBIRTH": "1636 Jan 31",
        "DATEOFDEATH": "1700 Jun 15",
        "PLACEOFBIRTH": "Zeil in Schwaben",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10716",
        "NAME": "Truchsess von Waldburg, Paris Jakob (1624\u20131684)",
        "DATEOFBIRTH": "1624 Jan 18",
        "DATEOFDEATH": "1684 Mar 24",
        "PLACEOFBIRTH": "Salzburg",
        "PLACEOFDEATH": "Zeil in Schwaben"
    },
    {
        "ID": "10717",
        "NAME": "Truchsess von Waldburg, Heinrich (1568\u20131637)",
        "DATEOFBIRTH": "1568 Mar 08",
        "DATEOFDEATH": "1637 Aug 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10718",
        "NAME": "Truchsess von Waldburg, Maximilian Willibald (1604\u20131667), K\u00e4mmerer",
        "DATEOFBIRTH": "1604 Sep 18",
        "DATEOFDEATH": "1667 Jan 30",
        "PLACEOFBIRTH": "Wolfegg in Schwaben",
        "PLACEOFDEATH": "Amberg in der Oberpfalz"
    },
    {
        "ID": "10719",
        "NAME": "Truchsess von Waldburg, Friedrich (1592\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1592 Jan 15",
        "DATEOFDEATH": "1636 Nov 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kempten im Allg\u00e4u"
    },
    {
        "ID": "10720",
        "NAME": "Truchsess von Waldburg, Johann Ernst (1630\u20131687), K\u00e4mmerer",
        "DATEOFBIRTH": "1630",
        "DATEOFDEATH": "1687 Feb 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "D\u00fcrmentingen"
    },
    {
        "ID": "10721",
        "NAME": "Wessel\u00e9nyi, Stephan (1583\u20131627)",
        "DATEOFBIRTH": "1583 Sep 03",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Trentschin im Waagtal",
        "PLACEOFDEATH": "Krakau"
    },
    {
        "ID": "10722",
        "NAME": "Wessel\u00e9nyi, Franz (1608\u20131667), Palatin von Ungarn",
        "DATEOFBIRTH": "1608 Mai 29",
        "DATEOFDEATH": "1667 Mar 28",
        "PLACEOFBIRTH": "Trentschin im Waagtal",
        "PLACEOFDEATH": "Liptsch an der Gran"
    },
    {
        "ID": "10723",
        "NAME": "Wessel\u00e9nyi, Adam (1630\u20131656), K\u00e4mmerer",
        "DATEOFBIRTH": "1630",
        "DATEOFDEATH": "1656 Mar 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Fileck"
    },
    {
        "ID": "10724",
        "NAME": "Hildebrandt, Konrad (1580\u20131644), Reichshofrat",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "Ehingen an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10725",
        "NAME": "Frangipane di Veglia, Georg (1620\u20131661), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1661 Feb 13",
        "PLACEOFBIRTH": "Wasseil",
        "PLACEOFDEATH": "Karlstadt in Kroatien"
    },
    {
        "ID": "10726",
        "NAME": "Kolowrat, Anna Ludmila (1601\u20131627)",
        "DATEOFBIRTH": "1601 Apr 17",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10727",
        "NAME": "Leipa, Vinzenz (1620\u20131683), Mundschenk",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1683",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Bobersdorf"
    },
    {
        "ID": "10728",
        "NAME": "Puchheim, Johann Christoph (1578\u20131619), Hofkriegsrat",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1619 Sep 17",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10729",
        "NAME": "Wangnereck von Gersdorf, Georg Christoph (1635\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Oetting am Inn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10730",
        "NAME": "Kolowrat, Albrecht (1350\u20131413)",
        "DATEOFBIRTH": "1350~",
        "DATEOFDEATH": "1413 Jul 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Liebstein in B\u00f6hmen"
    },
    {
        "ID": "10731",
        "NAME": "Kolowrat, Johann (1390\u20131422)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1422",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10732",
        "NAME": "Kolowrat, Albrecht (1420\u20131470)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1470 Dez 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rothschlo\u00df"
    },
    {
        "ID": "10733",
        "NAME": "Kolowrat, Heinrich (1459\u20131530)",
        "DATEOFBIRTH": "1459",
        "DATEOFDEATH": "1530",
        "PLACEOFBIRTH": "Rothschlo\u00df",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10734",
        "NAME": "Kolowrat, Albrecht (1490\u20131542)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1542",
        "PLACEOFBIRTH": "Rothschlo\u00df",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10735",
        "NAME": "Kolowrat, Christoph Heinrich (1519\u20131596)",
        "DATEOFBIRTH": "1519",
        "DATEOFDEATH": "1596 Jun 02",
        "PLACEOFBIRTH": "Rothschlo\u00df",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10736",
        "NAME": "Kolowrat, Albrecht Christoph (1558\u20131592)",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "Rothschlo\u00df",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10737",
        "NAME": "Kolowrat, Bernhard Alexander (1580\u20131613)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "Rothschlo\u00df",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10738",
        "NAME": "Kolowrat, Friedrich (1380\u20131433)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1433 Jul 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Liebstein in B\u00f6hmen"
    },
    {
        "ID": "10739",
        "NAME": "Kolowrat, Benedikt (1420\u20131495)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1495",
        "PLACEOFBIRTH": "Liebstein in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10740",
        "NAME": "Kolowrat, Johann (1450\u20131486)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1486",
        "PLACEOFBIRTH": "Liebstein in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10741",
        "NAME": "Kolowrat, Jaroslaus (1480\u20131530)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1530",
        "PLACEOFBIRTH": "Liebstein in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10742",
        "NAME": "Kolowrat, Jaroslaus (1528\u20131595), Geheimer Rat",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1595 Jun 12",
        "PLACEOFBIRTH": "Liebstein in B\u00f6hmen",
        "PLACEOFDEATH": "Petersburg in B\u00f6hmen"
    },
    {
        "ID": "10743",
        "NAME": "Kolowrat, Albin (1560\u20131604)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1604",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10744",
        "NAME": "Kolowrat, Christoph Jaroslaus (1600\u20131659)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1659 Mar 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10745",
        "NAME": "Kolowrat, Albrecht Heinrich (1635\u20131704), Mundschenk",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1704 Aug 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10746",
        "NAME": "Kolowrat, Burkhard (1475\u20131532)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1532",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10747",
        "NAME": "Kolowrat, Johann (1510\u20131555)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1555",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10748",
        "NAME": "Kolowrat, Wolfgang (1550\u20131609)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Schl\u00fcsselburg in B\u00f6hmen"
    },
    {
        "ID": "10749",
        "NAME": "Kolowrat, Sidonius (1585\u20131658), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1658 Feb 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Altbunzlau"
    },
    {
        "ID": "10750",
        "NAME": "Schutzbar genannt Milchling, Heinrich Hermann (1534\u20131591), Reichshofrat",
        "DATEOFBIRTH": "1534 Jan 28",
        "DATEOFDEATH": "1591 Jun 30",
        "PLACEOFBIRTH": "Treis an der Lumda",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "10751",
        "NAME": "Kolowrat, Johann Wenzel (1628\u20131690), K\u00e4mmerer",
        "DATEOFBIRTH": "1628",
        "DATEOFDEATH": "1690 Mai 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10752",
        "NAME": "Kolowrat, Franz Sidonius (1659\u20131716)",
        "DATEOFBIRTH": "1659 Jul 13",
        "DATEOFDEATH": "1716 Feb 02",
        "PLACEOFBIRTH": "Ko\u0161\u00e1tky",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10753",
        "NAME": "Kolowrat, Albrecht (1320\u20131391), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "1391 Jul 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10754",
        "NAME": "Kolowrat, Burkhard (1355\u20131410)",
        "DATEOFBIRTH": "1355~",
        "DATEOFDEATH": "1410",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Weseritz"
    },
    {
        "ID": "10755",
        "NAME": "Kolowrat, Burkhard (1390\u20131438)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1438",
        "PLACEOFBIRTH": "Weseritz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10756",
        "NAME": "Kolowrat, Albrecht (1430\u20131489)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1489",
        "PLACEOFBIRTH": "Weseritz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10757",
        "NAME": "Kolowrat, Johann (1460\u20131532)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1532",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10758",
        "NAME": "Kolowrat, Heinrich (1500\u20131548)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1548 Okt 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Opo\u010dno"
    },
    {
        "ID": "10759",
        "NAME": "Kolowrat, Joachim (1530\u20131600), Burggraf von Karlstein",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1600 Jan 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10760",
        "NAME": "Kolowrat, Johann (1565\u20131613), Mundschenk",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10761",
        "NAME": "Kolowrat, Sbigneus Leopold (1594\u20131630)",
        "DATEOFBIRTH": "1594 Jan 28",
        "DATEOFDEATH": "1630 Sep 11",
        "PLACEOFBIRTH": "Ko\u0161\u00e1tky",
        "PLACEOFDEATH": "Reichstadt in B\u00f6hmen"
    },
    {
        "ID": "10762",
        "NAME": "Kolowrat, Joachim (1590\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1631",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10763",
        "NAME": "Kolowrat, Karl (1570\u20131606)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10764",
        "NAME": "Kolowrat, Wilhelm (1600\u20131641)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1641",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10765",
        "NAME": "Kolowrat, Julius (1605\u20131656)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1656 Sep 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Liboritz:Pfarrkirche"
    },
    {
        "ID": "10766",
        "NAME": "Kolowrat, Benedikt (1568\u20131617), Truchsess",
        "DATEOFBIRTH": "1568 Jan 05",
        "DATEOFDEATH": "1617 Apr 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10767",
        "NAME": "Kolowrat, Jaroslaus (1595\u20131658), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10768",
        "NAME": "Kolowrat, Ferdinand (1600\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1648 Aug 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10769",
        "NAME": "Kolowrat, Julius Albrecht (1633\u20131683)",
        "DATEOFBIRTH": "1633",
        "DATEOFDEATH": "1683 Jul",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10770",
        "NAME": "W\u00fcrben, Judith Rivka (1612\u20131690)",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1690 Mar 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10771",
        "NAME": "Taxis, Rudger (1440\u20131515)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1515",
        "PLACEOFBIRTH": "Cornello",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "10772",
        "NAME": "Taxis, David (1475\u20131538)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1538",
        "PLACEOFBIRTH": "Cornello",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10773",
        "NAME": "Taxis, Rudger (1530\u20131582)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1582",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bergamo"
    },
    {
        "ID": "10774",
        "NAME": "Taxis, Ferdinand (1580\u20131648)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1648",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "10775",
        "NAME": "Taxis, Johann Baptist (1470\u20131541)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1541 Okt 16",
        "PLACEOFBIRTH": "Cornello",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "10776",
        "NAME": "Taxis, Leonhard (1523\u20131612), K\u00e4mmerer",
        "DATEOFBIRTH": "1523",
        "DATEOFDEATH": "1612 Mai 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Br\u00fcssel:Sandkirche"
    },
    {
        "ID": "10777",
        "NAME": "Taxis, Lamoral (1557\u20131624), K\u00e4mmerer",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1624 Jul 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Br\u00fcssel:Sandkirche"
    },
    {
        "ID": "10778",
        "NAME": "Taxis, Leonhard (1594\u20131628), K\u00e4mmerer",
        "DATEOFBIRTH": "1594 Jul 05",
        "DATEOFDEATH": "1628 Mai 23",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10779",
        "NAME": "Taxis, Lamoral Klaudius (1621\u20131676), K\u00e4mmerer",
        "DATEOFBIRTH": "1621 Feb 14",
        "DATEOFDEATH": "1676 Sep 13",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Antwerpen"
    },
    {
        "ID": "10780",
        "NAME": "Taxis, Oktavian (1621\u20131691), Truchsess",
        "DATEOFBIRTH": "1621",
        "DATEOFDEATH": "1691",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10781",
        "NAME": "Taxis, Eugen Alexander (1652\u20131714)",
        "DATEOFBIRTH": "1652 Jan 11",
        "DATEOFDEATH": "1714 Feb 21",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Frankfurt am Main:Kaiserdom"
    },
    {
        "ID": "10782",
        "NAME": "Taxis, Anselm Franz (1681\u20131739)",
        "DATEOFBIRTH": "1681 Jan 30",
        "DATEOFDEATH": "1739 Nov 08",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Br\u00fcssel:Sandkirche"
    },
    {
        "ID": "10783",
        "NAME": "Breunner, Renata (1596\u20131634)",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10784",
        "NAME": "Forg\u00e1ch, Emmerich (1543\u20131599), Hofdiener",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10785",
        "NAME": "Radolt, Klement (1593\u20131670), Hofkammerrat",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1670 Dez 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10786",
        "NAME": "Radolt, Franz Galeas (1646\u20131714), Truchsess",
        "DATEOFBIRTH": "1646",
        "DATEOFDEATH": "1714 Dez 14",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10787",
        "NAME": "Schaffgotsch, Johann Ulrich (1595\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1595 Aug 28",
        "DATEOFDEATH": "1635 Jul 23",
        "PLACEOFBIRTH": "Greiffenstein in Schlesien",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "10788",
        "NAME": "Radolt, Wenzel Ludwig (1667\u20131716)",
        "DATEOFBIRTH": "1667 Dez 18",
        "DATEOFDEATH": "1716 Mar 10",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10789",
        "NAME": "Radolt, Wolfgang Franz (1634\u20131663), Hofkammerrat",
        "DATEOFBIRTH": "1634",
        "DATEOFDEATH": "1663 Feb 10",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10790",
        "NAME": "Immendorff, Bartlome (1580\u20131646), Reichshoffiskal",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1646 Mar 01",
        "PLACEOFBIRTH": "J\u00fclich",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10791",
        "NAME": "Sartorius von Schwanenfeld, Veit (1600\u20131668), Reichshoffiskal",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1668 Apr 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10792",
        "NAME": "Sartorius von Schwanenfeld, Franz Karl (1640\u20131684), Reichshoffiskal",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1684",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10793",
        "NAME": "Ulm, Johann Ludwig (1567\u20131627), Reichsvizekanzler",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1627 Jul 16",
        "PLACEOFBIRTH": "Wangen am Untersee",
        "PLACEOFDEATH": "Marbach am Neckar"
    },
    {
        "ID": "10794",
        "NAME": "Fenckh, Wolfgang (1580\u20131635), Reichsvizekanzler",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1635 Nov 30",
        "PLACEOFBIRTH": "Steinhof am Liesingbach",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10795",
        "NAME": "Fenckh, Johann Wolfgang (1620\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Steinhof am Liesingbach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10796",
        "NAME": "Pr\u00fccklmayr von Goldegg, Johann Matthias (1589\u20131656), Reichsvizekanzler",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1656 Aug 20",
        "PLACEOFBIRTH": "Sankt Bernhard im Waldviertel",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "10797",
        "NAME": "Ulm, Leodefried (1615\u20131673), K\u00e4mmerer",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1673",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Erbach an der Donau"
    },
    {
        "ID": "10798",
        "NAME": "Kaltschmidt von Eisenberg, Johann Baptist (1604\u20131662), Reichshofrat",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1662 Jul 26",
        "PLACEOFBIRTH": "Stra\u00dfburg im Elsass",
        "PLACEOFDEATH": "D\u0159evohostice"
    },
    {
        "ID": "10799",
        "NAME": "Messerati, Johann Franz (1630\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Carignano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10800",
        "NAME": "Habsburg, Ferdinand (1529\u20131595), Landesherr von Tirol",
        "DATEOFBIRTH": "1529 Jun 14",
        "DATEOFDEATH": "1595 Jan 24",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": "Innsbruck:Silberne Kapelle"
    },
    {
        "ID": "10801",
        "NAME": "L\u00f6wenstein, Ludwig (1530\u20131611), Reichshofratspr\u00e4sident",
        "DATEOFBIRTH": "1530 Feb 17",
        "DATEOFDEATH": "1611 Mar 13",
        "PLACEOFBIRTH": "Vaihingen an der Enz",
        "PLACEOFDEATH": "Wertheim am Main"
    },
    {
        "ID": "10802",
        "NAME": "L\u00f6wenstein, Johann Theoderich (1584\u20131644)",
        "DATEOFBIRTH": "1584 Dez 31",
        "DATEOFDEATH": "1644 Mar 06",
        "PLACEOFBIRTH": "Wertheim am Main",
        "PLACEOFDEATH": "Wertheim am Main"
    },
    {
        "ID": "10803",
        "NAME": "L\u00f6wenstein, Ferdinand Karl (1616\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1616 Mai 18",
        "DATEOFDEATH": "1672 Jan 26",
        "PLACEOFBIRTH": "Rochefort in den Ardennen",
        "PLACEOFDEATH": "Wertheim am Main"
    },
    {
        "ID": "10804",
        "NAME": "L\u00f6wenstein, Maximilian Karl (1656\u20131718), Statthalter von Bayern",
        "DATEOFBIRTH": "1656 Jul 15",
        "DATEOFDEATH": "1718 Dez 26",
        "PLACEOFBIRTH": "Rochefort in den Ardennen",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "10805",
        "NAME": "L\u00f6wenstein, Maximilian Karl (1681\u20131710), Reichshofrat",
        "DATEOFBIRTH": "1681 Nov 30",
        "DATEOFDEATH": "1710 Okt 27",
        "PLACEOFBIRTH": "Wertheim am Main",
        "PLACEOFDEATH": "Eferding"
    },
    {
        "ID": "10806",
        "NAME": "Truchsess von Wetzhausen, Erhard (1617\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1617 Apr 30",
        "DATEOFDEATH": "1664 Mar 28",
        "PLACEOFBIRTH": "K\u00f6nigsberg in Preu\u00dfen",
        "PLACEOFDEATH": "Lo\u00dfainen am Legienersee"
    },
    {
        "ID": "10807",
        "NAME": "Andelot, Johann Franz (1618\u20131687), Truchsess",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1687 Aug 04",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10808",
        "NAME": "K\u00f6nigsegg, Haug (1596\u20131666), Reichshofrat",
        "DATEOFBIRTH": "1596 Feb 26",
        "DATEOFDEATH": "1666 Sep 10",
        "PLACEOFBIRTH": "Rothenfels im Allg\u00e4u",
        "PLACEOFDEATH": "Immenstadt im Allg\u00e4u"
    },
    {
        "ID": "10809",
        "NAME": "K\u00f6nigsegg, Leopold Wilhelm (1630\u20131694), Geheimer Rat",
        "DATEOFBIRTH": "1630 Mai 25",
        "DATEOFDEATH": "1694 Feb 05",
        "PLACEOFBIRTH": "Rothenfels im Allg\u00e4u",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10810",
        "NAME": "Montfort, Georg (1553\u20131590), Reichshofrat",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "Tettnang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10811",
        "NAME": "Hornstein, Balthasar Ferdinand (1614\u20131685), K\u00e4mmerer",
        "DATEOFBIRTH": "1614 Okt 19",
        "DATEOFDEATH": "1685 Sep 15",
        "PLACEOFBIRTH": "Stoffeln im Hegau",
        "PLACEOFDEATH": "Weiterdingen"
    },
    {
        "ID": "10812",
        "NAME": "Harrach, Maximiliana (1608\u20131661)",
        "DATEOFBIRTH": "1608 Apr 01",
        "DATEOFDEATH": "1661",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10813",
        "NAME": "Eggenberg, Wolfgang (1585\u20131615)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "Ehrenhausen in der Steiermark",
        "PLACEOFDEATH": "Karlstadt in Kroatien"
    },
    {
        "ID": "10814",
        "NAME": "Cavriani, Friedrich (1518\u20131566)",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1566",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10815",
        "NAME": "Cavriani, Ludwig (1565\u20131625)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1625",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10816",
        "NAME": "Ursenbeck, Georg Bernhard (1551\u20131618), Obersthofmeister",
        "DATEOFBIRTH": "1551 Sep 12",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10817",
        "NAME": "Ursenbeck, Christoph David (1576\u20131636), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10818",
        "NAME": "Ursenbeck, Franz Bernhard (1616\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10819",
        "NAME": "Eggenberg, Elisabeth (1615\u20131644)",
        "DATEOFBIRTH": "1615",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "Ehrenhausen in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10820",
        "NAME": "Batthy\u00e1ny, Adam (1610\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1610 Feb 14",
        "DATEOFDEATH": "1659 Mar 15",
        "PLACEOFBIRTH": "G\u00fcssing",
        "PLACEOFDEATH": "Rechnitz"
    },
    {
        "ID": "10821",
        "NAME": "Bubna, Franz Adam (1644\u20131711), Landeshauptmann von Glatz",
        "DATEOFBIRTH": "1644",
        "DATEOFDEATH": "1711 Jan 02",
        "PLACEOFBIRTH": "Litice im Adlergebirge",
        "PLACEOFDEATH": "Senftenberg im Adlergebirge"
    },
    {
        "ID": "10822",
        "NAME": "Hohenzollern, Karl (1547\u20131606), Reichshofrat",
        "DATEOFBIRTH": "1547 Jan 22",
        "DATEOFDEATH": "1606 Apr 08",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": "Sigmaringen"
    },
    {
        "ID": "10823",
        "NAME": "Hohenzollern, Elisabeth (1592\u20131659)",
        "DATEOFBIRTH": "1592 Jan 10",
        "DATEOFDEATH": "1659 Okt 26",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": "Tiengen im Klettgau"
    },
    {
        "ID": "10824",
        "NAME": "Sulz, Karl Ludwig (1560\u20131616), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1560 Jul 09",
        "DATEOFDEATH": "1616 Sep 29",
        "PLACEOFBIRTH": "Tiengen im Klettgau",
        "PLACEOFDEATH": "Trino im Piemont"
    },
    {
        "ID": "10825",
        "NAME": "Sulz, Karl Ludwig Ernst (1595\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1595 Sep 13",
        "DATEOFDEATH": "1648 Apr 16",
        "PLACEOFBIRTH": "Vaduz",
        "PLACEOFDEATH": "Amberg in der Oberpfalz"
    },
    {
        "ID": "10826",
        "NAME": "Sulz, Johann Ludwig (1626\u20131687), K\u00e4mmerer",
        "DATEOFBIRTH": "1626 Okt 23",
        "DATEOFDEATH": "1687 Aug 21",
        "PLACEOFBIRTH": "Tiengen im Klettgau",
        "PLACEOFDEATH": "Jestetten im Klettgau"
    },
    {
        "ID": "10827",
        "NAME": "Sulz, Alwig (1586\u20131632), Landgraf im Klettgau",
        "DATEOFBIRTH": "1586 Dez 12",
        "DATEOFDEATH": "1632 Mar 09",
        "PLACEOFBIRTH": "Speyer",
        "PLACEOFDEATH": "Bamberg"
    },
    {
        "ID": "10828",
        "NAME": "Paravicino, Niklas (1620\u20131672), Mundschenk",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "Caspano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10829",
        "NAME": "Dietrichstein, Siegmund Helfried (1635\u20131698), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1635",
        "DATEOFDEATH": "1698 Apr 02",
        "PLACEOFBIRTH": "Hollenburg an der Drau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10830",
        "NAME": "G\u00f6tzen, Peter (1550\u20131608), Domherr in Halberstadt",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1608 Mai 16",
        "PLACEOFBIRTH": "Zehlendorf an der Oberhavel",
        "PLACEOFDEATH": "Halberstadt"
    },
    {
        "ID": "10831",
        "NAME": "G\u00f6tzen, Johann (1599\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1645 Mar 06",
        "PLACEOFBIRTH": "Zehlendorf an der Oberhavel",
        "PLACEOFDEATH": "Jankau in Mittelb\u00f6hmen"
    },
    {
        "ID": "10832",
        "NAME": "G\u00f6tzen, Johann Georg (1623\u20131679), Landeshauptmann von Glatz",
        "DATEOFBIRTH": "1623 Mar 14",
        "DATEOFDEATH": "1679 Aug 23",
        "PLACEOFBIRTH": "Zehlendorf an der Oberhavel",
        "PLACEOFDEATH": "Scharfeneck an der Steine"
    },
    {
        "ID": "10833",
        "NAME": "G\u00f6tzen, Siegmund Friedrich (1622\u20131662), K\u00e4mmerer",
        "DATEOFBIRTH": "1622",
        "DATEOFDEATH": "1662 Jan 13",
        "PLACEOFBIRTH": "Zehlendorf an der Oberhavel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10834",
        "NAME": "G\u00f6tzen, Peter (1595\u20131638)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1638 Nov 18",
        "PLACEOFBIRTH": "Zehlendorf an der Oberhavel",
        "PLACEOFDEATH": "Vechta im Emsland"
    },
    {
        "ID": "10835",
        "NAME": "Gonzaga, Elisabeth (1638\u20131702)",
        "DATEOFBIRTH": "1638",
        "DATEOFDEATH": "1702 Apr 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10836",
        "NAME": "Gonzaga, Ludwig (1599\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1660",
        "PLACEOFBIRTH": "San Martino dall\u2019Argine",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10837",
        "NAME": "Gonzaga, Ferdinand (1550\u20131605), F\u00fcrst von Bozzolo",
        "DATEOFBIRTH": "1550",
        "DATEOFDEATH": "1605 Feb 11",
        "PLACEOFBIRTH": "San Martino dall\u2019Argine",
        "PLACEOFDEATH": "San Martino dall\u2019Argine"
    },
    {
        "ID": "10838",
        "NAME": "Piccolomini, Aeneas (1586\u20131619)",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10839",
        "NAME": "Piccolomini, Franz (1615\u20131670), K\u00e4mmerer",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1670",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10840",
        "NAME": "Piccolomini, Silvius (1543\u20131609)",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Florenz"
    },
    {
        "ID": "10841",
        "NAME": "Piccolomini, Silvius (1610\u20131634)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1634 Sep 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "N\u00f6rdlingen im Ries"
    },
    {
        "ID": "10842",
        "NAME": "Piccolomini, Aeneas Silvius (1653\u20131673), K\u00e4mmerer",
        "DATEOFBIRTH": "1653",
        "DATEOFDEATH": "1673",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "10843",
        "NAME": "Piccolomini, Lorenz (1656\u20131712)",
        "DATEOFBIRTH": "1656 Nov 24",
        "DATEOFDEATH": "1712 Sep 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "N\u00e1chod"
    },
    {
        "ID": "10844",
        "NAME": "Piccolomini, Johann (1590\u20131656)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10845",
        "NAME": "Piccolomini, Joseph (1623\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1645 Mar 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Jankau in Mittelb\u00f6hmen"
    },
    {
        "ID": "10846",
        "NAME": "Piccolomini, Alfons (1620\u20131685)",
        "DATEOFBIRTH": "1620",
        "DATEOFDEATH": "1685",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10847",
        "NAME": "Piccolomini, Franz (1654\u20131686)",
        "DATEOFBIRTH": "1654",
        "DATEOFDEATH": "1686 Jul 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "10848",
        "NAME": "Piccolomini, Johann Norbert (1654\u20131689)",
        "DATEOFBIRTH": "1654",
        "DATEOFDEATH": "1689 Nov 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prizren in Metochien"
    },
    {
        "ID": "10849",
        "NAME": "P\u00e1zm\u00e1ny, Niklas (1622\u20131667), K\u00e4mmerer",
        "DATEOFBIRTH": "1622 Nov 19",
        "DATEOFDEATH": "1667 Mar 17",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": "L\u00f6sch in M\u00e4hren"
    },
    {
        "ID": "10850",
        "NAME": "Gonzaga, Ferdinand (1507\u20131557), Graf von Guastalla",
        "DATEOFBIRTH": "1507 Jan 28",
        "DATEOFDEATH": "1557 Nov 15",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "10851",
        "NAME": "Strasoldo, Richard (1572\u20131651), K\u00e4mmerer",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1651 Okt 24",
        "PLACEOFBIRTH": "Cervignano del Friuli",
        "PLACEOFDEATH": "Farra an der Isnitz"
    },
    {
        "ID": "10852",
        "NAME": "Strasoldo, Johann Matthias (1625\u20131686), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1686",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10853",
        "NAME": "Groppello dei Medici, Leonhard (1595\u20131642), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10854",
        "NAME": "Collalto, Anton (1630\u20131696), Geheimer Rat",
        "DATEOFBIRTH": "1630 Mai 07",
        "DATEOFDEATH": "1696 Jul 05",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10855",
        "NAME": "Barbiano, Johann (1638\u20131715), Truchsess",
        "DATEOFBIRTH": "1638 Mai 28",
        "DATEOFDEATH": "1715 Dez 20",
        "PLACEOFBIRTH": "Belgiojoso",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "10856",
        "NAME": "Barbiano, Anton (1693\u20131779)",
        "DATEOFBIRTH": "1693 Jan 11",
        "DATEOFDEATH": "1779 Okt 26",
        "PLACEOFBIRTH": "Belgiojoso",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "10857",
        "NAME": "Hercolani, Caesar (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10858",
        "NAME": "Hercolani, Vinzenz (1625\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10859",
        "NAME": "Hercolani, Caesar Alexander (1630\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10860",
        "NAME": "Hercolani, Alfons (1630\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bologna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10861",
        "NAME": "Hercolani, Philipp (1663\u20131722), Geheimer Rat",
        "DATEOFBIRTH": "1663 Apr 30",
        "DATEOFDEATH": "1722 Jan 24",
        "PLACEOFBIRTH": "Bologna",
        "PLACEOFDEATH": "Bologna"
    },
    {
        "ID": "10862",
        "NAME": "Hercolani, Astor (1669\u20131718)",
        "DATEOFBIRTH": "1669 Apr 17",
        "DATEOFDEATH": "1718 Mai 02",
        "PLACEOFBIRTH": "Bologna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10863",
        "NAME": "Lantieri, Friedrich (1570\u20131642), Landeshauptmann von G\u00f6rz",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10864",
        "NAME": "Lantieri, Franz (1600\u20131656), Landeshauptmann von G\u00f6rz",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10865",
        "NAME": "Lantieri, Anton (1631\u20131690), Mundschenk",
        "DATEOFBIRTH": "1631 Jun 22",
        "DATEOFDEATH": "1690 Jul 29",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10866",
        "NAME": "Gonzaga, Caesar (1533\u20131575), Graf von Guastalla",
        "DATEOFBIRTH": "1533 Sep 06",
        "DATEOFDEATH": "1575 Feb 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Guastalla"
    },
    {
        "ID": "10867",
        "NAME": "Kolowrat, Maximiliana (1637\u20131695)",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1695 Nov 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10868",
        "NAME": "Borromeo, Kamila (1536\u20131582)",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1582 Dez 06",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "10869",
        "NAME": "Borromeo, Giselbrecht (1511\u20131558)",
        "DATEOFBIRTH": "1511 Nov 11",
        "DATEOFDEATH": "1558 Jul 27",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "10870",
        "NAME": "Gonzaga, Ferdinand (1563\u20131630), Herzog von Guastalla",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "1630 Aug 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Guastalla"
    },
    {
        "ID": "10871",
        "NAME": "P\u00e1lffy, Peter (1512\u20131568)",
        "DATEOFBIRTH": "1512",
        "DATEOFDEATH": "1568",
        "PLACEOFBIRTH": "Erd\u0151d",
        "PLACEOFDEATH": "Belica"
    },
    {
        "ID": "10872",
        "NAME": "P\u00e1lffy, Stephan (1550\u20131597)",
        "DATEOFBIRTH": "1550 Apr 02",
        "DATEOFDEATH": "1597 Okt 09",
        "PLACEOFBIRTH": "Erd\u0151d",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "10873",
        "NAME": "Salm, Niklas (1459\u20131530), Statthalter von Nieder\u00f6sterreich",
        "DATEOFBIRTH": "1459",
        "DATEOFDEATH": "1530 Mai 04",
        "PLACEOFBIRTH": "Salm in den Ardennen",
        "PLACEOFDEATH": "Marchegg"
    },
    {
        "ID": "10874",
        "NAME": "Salm, Niklas (1503\u20131550), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1503",
        "DATEOFDEATH": "1550 Feb 25",
        "PLACEOFBIRTH": "Marchegg",
        "PLACEOFDEATH": "Erlau"
    },
    {
        "ID": "10875",
        "NAME": "Salm, Niklas (1528\u20131580), Hofkriegsrat",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1580 Nov 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kanizsa"
    },
    {
        "ID": "10876",
        "NAME": "Salm, Julius (1531\u20131595), Reichshofrat",
        "DATEOFBIRTH": "1531 Nov 11",
        "DATEOFDEATH": "1595 Jul 02",
        "PLACEOFBIRTH": "Neuburg am Inn",
        "PLACEOFDEATH": "G\u00f6ding an der March"
    },
    {
        "ID": "10877",
        "NAME": "Salm, Weikhard (1575\u20131617)",
        "DATEOFBIRTH": "1575 Sep 16",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "Neuburg am Inn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10878",
        "NAME": "Salm, Maximiliana (1608\u20131663)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1663 Dez 08",
        "PLACEOFBIRTH": "Neuburg am Inn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10879",
        "NAME": "Liechtenstein von Kastelkorn, Philipp Rudolf (1590\u20131639), Landeshauptmann von Glatz",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Leifers",
        "PLACEOFDEATH": "Glatz"
    },
    {
        "ID": "10880",
        "NAME": "Vaud\u00e9mont, Karl (1643\u20131690), Statthalter von Vorder\u00f6sterreich",
        "DATEOFBIRTH": "1643 Apr 03",
        "DATEOFDEATH": "1690 Apr 18",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wels"
    },
    {
        "ID": "10881",
        "NAME": "Magnis, Konstantin (1539\u20131606), Geheimer Rat",
        "DATEOFBIRTH": "1539",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "Como",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10882",
        "NAME": "Magnis, Franz (1598\u20131652), Hofkriegsrat",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1652 Dez 06",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10883",
        "NAME": "Liechtenstein von Kastelkorn, Paul (1460\u20131513), K\u00e4mmerer",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1513 Jun 04",
        "PLACEOFBIRTH": "Leifers",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "10884",
        "NAME": "Liechtenstein von Kastelkorn, Christoph (1490\u20131547)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1547",
        "PLACEOFBIRTH": "Leifers",
        "PLACEOFDEATH": "Herrenw\u00f6rth im Chiemsee"
    },
    {
        "ID": "10885",
        "NAME": "Liechtenstein von Kastelkorn, Wilhelm (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Leifers",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10886",
        "NAME": "Pompei, Thomas (1611\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1654 Okt 05",
        "PLACEOFBIRTH": "Venedig",
        "PLACEOFDEATH": "Samitz"
    },
    {
        "ID": "10887",
        "NAME": "Magnis, Valerian (1586\u20131661)",
        "DATEOFBIRTH": "1586 Okt 15",
        "DATEOFDEATH": "1661 Jul 29",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "10888",
        "NAME": "Montecuccoli, Reimund (1609\u20131680), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1609 Feb 21",
        "DATEOFDEATH": "1680 Okt 16",
        "PLACEOFBIRTH": "Pavullo nel Frignano",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "10889",
        "NAME": "Gonzaga, Ferdinand (1614\u20131675), F\u00fcrst von Castiglione",
        "DATEOFBIRTH": "1614 Aug 07",
        "DATEOFDEATH": "1675 Apr 23",
        "PLACEOFBIRTH": "Castiglione delle Stiviere",
        "PLACEOFDEATH": "Castiglione delle Stiviere"
    },
    {
        "ID": "10890",
        "NAME": "Habsburg, Eleonora (1653\u20131697), K\u00f6nigin von Polen",
        "DATEOFBIRTH": "1653 Mai 21",
        "DATEOFDEATH": "1697 Dez 17",
        "PLACEOFBIRTH": "Regensburg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10891",
        "NAME": "Bubna, Anton Ignaz (1679\u20131725), K\u00e4mmerer",
        "DATEOFBIRTH": "1679",
        "DATEOFDEATH": "1725 Mar 08",
        "PLACEOFBIRTH": "Litice im Adlergebirge",
        "PLACEOFDEATH": "Senftenberg im Adlergebirge"
    },
    {
        "ID": "10892",
        "NAME": "Montecuccoli, Alfons (1546\u20131607), Mundschenk",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1607 Aug 11",
        "PLACEOFBIRTH": "Montespecchio di Montese",
        "PLACEOFDEATH": "Heraklion"
    },
    {
        "ID": "10893",
        "NAME": "Montecuccoli, Ernst (1582\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1633 Jul 18",
        "PLACEOFBIRTH": "Montespecchio di Montese",
        "PLACEOFDEATH": "Colmar"
    },
    {
        "ID": "10894",
        "NAME": "Montecuccoli, Hieronym (1583\u20131643), Obersthofmeister",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Montespecchio di Montese",
        "PLACEOFDEATH": "Hohenegg im Dunkelsteinerwald"
    },
    {
        "ID": "10895",
        "NAME": "Avil\u00e9s, Johann (1602\u20131675), Hofdiener",
        "DATEOFBIRTH": "1602",
        "DATEOFDEATH": "1675 Mar 20",
        "PLACEOFBIRTH": "Villanueva de los Infantes",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "10896",
        "NAME": "Dietrichstein, Anna Theresia (1633\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1633",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hollenburg an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10897",
        "NAME": "Ursenbeck, Anna Franziska (1638\u20131708)",
        "DATEOFBIRTH": "1638 Okt 07",
        "DATEOFDEATH": "1708 Jan 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10898",
        "NAME": "Capliers, Kaspar Sidonius (1611\u20131686), Geheimer Rat",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1686 Okt 06",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10899",
        "NAME": "Conti, Innozenz (1610\u20131661), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1661 Feb 12",
        "PLACEOFBIRTH": "Poli",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "10900",
        "NAME": "Habsburg, Maximilian (1558\u20131618), Hochmeister des Deutschen Ordens",
        "DATEOFBIRTH": "1558 Okt 12",
        "DATEOFDEATH": "1618 Nov 02",
        "PLACEOFBIRTH": "Neustadt im Steinfeld",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10901",
        "NAME": "Althan, Michael Johann (1607\u20131649), Oberstj\u00e4germeister",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1649 Feb 19",
        "PLACEOFBIRTH": "Murstetten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10902",
        "NAME": "Liechtenstein von Kastelkorn, Johann Jakob (1560\u20131604)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1604",
        "PLACEOFBIRTH": "Leifers",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10903",
        "NAME": "Zastrizl, Wenzel (1585\u20131632), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "Morkovice",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10904",
        "NAME": "Testa, Johann Maria (1625\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "Siena",
        "PLACEOFDEATH": "Calamandrana"
    },
    {
        "ID": "10905",
        "NAME": "Thurn, Jobst Joseph (1578\u20131617)",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10906",
        "NAME": "Collalto, Oktavian (1636\u20131716), Truchsess",
        "DATEOFBIRTH": "1636 Jan 06",
        "DATEOFDEATH": "1716",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10907",
        "NAME": "Trczka von Leipa, Maria Elisabeth (1631\u20131702)",
        "DATEOFBIRTH": "1631 Jan 22",
        "DATEOFDEATH": "1702 Okt 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10908",
        "NAME": "Gebhard, Jobst (1590\u20131656), Reichshofrat",
        "DATEOFBIRTH": "1590 Jan 11",
        "DATEOFDEATH": "1656 Nov 08",
        "PLACEOFBIRTH": "Kamenz in der Lausitz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10909",
        "NAME": "Meggau, Anna (1612\u20131698), Obersthofmeisterin",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1698 Mai 03",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "10910",
        "NAME": "Saurau, Wolfgang Rudolf (1618\u20131664), Geheimer Rat",
        "DATEOFBIRTH": "1618 Nov 20",
        "DATEOFDEATH": "1664 Apr 24",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10911",
        "NAME": "Haugwitz, Theoderich (1584\u20131643)",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Piszkowice",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10912",
        "NAME": "Haugwitz, Georg Heinrich (1611\u20131637)",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10913",
        "NAME": "Haugwitz, Wilhelm (1613\u20131637)",
        "DATEOFBIRTH": "1613",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wittenberg in Sachsen"
    },
    {
        "ID": "10914",
        "NAME": "Haugwitz, Theoderich (1537\u20131592)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10915",
        "NAME": "Liechtenstein von Kastelkorn, Christoph Paul (1585\u20131648), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1648 Aug 30",
        "PLACEOFBIRTH": "Leifers",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "10916",
        "NAME": "Rabatta, Joseph (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10917",
        "NAME": "Rabatta, Bernhard (1552\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10918",
        "NAME": "Gonzaga, Ferdinand (1648\u20131723), F\u00fcrst von Castiglione",
        "DATEOFBIRTH": "1648 Aug 28",
        "DATEOFDEATH": "1723 Feb 11",
        "PLACEOFBIRTH": "Solferino",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "10919",
        "NAME": "Piccolomini, Norbert Wenzel (1700\u20131746), K\u00e4mmerer",
        "DATEOFBIRTH": "1700 Apr 28",
        "DATEOFDEATH": "1746",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10920",
        "NAME": "Spinola, Ambros (1569\u20131630)",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1630 Sep 25",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": "Castelnuovo Scrivia"
    },
    {
        "ID": "10921",
        "NAME": "Spinola, Albrecht Vedast (1610\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1610",
        "DATEOFDEATH": "1645 Mar 06",
        "PLACEOFBIRTH": "Bruay in Artesien",
        "PLACEOFDEATH": "Jankau in Mittelb\u00f6hmen"
    },
    {
        "ID": "10922",
        "NAME": "Spinola, Philipp Karl (1612\u20131670)",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1670 Jan 14",
        "PLACEOFBIRTH": "Bruay in Artesien",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "10923",
        "NAME": "Serbelloni, Gabriel (1509\u20131580), Gro\u00dfprior des Malteserordens in Ungarn",
        "DATEOFBIRTH": "1509",
        "DATEOFDEATH": "1580 Jan 27",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Gorgonzola"
    },
    {
        "ID": "10924",
        "NAME": "Serbelloni, Johann Baptist (1540\u20131610)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1610",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Castiglione Lodigiano"
    },
    {
        "ID": "10925",
        "NAME": "Serbelloni, Johann Maria (1590\u20131638), Hofkriegsrat",
        "DATEOFBIRTH": "1590 Dez 07",
        "DATEOFDEATH": "1638 Feb 21",
        "PLACEOFBIRTH": "Castiglione Lodigiano",
        "PLACEOFDEATH": "Perpignan"
    },
    {
        "ID": "10926",
        "NAME": "Serbelloni, Gabriel (1635\u20131712), Truchsess",
        "DATEOFBIRTH": "1635",
        "DATEOFDEATH": "1712",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10927",
        "NAME": "Gyulaffy, Christoph (1585\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Csob\u00e1nc",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10928",
        "NAME": "Gyulaffy, Lassel (1615\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Csob\u00e1nc",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10929",
        "NAME": "Gyulaffy, Stephan (1620\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Csob\u00e1nc",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10930",
        "NAME": "Frangipane di Veglia, Franz (1643\u20131671), K\u00e4mmerer",
        "DATEOFBIRTH": "1643 Mar 04",
        "DATEOFDEATH": "1671 Apr 30",
        "PLACEOFBIRTH": "Wasseil",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "10931",
        "NAME": "Barbiano, Ludwig (1530\u20131590)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1590 Jun 12",
        "PLACEOFBIRTH": "Belgiojoso",
        "PLACEOFDEATH": "Belgiojoso"
    },
    {
        "ID": "10932",
        "NAME": "Barbiano, Johann Jakob (1565\u20131626)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1626 Okt 18",
        "PLACEOFBIRTH": "Belgiojoso",
        "PLACEOFDEATH": "L\u00fcttich"
    },
    {
        "ID": "10933",
        "NAME": "Barbiano, Alberich (1560\u20131621)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "Belgiojoso",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10934",
        "NAME": "Barbiano, Karl (1608\u20131656)",
        "DATEOFBIRTH": "1608 Feb 01",
        "DATEOFDEATH": "1656 Aug 22",
        "PLACEOFBIRTH": "Belgiojoso",
        "PLACEOFDEATH": "Belgiojoso"
    },
    {
        "ID": "10935",
        "NAME": "Albani, Johann Dominik (1619\u20131648), Truchsess",
        "DATEOFBIRTH": "1619",
        "DATEOFDEATH": "1648 Apr 16",
        "PLACEOFBIRTH": "Urgnano",
        "PLACEOFDEATH": "Sibenning"
    },
    {
        "ID": "10936",
        "NAME": "Pallavicino, Felix (1616\u20131654), Reichshofrat",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1654 Aug 18",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10937",
        "NAME": "Reifferscheid, Ernst Salentin (1621\u20131684), K\u00e4mmerer",
        "DATEOFBIRTH": "1621 Apr 04",
        "DATEOFDEATH": "1684 Jun 11",
        "PLACEOFBIRTH": "Reifferscheid in der Eifel",
        "PLACEOFDEATH": "Dyck am Niederrhein"
    },
    {
        "ID": "10938",
        "NAME": "Althan, Michael Ferdinand (1620\u20131658), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1658 Jul 30",
        "PLACEOFBIRTH": "Murstetten",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10939",
        "NAME": "Montby, Klaudius Kaspar (1620\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10940",
        "NAME": "Gonzaga, Ludwig (1412\u20131478), Markgraf von Mantua",
        "DATEOFBIRTH": "1412 Jun 05",
        "DATEOFDEATH": "1478 Jun 12",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Goito"
    },
    {
        "ID": "10941",
        "NAME": "Gonzaga, Rudolf (1452\u20131495), Markgraf von Luzzara",
        "DATEOFBIRTH": "1452 Apr 18",
        "DATEOFDEATH": "1495 Jul 06",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Fornovo di Taro"
    },
    {
        "ID": "10942",
        "NAME": "Gonzaga, Ludwig (1494\u20131548), Markgraf von Castel Goffredo",
        "DATEOFBIRTH": "1494 Apr 20",
        "DATEOFDEATH": "1548 Jul 19",
        "PLACEOFBIRTH": "Luzzara",
        "PLACEOFDEATH": "Castel Goffredo"
    },
    {
        "ID": "10943",
        "NAME": "Gonzaga, Friedrich (1441\u20131484), Markgraf von Mantua",
        "DATEOFBIRTH": "1441 Jul 02",
        "DATEOFDEATH": "1484 Jul 14",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "10944",
        "NAME": "Gonzaga, Franz (1466\u20131519), Markgraf von Mantua",
        "DATEOFBIRTH": "1466 Aug 10",
        "DATEOFDEATH": "1519 Mar 29",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "10945",
        "NAME": "Gonzaga, Friedrich (1500\u20131540), Herzog von Mantua",
        "DATEOFBIRTH": "1500 Mai 17",
        "DATEOFDEATH": "1540 Jun 28",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Marmirolo"
    },
    {
        "ID": "10946",
        "NAME": "Gonzaga, Ludwig (1539\u20131595), Herzog von Nevers",
        "DATEOFBIRTH": "1539 Sep 18",
        "DATEOFDEATH": "1595 Okt 23",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Nesle am Lingon"
    },
    {
        "ID": "10947",
        "NAME": "Gonzaga, Karl (1580\u20131637), Herzog von Mantua",
        "DATEOFBIRTH": "1580 Mai 06",
        "DATEOFDEATH": "1637 Sep 20",
        "PLACEOFBIRTH": "Paris",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "10948",
        "NAME": "Gonzaga, Karl (1609\u20131631), Herzog von Nevers",
        "DATEOFBIRTH": "1609 Okt 22",
        "DATEOFDEATH": "1631 Aug 30",
        "PLACEOFBIRTH": "Paris",
        "PLACEOFDEATH": "Cavriana"
    },
    {
        "ID": "10949",
        "NAME": "Gonzaga, Karl (1629\u20131665), Herzog von Mantua",
        "DATEOFBIRTH": "1629 Okt 31",
        "DATEOFDEATH": "1665 Aug 14",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "10950",
        "NAME": "Gonzaga, Eleonora (1630\u20131686), Kaiserin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1630 Nov 18",
        "DATEOFDEATH": "1686 Dez 06",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10951",
        "NAME": "Gonzaga, Franz (1446\u20131496)",
        "DATEOFBIRTH": "1446 Okt 04",
        "DATEOFDEATH": "1496 Aug 28",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Bozzolo"
    },
    {
        "ID": "10952",
        "NAME": "Gonzaga, Pyrrhus (1485\u20131529), F\u00fcrst von Bozzolo",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1529 Jan 22",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Gazzuolo"
    },
    {
        "ID": "10953",
        "NAME": "Gonzaga, Karl (1513\u20131555), F\u00fcrst von Bozzolo",
        "DATEOFBIRTH": "1513",
        "DATEOFDEATH": "1555 Jun 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Gazzuolo"
    },
    {
        "ID": "10954",
        "NAME": "Gonzaga, Wilhelm (1538\u20131587), Herzog von Mantua",
        "DATEOFBIRTH": "1538 Apr 24",
        "DATEOFDEATH": "1587 Aug 14",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Goito"
    },
    {
        "ID": "10955",
        "NAME": "Gonzaga, Vinzenz (1562\u20131612), Herzog von Mantua",
        "DATEOFBIRTH": "1562 Sep 21",
        "DATEOFDEATH": "1612 Feb 18",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "10956",
        "NAME": "Gonzaga, Ludwig (1481\u20131540)",
        "DATEOFBIRTH": "1481",
        "DATEOFDEATH": "1540 Jun 16",
        "PLACEOFBIRTH": "Bozzolo",
        "PLACEOFDEATH": "Sabbioneta"
    },
    {
        "ID": "10957",
        "NAME": "Gonzaga, Ludwig (1500\u20131532)",
        "DATEOFBIRTH": "1500 Aug 16",
        "DATEOFDEATH": "1532 Dez 03",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Vicovaro"
    },
    {
        "ID": "10958",
        "NAME": "Dietrichstein, Maria Eleonora (1639\u20131704)",
        "DATEOFBIRTH": "1639 Sep 01",
        "DATEOFDEATH": "1704 Feb 15",
        "PLACEOFBIRTH": "Hollenburg an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10959",
        "NAME": "Waldstein, Monika (1630\u20131666)",
        "DATEOFBIRTH": "1630",
        "DATEOFDEATH": "1666",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10960",
        "NAME": "Borromeo, Karl (1538\u20131584), Erzbischof von Mailand",
        "DATEOFBIRTH": "1538 Okt 02",
        "DATEOFDEATH": "1584 Nov 03",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "10961",
        "NAME": "Waldstein, Johann Karl (1650\u20131708), K\u00e4mmerer",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1708 Okt 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hraden\u00edn"
    },
    {
        "ID": "10962",
        "NAME": "Baranyai von \u0150cs\u00e9ny, Thomas (1630\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "V\u00e1rad",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10963",
        "NAME": "Dar\u00f3czy, Franz (1568\u20131620)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1620 Mai 01",
        "PLACEOFBIRTH": "Deregny\u0151",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10964",
        "NAME": "P\u00e1lffy, Elisabeth (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10965",
        "NAME": "Liechtenstein von Kastelkorn, Maximilian (1611\u20131676)",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1676",
        "PLACEOFBIRTH": "Glatz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10966",
        "NAME": "Liechtenstein von Kastelkorn, Franz Karl (1648\u20131723), Geheimer Rat",
        "DATEOFBIRTH": "1648 Nov 14",
        "DATEOFDEATH": "1723 Jun 14",
        "PLACEOFBIRTH": "Schenna",
        "PLACEOFDEATH": "Hertwigswalde in Schlesien"
    },
    {
        "ID": "10967",
        "NAME": "Wrtby, Sezima (1578\u20131648), Oberstlandk\u00e4mmerer von B\u00f6hmen",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1648 Mar 06",
        "PLACEOFBIRTH": "Vrtba",
        "PLACEOFDEATH": "Votice"
    },
    {
        "ID": "10968",
        "NAME": "Carafa, Ferdinand (1633\u20131661), Truchsess",
        "DATEOFBIRTH": "1633 Sep 07",
        "DATEOFDEATH": "1661 Dez 23",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "10969",
        "NAME": "Carafa, Anton (1642\u20131693), K\u00e4mmerer",
        "DATEOFBIRTH": "1642 Aug 14",
        "DATEOFDEATH": "1693 Mar 06",
        "PLACEOFBIRTH": "Torrepaduli",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10970",
        "NAME": "Habsburg, Eleonora (1534\u20131594), Herzogin von Mantua",
        "DATEOFBIRTH": "1534 Nov 02",
        "DATEOFDEATH": "1594 Aug 05",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "10971",
        "NAME": "Sternberg, Sidonius (1525\u20131575)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1575",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10972",
        "NAME": "Sternberg, Adam (1557\u20131623), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1623 Apr 10",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": "To\u010dn\u00edk"
    },
    {
        "ID": "10973",
        "NAME": "Sternberg, Franz Matthias Karl (1612\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1612 Sep 26",
        "DATEOFDEATH": "1648 Aug 09",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10974",
        "NAME": "Sternberg, Stephan Georg (1564\u20131625)",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1625 Dez 15",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10975",
        "NAME": "Sternberg, Johann Rudolf (1601\u20131638)",
        "DATEOFBIRTH": "1601 Jan 28",
        "DATEOFDEATH": "1638 Mar 18",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10976",
        "NAME": "Sternberg, Stephan Georg (1626\u20131706), K\u00e4mmerer",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1706",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10977",
        "NAME": "Sternberg, Adolf Barzel (1627\u20131703), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1703 Sep 04",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10978",
        "NAME": "Sternberg, Wenzel Albrecht (1643\u20131708), K\u00e4mmerer",
        "DATEOFBIRTH": "1643 Feb 09",
        "DATEOFDEATH": "1708 Jan 25",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10979",
        "NAME": "Sternberg, Franz Leopold (1680\u20131745), Obersthofmarschall",
        "DATEOFBIRTH": "1680 Okt 21",
        "DATEOFDEATH": "1745 Mai 14",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Serowitz"
    },
    {
        "ID": "10980",
        "NAME": "Gonzaga, Ludwig (1568\u20131591)",
        "DATEOFBIRTH": "1568 Mar 09",
        "DATEOFDEATH": "1591 Jun 21",
        "PLACEOFBIRTH": "Castiglione delle Stiviere",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "10981",
        "NAME": "Sternberg, Georg Wenzel (1614\u20131682), K\u00e4mmerer",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "1682",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10982",
        "NAME": "Sternberg, Johann Wenzel (1650\u20131712)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1712 Apr 12",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10983",
        "NAME": "Sternberg, Eleonora (1654\u20131703)",
        "DATEOFBIRTH": "1654 Aug 13",
        "DATEOFDEATH": "1703 Okt 18",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10984",
        "NAME": "Sternberg, Lassel (1530\u20131566), K\u00e4mmerer",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1566 Jul 07",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": "Nepomuk"
    },
    {
        "ID": "10985",
        "NAME": "Sternberg, Johann (1535\u20131578), K\u00e4mmerer",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1578 Jan 03",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10986",
        "NAME": "Sternberg, Jaroslaus Wolfgang (1590\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1635 Feb 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hajany"
    },
    {
        "ID": "10987",
        "NAME": "Eggenberg, Margarita (1609\u20131657)",
        "DATEOFBIRTH": "1609",
        "DATEOFDEATH": "1657 Mar 17",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "10988",
        "NAME": "Arco, Prosper (1615\u20131679), K\u00e4mmerer",
        "DATEOFBIRTH": "1615",
        "DATEOFDEATH": "1679",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10989",
        "NAME": "Magnis, Johann Jakob (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10990",
        "NAME": "Habsburg, Magdalena (1587\u20131631), Gro\u00dfherzogin der Toskana",
        "DATEOFBIRTH": "1587 Okt 07",
        "DATEOFDEATH": "1631 Nov 01",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "10991",
        "NAME": "Bubna, Niklas Barzel (1569\u20131617)",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "Priesen in B\u00f6hmen",
        "PLACEOFDEATH": "Priesen in B\u00f6hmen"
    },
    {
        "ID": "10992",
        "NAME": "Bubna, Konrad Jaroslaus (1610\u20131684)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1684 Jun 25",
        "PLACEOFBIRTH": "Litice im Adlergebirge",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10993",
        "NAME": "Bubna, Adam Maximilian (1650\u20131721)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1721",
        "PLACEOFBIRTH": "Litice im Adlergebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10994",
        "NAME": "Schwihau, Friedrich (1560\u20131629)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Riesenberg im B\u00f6hmerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10995",
        "NAME": "Schwihau, Maximiliana (1601\u20131661)",
        "DATEOFBIRTH": "1601",
        "DATEOFDEATH": "1661 Dez 16",
        "PLACEOFBIRTH": "Ellischau",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10996",
        "NAME": "Schwihau, Peter Wolfgang (1595\u20131642), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Riesenberg im B\u00f6hmerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10997",
        "NAME": "Schwihau, Friedrich Kaspar (1626\u20131654), Mundschenk",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1654 Nov 19",
        "PLACEOFBIRTH": "Ellischau",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "10998",
        "NAME": "Schwihau, Maria Elisabeth (1652\u20131701)",
        "DATEOFBIRTH": "1652",
        "DATEOFDEATH": "1701",
        "PLACEOFBIRTH": "Ellischau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "10999",
        "NAME": "Schwihau, Anna Maria (1654\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1654",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ellischau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11000",
        "NAME": "Habsburg, Joseph\u00a0I. (1678\u20131711), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1678 Jul 26",
        "DATEOFDEATH": "1711 Apr 17",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "11001",
        "NAME": "Haan von Werdenberg, Georg Albrecht (1580\u2013\u00a0\u00a0\u00a0\u00a0), Hofpfennigmeister",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11002",
        "NAME": "Haan von Werdenberg, Johann Albrecht (1615\u2013\u00a0\u00a0\u00a0\u00a0), Mundschenk",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11003",
        "NAME": "Kastele, Christoph (1590\u2013\u00a0\u00a0\u00a0\u00a0), Hofzahlmeister",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11005",
        "NAME": "Draskovich, Johann (1550\u20131613), Ban von Kroatien",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1613 Mar 11",
        "PLACEOFBIRTH": "Bilina in Dalmatien",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "11006",
        "NAME": "Draskovich, Johann (1603\u20131648), Palatin von Ungarn",
        "DATEOFBIRTH": "1603",
        "DATEOFDEATH": "1648 Aug 05",
        "PLACEOFBIRTH": "Drachenstein in Kroatien",
        "PLACEOFDEATH": "Altenburg an der Leitha"
    },
    {
        "ID": "11007",
        "NAME": "Draskovich, Niklas (1595\u20131629), K\u00e4mmerer",
        "DATEOFBIRTH": "1595 Mar 15",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Drachenstein in Kroatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11008",
        "NAME": "Draskovich, Niklas (1630\u20131687), K\u00e4mmerer",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1687 Okt 08",
        "PLACEOFBIRTH": "Drachenstein in Kroatien",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "11009",
        "NAME": "Lannoy, Andreas (1620\u20131662), Mundschenk",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1662 Feb 09",
        "PLACEOFBIRTH": "Helchin",
        "PLACEOFDEATH": "Tournai"
    },
    {
        "ID": "11010",
        "NAME": "Merode, Richard (1560\u20131635)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1635~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "L\u00fcttich"
    },
    {
        "ID": "11011",
        "NAME": "Merode, Philipp Anton (1620\u20131667), K\u00e4mmerer",
        "DATEOFBIRTH": "1620",
        "DATEOFDEATH": "1667 Feb 18",
        "PLACEOFBIRTH": "Beaucarmez",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "11012",
        "NAME": "Merode, Ernst (1600\u20131677), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1677 Sep 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11013",
        "NAME": "Merode, Johann (1589\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1633 Jul 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Nienburg an der Weser"
    },
    {
        "ID": "11014",
        "NAME": "Merode, Hermann Philipp (1590\u20131627)",
        "DATEOFBIRTH": "1590 Jun 20",
        "DATEOFDEATH": "1627 Apr 03",
        "PLACEOFBIRTH": "Argenteau",
        "PLACEOFDEATH": "Tr\u00e9lon"
    },
    {
        "ID": "11015",
        "NAME": "Merode, Albrecht (1618\u20131656), K\u00e4mmerer",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1656 Aug 05",
        "PLACEOFBIRTH": "Beaucarmez",
        "PLACEOFDEATH": "Valenciennes"
    },
    {
        "ID": "11016",
        "NAME": "Eder, Georg (1523\u20131587), Reichshofrat",
        "DATEOFBIRTH": "1523 Feb 02",
        "DATEOFDEATH": "1587 Mai 19",
        "PLACEOFBIRTH": "Freising",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11017",
        "NAME": "Eder, Maximilian (1560\u20131611), Hofkammerrat",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11018",
        "NAME": "Rogendorf, Kaspar (1450\u20131506), K\u00e4mmerer",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1506 Okt 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Guntersdorf im Weinviertel"
    },
    {
        "ID": "11019",
        "NAME": "Sternberg, Sedeslaus (1190\u20131263), K\u00e4mmerer",
        "DATEOFBIRTH": "1190~",
        "DATEOFDEATH": "1263",
        "PLACEOFBIRTH": "Chlumec an der Cidlina",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11020",
        "NAME": "Sternberg, Jaroslaus (1220\u20131287)",
        "DATEOFBIRTH": "1220~",
        "DATEOFDEATH": "1287",
        "PLACEOFBIRTH": "Chlumec an der Cidlina",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11021",
        "NAME": "Sternberg, Sedeslaus (1250\u20131323)",
        "DATEOFBIRTH": "1250~",
        "DATEOFDEATH": "1323",
        "PLACEOFBIRTH": "Sternberg in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11022",
        "NAME": "Sternberg, Sedeslaus (1280\u20131354)",
        "DATEOFBIRTH": "1280~",
        "DATEOFDEATH": "1354",
        "PLACEOFBIRTH": "Sternberg in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11023",
        "NAME": "Sternberg, Jaroslaus (1320\u20131380)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "1380",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11024",
        "NAME": "Sternberg, Jaroslaus (1357\u20131398)",
        "DATEOFBIRTH": "1357",
        "DATEOFDEATH": "1398",
        "PLACEOFBIRTH": "Triesch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11025",
        "NAME": "Sternberg, Jaroslaus (1385\u20131420)",
        "DATEOFBIRTH": "1385~",
        "DATEOFDEATH": "1420 Nov 01",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11026",
        "NAME": "Sternberg, Sidonius (1415\u20131476), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1415~",
        "DATEOFDEATH": "1476 Dez 09",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "11027",
        "NAME": "Sternberg, Jaroslaus (1440\u20131492)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1492",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11028",
        "NAME": "Sternberg, Johann (1468\u20131528)",
        "DATEOFBIRTH": "1468",
        "DATEOFDEATH": "1528 Sep 09",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": "Bechin"
    },
    {
        "ID": "11029",
        "NAME": "Sternberg, Adam (1495\u20131560)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1560 Feb 06",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11030",
        "NAME": "Sternberg, Sedeslaus (1230\u20131289)",
        "DATEOFBIRTH": "1230~",
        "DATEOFDEATH": "1289",
        "PLACEOFBIRTH": "Chlumec an der Cidlina",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11031",
        "NAME": "Sternberg, Jaroslaus (1280\u20131359)",
        "DATEOFBIRTH": "1280~",
        "DATEOFDEATH": "1359",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11032",
        "NAME": "Sternberg, Ulrich (1324\u20131387)",
        "DATEOFBIRTH": "1324",
        "DATEOFDEATH": "1387",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11033",
        "NAME": "Sternberg, Ulrich (1350\u20131397)",
        "DATEOFBIRTH": "1350~",
        "DATEOFDEATH": "1397",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11034",
        "NAME": "Sternberg, Alexander (1390\u20131455)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1455 Mar 19",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": "P\u00fcrglitz"
    },
    {
        "ID": "11035",
        "NAME": "Sternberg, Peter (1420\u20131454)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1454",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11036",
        "NAME": "Sternberg, Peter (1450\u20131514)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1514 Jun 04",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": "L\u00e9\u0161tno"
    },
    {
        "ID": "11037",
        "NAME": "Sternberg, Johann (1480\u20131551)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1551 Jun 12",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11038",
        "NAME": "Sternberg, Wenzel (1520\u20131576)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11039",
        "NAME": "Sternberg, Peter (1550\u20131608)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1608 Sep 28",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11040",
        "NAME": "Sternberg, Ulrich (1580\u20131618)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1618 Mai",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11041",
        "NAME": "Sternberg, Euseb (1380\u20131433)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1433",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11042",
        "NAME": "Krydelle, Johann (1600\u20131660), Reichshofrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1660 Jan 06",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11043",
        "NAME": "Drugeth von Homonna, Johann (1609\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1609",
        "DATEOFDEATH": "1645 Nov 22",
        "PLACEOFBIRTH": "Homenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11044",
        "NAME": "Drugeth von Homonna, Georg (1633\u20131661), K\u00e4mmerer",
        "DATEOFBIRTH": "1633 Jun 08",
        "DATEOFDEATH": "1661 Okt 09",
        "PLACEOFBIRTH": "Homenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11045",
        "NAME": "Putz von Adlersthurn, Thomas (1570\u20131630)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1630~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11046",
        "NAME": "Pinta von Bukowan, Adaukt Wenzel (1620\u20131664), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11047",
        "NAME": "Konarzewski, Adaukt (1610\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kniephof",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11048",
        "NAME": "Schallenberg, Christoph Ehrenreich (1616\u20131678), K\u00e4mmerer",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "Luftenberg an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11049",
        "NAME": "Schallenberg, Christoph Ernst (1617\u20131672), Mundschenk",
        "DATEOFBIRTH": "1617 Sep 27",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "Luftenberg an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11050",
        "NAME": "Schallenberg, Georg Christoph (1593\u20131656), K\u00e4mmerer",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "Seisenegg im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11051",
        "NAME": "Putz von Adlersthurn, Johann (1595\u20131660), Hofkammerrat",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1660",
        "PLACEOFBIRTH": "Kolin an der Elbe",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11052",
        "NAME": "Putz von Adlersthurn, Mark (1600\u20131662), Hofkammerrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1662",
        "PLACEOFBIRTH": "Kolin an der Elbe",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11053",
        "NAME": "Putz von Adlersthurn, Franz Edmund (1635\u20131674), Hofkammerrat",
        "DATEOFBIRTH": "1635",
        "DATEOFDEATH": "1674",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11054",
        "NAME": "Putz von Adlersthurn, Ignaz Dominik (1640\u20131718)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1718 Jan 28",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11055",
        "NAME": "Putz von Adlersthurn, Mark Maximilian (1640\u20131700)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1700",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11056",
        "NAME": "Waldstein, Adam Maximilian (1645\u20131680), K\u00e4mmerer",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "1680~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11057",
        "NAME": "Schallenberg, Christoph (1561\u20131597), Truchsess",
        "DATEOFBIRTH": "1561 Jan 31",
        "DATEOFDEATH": "1597 Apr 25",
        "PLACEOFBIRTH": "Piberstein im M\u00fchlviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11058",
        "NAME": "Kinsky, Wenzel (1502\u20131542)",
        "DATEOFBIRTH": "1502",
        "DATEOFDEATH": "1542",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11059",
        "NAME": "Kinsky, Rassel (1528\u20131619), Obersthofmeister",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "Petrovice in Mittelb\u00f6hmen",
        "PLACEOFDEATH": "Teplitz im Erzgebirge"
    },
    {
        "ID": "11060",
        "NAME": "Kinsky, Johann (1536\u20131590), Burggraf von Karlstein",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1590 Apr 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "11061",
        "NAME": "Kinsky, Johann (1568\u20131603)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "Eger in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11062",
        "NAME": "Kinsky, Wilhelm (1574\u20131634), Oberstj\u00e4germeister",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1634 Feb 25",
        "PLACEOFBIRTH": "Eger in B\u00f6hmen",
        "PLACEOFDEATH": "Eger in B\u00f6hmen"
    },
    {
        "ID": "11063",
        "NAME": "Kinsky, Wenzel (1572\u20131626), K\u00e4mmerer",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1626 Feb 28",
        "PLACEOFBIRTH": "Eger in B\u00f6hmen",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "11064",
        "NAME": "Kinsky, Oktavian (1604\u20131679), K\u00e4mmerer",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1679 Mai 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11065",
        "NAME": "Kinsky, Wenzel (1642\u20131719), Hofkanzler",
        "DATEOFBIRTH": "1642 Apr 01",
        "DATEOFDEATH": "1719 Jan 03",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11066",
        "NAME": "Kinsky, Rudolf (1570\u20131598)",
        "DATEOFBIRTH": "1570",
        "DATEOFDEATH": "1598 Jun 08",
        "PLACEOFBIRTH": "Eger in B\u00f6hmen",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "11067",
        "NAME": "Kinsky, Rassel (1582\u20131660)",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1660 Jul 26",
        "PLACEOFBIRTH": "Eger in B\u00f6hmen",
        "PLACEOFDEATH": "Leiden in Holland"
    },
    {
        "ID": "11068",
        "NAME": "Kinsky, Franz Ulrich (1634\u20131699), Oberstkanzler von B\u00f6hmen",
        "DATEOFBIRTH": "1634",
        "DATEOFDEATH": "1699 Feb 27",
        "PLACEOFBIRTH": "Chlumec an der Cidlina",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11069",
        "NAME": "Trczka von Leipa, Elisabeth (1605\u20131645)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Greifswald"
    },
    {
        "ID": "11070",
        "NAME": "Schallenberg, Christoph Theodemar (1646\u20131708), Hofkriegsrat",
        "DATEOFBIRTH": "1646",
        "DATEOFDEATH": "1708 Feb 06",
        "PLACEOFBIRTH": "Luftenberg an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11071",
        "NAME": "Schallenberg, Christoph Georg (1652\u20131720), Geheimer Rat",
        "DATEOFBIRTH": "1652",
        "DATEOFDEATH": "1720 Jan 02",
        "PLACEOFBIRTH": "Rosenau im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11072",
        "NAME": "Schallenberg, Christoph Leopold (1685\u20131713), K\u00e4mmerer",
        "DATEOFBIRTH": "1685",
        "DATEOFDEATH": "1713",
        "PLACEOFBIRTH": "Rosenau im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11073",
        "NAME": "Schallenberg, Christoph Alexander (1648\u20131670)",
        "DATEOFBIRTH": "1648 Jan 23",
        "DATEOFDEATH": "1670 Nov 29",
        "PLACEOFBIRTH": "Luftenberg an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11074",
        "NAME": "Schallenberg, Wolfgang Christoph (1589\u20131647)",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1647",
        "PLACEOFBIRTH": "Seisenegg im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11075",
        "NAME": "Schallenberg, Christoph Theoderich (1617\u20131664)",
        "DATEOFBIRTH": "1617 Jan 13",
        "DATEOFDEATH": "1664 Nov 11",
        "PLACEOFBIRTH": "Rosenau im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11076",
        "NAME": "Iselin von Lanans, Klaudius Franz (1610\u20131661)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1661",
        "PLACEOFBIRTH": "Lanans",
        "PLACEOFDEATH": "Roulans"
    },
    {
        "ID": "11077",
        "NAME": "Iselin von Lanans, Ferdinand (1645\u20131706), Truchsess",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "1706",
        "PLACEOFBIRTH": "Roulans",
        "PLACEOFDEATH": "Basel"
    },
    {
        "ID": "11078",
        "NAME": "Annenberg, Johann Arbogast (1590\u20131645), Landeshauptmann von Glatz",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1645 Jun 28",
        "PLACEOFBIRTH": "Latsch im Vinschgau",
        "PLACEOFDEATH": "Glatz"
    },
    {
        "ID": "11079",
        "NAME": "Waldstein, Ferdinand Karl (1652\u20131696), K\u00e4mmerer",
        "DATEOFBIRTH": "1652 Okt 28",
        "DATEOFDEATH": "1696 Dez 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11080",
        "NAME": "L\u00f6bl von Greinburg, Johann Bernhard (1560\u20131609), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "Greinburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11081",
        "NAME": "L\u00f6bl von Greinburg, Johann Christoph (1587\u20131638), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1587 Dez 25",
        "DATEOFDEATH": "1638 Jun 12",
        "PLACEOFBIRTH": "Greinburg",
        "PLACEOFDEATH": "Wien:Dominikanerkirche"
    },
    {
        "ID": "11082",
        "NAME": "L\u00f6bl von Greinburg, Johann Bernhard (1590\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Greinburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11083",
        "NAME": "L\u00f6bl von Greinburg, Johann Bernhard (1627\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1649 Aug 04",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11084",
        "NAME": "Herberstein, Anna Maria (1600\u20131641)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1641",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11085",
        "NAME": "L\u00f6bl von Greinburg, Johann Georg (1525\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11086",
        "NAME": "L\u00f6bl von Greinburg, Johann Jakob (1555\u20131602), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1602 Okt 11",
        "PLACEOFBIRTH": "Greinburg",
        "PLACEOFDEATH": "Greinburg"
    },
    {
        "ID": "11087",
        "NAME": "Ossolin\u0301ski, Christoph Baldwin (1616\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1649 Aug 16",
        "PLACEOFBIRTH": "Bukowsko",
        "PLACEOFDEATH": "Zbor\u00f3w am Strypa"
    },
    {
        "ID": "11088",
        "NAME": "Renesse, Alexander (1618\u20131658), K\u00e4mmerer",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "Warfus\u00e9e",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "11089",
        "NAME": "Odkolek, Albrecht Lassel (1630\u20131678), Truchsess",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "Battelau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11090",
        "NAME": "Wettstein, Johann Rudolf (1594\u20131666), B\u00fcrgermeister von Basel",
        "DATEOFBIRTH": "1594 Okt 27",
        "DATEOFDEATH": "1666 Apr 12",
        "PLACEOFBIRTH": "Basel",
        "PLACEOFDEATH": "Basel"
    },
    {
        "ID": "11091",
        "NAME": "Wettstein, Christoph (1625\u20131663), Truchsess",
        "DATEOFBIRTH": "1625 Jan 17",
        "DATEOFDEATH": "1663 Sep 05",
        "PLACEOFBIRTH": "Basel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11092",
        "NAME": "Rosenau, Rudolf Karl Ernst (1623\u20131678), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11094",
        "NAME": "Sinkmoser, Mark (1518\u20131569), Hofsekret\u00e4r",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1569 Mai 01",
        "PLACEOFBIRTH": "Hall in Tirol",
        "PLACEOFDEATH": "Juval im Vinschgau"
    },
    {
        "ID": "11095",
        "NAME": "Haag, David (1530\u20131603), Hofzahlmeister",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11096",
        "NAME": "Schlei\u00df von L\u00f6wenfeld, Jakob (1599\u20131661), Hofkammerregistrator",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1661",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11097",
        "NAME": "Loyselli, Johann Georg (1616\u20131672), Hofkammerkonzipist",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11098",
        "NAME": "Pr\u00fcschenk von Hardegg, Georg Friedrich (1568\u20131628), K\u00e4mmerer",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1628 Sep 06",
        "PLACEOFBIRTH": "Hardegg an der Thaya",
        "PLACEOFDEATH": "Wolfpassing am Wagram"
    },
    {
        "ID": "11099",
        "NAME": "Pr\u00fcschenk von Hardegg, Julius (1594\u20131684), K\u00e4mmerer",
        "DATEOFBIRTH": "1594 Mar 21",
        "DATEOFDEATH": "1684 Apr 27",
        "PLACEOFBIRTH": "Wolfpassing am Wagram",
        "PLACEOFDEATH": "Wolfpassing am Wagram"
    },
    {
        "ID": "11100",
        "NAME": "Lisen von Reschau, Leopold (1600\u20131647), Hofkammerrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1647 Apr 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11101",
        "NAME": "Pfundtner, Johann (1605\u20131649), Hofkammerrat",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1649 Jun 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11102",
        "NAME": "Peyerl, Gabriel (1600\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11104",
        "NAME": "Meroldt, Johann Adolf (1610\u20131672), Hofkammerrat",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11105",
        "NAME": "Herting von Plettenberg, Georg (1604\u20131682), Hofkammerrat",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1682 Mar 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Frankfurt am Main"
    },
    {
        "ID": "11106",
        "NAME": "Hegenm\u00fcller von Dubenweiler, Georg (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11107",
        "NAME": "Hegenm\u00fcller von Dubenweiler, Johann (1535\u20131584), Reichshofrat",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1584 Sep 27",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11108",
        "NAME": "Hegenm\u00fcller von Dubenweiler, Johann Ruprecht (1572\u20131633), Geheimer Rat",
        "DATEOFBIRTH": "1572 Jun 05",
        "DATEOFDEATH": "1633 Sep 17",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "11109",
        "NAME": "Hegenm\u00fcller von Dubenweiler, Wenzel (1608\u20131667), Hofkammerrat",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1667",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Albrechtsberg an der Pielach"
    },
    {
        "ID": "11110",
        "NAME": "Losy von Losinthal, Johann Anton (1600\u20131682), Hofkammerrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1682 Jul 27",
        "PLACEOFBIRTH": "Poschiavo",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11111",
        "NAME": "Losy von Losinthal, Johann Anton (1648\u20131721)",
        "DATEOFBIRTH": "1648",
        "DATEOFDEATH": "1721 Aug 22",
        "PLACEOFBIRTH": "Steken im B\u00f6hmerwald",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11112",
        "NAME": "Losy von Losinthal, Adam Philipp (1705\u20131781)",
        "DATEOFBIRTH": "1705",
        "DATEOFDEATH": "1781 Apr 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11113",
        "NAME": "Losy von Losinthal, Maria Theresia (1659\u20131695)",
        "DATEOFBIRTH": "1659",
        "DATEOFDEATH": "1695 Feb 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11114",
        "NAME": "Losy von Losinthal, Johann Baptist (1652\u20131687)",
        "DATEOFBIRTH": "1652",
        "DATEOFDEATH": "1687",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11115",
        "NAME": "Kotz von Dobrz, Karl Hermann (1615\u20131655), Truchsess",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1655 Mai 17",
        "PLACEOFBIRTH": "Dobrz",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11116",
        "NAME": "Kotz von Dobrz, Wenzel Albrecht (1635\u20131698)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1698",
        "PLACEOFBIRTH": "Dobrz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11117",
        "NAME": "Kotz von Dobrz, Jaroslaus Joachim (1620\u20131656)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "Dobrz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11118",
        "NAME": "Kotz von Dobrz, Maximiliana Franziska (1650\u20131708)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1708 Feb 07",
        "PLACEOFBIRTH": "Dobrz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11119",
        "NAME": "Kotz von Dobrz, Dionys (1585\u20131641), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1641",
        "PLACEOFBIRTH": "Dobrz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11120",
        "NAME": "Kolowrat, Polyxena (1632\u20131671)",
        "DATEOFBIRTH": "1632",
        "DATEOFDEATH": "1671 Apr 24",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11121",
        "NAME": "Kotz von Dobrz, Dionys Georg (1625\u20131665), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "Dobrz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11122",
        "NAME": "Go\u00ebss, Johann (1590\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1634 Jun 09",
        "PLACEOFBIRTH": "L\u00f6wen in Brabant",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "11123",
        "NAME": "Go\u00ebss, Johann Baptist (1612\u20131696), Bischof von Gurk",
        "DATEOFBIRTH": "1612 Feb 10",
        "DATEOFDEATH": "1696 Okt 19",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "11124",
        "NAME": "Zedlitz, Ferdinand (1619\u20131668), Truchsess",
        "DATEOFBIRTH": "1619",
        "DATEOFDEATH": "1668",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11126",
        "NAME": "Berchtold, Jakob (1590\u20131641), Hofkammerrat",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1641 Mai 28",
        "PLACEOFBIRTH": "Sachsengang",
        "PLACEOFDEATH": "Wien:Stephansdom"
    },
    {
        "ID": "11127",
        "NAME": "Berchtold, Franz Benedikt (1631\u20131690), K\u00e4mmerer",
        "DATEOFBIRTH": "1631 Mar 04",
        "DATEOFDEATH": "1690 Jul 29",
        "PLACEOFBIRTH": "Ungarschitz in M\u00e4hren",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "11128",
        "NAME": "Kazianer von Katzenstein, Johann Weikhard (1630\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11129",
        "NAME": "Kazianer von Katzenstein, Johann Herbert (1625\u20131681), Landeshauptmann von G\u00f6rz",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1681 Okt 13",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11130",
        "NAME": "Kazianer von Katzenstein, Georg Andreas (1550\u20131616)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11131",
        "NAME": "Kazianer von Katzenstein, Johann Siegmund (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11132",
        "NAME": "Kazianer von Katzenstein, Wolfgang Jakob (1595\u20131639)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1639 Nov 29",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11133",
        "NAME": "Kazianer von Katzenstein, Georg Siegmund (1620\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11134",
        "NAME": "Kazianer von Katzenstein, Ferdinand Helfried (1625\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11135",
        "NAME": "Kazianer von Katzenstein, Siegmund Ferdinand (1630\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11136",
        "NAME": "Kazianer von Katzenstein, Johann (1491\u20131539), Landeshauptmann von Krain",
        "DATEOFBIRTH": "1491",
        "DATEOFDEATH": "1539 Okt 27",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": "Kostajnica"
    },
    {
        "ID": "11137",
        "NAME": "Kazianer von Katzenstein, Balthasar (1505\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11138",
        "NAME": "Kazianer von Katzenstein, Leonhard (1460\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11139",
        "NAME": "Kazianer von Katzenstein, Eleonora Elisabeth (1635\u20131685)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1685~",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11140",
        "NAME": "Gera, Johann Veit (1628\u20131703), K\u00e4mmerer",
        "DATEOFBIRTH": "1628",
        "DATEOFDEATH": "1703 Jun 27",
        "PLACEOFBIRTH": "Arnfels",
        "PLACEOFDEATH": "Engelszell"
    },
    {
        "ID": "11142",
        "NAME": "Eibiswald, Gottfried (1585\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "Burgstall an der Sulm",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11143",
        "NAME": "Crane, Johann Baptist (1595\u20131672), Reichshofrat",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "Geseke",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11144",
        "NAME": "Drugeth von Homonna, Siegmund (1655\u20131684), K\u00e4mmerer",
        "DATEOFBIRTH": "1655~",
        "DATEOFDEATH": "1684 Apr 14",
        "PLACEOFBIRTH": "Homenau",
        "PLACEOFDEATH": "Kaschau"
    },
    {
        "ID": "11145",
        "NAME": "Rungen, Reinhold (1600\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11146",
        "NAME": "Schurff, Karl (1548\u20131626), K\u00e4mmerer",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1626 Apr 02",
        "PLACEOFBIRTH": "Sch\u00f6nweer in Tirol",
        "PLACEOFDEATH": "Kufstein"
    },
    {
        "ID": "11147",
        "NAME": "Schurff, Karl (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mariastein in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11148",
        "NAME": "Haim von Reichenstein, Stephan (1553\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1553 Mai 17",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Reichenstein im M\u00fchlviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11149",
        "NAME": "Haim von Reichenstein, Johann Christoph (1595\u20131652), K\u00e4mmerer",
        "DATEOFBIRTH": "1595 Nov 07",
        "DATEOFDEATH": "1652",
        "PLACEOFBIRTH": "Heinrichschlag im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11150",
        "NAME": "Heusenstamm, Johann (1530\u2013\u00a0\u00a0\u00a0\u00a0), Reichshofrat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11151",
        "NAME": "Heusenstamm, Maximilian (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11152",
        "NAME": "Heusenstamm, Johann Georg (1560\u20131616), Oberststallmeister",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11153",
        "NAME": "Heusenstamm, Ehrenreich (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11154",
        "NAME": "Heusenstamm, Johann Lassel (1590\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1648",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11155",
        "NAME": "Heusenstamm, Ferdinand (1620\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1660",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11156",
        "NAME": "Heusenstamm, Otto Heinrich (1595\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1664 Okt 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11157",
        "NAME": "Heusenstamm, Christoph Ferdinand (1625\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11158",
        "NAME": "Heusenstamm, Otto Felizian (1630\u20131693)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1693",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11159",
        "NAME": "Heusenstamm, Franz Dominik (1635\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11160",
        "NAME": "R\u00f6merstal, Johann Christoph (1593\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1637 Sep 30",
        "PLACEOFBIRTH": "Delsberg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11161",
        "NAME": "Trczka von Leipa, Niklas (1400\u20131453)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1453",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lipnitz an der Sasau"
    },
    {
        "ID": "11162",
        "NAME": "Trczka von Leipa, Burian (1430\u20131468)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1468",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11163",
        "NAME": "Trczka von Leipa, Burian (1465\u20131522)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1522",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11164",
        "NAME": "Lindensp\u00fcr, Georg Ludwig (1607\u20131663), Reichshofrat",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "Stuttgart",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11165",
        "NAME": "Lindensp\u00fcr, Wolfgang Friedrich (1581\u20131651)",
        "DATEOFBIRTH": "1581 Mar 02",
        "DATEOFDEATH": "1651 Jun 10",
        "PLACEOFBIRTH": "Sommerhausen",
        "PLACEOFDEATH": "Stuttgart"
    },
    {
        "ID": "11166",
        "NAME": "Lindensp\u00fcr, Georg Friedrich (1612\u20131680)",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1680",
        "PLACEOFBIRTH": "Stuttgart",
        "PLACEOFDEATH": "Schwarzenau im Waldviertel"
    },
    {
        "ID": "11167",
        "NAME": "Tattenbach, Johann Christoph (1574\u20131627)",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1627 Apr 26",
        "PLACEOFBIRTH": "Landsberg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11168",
        "NAME": "Tattenbach, Wilhelm Leopold (1609\u20131661), Gro\u00dfprior des Malteserordens in B\u00f6hmen",
        "DATEOFBIRTH": "1609 Jul 10",
        "DATEOFDEATH": "1661 Nov 25",
        "PLACEOFBIRTH": "Landsberg in der Krain",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "11169",
        "NAME": "Tattenbach, Johann Gottfried (1607\u20131640)",
        "DATEOFBIRTH": "1607 Jan 31",
        "DATEOFDEATH": "1640",
        "PLACEOFBIRTH": "Landsberg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11170",
        "NAME": "Tattenbach, Johann Erasam (1631\u20131671), K\u00e4mmerer",
        "DATEOFBIRTH": "1631 Feb 03",
        "DATEOFDEATH": "1671 Dez 01",
        "PLACEOFBIRTH": "Landsberg in der Krain",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "11171",
        "NAME": "Velen, Alexander (1599\u20131675), K\u00e4mmerer",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1675 Okt 10",
        "PLACEOFBIRTH": "Raesfeld",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11172",
        "NAME": "Velen, Ferdinand Gottfried (1626\u20131685), K\u00e4mmerer",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1685 Jul 07",
        "PLACEOFBIRTH": "Raesfeld",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11173",
        "NAME": "Schellhardt von Hartenfels, Johann Bartlome (1600\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11174",
        "NAME": "Pfister, Christoph (1535\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11175",
        "NAME": "S\u00f6ldner, Johann (1580\u20131649), Reichshofrat",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1649 Feb 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11176",
        "NAME": "B\u00f6hmer, Arnold (1580\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11177",
        "NAME": "Bidembach von Treuenfels, Wilhelm (1587\u20131655), Reichshofrat",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1655 Dez 15",
        "PLACEOFBIRTH": "Stuttgart",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11178",
        "NAME": "Bohn, Johann Philipp (1597\u20131658), Reichshofrat",
        "DATEOFBIRTH": "1597 Feb 09",
        "DATEOFDEATH": "1658 Feb 28",
        "PLACEOFBIRTH": "Lorch im Rheingau",
        "PLACEOFDEATH": "Birkenau im Odenwald"
    },
    {
        "ID": "11179",
        "NAME": "Goppold, Johann Jakob (1620\u20131683), Reichshofrat",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1683",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11180",
        "NAME": "Hofmann von Gr\u00fcnb\u00fchel, Johann (1492\u20131564), K\u00e4mmerer",
        "DATEOFBIRTH": "1492",
        "DATEOFDEATH": "1564 Jul 18",
        "PLACEOFBIRTH": "Gr\u00fcnb\u00fchel in der Steiermark",
        "PLACEOFDEATH": "Strechau"
    },
    {
        "ID": "11181",
        "NAME": "Hofmann von Gr\u00fcnb\u00fchel, Adam (1523\u20131573), K\u00e4mmerer",
        "DATEOFBIRTH": "1523",
        "DATEOFDEATH": "1573 Sep 08",
        "PLACEOFBIRTH": "Gr\u00fcnb\u00fchel in der Steiermark",
        "PLACEOFDEATH": "Steyr"
    },
    {
        "ID": "11182",
        "NAME": "Hofmann von Gr\u00fcnb\u00fchel, Johann Adam (1560\u20131594), Vorschneider",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "Strechau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11183",
        "NAME": "Hofmann von Gr\u00fcnb\u00fchel, Johann Friedrich (1530\u20131589), K\u00e4mmerer",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "Gr\u00fcnb\u00fchel in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11184",
        "NAME": "Hofmann von Gr\u00fcnb\u00fchel, Wolfgang (1570\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Strechau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11185",
        "NAME": "Hofmann von Gr\u00fcnb\u00fchel, Wolfgang Friedrich (1600\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "Strechau",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "11186",
        "NAME": "Hofmann von Gr\u00fcnb\u00fchel, Ferdinand (1540\u20131607), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1540 Mai 10",
        "DATEOFDEATH": "1607 Mar 23",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Grafenstein in B\u00f6hmen"
    },
    {
        "ID": "11187",
        "NAME": "Pucher von Meggenhausen, Johann Rudolf (1560\u20131625), Reichshofrat",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1625 Nov 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Meckenhausen in Mittelfranken"
    },
    {
        "ID": "11188",
        "NAME": "Pucher von Meggenhausen, Johann Georg (1602\u20131665), Hofkriegsrat",
        "DATEOFBIRTH": "1602 Jan 06",
        "DATEOFDEATH": "1665 Apr 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11189",
        "NAME": "Pucher von Meggenhausen, Georg Niklas (1570\u20131644)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Eggendorf im Traunkreis"
    },
    {
        "ID": "11190",
        "NAME": "Schmid von Schwarzenhorn, Johann Rudolf (1590\u20131667), Hofkriegsrat",
        "DATEOFBIRTH": "1590 Apr 17",
        "DATEOFDEATH": "1667 Apr 12",
        "PLACEOFBIRTH": "Stein am Rhein",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "11191",
        "NAME": "Ottmann von Ottensee, Vinzenz Ernst (1600\u20131657), Hofkriegsrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1657",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11192",
        "NAME": "Marcus, Matthias (1590\u20131643), Untermustermeister",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1643 Dez 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11193",
        "NAME": "Gersdorff, Johann (1580\u20131634)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "Seichau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11194",
        "NAME": "Gersdorff, Georg Rudolf (1622\u20131684), K\u00e4mmerer",
        "DATEOFBIRTH": "1622",
        "DATEOFDEATH": "1684",
        "PLACEOFBIRTH": "Seichau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11195",
        "NAME": "Gersdorff, Georg Rudolf (1654\u20131711), K\u00e4mmerer",
        "DATEOFBIRTH": "1654",
        "DATEOFDEATH": "1711",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11196",
        "NAME": "Gersdorff, Georg (1490\u20131558)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1558 Jun 09",
        "PLACEOFBIRTH": "Choltice",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11197",
        "NAME": "Gersdorff, Sebastian (1510\u20131569)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "Malschwitz in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11198",
        "NAME": "Gersdorff, Friedrich (1540\u20131606)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "Malschwitz in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11199",
        "NAME": "Gersdorff, Niklas (1590\u20131631), Hofkammerrat",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1631 Okt 02",
        "PLACEOFBIRTH": "Malschwitz in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11200",
        "NAME": "Habsburg, Johann Karl (1605\u20131619)",
        "DATEOFBIRTH": "1605 Nov 01",
        "DATEOFDEATH": "1619 Dez 26",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "11201",
        "NAME": "Rosental, Johann (1390\u20131430)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1430",
        "PLACEOFBIRTH": "Rosental an der Skalitz",
        "PLACEOFDEATH": "Taus:Augustinerkirche"
    },
    {
        "ID": "11202",
        "NAME": "Rosental, Johanna (1430\u20131475), K\u00f6nigin von B\u00f6hmen",
        "DATEOFBIRTH": "1430",
        "DATEOFDEATH": "1475 Nov 12",
        "PLACEOFBIRTH": "Rosental an der Skalitz",
        "PLACEOFDEATH": "Melnik"
    },
    {
        "ID": "11203",
        "NAME": "Welsperg, Johann (1520\u20131583), Reichshofrat",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1583",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11204",
        "NAME": "Stain von Rechtenstein, Johann Jakob (1590\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "Konstanz im Hegau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11205",
        "NAME": "Offenheim, Eustach (1535\u20131625), Obersthofmeister",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1625~",
        "PLACEOFBIRTH": "Guteneck am Sulzbach",
        "PLACEOFDEATH": "Seibersdorf am Inn"
    },
    {
        "ID": "11206",
        "NAME": "Leslie, Johann (1546\u20131622)",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1622",
        "PLACEOFBIRTH": "Balquhain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11207",
        "NAME": "Leslie, Alexander (1599\u20131677)",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1677 Mar 03",
        "PLACEOFBIRTH": "Balquhain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11208",
        "NAME": "Hundt von Lauterbach, Wolfgang Wilhelm (1575\u20131616), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Falkenstein am Inn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11209",
        "NAME": "Sapieha, Stenzel (1589\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1589 Okt 25",
        "DATEOFDEATH": "1635 Apr 10",
        "PLACEOFBIRTH": "Mo\u0142odeczno",
        "PLACEOFDEATH": "Lachowicze"
    },
    {
        "ID": "11210",
        "NAME": "Draskovich, Bartlome (1480\u20131538)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1538",
        "PLACEOFBIRTH": "Bilina in Dalmatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11211",
        "NAME": "Draskovich, Georg (1515\u20131587), Erzbischof von Kollotschau",
        "DATEOFBIRTH": "1515 Feb 05",
        "DATEOFDEATH": "1587 Jan 21",
        "PLACEOFBIRTH": "Bilina in Dalmatien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11212",
        "NAME": "Draskovich, Kaspar (1520\u20131591)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1591 Dez 31",
        "PLACEOFBIRTH": "Bilina in Dalmatien",
        "PLACEOFDEATH": "Drachenstein in Kroatien"
    },
    {
        "ID": "11213",
        "NAME": "Draskovich, Johann (1525\u20131566)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1566 Sep 07",
        "PLACEOFBIRTH": "Bilina in Dalmatien",
        "PLACEOFDEATH": "Szigetv\u00e1r"
    },
    {
        "ID": "11214",
        "NAME": "Draskovich, Georg (1559\u20131607), Hofdiener",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "Bilina in Dalmatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11215",
        "NAME": "Draskovich, Georg (1599\u20131650), Bischof von Jauer an der Raab",
        "DATEOFBIRTH": "1599 Mai 14",
        "DATEOFDEATH": "1650 Nov 26",
        "PLACEOFBIRTH": "Drachenstein in Kroatien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11216",
        "NAME": "Draskovich, Johann (1635\u20131692), Obersthofmeister",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1692 Apr 02",
        "PLACEOFBIRTH": "Drachenstein in Kroatien",
        "PLACEOFDEATH": "Lockenhaus"
    },
    {
        "ID": "11217",
        "NAME": "Draskovich, Johann (1670\u20131733), Ban von Kroatien",
        "DATEOFBIRTH": "1670~",
        "DATEOFDEATH": "1733 Jan 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Klenovnik in Kroatien"
    },
    {
        "ID": "11218",
        "NAME": "Orsich, Johann Franz (1630\u20131686), Truchsess",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1686",
        "PLACEOFBIRTH": "Slaveti\u0107",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11219",
        "NAME": "Petschwitz, Georg Andreas (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11220",
        "NAME": "Isolani, Johann Ludwig (1586\u20131640), K\u00e4mmerer",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1640 Mar 29",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11221",
        "NAME": "Dolski, Paul Lassel (1610\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Dolsk",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11222",
        "NAME": "Erd\u0151dy, Siegmund (1590\u20131639), Ban von Kroatien",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1639 Jun 28",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11223",
        "NAME": "Erd\u0151dy, Niklas (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11224",
        "NAME": "Erd\u0151dy, Christoph (1584\u20131621)",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1621 Aug 27",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11225",
        "NAME": "Erd\u0151dy, Gabriel (1613\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1613",
        "DATEOFDEATH": "1650 Jul 13",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11226",
        "NAME": "Draskovich, Helena (1591\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1591 Okt 01",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Drachenstein in Kroatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11227",
        "NAME": "Schlick, Johann Ludwig (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neudek an der Rohlau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11228",
        "NAME": "Kolowrat, Karl (1585\u20131629), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Rothschlo\u00df",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11229",
        "NAME": "Kolowrat, Johanna Dorothea (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rothschlo\u00df",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11230",
        "NAME": "Zierotin, Johann Joachim (1667\u20131716), K\u00e4mmerer",
        "DATEOFBIRTH": "1667 Apr 01",
        "DATEOFDEATH": "1716 Mai 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11231",
        "NAME": "Sahrer von Sahr, Florian Theoderich (1598\u20131653), K\u00e4mmerer",
        "DATEOFBIRTH": "1598 Mai 09",
        "DATEOFDEATH": "1653 Mai 07",
        "PLACEOFBIRTH": "Tachlovice",
        "PLACEOFDEATH": "Kladno"
    },
    {
        "ID": "11232",
        "NAME": "Sahrer von Sahr, Maria Katharina (1630\u20131658)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11233",
        "NAME": "Martinitz, Elisabeth Quirina (1604\u20131649)",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1649 Jul 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11234",
        "NAME": "Martinitz, Barbara Eusebia (1610\u20131656)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1656 Jun 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11235",
        "NAME": "Slavata, Adam (1546\u20131616)",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1616 Feb 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11236",
        "NAME": "Slavata, Adam Paul (1604\u20131657), K\u00e4mmerer",
        "DATEOFBIRTH": "1604 Jun 13",
        "DATEOFDEATH": "1657 Jul 02",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Neuhaus in B\u00f6hmen"
    },
    {
        "ID": "11237",
        "NAME": "Slavata, Elisabeth (1573\u20131605)",
        "DATEOFBIRTH": "1573",
        "DATEOFDEATH": "1605 Feb 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11238",
        "NAME": "Slavata, Joachim (1576\u20131630), K\u00e4mmerer",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1630",
        "PLACEOFBIRTH": "\u010cest\u00edn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11239",
        "NAME": "Slavata, Dionys Wilhelm (1519\u20131575)",
        "DATEOFBIRTH": "1519",
        "DATEOFDEATH": "1575 Aug 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11240",
        "NAME": "Slavata, Heinrich (1550\u20131599)",
        "DATEOFBIRTH": "1550",
        "DATEOFDEATH": "1599 Jan 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11241",
        "NAME": "Slavata, Dionys (1586\u20131623)",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1623 Feb 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11242",
        "NAME": "Slavata, Heinrich Wilhelm (1605\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1654 Okt 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11243",
        "NAME": "Wrtby, Johann Franz (1631\u20131687), K\u00e4mmerer",
        "DATEOFBIRTH": "1631",
        "DATEOFDEATH": "1687 Aug 20",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11244",
        "NAME": "Schambach, Karl Sidonius (1588\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "Schambach im Adlergebirge",
        "PLACEOFDEATH": "Pottenstein im Adlergebirge"
    },
    {
        "ID": "11245",
        "NAME": "Logau, Heinrich (1570\u20131625), Gro\u00dfprior des Malteserordens in B\u00f6hmen",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1625 Okt 11",
        "PLACEOFBIRTH": "Olbersdorf am Weigelsdorfer Wasser",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11246",
        "NAME": "Hase von Hasenburg, Johann (1486\u20131553)",
        "DATEOFBIRTH": "1486",
        "DATEOFDEATH": "1553 Okt 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Budin an der Eger"
    },
    {
        "ID": "11247",
        "NAME": "Hase von Hasenburg, Wenzel (1518\u20131578)",
        "DATEOFBIRTH": "1518 Mar 03",
        "DATEOFDEATH": "1578 Jan 27",
        "PLACEOFBIRTH": "Budin an der Eger",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11248",
        "NAME": "Hase von Hasenburg, Niklas (1524\u20131585)",
        "DATEOFBIRTH": "1524 Sep 14",
        "DATEOFDEATH": "1585 Mar 20",
        "PLACEOFBIRTH": "Budin an der Eger",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11249",
        "NAME": "Wrtby, Ferdinand Franz (1636\u20131712), K\u00e4mmerer",
        "DATEOFBIRTH": "1636",
        "DATEOFDEATH": "1712 Mar 20",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11250",
        "NAME": "Melun, Wilhelm (1588\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1588 Mar 08",
        "DATEOFDEATH": "1635 Sep 08",
        "PLACEOFBIRTH": "Gent in Flandern",
        "PLACEOFDEATH": "Saint Quentin"
    },
    {
        "ID": "11251",
        "NAME": "Rosental, Jaroslaus (1425\u20131486)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "1486 Okt 23",
        "PLACEOFBIRTH": "Rosental an der Skalitz",
        "PLACEOFDEATH": "Blatn\u00e1"
    },
    {
        "ID": "11252",
        "NAME": "Rosental, Sidonius (1470\u20131535), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1535 Sep 14",
        "PLACEOFBIRTH": "Rosental an der Skalitz",
        "PLACEOFDEATH": "Blatn\u00e1"
    },
    {
        "ID": "11253",
        "NAME": "Rosental, Sidonius (1510\u20131580), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1580",
        "PLACEOFBIRTH": "Blatn\u00e1",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11254",
        "NAME": "Rosental, Maximilian (1550\u20131613)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "Blatn\u00e1",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11255",
        "NAME": "Rosental, Sidonius Franz (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Blatn\u00e1",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11256",
        "NAME": "Rosenberg, Johann (1434\u20131472), Landeshauptmann von Schweidnitz und Jauer",
        "DATEOFBIRTH": "1434",
        "DATEOFDEATH": "1472 Nov 08",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": "Ortenburg im Wolfachtal"
    },
    {
        "ID": "11257",
        "NAME": "Rosenberg, Peter (1462\u20131523), Statthalter von B\u00f6hmen",
        "DATEOFBIRTH": "1462 Jan 17",
        "DATEOFDEATH": "1523 Okt 09",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": "Krumau in B\u00f6hmen"
    },
    {
        "ID": "11258",
        "NAME": "Rosenberg, Wolfgang (1459\u20131505)",
        "DATEOFBIRTH": "1459 Jul 18",
        "DATEOFDEATH": "1505 Sep 01",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": "Wittingau"
    },
    {
        "ID": "11259",
        "NAME": "Rosenberg, Jobst (1488\u20131539)",
        "DATEOFBIRTH": "1488 Jun 30",
        "DATEOFDEATH": "1539 Okt 15",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": "Krumau in B\u00f6hmen"
    },
    {
        "ID": "11260",
        "NAME": "Rosenberg, Peter Wolfgang (1539\u20131611)",
        "DATEOFBIRTH": "1539 Okt 01",
        "DATEOFDEATH": "1611 Nov 06",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": "Wittingau"
    },
    {
        "ID": "11261",
        "NAME": "Steinberg, Heinrich (1584\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1584 Jul 10",
        "DATEOFDEATH": "1639 Feb 13",
        "PLACEOFBIRTH": "Bodenburg im Leinebergland",
        "PLACEOFDEATH": "Halberstadt"
    },
    {
        "ID": "11262",
        "NAME": "Eibiswald, Siegmund (1505\u20131556)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1556",
        "PLACEOFBIRTH": "Eibiswald im Saggautal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11263",
        "NAME": "Eibiswald, Kaspar (1545\u20131598)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Burgstall an der Sulm",
        "PLACEOFDEATH": "Konstantinopel"
    },
    {
        "ID": "11264",
        "NAME": "Rosenberg, Johann (1560\u20131617)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "Aust an der Lainsitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11265",
        "NAME": "Rosenberg, Georg Wilhelm (1590\u20131621)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "Aust an der Lainsitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11266",
        "NAME": "Lobkowicz, Georg (1540\u20131607), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1607 Mai 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Elbogen an der Eger"
    },
    {
        "ID": "11267",
        "NAME": "Waldstein, Wenzel (1520\u20131579)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1579 Aug 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11268",
        "NAME": "Waldstein, Elisabeth (1575\u20131631)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1631",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11269",
        "NAME": "Jen\u00ed\u0161ek von \u00dajezd, Johann (1500\u20131556)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1556",
        "PLACEOFBIRTH": "Svr\u010dovec",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11270",
        "NAME": "Jen\u00ed\u0161ek von \u00dajezd, Adaukt (1580\u20131651), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1651 Mar 25",
        "PLACEOFBIRTH": "Svr\u010dovec",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11271",
        "NAME": "Jen\u00ed\u0161ek von \u00dajezd, Burian (1540\u20131599)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "Svr\u010dovec",
        "PLACEOFDEATH": "\u0160t\u011bp\u00e1novice an der Angel"
    },
    {
        "ID": "11272",
        "NAME": "Jen\u00ed\u0161ek von \u00dajezd, Johann (1575\u20131642)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Svr\u010dovec",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11273",
        "NAME": "Jen\u00ed\u0161ek von \u00dajezd, Adaukt Franz (1620\u20131661)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1661",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11274",
        "NAME": "Jen\u00ed\u0161ek von \u00dajezd, Johann Joseph (1657\u20131728), K\u00e4mmerer",
        "DATEOFBIRTH": "1657",
        "DATEOFDEATH": "1728",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11275",
        "NAME": "Zierotin, Kaspar Melchior (1559\u20131628), K\u00e4mmerer",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11276",
        "NAME": "Zierotin, Johann Lorenz (1583\u20131619), Truchsess",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11277",
        "NAME": "Zierotin, Ludmila (1595\u20131615)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11278",
        "NAME": "Zierotin, Veronika (1585\u20131625)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1625~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11279",
        "NAME": "Zierotin, Johann Theoderich (1555\u20131599)",
        "DATEOFBIRTH": "1555",
        "DATEOFDEATH": "1599 Okt 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Seelowitz"
    },
    {
        "ID": "11280",
        "NAME": "Zierotin, Wilhelm (1491\u20131547)",
        "DATEOFBIRTH": "1491",
        "DATEOFDEATH": "1547",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11281",
        "NAME": "Zierotin, Johann (1473\u20131531)",
        "DATEOFBIRTH": "1473",
        "DATEOFDEATH": "1531",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11282",
        "NAME": "Zierotin, Johann (1510\u20131558), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1558",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11283",
        "NAME": "Zierotin, Karl (1509\u20131560), Hofkriegsrat",
        "DATEOFBIRTH": "1509",
        "DATEOFDEATH": "1560 Sep 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kolin an der Elbe"
    },
    {
        "ID": "11284",
        "NAME": "Zierotin, Premsel (1500\u20131558)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1558",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11285",
        "NAME": "Zierotin, Johann (1540\u20131608)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11286",
        "NAME": "Zierotin, Premsel (1590\u20131652)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1652 Jan 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11287",
        "NAME": "Zierotin, Premsel (1629\u20131673)",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1673 Feb 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11288",
        "NAME": "Zierotin, Friedrich (1495\u20131543)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11289",
        "NAME": "Zierotin, Johann (1535\u20131583)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1583 Feb 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Brandeis an der Adler"
    },
    {
        "ID": "11290",
        "NAME": "Zierotin, Karl (1564\u20131636), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1564 Sep 14",
        "DATEOFDEATH": "1636 Okt 09",
        "PLACEOFBIRTH": "Brandeis an der Adler",
        "PLACEOFDEATH": "Prerau in M\u00e4hren"
    },
    {
        "ID": "11291",
        "NAME": "Zierotin, Bernhard (1400\u20131457)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1457",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11292",
        "NAME": "Zierotin, Johann (1430\u20131499)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1499 Okt 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11293",
        "NAME": "Zierotin, Peter (1465\u20131528)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11294",
        "NAME": "Zierotin, Bernhard (1435\u20131480)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1480~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11295",
        "NAME": "Zierotin, Wenzel (1470\u20131534)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1534 Mai 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11296",
        "NAME": "Zierotin, Paul (1500\u20131549)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1549 Apr 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11297",
        "NAME": "Zierotin, Theoderich (1540\u20131596), Vorschneider",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11298",
        "NAME": "Zierotin, Friedrich (1530\u20131598), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1598 Mai 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11299",
        "NAME": "Kazanowski, Adam (1599\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1649 Dez 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Warszawa"
    },
    {
        "ID": "11300",
        "NAME": "Habsburg, Maria Anna (1634\u20131696), K\u00f6nigin von Spanien",
        "DATEOFBIRTH": "1634 Dez 23",
        "DATEOFDEATH": "1696 Mai 16",
        "PLACEOFBIRTH": "Neustadt im Steinfeld",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "11301",
        "NAME": "Praschma von Bilkau, Johann Bernhard (1603\u20131668)",
        "DATEOFBIRTH": "1603",
        "DATEOFDEATH": "1668 Dez 22",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": "Rybnik in Schlesien"
    },
    {
        "ID": "11302",
        "NAME": "Praschma von Bilkau, Karl Ferdinand (1634\u20131677)",
        "DATEOFBIRTH": "1634",
        "DATEOFDEATH": "1677",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11303",
        "NAME": "Praschma von Bilkau, Johann Moritz (1635\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11304",
        "NAME": "Glauchau, Anna (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11305",
        "NAME": "De Witte von Lilienthal, Johann (1583\u20131630), Hofdiener",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1630 Sep 11",
        "PLACEOFBIRTH": "Antwerpen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11306",
        "NAME": "Seeau, Thomas (1490\u20131586)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "Goisern am Hallst\u00e4ttersee",
        "PLACEOFDEATH": "Goisern am Hallst\u00e4ttersee"
    },
    {
        "ID": "11307",
        "NAME": "Seeau, Wolfgang (1530\u20131592)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1592 Feb 02",
        "PLACEOFBIRTH": "Goisern am Hallst\u00e4ttersee",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "11308",
        "NAME": "Seeau, Thomas (1580\u20131643)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1643 Nov 12",
        "PLACEOFBIRTH": "Goisern am Hallst\u00e4ttersee",
        "PLACEOFDEATH": "Ebenzweier"
    },
    {
        "ID": "11309",
        "NAME": "Seeau, Achaz (1530\u20131600)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1600~",
        "PLACEOFBIRTH": "Goisern am Hallst\u00e4ttersee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11310",
        "NAME": "Stadion, Johann Kaspar (1567\u20131641), Hochmeister des Deutschen Ordens",
        "DATEOFBIRTH": "1567 Dez 21",
        "DATEOFDEATH": "1641 Nov 21",
        "PLACEOFBIRTH": "Belfort im Sundgau",
        "PLACEOFDEATH": "Ammern im Unstruttal"
    },
    {
        "ID": "11311",
        "NAME": "Strein von Schwarzenau, Richard (1538\u20131600), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1538 Nov 09",
        "DATEOFDEATH": "1600 Nov 08",
        "PLACEOFBIRTH": "Hartenstein in der Wachau",
        "PLACEOFDEATH": "Freidegg"
    },
    {
        "ID": "11312",
        "NAME": "Schmalz, Peter Abel (1610\u20131650), Hofkriegsratssekret\u00e4r",
        "DATEOFBIRTH": "1610 Dez 21",
        "DATEOFDEATH": "1650~",
        "PLACEOFBIRTH": "\u00d6rebro",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "11313",
        "NAME": "Knillenberg, Johann Philipp (1590\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Reichenbach in Tirol",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11314",
        "NAME": "Vischer von Ramprechtstorff, Johann Friedrich (1600\u20131639), Hofkriegsratssekret\u00e4r",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Reinprechtsdorf am Hundsturm",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11315",
        "NAME": "Fellner von Feldegg, Matthias (1580\u20131637), M\u00fcnzmeister in Wien",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1637 Sep 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sankt Margareten an der Wien"
    },
    {
        "ID": "11316",
        "NAME": "Fellner von Feldegg, Helena (1614\u20131680)",
        "DATEOFBIRTH": "1614 Mai 04",
        "DATEOFDEATH": "1680 Aug 06",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Sankt Margareten an der Wien"
    },
    {
        "ID": "11317",
        "NAME": "Schmid von Schwarzenhorn, Polyxena (1649\u20131727)",
        "DATEOFBIRTH": "1649",
        "DATEOFDEATH": "1727",
        "PLACEOFBIRTH": "Sankt Margareten an der Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11318",
        "NAME": "Schmid von Schwarzenhorn, Anna (1648\u20131733)",
        "DATEOFBIRTH": "1648",
        "DATEOFDEATH": "1733 Jan 22",
        "PLACEOFBIRTH": "Sankt Margareten an der Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11319",
        "NAME": "Seeau, Johann Maximilian (1623\u20131683), Hofkammerrat",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1683 Feb 13",
        "PLACEOFBIRTH": "M\u00fchlleiten an der Traun",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11320",
        "NAME": "Vischer von Ramprechtstorff, Franz Heinrich (1635\u20131672)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "Reinprechtsdorf am Hundsturm",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11321",
        "NAME": "Seeau, Johann Ehrenreich (1615\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "M\u00fchlleiten an der Traun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11322",
        "NAME": "Seeau, Johann Achaz (1620\u20131673)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1673",
        "PLACEOFBIRTH": "M\u00fchlleiten an der Traun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11323",
        "NAME": "Seeau, Sebastian (1560\u20131622), Hofbuchhalter",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1622",
        "PLACEOFBIRTH": "Goisern am Hallst\u00e4ttersee",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11324",
        "NAME": "Seeau, Michael (1565\u20131629)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Goisern am Hallst\u00e4ttersee",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11325",
        "NAME": "Kielmann von Kielmansegg, Arnold (1560\u20131627)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1627 Nov 14",
        "PLACEOFBIRTH": "Hattingen an der Ruhr",
        "PLACEOFDEATH": "Hattingen an der Ruhr"
    },
    {
        "ID": "11326",
        "NAME": "Kielmann von Kielmansegg, Heinrich (1586\u20131659), Hofkammerrat",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1659 Jan 25",
        "PLACEOFBIRTH": "Hattingen an der Ruhr",
        "PLACEOFDEATH": "Wien:Peterskirche"
    },
    {
        "ID": "11327",
        "NAME": "Kielmann von Kielmansegg, Johann Baptist (1590\u20131641), Hofkriegsratssekret\u00e4r",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1641 Jun 10",
        "PLACEOFBIRTH": "Hattingen an der Ruhr",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "11328",
        "NAME": "Mosm\u00fcller, Franz (1610\u2013\u00a0\u00a0\u00a0\u00a0), Hofkriegsratssekret\u00e4r",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11329",
        "NAME": "Wittmer, Ferdinand (1615\u2013\u00a0\u00a0\u00a0\u00a0), Hofkriegsratssekret\u00e4r",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11330",
        "NAME": "Habsburg, Margarita (1651\u20131673), Kaiserin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1651 Jul 12",
        "DATEOFDEATH": "1673 Mar 12",
        "PLACEOFBIRTH": "Madrid",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11331",
        "NAME": "Gallenfels, Jakob Siegmund (1640\u20131697)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1697 Nov 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11333",
        "NAME": "Usseri, Franz (1615\u2013\u00a0\u00a0\u00a0\u00a0), Hofkriegsratssekret\u00e4r",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11334",
        "NAME": "Zeller von Rastenberg, Michael (1560\u20131619), Hofkammerrat",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rastenberg im Waldviertel"
    },
    {
        "ID": "11335",
        "NAME": "Eibiswald, Siegmund (1540\u20131607)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "Burgstall an der Sulm",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11336",
        "NAME": "Eibiswald, Christoph Ferdinand (1585\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Burgstall an der Sulm",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11337",
        "NAME": "Eibiswald, Johann Siegmund (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Burgstall an der Sulm",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11338",
        "NAME": "Eibiswald, Georg Amalrich (1595\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "Burgstall an der Sulm",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11339",
        "NAME": "Zeller, Georg (1580\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11340",
        "NAME": "Habsburg, Antonia (1669\u20131692), Herzogin in Bayern",
        "DATEOFBIRTH": "1669 Jan 18",
        "DATEOFDEATH": "1692 Dez 24",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "11341",
        "NAME": "G\u00f6tzen, Margarita (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Zehlendorf an der Oberhavel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11342",
        "NAME": "Kl\u00f6den, Georg (1593\u20131648)",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1648",
        "PLACEOFBIRTH": "Kl\u00e4den in der Altmark",
        "PLACEOFDEATH": "Detershagen im Jerichower Land"
    },
    {
        "ID": "11343",
        "NAME": "Kl\u00f6den, Peter Hildemar (1625\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Detershagen im Jerichower Land",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11344",
        "NAME": "Gera, Maria Eleonora (1665\u20131691)",
        "DATEOFBIRTH": "1665~",
        "DATEOFDEATH": "1691 Jul 18",
        "PLACEOFBIRTH": "Eschelberg",
        "PLACEOFDEATH": "M\u00fchlleiten an der Traun"
    },
    {
        "ID": "11345",
        "NAME": "Gera, Maria Barbara (1670\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1670~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Eschelberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11346",
        "NAME": "Schenk von Limpurg, Heinrich (1573\u20131637), Reichshofrat",
        "DATEOFBIRTH": "1573 Jan 22",
        "DATEOFDEATH": "1637 Mai 13",
        "PLACEOFBIRTH": "Sontheim im B\u00fchlertal",
        "PLACEOFDEATH": "Sontheim im B\u00fchlertal"
    },
    {
        "ID": "11347",
        "NAME": "Zedlitz, Lassel (1563\u20131628)",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "1628 Dez 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Gr\u00fc\u00dfau an der Zieder"
    },
    {
        "ID": "11348",
        "NAME": "W\u00fcrzburger, Johann Karl (1610\u20131681), Reichsvizekanzler",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1681",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11349",
        "NAME": "Zinzendorf, Georg Christoph (1580\u20131616)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11350",
        "NAME": "Wittelsbach, Joseph Ferdinand (1692\u20131699), F\u00fcrst von Asturien",
        "DATEOFBIRTH": "1692 Okt 28",
        "DATEOFDEATH": "1699 Feb 06",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Br\u00fcssel:Kathedrale"
    },
    {
        "ID": "11351",
        "NAME": "Strein von Schwarzenau, Gotthard (1495\u20131548), Hofdiener",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "Hartenstein in der Wachau",
        "PLACEOFDEATH": "Haselbach im Waldviertel"
    },
    {
        "ID": "11352",
        "NAME": "Strein von Schwarzenau, Gabriel (1536\u20131598), Reichshofrat",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Hartenstein in der Wachau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11354",
        "NAME": "Schmid von Obernburg, Johann (1486\u20131552)",
        "DATEOFBIRTH": "1486",
        "DATEOFDEATH": "1552 Jun 23",
        "PLACEOFBIRTH": "Obernburg am Main",
        "PLACEOFDEATH": "Villach in K\u00e4rnten"
    },
    {
        "ID": "11355",
        "NAME": "Schmid von Obernburg, Peter (1490\u20131552)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1552 Mar 16",
        "PLACEOFBIRTH": "Obernburg am Main",
        "PLACEOFDEATH": "Obernburg am Main"
    },
    {
        "ID": "11356",
        "NAME": "Schmid von Obernburg, Peter (1530\u20131588), Reichshofrat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1588 Nov 17",
        "PLACEOFBIRTH": "Obernburg am Main",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11357",
        "NAME": "Butler, Walter (1600\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1634 Dez 25",
        "PLACEOFBIRTH": "Roscrea",
        "PLACEOFDEATH": "Schorndorf im Remstal"
    },
    {
        "ID": "11358",
        "NAME": "Geraldine, Ruprecht (1600\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Dublin",
        "PLACEOFDEATH": "Lobe\u010d"
    },
    {
        "ID": "11359",
        "NAME": "Ihlow, Christian (1585\u20131634)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1634 Feb 25",
        "PLACEOFBIRTH": "Leichholz in der Neumark",
        "PLACEOFDEATH": "Eger in B\u00f6hmen"
    },
    {
        "ID": "11360",
        "NAME": "Martinitz, Jaroslaus (1549\u20131581), K\u00e4mmerer",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1581",
        "PLACEOFBIRTH": "Smetschna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11361",
        "NAME": "Wratislaw von Mitrowitz, Barzel (1565\u20131610)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1610~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11362",
        "NAME": "Wratislaw von Mitrowitz, Johann Sidonius (1595\u20131655), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1655~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11363",
        "NAME": "Wratislaw von Mitrowitz, Hartwig (1580\u20131624), K\u00e4mmerer",
        "DATEOFBIRTH": "1580",
        "DATEOFDEATH": "1624 Mar 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11364",
        "NAME": "Wratislaw von Mitrowitz, Johann (1460\u20131520)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1520 Feb 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Dob\u0159any"
    },
    {
        "ID": "11365",
        "NAME": "Wratislaw von Mitrowitz, Barzel (1490\u20131543)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11366",
        "NAME": "Wratislaw von Mitrowitz, Johann (1530\u20131581)",
        "DATEOFBIRTH": "1530",
        "DATEOFDEATH": "1581 Jul 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11367",
        "NAME": "Wratislaw von Mitrowitz, Sidonius (1578\u20131641), K\u00e4mmerer",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1641",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11368",
        "NAME": "Wratislaw von Mitrowitz, Franz Christoph (1640\u20131689), Geheimer Rat",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1689 Mai 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11369",
        "NAME": "Wratislaw von Mitrowitz, Johann Wenzel (1669\u20131712)",
        "DATEOFBIRTH": "1669 Nov 25",
        "DATEOFDEATH": "1712 Dez 05",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11370",
        "NAME": "Wittelsbach, Ludwig (1229\u20131294)",
        "DATEOFBIRTH": "1229",
        "DATEOFDEATH": "1294",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11371",
        "NAME": "Wittelsbach, Rudolf (1274\u20131319)",
        "DATEOFBIRTH": "1274",
        "DATEOFDEATH": "1319",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11372",
        "NAME": "Berka von der Duba, Heinrich (1360\u20131404)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1404",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11373",
        "NAME": "Berka von der Duba, Ignaz (1390\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11374",
        "NAME": "Berka von der Duba, Heinrich (1430\u20131470)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1470",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11375",
        "NAME": "Berka von der Duba, Georg (1460\u20131514)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1514",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11376",
        "NAME": "Berka von der Duba, Christoph (1500\u20131555)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1555",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11377",
        "NAME": "Berka von der Duba, Heinrich (1530\u20131601)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1601",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11378",
        "NAME": "Berka von der Duba, Heinrich (1560\u20131609)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11379",
        "NAME": "Berka von der Duba, Georg (1565\u20131618)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11380",
        "NAME": "Berka von der Duba, Heinrich (1490\u20131541)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1541 Jan 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11381",
        "NAME": "Berka von der Duba, Sidonius (1520\u20131572), Mundschenk",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1572 Sep 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11382",
        "NAME": "Berka von der Duba, Wenzel (1554\u20131608)",
        "DATEOFBIRTH": "1554",
        "DATEOFDEATH": "1608 Jul 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11383",
        "NAME": "Berka von der Duba, Sbigneus (1518\u20131578), Gro\u00dfprior des Malteserordens in B\u00f6hmen",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1578 Mar 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Reichstadt in B\u00f6hmen"
    },
    {
        "ID": "11384",
        "NAME": "Wratislaw von Mitrowitz, Johann (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11385",
        "NAME": "Wratislaw von Mitrowitz, Wenzel (1565\u20131612)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11386",
        "NAME": "Wratislaw von Mitrowitz, Georg (1596\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1639 Jun 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11387",
        "NAME": "Wratislaw von Mitrowitz, Sebastian (1550\u20131586)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11388",
        "NAME": "Wratislaw von Mitrowitz, Niklas (1580\u20131628)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11389",
        "NAME": "Wratislaw von Mitrowitz, Dionys (1615\u20131677)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1677",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11390",
        "NAME": "Lang von Langenfels, Philipp (1560\u20131609), Kammerdiener",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11391",
        "NAME": "Racknitz, Gall (1590\u20131658), K\u00e4mmerer",
        "DATEOFBIRTH": "1590 Mai 12",
        "DATEOFDEATH": "1658 Mar 25",
        "PLACEOFBIRTH": "Sankt Ulrich in der Steiermark",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "11392",
        "NAME": "Wittelsbach, Adolf (1300\u20131327)",
        "DATEOFBIRTH": "1300",
        "DATEOFDEATH": "1327",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11393",
        "NAME": "Berka von der Duba, Wenzel (1400\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11394",
        "NAME": "Berka von der Duba, Alexander (1430\u20131481)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1481",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11395",
        "NAME": "Berka von der Duba, Georg (1460\u20131522)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1522",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11396",
        "NAME": "Berka von der Duba, Alexander (1495\u20131544)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1544",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11397",
        "NAME": "Berka von der Duba, Adam (1530\u20131583)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1583",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11398",
        "NAME": "Berka von der Duba, Wenzel (1570\u20131625)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1625",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11399",
        "NAME": "Notthafft, Wilhelm (1575\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1633 Jan 17",
        "PLACEOFBIRTH": "Aholming in der Isarau",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "11400",
        "NAME": "Habsburg, Albrecht (1188\u20131239), Landgraf im Elsass",
        "DATEOFBIRTH": "1188",
        "DATEOFDEATH": "1239 Dez 13",
        "PLACEOFBIRTH": "Habsburg im Aargau",
        "PLACEOFDEATH": "Askalon"
    },
    {
        "ID": "11401",
        "NAME": "Lockher, Georg (1590\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerregistrator",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11402",
        "NAME": "Metzhofen, Johann (1600\u20131647), Hofkammerregistrator",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1647 Aug 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11403",
        "NAME": "Melmeck, Johann (1610\u20131658), Hofkammerregistrator",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11404",
        "NAME": "Melmeck, Theoderich (1657\u20131700), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1657",
        "DATEOFDEATH": "1700",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11405",
        "NAME": "Kurtz von Senftenau, Engelhard (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Feldkirch in Vorarlberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11406",
        "NAME": "Kurtz von Senftenau, Rudolf Heinrich (1580\u20131623)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11407",
        "NAME": "Kurtz von Senftenau, Karl (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Feldkirch in Vorarlberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11408",
        "NAME": "Kurtz von Senftenau, Maximilian (1595\u20131662)",
        "DATEOFBIRTH": "1595",
        "DATEOFDEATH": "1662 Jul 10",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "11409",
        "NAME": "Kurtz von Senftenau, Sebastian (1508\u20131568), Hofdiener",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "1568",
        "PLACEOFBIRTH": "Niederdorf im Pustertal",
        "PLACEOFDEATH": "Lindau im Bodensee"
    },
    {
        "ID": "11410",
        "NAME": "Kurtz von Senftenau, Johann Jakob (1583\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11411",
        "NAME": "Kurtz von Senftenau, Jakob (1553\u20131594), Geheimer Rat",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1594 Mar 11",
        "PLACEOFBIRTH": "Feldkirch in Vorarlberg",
        "PLACEOFDEATH": "Prag:Thomaskirche"
    },
    {
        "ID": "11412",
        "NAME": "Kurtz von Senftenau, Philipp (1555\u20131643)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Feldkirch in Vorarlberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11413",
        "NAME": "Tauber, Johann Siegmund (1610\u20131648), Hofkammerkonzipist",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1648 Feb 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11414",
        "NAME": "Gleth, Christoph Jakob (1610\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerkonzipist",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11415",
        "NAME": "Askanien, Albrecht (1100\u20131170), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1100~",
        "DATEOFDEATH": "1170 Nov 18",
        "PLACEOFBIRTH": "Ballenstedt im Harz",
        "PLACEOFDEATH": "Stendal in der Altmark"
    },
    {
        "ID": "11416",
        "NAME": "Askanien, Otto (1128\u20131184), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1128",
        "DATEOFDEATH": "1184 Mar 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lehnin in der Zauche:Klosterkirche"
    },
    {
        "ID": "11417",
        "NAME": "Askanien, Otto (1160\u20131205), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1160~",
        "DATEOFDEATH": "1205 Jul 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11418",
        "NAME": "Askanien, Albrecht (1171\u20131220), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1171 Jan 01",
        "DATEOFDEATH": "1220 Feb 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lehnin in der Zauche:Klosterkirche"
    },
    {
        "ID": "11419",
        "NAME": "Wagner, Georg (1600\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11420",
        "NAME": "Papierer, Johann Ulrich (1570\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11421",
        "NAME": "Papierer, Susanna (1600\u20131632)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11422",
        "NAME": "Kielmann von Kielmansegg, Susanna (1625\u20131675)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1675 Jun 27",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11423",
        "NAME": "Kielmann von Kielmansegg, Ulrich (1629\u20131676)",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1676 Aug 02",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Speyer"
    },
    {
        "ID": "11424",
        "NAME": "Valmarana, Leonhard (1548\u20131613)",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1613 Nov 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Vicenza"
    },
    {
        "ID": "11425",
        "NAME": "Maschwander von Schwanau, Ulrich (1540\u20131600)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1600~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11426",
        "NAME": "Haim von Reichenstein, Christoph (1517\u20131571), Hofkammerrat",
        "DATEOFBIRTH": "1517 Jan 31",
        "DATEOFDEATH": "1571 Jun 06",
        "PLACEOFBIRTH": "Seckau im Murtal",
        "PLACEOFDEATH": "Reichenstein im M\u00fchlviertel"
    },
    {
        "ID": "11427",
        "NAME": "Haim von Reichenstein, Johann (1544\u20131616), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1544 Feb 12",
        "DATEOFDEATH": "1616 Apr 19",
        "PLACEOFBIRTH": "Reichenstein im M\u00fchlviertel",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "11428",
        "NAME": "Paradis de Lasaga, Johann (1550\u2013\u00a0\u00a0\u00a0\u00a0), Vorschneider",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11429",
        "NAME": "Paradis de Lasaga, Leopold (1595\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11430",
        "NAME": "Grundemann von Falkenberg, Konstantin (1582\u20131658)",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11431",
        "NAME": "Grundemann von Falkenberg, Adam Anton (1624\u20131711), Geheimer Rat",
        "DATEOFBIRTH": "1624",
        "DATEOFDEATH": "1711",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11432",
        "NAME": "Grundemann von Falkenberg, Ernst Konstantin (1653\u20131702)",
        "DATEOFBIRTH": "1653",
        "DATEOFDEATH": "1702",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11433",
        "NAME": "Grundemann von Falkenberg, Georg Konstantin (1623\u20131691), Hofkammerrat",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1691",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11434",
        "NAME": "Grundemann von Falkenberg, Johann Erasam (1630\u20131663)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wilhering"
    },
    {
        "ID": "11435",
        "NAME": "Grundemann von Falkenberg, Susanna Franziska (1689\u20131748)",
        "DATEOFBIRTH": "1689",
        "DATEOFDEATH": "1748",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11436",
        "NAME": "Welz, Konrad (1245\u20131305)",
        "DATEOFBIRTH": "1245~",
        "DATEOFDEATH": "1305~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11437",
        "NAME": "Welz, Konrad (1285\u20131334)",
        "DATEOFBIRTH": "1285~",
        "DATEOFDEATH": "1334",
        "PLACEOFBIRTH": "Winklern in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11438",
        "NAME": "Welz, Wolfgang (1280\u20131345)",
        "DATEOFBIRTH": "1280~",
        "DATEOFDEATH": "1345 Feb 07",
        "PLACEOFBIRTH": "Winklern in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11439",
        "NAME": "Welz, Christoph (1320\u20131372)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "1372",
        "PLACEOFBIRTH": "Mitterdorf im Katschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11440",
        "NAME": "Welz, Moritz (1360\u20131428), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1428",
        "PLACEOFBIRTH": "Mitterdorf im Katschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11441",
        "NAME": "Welz, Moritz (1400\u20131462)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1462 Feb 04",
        "PLACEOFBIRTH": "Mitterdorf im Katschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11442",
        "NAME": "Welz, Georg (1440\u20131488)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1488",
        "PLACEOFBIRTH": "Eberstein in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11443",
        "NAME": "Welz, Christoph (1470\u20131539)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1539 Okt 25",
        "PLACEOFBIRTH": "Eberstein in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11444",
        "NAME": "Welz, Moritz (1500\u20131555)",
        "DATEOFBIRTH": "1500",
        "DATEOFDEATH": "1555 Sep 23",
        "PLACEOFBIRTH": "Eberstein in K\u00e4rnten",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11445",
        "NAME": "Welz, Christoph (1530\u20131566)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1566 Sep 21",
        "PLACEOFBIRTH": "Frauenstein in K\u00e4rnten",
        "PLACEOFDEATH": "Radkersburg"
    },
    {
        "ID": "11446",
        "NAME": "Welz, Veit Christoph (1567\u20131586)",
        "DATEOFBIRTH": "1567 Mai 30",
        "DATEOFDEATH": "1586 Nov 06",
        "PLACEOFBIRTH": "Frauenstein in K\u00e4rnten",
        "PLACEOFDEATH": "Basel"
    },
    {
        "ID": "11447",
        "NAME": "Welz, Maria Magdalena (1554\u20131642)",
        "DATEOFBIRTH": "1554",
        "DATEOFDEATH": "1642 Jun 03",
        "PLACEOFBIRTH": "Frauenstein in K\u00e4rnten",
        "PLACEOFDEATH": "N\u00fcrnberg:Johannisfriedhof"
    },
    {
        "ID": "11448",
        "NAME": "Welz, Veit (1452\u20131540), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1452",
        "DATEOFDEATH": "1540 Mai 24",
        "PLACEOFBIRTH": "Eberstein in K\u00e4rnten",
        "PLACEOFDEATH": "Stra\u00dfburg in K\u00e4rnten:Nikolauskirche"
    },
    {
        "ID": "11449",
        "NAME": "Scherer von Hohenkreuzberg, Johann (1620\u20131691)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1691 Mar 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11450",
        "NAME": "Hohenzollern, Friedrich (1139\u20131201), Burggraf von N\u00fcrnberg",
        "DATEOFBIRTH": "1139",
        "DATEOFDEATH": "1201 Jun 24",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "11451",
        "NAME": "Hohenzollern, Friedrich (1188\u20131255)",
        "DATEOFBIRTH": "1188",
        "DATEOFDEATH": "1255",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Hechingen"
    },
    {
        "ID": "11452",
        "NAME": "Hohenzollern, Friedrich (1220\u20131289)",
        "DATEOFBIRTH": "1220~",
        "DATEOFDEATH": "1289 Mai 24",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Hechingen"
    },
    {
        "ID": "11453",
        "NAME": "Hohenzollern, Friedrich (1250\u20131298)",
        "DATEOFBIRTH": "1250~",
        "DATEOFDEATH": "1298 Mai 04",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Hechingen"
    },
    {
        "ID": "11454",
        "NAME": "Hohenzollern, Friedrich (1280\u20131333)",
        "DATEOFBIRTH": "1280~",
        "DATEOFDEATH": "1333",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Hechingen"
    },
    {
        "ID": "11455",
        "NAME": "Hohenzollern, Friedrich (1310\u20131365), Domherr in Stra\u00dfburg",
        "DATEOFBIRTH": "1310~",
        "DATEOFDEATH": "1365 Mar 09",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Hechingen"
    },
    {
        "ID": "11456",
        "NAME": "Hohenzollern, Friedrich (1350\u20131401)",
        "DATEOFBIRTH": "1350~",
        "DATEOFDEATH": "1401 Nov 26",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Hechingen"
    },
    {
        "ID": "11457",
        "NAME": "Hohenzollern, Eitel Friedrich (1384\u20131439)",
        "DATEOFBIRTH": "1384",
        "DATEOFDEATH": "1439 Sep 21",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Hechingen"
    },
    {
        "ID": "11458",
        "NAME": "Hohenzollern, Jobst Niklas (1433\u20131488)",
        "DATEOFBIRTH": "1433",
        "DATEOFDEATH": "1488 Feb 09",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "11459",
        "NAME": "Hohenzollern, Eitel Friedrich (1452\u20131512), Obersthofmeister",
        "DATEOFBIRTH": "1452",
        "DATEOFDEATH": "1512 Jun 18",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Trier"
    },
    {
        "ID": "11460",
        "NAME": "Hohenzollern, Eitel Friedrich (1494\u20131525)",
        "DATEOFBIRTH": "1494",
        "DATEOFDEATH": "1525 Jan 15",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Pavia"
    },
    {
        "ID": "11461",
        "NAME": "Hohenzollern, Konrad (1186\u20131261), Burggraf von N\u00fcrnberg",
        "DATEOFBIRTH": "1186",
        "DATEOFDEATH": "1261",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "11462",
        "NAME": "Hohenzollern, Friedrich (1225\u20131297), Burggraf von N\u00fcrnberg",
        "DATEOFBIRTH": "1225~",
        "DATEOFDEATH": "1297 Aug 14",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "Cadolzburg"
    },
    {
        "ID": "11463",
        "NAME": "Hohenzollern, Friedrich (1287\u20131332), Burggraf von N\u00fcrnberg",
        "DATEOFBIRTH": "1287",
        "DATEOFDEATH": "1332 Mai 19",
        "PLACEOFBIRTH": "Cadolzburg",
        "PLACEOFDEATH": "Cadolzburg"
    },
    {
        "ID": "11464",
        "NAME": "Hohenzollern, Johann (1310\u20131357), Burggraf von N\u00fcrnberg",
        "DATEOFBIRTH": "1310~",
        "DATEOFDEATH": "1357 Okt 07",
        "PLACEOFBIRTH": "Cadolzburg",
        "PLACEOFDEATH": "Cadolzburg"
    },
    {
        "ID": "11465",
        "NAME": "Hohenzollern, Friedrich (1332\u20131398), Burggraf von N\u00fcrnberg",
        "DATEOFBIRTH": "1332",
        "DATEOFDEATH": "1398 Jan 22",
        "PLACEOFBIRTH": "Cadolzburg",
        "PLACEOFDEATH": "Kulmbach"
    },
    {
        "ID": "11466",
        "NAME": "Hohenzollern, Friedrich (1371\u20131440), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1371 Aug 06",
        "DATEOFDEATH": "1440 Sep 20",
        "PLACEOFBIRTH": "Cadolzburg",
        "PLACEOFDEATH": "Cadolzburg"
    },
    {
        "ID": "11467",
        "NAME": "Hohenzollern, Friedrich (1413\u20131471), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1413 Nov 19",
        "DATEOFDEATH": "1471 Feb 10",
        "PLACEOFBIRTH": "Tangerm\u00fcnde",
        "PLACEOFDEATH": "Neustadt an der Aisch"
    },
    {
        "ID": "11468",
        "NAME": "Hohenzollern, Albrecht (1414\u20131486), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1414 Nov 24",
        "DATEOFDEATH": "1486 Mar 11",
        "PLACEOFBIRTH": "Tangerm\u00fcnde",
        "PLACEOFDEATH": "Frankfurt am Main"
    },
    {
        "ID": "11469",
        "NAME": "Hohenzollern, Johann (1455\u20131499), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1455 Aug 02",
        "DATEOFDEATH": "1499 Jan 09",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Arneburg"
    },
    {
        "ID": "11470",
        "NAME": "Hohenzollern, Joachim (1484\u20131535), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1484 Feb 21",
        "DATEOFDEATH": "1535 Jul 11",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "Stendal in der Altmark"
    },
    {
        "ID": "11471",
        "NAME": "Hohenzollern, Joachim (1505\u20131571), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1505 Jan 09",
        "DATEOFDEATH": "1571 Jan 03",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "K\u00f6penick"
    },
    {
        "ID": "11472",
        "NAME": "Hohenzollern, Johann Georg (1525\u20131598), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1525 Sep 11",
        "DATEOFDEATH": "1598 Jan 18",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "K\u00f6lln an der Spree"
    },
    {
        "ID": "11473",
        "NAME": "Hohenzollern, Joachim Friedrich (1546\u20131608), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1546 Jan 27",
        "DATEOFDEATH": "1608 Jul 28",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "Gr\u00fcnau an der Dahme"
    },
    {
        "ID": "11474",
        "NAME": "Hohenzollern, Johann Siegmund (1572\u20131620), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1572 Nov 08",
        "DATEOFDEATH": "1620 Jan 02",
        "PLACEOFBIRTH": "Halle an der Saale",
        "PLACEOFDEATH": "K\u00f6lln an der Spree"
    },
    {
        "ID": "11475",
        "NAME": "Hohenzollern, Georg Wilhelm (1595\u20131640), Markgraf von Brandenburg",
        "DATEOFBIRTH": "1595 Nov 13",
        "DATEOFDEATH": "1640 Dez 01",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "K\u00f6nigsberg in Preu\u00dfen"
    },
    {
        "ID": "11476",
        "NAME": "Hohenzollern, Johann Georg (1577\u20131624), Herzog von J\u00e4gerndorf",
        "DATEOFBIRTH": "1577 Dez 16",
        "DATEOFDEATH": "1624 Mar 02",
        "PLACEOFBIRTH": "Wolmirstedt",
        "PLACEOFDEATH": "Leutschau in der Zips"
    },
    {
        "ID": "11477",
        "NAME": "Hohenzollern, Agnes (1584\u20131629)",
        "DATEOFBIRTH": "1584 Jul 27",
        "DATEOFDEATH": "1629 Mar 26",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "Neuhaus an der Elbe"
    },
    {
        "ID": "11478",
        "NAME": "Hohenzollern, Elisabeth (1589\u20131629)",
        "DATEOFBIRTH": "1589 Jul 04",
        "DATEOFDEATH": "1629 Dez 24",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "Frankfurt an der Oder"
    },
    {
        "ID": "11479",
        "NAME": "Hohenzollern, Dorothea (1590\u20131625)",
        "DATEOFBIRTH": "1590 Okt 19",
        "DATEOFDEATH": "1625 Mar 19",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "Brieg"
    },
    {
        "ID": "11480",
        "NAME": "Hohenzollern, Johann (1597\u20131627)",
        "DATEOFBIRTH": "1597 Jul 23",
        "DATEOFDEATH": "1627 Sep 23",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "Steinburg in Holstein"
    },
    {
        "ID": "11481",
        "NAME": "Hohenzollern, Johann Georg (1598\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1598 Aug 14",
        "DATEOFDEATH": "1637 Feb 06",
        "PLACEOFBIRTH": "Crossen an der Oder",
        "PLACEOFDEATH": "Crailsheim"
    },
    {
        "ID": "11482",
        "NAME": "Hohenzollern, Joachim Ernst (1583\u20131625), Landesherr von Ansbach",
        "DATEOFBIRTH": "1583 Jun 22",
        "DATEOFDEATH": "1625 Mar 07",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "Ansbach"
    },
    {
        "ID": "11483",
        "NAME": "Hohenzollern, Christian (1581\u20131655), Landesherr von Kulmbach",
        "DATEOFBIRTH": "1581 Jan 30",
        "DATEOFDEATH": "1655 Mai 30",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "Bayreuth"
    },
    {
        "ID": "11484",
        "NAME": "Hohenzollern, Friedrich (1616\u20131634), Erbprinz von Ansbach",
        "DATEOFBIRTH": "1616 Mai 01",
        "DATEOFDEATH": "1634 Sep 06",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "N\u00f6rdlingen im Ries"
    },
    {
        "ID": "11485",
        "NAME": "Hohenzollern, Erdmann August (1615\u20131651), Erbprinz von Kulmbach",
        "DATEOFBIRTH": "1615 Okt 08",
        "DATEOFDEATH": "1651 Feb 06",
        "PLACEOFBIRTH": "Bayreuth",
        "PLACEOFDEATH": "Hof an der Regnitz"
    },
    {
        "ID": "11486",
        "NAME": "Hohenzollern, Albrecht (1620\u20131667), Landesherr von Ansbach",
        "DATEOFBIRTH": "1620 Sep 18",
        "DATEOFDEATH": "1667 Okt 22",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Ansbach"
    },
    {
        "ID": "11487",
        "NAME": "Hohenzollern, Johann Friedrich (1654\u20131686), Landesherr von Ansbach",
        "DATEOFBIRTH": "1654 Okt 18",
        "DATEOFDEATH": "1686 Apr 01",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Ansbach"
    },
    {
        "ID": "11488",
        "NAME": "Hohenzollern, Christian Ernst (1644\u20131712), Landesherr von Kulmbach",
        "DATEOFBIRTH": "1644 Aug 06",
        "DATEOFDEATH": "1712 Mai 10",
        "PLACEOFBIRTH": "Bayreuth",
        "PLACEOFDEATH": "Erlangen"
    },
    {
        "ID": "11489",
        "NAME": "Hohenzollern, Christian Wilhelm (1587\u20131665), Administrator von Magdeburg",
        "DATEOFBIRTH": "1587 Sep 07",
        "DATEOFDEATH": "1665 Jan 11",
        "PLACEOFBIRTH": "Wolmirstedt",
        "PLACEOFDEATH": "Zinna an der Nuthe"
    },
    {
        "ID": "11490",
        "NAME": "Hohenzollern, Johann (1406\u20131464), Landesherr von Kulmbach",
        "DATEOFBIRTH": "1406",
        "DATEOFDEATH": "1464 Nov 16",
        "PLACEOFBIRTH": "Cadolzburg",
        "PLACEOFDEATH": "Scharfeneck im Regnitzgrund"
    },
    {
        "ID": "11491",
        "NAME": "Hohenzollern, Friedrich (1460\u20131536), Landesherr von Ansbach",
        "DATEOFBIRTH": "1460 Mai 02",
        "DATEOFDEATH": "1536 Apr 04",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Ansbach"
    },
    {
        "ID": "11492",
        "NAME": "Hohenzollern, Kasimir (1481\u20131527), Landesherr von Kulmbach",
        "DATEOFBIRTH": "1481 Sep 27",
        "DATEOFDEATH": "1527 Sep 21",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "11493",
        "NAME": "Hohenzollern, Georg (1484\u20131543), Landesherr von Ansbach",
        "DATEOFBIRTH": "1484 Mar 04",
        "DATEOFDEATH": "1543 Dez 27",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Ansbach"
    },
    {
        "ID": "11494",
        "NAME": "Hohenzollern, Albrecht (1522\u20131557), Landesherr von Kulmbach",
        "DATEOFBIRTH": "1522 Mar 28",
        "DATEOFDEATH": "1557 Jan 08",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Pforzheim"
    },
    {
        "ID": "11495",
        "NAME": "Hohenzollern, Georg Friedrich (1539\u20131603), Landesherr von Ansbach",
        "DATEOFBIRTH": "1539 Apr 05",
        "DATEOFDEATH": "1603 Mai 05",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Ansbach"
    },
    {
        "ID": "11496",
        "NAME": "Hohenzollern, Sophia (1614\u20131646)",
        "DATEOFBIRTH": "1614 Jun 10",
        "DATEOFDEATH": "1646 Dez 03",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Bayreuth:Stadtkirche"
    },
    {
        "ID": "11497",
        "NAME": "Hohenzollern, Johann (1369\u20131420), Landesherr von Kulmbach",
        "DATEOFBIRTH": "1369",
        "DATEOFDEATH": "1420 Jun 11",
        "PLACEOFBIRTH": "Cadolzburg",
        "PLACEOFDEATH": "Kulmbach"
    },
    {
        "ID": "11498",
        "NAME": "Hohenzollern, Georg Friedrich (1678\u20131703), Landesherr von Ansbach",
        "DATEOFBIRTH": "1678 Mai 03",
        "DATEOFDEATH": "1703 Mar 29",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Schmidm\u00fchlen an der Vils"
    },
    {
        "ID": "11499",
        "NAME": "Hohenzollern, Wilhelm Friedrich (1686\u20131723), Landesherr von Ansbach",
        "DATEOFBIRTH": "1686 Jan 08",
        "DATEOFDEATH": "1723 Jan 07",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Reichenbach an der Schwabach"
    },
    {
        "ID": "11500",
        "NAME": "Habsburg, Leopold (1586\u20131632), Landesherr von Tirol",
        "DATEOFBIRTH": "1586 Okt 09",
        "DATEOFDEATH": "1632 Sep 13",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Schwaz in Tirol"
    },
    {
        "ID": "11501",
        "NAME": "Sigelstorff, Albrecht (1576\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11502",
        "NAME": "Nie\u00dfer von Steinstra\u00df, Joseph (1570\u2013\u00a0\u00a0\u00a0\u00a0), Hofzahlmeister",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11503",
        "NAME": "Schifer, Ludwig Friedrich (1625\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Freiling in der Traunebene",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11504",
        "NAME": "Traun, Siegmund Adam (1573\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1573 Jan 24",
        "DATEOFDEATH": "1637 Feb 02",
        "PLACEOFBIRTH": "Maissau",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "11505",
        "NAME": "Traun, Ernst (1608\u20131668), Geheimer Rat",
        "DATEOFBIRTH": "1608 Mar 26",
        "DATEOFDEATH": "1668 Nov 18",
        "PLACEOFBIRTH": "Maissau",
        "PLACEOFDEATH": "Bologna"
    },
    {
        "ID": "11506",
        "NAME": "Traun, Ferdinand Ernst (1647\u20131685), K\u00e4mmerer",
        "DATEOFBIRTH": "1647",
        "DATEOFDEATH": "1685 Jan 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11507",
        "NAME": "Traun, Margarita (1649\u20131706)",
        "DATEOFBIRTH": "1649 Jul 13",
        "DATEOFDEATH": "1706 Dez 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11508",
        "NAME": "Eggenberg, Sidonia (1600\u20131650)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1650 Jan 15",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "11509",
        "NAME": "M\u00f6rsperg, Maria Theresia (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11510",
        "NAME": "Puchheim, Adolf (1600\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1639 Nov 15",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11511",
        "NAME": "Schifer, Alexander (1612\u20131661), K\u00e4mmerer",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1661",
        "PLACEOFBIRTH": "Freiling in der Traunebene",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11512",
        "NAME": "Egg von Hungersbach, Heinrich (1425\u20131509)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "1509",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hungersbach in der Krain"
    },
    {
        "ID": "11514",
        "NAME": "Egg von Hungersbach, Georg (1462\u20131531), Landeshauptmann von G\u00f6rz",
        "DATEOFBIRTH": "1462",
        "DATEOFDEATH": "1531",
        "PLACEOFBIRTH": "Hungersbach in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11515",
        "NAME": "Egg von Hungersbach, Johann (1463\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1463",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hungersbach in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11516",
        "NAME": "Egg von Hungersbach, Mang (1493\u20131577), Reichshofrat",
        "DATEOFBIRTH": "1493",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "Hungersbach in der Krain",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11517",
        "NAME": "Egg von Hungersbach, Christoph (1546\u2013\u00a0\u00a0\u00a0\u00a0), Hofkriegsrat",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11518",
        "NAME": "Egg von Hungersbach, Ernst (1557\u20131607), Hofkammerrat",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1607 Dez 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11519",
        "NAME": "Egg von Hungersbach, Christian (1645\u20131706), Geheimer Rat",
        "DATEOFBIRTH": "1645 Aug 18",
        "DATEOFDEATH": "1706 Aug 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hamburg"
    },
    {
        "ID": "11520",
        "NAME": "Egg von Hungersbach, Markward (1570\u20131618), Obersthofmeister",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1618 Mar 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Karlstadt in Kroatien"
    },
    {
        "ID": "11521",
        "NAME": "Egg von Hungersbach, Bonaventura (1500\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hungersbach in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11522",
        "NAME": "Egg von Hungersbach, Hannibal (1530\u20131601)",
        "DATEOFBIRTH": "1530",
        "DATEOFDEATH": "1601",
        "PLACEOFBIRTH": "Hungersbach in der Krain",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11523",
        "NAME": "Egg von Hungersbach, Karl (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11524",
        "NAME": "Egg von Hungersbach, Jakob Ernst (1620\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11525",
        "NAME": "Egg von Hungersbach, Siegmund (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11526",
        "NAME": "Egg von Hungersbach, Christian (1599\u20131675)",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1675 Jan",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "W\u00f6hrd an der Pegnitz"
    },
    {
        "ID": "11527",
        "NAME": "Egg von Hungersbach, Georg Siegmund (1586\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1646 Nov 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ratzenegg in K\u00e4rnten"
    },
    {
        "ID": "11528",
        "NAME": "Egg von Hungersbach, Georg Hannibal (1627\u20131702)",
        "DATEOFBIRTH": "1627 Mar 24",
        "DATEOFDEATH": "1702 Mai 15",
        "PLACEOFBIRTH": "Klagenfurt am W\u00f6rthersee",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "11529",
        "NAME": "Egg von Hungersbach, Franz Joseph (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hungersbach in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11530",
        "NAME": "Egg von Hungersbach, Franziska (1681\u20131739)",
        "DATEOFBIRTH": "1681",
        "DATEOFDEATH": "1739 Mar 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11531",
        "NAME": "Isenburg, Salentin (1532\u20131610), Erzbischof von K\u00f6ln",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1610 Mar 19",
        "PLACEOFBIRTH": "Isenburg im Westerwald",
        "PLACEOFDEATH": "Arenfels am Rhein"
    },
    {
        "ID": "11532",
        "NAME": "Isenburg, Ernst (1584\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1664 Mai 30",
        "PLACEOFBIRTH": "Grenzau im Westerwald",
        "PLACEOFDEATH": "Br\u00fcssel:Kathedrale"
    },
    {
        "ID": "11533",
        "NAME": "Isenburg, Salentin (1580\u20131619)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1619 Dez 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11534",
        "NAME": "Drugeth von Homonna, Georg (1555\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Homenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11535",
        "NAME": "Stadl, Erasam (1510\u20131578)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1578 Mai 31",
        "PLACEOFBIRTH": "Stadl an der Raab",
        "PLACEOFDEATH": "Riegersburg in der Steiermark:Martinskirche"
    },
    {
        "ID": "11536",
        "NAME": "Herberstein, Johann (1472\u20131535), Edelknabe",
        "DATEOFBIRTH": "1472",
        "DATEOFDEATH": "1535 Jun 18",
        "PLACEOFBIRTH": "Wippach in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11537",
        "NAME": "Herberstein, Kaspar (1515\u20131572), Obersthofmeister",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1572 Apr 14",
        "PLACEOFBIRTH": "Neuberg am Ringkogel",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "11538",
        "NAME": "Herberstein, Johann Siegmund (1555\u20131611), Hofkriegsrat",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "Neuberg am Ringkogel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11539",
        "NAME": "Herberstein, Johann Albrecht (1590\u2013\u00a0\u00a0\u00a0\u00a0), Hofkriegsrat",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neuberg am Ringkogel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11540",
        "NAME": "Manlich, Simon (1470\u20131517)",
        "DATEOFBIRTH": "1470",
        "DATEOFDEATH": "1517 Jul 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "11541",
        "NAME": "Manlich, Melchior (1513\u20131576)",
        "DATEOFBIRTH": "1513",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Freudenberg in der Oberpfalz"
    },
    {
        "ID": "11542",
        "NAME": "Manlich, Matthias (1499\u20131559)",
        "DATEOFBIRTH": "1499 Mar 02",
        "DATEOFDEATH": "1559 Jan 16",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11543",
        "NAME": "Manlich, Magdalena (1503\u20131563)",
        "DATEOFBIRTH": "1503",
        "DATEOFDEATH": "1563",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11544",
        "NAME": "Manlich, Simon (1508\u20131547)",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "1547",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11545",
        "NAME": "Liebenthal, Peter (1580\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Soldin in der Neumark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11546",
        "NAME": "Altensteig, Adam (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofsekret\u00e4r",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11547",
        "NAME": "Hueber, Jakob (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11548",
        "NAME": "Herberstein, Johann Kaspar (1585\u20131628), Mundschenk",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "Neuberg am Ringkogel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11549",
        "NAME": "Drugeth von Homonna, Georg (1583\u20131620)",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1620 Jun 21",
        "PLACEOFBIRTH": "Homenau",
        "PLACEOFDEATH": "Tyrnau"
    },
    {
        "ID": "11550",
        "NAME": "Go\u00ebss, Damian (1502\u20131574)",
        "DATEOFBIRTH": "1502 Feb 02",
        "DATEOFDEATH": "1574 Jan 30",
        "PLACEOFBIRTH": "Alenquer",
        "PLACEOFDEATH": "Alcoba\u00e7a"
    },
    {
        "ID": "11551",
        "NAME": "Go\u00ebss, Emanuel (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "L\u00f6wen in Brabant",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11552",
        "NAME": "Go\u00ebss, Franz (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "L\u00f6wen in Brabant",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11553",
        "NAME": "Go\u00ebss, Anton (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11554",
        "NAME": "Go\u00ebss, Peter (1667\u20131716), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1667 Mar 23",
        "DATEOFDEATH": "1716 Mar 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Klagenfurt am W\u00f6rthersee"
    },
    {
        "ID": "11555",
        "NAME": "Zinzendorf, Christoph (1460\u20131535), Oberstj\u00e4germeister",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1535",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11556",
        "NAME": "Zinzendorf, Stephan (1490\u20131548)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11557",
        "NAME": "Zinzendorf, Johann Adam (1520\u20131562)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1562",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11558",
        "NAME": "Zinzendorf, Johann Christoph (1550\u20131591)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1591",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11559",
        "NAME": "Zinzendorf, Johann (1507\u20131552)",
        "DATEOFBIRTH": "1507",
        "DATEOFDEATH": "1552 Okt 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11560",
        "NAME": "Zinzendorf, Johann Friedrich (1546\u20131600)",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1600",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Gresten"
    },
    {
        "ID": "11561",
        "NAME": "Zinzendorf, Georg Christian (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11562",
        "NAME": "Zinzendorf, Alexander (1541\u20131577)",
        "DATEOFBIRTH": "1541 Jan 09",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Gresten"
    },
    {
        "ID": "11563",
        "NAME": "Czernczitzky von Katzowa, Johann (1520\u20131561)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1561 Jan 22",
        "PLACEOFBIRTH": "Neustadt an der Mettau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11564",
        "NAME": "Czernczitzky von Katzowa, Johann Burkhard (1550\u20131585), Truchsess",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1585 Apr 07",
        "PLACEOFBIRTH": "Neustadt an der Mettau",
        "PLACEOFDEATH": "Chropyn\u011b"
    },
    {
        "ID": "11565",
        "NAME": "Zahradek, Wenzel (1595\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1647 Aug 21",
        "PLACEOFBIRTH": "Rottowitz",
        "PLACEOFDEATH": "Pilsen"
    },
    {
        "ID": "11566",
        "NAME": "Sch\u00f6nfeld, Niklas (1588\u20131663), Hofkriegsrat",
        "DATEOFBIRTH": "1588 Apr 06",
        "DATEOFDEATH": "1663 Jan 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11567",
        "NAME": "Sch\u00f6nfeld, Rudolf (1627\u20131684)",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1684 Aug 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Setsch im Eisengebirge"
    },
    {
        "ID": "11568",
        "NAME": "Sch\u00f6nfeld, Polyxena (1638\u20131694)",
        "DATEOFBIRTH": "1638",
        "DATEOFDEATH": "1694 Dez 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11569",
        "NAME": "Sch\u00f6nfeld, Joseph Franz (1668\u20131737)",
        "DATEOFBIRTH": "1668 Sep 04",
        "DATEOFDEATH": "1737 Feb 18",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Zaje\u010dice"
    },
    {
        "ID": "11570",
        "NAME": "Schlick, Hieronym (1494\u20131551)",
        "DATEOFBIRTH": "1494",
        "DATEOFDEATH": "1551 Jun 12",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11571",
        "NAME": "Schlick, Joachim (1520\u20131572)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1572 Jan 05",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11572",
        "NAME": "Schlick, Ludwig (1545\u20131575)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1575",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11573",
        "NAME": "Schlick, Joachim Andreas (1569\u20131621), Edelknabe",
        "DATEOFBIRTH": "1569 Sep 09",
        "DATEOFDEATH": "1621 Jun 21",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11574",
        "NAME": "Zierotin, Angela (1625\u20131695)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1695",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11575",
        "NAME": "Michna von Waizenhofen, Wenzel (1610\u20131667)",
        "DATEOFBIRTH": "1610",
        "DATEOFDEATH": "1667 Mai 21",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11576",
        "NAME": "Michna von Waizenhofen, Polyxena (1614\u20131650)",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11577",
        "NAME": "Tschirnhaus, Friedrich (1575\u20131614), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1614",
        "PLACEOFBIRTH": "Mittelwalde in Schlesien",
        "PLACEOFDEATH": "Sch\u00f6nfeld an der Nei\u00dfe"
    },
    {
        "ID": "11578",
        "NAME": "Annenberg, Karl Heinrich (1625\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11579",
        "NAME": "Annenberg, Johann Arbogast (1630\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11580",
        "NAME": "Boskowitz von Schwarzenberg, Johann (1530\u20131597), Truchsess",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1597 Apr 30",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren:Minoritenkloster"
    },
    {
        "ID": "11581",
        "NAME": "Boskowitz von Schwarzenberg, Anna (1575\u20131625)",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1625 Jun 06",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Blumenau in M\u00e4hren"
    },
    {
        "ID": "11582",
        "NAME": "Boskowitz von Schwarzenberg, Katharina (1579\u20131637)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1637 Jan 24",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Butschowitz in M\u00e4hren"
    },
    {
        "ID": "11583",
        "NAME": "Paczensky von Tenczin, Wenzel (1595\u20131661)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1661 Sep 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11584",
        "NAME": "Podiebrad, Georg (1420\u20131471), K\u00f6nig von B\u00f6hmen",
        "DATEOFBIRTH": "1420 Apr 23",
        "DATEOFDEATH": "1471 Mar 22",
        "PLACEOFBIRTH": "Podiebrad",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11585",
        "NAME": "Podiebrad, Heinrich (1448\u20131498), Landeshauptmann von B\u00f6hmen",
        "DATEOFBIRTH": "1448 Mai 15",
        "DATEOFDEATH": "1498 Jun 24",
        "PLACEOFBIRTH": "Podiebrad",
        "PLACEOFDEATH": "Glatz"
    },
    {
        "ID": "11586",
        "NAME": "Podiebrad, Karl (1476\u20131536), Landeshauptmann von B\u00f6hmen",
        "DATEOFBIRTH": "1476 Mai 04",
        "DATEOFDEATH": "1536 Mai 31",
        "PLACEOFBIRTH": "Glatz",
        "PLACEOFDEATH": "Frankenstein in Schlesien"
    },
    {
        "ID": "11587",
        "NAME": "Podiebrad, Heinrich (1507\u20131548), Landesherr von Bernstadt",
        "DATEOFBIRTH": "1507 Mar 29",
        "DATEOFDEATH": "1548 Aug 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bernstadt an der Weide"
    },
    {
        "ID": "11588",
        "NAME": "Podiebrad, Karl (1545\u20131617), Oberlandeshauptmann von Schlesien",
        "DATEOFBIRTH": "1545 Apr 15",
        "DATEOFDEATH": "1617 Jan 28",
        "PLACEOFBIRTH": "Oels",
        "PLACEOFDEATH": "Oels"
    },
    {
        "ID": "11589",
        "NAME": "Hase von Hasenburg, Margarita (1557\u20131603)",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "Raudnitz an der Elbe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11590",
        "NAME": "Lobkowicz, Niklas (1390\u20131441)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1441 Mar 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pre\u00dfnitz im Erzgebirge"
    },
    {
        "ID": "11591",
        "NAME": "Lobkowicz, Niklas (1420\u20131462)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1462 Jul 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hassenstein"
    },
    {
        "ID": "11592",
        "NAME": "Lobkowicz, Johann (1450\u20131517)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1517 Jan 28",
        "PLACEOFBIRTH": "Hassenstein",
        "PLACEOFDEATH": "Kaaden an der Eger"
    },
    {
        "ID": "11593",
        "NAME": "Lobkowicz, Niklas (1455\u20131500)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1500",
        "PLACEOFBIRTH": "Hassenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11594",
        "NAME": "Lobkowicz, Bosel (1462\u20131510)",
        "DATEOFBIRTH": "1462",
        "DATEOFDEATH": "1510 Nov 14",
        "PLACEOFBIRTH": "Hassenstein",
        "PLACEOFDEATH": "Hassenstein"
    },
    {
        "ID": "11595",
        "NAME": "Lobkowicz, Wenzel (1490\u20131520)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1520 Jan 06",
        "PLACEOFBIRTH": "Hassenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11596",
        "NAME": "Lobkowicz, Bosel Felix (1517\u20131583)",
        "DATEOFBIRTH": "1517 Jan 13",
        "DATEOFDEATH": "1583 Aug 27",
        "PLACEOFBIRTH": "Hassenstein",
        "PLACEOFDEATH": "Li\u010dkov"
    },
    {
        "ID": "11597",
        "NAME": "Lobkowicz, Bosel Joachim (1546\u20131605), Vorschneider",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1605 Okt 17",
        "PLACEOFBIRTH": "Hassenstein",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11598",
        "NAME": "Trczka von Leipa, Johann (1495\u20131540)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1540 Jul 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11599",
        "NAME": "Trczka von Leipa, Johanna (1540\u20131597)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11600",
        "NAME": "Habsburg, Ferdinand Karl (1628\u20131662), Landesherr von Tirol",
        "DATEOFBIRTH": "1628 Mai 17",
        "DATEOFDEATH": "1662 Dez 30",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Kaltern an der Weinstra\u00dfe"
    },
    {
        "ID": "11601",
        "NAME": "Lannoy, Karl (1482\u20131527)",
        "DATEOFBIRTH": "1482",
        "DATEOFDEATH": "1527 Sep 24",
        "PLACEOFBIRTH": "Valenciennes",
        "PLACEOFDEATH": "Gaeta"
    },
    {
        "ID": "11603",
        "NAME": "Renesse, Renat (1584\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1637 Apr 16",
        "PLACEOFBIRTH": "Warfus\u00e9e",
        "PLACEOFDEATH": "L\u00fcttich"
    },
    {
        "ID": "11604",
        "NAME": "Perrenot de Granvelle, Thomas (1521\u20131571)",
        "DATEOFBIRTH": "1521 Jun 04",
        "DATEOFDEATH": "1571 Feb 14",
        "PLACEOFBIRTH": "Ornans",
        "PLACEOFDEATH": "Antwerpen"
    },
    {
        "ID": "11605",
        "NAME": "Perrenot de Granvelle, Franz (1550\u20131606)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1606 Nov 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11606",
        "NAME": "Perrenot de Granvelle, Petronella (1560\u20131599)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1599 Sep 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11607",
        "NAME": "Oyselay, Peter Anton (1540\u20131602)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11608",
        "NAME": "Oyselay, Franz Thomas (1589\u20131629), K\u00e4mmerer",
        "DATEOFBIRTH": "1589 Sep 04",
        "DATEOFDEATH": "1629 Jan 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Besan\u00e7on"
    },
    {
        "ID": "11609",
        "NAME": "Oyselay, Eugen Leopold (1612\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1637 Feb 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Besan\u00e7on"
    },
    {
        "ID": "11610",
        "NAME": "Habsburg, Karolina (1591\u20131662)",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1662 Jan 12",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Mechelen"
    },
    {
        "ID": "11611",
        "NAME": "Perrenot de Granvelle, Niklas (1484\u20131550)",
        "DATEOFBIRTH": "1484",
        "DATEOFDEATH": "1550 Aug 15",
        "PLACEOFBIRTH": "Ornans",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "11612",
        "NAME": "Perrenot de Granvelle, Anton (1517\u20131586), Erzbischof von Bisanz",
        "DATEOFBIRTH": "1517 Aug 26",
        "DATEOFDEATH": "1586 Sep 21",
        "PLACEOFBIRTH": "Ornans",
        "PLACEOFDEATH": "Vallecas"
    },
    {
        "ID": "11613",
        "NAME": "Thoillier de Guillebon, Albrecht Niklas (1610\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Beauvais",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11614",
        "NAME": "H\u00e4ckhl von Lichtenfels, Peter (1540\u20131607), Hofzahlmeister",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lichtenfels im Waldviertel"
    },
    {
        "ID": "11615",
        "NAME": "Rietmann, Johann (1550\u20131609), Hofzahlmeister",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11616",
        "NAME": "Gordon, Johann (1600\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "Milton of Noth",
        "PLACEOFDEATH": "Delft"
    },
    {
        "ID": "11617",
        "NAME": "Devereux, Walter (1600\u20131640), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1640 Jan",
        "PLACEOFBIRTH": "Dublin",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11618",
        "NAME": "Barbitz von Fernemont, Johann Baptist (1555\u20131620), Reichshofrat",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1620",
        "PLACEOFBIRTH": "Utrecht",
        "PLACEOFDEATH": "K\u00f6ln am Rhein:Dominikanerkirche"
    },
    {
        "ID": "11619",
        "NAME": "Barbitz von Fernemont, Johann Franz (1598\u20131667), Landeshauptmann von Glogau",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1667 Sep 13",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Glogau in Niederschlesien"
    },
    {
        "ID": "11620",
        "NAME": "Habsburg, Karl (1603\u20131628), K\u00e4mmerer",
        "DATEOFBIRTH": "1603",
        "DATEOFDEATH": "1628 Sep 30",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11621",
        "NAME": "Habsburg, Julius (1586\u20131609)",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1609 Jun 25",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Krumau in B\u00f6hmen:Minoritenkloster"
    },
    {
        "ID": "11622",
        "NAME": "Markham, Greif (1565\u20131644), K\u00e4mmerer",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "Ollerton",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11623",
        "NAME": "Erd\u0151dy, Niklas (1630\u20131693), Ban von Kroatien",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1693 Jun 07",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": "Zlat\u00e9 Moravce"
    },
    {
        "ID": "11624",
        "NAME": "Erd\u0151dy, Elisabeth (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11625",
        "NAME": "Holk, Heinrich (1599\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1599 Apr 28",
        "DATEOFDEATH": "1633 Sep 09",
        "PLACEOFBIRTH": "Kronborg auf Seeland",
        "PLACEOFDEATH": "Troschenreuth im Vogtland"
    },
    {
        "ID": "11626",
        "NAME": "Leutersam, Johann (1600\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1647 Okt 26",
        "PLACEOFBIRTH": "Enniger im M\u00fcnsterland",
        "PLACEOFDEATH": "Steinfurt am Sundern"
    },
    {
        "ID": "11627",
        "NAME": "Laminger von Albenreuth, Wolfgang Wilhelm (1590\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Heiligenkreuz am Engelbach"
    },
    {
        "ID": "11628",
        "NAME": "Laminger von Albenreuth, Wolfgang Maximilian (1634\u20131696), K\u00e4mmerer",
        "DATEOFBIRTH": "1634 Nov 23",
        "DATEOFDEATH": "1696 Nov 02",
        "PLACEOFBIRTH": "Heiligenkreuz am Engelbach",
        "PLACEOFDEATH": "Trhanov"
    },
    {
        "ID": "11629",
        "NAME": "Kinsky, Ulrich (1583\u20131620), K\u00e4mmerer",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1620",
        "PLACEOFBIRTH": "Eger in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11630",
        "NAME": "Habsburg, Matthias (1594\u20131626), K\u00e4mmerer",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1626 Aug 29",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11631",
        "NAME": "Askanien, Bernhard (1140\u20131212)",
        "DATEOFBIRTH": "1140~",
        "DATEOFDEATH": "1212 Feb 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bernburg an der Saale"
    },
    {
        "ID": "11632",
        "NAME": "Askanien, Heinrich (1175\u20131252)",
        "DATEOFBIRTH": "1175~",
        "DATEOFDEATH": "1252",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11633",
        "NAME": "Askanien, Siegfried (1220\u20131298)",
        "DATEOFBIRTH": "1220~",
        "DATEOFDEATH": "1298 Mar 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11634",
        "NAME": "Askanien, Albrecht (1265\u20131316)",
        "DATEOFBIRTH": "1265~",
        "DATEOFDEATH": "1316",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11635",
        "NAME": "Askanien, Albrecht (1306\u20131362)",
        "DATEOFBIRTH": "1306",
        "DATEOFDEATH": "1362",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11636",
        "NAME": "Askanien, Johann (1340\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11637",
        "NAME": "Askanien, Siegmund (1368\u20131405)",
        "DATEOFBIRTH": "1368",
        "DATEOFDEATH": "1405",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11638",
        "NAME": "Askanien, Georg (1405\u20131474)",
        "DATEOFBIRTH": "1405~",
        "DATEOFDEATH": "1474 Sep 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Dessau"
    },
    {
        "ID": "11639",
        "NAME": "Askanien, Ernst (1450\u20131516)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1516 Jun 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11640",
        "NAME": "Bronckhorst, Johann Jakob (1582\u20131630)",
        "DATEOFBIRTH": "1582 Feb 12",
        "DATEOFDEATH": "1630 Okt 18",
        "PLACEOFBIRTH": "Anholt in Westfalen",
        "PLACEOFDEATH": "Freiburg im Breisgau"
    },
    {
        "ID": "11641",
        "NAME": "Sternberg, Albrecht (1470\u20131530)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1530~",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11642",
        "NAME": "Volkra, Ferdinand (1555\u20131604), Truchsess",
        "DATEOFBIRTH": "1555 Sep 02",
        "DATEOFDEATH": "1604 Jun 10",
        "PLACEOFBIRTH": "Steinabrunn",
        "PLACEOFDEATH": "Steinabrunn"
    },
    {
        "ID": "11643",
        "NAME": "Dodoens van Joenckema, Reinprecht (1517\u20131585), Hofarzt",
        "DATEOFBIRTH": "1517 Jun 29",
        "DATEOFDEATH": "1585 Mar 10",
        "PLACEOFBIRTH": "Mechelen",
        "PLACEOFDEATH": "Leiden in Holland"
    },
    {
        "ID": "11644",
        "NAME": "Tonner von Truppach, Johann (1540\u20131620), Reichshofrat",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1620 Mai 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11645",
        "NAME": "Jung, Johann (1425\u20131505)",
        "DATEOFBIRTH": "1425",
        "DATEOFDEATH": "1505 Feb 16",
        "PLACEOFBIRTH": "Z\u00fcrich",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "11646",
        "NAME": "Jung, Ulrich (1478\u20131539)",
        "DATEOFBIRTH": "1478 Mar 29",
        "DATEOFDEATH": "1539 Jul 18",
        "PLACEOFBIRTH": "Ulm an der Donau",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "11647",
        "NAME": "Jung, Ambros (1471\u20131548)",
        "DATEOFBIRTH": "1471",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "Ulm an der Donau",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "11648",
        "NAME": "Jung, Timotheus (1523\u20131580), Reichshofrat",
        "DATEOFBIRTH": "1523 Jan 24",
        "DATEOFDEATH": "1580 Jan 24",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11649",
        "NAME": "Podiebrad, Sidonia (1449\u20131510)",
        "DATEOFBIRTH": "1449 Nov 11",
        "DATEOFDEATH": "1510 Feb 01",
        "PLACEOFBIRTH": "Podiebrad",
        "PLACEOFDEATH": "Tharandt"
    },
    {
        "ID": "11650",
        "NAME": "Alessandrini, Peter (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11651",
        "NAME": "Alessandrini, Julius (1506\u20131590), Hofarzt",
        "DATEOFBIRTH": "1506",
        "DATEOFDEATH": "1590 Aug 25",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": "Civezzano"
    },
    {
        "ID": "11652",
        "NAME": "Alessandrini, Johann (1540\u2013\u00a0\u00a0\u00a0\u00a0), Reichshofrat",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11653",
        "NAME": "Griesst\u00e4tter von Haselbach, Urban (1460\u20131514)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1514",
        "PLACEOFBIRTH": "Haselbach am Tannberg",
        "PLACEOFDEATH": "Biburg an der Bina"
    },
    {
        "ID": "11654",
        "NAME": "Griesst\u00e4tter von Haselbach, Wolfgang (1490\u20131567), Propst von Berchtesgaden",
        "DATEOFBIRTH": "1490",
        "DATEOFDEATH": "1567 Jul 14",
        "PLACEOFBIRTH": "Haselbach am Tannberg",
        "PLACEOFDEATH": "Berchtesgaden:Franziskanerkirche"
    },
    {
        "ID": "11655",
        "NAME": "Griesst\u00e4tter von Haselbach, Johann (1500\u20131551)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1551",
        "PLACEOFBIRTH": "Haselbach am Tannberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11656",
        "NAME": "Griesst\u00e4tter von Haselbach, Wolfgang (1530\u20131577), Reichshofrat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "Haselbach am Tannberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11657",
        "NAME": "Meggau, Ferdinand Helfried (1581\u20131620), K\u00e4mmerer",
        "DATEOFBIRTH": "1581",
        "DATEOFDEATH": "1620 Nov 08",
        "PLACEOFBIRTH": "Kreuzen im M\u00fchlviertel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11658",
        "NAME": "Sprinzenstein, Johann Albrecht (1543\u20131598), Geheimer Rat",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1598 Nov 25",
        "PLACEOFBIRTH": "Neuhaus im M\u00fchlviertel",
        "PLACEOFDEATH": "Regelsbrunn"
    },
    {
        "ID": "11659",
        "NAME": "Sprinzenstein, Johann Ernst (1574\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1639 Nov 02",
        "PLACEOFBIRTH": "Neuhaus im M\u00fchlviertel",
        "PLACEOFDEATH": "Gotthardswalde"
    },
    {
        "ID": "11660",
        "NAME": "Puchheim, Pilgram (1280\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1280~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Puchheim im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11661",
        "NAME": "Puchheim, Pilgram (1330\u20131396), Erzbischof von Salzburg",
        "DATEOFBIRTH": "1330~",
        "DATEOFDEATH": "1396 Apr 05",
        "PLACEOFBIRTH": "Puchheim im Hausruckviertel",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "11662",
        "NAME": "Stralendorff, Wolfgang Leopold (1590\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "Heiligenstadt im Eichsfeld",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11663",
        "NAME": "Stralendorff, Adolf Joachim (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11664",
        "NAME": "Neustetter genannt St\u00fcrmer, Sebastian (1500\u20131562)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1562",
        "PLACEOFBIRTH": "Neust\u00e4dtlein am Forst",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11665",
        "NAME": "Neustetter genannt St\u00fcrmer, Sebastian (1540\u20131593)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1593",
        "PLACEOFBIRTH": "Sch\u00f6nfeld im Lochautal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11666",
        "NAME": "Neustetter genannt St\u00fcrmer, Johann Christoph (1570\u20131638)",
        "DATEOFBIRTH": "1570 Mar 30",
        "DATEOFDEATH": "1638 Nov 19",
        "PLACEOFBIRTH": "Ha\u00dffurt",
        "PLACEOFDEATH": "Bamberg"
    },
    {
        "ID": "11667",
        "NAME": "Neustetter genannt St\u00fcrmer, Karl (1575\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ha\u00dffurt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11668",
        "NAME": "Neustetter genannt St\u00fcrmer, Erasam (1523\u20131594)",
        "DATEOFBIRTH": "1523 Nov 07",
        "DATEOFDEATH": "1594 Dez 03",
        "PLACEOFBIRTH": "Sch\u00f6nfeld im Lochautal",
        "PLACEOFDEATH": "W\u00fcrzburg"
    },
    {
        "ID": "11669",
        "NAME": "Truchsess von Waldburg, Eberhard (1420\u20131479)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1479 Sep 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11670",
        "NAME": "Truchsess von Waldburg, Johann (1460\u20131510)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1510 Jun 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wolfegg in Schwaben"
    },
    {
        "ID": "11671",
        "NAME": "Leipa, Heinrich (1400\u20131469)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1469",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11672",
        "NAME": "Leipa, Berthold (1430\u20131482)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1482",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11673",
        "NAME": "Leipa, Heinrich (1460\u20131515)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1515",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11674",
        "NAME": "Leipa, Vinzenz (1530\u20131579), Mundschenk",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "Kromau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11675",
        "NAME": "Hohenzollern, Dorothea (1430\u20131495), K\u00f6nigin von D\u00e4nemark",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1495 Nov 20",
        "PLACEOFBIRTH": "Trebitz an der Elbe",
        "PLACEOFDEATH": "Kalundborg"
    },
    {
        "ID": "11676",
        "NAME": "Schwarzbeck, Johann (1520\u20131576)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Krems an der Donau",
        "PLACEOFDEATH": "Krems an der Donau"
    },
    {
        "ID": "11677",
        "NAME": "Schwarzbeck, Georg (1550\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Krems an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11678",
        "NAME": "Schwarzbeck, Leopold (1560\u20131612), Hofdiener",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1612 Jan 01",
        "PLACEOFBIRTH": "Krems an der Donau",
        "PLACEOFDEATH": "Senftenberg im Kremstal"
    },
    {
        "ID": "11679",
        "NAME": "Pruckhner, Johann (1550\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11680",
        "NAME": "Truchsess von Waldburg, Andreas (1450\u20131511)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1511 Mai 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Herbertingen"
    },
    {
        "ID": "11681",
        "NAME": "Puchheim, Niklas (1535\u20131591), Hofdiener",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1591",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": "Raabs an der Thaya"
    },
    {
        "ID": "11682",
        "NAME": "Puchheim, Georg Ehrenreich (1565\u20131612), Hofkriegsrat",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11693",
        "NAME": "Haugwitz, Alexander (1585\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "Piszkowice",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11694",
        "NAME": "Schlick, Anna Sidonia (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11695",
        "NAME": "Hohenzollern, Anna (1487\u20131514), K\u00f6nigin von D\u00e4nemark",
        "DATEOFBIRTH": "1487 Aug 27",
        "DATEOFDEATH": "1514 Mai 03",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "Kiel"
    },
    {
        "ID": "11696",
        "NAME": "Tannberg, David (1530\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11698",
        "NAME": "Hohenzollern, Ursula (1450\u20131508)",
        "DATEOFBIRTH": "1450 Sep 25",
        "DATEOFDEATH": "1508 Nov 25",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "11699",
        "NAME": "Sebottendorf, Moritz (1550\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Weigwitz in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11700",
        "NAME": "Habsburg, Maria (1531\u20131581), Herzogin von J\u00fclich",
        "DATEOFBIRTH": "1531 Mai 15",
        "DATEOFDEATH": "1581 Dez 11",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Hambach in der Eifel"
    },
    {
        "ID": "11701",
        "NAME": "Sinzendorf, Joachim (1544\u20131594), Reichshofrat",
        "DATEOFBIRTH": "1544 Jul 12",
        "DATEOFDEATH": "1594 Jan 28",
        "PLACEOFBIRTH": "Feyregg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11702",
        "NAME": "Sinzendorf, August (1590\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1590",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "Feyregg",
        "PLACEOFDEATH": "P\u00f6ggstall im Waldviertel"
    },
    {
        "ID": "11703",
        "NAME": "Sinzendorf, Leonhard (1420\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sinzendorf im Traunviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11704",
        "NAME": "Sinzendorf, Christian Ludwig (1669\u20131687)",
        "DATEOFBIRTH": "1669 Jan 04",
        "DATEOFDEATH": "1687 Aug 12",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Sikl\u00f3s"
    },
    {
        "ID": "11705",
        "NAME": "Sinzendorf, Philipp Ludwig (1671\u20131742), K\u00e4mmerer",
        "DATEOFBIRTH": "1671 Dez 26",
        "DATEOFDEATH": "1742 Feb 08",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11706",
        "NAME": "Sinzendorf, Reinprecht (1470\u20131521)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1521",
        "PLACEOFBIRTH": "Sinzendorf im Traunviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11707",
        "NAME": "Sinzendorf, Pilgram (1518\u20131579)",
        "DATEOFBIRTH": "1518 Feb 20",
        "DATEOFDEATH": "1579 Jul 19",
        "PLACEOFBIRTH": "Fridau an der Pielach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11708",
        "NAME": "Sinzendorf, Pilgram (1576\u20131632), K\u00e4mmerer",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1632 Mar 14",
        "PLACEOFBIRTH": "Fridau an der Pielach",
        "PLACEOFDEATH": "P\u00f6ggstall im Waldviertel"
    },
    {
        "ID": "11709",
        "NAME": "Sinzendorf, Lorenz (1460\u20131515)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1515 Jun 24",
        "PLACEOFBIRTH": "Sinzendorf im Traunviertel",
        "PLACEOFDEATH": "Achleiten an der Krems"
    },
    {
        "ID": "11710",
        "NAME": "Sinzendorf, Leonhard (1500\u20131548)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "Feyregg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11711",
        "NAME": "Sinzendorf, Johann (1534\u20131594), Hofkammerrat",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1594 Dez 31",
        "PLACEOFBIRTH": "Feyregg",
        "PLACEOFDEATH": "V\u00f6slau"
    },
    {
        "ID": "11712",
        "NAME": "Sinzendorf, Johann Karl (1612\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1612 Jul 02",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11713",
        "NAME": "Sinzendorf, Karl Ludwig (1652\u20131722), Reichshofratsvizepr\u00e4sident",
        "DATEOFBIRTH": "1652",
        "DATEOFDEATH": "1722 Apr 16",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11714",
        "NAME": "Sinzendorf, Ludwig Otto (1680\u20131711), K\u00e4mmerer",
        "DATEOFBIRTH": "1680~",
        "DATEOFDEATH": "1711 Nov 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11715",
        "NAME": "Sinzendorf, Siegmund (1670\u20131747), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1670",
        "DATEOFDEATH": "1747 Jan 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11716",
        "NAME": "Sinzendorf, Theoderich (1658\u20131706), K\u00e4mmerer",
        "DATEOFBIRTH": "1658 Nov 15",
        "DATEOFDEATH": "1706 Apr 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11717",
        "NAME": "Sinzendorf, August (1644\u20131676), K\u00e4mmerer",
        "DATEOFBIRTH": "1644",
        "DATEOFDEATH": "1676",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11718",
        "NAME": "Sinzendorf, Johann Weikhard (1656\u20131715), K\u00e4mmerer",
        "DATEOFBIRTH": "1656 Jan 09",
        "DATEOFDEATH": "1715 Okt 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11719",
        "NAME": "Sinzendorf, Adolf (1659\u20131700), K\u00e4mmerer",
        "DATEOFBIRTH": "1659 Mar 07",
        "DATEOFDEATH": "1700 Mai 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Konstantinopel"
    },
    {
        "ID": "11720",
        "NAME": "Trczka von Leipa, Burian (1525\u20131591), Landesunterk\u00e4mmerer von B\u00f6hmen",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1591 Mai 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Swietla an der Sasau"
    },
    {
        "ID": "11721",
        "NAME": "Trczka von Leipa, Wilhelm (1600\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1634 Apr 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11722",
        "NAME": "Kolowrat, Harald (1570\u20131630), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1630 Dez 16",
        "PLACEOFBIRTH": "Altsattler B\u00fcrgel",
        "PLACEOFDEATH": "Kuttenberg"
    },
    {
        "ID": "11723",
        "NAME": "Leskowetz, Bosel (1553\u20131603), Panetier",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11724",
        "NAME": "Schlick, Kaspar (1505\u20131575)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1575",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11725",
        "NAME": "Berka von der Duba, Johann (1525\u20131582)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1582 Mar 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11726",
        "NAME": "Berka von der Duba, Alexander (1553\u20131599), Truchsess",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11727",
        "NAME": "Berka von der Duba, Johann (1557\u20131578), Truchsess",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1578 Nov 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "L\u00edpa in B\u00f6hmen"
    },
    {
        "ID": "11728",
        "NAME": "Berka von der Duba, Burian (1590\u20131626), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1626 Mar 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11729",
        "NAME": "Zinzendorf, Otto Heinrich (1605\u20131655), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1655 Mar 28",
        "PLACEOFBIRTH": "Karlsbach im M\u00fchlkreis",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11730",
        "NAME": "Podiebrad, Hedwig (1508\u20131531)",
        "DATEOFBIRTH": "1508 Jun 12",
        "DATEOFDEATH": "1531 Nov 28",
        "PLACEOFBIRTH": "Oels",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "11731",
        "NAME": "Trapp von Matsch, Georg (1586\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1631 Aug 09",
        "PLACEOFBIRTH": "Churburg",
        "PLACEOFDEATH": "Eschenlohe im Ultental"
    },
    {
        "ID": "11732",
        "NAME": "F\u00fcllinger, Karl (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11733",
        "NAME": "Dohna, Abraham (1530\u20131587)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1587",
        "PLACEOFBIRTH": "Kraschen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11734",
        "NAME": "Dohna, Abraham (1561\u20131613), Geheimer Rat",
        "DATEOFBIRTH": "1561 Dez 19",
        "DATEOFDEATH": "1613 Mai 01",
        "PLACEOFBIRTH": "Kraschen",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "11735",
        "NAME": "Dohna, Heinrich (1559\u20131618)",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "Kraschen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11736",
        "NAME": "Herberstein, Johann Ferdinand (1640\u20131675)",
        "DATEOFBIRTH": "1640 Jan 18",
        "DATEOFDEATH": "1675 Nov 01",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11737",
        "NAME": "Herberstein, Otto Heinrich (1595\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1634 Mar 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11738",
        "NAME": "Herberstein, Karl Siegmund (1650\u20131687)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1687",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11739",
        "NAME": "Herberstein, Ferdinand Ernst (1670\u20131720), K\u00e4mmerer",
        "DATEOFBIRTH": "1670~",
        "DATEOFDEATH": "1720 Mar 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11740",
        "NAME": "Prinz von Buchau, Daniel (1546\u20131608), Hofkammerrat",
        "DATEOFBIRTH": "1546 Sep 14",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "L\u00f6wenberg in Schlesien",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "11741",
        "NAME": "Askanien, Albrecht (1180\u20131261)",
        "DATEOFBIRTH": "1180~",
        "DATEOFDEATH": "1261 Nov 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lehnin in der Zauche:Klosterkirche"
    },
    {
        "ID": "11742",
        "NAME": "Askanien, Johann (1230\u20131285)",
        "DATEOFBIRTH": "1230~",
        "DATEOFDEATH": "1285 Jul 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wittenberg in Sachsen:Franziskanerkirche"
    },
    {
        "ID": "11743",
        "NAME": "Askanien, Ehrenreich (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11744",
        "NAME": "Askanien, Ehrenreich (1316\u20131368)",
        "DATEOFBIRTH": "1316",
        "DATEOFDEATH": "1368",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11745",
        "NAME": "Askanien, Ehrenreich (1354\u20131411)",
        "DATEOFBIRTH": "1354",
        "DATEOFDEATH": "1411",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11746",
        "NAME": "Askanien, Bernhard (1380\u20131463)",
        "DATEOFBIRTH": "1380",
        "DATEOFDEATH": "1463 Jul 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11747",
        "NAME": "Askanien, Johann (1439\u20131507)",
        "DATEOFBIRTH": "1439 Jul 18",
        "DATEOFDEATH": "1507 Aug 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11748",
        "NAME": "Askanien, Mang (1470\u20131543)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1543 Aug 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11749",
        "NAME": "Askanien, Franz (1510\u20131581)",
        "DATEOFBIRTH": "1510",
        "DATEOFDEATH": "1581 Mar 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11750",
        "NAME": "Leyen von Argenschwang, Johann Meinhard (1570\u20131640)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1640~",
        "PLACEOFBIRTH": "Argenschwang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11751",
        "NAME": "Puchheim, Pilgram (1338\u20131380)",
        "DATEOFBIRTH": "1338",
        "DATEOFDEATH": "1380",
        "PLACEOFBIRTH": "Puchheim im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11752",
        "NAME": "Puchheim, Johann (1375\u20131438)",
        "DATEOFBIRTH": "1375~",
        "DATEOFDEATH": "1438",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11753",
        "NAME": "Puchheim, Johann (1410\u20131446)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1446",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11754",
        "NAME": "Puchheim, Neidhard (1440\u20131495)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1495",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11755",
        "NAME": "Puchheim, Johann (1480\u20131522)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1522 Aug 09",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "11756",
        "NAME": "Puchheim, Michael Ludwig (1515\u20131580)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1580 Jun 10",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11757",
        "NAME": "Puchheim, Johann Christoph (1550\u20131598)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1598 Okt 06",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11758",
        "NAME": "Slavata, Michael (1574\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "\u010cest\u00edn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11759",
        "NAME": "Schellhardt von Hartenfels, Bartlome (1550\u2013\u00a0\u00a0\u00a0\u00a0), Sommelier",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11760",
        "NAME": "Thurn, Pagan (1180\u20131241)",
        "DATEOFBIRTH": "1180~",
        "DATEOFDEATH": "1241 Jan 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Chiaravalle Milanese"
    },
    {
        "ID": "11761",
        "NAME": "Thurn, Salvator (1220\u20131281)",
        "DATEOFBIRTH": "1220~",
        "DATEOFDEATH": "1281",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11762",
        "NAME": "Thurn, Wolfgang (1260\u20131307)",
        "DATEOFBIRTH": "1260~",
        "DATEOFDEATH": "1307",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "G\u00f6rz"
    },
    {
        "ID": "11763",
        "NAME": "Thurn, Richard (1300\u20131354)",
        "DATEOFBIRTH": "1300~",
        "DATEOFDEATH": "1354",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11764",
        "NAME": "Thurn, Johann (1340\u20131412)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "1412",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11765",
        "NAME": "Thurn, Richard (1370\u20131431)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "1431",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11766",
        "NAME": "Thurn, Matthias (1400\u20131461)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1461",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11767",
        "NAME": "Thurn, Hermann (1210\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1210~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11768",
        "NAME": "Thurn, Lombard (1240\u20131280)",
        "DATEOFBIRTH": "1240~",
        "DATEOFDEATH": "1280",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11769",
        "NAME": "Thurn, Phoebus (1270\u20131328)",
        "DATEOFBIRTH": "1270~",
        "DATEOFDEATH": "1328",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11770",
        "NAME": "Thurn, Johann (1305\u20131345)",
        "DATEOFBIRTH": "1305~",
        "DATEOFDEATH": "1345",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11771",
        "NAME": "Thurn, Phoebus (1340\u20131409)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "1409",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11772",
        "NAME": "Thurn, Thomas (1380\u20131451)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1451",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bergamo"
    },
    {
        "ID": "11773",
        "NAME": "Thurn, Phoebus (1420\u20131485)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1485",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11774",
        "NAME": "Thurn, Johann (1464\u20131547)",
        "DATEOFBIRTH": "1464",
        "DATEOFDEATH": "1547",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11775",
        "NAME": "Thurn, Franz (1518\u20131565)",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1565",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "11776",
        "NAME": "Thurn, Reimund (1540\u20131623), K\u00e4mmerer",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1623 Aug 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "11777",
        "NAME": "Thurn, Johann Matthias (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bologna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11778",
        "NAME": "Thurn, Karl Maximilian (1643\u20131716), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1643 Okt 15",
        "DATEOFDEATH": "1716 Jun 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Znaim:Dominikanerkirche"
    },
    {
        "ID": "11779",
        "NAME": "Thurn, Franz Phoebus (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bologna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11780",
        "NAME": "Thurn, Johann Philipp (1598\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "Bologna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11781",
        "NAME": "Thurn, Ludwig Leopold (1627\u20131650)",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Florenz"
    },
    {
        "ID": "11782",
        "NAME": "Thurn, Franz Ulrich (1629\u20131695), K\u00e4mmerer",
        "DATEOFBIRTH": "1629 Okt 05",
        "DATEOFDEATH": "1695 Dez 13",
        "PLACEOFBIRTH": "Sagra an der Isnitz",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "11783",
        "NAME": "Thurn, Reimund Bonifaz (1638\u20131714), K\u00e4mmerer",
        "DATEOFBIRTH": "1638 Mai 16",
        "DATEOFDEATH": "1714 Sep 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11784",
        "NAME": "Thurn, Philipp Jakob (1639\u20131704)",
        "DATEOFBIRTH": "1639 Dez 21",
        "DATEOFDEATH": "1704 Mai 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "11785",
        "NAME": "Thurn, Niklas Pagan (1643\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1643",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11786",
        "NAME": "Thurn, Napoleon (1215\u20131278)",
        "DATEOFBIRTH": "1215~",
        "DATEOFDEATH": "1278 Aug 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Baradello"
    },
    {
        "ID": "11787",
        "NAME": "Thurn, Konrad (1251\u20131304)",
        "DATEOFBIRTH": "1251",
        "DATEOFDEATH": "1304 Okt 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "11788",
        "NAME": "Thurn, Flormund (1290\u20131350)",
        "DATEOFBIRTH": "1290~",
        "DATEOFDEATH": "1350~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11789",
        "NAME": "Thurn, Otto (1330\u20131385)",
        "DATEOFBIRTH": "1330~",
        "DATEOFDEATH": "1385",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11790",
        "NAME": "Thurn, Niklas (1370\u20131436)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "1436",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11791",
        "NAME": "Thurn, Niklas (1410\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11792",
        "NAME": "Thurn, Ludwig (1450\u20131511)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1511 Feb 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Udine"
    },
    {
        "ID": "11793",
        "NAME": "Thurn, Hieronym (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11794",
        "NAME": "Thurn, Siegmund (1528\u20131601), Truchsess",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1601 Jun 07",
        "PLACEOFBIRTH": "Venedig",
        "PLACEOFDEATH": "G\u00f6rz:Franziskanerkloster"
    },
    {
        "ID": "11795",
        "NAME": "Thurn, Karl (1560\u20131607)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "Thybein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11796",
        "NAME": "Thurn, Siegmund (1595\u20131643), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Thybein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11797",
        "NAME": "Thurn, Simon (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Thybein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11798",
        "NAME": "Thurn, Karl (1622\u20131689), K\u00e4mmerer",
        "DATEOFBIRTH": "1622",
        "DATEOFDEATH": "1689 Apr 27",
        "PLACEOFBIRTH": "Thybein",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "11799",
        "NAME": "Thurn, Hektor (1630\u20131678), K\u00e4mmerer",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "Thybein",
        "PLACEOFDEATH": "Stra\u00dfburg im Elsass"
    },
    {
        "ID": "11800",
        "NAME": "Habsburg, Siegmund Franz (1630\u20131665), Landesherr von Tirol",
        "DATEOFBIRTH": "1630 Nov 27",
        "DATEOFDEATH": "1665 Jun 25",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Innsbruck:Jesuitenkirche"
    },
    {
        "ID": "11801",
        "NAME": "Hattstein, Johann (1447\u20131546), Gro\u00dfprior des Malteserordens in Deutschland",
        "DATEOFBIRTH": "1447",
        "DATEOFDEATH": "1546 Apr 04",
        "PLACEOFBIRTH": "Usingen im Taunus",
        "PLACEOFDEATH": "Speyer"
    },
    {
        "ID": "11802",
        "NAME": "Ebersdorf, Reinprecht (1500\u20131554)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1554 Jan 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11803",
        "NAME": "Krusics, Peter (1491\u20131537)",
        "DATEOFBIRTH": "1491 Okt 16",
        "DATEOFDEATH": "1537 Mar 12",
        "PLACEOFBIRTH": "M\u00e4hrenfels in Istrien",
        "PLACEOFDEATH": "Klissa in Dalmatien"
    },
    {
        "ID": "11804",
        "NAME": "Schober, Georg (1529\u20131597)",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sankt Peter in Krain"
    },
    {
        "ID": "11805",
        "NAME": "Flach von Schwarzenberg, Philipp (1525\u20131594)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1594 Mar 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Heitersheim im Breisgau"
    },
    {
        "ID": "11806",
        "NAME": "Riedesel, Philipp (1545\u20131598), Hofkriegsrat",
        "DATEOFBIRTH": "1545",
        "DATEOFDEATH": "1598 Mar 13",
        "PLACEOFBIRTH": "Camberg im Taunus",
        "PLACEOFDEATH": "Freiburg im Breisgau"
    },
    {
        "ID": "11807",
        "NAME": "Riedesel, Hermann (1626\u20131663), Hofkriegsrat",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "Eisenbach am Vogelsberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11808",
        "NAME": "Tettau, Karl (1555\u20131609)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Mailberg im Weinviertel"
    },
    {
        "ID": "11809",
        "NAME": "R\u00f6mer von Maretsch, Christoph Siegmund (1520\u20131576)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Triest"
    },
    {
        "ID": "11810",
        "NAME": "Puchheim, Albrecht (1315\u20131384), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1315~",
        "DATEOFDEATH": "1384",
        "PLACEOFBIRTH": "Puchheim im Hausruckviertel",
        "PLACEOFDEATH": "Litschau im Waldviertel"
    },
    {
        "ID": "11811",
        "NAME": "Puchheim, Albrecht (1360\u20131430)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1430~",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11812",
        "NAME": "Puchheim, Georg (1390\u20131458)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1458",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11813",
        "NAME": "Puchheim, Balthasar (1440\u20131504)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1504",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11814",
        "NAME": "Puchheim, Georg (1475\u20131531)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1531",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11815",
        "NAME": "Puchheim, Johann (1445\u20131518)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1518",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11816",
        "NAME": "Puchheim, Wilhelm (1480\u20131534)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1534",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11817",
        "NAME": "Puchheim, Pilgram (1475\u20131542)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1542",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11818",
        "NAME": "Puchheim, Andreas (1530\u20131592), Panetier",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11819",
        "NAME": "Puchheim, Otto Heinrich (1525\u20131578), Hofkriegsrat",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1578",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11820",
        "NAME": "Saurau, Georg (1400\u20131460)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1460~",
        "PLACEOFBIRTH": "Saurau im Murtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11821",
        "NAME": "Saurau, Wilhelm (1430\u20131475), Truchsess",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1475~",
        "PLACEOFBIRTH": "Saurau im Murtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11822",
        "NAME": "Saurau, Erasam (1470\u20131532)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1532",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11823",
        "NAME": "Saurau, Alban (1525\u20131579)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1579 Feb 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11824",
        "NAME": "Saurau, Christoph (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11825",
        "NAME": "Saurau, Otto (1580\u20131609)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11826",
        "NAME": "Saurau, Christoph Alban (1605\u20131656), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1656 Jul 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "11827",
        "NAME": "Saurau, Johann Wilhelm (1585\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11828",
        "NAME": "Saurau, Ehrenreich (1610\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11829",
        "NAME": "Saurau, Gilg (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11830",
        "NAME": "Saurau, Erasam (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11831",
        "NAME": "Saurau, Johann (1440\u20131476)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1476",
        "PLACEOFBIRTH": "Saurau im Murtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11832",
        "NAME": "Saurau, Wolfgang (1470\u20131521)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1521",
        "PLACEOFBIRTH": "Ligist",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11833",
        "NAME": "Saurau, Franz (1500\u20131555)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1555~",
        "PLACEOFBIRTH": "Ligist",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11834",
        "NAME": "Saurau, Georg (1530\u20131568)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1568",
        "PLACEOFBIRTH": "Ligist",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11835",
        "NAME": "Saurau, Friedrich (1450\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Saurau im Murtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11836",
        "NAME": "Saurau, Michael (1480\u20131543)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11837",
        "NAME": "Saurau, Johann (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11838",
        "NAME": "Saurau, Michael (1535\u20131572)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1572",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11839",
        "NAME": "Saurau, Wolfgang (1535\u20131563)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1563",
        "PLACEOFBIRTH": "Ligist",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11840",
        "NAME": "Wanga von Rubein, Georg Theoderich (1595\u20131669), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1669",
        "PLACEOFBIRTH": "Rubein",
        "PLACEOFDEATH": "Meran"
    },
    {
        "ID": "11841",
        "NAME": "Kolowrat, Johann (1420\u20131469)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1469",
        "PLACEOFBIRTH": "Weseritz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11842",
        "NAME": "Kolowrat, Wenzel (1457\u20131536)",
        "DATEOFBIRTH": "1457",
        "DATEOFDEATH": "1536",
        "PLACEOFBIRTH": "Weseritz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11843",
        "NAME": "Kolowrat, Ludwig (1500\u20131555)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1555",
        "PLACEOFBIRTH": "Weseritz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11844",
        "NAME": "Kolowrat, Johann (1540\u20131604)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1604",
        "PLACEOFBIRTH": "Weseritz",
        "PLACEOFDEATH": "Bistrau in B\u00f6hmen"
    },
    {
        "ID": "11845",
        "NAME": "Kolowrat, Wilhelm Heinrich (1589\u20131642), K\u00e4mmerer",
        "DATEOFBIRTH": "1589 Nov 05",
        "DATEOFDEATH": "1642 Jul 11",
        "PLACEOFBIRTH": "Weseritz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11846",
        "NAME": "Malowetz, Georg (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ch\u00fdnov",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11847",
        "NAME": "Ple\u00df von Slaupna, Wenzel (1550\u20131603), Vorschneider",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11848",
        "NAME": "Capliers, Kaspar (1541\u20131621)",
        "DATEOFBIRTH": "1541",
        "DATEOFDEATH": "1621 Jun 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11849",
        "NAME": "Capliers, Albrecht (1583\u20131616), Truchsess",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1616 Aug 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neustupov"
    },
    {
        "ID": "11850",
        "NAME": "Kinsky, Johann (1471\u20131521)",
        "DATEOFBIRTH": "1471",
        "DATEOFDEATH": "1521",
        "PLACEOFBIRTH": "Vchynice",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11851",
        "NAME": "Kinsky, Georg (1500\u20131566)",
        "DATEOFBIRTH": "1500",
        "DATEOFDEATH": "1566",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11852",
        "NAME": "Kinsky, Jaroslaus (1540\u20131614), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1614 Mar 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11853",
        "NAME": "Kinsky, Johann Friedrich (1580\u20131644), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11854",
        "NAME": "Zaruba von Hustirzan, Karl (1550\u20131619), Vorschneider",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "Hust\u00ed\u0159an",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11865",
        "NAME": "Podiebrad, Heinrich Wenzel (1592\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1592 Okt 07",
        "DATEOFDEATH": "1639 Aug 21",
        "PLACEOFBIRTH": "Oels",
        "PLACEOFDEATH": "Bernstadt an der Weide"
    },
    {
        "ID": "11866",
        "NAME": "Ritschan, Harald (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11867",
        "NAME": "Ritschan, Sidonius (1530\u20131582)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1582 Jul 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Z\u00e1dve\u0159ice"
    },
    {
        "ID": "11868",
        "NAME": "Ritschan, Wenzel (1537\u20131596), Vorschneider",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11869",
        "NAME": "Ritschan, Johann (1565\u20131643), Truchsess",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11870",
        "NAME": "Wettin, Friedrich (1412\u20131464), Herzog zu Sachsen",
        "DATEOFBIRTH": "1412 Aug 22",
        "DATEOFDEATH": "1464 Sep 07",
        "PLACEOFBIRTH": "Altenburg in Th\u00fcringen",
        "PLACEOFDEATH": "Leipzig"
    },
    {
        "ID": "11871",
        "NAME": "Wettin, Ernst (1441\u20131486), Herzog zu Sachsen",
        "DATEOFBIRTH": "1441 Mar 24",
        "DATEOFDEATH": "1486 Aug 26",
        "PLACEOFBIRTH": "Altenburg in Th\u00fcringen",
        "PLACEOFDEATH": "Colditz"
    },
    {
        "ID": "11872",
        "NAME": "Wettin, Albrecht (1443\u20131500), Herzog zu Sachsen",
        "DATEOFBIRTH": "1443 Jul 31",
        "DATEOFDEATH": "1500 Sep 12",
        "PLACEOFBIRTH": "Altenburg in Th\u00fcringen",
        "PLACEOFDEATH": "Emden in Ostfriesland"
    },
    {
        "ID": "11873",
        "NAME": "Wettin, Georg (1471\u20131539), Herzog zu Sachsen",
        "DATEOFBIRTH": "1471",
        "DATEOFDEATH": "1539",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11874",
        "NAME": "Wettin, Heinrich (1473\u20131541), Herzog zu Sachsen",
        "DATEOFBIRTH": "1473 Mar 16",
        "DATEOFDEATH": "1541 Aug 18",
        "PLACEOFBIRTH": "Dresden",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "11875",
        "NAME": "Wettin, Friedrich (1474\u20131510)",
        "DATEOFBIRTH": "1474 Okt 25",
        "DATEOFDEATH": "1510 Dez 13",
        "PLACEOFBIRTH": "Torgau",
        "PLACEOFDEATH": "Rochlitz"
    },
    {
        "ID": "11876",
        "NAME": "Wettin, Moritz (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11877",
        "NAME": "Wettin, Ernst (1464\u20131513)",
        "DATEOFBIRTH": "1464 Jun 26",
        "DATEOFDEATH": "1513 Aug 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Halle an der Saale"
    },
    {
        "ID": "11878",
        "NAME": "Wettin, Albrecht (1467\u20131484), Erzbischof von Mainz",
        "DATEOFBIRTH": "1467 Mai 08",
        "DATEOFDEATH": "1484 Mai 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Aschaffenburg"
    },
    {
        "ID": "11879",
        "NAME": "Wettin, Johann (1468\u20131532)",
        "DATEOFBIRTH": "1468 Jun 30",
        "DATEOFDEATH": "1532 Aug 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11880",
        "NAME": "Wettin, Friedrich (1463\u20131525), Herzog zu Sachsen",
        "DATEOFBIRTH": "1463 Jan 17",
        "DATEOFDEATH": "1525 Mai 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11881",
        "NAME": "Puchheim, Otto Friedrich (1606\u20131664), Bischof von Laibach",
        "DATEOFBIRTH": "1606 Aug 31",
        "DATEOFDEATH": "1664 Apr 03",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "11882",
        "NAME": "Rabatta, Reimund Ferdinand (1669\u20131722), Bischof von Passau",
        "DATEOFBIRTH": "1669 Feb 04",
        "DATEOFDEATH": "1722 Okt 25",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "11883",
        "NAME": "Mattioli, Peter Andreas (1501\u20131578), Hofarzt",
        "DATEOFBIRTH": "1501 Mar 12",
        "DATEOFDEATH": "1578",
        "PLACEOFBIRTH": "Siena",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "11884",
        "NAME": "Mattioli, Ferdinand (1562\u20131625), Hofarzt",
        "DATEOFBIRTH": "1562",
        "DATEOFDEATH": "1625",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "11885",
        "NAME": "Rindsmaul, Ruprecht (1570\u20131651)",
        "DATEOFBIRTH": "1570 Aug 31",
        "DATEOFDEATH": "1651 Mai 15",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11886",
        "NAME": "Rindsmaul, Maria Rosalia (1622\u20131665)",
        "DATEOFBIRTH": "1622",
        "DATEOFDEATH": "1665 Mar 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11888",
        "NAME": "Rindsmaul, Wolfgang Ruprecht (1610\u20131683), Obersthofmeister",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1683",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11889",
        "NAME": "Rindsmaul, Johann Otto (1615\u20131667), Landeshauptmann von G\u00f6rz",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1667 Sep 28",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "11890",
        "NAME": "Liechtenstein von Kastelkorn, Johann Christoph (1591\u20131643), Bischof von Chiemsee",
        "DATEOFBIRTH": "1591 Dez 12",
        "DATEOFDEATH": "1643 Dez 01",
        "PLACEOFBIRTH": "Leifers",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "11891",
        "NAME": "Kurtz von Senftenau, Albrecht (1600\u20131671)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1671 Dez 19",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Neuburg an der Donau"
    },
    {
        "ID": "11892",
        "NAME": "Reich, Karl Friedrich (1615\u20131647)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1647 Dez 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Gie\u00dfen an der Lahn"
    },
    {
        "ID": "11893",
        "NAME": "Manesis, Bernhard (1530\u2013\u00a0\u00a0\u00a0\u00a0), Oberstk\u00fcchenmeister",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11894",
        "NAME": "Mehl von Strehlitz, Balthasar (1480\u20131545)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1545 Mar 03",
        "PLACEOFBIRTH": "Strehlitz an der Studnitz",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "11895",
        "NAME": "Mehl von Strehlitz, Georg (1514\u20131589)",
        "DATEOFBIRTH": "1514",
        "DATEOFDEATH": "1589 Jan 24",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11896",
        "NAME": "Barbo von Waxenstein, Sebald (1545\u20131589)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1589 Mar 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "11897",
        "NAME": "Barbo von Waxenstein, Siegmund (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11898",
        "NAME": "Barbo von Waxenstein, Bernhard (1580\u20131632), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11899",
        "NAME": "Barbo von Waxenstein, Georg (1605\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11900",
        "NAME": "Habsburg, Rudolf\u00a0I. (1218\u20131291), K\u00f6nig des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1218 Mai 01",
        "DATEOFDEATH": "1291 Jul 15",
        "PLACEOFBIRTH": "Limburg im Breisgau",
        "PLACEOFDEATH": "Speyer:Dom"
    },
    {
        "ID": "11901",
        "NAME": "Oldenburg, Theoderich (1394\u20131440)",
        "DATEOFBIRTH": "1394",
        "DATEOFDEATH": "1440 Feb 14",
        "PLACEOFBIRTH": "Oldenburg an der Hunte",
        "PLACEOFDEATH": "Delmenhorst"
    },
    {
        "ID": "11902",
        "NAME": "Oldenburg, Gerhard (1430\u20131500)",
        "DATEOFBIRTH": "1430",
        "DATEOFDEATH": "1500 Feb 22",
        "PLACEOFBIRTH": "Oldenburg an der Hunte",
        "PLACEOFDEATH": "Saint Esprit du Pont"
    },
    {
        "ID": "11903",
        "NAME": "Oldenburg, Johann (1460\u20131526)",
        "DATEOFBIRTH": "1460",
        "DATEOFDEATH": "1526 Feb 10",
        "PLACEOFBIRTH": "Oldenburg an der Hunte",
        "PLACEOFDEATH": "Oldenburg an der Hunte"
    },
    {
        "ID": "11904",
        "NAME": "Oldenburg, Anton (1505\u20131573)",
        "DATEOFBIRTH": "1505",
        "DATEOFDEATH": "1573 Jan 22",
        "PLACEOFBIRTH": "Oldenburg an der Hunte",
        "PLACEOFDEATH": "Oldenburg an der Hunte"
    },
    {
        "ID": "11905",
        "NAME": "Oldenburg, Johann (1540\u20131603)",
        "DATEOFBIRTH": "1540 Sep 09",
        "DATEOFDEATH": "1603 Nov 12",
        "PLACEOFBIRTH": "Oldenburg an der Hunte",
        "PLACEOFDEATH": "Oldenburg an der Hunte"
    },
    {
        "ID": "11906",
        "NAME": "Oldenburg, Christian (1426\u20131481), K\u00f6nig von D\u00e4nemark",
        "DATEOFBIRTH": "1426",
        "DATEOFDEATH": "1481 Mai 21",
        "PLACEOFBIRTH": "Oldenburg an der Hunte",
        "PLACEOFDEATH": "Kopenhagen"
    },
    {
        "ID": "11907",
        "NAME": "Oldenburg, Friedrich (1471\u20131533), K\u00f6nig von D\u00e4nemark",
        "DATEOFBIRTH": "1471 Okt 07",
        "DATEOFDEATH": "1533 Apr 10",
        "PLACEOFBIRTH": "Hadersleben",
        "PLACEOFDEATH": "Gottorf"
    },
    {
        "ID": "11908",
        "NAME": "Oldenburg, Christian (1503\u20131559), K\u00f6nig von D\u00e4nemark",
        "DATEOFBIRTH": "1503 Aug 12",
        "DATEOFDEATH": "1559 Jan 01",
        "PLACEOFBIRTH": "Gottorf",
        "PLACEOFDEATH": "Kolding"
    },
    {
        "ID": "11909",
        "NAME": "Oldenburg, Friedrich (1534\u20131588), K\u00f6nig von D\u00e4nemark",
        "DATEOFBIRTH": "1534 Jul 01",
        "DATEOFDEATH": "1588 Apr 04",
        "PLACEOFBIRTH": "Hadersleben",
        "PLACEOFDEATH": "Antvorskov"
    },
    {
        "ID": "11910",
        "NAME": "Oldenburg, Christian (1577\u20131648), K\u00f6nig von D\u00e4nemark",
        "DATEOFBIRTH": "1577 Apr 12",
        "DATEOFDEATH": "1648 Feb 28",
        "PLACEOFBIRTH": "Frederiksborg",
        "PLACEOFDEATH": "Kopenhagen"
    },
    {
        "ID": "11911",
        "NAME": "Wittelsbach, Ludwig (1315\u20131361)",
        "DATEOFBIRTH": "1315",
        "DATEOFDEATH": "1361 Sep 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11912",
        "NAME": "Wittelsbach, Ludwig (1328\u20131365)",
        "DATEOFBIRTH": "1328 Mai 07",
        "DATEOFDEATH": "1365 Feb 27",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11913",
        "NAME": "Wittelsbach, Stephan (1319\u20131375)",
        "DATEOFBIRTH": "1319",
        "DATEOFDEATH": "1375",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11914",
        "NAME": "Wittelsbach, Johann (1341\u20131397)",
        "DATEOFBIRTH": "1341",
        "DATEOFDEATH": "1397 Jul 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11915",
        "NAME": "Wittelsbach, Ernst (1373\u20131438)",
        "DATEOFBIRTH": "1373",
        "DATEOFDEATH": "1438 Jul 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "11916",
        "NAME": "Wittelsbach, Albrecht (1401\u20131460)",
        "DATEOFBIRTH": "1401 Mar 27",
        "DATEOFDEATH": "1460 Feb 29",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "11917",
        "NAME": "Wittelsbach, Albrecht (1447\u20131508)",
        "DATEOFBIRTH": "1447 Dez 15",
        "DATEOFDEATH": "1508 Mar 18",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "11918",
        "NAME": "Wittelsbach, Wilhelm (1493\u20131550), Herzog in Bayern",
        "DATEOFBIRTH": "1493 Nov 13",
        "DATEOFDEATH": "1550 Mar 07",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "M\u00fcnchen:Liebfrauenkirche"
    },
    {
        "ID": "11919",
        "NAME": "Wittelsbach, Ludwig (1495\u20131545), Graf von Vohburg",
        "DATEOFBIRTH": "1495 Sep 18",
        "DATEOFDEATH": "1545 Apr 22",
        "PLACEOFBIRTH": "Gr\u00fcnwald im Isartal",
        "PLACEOFDEATH": "Landshut in Niederbayern"
    },
    {
        "ID": "11920",
        "NAME": "Oldenburg, Anton Gundaker (1583\u20131667), K\u00e4mmerer",
        "DATEOFBIRTH": "1583 Nov 01",
        "DATEOFDEATH": "1667 Jun 19",
        "PLACEOFBIRTH": "Oldenburg an der Hunte",
        "PLACEOFDEATH": "Rastede im Ammerland"
    },
    {
        "ID": "11921",
        "NAME": "Fuchs von Fuchsberg, Christoph (1360\u20131421)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1421",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Jaufenburg in Passeier"
    },
    {
        "ID": "11922",
        "NAME": "Fuchs von Fuchsberg, Georg (1400\u2013\u00a0\u00a0\u00a0\u00a0), Obersthofmarschall",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Jaufenburg in Passeier",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11923",
        "NAME": "Fuchs von Fuchsberg, Hildebrand (1410\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Jaufenburg in Passeier",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11924",
        "NAME": "Fuchs von Fuchsberg, Degenhard (1450\u20131528), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1528 Dez 29",
        "PLACEOFBIRTH": "Jaufenburg in Passeier",
        "PLACEOFDEATH": "Kufstein:Veitskirche"
    },
    {
        "ID": "11925",
        "NAME": "Fuchs von Fuchsberg, Christoph (1482\u20131542), Bischof von Brixen",
        "DATEOFBIRTH": "1482",
        "DATEOFDEATH": "1542 Dez 09",
        "PLACEOFBIRTH": "Sankt Michael in Eppan",
        "PLACEOFDEATH": "Brixen am Eisack:Dom"
    },
    {
        "ID": "11926",
        "NAME": "Fuchs von Fuchsberg, Christoph (1520\u20131560)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1560",
        "PLACEOFBIRTH": "Sankt Michael in Eppan",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11927",
        "NAME": "Fuchs von Fuchsberg, Karl (1550\u20131609)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "Lebenberg im Etschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11928",
        "NAME": "Fuchs von Fuchsberg, Anna (1485\u20131534), Obersthofmeisterin",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1534",
        "PLACEOFBIRTH": "Sankt Michael in Eppan",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11929",
        "NAME": "Fuchs von Fuchsberg, Magdalena (1495\u20131556)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1556 Sep 06",
        "PLACEOFBIRTH": "Sankt Michael in Eppan",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11930",
        "NAME": "Oldenburg, Anton (1633\u20131680), Graf von Aldenburg",
        "DATEOFBIRTH": "1633 Feb 01",
        "DATEOFDEATH": "1680 Okt 27",
        "PLACEOFBIRTH": "Hatten",
        "PLACEOFDEATH": "Varel am Jadebusen"
    },
    {
        "ID": "11931",
        "NAME": "Starhemberg, Kaspar (1360\u20131418)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1418",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11932",
        "NAME": "Starhemberg, Johann (1412\u20131474), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1412",
        "DATEOFDEATH": "1474",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11933",
        "NAME": "Starhemberg, Bartlome (1460\u20131531)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1531 Apr 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11934",
        "NAME": "Starhemberg, Ulrich (1410\u20131474)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1474 Sep 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11935",
        "NAME": "Schlick, Heinrich (1365\u20131431)",
        "DATEOFBIRTH": "1365~",
        "DATEOFDEATH": "1431",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11936",
        "NAME": "Schlick, Kaspar (1396\u20131449)",
        "DATEOFBIRTH": "1396",
        "DATEOFDEATH": "1449 Jul 19",
        "PLACEOFBIRTH": "Eger in B\u00f6hmen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "11937",
        "NAME": "Schlick, Matthias (1410\u20131487)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1487 Sep 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Elbogen an der Eger"
    },
    {
        "ID": "11938",
        "NAME": "Schlick, Hieronym (1440\u20131491)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1491 Jul 11",
        "PLACEOFBIRTH": "Elbogen an der Eger",
        "PLACEOFDEATH": "Gran an der Donau"
    },
    {
        "ID": "11939",
        "NAME": "Schlick, Albrecht (1490\u20131558)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1558",
        "PLACEOFBIRTH": "Elbogen an der Eger",
        "PLACEOFDEATH": "Winteritz in B\u00f6hmen"
    },
    {
        "ID": "11940",
        "NAME": "Pernstein, Johann (1406\u20131475)",
        "DATEOFBIRTH": "1406",
        "DATEOFDEATH": "1475 Dez 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11941",
        "NAME": "Pernstein, Wilhelm (1438\u20131521)",
        "DATEOFBIRTH": "1438",
        "DATEOFDEATH": "1521 Apr 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pardubitz"
    },
    {
        "ID": "11942",
        "NAME": "Pernstein, Johann (1487\u20131548), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1487 Nov 14",
        "DATEOFDEATH": "1548 Sep 08",
        "PLACEOFBIRTH": "Kromau in M\u00e4hren",
        "PLACEOFDEATH": "Seelowitz"
    },
    {
        "ID": "11943",
        "NAME": "Pernstein, Albrecht (1490\u20131534), Landeshauptmann von B\u00f6hmen",
        "DATEOFBIRTH": "1490 Apr 04",
        "DATEOFDEATH": "1534 Mar 17",
        "PLACEOFBIRTH": "Kromau in M\u00e4hren",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11944",
        "NAME": "Leipa, Johann (1490\u20131531)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1531",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kromau in M\u00e4hren"
    },
    {
        "ID": "11945",
        "NAME": "Leipa, Berthold (1520\u20131576), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Kromau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11946",
        "NAME": "Leipa, Johann (1550\u20131598), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "G\u00f6ding an der March",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11948",
        "NAME": "Sternberg, Wilhelm (1520\u20131562)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1562",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11949",
        "NAME": "Waldstein, Friedrich (1510\u20131569)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1569 Jul 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11950",
        "NAME": "Przemysl, Odoaker (1233\u20131278), K\u00f6nig von B\u00f6hmen",
        "DATEOFBIRTH": "1233",
        "DATEOFDEATH": "1278 Aug 26",
        "PLACEOFBIRTH": "K\u00f6nigst\u00e4dtel in B\u00f6hmen",
        "PLACEOFDEATH": "D\u00fcrnkrut an der March"
    },
    {
        "ID": "11951",
        "NAME": "Welz, Viktor (1535\u20131590)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1590~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11952",
        "NAME": "Welz, Moritz (1565\u20131606)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1606 Mar 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11953",
        "NAME": "Welz, Siegmund (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600 Dez 28",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11954",
        "NAME": "Welz, Franz (1635\u20131674)",
        "DATEOFBIRTH": "1635 Jul 23",
        "DATEOFDEATH": "1674",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11955",
        "NAME": "Welz, Franziska Barbara (1666\u20131718)",
        "DATEOFBIRTH": "1666 Aug 04",
        "DATEOFDEATH": "1718 Apr 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wilhermsdorf im Zenngrund"
    },
    {
        "ID": "11956",
        "NAME": "Welz, Franz (1594\u20131661)",
        "DATEOFBIRTH": "1594 Feb 20",
        "DATEOFDEATH": "1661 Apr 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11957",
        "NAME": "Welz, Siegmund Moritz (1619\u20131673)",
        "DATEOFBIRTH": "1619",
        "DATEOFDEATH": "1673 Mai 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "N\u00f6rdlingen im Ries"
    },
    {
        "ID": "11958",
        "NAME": "Welz, Hiob Hartmann (1617\u20131667)",
        "DATEOFBIRTH": "1617 Sep 02",
        "DATEOFDEATH": "1667",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11959",
        "NAME": "Neumann von Wasserleonburg, Wilhelm (1490\u20131536)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1536",
        "PLACEOFBIRTH": "Weitensfeld im Gurktal",
        "PLACEOFDEATH": "Villach in K\u00e4rnten"
    },
    {
        "ID": "11960",
        "NAME": "Neumann von Wasserleonburg, Anna (1535\u20131623)",
        "DATEOFBIRTH": "1535 Nov 25",
        "DATEOFDEATH": "1623 Dez 18",
        "PLACEOFBIRTH": "Villach in K\u00e4rnten",
        "PLACEOFDEATH": "Murau:Kapuzinerkirche"
    },
    {
        "ID": "11961",
        "NAME": "Hohenlohe, Georg (1488\u20131551)",
        "DATEOFBIRTH": "1488 Jan 17",
        "DATEOFDEATH": "1551 Mar 16",
        "PLACEOFBIRTH": "Neuenstein im Hohenloher Land",
        "PLACEOFDEATH": "Waldenburg im Hohenloher Land"
    },
    {
        "ID": "11962",
        "NAME": "Hohenlohe, Ludwig Kasimir (1517\u20131568)",
        "DATEOFBIRTH": "1517 Jan 12",
        "DATEOFDEATH": "1568 Aug 24",
        "PLACEOFBIRTH": "\u00d6hringen",
        "PLACEOFDEATH": "Neuenstein im Hohenloher Land"
    },
    {
        "ID": "11963",
        "NAME": "Hohenlohe, Eberhard (1535\u20131570)",
        "DATEOFBIRTH": "1535 Okt 11",
        "DATEOFDEATH": "1570 Mar 09",
        "PLACEOFBIRTH": "\u00d6hringen",
        "PLACEOFDEATH": "Waldenburg im Hohenloher Land"
    },
    {
        "ID": "11964",
        "NAME": "Hohenlohe, Georg Friedrich (1562\u20131600)",
        "DATEOFBIRTH": "1562 Apr 03",
        "DATEOFDEATH": "1600 Nov 01",
        "PLACEOFBIRTH": "Waldenburg im Hohenloher Land",
        "PLACEOFDEATH": "Waldenburg im Hohenloher Land"
    },
    {
        "ID": "11965",
        "NAME": "Hohenlohe, Georg Friedrich (1595\u20131635)",
        "DATEOFBIRTH": "1595 Jun 16",
        "DATEOFDEATH": "1635 Sep 26",
        "PLACEOFBIRTH": "Waldenburg im Hohenloher Land",
        "PLACEOFDEATH": "Frankfurt am Main"
    },
    {
        "ID": "11966",
        "NAME": "Hohenlohe, Ludwig Gustav (1634\u20131697), Geheimer Rat",
        "DATEOFBIRTH": "1634 Jun 08",
        "DATEOFDEATH": "1697 Feb 21",
        "PLACEOFBIRTH": "Schillingsf\u00fcrst in Mittelfranken",
        "PLACEOFDEATH": "Frankfurt am Main"
    },
    {
        "ID": "11967",
        "NAME": "Huyn van Geleen, Arnold (1560\u20131636)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Amstenrade",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11968",
        "NAME": "Huyn van Geleen, Gottfried (1595\u20131657)",
        "DATEOFBIRTH": "1595",
        "DATEOFDEATH": "1657 Aug 27",
        "PLACEOFBIRTH": "Amstenrade",
        "PLACEOFDEATH": "Biesen am Niederrhein"
    },
    {
        "ID": "11969",
        "NAME": "Huyn van Geleen, Alexandra (1605\u20131654)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1654",
        "PLACEOFBIRTH": "Amstenrade",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11970",
        "NAME": "Solms, Otto (1340\u20131410)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "1410",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11971",
        "NAME": "Solms, Johann (1390\u20131457)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1457",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11972",
        "NAME": "Solms, Konrad (1430\u20131477)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1477 Mai 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11973",
        "NAME": "Solms, Bernhard (1380\u20131459)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1459",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11974",
        "NAME": "Solms, Otto (1426\u20131504)",
        "DATEOFBIRTH": "1426 Nov 22",
        "DATEOFDEATH": "1504 Jun 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11975",
        "NAME": "Solms, Bernhard (1468\u20131547)",
        "DATEOFBIRTH": "1468",
        "DATEOFDEATH": "1547 Mar 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11976",
        "NAME": "Solms, Philipp (1494\u20131581)",
        "DATEOFBIRTH": "1494 Feb 23",
        "DATEOFDEATH": "1581 Feb 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11977",
        "NAME": "Solms, Konrad (1540\u20131592)",
        "DATEOFBIRTH": "1540 Jun 17",
        "DATEOFDEATH": "1592 Dez 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Braunfels im Westerwald"
    },
    {
        "ID": "11978",
        "NAME": "Solms, Wilhelm (1570\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1570 Apr 18",
        "DATEOFDEATH": "1635 Feb 03",
        "PLACEOFBIRTH": "Braunfels im Westerwald",
        "PLACEOFDEATH": "Greifenstein im Westerwald"
    },
    {
        "ID": "11979",
        "NAME": "Solms, Reinhard (1573\u20131630)",
        "DATEOFBIRTH": "1573 Mar 27",
        "DATEOFDEATH": "1630 Mai 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11980",
        "NAME": "Brahe, Tyge (1546\u20131601)",
        "DATEOFBIRTH": "1546 Dez 14",
        "DATEOFDEATH": "1601 Okt 24",
        "PLACEOFBIRTH": "Knudstrup",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "11981",
        "NAME": "Puchheim, Andreas (1505\u20131558)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1558",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11982",
        "NAME": "Puchheim, Siegmund (1540\u20131595), Hofkammerrat",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1595",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11983",
        "NAME": "Puchheim, Heinrich (1430\u20131478)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1478",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11984",
        "NAME": "Puchheim, Georg (1460\u20131514)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1514",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11985",
        "NAME": "Puchheim, Wolfgang (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11986",
        "NAME": "Puchheim, Georg (1550\u20131613), Oberstfalkenmeister",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11987",
        "NAME": "Puchheim, Veit (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11988",
        "NAME": "Puchheim, Johann (1500\u20131544)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1544",
        "PLACEOFBIRTH": "Horn im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11989",
        "NAME": "Puchheim, Veit Albrecht (1532\u20131584)",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "Horn im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11990",
        "NAME": "Kepler, Johann (1571\u20131630), Hofmathematiker",
        "DATEOFBIRTH": "1571 Dez 27",
        "DATEOFDEATH": "1630 Nov 15",
        "PLACEOFBIRTH": "Weil der Stadt",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "11991",
        "NAME": "Traudisch, Georg Adam (1590\u20131653)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1653",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11992",
        "NAME": "Traudisch, Johann Georg (1627\u20131646)",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1646 Nov 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Schweinfurt"
    },
    {
        "ID": "11993",
        "NAME": "Lindauer, Michael (1550\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11994",
        "NAME": "Wettin, Friedrich (1504\u20131539)",
        "DATEOFBIRTH": "1504 Mar 15",
        "DATEOFDEATH": "1539 Feb 26",
        "PLACEOFBIRTH": "Dresden",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "11995",
        "NAME": "Thurn, Markela (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Venedig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11996",
        "NAME": "Guarinoni, Christoph (1540\u20131610)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1610~",
        "PLACEOFBIRTH": "Verona",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11997",
        "NAME": "Guarinoni, Bartlome (1534\u20131616), Hofarzt",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "11998",
        "NAME": "Guarinoni, Hippolyt (1571\u20131654)",
        "DATEOFBIRTH": "1571 Nov 18",
        "DATEOFDEATH": "1654 Mai 31",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": "Hall in Tirol"
    },
    {
        "ID": "11999",
        "NAME": "Spie\u00df, Helena (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12000",
        "NAME": "Wittelsbach, Albrecht (1528\u20131579), Herzog in Bayern",
        "DATEOFBIRTH": "1528 Feb 29",
        "DATEOFDEATH": "1579 Okt 24",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "12001",
        "NAME": "Oldenburg, Waldemar Christian (1622\u20131656), Reichshofrat",
        "DATEOFBIRTH": "1622 Jun 26",
        "DATEOFDEATH": "1656 Feb 26",
        "PLACEOFBIRTH": "Frederiksborg",
        "PLACEOFDEATH": "Lublin"
    },
    {
        "ID": "12002",
        "NAME": "Frangipane di Veglia, Katharina (1625\u20131673)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1673 Nov 16",
        "PLACEOFBIRTH": "Wasseil",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "12003",
        "NAME": "Zr\u00ednyi, Helena (1643\u20131703)",
        "DATEOFBIRTH": "1643",
        "DATEOFDEATH": "1703 Feb 18",
        "PLACEOFBIRTH": "Wasseil",
        "PLACEOFDEATH": "Nikomedia"
    },
    {
        "ID": "12004",
        "NAME": "Frangipane di Veglia, Juliana (1650\u20131693)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1693",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12005",
        "NAME": "Bournonville, Alexander (1616\u20131690), K\u00e4mmerer",
        "DATEOFBIRTH": "1616 Jan 05",
        "DATEOFDEATH": "1690 Aug 20",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Pamplona"
    },
    {
        "ID": "12006",
        "NAME": "Caprara, Aeneas (1631\u20131701), Geheimer Rat",
        "DATEOFBIRTH": "1631 Nov 16",
        "DATEOFDEATH": "1701 Feb 03",
        "PLACEOFBIRTH": "Bologna",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12007",
        "NAME": "Baranyai von \u0150cs\u00e9ny, Thomas (1595\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "V\u00e1rad",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12008",
        "NAME": "Howard von Stafford, Wilhelm (1614\u20131680), K\u00e4mmerer",
        "DATEOFBIRTH": "1614 Nov 30",
        "DATEOFDEATH": "1680 Dez 29",
        "PLACEOFBIRTH": "Arundel",
        "PLACEOFDEATH": "London"
    },
    {
        "ID": "12009",
        "NAME": "Saavedra, Johann (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12010",
        "NAME": "R\u00e1k\u00f3czi, Siegmund (1544\u20131608), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1544",
        "DATEOFDEATH": "1608 Dez 05",
        "PLACEOFBIRTH": "Fels\u0151vad\u00e1sz",
        "PLACEOFDEATH": "Fels\u0151vad\u00e1sz"
    },
    {
        "ID": "12011",
        "NAME": "R\u00e1k\u00f3czi, Georg (1593\u20131648), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1593 Jun 08",
        "DATEOFDEATH": "1648 Okt 11",
        "PLACEOFBIRTH": "Szerencs",
        "PLACEOFDEATH": "Patak am Bodrog"
    },
    {
        "ID": "12012",
        "NAME": "R\u00e1k\u00f3czi, Georg (1621\u20131660), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1621 Jan 30",
        "DATEOFDEATH": "1660 Jun 07",
        "PLACEOFBIRTH": "Patak am Bodrog",
        "PLACEOFDEATH": "Wardein an der Schnellen Kreisch"
    },
    {
        "ID": "12013",
        "NAME": "R\u00e1k\u00f3czi, Paul (1596\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1636 Mar 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12014",
        "NAME": "R\u00e1k\u00f3czi, Franz (1645\u20131676), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1645 Feb 24",
        "DATEOFDEATH": "1676 Jul 08",
        "PLACEOFBIRTH": "Wei\u00dfenburg in Siebenb\u00fcrgen",
        "PLACEOFDEATH": "Makovica"
    },
    {
        "ID": "12015",
        "NAME": "R\u00e1k\u00f3czi, Franz (1676\u20131735), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1676 Mar 27",
        "DATEOFDEATH": "1735 Apr 08",
        "PLACEOFBIRTH": "Borsi am Bodrog",
        "PLACEOFDEATH": "Bisanthe am Marmarameer"
    },
    {
        "ID": "12016",
        "NAME": "Koh\u00e1ry, Peter (1564\u20131629)",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Lewenz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12017",
        "NAME": "Koh\u00e1ry, Magdalena (1601\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1601",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12018",
        "NAME": "Baranyai von \u0150cs\u00e9ny, Maria Magdalena (1620\u20131652)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1652",
        "PLACEOFBIRTH": "V\u00e1rad",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12019",
        "NAME": "Esterh\u00e1zy, Gabriel (1580\u20131626)",
        "DATEOFBIRTH": "1580 Okt 08",
        "DATEOFDEATH": "1626 Dez 28",
        "PLACEOFBIRTH": "Gallandau",
        "PLACEOFDEATH": "Domani\u017ea"
    },
    {
        "ID": "12020",
        "NAME": "Manrique de Lara, Kasilda (1597\u20131670)",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1670 Aug 26",
        "PLACEOFBIRTH": "Ordu\u00f1a",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "12021",
        "NAME": "J\u00f6rger von Tollet, Johann Helfried (1594\u20131657), Obersthofmeister",
        "DATEOFBIRTH": "1594 Dez 31",
        "DATEOFDEATH": "1657",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12022",
        "NAME": "Oldenburg, Alexander (1608\u20131667)",
        "DATEOFBIRTH": "1608 Sep 12",
        "DATEOFDEATH": "1667 Sep 05",
        "PLACEOFBIRTH": "Beck im Werretal",
        "PLACEOFDEATH": "Tobitschau"
    },
    {
        "ID": "12023",
        "NAME": "Dietrichstein, Rudolf (1603\u20131649)",
        "DATEOFBIRTH": "1603 Okt 14",
        "DATEOFDEATH": "1649 Mai 15",
        "PLACEOFBIRTH": "Hollenburg an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12024",
        "NAME": "Kuefstein, Georg Adam (1605\u20131656), Hofkriegsrat",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1656 Sep 21",
        "PLACEOFBIRTH": "Greillenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12025",
        "NAME": "Kollonitz, Heinrich Karl (1611\u20131676)",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1676",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12026",
        "NAME": "Windischgr\u00e4tz, Gottlieb (1630\u20131695), Reichsvizekanzler",
        "DATEOFBIRTH": "1630 Mar 23",
        "DATEOFDEATH": "1695 Dez 25",
        "PLACEOFBIRTH": "Regensburg",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "12027",
        "NAME": "Windischgr\u00e4tz, Leopold Viktorin (1686\u20131746), Reichshofrat",
        "DATEOFBIRTH": "1686 Sep 17",
        "DATEOFDEATH": "1746 Dez 19",
        "PLACEOFBIRTH": "Regensburg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12028",
        "NAME": "Thurn, Jobst Joseph (1533\u20131589), Hofkriegsrat",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12029",
        "NAME": "Thurn, Joseph (1635\u2013\u00a0\u00a0\u00a0\u00a0), Mundschenk",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12030",
        "NAME": "Boccamaggiore di Cropelli, Kamil (1600\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12031",
        "NAME": "Auersperg, Weikhard (1583\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1583 Jan 15",
        "DATEOFDEATH": "1660 Apr 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12032",
        "NAME": "Beck, Philipp (1591\u20131654)",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1654 Jan 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12033",
        "NAME": "Kuefstein, Lobgott (1632\u20131680), K\u00e4mmerer",
        "DATEOFBIRTH": "1632",
        "DATEOFDEATH": "1680",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12034",
        "NAME": "Kuefstein, Ehregott (1635\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12035",
        "NAME": "R\u00fcbland, Johann Christoph (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12036",
        "NAME": "Fernberger, Christoph Karl (1596\u20131653)",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1653 Dez 02",
        "PLACEOFBIRTH": "Eggenberg im Traunviertel",
        "PLACEOFDEATH": "Brunn am Gebirge"
    },
    {
        "ID": "12037",
        "NAME": "Beygott von Reinderstadt, Daniel (1600\u20131668)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1668",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Albrechtitz im Reichenberger Land"
    },
    {
        "ID": "12038",
        "NAME": "Cs\u00e1ky, Franz (1630\u20131670), K\u00e4mmerer",
        "DATEOFBIRTH": "1630",
        "DATEOFDEATH": "1670 Sep 17",
        "PLACEOFBIRTH": "Alm\u00e1s im Kreischgebiet",
        "PLACEOFDEATH": "Kaschau"
    },
    {
        "ID": "12039",
        "NAME": "Brisigell, Johann Thomas (1600\u20131652)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1652",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Budweis in B\u00f6hmen"
    },
    {
        "ID": "12040",
        "NAME": "Craiovescu, Rudolf Servas (1560\u20131620), F\u00fcrst der Walachei",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1620 Mar 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12041",
        "NAME": "R\u00e9vay, Lassel (1600\u20131667)",
        "DATEOFBIRTH": "1600 Feb 07",
        "DATEOFDEATH": "1667",
        "PLACEOFBIRTH": "Madocs\u00e1n",
        "PLACEOFDEATH": "Bolondv\u00e1r an der Waag"
    },
    {
        "ID": "12042",
        "NAME": "Sp\u00e1czay, Martin (1600\u20131650)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12043",
        "NAME": "Vad\u00e1szi, Paul (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12044",
        "NAME": "Forg\u00e1ch, Lassel (1600\u20131669)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1669",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trentschin im Waagtal"
    },
    {
        "ID": "12045",
        "NAME": "Mikulich von Brukonovcz, Thomas (1580\u20131649)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12046",
        "NAME": "P\u00e1lffy, Andreas (1610\u20131649)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1649 Okt 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Skalitz"
    },
    {
        "ID": "12047",
        "NAME": "F\u00f6ldv\u00e1ry, Niklas (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12048",
        "NAME": "Czobor, Emmerich (1600\u20131677), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1677",
        "PLACEOFBIRTH": "Maria Scho\u00dfberg",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "12049",
        "NAME": "Koh\u00e1ry, Stephan (1616\u20131664)",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1664 Jul 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lewenz"
    },
    {
        "ID": "12050",
        "NAME": "Ill\u00e9sh\u00e1zy, Stephan (1540\u20131609), Palatin von Ungarn",
        "DATEOFBIRTH": "1540",
        "DATEOFDEATH": "1609 Mai 09",
        "PLACEOFBIRTH": "Pressburg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12051",
        "NAME": "Esterh\u00e1zy, Daniel (1585\u20131654)",
        "DATEOFBIRTH": "1585 Jul 26",
        "DATEOFDEATH": "1654 Jun 14",
        "PLACEOFBIRTH": "Gallandau",
        "PLACEOFDEATH": "Schintau an der Waag"
    },
    {
        "ID": "12052",
        "NAME": "Esterh\u00e1zy, Wolfgang (1615\u20131670), Truchsess",
        "DATEOFBIRTH": "1615 Mai 07",
        "DATEOFDEATH": "1670 Sep 02",
        "PLACEOFBIRTH": "Gallandau",
        "PLACEOFDEATH": "Leutschau in der Zips"
    },
    {
        "ID": "12053",
        "NAME": "Esterh\u00e1zy, Stephan (1616\u20131641), K\u00e4mmerer",
        "DATEOFBIRTH": "1616 Feb 27",
        "DATEOFDEATH": "1641 Jun 04",
        "PLACEOFBIRTH": "Plankenburg in den Karpaten",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12054",
        "NAME": "Esterh\u00e1zy, Paul (1635\u20131713), Palatin von Ungarn",
        "DATEOFBIRTH": "1635 Sep 08",
        "DATEOFDEATH": "1713 Mar 26",
        "PLACEOFBIRTH": "Eisenstadt im Burgenland",
        "PLACEOFDEATH": "Eisenstadt im Burgenland"
    },
    {
        "ID": "12055",
        "NAME": "Pr\u00e9postv\u00e1ri, Siegmund (1600\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "Lok\u00e1cs",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12056",
        "NAME": "P\u00e1lffy, Katharina (1542\u20131616)",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Erd\u0151d",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12057",
        "NAME": "Ill\u00e9sh\u00e1zy, Kaspar (1593\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1648 Apr 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12058",
        "NAME": "Ill\u00e9sh\u00e1zy, Georg (1620\u20131689), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1689",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12059",
        "NAME": "Majth\u00e9nyi, Michael (1590\u20131655)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1655 Apr 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12060",
        "NAME": "Makripodaris, Hyazinth (1610\u20131672), Bischof von Maroschburg",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1672 Jul 30",
        "PLACEOFBIRTH": "Chios",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12061",
        "NAME": "Forg\u00e1ch, Andreas (1530\u20131612)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12062",
        "NAME": "Forg\u00e1ch, Lassel (1570\u20131605)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12063",
        "NAME": "Orosy, Georg (1600\u20131665)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12064",
        "NAME": "P\u00e1lffy, Johann (1548\u20131593)",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1593",
        "PLACEOFBIRTH": "Erd\u0151d",
        "PLACEOFDEATH": "Somosk\u0151"
    },
    {
        "ID": "12065",
        "NAME": "P\u00e1lffy, Thomas (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12066",
        "NAME": "Szelepcse\u0301nyi, Georg (1595\u20131685), Erzbischof von Gran",
        "DATEOFBIRTH": "1595 Apr 24",
        "DATEOFDEATH": "1685 Jan 14",
        "PLACEOFBIRTH": "Tyrnau",
        "PLACEOFDEATH": "Letowitz in M\u00e4hren"
    },
    {
        "ID": "12067",
        "NAME": "Salm, Maria Magdalena (1548\u20131607)",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1607 Jul 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12068",
        "NAME": "Lobkowicz, Lassel (1537\u20131609)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1609 Mar 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12069",
        "NAME": "Lobkowicz, Eva (1585\u20131640)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1640 Dez 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neuhaus am Klausenbach"
    },
    {
        "ID": "12070",
        "NAME": "Batthy\u00e1ny, Franz (1577\u20131625), K\u00e4mmerer",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1625 Sep 13",
        "PLACEOFBIRTH": "Schlaining",
        "PLACEOFDEATH": "Schlaining"
    },
    {
        "ID": "12071",
        "NAME": "Althan, Michael Johann (1643\u20131702)",
        "DATEOFBIRTH": "1643 Aug 26",
        "DATEOFDEATH": "1702",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12072",
        "NAME": "Basta, Georg (1550\u20131607), Hofkriegsrat",
        "DATEOFBIRTH": "1550 Jan 30",
        "DATEOFDEATH": "1607 Aug 26",
        "PLACEOFBIRTH": "Roccaforzata",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "12073",
        "NAME": "Pio di Savoia, Giselbrecht (1629\u20131676), K\u00e4mmerer",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1676 Sep 11",
        "PLACEOFBIRTH": "Sassuolo",
        "PLACEOFDEATH": "Philippsburg am Rhein"
    },
    {
        "ID": "12074",
        "NAME": "Cs\u00e1ky, Lassel (1602\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1602",
        "DATEOFDEATH": "1654 Sep 01",
        "PLACEOFBIRTH": "Adorj\u00e1n an der Beretty\u00f3",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "12075",
        "NAME": "Cs\u00e1ky, Stephan (1569\u20131605)",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1605 Jul 10",
        "PLACEOFBIRTH": "Adorj\u00e1n an der Beretty\u00f3",
        "PLACEOFDEATH": "Klausenburg"
    },
    {
        "ID": "12076",
        "NAME": "Cs\u00e1ky, Stephan (1603\u20131662), K\u00e4mmerer",
        "DATEOFBIRTH": "1603 Mai 03",
        "DATEOFDEATH": "1662 Nov 10",
        "PLACEOFBIRTH": "Ruskov",
        "PLACEOFDEATH": "Zipserhaus"
    },
    {
        "ID": "12077",
        "NAME": "Cs\u00e1ky, Lassel (1630\u20131691)",
        "DATEOFBIRTH": "1630 Mar 02",
        "DATEOFDEATH": "1691",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Komorn an der Donau"
    },
    {
        "ID": "12078",
        "NAME": "Batthy\u00e1ny, Margarita (1611\u20131664)",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "G\u00fcssing",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12079",
        "NAME": "Schwarzenberg, Maria Ernestina (1649\u20131719)",
        "DATEOFBIRTH": "1649",
        "DATEOFDEATH": "1719 Apr 03",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12080",
        "NAME": "Auersperg, Herbert (1574\u20131618)",
        "DATEOFBIRTH": "1574 Okt 04",
        "DATEOFDEATH": "1618 Mar 24",
        "PLACEOFBIRTH": "Laibach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12081",
        "NAME": "Auersperg, Niklas (1522\u20131581)",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "1581 Mar 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12082",
        "NAME": "Auersperg, Wolfgang Siegmund (1543\u20131598), Oberstj\u00e4germeister",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1598 Nov 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12083",
        "NAME": "Auersperg, Weikhard (1575\u20131607)",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "Laibach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12084",
        "NAME": "Kuefstein, Johann Wilhelm (1606\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1637 Mai 05",
        "PLACEOFBIRTH": "Greillenstein",
        "PLACEOFDEATH": "Oschatz"
    },
    {
        "ID": "12085",
        "NAME": "Kuefstein, Hilfgott (1643\u20131713)",
        "DATEOFBIRTH": "1643",
        "DATEOFDEATH": "1713",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12086",
        "NAME": "R\u00e1k\u00f3czi, Juliana (1672\u20131717)",
        "DATEOFBIRTH": "1672",
        "DATEOFDEATH": "1717 Mai 26",
        "PLACEOFBIRTH": "Borsi am Bodrog",
        "PLACEOFDEATH": "Reckheim"
    },
    {
        "ID": "12087",
        "NAME": "Althan, Michael Wenzel (1630\u20131686), Landeshauptmann von Glatz",
        "DATEOFBIRTH": "1630 Jun 30",
        "DATEOFDEATH": "1686 Mai 17",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "W\u00f6lfelsdorf in Schlesien"
    },
    {
        "ID": "12088",
        "NAME": "Wachenheim, Otto Ludwig (1610\u20131660)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1660 Jan 24",
        "PLACEOFBIRTH": "Wachenheim an der Pfrimm",
        "PLACEOFDEATH": "Monsheim an der Pfrimm"
    },
    {
        "ID": "12089",
        "NAME": "Waldstein, Karl Ernst (1661\u20131713), Obersthofmeister",
        "DATEOFBIRTH": "1661 Mai 13",
        "DATEOFDEATH": "1713 Jan 07",
        "PLACEOFBIRTH": "Dobrovice",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12090",
        "NAME": "P\u0103tra\u0219cu, Michael (1558\u20131601), F\u00fcrst der Walachei",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1601 Aug 19",
        "PLACEOFBIRTH": "Wollmarkt in der Walachei",
        "PLACEOFDEATH": "Thorenburg"
    },
    {
        "ID": "12091",
        "NAME": "P\u0103tra\u0219cu, Niklas (1584\u20131627), F\u00fcrst der Walachei",
        "DATEOFBIRTH": "1584 Jul 09",
        "DATEOFDEATH": "1627 Sep 07",
        "PLACEOFBIRTH": "K\u00f6nigsberg in der Walachei",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12092",
        "NAME": "Craiovescu, Anna Rudolfina (1590\u20131664)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1664 Dez 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12093",
        "NAME": "Craiovescu, Konstantin Servas (1608\u20131685), F\u00fcrst der Walachei",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1685 Jun 27",
        "PLACEOFBIRTH": "Curtea de Arge\u0219",
        "PLACEOFDEATH": "Waniowice"
    },
    {
        "ID": "12094",
        "NAME": "Batthy\u00e1ny, Barbara (1615\u20131680)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1680",
        "PLACEOFBIRTH": "G\u00fcssing",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12095",
        "NAME": "Batthy\u00e1ny, Elisabeth (1619\u20131674)",
        "DATEOFBIRTH": "1619",
        "DATEOFDEATH": "1674 Jul 04",
        "PLACEOFBIRTH": "G\u00fcssing",
        "PLACEOFDEATH": "Oedenburg"
    },
    {
        "ID": "12096",
        "NAME": "Losenstein, Georg Achaz (1545\u20131597), Reichshofrat",
        "DATEOFBIRTH": "1545",
        "DATEOFDEATH": "1597 Mai 05",
        "PLACEOFBIRTH": "Schallaburg",
        "PLACEOFDEATH": "Offenhausen im Gr\u00fcnbachtal"
    },
    {
        "ID": "12097",
        "NAME": "Losenstein, Franz Adam (1631\u20131666), K\u00e4mmerer",
        "DATEOFBIRTH": "1631 Jun 30",
        "DATEOFDEATH": "1666 Aug 07",
        "PLACEOFBIRTH": "Gschwendt an der Krems",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12098",
        "NAME": "Losenstein, Theodemar (1510\u20131577), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1577 Jan 20",
        "PLACEOFBIRTH": "Gschwendt an der Krems",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "12099",
        "NAME": "Losenstein, Franz Anton (1642\u20131692), Bischof von Dura",
        "DATEOFBIRTH": "1642 Mai 12",
        "DATEOFDEATH": "1692 Jun 17",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12100",
        "NAME": "Jagiello, Anna (1503\u20131547), K\u00f6nigin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1503 Jul 23",
        "DATEOFDEATH": "1547 Jan 27",
        "PLACEOFBIRTH": "Ofen",
        "PLACEOFDEATH": "Prag:Veitsdom"
    },
    {
        "ID": "12101",
        "NAME": "Longueval de Buquoy, Karl Albrecht (1607\u20131663), K\u00e4mmerer",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1663 Mar 29",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Bergen im Hennegau"
    },
    {
        "ID": "12102",
        "NAME": "Longueval de Buquoy, Ferdinand Karl (1634\u20131685), K\u00e4mmerer",
        "DATEOFBIRTH": "1634",
        "DATEOFDEATH": "1685 Jan 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12103",
        "NAME": "Longueval de Buquoy, Albrecht Karl (1637\u20131714), K\u00e4mmerer",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1714 Okt 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12104",
        "NAME": "Kamie\u0144ski, Johann (1615\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12105",
        "NAME": "Parzuchowski, Alexander Michael (1615\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12106",
        "NAME": "Luzs\u00e9nszky, Lassel (1620\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Lu\u017en\u00e1 in Mittelb\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12107",
        "NAME": "Zichy, Stephan (1616\u20131693), K\u00e4mmerer",
        "DATEOFBIRTH": "1616 Sep 08",
        "DATEOFDEATH": "1693 Mar 15",
        "PLACEOFBIRTH": "Wei\u00dfbrunn in Ungarn",
        "PLACEOFDEATH": "Karlburg an der Donau"
    },
    {
        "ID": "12108",
        "NAME": "Wrzesowitz, Ferdinand (1620\u20131670), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1670~",
        "PLACEOFBIRTH": "Geiersberg in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12109",
        "NAME": "Wrzesowitz, Wolfgang (1575\u20131634), Oberstj\u00e4germeister",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1634 Dez 09",
        "PLACEOFBIRTH": "Eulenburg in M\u00e4hren",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12110",
        "NAME": "Wrzesowitz, Johann Albrecht (1550\u20131605), Oberstj\u00e4germeister",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1605 Mar 26",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": "Karlstein in B\u00f6hmen"
    },
    {
        "ID": "12111",
        "NAME": "Wrzesowitz, Wenzel (1532\u20131583), K\u00e4mmerer",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1583 Jun 18",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12112",
        "NAME": "Wrzesowitz, Wolfgang (1525\u20131569), K\u00e4mmerer",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1569 Mar 21",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": "Teplitz im Erzgebirge"
    },
    {
        "ID": "12113",
        "NAME": "Wrzesowitz, Johann (1450\u20131486)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1486",
        "PLACEOFBIRTH": "Eulenburg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12114",
        "NAME": "Wrzesowitz, Wilhelm (1480\u20131535)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1535~",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12115",
        "NAME": "Wrzesowitz, Albrecht (1520\u20131568)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1568",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12116",
        "NAME": "Wrzesowitz, Johann (1420\u20131478)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1478",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12117",
        "NAME": "Wrzesowitz, Jaroslaus (1445\u20131491)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1491",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12118",
        "NAME": "Wrzesowitz, Jakob (1480\u20131526)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1526 Aug 29",
        "PLACEOFBIRTH": "Geiersberg in B\u00f6hmen",
        "PLACEOFDEATH": "Moh\u00e1cs"
    },
    {
        "ID": "12119",
        "NAME": "Wrzesowitz, Jaroslaus (1525\u20131601)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1601",
        "PLACEOFBIRTH": "Geiersberg in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12120",
        "NAME": "Wrzesowitz, Burian (1575\u20131631)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1631",
        "PLACEOFBIRTH": "Geiersberg in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12121",
        "NAME": "Wrzesowitz, Wilhelm (1625\u20131678)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "Geiersberg in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12122",
        "NAME": "Wrzesowitz, Jakob (1390\u20131462)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1462",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12123",
        "NAME": "Horka, Franz (1625\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Horka an der March",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12124",
        "NAME": "Hohenzollern, Eleonora (1599\u20131655), K\u00f6nigin von Schweden",
        "DATEOFBIRTH": "1599 Nov 11",
        "DATEOFDEATH": "1655 Mar 28",
        "PLACEOFBIRTH": "K\u00f6nigsberg in Preu\u00dfen",
        "PLACEOFDEATH": "Stockholm:Ritterholmskirche"
    },
    {
        "ID": "12125",
        "NAME": "Czabeliczky, Wenzel (1590\u20131649), Hofkriegsrat",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1649 Okt 31",
        "PLACEOFBIRTH": "\u017dimutice",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12126",
        "NAME": "Czabeliczky, Karl Wenzel (1625\u20131687), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1687",
        "PLACEOFBIRTH": "\u017dimutice",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12127",
        "NAME": "Laubsky, Peter (1630\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hammer auf der Insel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12128",
        "NAME": "Ser\u00e9nyi, Gabriel (1598\u20131664), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1664 Aug 06",
        "PLACEOFBIRTH": "Swietlau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12129",
        "NAME": "Ser\u00e9nyi, Paul (1596\u20131667)",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1667 Apr 24",
        "PLACEOFBIRTH": "Swietlau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12130",
        "NAME": "Ser\u00e9nyi, Franz (1564\u20131621)",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1621 Mai 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Swietlau in M\u00e4hren"
    },
    {
        "ID": "12131",
        "NAME": "Ser\u00e9nyi, Johann Karl (1640\u20131691), Hofkriegsrat",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1691 Jan 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12132",
        "NAME": "Ser\u00e9nyi, Franz Gabriel (1635\u20131677), K\u00e4mmerer",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1677 Sep 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12133",
        "NAME": "Ser\u00e9nyi, Franz Joseph (1664\u20131705)",
        "DATEOFBIRTH": "1664",
        "DATEOFDEATH": "1705 Jun 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Urago d\u2019Oglio"
    },
    {
        "ID": "12134",
        "NAME": "B\u00e1nffy von Als\u00f3lendva, Niklas (1599\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1599 Jan 09",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Limbach an der Mur",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12135",
        "NAME": "R\u00e1ttkay, Siegmund (1600\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "Tabor in Kroatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12136",
        "NAME": "R\u00e1ttkay, Peter (1580\u20131631)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1631",
        "PLACEOFBIRTH": "Tabor in Kroatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12137",
        "NAME": "Erd\u0151dy, Barbara (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12138",
        "NAME": "R\u00e1ttkay, Georg (1612\u20131666)",
        "DATEOFBIRTH": "1612 Dez 22",
        "DATEOFDEATH": "1666 Sep 01",
        "PLACEOFBIRTH": "Tabor in Kroatien",
        "PLACEOFDEATH": "Agram"
    },
    {
        "ID": "12139",
        "NAME": "R\u00e1ttkay, Johann (1647\u20131683)",
        "DATEOFBIRTH": "1647 Mai 22",
        "DATEOFDEATH": "1683 Dez 26",
        "PLACEOFBIRTH": "Pettau",
        "PLACEOFDEATH": "Carich\u00edc"
    },
    {
        "ID": "12140",
        "NAME": "R\u00e1ttkay, Johann (1550\u20131611)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12141",
        "NAME": "Keglevich, Franz (1575\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1659",
        "PLACEOFBIRTH": "Bu\u017eim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12142",
        "NAME": "Keglevich, Siegmund (1609\u20131662), K\u00e4mmerer",
        "DATEOFBIRTH": "1609",
        "DATEOFDEATH": "1662",
        "PLACEOFBIRTH": "Bu\u017eim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12143",
        "NAME": "Keglevich, Georg (1565\u20131622)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1622",
        "PLACEOFBIRTH": "Bu\u017eim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12144",
        "NAME": "Keglevich, Simon (1535\u20131576)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Bu\u017eim",
        "PLACEOFDEATH": "Krapina"
    },
    {
        "ID": "12145",
        "NAME": "Keglevich, Peter (1603\u20131665)",
        "DATEOFBIRTH": "1603 Jan 23",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "Bu\u017eim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12146",
        "NAME": "Szunyogh, Kaspar (1595\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1659 Mar 01",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": "Budat\u00edn an der Kisch\u00fctz"
    },
    {
        "ID": "12147",
        "NAME": "Horva\u0301th, Lassel (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12148",
        "NAME": "Mikulich von Brukonovcz, Alexander (1620\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1660 Aug 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12149",
        "NAME": "Zastrizl, Wenzel (1554\u20131600), Vorschneider",
        "DATEOFBIRTH": "1554",
        "DATEOFDEATH": "1600 Apr 22",
        "PLACEOFBIRTH": "Morkovice",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12150",
        "NAME": "S\u0119dzimir, Michael (1566\u20131646), Hofdiener",
        "DATEOFBIRTH": "1566 Feb 02",
        "DATEOFDEATH": "1646 Mai 20",
        "PLACEOFBIRTH": "\u0141ukowica",
        "PLACEOFDEATH": "Krawarn in Schlesien"
    },
    {
        "ID": "12151",
        "NAME": "Sennyey, Alexander (1599\u20131641), K\u00e4mmerer",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1641",
        "PLACEOFBIRTH": "Ungv\u00e1r",
        "PLACEOFDEATH": "P\u00e1cin"
    },
    {
        "ID": "12152",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Georg (1400\u20131458)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1458",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Leutschau in der Zips"
    },
    {
        "ID": "12153",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Johann (1437\u20131508)",
        "DATEOFBIRTH": "1437 Apr 30",
        "DATEOFDEATH": "1508 Okt 10",
        "PLACEOFBIRTH": "Leutschau in der Zips",
        "PLACEOFDEATH": "Neustadt am Frauenbach"
    },
    {
        "ID": "12154",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Georg (1467\u20131521)",
        "DATEOFBIRTH": "1467 Mar 26",
        "DATEOFDEATH": "1521 Mar 19",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "12155",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Christoph (1505\u20131545)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1545~",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12156",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Alexander (1540\u20131594), Vorschneider",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1594 Mar 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Leutschau in der Zips"
    },
    {
        "ID": "12157",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Gottlieb (1457\u20131503)",
        "DATEOFBIRTH": "1457",
        "DATEOFDEATH": "1503",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12158",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Johann (1485\u20131528)",
        "DATEOFBIRTH": "1485",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12159",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Franz (1512\u20131576), Bischof von Neutra",
        "DATEOFBIRTH": "1512",
        "DATEOFDEATH": "1576 Mar 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Arwaburg"
    },
    {
        "ID": "12160",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Georg (1567\u20131616), Palatin von Ungarn",
        "DATEOFBIRTH": "1567 Sep 02",
        "DATEOFDEATH": "1616 Dez 26",
        "PLACEOFBIRTH": "Lietava",
        "PLACEOFDEATH": "Bitscha an der Waag"
    },
    {
        "ID": "12161",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Christoph (1583\u20131614), K\u00e4mmerer",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1614 Apr 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Leutschau in der Zips"
    },
    {
        "ID": "12162",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Johann (1492\u20131558)",
        "DATEOFBIRTH": "1492",
        "DATEOFDEATH": "1558 Mar 29",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": "Zipserhaus"
    },
    {
        "ID": "12163",
        "NAME": "Bark\u00f3czy, Franz (1627\u20131709)",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1709 Jul 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kaschau"
    },
    {
        "ID": "12164",
        "NAME": "Bark\u00f3czy, Franz (1650\u20131727), K\u00e4mmerer",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1727 Apr 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12165",
        "NAME": "Dar\u00f3czy, Franz (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Deregny\u0151",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12166",
        "NAME": "Bosny\u00e1k, Thomas (1572\u20131634)",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1634 Dez 19",
        "PLACEOFBIRTH": "Biel im Donautiefland",
        "PLACEOFDEATH": "Sur\u00e1ny"
    },
    {
        "ID": "12167",
        "NAME": "Bosny\u00e1k, Thomas (1605\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1605 Okt 01",
        "DATEOFDEATH": "1627 Apr 24",
        "PLACEOFBIRTH": "Fileck",
        "PLACEOFDEATH": "Eisenstadt im Burgenland"
    },
    {
        "ID": "12168",
        "NAME": "P\u00e1zm\u00e1ny, Georg (1583\u20131627)",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12169",
        "NAME": "P\u00e1zm\u00e1ny, Niklas (1540\u20131584)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1584 Nov 04",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": "Wardein an der Schnellen Kreisch"
    },
    {
        "ID": "12170",
        "NAME": "P\u00e1zm\u00e1ny, Peter (1570\u20131637), Erzbischof von Gran",
        "DATEOFBIRTH": "1570 Okt 04",
        "DATEOFDEATH": "1637 Mar 19",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "12171",
        "NAME": "Peth\u0151 von Gerse, Johann (1370\u20131424)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "1424",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12172",
        "NAME": "Peth\u0151 von Gerse, Peter (1405\u20131454)",
        "DATEOFBIRTH": "1405~",
        "DATEOFDEATH": "1454",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12173",
        "NAME": "Peth\u0151 von Gerse, Johann (1450\u20131521)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1521",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12174",
        "NAME": "Peth\u0151 von Gerse, Franz (1480\u20131536)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1536",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12175",
        "NAME": "Peth\u0151 von Gerse, Johann (1525\u20131578)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1578 Jan 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12176",
        "NAME": "Peth\u0151 von Gerse, Stephan (1560\u20131611)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Moldau"
    },
    {
        "ID": "12177",
        "NAME": "Peth\u0151 von Gerse, Michael (1590\u20131651)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1651",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12178",
        "NAME": "Peth\u0151 von Gerse, Siegmund (1622\u20131675), K\u00e4mmerer",
        "DATEOFBIRTH": "1622",
        "DATEOFDEATH": "1675 Apr 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12179",
        "NAME": "Peth\u0151 von Gerse, Lassel (1400\u20131455)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1455",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12180",
        "NAME": "Peth\u0151 von Gerse, Niklas (1450\u20131501)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1501",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12181",
        "NAME": "Peth\u0151 von Gerse, Thomas (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12182",
        "NAME": "Peth\u0151 von Gerse, Georg (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12183",
        "NAME": "Peth\u0151 von Gerse, Gabriel (1550\u20131607)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12184",
        "NAME": "Peth\u0151 von Gerse, Georg (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12185",
        "NAME": "Peth\u0151 von Gerse, Franz (1650\u20131686), K\u00e4mmerer",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1686",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12186",
        "NAME": "Peth\u0151 von Gerse, Lassel (1620\u20131677)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1677 Mai 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12187",
        "NAME": "Peth\u0151 von Gerse, Lassel (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12188",
        "NAME": "Peth\u0151 von Gerse, Gregor (1570\u20131629)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Warasdin an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12189",
        "NAME": "Jakussith, Georg (1609\u20131647), Bischof von Erlau",
        "DATEOFBIRTH": "1609",
        "DATEOFDEATH": "1647 Nov 21",
        "PLACEOFBIRTH": "Pruskau im Waagtal",
        "PLACEOFDEATH": "Erlau"
    },
    {
        "ID": "12190",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Stenzel (1576\u20131625), Palatin von Ungarn",
        "DATEOFBIRTH": "1576 Jul 24",
        "DATEOFDEATH": "1625 Mai 01",
        "PLACEOFBIRTH": "Weinitz",
        "PLACEOFDEATH": "Leutschau in der Zips"
    },
    {
        "ID": "12191",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Adam (1600\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1635 Dez 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kirchdorf in der Zips"
    },
    {
        "ID": "12192",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Alexander (1490\u20131543), Palatin von Ungarn",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1543 Jan 25",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": "Leutschau in der Zips"
    },
    {
        "ID": "12193",
        "NAME": "B\u00e1thory, Stephan (1480\u20131530), Palatin von Ungarn",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1530 Mai 08",
        "PLACEOFBIRTH": "Ecsed",
        "PLACEOFDEATH": "Theben an der Donau"
    },
    {
        "ID": "12194",
        "NAME": "Bocskai, Stephan (1557\u20131606), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1557 Jan 01",
        "DATEOFDEATH": "1606 Dez 29",
        "PLACEOFBIRTH": "Klausenburg",
        "PLACEOFDEATH": "Kaschau"
    },
    {
        "ID": "12195",
        "NAME": "Bosny\u00e1k, Judith (1606\u20131654)",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1654",
        "PLACEOFBIRTH": "Fileck",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12196",
        "NAME": "Balassa, Franz (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12197",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Judith (1590\u20131637)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12198",
        "NAME": "Jakussith, Andreas (1584\u20131623)",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1623 Okt 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12199",
        "NAME": "Pucher von Meggenhausen, Georg (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12200",
        "NAME": "Wittelsbach, Ludwig\u00a0IV. (1282\u20131347), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1282",
        "DATEOFDEATH": "1347 Okt 11",
        "PLACEOFBIRTH": "Heidelberg",
        "PLACEOFDEATH": "Puch an der Amper"
    },
    {
        "ID": "12201",
        "NAME": "Metternich, Lothar (1600\u20131663), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12202",
        "NAME": "Metternich, Wilhelm (1590\u20131652), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1652",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12203",
        "NAME": "Metternich, Karl Heinrich (1622\u20131679), Erzbischof von Mainz",
        "DATEOFBIRTH": "1622 Jul 14",
        "DATEOFDEATH": "1679 Sep 26",
        "PLACEOFBIRTH": "Koblenz am Rhein",
        "PLACEOFDEATH": "Aschaffenburg"
    },
    {
        "ID": "12204",
        "NAME": "Metternich, Philipp Emmerich (1621\u20131698), K\u00e4mmerer",
        "DATEOFBIRTH": "1621",
        "DATEOFDEATH": "1698 Mar 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12205",
        "NAME": "Trautson, Johann (1509\u20131589), Obersthofmeister",
        "DATEOFBIRTH": "1509",
        "DATEOFDEATH": "1589 Dez 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12206",
        "NAME": "Trautson, Johann (1540\u20131566), Mundschenk",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1566 Okt 24",
        "PLACEOFBIRTH": "Stein am Gallian",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "12207",
        "NAME": "Mollard, Peter (1515\u20131576), Oberststallmeister",
        "DATEOFBIRTH": "1515",
        "DATEOFDEATH": "1576 Apr 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "12208",
        "NAME": "Mollard, Ernst (1554\u20131621), Obersthofmarschall",
        "DATEOFBIRTH": "1554",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Frinco"
    },
    {
        "ID": "12209",
        "NAME": "Mollard, Jakob (1565\u20131616), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1565",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12210",
        "NAME": "Thannhausen, Konrad (1545\u20131601), K\u00e4mmerer",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1601 Jun 14",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Thannhausen in der Steiermark"
    },
    {
        "ID": "12211",
        "NAME": "Thannhausen, Balthasar (1574\u20131627), Geheimer Rat",
        "DATEOFBIRTH": "1574 Jan 14",
        "DATEOFDEATH": "1627 Okt 10",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Thannhausen in der Steiermark"
    },
    {
        "ID": "12212",
        "NAME": "Thannhausen, Maria (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12213",
        "NAME": "Zwickel, Georg Bartlome (1560\u20131605)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1605 Apr 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Johnsdorf in der Steiermark"
    },
    {
        "ID": "12214",
        "NAME": "Zwickel, Georg Bartlome (1600\u20131656), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1656 Mar 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "12215",
        "NAME": "Khisl von Kaltenbrunn, Georg (1558\u20131605)",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "Kaltenbrunn an der Laibach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12216",
        "NAME": "Khisl von Kaltenbrunn, Johann (1530\u20131591), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1591 Apr 03",
        "PLACEOFBIRTH": "Kaltenbrunn an der Laibach",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "12217",
        "NAME": "Khisl von Kaltenbrunn, Veit (1560\u20131609)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "Kaltenbrunn an der Laibach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12218",
        "NAME": "Schiller, Elias (1580\u20131655), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1655 Okt 15",
        "PLACEOFBIRTH": "Beinheim im Elsass",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12219",
        "NAME": "Fernberger, Karl Ludwig (1569\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1635 Jan 05",
        "PLACEOFBIRTH": "Eggenberg im Traunviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12220",
        "NAME": "Thun, Philipp (1525\u20131600), K\u00e4mmerer",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1600 Aug 08",
        "PLACEOFBIRTH": "Thun in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12221",
        "NAME": "Thun, Siegmund (1487\u20131569), K\u00e4mmerer",
        "DATEOFBIRTH": "1487 Okt 22",
        "DATEOFDEATH": "1569 Mar 31",
        "PLACEOFBIRTH": "Thun in Tirol",
        "PLACEOFDEATH": "Thun in Tirol"
    },
    {
        "ID": "12222",
        "NAME": "Thun, Georg (1497\u20131567), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1497 Jul 12",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "Thun in Tirol",
        "PLACEOFDEATH": "Kufstein"
    },
    {
        "ID": "12223",
        "NAME": "Mollard, Ludwig (1575\u20131623), Hofkriegsrat",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1623 Feb 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12224",
        "NAME": "Serntein, Johann (1420\u20131475)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1475 Sep 17",
        "PLACEOFBIRTH": "Nordheim im Sarntal",
        "PLACEOFDEATH": "Sarnthein:Pfarrkirche"
    },
    {
        "ID": "12225",
        "NAME": "Serntein, Zyprian (1457\u20131524), Hofkanzler",
        "DATEOFBIRTH": "1457",
        "DATEOFDEATH": "1524 Apr 07",
        "PLACEOFBIRTH": "H\u00f6rtenberg im Inntal",
        "PLACEOFDEATH": "Innsbruck:Jakobskirche"
    },
    {
        "ID": "12226",
        "NAME": "Serntein, Karl (1510\u20131560), Truchsess",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1560",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12227",
        "NAME": "Serntein, Johann Friedrich (1550\u20131595)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1595",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12228",
        "NAME": "Serntein, Maximilian (1590\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1646 Nov 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "12229",
        "NAME": "Serntein, Johann (1471\u20131547)",
        "DATEOFBIRTH": "1471",
        "DATEOFDEATH": "1547 Jan 13",
        "PLACEOFBIRTH": "H\u00f6rtenberg im Inntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12230",
        "NAME": "Fuchs von Fuchsberg, Johann Karl (1625\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1664 Jun 08",
        "PLACEOFBIRTH": "Lebenberg im Etschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12231",
        "NAME": "Fernberger, Johann (1490\u20131554)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1554",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "12232",
        "NAME": "Fernberger, Ulrich (1520\u20131573)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1573 Jul",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Vorchdorf im Traunviertel"
    },
    {
        "ID": "12233",
        "NAME": "Fernberger, Friedrich (1525\u20131564)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1564",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12234",
        "NAME": "Fernberger, Christoph (1530\u20131593)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1593",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12235",
        "NAME": "Fernberger, Wolfgang Adam (1575\u20131639), Panetier",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12236",
        "NAME": "Fernberger, Anna (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12237",
        "NAME": "Fernberger, Ulrich (1450\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12238",
        "NAME": "Fernberger, Albrecht (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12239",
        "NAME": "Fernberger, Johann (1511\u20131584)",
        "DATEOFBIRTH": "1511",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "Auer an der Etsch",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12240",
        "NAME": "Fernberger, Georg Christoph (1557\u20131594)",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12241",
        "NAME": "Trautson, Balthasar (1535\u20131594), Oberststallmeister",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "Stein am Gallian",
        "PLACEOFDEATH": "Rovereid"
    },
    {
        "ID": "12242",
        "NAME": "Trautson, Anna Maria (1572\u20131602)",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1602 Mar 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12243",
        "NAME": "Trautson, Johann (1570\u20131598), Edelknabe",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12247",
        "NAME": "Trautson, Anton (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12248",
        "NAME": "Trautson, Maximilian (1590\u20131629), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12249",
        "NAME": "Trautson, Ferdinand (1565\u20131615), Reichshofrat",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1615 Apr 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12250",
        "NAME": "T\u00e4nzl von Trazberg, Christian (1430\u20131491)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1491 Feb 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Schwaz in Tirol"
    },
    {
        "ID": "12251",
        "NAME": "T\u00e4nzl von Trazberg, Simon (1470\u20131525)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1525 Okt 01",
        "PLACEOFBIRTH": "Schwaz in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12252",
        "NAME": "T\u00e4nzl von Trazberg, Kaspar Joachim (1510\u20131553)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1553",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12253",
        "NAME": "T\u00e4nzl von Trazberg, Simon (1550\u20131605), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Krumau in B\u00f6hmen"
    },
    {
        "ID": "12254",
        "NAME": "T\u00e4nzl von Trazberg, Matthias (1581\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1581",
        "DATEOFDEATH": "1638 Aug 03",
        "PLACEOFBIRTH": "Waldbach in Schwaben",
        "PLACEOFDEATH": "Lauingen an der Donau"
    },
    {
        "ID": "12255",
        "NAME": "T\u00e4nzl von Trazberg, Veit Jakob (1465\u20131530)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1530 Apr 16",
        "PLACEOFBIRTH": "Schwaz in Tirol",
        "PLACEOFDEATH": "Schwaz in Tirol"
    },
    {
        "ID": "12256",
        "NAME": "T\u00e4nzl von Trazberg, Johann Jakob (1505\u20131536)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1536",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12257",
        "NAME": "Pergen, Benedikt (1545\u20131611)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12258",
        "NAME": "Pergen, Karl (1592\u20131646)",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1646 Jul 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12259",
        "NAME": "Pergen, Johann Heinrich (1629\u20131702), K\u00e4mmerer",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1702",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12260",
        "NAME": "Pergen, Karl (1623\u20131659)",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1659 Feb 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12261",
        "NAME": "Pranckh, Johann Christoph (1580\u20131640), Oberststallmeister",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1640",
        "PLACEOFBIRTH": "Sankt Marein in der Steiermark",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12262",
        "NAME": "Pranckh, Maria Felizitas (1610\u20131663)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "Sankt Marein in der Steiermark",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12263",
        "NAME": "Hendl von Goldrain, Siegmund (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Imst",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12264",
        "NAME": "Hendl von Goldrain, Franz (1540\u20131592), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1592 Feb 16",
        "PLACEOFBIRTH": "Goldrain im Vinschgau",
        "PLACEOFDEATH": "Latsch im Vinschgau"
    },
    {
        "ID": "12265",
        "NAME": "Hendl von Goldrain, Siegmund (1530\u20131584)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "Goldrain im Vinschgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12266",
        "NAME": "Hendl von Goldrain, Reinprecht (1580\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "Goldrain im Vinschgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12267",
        "NAME": "Hendl von Goldrain, Sibylla (1570\u20131598)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Goldrain im Vinschgau",
        "PLACEOFDEATH": "Fahlburg"
    },
    {
        "ID": "12268",
        "NAME": "Hendl von Goldrain, Maximilian (1570\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Kastelbell im Vinschgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12269",
        "NAME": "Hendl von Goldrain, Maximiliana (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kastelbell im Vinschgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12270",
        "NAME": "Hendl von Goldrain, Johann Baptist (1599\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kastelbell im Vinschgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12271",
        "NAME": "Hendl von Goldrain, Christoph (1565\u20131618)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "Kastelbell im Vinschgau",
        "PLACEOFDEATH": "Tschars im Vinschgau"
    },
    {
        "ID": "12272",
        "NAME": "Hendl von Goldrain, Siegmund (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Goldrain im Vinschgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12273",
        "NAME": "Hendl von Goldrain, Johann Kaspar (1650\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Goldrain im Vinschgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12274",
        "NAME": "Liechtenstein von Kastelkorn, Georg (1520\u20131561)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1561",
        "PLACEOFBIRTH": "Leifers",
        "PLACEOFDEATH": "Rattenberg in Tirol"
    },
    {
        "ID": "12275",
        "NAME": "Liechtenstein von Kastelkorn, Konstantin (1550\u20131614)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1614",
        "PLACEOFBIRTH": "Leifers",
        "PLACEOFDEATH": "Konstantinopel"
    },
    {
        "ID": "12276",
        "NAME": "Liechtenstein von Kastelkorn, Georg (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12277",
        "NAME": "Liechtenstein von Kastelkorn, Konstantin (1600\u20131662)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1662 Jul 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "12278",
        "NAME": "Liechtenstein von Kastelkorn, Konstantin (1595\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1635 Jan 01",
        "PLACEOFBIRTH": "Leifers",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "12279",
        "NAME": "Liechtenstein von Kastelkorn, Christoph Philipp (1645\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schenna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12280",
        "NAME": "Sch\u00e4tzl, Urban (1561\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1561",
        "DATEOFDEATH": "1638 Okt 04",
        "PLACEOFBIRTH": "Thyrnau vor dem Wald",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "12281",
        "NAME": "Madrutsch, Johann Gaudenz (1486\u20131550)",
        "DATEOFBIRTH": "1486",
        "DATEOFDEATH": "1550 Aug 20",
        "PLACEOFBIRTH": "Madrutsch",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "12282",
        "NAME": "Madrutsch, Niklas (1508\u20131572), K\u00e4mmerer",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "1572 Dez 23",
        "PLACEOFBIRTH": "Madrutsch",
        "PLACEOFDEATH": "Riva del Garda"
    },
    {
        "ID": "12283",
        "NAME": "Madrutsch, Ludwig (1532\u20131600), Bischof von Trient",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1600 Apr 02",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "12284",
        "NAME": "Madrutsch, Fortunat (1538\u20131612)",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": "Fersen im Suganertal"
    },
    {
        "ID": "12285",
        "NAME": "Madrutsch, Johann Friedrich (1534\u20131586)",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1586 Apr 09",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": "Issogne im Aostatal"
    },
    {
        "ID": "12286",
        "NAME": "Madrutsch, Karl Gaudenz (1562\u20131629), Bischof von Trient",
        "DATEOFBIRTH": "1562",
        "DATEOFDEATH": "1629 Aug 19",
        "PLACEOFBIRTH": "Issogne im Aostatal",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "12287",
        "NAME": "Madrutsch, Ferdinand Gabriel (1564\u20131607), Mundschenk",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "Issogne im Aostatal",
        "PLACEOFDEATH": "Nancy"
    },
    {
        "ID": "12288",
        "NAME": "Madrutsch, Christoph (1512\u20131578), Bischof von Trient",
        "DATEOFBIRTH": "1512 Jul 05",
        "DATEOFDEATH": "1578 Jul 05",
        "PLACEOFBIRTH": "Madrutsch",
        "PLACEOFDEATH": "Tivoli"
    },
    {
        "ID": "12289",
        "NAME": "Stadl, Gottfried (1560\u20131627), Hofkriegsrat",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1627 Mai 29",
        "PLACEOFBIRTH": "Riegersburg in der Steiermark",
        "PLACEOFDEATH": "Graz:Jesuitenkirche"
    },
    {
        "ID": "12290",
        "NAME": "Hundbi\u00df, Friedrich (1305\u20131346)",
        "DATEOFBIRTH": "1305~",
        "DATEOFDEATH": "1346",
        "PLACEOFBIRTH": "Ravensburg im Schussental",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12291",
        "NAME": "Thanr\u00e4dl, Heinrich (1445\u20131494)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1494",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12292",
        "NAME": "Thanr\u00e4dl, Wolfgang (1475\u20131535)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1535",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12293",
        "NAME": "Thanr\u00e4dl, Andreas (1509\u20131566)",
        "DATEOFBIRTH": "1509",
        "DATEOFDEATH": "1566 Feb 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12294",
        "NAME": "Thanr\u00e4dl, Balthasar (1535\u20131600), Hofkammerrat",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1600 Dez 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12295",
        "NAME": "Thanr\u00e4dl, Wolfgang (1574\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12296",
        "NAME": "Spaur, Anton (1574\u20131629), K\u00e4mmerer",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12297",
        "NAME": "Fuchs von Fuchsberg, Helena (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sankt Michael in Eppan",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12298",
        "NAME": "Wittelsbach, Wilhelm (1548\u20131626), Herzog in Bayern",
        "DATEOFBIRTH": "1548 Sep 29",
        "DATEOFDEATH": "1626 Feb 07",
        "PLACEOFBIRTH": "Landshut in Niederbayern",
        "PLACEOFDEATH": "Schlei\u00dfheim"
    },
    {
        "ID": "12299",
        "NAME": "Wittelsbach, Maria Anna (1574\u20131616)",
        "DATEOFBIRTH": "1574 Dez 18",
        "DATEOFDEATH": "1616 Mar 08",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "12300",
        "NAME": "Wittelsbach, Maximilian (1573\u20131651), Herzog in Bayern",
        "DATEOFBIRTH": "1573 Apr 17",
        "DATEOFDEATH": "1651 Sep 27",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "12301",
        "NAME": "Borromeo, Johann (1439\u20131495)",
        "DATEOFBIRTH": "1439 Mai 12",
        "DATEOFDEATH": "1495 Nov 14",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "12302",
        "NAME": "Borromeo, Giselbrecht (1463\u20131508)",
        "DATEOFBIRTH": "1463",
        "DATEOFDEATH": "1508 Feb 27",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "12303",
        "NAME": "Borromeo, Friedrich (1492\u20131529)",
        "DATEOFBIRTH": "1492",
        "DATEOFDEATH": "1529 Jun 05",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "12304",
        "NAME": "Borromeo, Ludwig (1468\u20131527)",
        "DATEOFBIRTH": "1468 Aug 26",
        "DATEOFDEATH": "1527 Okt 05",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12305",
        "NAME": "Borromeo, Kamil (1500\u20131549), K\u00e4mmerer",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1549 Jan 28",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "12306",
        "NAME": "Borromeo, Justina (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12307",
        "NAME": "Manrique de Lara, Jakob (1530\u2013\u00a0\u00a0\u00a0\u00a0), Mundschenk",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12308",
        "NAME": "Manrique de Lara, Philipp (1535\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12309",
        "NAME": "Manrique de Lara, Johann (1536\u20131593), K\u00e4mmerer",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1593 Jun 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12310",
        "NAME": "Manrique de Lara, Maria (1538\u20131608)",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1608 Feb 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Raudnitz an der Elbe"
    },
    {
        "ID": "12311",
        "NAME": "Manrique de Lara, Bernhard (1490\u20131565)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1565",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Parma"
    },
    {
        "ID": "12312",
        "NAME": "Manrique de Lara, Maria (1570\u20131636)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1636 Apr 30",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12313",
        "NAME": "Pernstein, Barzel (1530\u20131582), Oberstkanzler von B\u00f6hmen",
        "DATEOFBIRTH": "1530 Jul 09",
        "DATEOFDEATH": "1582 Okt 27",
        "PLACEOFBIRTH": "Meseritsch in M\u00e4hren",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "12314",
        "NAME": "Pernstein, Johann (1561\u20131597), K\u00e4mmerer",
        "DATEOFBIRTH": "1561 Jul 30",
        "DATEOFDEATH": "1597 Sep 29",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "12315",
        "NAME": "Pernstein, Barzel Euseb (1594\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1631 Jul 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Tangerm\u00fcnde"
    },
    {
        "ID": "12316",
        "NAME": "Pernstein, Polyxena (1567\u20131642)",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1642 Mai 24",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12317",
        "NAME": "Pernstein, Johanna (1566\u20131631)",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "1631 Jan 03",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12318",
        "NAME": "Manrique de Lara, Georg (1535\u20131609)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Desio in der Lombardei"
    },
    {
        "ID": "12319",
        "NAME": "Manrique de Lara, Andreas (1575\u20131618)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Desio in der Lombardei"
    },
    {
        "ID": "12320",
        "NAME": "Manrique de Lara, Johann (1600\u20131682)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1682",
        "PLACEOFBIRTH": "Desio in der Lombardei",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12321",
        "NAME": "Hohenems, Ulrich (1400\u20131449)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1449",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12322",
        "NAME": "Hohenems, Markward (1430\u20131488)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1488",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12323",
        "NAME": "Pernstein, Jaroslaus (1528\u20131569), Oberststallmeister",
        "DATEOFBIRTH": "1528 Nov 14",
        "DATEOFDEATH": "1569 Jul 27",
        "PLACEOFBIRTH": "Kromau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12324",
        "NAME": "Basta, Karl (1589\u20131612), K\u00e4mmerer",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Troppau"
    },
    {
        "ID": "12325",
        "NAME": "Basta, Ferdinand (1596\u20131652)",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1652 Sep 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hainburg an der Donau"
    },
    {
        "ID": "12326",
        "NAME": "Basta, Niklas (1627\u20131682)",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1682",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12327",
        "NAME": "Gatta, Foppe (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12328",
        "NAME": "Gatta, Karl (1605\u20131656)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "12329",
        "NAME": "Valmarana, Askan (1576\u20131623), K\u00e4mmerer",
        "DATEOFBIRTH": "1576 Sep 30",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "Vicenza",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12330",
        "NAME": "Waldstein, Heinrich (1574\u20131600)",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1600 Jul 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12331",
        "NAME": "Waldstein, Bartlome (1575\u20131617)",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1617 Apr 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12332",
        "NAME": "Waldstein, Johann Christoph (1608\u20131655)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1655 Apr 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12333",
        "NAME": "Waldstein, Hannibal (1600\u20131637)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12334",
        "NAME": "Waldstein, Sidonius (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12335",
        "NAME": "Waldstein, Franz August (1628\u20131684), Obersthofmarschall",
        "DATEOFBIRTH": "1628",
        "DATEOFDEATH": "1684 Aug 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12336",
        "NAME": "Waldstein, Katharina (1568\u20131637)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1637 Feb 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prerau in M\u00e4hren"
    },
    {
        "ID": "12337",
        "NAME": "Waldstein, Anna (1584\u20131605)",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1605 Aug 09",
        "PLACEOFBIRTH": "Hermanitz an der Elbe",
        "PLACEOFDEATH": "Brandeis an der Adler"
    },
    {
        "ID": "12338",
        "NAME": "Waldstein, Hannibal (1576\u20131622), Oberstm\u00fcnzmeister in B\u00f6hmen",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1622 Apr 21",
        "PLACEOFBIRTH": "Arnau in B\u00f6hmen",
        "PLACEOFDEATH": "Gr\u00e4tz an der Elbe"
    },
    {
        "ID": "12339",
        "NAME": "Waldstein, Johann Wilhelm (1600\u20131640)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1640~",
        "PLACEOFBIRTH": "Arnau in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12340",
        "NAME": "Echter von Mespelbrunn, Valentin (1550\u20131624), Reichshofrat",
        "DATEOFBIRTH": "1550 Mai 21",
        "DATEOFDEATH": "1624 Sep 24",
        "PLACEOFBIRTH": "Mespelbrunn im Spessart",
        "PLACEOFDEATH": "\u00d6ttershausen"
    },
    {
        "ID": "12341",
        "NAME": "Ser\u00e9nyi, Margarita (1630\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12342",
        "NAME": "Liechtenstein von Nikolsburg, Ferdinand (1622\u20131666)",
        "DATEOFBIRTH": "1622 Dez 27",
        "DATEOFDEATH": "1666 Jan 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12343",
        "NAME": "Salm, Elisabeth (1565\u20131615)",
        "DATEOFBIRTH": "1565 Jun 30",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12344",
        "NAME": "Lobkowicz, Lassel (1566\u20131621), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1566 Okt 15",
        "DATEOFDEATH": "1621 Mar 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "12345",
        "NAME": "Salm, Anna (1598\u20131647)",
        "DATEOFBIRTH": "1598 Okt 24",
        "DATEOFDEATH": "1647 Okt 15",
        "PLACEOFBIRTH": "Neuburg am Inn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12346",
        "NAME": "Schlick, Maria Sidonia (1625\u20131691)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1691",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12347",
        "NAME": "Metternich, Johann (1500\u20131562)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1562",
        "PLACEOFBIRTH": "Koblenz am Rhein",
        "PLACEOFDEATH": "Trier"
    },
    {
        "ID": "12348",
        "NAME": "Metternich, Johann Theoderich (1553\u20131625)",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1625 Mar 20",
        "PLACEOFBIRTH": "Vettelhoven",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12349",
        "NAME": "Metternich, Anna (1548\u20131620)",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1620~",
        "PLACEOFBIRTH": "Vettelhoven",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12350",
        "NAME": "Metternich, Lothar (1551\u20131623), Erzbischof von Trier",
        "DATEOFBIRTH": "1551 Aug 31",
        "DATEOFDEATH": "1623 Sep 17",
        "PLACEOFBIRTH": "Vettelhoven",
        "PLACEOFDEATH": "Koblenz am Rhein"
    },
    {
        "ID": "12351",
        "NAME": "Wittelsbach, Ferdinand (1550\u20131608)",
        "DATEOFBIRTH": "1550 Jan 20",
        "DATEOFDEATH": "1608 Jan 30",
        "PLACEOFBIRTH": "Landshut in Niederbayern",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "12352",
        "NAME": "Wittelsbach, Franz Wilhelm (1593\u20131661), Graf von Wartenberg",
        "DATEOFBIRTH": "1593 Mar 01",
        "DATEOFDEATH": "1661 Mai 06",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "12353",
        "NAME": "Hohenems, Kaspar (1573\u20131640), K\u00e4mmerer",
        "DATEOFBIRTH": "1573 Mar 01",
        "DATEOFDEATH": "1640 Sep 10",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Hohenems"
    },
    {
        "ID": "12354",
        "NAME": "Hohenems, Wolfgang Theoderich (1507\u20131538)",
        "DATEOFBIRTH": "1507",
        "DATEOFDEATH": "1538",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12355",
        "NAME": "Hohenems, Jakob Hannibal (1530\u20131587), K\u00e4mmerer",
        "DATEOFBIRTH": "1530 Mai 13",
        "DATEOFDEATH": "1587 Dez 26",
        "PLACEOFBIRTH": "Bludenz",
        "PLACEOFDEATH": "Hohenems"
    },
    {
        "ID": "12356",
        "NAME": "Hohenems, Jakob Hannibal (1595\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1595 Mar 20",
        "DATEOFDEATH": "1646 Apr 10",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Hohenems"
    },
    {
        "ID": "12357",
        "NAME": "Hohenems, Karl Friedrich (1622\u20131675)",
        "DATEOFBIRTH": "1622 Nov 11",
        "DATEOFDEATH": "1675 Okt 20",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Hohenems"
    },
    {
        "ID": "12358",
        "NAME": "Hohenems, Franz Wilhelm (1628\u20131662)",
        "DATEOFBIRTH": "1628",
        "DATEOFDEATH": "1662 Sep 19",
        "PLACEOFBIRTH": "Ensisheim",
        "PLACEOFDEATH": "Chur in Graub\u00fcnden"
    },
    {
        "ID": "12359",
        "NAME": "Hohenems, Jakob Hannibal (1652\u20131730), Obersthofmeister",
        "DATEOFBIRTH": "1652 Mar 07",
        "DATEOFDEATH": "1730 Aug 14",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12360",
        "NAME": "Hohenems, Mark Sittich (1574\u20131619), Erzbischof von Salzburg",
        "DATEOFBIRTH": "1574 Jun 24",
        "DATEOFDEATH": "1619 Okt 09",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "12361",
        "NAME": "Firmian, Georg Siegmund (1596\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1596 Nov 08",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kronmetz im Etschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12362",
        "NAME": "Borromeo, Philipp (1467\u20131508)",
        "DATEOFBIRTH": "1467 Mar 04",
        "DATEOFDEATH": "1508 Sep 14",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": "Peschiera"
    },
    {
        "ID": "12363",
        "NAME": "Borromeo, Johann (1490\u20131536)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1536 Apr 08",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12364",
        "NAME": "Borromeo, Philipp (1519\u20131562)",
        "DATEOFBIRTH": "1519",
        "DATEOFDEATH": "1562 Nov 27",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12365",
        "NAME": "Borromeo, Konstantia (1547\u20131576)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12366",
        "NAME": "Dietrichstein, Ludwig (1553\u20131615)",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12367",
        "NAME": "Capliers, Wenzel (1520\u20131579)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12368",
        "NAME": "Capliers, Sedeslaus (1550\u20131603), Truchsess",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12369",
        "NAME": "Capliers, Johann Burian (1580\u20131618), Truchsess",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Zwettl im Waldviertel"
    },
    {
        "ID": "12370",
        "NAME": "J\u00f6rger von Tollet, Wolfgang (1460\u20131524), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1524 Mar 15",
        "PLACEOFBIRTH": "Tollet an der Trattnach",
        "PLACEOFDEATH": "Sankt Georgen am Steinbach"
    },
    {
        "ID": "12371",
        "NAME": "J\u00f6rger von Tollet, Christoph (1502\u20131578)",
        "DATEOFBIRTH": "1502",
        "DATEOFDEATH": "1578 Jan 19",
        "PLACEOFBIRTH": "Tollet an der Trattnach",
        "PLACEOFDEATH": "Kroisbach"
    },
    {
        "ID": "12372",
        "NAME": "J\u00f6rger von Tollet, Johann (1503\u20131550)",
        "DATEOFBIRTH": "1503",
        "DATEOFDEATH": "1550~",
        "PLACEOFBIRTH": "Tollet an der Trattnach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12373",
        "NAME": "J\u00f6rger von Tollet, Sebastian (1530\u20131571)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1571 Nov 21",
        "PLACEOFBIRTH": "Tollet an der Trattnach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12374",
        "NAME": "J\u00f6rger von Tollet, Wolfgang (1537\u20131613), K\u00e4mmerer",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1613 Mar 07",
        "PLACEOFBIRTH": "Tollet an der Trattnach",
        "PLACEOFDEATH": "Steyregg im M\u00fchlviertel"
    },
    {
        "ID": "12375",
        "NAME": "J\u00f6rger von Tollet, Helmhard (1572\u20131631), Vorschneider",
        "DATEOFBIRTH": "1572 Feb 17",
        "DATEOFDEATH": "1631 Jan 01",
        "PLACEOFBIRTH": "Starhemberg am Hausruck",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "12376",
        "NAME": "Hornstein, Jakob Ernst (1511\u20131580)",
        "DATEOFBIRTH": "1511",
        "DATEOFDEATH": "1580 Nov 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Gr\u00fcningen in Schwaben"
    },
    {
        "ID": "12377",
        "NAME": "Hornstein, Balthasar (1540\u20131620)",
        "DATEOFBIRTH": "1540",
        "DATEOFDEATH": "1620 Jan 16",
        "PLACEOFBIRTH": "Gr\u00fcningen in Schwaben",
        "PLACEOFDEATH": "Gr\u00fcningen in Schwaben"
    },
    {
        "ID": "12378",
        "NAME": "Hornstein, Johann Christoph (1542\u20131606), Geheimer Rat",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1606 Jul 16",
        "PLACEOFBIRTH": "Gr\u00fcningen in Schwaben",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12379",
        "NAME": "Hornstein, Johann Erhard (1578\u20131625)",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1625 Nov 04",
        "PLACEOFBIRTH": "Stoffeln im Hegau",
        "PLACEOFDEATH": "Stoffeln im Hegau"
    },
    {
        "ID": "12380",
        "NAME": "Esclaibes, Ruprecht (1576\u20131664)",
        "DATEOFBIRTH": "1576 Feb 28",
        "DATEOFDEATH": "1664 Okt 10",
        "PLACEOFBIRTH": "Clermont en Cambr\u00e9sis",
        "PLACEOFDEATH": "Clermont en Cambr\u00e9sis"
    },
    {
        "ID": "12381",
        "NAME": "Ter Gracht, Walter (1540\u20131593), K\u00e4mmerer",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1593 Mai 07",
        "PLACEOFBIRTH": "Maelstede",
        "PLACEOFDEATH": "Kortr\u0133k"
    },
    {
        "ID": "12382",
        "NAME": "Ter Gracht, Walter (1575\u20131623)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "Kortr\u0133k",
        "PLACEOFDEATH": "Kortr\u0133k"
    },
    {
        "ID": "12383",
        "NAME": "Ter Gracht, Maria (1585\u20131662)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1662",
        "PLACEOFBIRTH": "Kortr\u0133k",
        "PLACEOFDEATH": "Clermont en Cambr\u00e9sis"
    },
    {
        "ID": "12384",
        "NAME": "Ter Gracht, Franziska (1590\u20131650)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "Kortr\u0133k",
        "PLACEOFDEATH": "Hainburg an der Donau"
    },
    {
        "ID": "12388",
        "NAME": "Ter Gracht, Anton (1550\u20131619), Truchsess",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1619 Mar 17",
        "PLACEOFBIRTH": "Schardau",
        "PLACEOFDEATH": "Mechelen"
    },
    {
        "ID": "12389",
        "NAME": "Werth, Johann (1591\u20131652)",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1652 Sep 12",
        "PLACEOFBIRTH": "B\u00fcttgen am Niederrhein",
        "PLACEOFDEATH": "Benatek an der Iser"
    },
    {
        "ID": "12390",
        "NAME": "Batthy\u00e1ny, Balthasar (1542\u20131590), Mundschenk",
        "DATEOFBIRTH": "1542 Jan 24",
        "DATEOFDEATH": "1590 Feb 11",
        "PLACEOFBIRTH": "Schlaining",
        "PLACEOFDEATH": "Rechnitz"
    },
    {
        "ID": "12391",
        "NAME": "Hohenzollern, Joachim (1554\u20131587)",
        "DATEOFBIRTH": "1554 Jun 21",
        "DATEOFDEATH": "1587 Jul 07",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": "K\u00f6lln an der Spree"
    },
    {
        "ID": "12392",
        "NAME": "Hohenzollern, Johann Georg (1580\u20131622)",
        "DATEOFBIRTH": "1580 Mai 12",
        "DATEOFDEATH": "1622 Mar 16",
        "PLACEOFBIRTH": "K\u00f6lln an der Spree",
        "PLACEOFDEATH": "K\u00f6nigsberg im Eulengebirge"
    },
    {
        "ID": "12393",
        "NAME": "Hohenzollern, Meinrad (1605\u20131681)",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1681 Jan 30",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Sigmaringen"
    },
    {
        "ID": "12394",
        "NAME": "Hohenzollern, Johann (1578\u20131638)",
        "DATEOFBIRTH": "1578 Aug 17",
        "DATEOFDEATH": "1638 Mar 22",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "12395",
        "NAME": "Hohenzollern, Ernst Georg (1585\u20131625), Landesherr von Krauchenwies",
        "DATEOFBIRTH": "1585 Mai 07",
        "DATEOFDEATH": "1625 Apr 19",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": "Wallerstein"
    },
    {
        "ID": "12396",
        "NAME": "Helfenstein, Rudolf (1560\u20131601)",
        "DATEOFBIRTH": "1560 Mar 24",
        "DATEOFDEATH": "1601 Feb 16",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "12397",
        "NAME": "Dietrichstein, Siegfried (1507\u20131568)",
        "DATEOFBIRTH": "1507",
        "DATEOFDEATH": "1568",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Weixelst\u00e4tten"
    },
    {
        "ID": "12398",
        "NAME": "Dietrichstein, Wilhelm (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12399",
        "NAME": "Dietrichstein, Gabriel (1594\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1594 Jan 27",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12400",
        "NAME": "Wittelsbach, Ferdinand Maria (1636\u20131679), Herzog in Bayern",
        "DATEOFBIRTH": "1636 Okt 31",
        "DATEOFDEATH": "1679 Mai 26",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Schlei\u00dfheim"
    },
    {
        "ID": "12401",
        "NAME": "Lamberg, Wilhelm (1356\u20131414)",
        "DATEOFBIRTH": "1356",
        "DATEOFDEATH": "1414",
        "PLACEOFBIRTH": "Ortenegg in der Windischen Mark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12402",
        "NAME": "Lamberg, Balthasar (1400\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ortenegg in der Windischen Mark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12403",
        "NAME": "Lamberg, Georg (1450\u20131499)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1499",
        "PLACEOFBIRTH": "Ortenegg in der Windischen Mark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12404",
        "NAME": "Lamberg, Kaspar (1492\u20131548)",
        "DATEOFBIRTH": "1492",
        "DATEOFDEATH": "1548 Apr 27",
        "PLACEOFBIRTH": "Ortenegg in der Windischen Mark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12405",
        "NAME": "Lamberg, Siegmund (1539\u20131619), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1539 Apr 28",
        "DATEOFDEATH": "1619 Nov 18",
        "PLACEOFBIRTH": "Ottenstein im Waldviertel",
        "PLACEOFDEATH": "Kitzb\u00fchel"
    },
    {
        "ID": "12406",
        "NAME": "Lamberg, Georg Siegmund (1565\u20131630), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1565 Apr 14",
        "DATEOFDEATH": "1630 Jun 07",
        "PLACEOFBIRTH": "Ottenstein im Waldviertel",
        "PLACEOFDEATH": "Kitzb\u00fchel"
    },
    {
        "ID": "12407",
        "NAME": "Lamberg, Franz Joseph (1637\u20131712), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1637 Okt 29",
        "DATEOFDEATH": "1712 Nov 02",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Steyr"
    },
    {
        "ID": "12408",
        "NAME": "Lamberg, Leopold Matthias (1667\u20131711), Landgraf von Leuchtenberg",
        "DATEOFBIRTH": "1667 Feb 23",
        "DATEOFDEATH": "1711 Mar 10",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12409",
        "NAME": "Lamberg, Jakob (1390\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ortenegg in der Windischen Mark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12410",
        "NAME": "Lamberg, Siegmund (1425\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rottenb\u00fcchel in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12411",
        "NAME": "Lamberg, Siegmund (1460\u20131518)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1518",
        "PLACEOFBIRTH": "Rottenb\u00fcchel in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12412",
        "NAME": "Lamberg, Georg (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rottenb\u00fcchel in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12413",
        "NAME": "Lamberg, Sebastian (1520\u20131586)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "Rottenb\u00fcchel in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12414",
        "NAME": "Lamberg, Johann Georg (1550\u20131597)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "Rottenb\u00fcchel in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12415",
        "NAME": "Lamberg, Sebastian (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rottenb\u00fcchel in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12416",
        "NAME": "Lamberg, Johann Philipp (1651\u20131712), Bischof von Passau",
        "DATEOFBIRTH": "1651 Nov 26",
        "DATEOFDEATH": "1712 Okt 20",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "12417",
        "NAME": "Lamberg, Johann Albrecht (1584\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1650 Apr 14",
        "PLACEOFBIRTH": "Ottenstein im Waldviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12418",
        "NAME": "Lamberg, Johann Franz (1618\u20131666), K\u00e4mmerer",
        "DATEOFBIRTH": "1618 Feb 27",
        "DATEOFDEATH": "1666 Apr 15",
        "PLACEOFBIRTH": "Ottenstein im Waldviertel",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "12419",
        "NAME": "Lamberg, Leopold Joseph (1653\u20131706), K\u00e4mmerer",
        "DATEOFBIRTH": "1653 Mai 13",
        "DATEOFDEATH": "1706 Jun 28",
        "PLACEOFBIRTH": "Ottenstein im Waldviertel",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "12420",
        "NAME": "Rechberg, Johann (1510\u20131574)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1574 Sep 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12421",
        "NAME": "Rechberg, Kaspar Bernhard (1545\u20131605)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1605 Okt 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12422",
        "NAME": "Rechberg, Kaspar Bernhard (1588\u20131651)",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1651 Nov 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12423",
        "NAME": "Rechberg, Johann (1631\u20131676), K\u00e4mmerer",
        "DATEOFBIRTH": "1631 Jun 05",
        "DATEOFDEATH": "1676 Jun 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12424",
        "NAME": "J\u00f6rger von Tollet, Johann (1558\u20131627)",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Tollet an der Trattnach",
        "PLACEOFDEATH": "Hofkirchen an der Trattnach"
    },
    {
        "ID": "12425",
        "NAME": "J\u00f6rger von Tollet, Susanna Polyxena (1590\u20131638)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1638 Mai 23",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12426",
        "NAME": "Herberstein, Ursula (1465\u20131533)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1533",
        "PLACEOFBIRTH": "Wippach in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12427",
        "NAME": "Mollard, Peter Ernst (1590\u20131655), Obersthofmeister",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1655 Dez 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12428",
        "NAME": "Muschinger, Maria Katharina (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gumpendorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12429",
        "NAME": "Mollard, Franz Maximilian (1628\u20131690), K\u00e4mmerer",
        "DATEOFBIRTH": "1628",
        "DATEOFDEATH": "1690 Jun 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12430",
        "NAME": "Mollard, Peter Ernst (1641\u20131686), Oberstk\u00fcchenmeister",
        "DATEOFBIRTH": "1641",
        "DATEOFDEATH": "1686 Dez 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12431",
        "NAME": "Thoman von Frankenberg, Paul (1600\u20131648), Reichshofratssekret\u00e4r",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1648 Dez 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12432",
        "NAME": "Thoman von Frankenberg, Maria Katharina (1630\u20131694)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1694 Okt 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12433",
        "NAME": "Seeau, Gilg (1590\u20131663)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "Goisern am Hallst\u00e4ttersee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12434",
        "NAME": "Seeau, Michael Ferdinand (1640\u20131668)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1668",
        "PLACEOFBIRTH": "M\u00fchlleiten an der Traun",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "12435",
        "NAME": "Seeau, Elias (1595\u20131670)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1670 Feb 19",
        "PLACEOFBIRTH": "Goisern am Hallst\u00e4ttersee",
        "PLACEOFDEATH": "W\u00fcrting"
    },
    {
        "ID": "12436",
        "NAME": "Seeau, Johann Friedrich (1659\u20131729), K\u00e4mmerer",
        "DATEOFBIRTH": "1659 Aug 05",
        "DATEOFDEATH": "1729 Dez 06",
        "PLACEOFBIRTH": "W\u00fcrting",
        "PLACEOFDEATH": "W\u00fcrting"
    },
    {
        "ID": "12437",
        "NAME": "Seeau, Johann Ehrenreich (1666\u20131708), Hofkammerrat",
        "DATEOFBIRTH": "1666 Jun 15",
        "DATEOFDEATH": "1708",
        "PLACEOFBIRTH": "W\u00fcrting",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12438",
        "NAME": "Seeau, Elisabeth (1599\u20131669)",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1669 Mai 24",
        "PLACEOFBIRTH": "Goisern am Hallst\u00e4ttersee",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12439",
        "NAME": "Lamberg, Susanna (1585\u20131620)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1620~",
        "PLACEOFBIRTH": "Ottenstein im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12440",
        "NAME": "B\u00e1thory, Stephan (1477\u20131534)",
        "DATEOFBIRTH": "1477",
        "DATEOFDEATH": "1534 Mar 17",
        "PLACEOFBIRTH": "Schomlenmarkt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12441",
        "NAME": "B\u00e1thory, Friedrich (1250\u20131321)",
        "DATEOFBIRTH": "1250~",
        "DATEOFDEATH": "1321",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12442",
        "NAME": "B\u00e1thory, Johann (1280\u20131350)",
        "DATEOFBIRTH": "1280~",
        "DATEOFDEATH": "1350~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12443",
        "NAME": "B\u00e1thory, Lassel (1320\u20131373)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "1373",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12444",
        "NAME": "B\u00e1thory, Stenzel (1350\u20131395)",
        "DATEOFBIRTH": "1350~",
        "DATEOFDEATH": "1395",
        "PLACEOFBIRTH": "Schomlenmarkt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12445",
        "NAME": "B\u00e1thory, Stephan (1390\u20131453)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1453",
        "PLACEOFBIRTH": "Schomlenmarkt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12446",
        "NAME": "B\u00e1thory, Niklas (1430\u20131498)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1498",
        "PLACEOFBIRTH": "Schomlenmarkt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12447",
        "NAME": "B\u00e1thory, Andreas (1440\u20131496)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1496",
        "PLACEOFBIRTH": "Ecsed",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12448",
        "NAME": "B\u00e1thory, Andreas (1485\u20131534)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1534",
        "PLACEOFBIRTH": "Ecsed",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12449",
        "NAME": "B\u00e1thory, Georg (1520\u20131570)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1570",
        "PLACEOFBIRTH": "Ecsed",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12450",
        "NAME": "Lobkowicz, Johann (1527\u20131590), Hofdiener",
        "DATEOFBIRTH": "1527",
        "DATEOFDEATH": "1590 Jun 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12451",
        "NAME": "Lobkowicz, Helena (1554\u20131589)",
        "DATEOFBIRTH": "1554",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12452",
        "NAME": "Lobkowicz, Adam Gall (1557\u20131605), K\u00e4mmerer",
        "DATEOFBIRTH": "1557 Okt 09",
        "DATEOFDEATH": "1605 Mai 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12453",
        "NAME": "Lobkowicz, Wenzel Wilhelm (1592\u20131626), K\u00e4mmerer",
        "DATEOFBIRTH": "1592 Mar 20",
        "DATEOFDEATH": "1626 Feb 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Nikolsburg in M\u00e4hren"
    },
    {
        "ID": "12454",
        "NAME": "Dietrichstein, Margarita (1597\u20131617)",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1617 Feb 03",
        "PLACEOFBIRTH": "Nikolsburg in M\u00e4hren",
        "PLACEOFDEATH": "Nikolsburg in M\u00e4hren"
    },
    {
        "ID": "12455",
        "NAME": "Lamberg, Klara Katharina (1644\u20131663)",
        "DATEOFBIRTH": "1644",
        "DATEOFDEATH": "1663 Mai 02",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12456",
        "NAME": "Tserclaes von Tilly, Elisabeth Apollonia (1630\u20131665)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1665 Aug 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12457",
        "NAME": "T\u00e4nzl von Trazberg, Maria (1506\u20131560)",
        "DATEOFBIRTH": "1506",
        "DATEOFDEATH": "1560",
        "PLACEOFBIRTH": "Tratzberg im Inntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12458",
        "NAME": "Dietrichstein, Eleonora (1623\u20131687)",
        "DATEOFBIRTH": "1623 Jan 01",
        "DATEOFDEATH": "1687 Mar 20",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "12459",
        "NAME": "Brandis, Johann Heinrich (1530\u20131589), K\u00e4mmerer",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12460",
        "NAME": "Hohenzollern, Eitel Friedrich (1582\u20131625), Bischof von Osnabr\u00fcck",
        "DATEOFBIRTH": "1582 Sep 26",
        "DATEOFDEATH": "1625 Sep 19",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": "Iburg am D\u00f6renberg"
    },
    {
        "ID": "12461",
        "NAME": "Truchsess von Waldburg, Eleonora (1555\u20131609)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1609 Aug 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12462",
        "NAME": "Hohenzollern, Katharina (1604\u20131649), F\u00fcrstin von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1604 Mai 28",
        "DATEOFDEATH": "1649 Aug 27",
        "PLACEOFBIRTH": "K\u00f6nigsberg in Preu\u00dfen",
        "PLACEOFDEATH": "Sch\u00f6ningen am Elm"
    },
    {
        "ID": "12463",
        "NAME": "Hohenzollern, Anna Maria (1609\u20131680)",
        "DATEOFBIRTH": "1609 Dez 30",
        "DATEOFDEATH": "1680 Mai 08",
        "PLACEOFBIRTH": "Bayreuth",
        "PLACEOFDEATH": "Oedenburg"
    },
    {
        "ID": "12464",
        "NAME": "M\u00f6rsperg, Maria Sidonia (1635\u20131666)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1666 Jun 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "12465",
        "NAME": "Hofmann von Gr\u00fcnb\u00fchel, Eva (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gr\u00fcnb\u00fchel in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12466",
        "NAME": "Lobkowicz, Eleonora Maria (1620\u20131681)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1681 Dez 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12467",
        "NAME": "Lamberg, Anna Maria (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12468",
        "NAME": "Talmberg, Ludmila Katharina (1605\u20131670)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1670",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bresnitz"
    },
    {
        "ID": "12469",
        "NAME": "Metternich, Maria (1595\u20131625)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1625 Sep 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12470",
        "NAME": "Truchsess von Waldburg, Anna Walburga (1606\u20131652)",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1652",
        "PLACEOFBIRTH": "Zeil in Schwaben",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12471",
        "NAME": "Truchsess von Waldburg, Anna Maria (1650\u20131720)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1720",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12472",
        "NAME": "Truchsess von Waldburg, Maximilian Wunibald (1647\u20131717)",
        "DATEOFBIRTH": "1647",
        "DATEOFDEATH": "1717 Apr 16",
        "PLACEOFBIRTH": "Leitmeritz",
        "PLACEOFDEATH": "Konstanz im Hegau"
    },
    {
        "ID": "12473",
        "NAME": "Verda von Verdenberg, Anna Kamila (1620\u20131677)",
        "DATEOFBIRTH": "1620",
        "DATEOFDEATH": "1677",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "12474",
        "NAME": "Coronini von Cronberg, Katharina (1590\u20131660)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1660 Mar 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12475",
        "NAME": "Lamberg, Anna (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rottenb\u00fcchel in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12476",
        "NAME": "Hohenems, Helena (1535\u20131586)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1586 Apr 29",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Langenstein im Hegau"
    },
    {
        "ID": "12477",
        "NAME": "Sulz, Anna Amalia (1593\u20131658)",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1658 Apr 26",
        "PLACEOFBIRTH": "Vaduz",
        "PLACEOFDEATH": "Waldshut"
    },
    {
        "ID": "12478",
        "NAME": "Hohenzollern, Franziska (1600\u20131665)",
        "DATEOFBIRTH": "1600",
        "DATEOFDEATH": "1665 Jun 16",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Hohenems"
    },
    {
        "ID": "12479",
        "NAME": "F\u00fcrstenberg, Eleonora (1630\u20131670)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1670 Feb 18",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Vaduz"
    },
    {
        "ID": "12480",
        "NAME": "Althan, Maria Maximiliana (1635\u20131689)",
        "DATEOFBIRTH": "1635 Aug 25",
        "DATEOFDEATH": "1689 Okt 11",
        "PLACEOFBIRTH": "Murstetten",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12481",
        "NAME": "Tattenbach, Sidonia (1608\u20131636)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Landsberg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12482",
        "NAME": "Trauttmansdorff, Elisabeth (1587\u20131653)",
        "DATEOFBIRTH": "1587 Mai 05",
        "DATEOFDEATH": "1653 Mai 29",
        "PLACEOFBIRTH": "Gleichenberg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12483",
        "NAME": "Trauttmansdorff, Susanna (1589\u20131619)",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1619 Mai 15",
        "PLACEOFBIRTH": "Gleichenberg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12484",
        "NAME": "Schlick, Karolina (1540\u20131594)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "\u017dalmanov"
    },
    {
        "ID": "12485",
        "NAME": "Harrach, Margarita (1508\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12486",
        "NAME": "Thanr\u00e4dl, Margarita (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12487",
        "NAME": "Heusenstamm, Anna Eleonora (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12488",
        "NAME": "Habsburg, Barbara (1500\u20131550)",
        "DATEOFBIRTH": "1500 Jun 29",
        "DATEOFDEATH": "1550 Mar 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Fulnek"
    },
    {
        "ID": "12489",
        "NAME": "Thun, Eleonora (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Thun in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12490",
        "NAME": "Rosenberg, Anna (1530\u20131580)",
        "DATEOFBIRTH": "1530 Jan 26",
        "DATEOFDEATH": "1580 Dez 16",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": "Neuhaus in B\u00f6hmen"
    },
    {
        "ID": "12491",
        "NAME": "P\u00e1lffy, Barbara (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12492",
        "NAME": "Kuefstein, Eva (1585\u20131651)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1651 Dez 12",
        "PLACEOFBIRTH": "Greillenstein",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "12493",
        "NAME": "Hohenzollern, Anna Maria (1573\u20131598)",
        "DATEOFBIRTH": "1573",
        "DATEOFDEATH": "1598 Jun 01",
        "PLACEOFBIRTH": "Ensisheim",
        "PLACEOFDEATH": "Kirchheim in Schwaben"
    },
    {
        "ID": "12494",
        "NAME": "Hohenzollern, Maximiliana (1583\u20131649)",
        "DATEOFBIRTH": "1583 Okt 31",
        "DATEOFDEATH": "1649 Sep 11",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12495",
        "NAME": "Hohenzollern, Eleonora (1586\u20131668)",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1668",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12496",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Katharina (1488\u20131535)",
        "DATEOFBIRTH": "1488",
        "DATEOFDEATH": "1535 Jan 31",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "12497",
        "NAME": "Horowicz, Anna Salomena (1590\u20131632)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12498",
        "NAME": "Wittelsbach, Maria (1551\u20131608)",
        "DATEOFBIRTH": "1551 Mar 21",
        "DATEOFDEATH": "1608 Apr 29",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "12499",
        "NAME": "Zehentner von Zehentgrub, Anna (1668\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1668 Mai 06",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12500",
        "NAME": "Habsburg, Johann (1545\u20131578), Statthalter der Spanischen Niederlande",
        "DATEOFBIRTH": "1545 Feb 25",
        "DATEOFDEATH": "1578",
        "PLACEOFBIRTH": "Regensburg",
        "PLACEOFDEATH": "Namur"
    },
    {
        "ID": "12501",
        "NAME": "T\u00e9llez Gir\u00f3n de Osuna, Peter (1574\u20131624), Vizek\u00f6nig von Neapel",
        "DATEOFBIRTH": "1574 Dez 17",
        "DATEOFDEATH": "1624 Sep 24",
        "PLACEOFBIRTH": "Osuna in Andalusien",
        "PLACEOFDEATH": "Alameda de Osuna"
    },
    {
        "ID": "12502",
        "NAME": "T\u00e9llez Gir\u00f3n de Osuna, Johann (1597\u20131656), Vizek\u00f6nig von Sizilien",
        "DATEOFBIRTH": "1597 Nov 15",
        "DATEOFDEATH": "1656 Okt 12",
        "PLACEOFBIRTH": "Pe\u00f1afiel in Kastilien",
        "PLACEOFDEATH": "Palermo"
    },
    {
        "ID": "12503",
        "NAME": "Monsalve, Wolfgang (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sevilla",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12504",
        "NAME": "Guevara, Ladr\u00f3n (1545\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Guevara",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12505",
        "NAME": "Pe\u00f1alosa, Ambros (1589\u20131656), K\u00e4mmerer",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "Mond\u00e9jar in Kastilien",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "12506",
        "NAME": "Ercilla, Alfons (1533\u20131594), K\u00e4mmerer",
        "DATEOFBIRTH": "1533 Aug 07",
        "DATEOFDEATH": "1594 Nov 29",
        "PLACEOFBIRTH": "Madrid",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "12507",
        "NAME": "Guevara, Ludwig (1585\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12508",
        "NAME": "Fugger, Georg (1577\u20131643), Landvogt von Schwaben",
        "DATEOFBIRTH": "1577 Sep 02",
        "DATEOFDEATH": "1643 Jul 05",
        "PLACEOFBIRTH": "Babenhausen in Schwaben",
        "PLACEOFDEATH": "Schwaz in Tirol"
    },
    {
        "ID": "12509",
        "NAME": "T\u00e9llez Gir\u00f3n de Osuna, Peter (1596\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Madrid",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12510",
        "NAME": "Fugger, Georg (1453\u20131506)",
        "DATEOFBIRTH": "1453 Mai 08",
        "DATEOFDEATH": "1506 Mar 14",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "12511",
        "NAME": "Fugger, Reimund (1489\u20131535)",
        "DATEOFBIRTH": "1489 Okt 24",
        "DATEOFDEATH": "1535 Dez 03",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Mickhausen"
    },
    {
        "ID": "12512",
        "NAME": "Fugger, Johann Jakob (1516\u20131575)",
        "DATEOFBIRTH": "1516 Dez 23",
        "DATEOFDEATH": "1575 Jul 14",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "12513",
        "NAME": "Fugger, Severin (1551\u20131601)",
        "DATEOFBIRTH": "1551 Mar 29",
        "DATEOFDEATH": "1601 Feb 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Schwabm\u00fcnchen"
    },
    {
        "ID": "12514",
        "NAME": "Fugger, Wilhelm (1585\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1585 Jan 06",
        "DATEOFDEATH": "1659 Apr 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "12515",
        "NAME": "Fugger, Regina (1499\u20131552)",
        "DATEOFBIRTH": "1499 Nov 07",
        "DATEOFDEATH": "1552 Dez 26",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "12516",
        "NAME": "Fugger, Maria (1543\u20131583)",
        "DATEOFBIRTH": "1543 Nov 27",
        "DATEOFDEATH": "1583 Nov 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12517",
        "NAME": "Fugger, Susanna (1539\u20131588)",
        "DATEOFBIRTH": "1539 Feb 28",
        "DATEOFDEATH": "1588 Nov 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12518",
        "NAME": "Solms, Johann Georg (1546\u20131600)",
        "DATEOFBIRTH": "1546 Nov 26",
        "DATEOFDEATH": "1600 Aug 19",
        "PLACEOFBIRTH": "S\u00f6del in der Wetterau",
        "PLACEOFDEATH": "Laubach im Wettertal"
    },
    {
        "ID": "12519",
        "NAME": "Solms, Sophia (1594\u20131651), Landesregentin von Ansbach",
        "DATEOFBIRTH": "1594 Mai 15",
        "DATEOFDEATH": "1651 Mai 16",
        "PLACEOFBIRTH": "Laubach im Wettertal",
        "PLACEOFDEATH": "Pl\u00f6tzkau"
    },
    {
        "ID": "12520",
        "NAME": "Trazegnies, Johann (1470\u20131550), K\u00e4mmerer",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1550 Mai 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trazegnies"
    },
    {
        "ID": "12521",
        "NAME": "Eggenberg, Johann Anton (1610\u20131649), Landeshauptmann von Krain",
        "DATEOFBIRTH": "1610 Feb 05",
        "DATEOFDEATH": "1649 Feb 19",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "12522",
        "NAME": "Eggenberg, Johann Christian (1641\u20131710), Geheimer Rat",
        "DATEOFBIRTH": "1641 Sep 07",
        "DATEOFDEATH": "1710 Dez 14",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12523",
        "NAME": "Eggenberg, Elisabeth (1640\u20131715)",
        "DATEOFBIRTH": "1640 Sep 25",
        "DATEOFDEATH": "1715 Mai 18",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12524",
        "NAME": "Eggenberg, Johann Siegfried (1644\u20131713), Landeshauptmann von Krain",
        "DATEOFBIRTH": "1644 Aug 12",
        "DATEOFDEATH": "1713 Okt 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Waldstein in der Steiermark"
    },
    {
        "ID": "12525",
        "NAME": "Kollonitz, Ferdinand (1575\u20131611), Hofkriegsrat",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12526",
        "NAME": "Kollonitz, Erasam Ferdinand (1590\u20131640), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1640",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": "Friesach in K\u00e4rnten"
    },
    {
        "ID": "12527",
        "NAME": "Kollonitz, Christoph Ferdinand (1612\u20131670)",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1670",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12528",
        "NAME": "Kollonitz, Otto Gottfried (1598\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1664 Jun 10",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": "Leibnitz in der Steiermark"
    },
    {
        "ID": "12529",
        "NAME": "Kollonitz, Adam (1561\u20131612), K\u00e4mmerer",
        "DATEOFBIRTH": "1561",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12530",
        "NAME": "Kollonitz, Siegfried (1490\u20131555), Hofkammerrat",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1555 Nov 17",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12531",
        "NAME": "Kollonitz, Ferdinand (1520\u20131574)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1574 Jan 17",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12532",
        "NAME": "Kollonitz, Georg (1537\u20131599), K\u00e4mmerer",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": "Jedenspeigen an der March"
    },
    {
        "ID": "12533",
        "NAME": "Kollonitz, Johann Georg (1570\u20131636), Vorschneider",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12534",
        "NAME": "Kollonitz, Siegfried (1572\u20131624), Hofkriegsrat",
        "DATEOFBIRTH": "1572 Sep 22",
        "DATEOFDEATH": "1624 Feb 12",
        "PLACEOFBIRTH": "Eisenstadt im Burgenland",
        "PLACEOFDEATH": "Lewenz"
    },
    {
        "ID": "12535",
        "NAME": "Kollonitz, Johann Ulrich (1606\u20131676)",
        "DATEOFBIRTH": "1606 Feb 28",
        "DATEOFDEATH": "1676",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12536",
        "NAME": "Kollonitz, Adam (1651\u20131726), K\u00e4mmerer",
        "DATEOFBIRTH": "1651 Feb 22",
        "DATEOFDEATH": "1726",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12537",
        "NAME": "Eggenberg, Eleonora (1582\u20131649)",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12538",
        "NAME": "Savelli, Bernhard (1533\u20131590)",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1590 Nov 15",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12539",
        "NAME": "Savelli, Paul (1571\u20131632), Geheimer Rat",
        "DATEOFBIRTH": "1571",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12540",
        "NAME": "Carafa, Karl (1584\u20131644), Bischof von Aversa",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1644 Apr 07",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": "Aversa"
    },
    {
        "ID": "12541",
        "NAME": "Carafa, Hieronym (1505\u20131548)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12542",
        "NAME": "Carafa, Johann Anton (1540\u20131592)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1592 Mar 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12543",
        "NAME": "Carafa, Ludwig (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12544",
        "NAME": "Carafa, Hieronym (1602\u20131658)",
        "DATEOFBIRTH": "1602 Mai 30",
        "DATEOFDEATH": "1658 Mar 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Castel San Lorenzo"
    },
    {
        "ID": "12545",
        "NAME": "M\u00f6rsperg, Johann Friedrich (1560\u20131626), Hofkriegsrat",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1626 Feb 13",
        "PLACEOFBIRTH": "M\u00f6rsperg im Sundgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12546",
        "NAME": "M\u00f6rsperg, Anna Katharina (1600\u20131638)",
        "DATEOFBIRTH": "1600",
        "DATEOFDEATH": "1638 Jun 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12547",
        "NAME": "Pepoli, Widebald (1640\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Castiglione dei Gatti",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12548",
        "NAME": "Pepoli, Anton (1660\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Castiglione dei Gatti",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12549",
        "NAME": "Dyhrn, Georg Abraham (1612\u20131671), Landeshauptmann von Glogau",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1671",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Dyhrenfurth"
    },
    {
        "ID": "12550",
        "NAME": "Rabenhaupt, Wenzel (1480\u20131532)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1532",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12551",
        "NAME": "Rabenhaupt, Johann (1520\u20131581)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1581",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12552",
        "NAME": "Rabenhaupt, Siegmund (1510\u20131551)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1551",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12553",
        "NAME": "Rabenhaupt, Albrecht (1540\u20131595)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1595",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ronow an der Daubrawa"
    },
    {
        "ID": "12554",
        "NAME": "Rabenhaupt, Siegmund (1568\u20131624)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1624 Jul 24",
        "PLACEOFBIRTH": "Lichtenburg im Eisengebirge",
        "PLACEOFDEATH": "Tremoschnitz"
    },
    {
        "ID": "12555",
        "NAME": "Rabenhaupt, Ferdinand (1602\u20131675), K\u00e4mmerer",
        "DATEOFBIRTH": "1602",
        "DATEOFDEATH": "1675 Nov 06",
        "PLACEOFBIRTH": "Lichtenburg im Eisengebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12556",
        "NAME": "Rabenhaupt, Kaspar (1450\u20131523)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1523 Apr 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12557",
        "NAME": "Rabenhaupt, Andreas (1475\u20131522)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1522",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12558",
        "NAME": "Rabenhaupt, Wilhelm (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12559",
        "NAME": "Rabenhaupt, Niklas (1470\u20131538)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1538 Jun 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12560",
        "NAME": "Porcia, Johann Karl (1630\u20131667), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1667 Apr 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12561",
        "NAME": "Porcia, Hermes (1540\u20131609), K\u00e4mmerer",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "Venedig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12562",
        "NAME": "Porcia, Karl (1570\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Venedig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12563",
        "NAME": "Porcia, Alfons (1575\u20131620)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1620",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12564",
        "NAME": "Porcia, Ferdinand (1615\u20131688)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1688",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "12565",
        "NAME": "Porcia, Hieronym (1645\u20131724)",
        "DATEOFBIRTH": "1645 Okt 18",
        "DATEOFDEATH": "1724 Jul 19",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12566",
        "NAME": "Porcia, Hannibal (1679\u20131738), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1679 Mai 07",
        "DATEOFDEATH": "1738 Nov 04",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Spittal an der Drau"
    },
    {
        "ID": "12567",
        "NAME": "Porcia, Karl Anton (1683\u20131752), K\u00e4mmerer",
        "DATEOFBIRTH": "1683 Nov 13",
        "DATEOFDEATH": "1752 Aug 11",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "12568",
        "NAME": "Porcia, Hermes (1688\u20131749), Geheimer Rat",
        "DATEOFBIRTH": "1688 Dez 17",
        "DATEOFDEATH": "1749 Jul 15",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12569",
        "NAME": "Porcia, Franz Anton (1663\u20131698)",
        "DATEOFBIRTH": "1663",
        "DATEOFDEATH": "1698 Apr 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12570",
        "NAME": "Auersperg, Anna (1610\u20131636)",
        "DATEOFBIRTH": "1610 Mai 08",
        "DATEOFDEATH": "1636 Feb 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12571",
        "NAME": "Hohenzollern, Katharina (1605\u20131640)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1640 Jun 02",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Baden in Baden"
    },
    {
        "ID": "12572",
        "NAME": "Auersperg, Wolfgang Engelbrecht (1610\u20131673), Landeshauptmann von Krain",
        "DATEOFBIRTH": "1610 Dez 22",
        "DATEOFDEATH": "1673 Apr 28",
        "PLACEOFBIRTH": "Seisenberg in der Krain",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "12573",
        "NAME": "Brandis, Jakob Andreas (1569\u20131629), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1569 Jan 10",
        "DATEOFDEATH": "1629 Nov 07",
        "PLACEOFBIRTH": "Neustadt im Steinfeld",
        "PLACEOFDEATH": "Fahlburg"
    },
    {
        "ID": "12574",
        "NAME": "Rumpf, Wilhelm (1480\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wullross im Gurktal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12575",
        "NAME": "Rumpf, Wolfgang (1536\u20131605), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1605 Mai 13",
        "PLACEOFBIRTH": "Wullross im Gurktal",
        "PLACEOFDEATH": "Weitra im Waldviertel"
    },
    {
        "ID": "12576",
        "NAME": "Brandis, Andreas Wilhelm (1595\u20131642), Hofkammervizepr\u00e4sident",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1642 Apr 18",
        "PLACEOFBIRTH": "Fahlburg",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "12577",
        "NAME": "Brandis, Adam Wilhelm (1636\u20131699), Obersthofmeister",
        "DATEOFBIRTH": "1636",
        "DATEOFDEATH": "1699 Apr 06",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12578",
        "NAME": "Hohenzollern, Barbara Sophia (1589\u20131636)",
        "DATEOFBIRTH": "1589 Nov 16",
        "DATEOFDEATH": "1636 Feb 13",
        "PLACEOFBIRTH": "Halle an der Saale",
        "PLACEOFDEATH": "Stra\u00dfburg im Elsass"
    },
    {
        "ID": "12579",
        "NAME": "Gallas, Franz Ferdinand (1635\u20131697), K\u00e4mmerer",
        "DATEOFBIRTH": "1635",
        "DATEOFDEATH": "1697 Jan 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12580",
        "NAME": "Pallavicino, Sforza (1519\u20131585), Markgraf von Cortemaggiore",
        "DATEOFBIRTH": "1519",
        "DATEOFDEATH": "1585 Feb 04",
        "PLACEOFBIRTH": "Fiorenzuola d\u2019Arda",
        "PLACEOFDEATH": "Sal\u00f2"
    },
    {
        "ID": "12581",
        "NAME": "Barbolani di Montauto, Bartlome (1550\u20131599)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "Montauto dei Barbolani",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12582",
        "NAME": "Barbolani di Montauto, Montaut (1590\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1664 Jan 09",
        "PLACEOFBIRTH": "Montauto dei Barbolani",
        "PLACEOFDEATH": "Galbino"
    },
    {
        "ID": "12583",
        "NAME": "Barbolani di Montauto, Julius (1585\u20131641), Hofkriegsrat",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1641",
        "PLACEOFBIRTH": "Montauto dei Barbolani",
        "PLACEOFDEATH": "Livorno"
    },
    {
        "ID": "12584",
        "NAME": "Gonzaga, Scipio (1595\u20131670), F\u00fcrst von Bozzolo",
        "DATEOFBIRTH": "1595",
        "DATEOFDEATH": "1670 Mai 12",
        "PLACEOFBIRTH": "San Martino dall\u2019Argine",
        "PLACEOFDEATH": "San Martino dall\u2019Argine"
    },
    {
        "ID": "12585",
        "NAME": "Colloredo, Hieronym (1570\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1638 Jul 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Saint Omer"
    },
    {
        "ID": "12586",
        "NAME": "Porcia, Luzia (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12587",
        "NAME": "Colloredo, Ludwig (1631\u20131693), Geheimer Rat",
        "DATEOFBIRTH": "1631",
        "DATEOFDEATH": "1693 Dez 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "12588",
        "NAME": "Colloredo, Antonia (1670\u20131738)",
        "DATEOFBIRTH": "1670~",
        "DATEOFDEATH": "1738 Jan 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12589",
        "NAME": "Hercolani, Caesar (1499\u20131534)",
        "DATEOFBIRTH": "1499",
        "DATEOFDEATH": "1534 Sep 08",
        "PLACEOFBIRTH": "Bagnacavallo",
        "PLACEOFDEATH": "Forl\u00ec"
    },
    {
        "ID": "12590",
        "NAME": "Salamanca, Gabriel (1489\u20131539)",
        "DATEOFBIRTH": "1489",
        "DATEOFDEATH": "1539 Dez 12",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": "Ensisheim"
    },
    {
        "ID": "12591",
        "NAME": "Salamanca, Gundebald (1450\u20131516)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1516",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12592",
        "NAME": "Salamanca, Agnes (1485\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12593",
        "NAME": "Hoyos, Johann Baptist (1481\u20131538)",
        "DATEOFBIRTH": "1481",
        "DATEOFDEATH": "1538",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12594",
        "NAME": "Hoyos, Johann Baptist (1506\u20131561), K\u00e4mmerer",
        "DATEOFBIRTH": "1506",
        "DATEOFDEATH": "1561 Mai 22",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": "Gradisch an der Isnitz"
    },
    {
        "ID": "12595",
        "NAME": "Hoyos, Anton (1504\u20131551), Bischof von Gurk",
        "DATEOFBIRTH": "1504",
        "DATEOFDEATH": "1551",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": "Conegliano:Marienkirche"
    },
    {
        "ID": "12596",
        "NAME": "Hoyos, Ferdinand (1553\u20131609), K\u00e4mmerer",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1609 Mar 02",
        "PLACEOFBIRTH": "Stixenstein",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "12597",
        "NAME": "Lobkowicz, Regina (1560\u20131627)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1627 Mai 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hall in Tirol"
    },
    {
        "ID": "12598",
        "NAME": "Lobkowicz, Eva (1559\u20131599)",
        "DATEOFBIRTH": "1559 Feb 14",
        "DATEOFDEATH": "1599 Jul 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bechin"
    },
    {
        "ID": "12599",
        "NAME": "Lobkowicz, Wilhelm (1568\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "Teinitz an der Radbusa",
        "PLACEOFDEATH": "Zbiroh"
    },
    {
        "ID": "12600",
        "NAME": "Habsburg, Maria (1528\u20131603), Kaiserin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1528 Jun 21",
        "DATEOFDEATH": "1603 Feb 26",
        "PLACEOFBIRTH": "Madrid",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "12601",
        "NAME": "Bark\u00f3czy, Lassel (1630\u20131700), K\u00e4mmerer",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1700~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12602",
        "NAME": "Sz\u00e9chy, Dionys (1595\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "Sz\u00e9cs an der Rimau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12603",
        "NAME": "Sz\u00e9chy, Georg (1630\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sz\u00e9cs an der Rimau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12604",
        "NAME": "Sz\u00e9chy, Peter (1635\u20131685), K\u00e4mmerer",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1685",
        "PLACEOFBIRTH": "Sz\u00e9cs an der Rimau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12605",
        "NAME": "Batthy\u00e1ny, Barbara (1640\u20131692)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1692",
        "PLACEOFBIRTH": "G\u00fcssing",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12606",
        "NAME": "Sz\u00e9chy, Thomas (1550\u20131618)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1618 Feb 09",
        "PLACEOFBIRTH": "Sz\u00e9cs an der Rimau",
        "PLACEOFDEATH": "Limbach auf dem Berg"
    },
    {
        "ID": "12607",
        "NAME": "Sz\u00e9chy, Georg (1577\u20131625), K\u00e4mmerer",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1625 Aug 31",
        "PLACEOFBIRTH": "Sz\u00e9cs an der Rimau",
        "PLACEOFDEATH": "Muran"
    },
    {
        "ID": "12608",
        "NAME": "Sz\u00e9chy, Maria (1610\u20131679)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1679 Jul 18",
        "PLACEOFBIRTH": "Sz\u00e9cs an der Rimau",
        "PLACEOFDEATH": "G\u00fcns"
    },
    {
        "ID": "12609",
        "NAME": "Bosny\u00e1k, Sophia (1609\u20131644)",
        "DATEOFBIRTH": "1609 Jun 02",
        "DATEOFDEATH": "1644 Apr 28",
        "PLACEOFBIRTH": "Sur\u00e1ny",
        "PLACEOFDEATH": "Stre\u010dno"
    },
    {
        "ID": "12610",
        "NAME": "Hohenzollern, Barbara (1464\u20131515)",
        "DATEOFBIRTH": "1464 Mai 29",
        "DATEOFDEATH": "1515 Sep 04",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Ansbach"
    },
    {
        "ID": "12611",
        "NAME": "Kastell\u00e1nfi von Szentl\u00e9lek, Georg (1450\u20131513)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1513 Feb",
        "PLACEOFBIRTH": "Biksz\u00e1d an der Lonja",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "12612",
        "NAME": "Kastell\u00e1nfi von Szentl\u00e9lek, Johann (1494\u20131541)",
        "DATEOFBIRTH": "1494",
        "DATEOFDEATH": "1541",
        "PLACEOFBIRTH": "Biksz\u00e1d an der Lonja",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12613",
        "NAME": "Kastell\u00e1nfi von Szentl\u00e9lek, Anna (1536\u20131591)",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1591 Mar 29",
        "PLACEOFBIRTH": "Biksz\u00e1d an der Lonja",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12614",
        "NAME": "Kastell\u00e1nfi von Szentl\u00e9lek, Peter (1524\u20131571)",
        "DATEOFBIRTH": "1524",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Biksz\u00e1d an der Lonja",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12615",
        "NAME": "Kastell\u00e1nfi von Szentl\u00e9lek, Stephan (1526\u20131579), Hofdiener",
        "DATEOFBIRTH": "1526",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "Biksz\u00e1d an der Lonja",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12616",
        "NAME": "Kastell\u00e1nfi von Szentl\u00e9lek, Stephan (1556\u20131593)",
        "DATEOFBIRTH": "1556",
        "DATEOFDEATH": "1593",
        "PLACEOFBIRTH": "Biksz\u00e1d an der Lonja",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12617",
        "NAME": "Torquato di Corbavia, Karl (1440\u20131493)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1493 Sep 09",
        "PLACEOFBIRTH": "Udbina in der Lika",
        "PLACEOFDEATH": "Udbina in der Lika"
    },
    {
        "ID": "12618",
        "NAME": "Torquato di Corbavia, Helena (1475\u20131535)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1535 Jan 13",
        "PLACEOFBIRTH": "Udbina in der Lika",
        "PLACEOFDEATH": "Biksz\u00e1d an der Lonja"
    },
    {
        "ID": "12619",
        "NAME": "\u00dajlaki, Katharina (1448\u20131480)",
        "DATEOFBIRTH": "1448",
        "DATEOFDEATH": "1480~",
        "PLACEOFBIRTH": "Illok in Syrmien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12620",
        "NAME": "\u00dajlaki, Niklas (1410\u20131477), K\u00f6nig von Bosnien",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1477 Apr 16",
        "PLACEOFBIRTH": "Illok in Syrmien",
        "PLACEOFDEATH": "Illok in Syrmien"
    },
    {
        "ID": "12621",
        "NAME": "\u00dajlaki, Lorenz (1459\u20131524)",
        "DATEOFBIRTH": "1459 Aug 06",
        "DATEOFDEATH": "1524 Mai 23",
        "PLACEOFBIRTH": "Illok in Syrmien",
        "PLACEOFDEATH": "Illok in Syrmien"
    },
    {
        "ID": "12622",
        "NAME": "B\u00e1thory, Stephan (1533\u20131586), K\u00f6nig von Polen",
        "DATEOFBIRTH": "1533 Sep 27",
        "DATEOFDEATH": "1586 Dez 12",
        "PLACEOFBIRTH": "Schomlenmarkt",
        "PLACEOFDEATH": "Garten an der Memel"
    },
    {
        "ID": "12623",
        "NAME": "B\u00e1thory, Christoph (1530\u20131581), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1530",
        "DATEOFDEATH": "1581 Mai 27",
        "PLACEOFBIRTH": "Schomlenmarkt",
        "PLACEOFDEATH": "Wei\u00dfenburg in Siebenb\u00fcrgen"
    },
    {
        "ID": "12624",
        "NAME": "B\u00e1thory, Siegmund (1572\u20131613), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1613 Mar 28",
        "PLACEOFBIRTH": "Schomlenmarkt",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12625",
        "NAME": "B\u00e1thory, Lorenz (1290\u20131330)",
        "DATEOFBIRTH": "1290~",
        "DATEOFDEATH": "1330",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12626",
        "NAME": "B\u00e1thory, Peter (1320\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ecsed",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12627",
        "NAME": "B\u00e1thory, Johann (1360\u20131416)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1416",
        "PLACEOFBIRTH": "Ecsed",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12628",
        "NAME": "B\u00e1thory, Stephan (1400\u20131444)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1444 Nov 11",
        "PLACEOFBIRTH": "Ecsed",
        "PLACEOFDEATH": "Varna"
    },
    {
        "ID": "12629",
        "NAME": "B\u00e1thory, Stephan (1430\u20131493), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1493",
        "PLACEOFBIRTH": "Ecsed",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12630",
        "NAME": "B\u00e1thory, Stephan (1555\u20131605)",
        "DATEOFBIRTH": "1555",
        "DATEOFDEATH": "1605 Jul 25",
        "PLACEOFBIRTH": "Ecsed",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12631",
        "NAME": "N\u00e1dasdy, Thomas (1498\u20131562), Palatin von Ungarn",
        "DATEOFBIRTH": "1498",
        "DATEOFDEATH": "1562 Jun 02",
        "PLACEOFBIRTH": "Ofen",
        "PLACEOFDEATH": "Egerv\u00e1r"
    },
    {
        "ID": "12632",
        "NAME": "N\u00e1dasdy, Franz (1555\u20131604), Oberststallmeister",
        "DATEOFBIRTH": "1555 Okt 06",
        "DATEOFDEATH": "1604 Jan 04",
        "PLACEOFBIRTH": "Rotenturm an der Raab",
        "PLACEOFDEATH": "Rotenturm an der Raab"
    },
    {
        "ID": "12633",
        "NAME": "Bark\u00f3czy, Stephan (1625\u20131679), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1679",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12634",
        "NAME": "Boss\u00e1nyi, Gabriel (1610\u20131681)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1681",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12635",
        "NAME": "Batthy\u00e1ny, Paul (1639\u20131674)",
        "DATEOFBIRTH": "1639",
        "DATEOFDEATH": "1674",
        "PLACEOFBIRTH": "G\u00fcssing",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12636",
        "NAME": "Batthy\u00e1ny, Franz (1665\u20131717)",
        "DATEOFBIRTH": "1665~",
        "DATEOFDEATH": "1717",
        "PLACEOFBIRTH": "G\u00fcssing",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12637",
        "NAME": "Bethlen, Wolfgang (1530\u20131590)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12638",
        "NAME": "Bethlen, Gabriel (1580\u20131629), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1580",
        "DATEOFDEATH": "1629 Nov 15",
        "PLACEOFBIRTH": "Elienmarkt",
        "PLACEOFDEATH": "Wei\u00dfenburg in Siebenb\u00fcrgen"
    },
    {
        "ID": "12639",
        "NAME": "Bethlen, Stephan (1582\u20131648), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1648 Jan 10",
        "PLACEOFBIRTH": "Elienmarkt",
        "PLACEOFDEATH": "Ecsed"
    },
    {
        "ID": "12640",
        "NAME": "B\u00e1thory, Elisabeth (1560\u20131614)",
        "DATEOFBIRTH": "1560 Aug 07",
        "DATEOFDEATH": "1614 Aug 21",
        "PLACEOFBIRTH": "Ny\u00edrb\u00e1tor",
        "PLACEOFDEATH": "Sch\u00e4chtitz"
    },
    {
        "ID": "12641",
        "NAME": "Gatta, Dominik (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12642",
        "NAME": "Canossa, Siegmund (1640\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12643",
        "NAME": "Canossa, Kyros (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Verona",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12644",
        "NAME": "Canossa, Paul (1600\u20131660)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1660~",
        "PLACEOFBIRTH": "Verona",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12645",
        "NAME": "Canossa, Hieronym (1533\u20131592)",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "Verona",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "12646",
        "NAME": "Canossa, Albrecht (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12647",
        "NAME": "Canossa, Galeas (1640\u20131680)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1680~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12648",
        "NAME": "Canossa, Adelheid (1672\u20131737)",
        "DATEOFBIRTH": "1672 Mar 21",
        "DATEOFDEATH": "1737 Feb 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12649",
        "NAME": "Canossa, Anton (1638\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1638",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12650",
        "NAME": "Hofkirchen, Wilhelm (1529\u20131584), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "Dr\u00f6siedl",
        "PLACEOFDEATH": "V\u00f6sendorf"
    },
    {
        "ID": "12651",
        "NAME": "Hofkirchen, Wolfgang (1555\u20131611)",
        "DATEOFBIRTH": "1555 Sep 01",
        "DATEOFDEATH": "1611 Jun 15",
        "PLACEOFBIRTH": "Kollmitz",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12652",
        "NAME": "Hofkirchen, Wilhelm (1583\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kollmitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12653",
        "NAME": "Hofkirchen, Lorenz (1606\u20131656)",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "Kollmitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12654",
        "NAME": "Hofkirchen, Albrecht (1600\u20131633)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1633 Feb 14",
        "PLACEOFBIRTH": "Kollmitz",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12655",
        "NAME": "Hofkirchen, Georg Andreas (1562\u20131623), Hofkriegsrat",
        "DATEOFBIRTH": "1562 Apr 19",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "Kollmitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12656",
        "NAME": "Hofkirchen, Johann Bernhard (1590\u20131638), Truchsess",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "Kollmitz",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "12657",
        "NAME": "Canossa, Johann Thomas (1580\u20131650)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1650~",
        "PLACEOFBIRTH": "Verona",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12658",
        "NAME": "Canossa, Ludwig (1623\u20131687), K\u00e4mmerer",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1687 Aug 10",
        "PLACEOFBIRTH": "Casale Monferrato",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "12659",
        "NAME": "Canossa, Hotze (1620\u20131673)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1673 Mai 25",
        "PLACEOFBIRTH": "Casale Monferrato",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "12660",
        "NAME": "Wettin, Christian August (1666\u20131725), Prinzipalkommissar",
        "DATEOFBIRTH": "1666 Okt 19",
        "DATEOFDEATH": "1725 Aug 23",
        "PLACEOFBIRTH": "Zeitz an der Elster",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "12661",
        "NAME": "Herberstein, Georg (1530\u20131570), Truchsess",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1570 Mar 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "12662",
        "NAME": "Herberstein, Quintin Karl (1660\u20131719), K\u00e4mmerer",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "1719 Nov 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12663",
        "NAME": "Herberstein, Wolfgang Wilhelm (1560\u20131619)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Windenau an der Drau"
    },
    {
        "ID": "12664",
        "NAME": "Herberstein, Johann Friedrich (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gutenhag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12665",
        "NAME": "Herberstein, Siegmund Lassel (1640\u20131697), K\u00e4mmerer",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1697",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12666",
        "NAME": "Herberstein, Maximilian Ernst (1674\u20131708), Hofkammerrat",
        "DATEOFBIRTH": "1674",
        "DATEOFDEATH": "1708 Mai 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hirschbach im Waldviertel"
    },
    {
        "ID": "12667",
        "NAME": "Marschall von Pappenheim, Wilhelm (1450\u20131508)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1508",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "12668",
        "NAME": "Marschall von Pappenheim, Wolfgang (1495\u20131558)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1558",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kalden an der Iller"
    },
    {
        "ID": "12669",
        "NAME": "Marschall von Pappenheim, Philipp (1542\u20131619)",
        "DATEOFBIRTH": "1542 Dez 14",
        "DATEOFDEATH": "1619 Nov 13",
        "PLACEOFBIRTH": "Rothenstein im Allg\u00e4u",
        "PLACEOFDEATH": "Gr\u00f6nenbach im Allg\u00e4u"
    },
    {
        "ID": "12670",
        "NAME": "Askanien, Franz (1547\u20131619)",
        "DATEOFBIRTH": "1547 Aug 10",
        "DATEOFDEATH": "1619 Jul 02",
        "PLACEOFBIRTH": "Ratzeburg",
        "PLACEOFDEATH": "Lauenburg an der Elbe:Stadtkirche"
    },
    {
        "ID": "12671",
        "NAME": "Askanien, Julius Heinrich (1586\u20131665), K\u00e4mmerer",
        "DATEOFBIRTH": "1586 Apr 09",
        "DATEOFDEATH": "1665 Nov 20",
        "PLACEOFBIRTH": "Wolfenb\u00fcttel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12672",
        "NAME": "Askanien, Franz Karl (1594\u20131660)",
        "DATEOFBIRTH": "1594 Mai 02",
        "DATEOFDEATH": "1660 Nov 30",
        "PLACEOFBIRTH": "Ratzeburg",
        "PLACEOFDEATH": "Neuhaus an der Elbe"
    },
    {
        "ID": "12673",
        "NAME": "Askanien, Rudolf Maximilian (1596\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1596 Jun 18",
        "DATEOFDEATH": "1647 Okt 01",
        "PLACEOFBIRTH": "Ratzeburg",
        "PLACEOFDEATH": "L\u00fcbeck"
    },
    {
        "ID": "12674",
        "NAME": "Askanien, Franz Albrecht (1598\u20131642), K\u00e4mmerer",
        "DATEOFBIRTH": "1598 Okt 31",
        "DATEOFDEATH": "1642 Jun 10",
        "PLACEOFBIRTH": "Lauenburg an der Elbe",
        "PLACEOFDEATH": "Schweidnitz"
    },
    {
        "ID": "12675",
        "NAME": "Askanien, Franz Erdmann (1629\u20131666), K\u00e4mmerer",
        "DATEOFBIRTH": "1629 Feb 25",
        "DATEOFDEATH": "1666 Jul 30",
        "PLACEOFBIRTH": "Theusing",
        "PLACEOFDEATH": "Schwarzenbek"
    },
    {
        "ID": "12676",
        "NAME": "Askanien, Julius Franz (1641\u20131689)",
        "DATEOFBIRTH": "1641 Sep 16",
        "DATEOFDEATH": "1689 Sep 30",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Reichstadt in B\u00f6hmen"
    },
    {
        "ID": "12677",
        "NAME": "Askanien, Franz Julius (1584\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1584 Sep 13",
        "DATEOFDEATH": "1634 Okt 08",
        "PLACEOFBIRTH": "Wolfenb\u00fcttel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12678",
        "NAME": "Montfort, Katharina (1596\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Tettnang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12679",
        "NAME": "Hofkirchen, Hippolyta Franziska (1610\u20131657)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1657",
        "PLACEOFBIRTH": "Kollmitz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12680",
        "NAME": "N\u00e1dasdy, Paul (1597\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1633 Okt 15",
        "PLACEOFBIRTH": "Rotenturm an der Raab",
        "PLACEOFDEATH": "Csepreg"
    },
    {
        "ID": "12681",
        "NAME": "R\u00e1ttkay, Peter (1520\u20131586)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1586 Feb 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12682",
        "NAME": "R\u00e1ttkay, Georg (1560\u20131614)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1614",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12683",
        "NAME": "R\u00e1ttkay, Paul (1605\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1646",
        "PLACEOFBIRTH": "Tabor in Kroatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12684",
        "NAME": "R\u00e1ttkay, Kaspar (1590\u20131663)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "Tabor in Kroatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12685",
        "NAME": "R\u00e1ttkay, Peter (1620\u20131672)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12686",
        "NAME": "R\u00e1ttkay, Siegmund (1660\u20131702), K\u00e4mmerer",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "1702 Mai 05",
        "PLACEOFBIRTH": "Pettau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12687",
        "NAME": "P\u00e1lffy, Euphrosina (1570\u20131623)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12688",
        "NAME": "Esterh\u00e1zy, Franz (1641\u20131683)",
        "DATEOFBIRTH": "1641 Feb 17",
        "DATEOFDEATH": "1683 Okt 16",
        "PLACEOFBIRTH": "Schintau an der Waag",
        "PLACEOFDEATH": "Kreutz im Burgenland"
    },
    {
        "ID": "12689",
        "NAME": "D\u00f3czy, Stephan (1580\u20131630), Ungarischer Kronh\u00fcter",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1630",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12690",
        "NAME": "Liszthi, Johann (1520\u20131578), Bischof von Jauer an der Raab",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1578 Feb 22",
        "PLACEOFBIRTH": "Hermannstadt in Siebenb\u00fcrgen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12691",
        "NAME": "Balassa, Franz (1475\u20131526)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1526 Aug 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Moh\u00e1cs"
    },
    {
        "ID": "12692",
        "NAME": "Balassa, Emmerich (1505\u20131550)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1550",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12693",
        "NAME": "Balassa, Melchior (1511\u20131568)",
        "DATEOFBIRTH": "1511",
        "DATEOFDEATH": "1568 Feb 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12694",
        "NAME": "Balassa, Stephan (1540\u20131584)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12695",
        "NAME": "Balassa, Melchior (1569\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12696",
        "NAME": "Balassa, Peter (1595\u20131621), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12697",
        "NAME": "Balassa, Johann (1518\u20131577)",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12698",
        "NAME": "Balassa, Valentin (1554\u20131594)",
        "DATEOFBIRTH": "1554 Okt 20",
        "DATEOFDEATH": "1594 Mai 30",
        "PLACEOFBIRTH": "Sohl an der Gran",
        "PLACEOFDEATH": "Gran an der Donau"
    },
    {
        "ID": "12699",
        "NAME": "Liszthi, Johann (1600\u20131673), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1673",
        "PLACEOFBIRTH": "Hermannstadt in Siebenb\u00fcrgen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12700",
        "NAME": "Habsburg, Anna (1528\u20131590), Herzogin in Bayern",
        "DATEOFBIRTH": "1528 Jul 07",
        "DATEOFDEATH": "1590 Okt 16",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "12701",
        "NAME": "Per\u00e9nyi, Emmerich (1459\u20131519), Palatin von Ungarn",
        "DATEOFBIRTH": "1459 Nov 30",
        "DATEOFDEATH": "1519 Feb 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12702",
        "NAME": "Per\u00e9nyi, Peter (1490\u20131548), Ungarischer Kronh\u00fcter",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1548 Feb 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12703",
        "NAME": "Kanizsai, Dorothea (1475\u20131532)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1532",
        "PLACEOFBIRTH": "Kanizsa",
        "PLACEOFDEATH": "Sikl\u00f3s"
    },
    {
        "ID": "12704",
        "NAME": "Ill\u00e9sh\u00e1zy, Gabriel (1618\u20131667), K\u00e4mmerer",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1667 Jan 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12705",
        "NAME": "Ill\u00e9sh\u00e1zy, Thomas (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pressburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12706",
        "NAME": "Ill\u00e9sh\u00e1zy, Franz (1556\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1556",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pressburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12707",
        "NAME": "Ill\u00e9sh\u00e1zy, Franz (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12708",
        "NAME": "Ill\u00e9sh\u00e1zy, Franz (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12709",
        "NAME": "Ill\u00e9sh\u00e1zy, Niklas (1653\u20131723), K\u00e4mmerer",
        "DATEOFBIRTH": "1653",
        "DATEOFDEATH": "1723",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12710",
        "NAME": "Bassompierre, Anna Franz (1612\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1612 Mar",
        "DATEOFDEATH": "1646 Mai 19",
        "PLACEOFBIRTH": "Removille",
        "PLACEOFDEATH": "Staffelstein am Main"
    },
    {
        "ID": "12711",
        "NAME": "Lang von Wellenburg, Johann (1440\u20131511)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1511 Dez 08",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "12712",
        "NAME": "Lang von Wellenburg, Matthias (1468\u20131540), Erzbischof von Salzburg",
        "DATEOFBIRTH": "1468",
        "DATEOFDEATH": "1540 Mar 30",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "12713",
        "NAME": "Lang von Wellenburg, Apollonia (1476\u20131519)",
        "DATEOFBIRTH": "1476",
        "DATEOFDEATH": "1519 Sep 04",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "12714",
        "NAME": "Ulfeldt, Franz (1601\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1601 Okt 30",
        "DATEOFDEATH": "1636 Nov 14",
        "PLACEOFBIRTH": "Hagenskov",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12715",
        "NAME": "Draskovich, Peter (1570\u20131616)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1616 Feb 17",
        "PLACEOFBIRTH": "Bilina in Dalmatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12716",
        "NAME": "Draskovich, Kaspar (1600\u20131668), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1668",
        "PLACEOFBIRTH": "Drachenstein in Kroatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12717",
        "NAME": "Draskovich, Eusebia (1630\u20131650)",
        "DATEOFBIRTH": "1630 Jan 09",
        "DATEOFDEATH": "1650 Sep 24",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12718",
        "NAME": "Ostrosith, Johann (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Giletinci",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12719",
        "NAME": "Ostrosith, Niklas (1540\u20131593)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1593",
        "PLACEOFBIRTH": "Giletinci",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12720",
        "NAME": "Ostrosith, Andreas (1550\u20131609)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "Giletinci",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12721",
        "NAME": "Ostrosith, Stephan (1579\u20131659)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1659",
        "PLACEOFBIRTH": "Illau an der Waag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12722",
        "NAME": "Ostrosith, Niklas (1610\u20131660), Ungarischer Kronh\u00fcter",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1660",
        "PLACEOFBIRTH": "Illau an der Waag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12723",
        "NAME": "Ostrosith, Paul (1620\u20131652)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1652 Okt 17",
        "PLACEOFBIRTH": "Illau an der Waag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12724",
        "NAME": "Ostrosith, Matthias (1625\u20131701)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1701",
        "PLACEOFBIRTH": "Illau an der Waag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12725",
        "NAME": "Ostrosith, Johann (1599\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "Illau an der Waag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12726",
        "NAME": "Keglevich, Niklas (1610\u20131642)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Bu\u017eim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12727",
        "NAME": "Keglevich, Johann (1570\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "Bu\u017eim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12728",
        "NAME": "Keglevich, Peter (1478\u20131554)",
        "DATEOFBIRTH": "1478",
        "DATEOFDEATH": "1554",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bu\u017eim"
    },
    {
        "ID": "12729",
        "NAME": "Keglevich, Niklas (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bu\u017eim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12730",
        "NAME": "Keglevich, Niklas (1640\u20131701)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1701",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "G\u00fcns"
    },
    {
        "ID": "12731",
        "NAME": "M\u00f6rsperg, Erhard Friedrich (1592\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1650~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12732",
        "NAME": "J\u00f6rger von Tollet, Helmhard (1530\u20131594), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1530 Jan 29",
        "DATEOFDEATH": "1594 Dez 18",
        "PLACEOFBIRTH": "Tollet an der Trattnach",
        "PLACEOFDEATH": "Walpersdorf ob der Traisen"
    },
    {
        "ID": "12733",
        "NAME": "Paradeiser von Neuhaus, Georg (1565\u20131601)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1601 Okt 19",
        "PLACEOFBIRTH": "Neuhaus in K\u00e4rnten",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12734",
        "NAME": "Nagy, Stephan (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12735",
        "NAME": "Bartholis, Johann Baptist (1550\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12736",
        "NAME": "Waldstein, Magdalena (1640\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12737",
        "NAME": "Colloredo, Marzius (1505\u20131586)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12738",
        "NAME": "Colloredo, Friedrich (1530\u20131591), K\u00e4mmerer",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1591",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12739",
        "NAME": "Colloredo, L\u00e4lius (1544\u20131602), K\u00e4mmerer",
        "DATEOFBIRTH": "1544",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12740",
        "NAME": "Colloredo, Wilhelm (1275\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1275~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12741",
        "NAME": "Colloredo, Asquin (1310\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1310~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12742",
        "NAME": "Colloredo, Niklas (1340\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12743",
        "NAME": "Colloredo, Asquin (1370\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12744",
        "NAME": "Colloredo, Friedrich (1410\u20131465)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1465~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12745",
        "NAME": "Colloredo, Ludwig (1440\u20131480)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1480~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12746",
        "NAME": "Colloredo, Bernhard (1313\u20131347)",
        "DATEOFBIRTH": "1313",
        "DATEOFDEATH": "1347",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12747",
        "NAME": "Colloredo, Franz (1345\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1345~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12748",
        "NAME": "Colloredo, Johann (1380\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12749",
        "NAME": "Colloredo, Matthias (1410\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12750",
        "NAME": "Colloredo, Johann Baptist (1656\u20131729), Obersthofmarschall",
        "DATEOFBIRTH": "1656",
        "DATEOFDEATH": "1729 Apr 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12751",
        "NAME": "Colloredo, Johann (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12752",
        "NAME": "Colloredo, Hieronym (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12753",
        "NAME": "Colloredo, Johann Baptist (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12754",
        "NAME": "Colloredo, Kurt (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12755",
        "NAME": "Colloredo, Weikhard (1315\u20131366)",
        "DATEOFBIRTH": "1315~",
        "DATEOFDEATH": "1366",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12756",
        "NAME": "Colloredo, Simon (1350\u20131407)",
        "DATEOFBIRTH": "1350~",
        "DATEOFDEATH": "1407",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12757",
        "NAME": "Colloredo, Weikhard (1380\u20131430)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1430~",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12758",
        "NAME": "Colloredo, Ulrich (1420\u20131476)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1476",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12759",
        "NAME": "Colloredo, Albrecht (1450\u20131512)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12760",
        "NAME": "Colloredo, Hieronym (1480\u20131540)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1540~",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12761",
        "NAME": "Colloredo, Friedrich (1470\u20131511)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1511",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12762",
        "NAME": "Colloredo, Christoph (1588\u20131606), Panetier",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12763",
        "NAME": "Colloredo, L\u00e4lius (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12764",
        "NAME": "Warsberg, Samson (1569\u20131630)",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1630~",
        "PLACEOFBIRTH": "Warsberg in Lothringen",
        "PLACEOFDEATH": "Rheineck im Ahrgau"
    },
    {
        "ID": "12765",
        "NAME": "Warsberg, Walter (1595\u20131643), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Rheineck im Ahrgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12766",
        "NAME": "Warsberg, Magdalena (1605\u20131647)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1647 Dez 26",
        "PLACEOFBIRTH": "Rheineck im Ahrgau",
        "PLACEOFDEATH": "Worms:Martinskirche"
    },
    {
        "ID": "12767",
        "NAME": "K\u00e4mmerer von Worms genannt Dalberg, Philipp Balthasar (1597\u20131639)",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1639 Apr 10",
        "PLACEOFBIRTH": "Worms",
        "PLACEOFDEATH": "Worms:Martinskirche"
    },
    {
        "ID": "12768",
        "NAME": "K\u00e4mmerer von Worms genannt Dalberg, Philipp Franz (1635\u20131693)",
        "DATEOFBIRTH": "1635 Mar 15",
        "DATEOFDEATH": "1693 Dez 24",
        "PLACEOFBIRTH": "Worms",
        "PLACEOFDEATH": "Mainz"
    },
    {
        "ID": "12769",
        "NAME": "Gallas, Anton Pankraz (1638\u20131695), K\u00e4mmerer",
        "DATEOFBIRTH": "1638",
        "DATEOFDEATH": "1695",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12770",
        "NAME": "Salm, Johann (1431\u20131485)",
        "DATEOFBIRTH": "1431 Jun 29",
        "DATEOFDEATH": "1485 Jun 04",
        "PLACEOFBIRTH": "Salm in den Ardennen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12771",
        "NAME": "Schaffgotsch, Johann (1420\u20131489)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1489",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Warmbrunn im Riesengebirge"
    },
    {
        "ID": "12772",
        "NAME": "Schaffgotsch, Kaspar (1476\u20131534), Landeshauptmann von Schweidnitz und Jauer",
        "DATEOFBIRTH": "1476",
        "DATEOFDEATH": "1534",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Warmbrunn im Riesengebirge"
    },
    {
        "ID": "12773",
        "NAME": "Schaffgotsch, Balthasar (1520\u20131567)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "Langenau im Riesengebirge",
        "PLACEOFDEATH": "Warmbrunn im Riesengebirge"
    },
    {
        "ID": "12774",
        "NAME": "Schaffgotsch, Ulrich (1480\u20131543)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1543 Mar 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Warmbrunn im Riesengebirge"
    },
    {
        "ID": "12775",
        "NAME": "Schaffgotsch, Johann (1520\u20131584)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1584 Jan 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Greiffenberg in Schlesien"
    },
    {
        "ID": "12776",
        "NAME": "Schaffgotsch, Gotthard (1550\u20131576), Truchsess",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1576 Mai 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Annaburg"
    },
    {
        "ID": "12777",
        "NAME": "Schaffgotsch, Magdalena (1560\u20131587)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1587 Apr 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Greiffenberg in Schlesien"
    },
    {
        "ID": "12778",
        "NAME": "Schaffgotsch, Johann Ulrich (1553\u20131589), Truchsess",
        "DATEOFBIRTH": "1553 Nov 30",
        "DATEOFDEATH": "1589 Aug 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Greiffenberg in Schlesien"
    },
    {
        "ID": "12779",
        "NAME": "Schaffgotsch, Christoph (1552\u20131601)",
        "DATEOFBIRTH": "1552 Mar 27",
        "DATEOFDEATH": "1601 Jun 09",
        "PLACEOFBIRTH": "Langenau im Riesengebirge",
        "PLACEOFDEATH": "Warmbrunn im Riesengebirge"
    },
    {
        "ID": "12780",
        "NAME": "Sulz, Rudolf (1478\u20131535), Landgraf im Klettgau",
        "DATEOFBIRTH": "1478",
        "DATEOFDEATH": "1535 Okt 05",
        "PLACEOFBIRTH": "Tiengen im Klettgau",
        "PLACEOFDEATH": "Vaduz"
    },
    {
        "ID": "12781",
        "NAME": "Sulz, Johann Ludwig (1500\u20131544), Landgraf im Klettgau",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1544",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12782",
        "NAME": "Sulz, Alwig (1527\u20131572), Landgraf im Klettgau",
        "DATEOFBIRTH": "1527",
        "DATEOFDEATH": "1572 Jan 04",
        "PLACEOFBIRTH": "Tiengen im Klettgau",
        "PLACEOFDEATH": "Ensisheim"
    },
    {
        "ID": "12783",
        "NAME": "Auersperg, Wolfgang Niklas (1579\u20131632), Mundschenk",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1632 Apr 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12784",
        "NAME": "Auersperg, Paul Volkhard (1581\u20131605), Truchsess",
        "DATEOFBIRTH": "1581",
        "DATEOFDEATH": "1605 Mar 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12785",
        "NAME": "Auersperg, Georg Jakob (1586\u20131649), Panetier",
        "DATEOFBIRTH": "1586 Sep 07",
        "DATEOFDEATH": "1649 Mai 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sankt P\u00f6lten"
    },
    {
        "ID": "12786",
        "NAME": "Marschall von Pappenheim, Thomas (1505\u20131552)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1552",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12787",
        "NAME": "Marschall von Pappenheim, Thomas (1535\u20131568)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1568",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12788",
        "NAME": "Marschall von Pappenheim, Philipp Thomas (1569\u20131634)",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1634 Feb 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12789",
        "NAME": "Dietrichstein, Johann Balthasar (1598\u20131634), Hofkriegsrat",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12790",
        "NAME": "Schutzbar genannt Milchling, Heinrich Hermann (1576\u20131656), K\u00e4mmerer",
        "DATEOFBIRTH": "1576 Okt 11",
        "DATEOFDEATH": "1656 Jan 31",
        "PLACEOFBIRTH": "Wilhermsdorf im Zenngrund",
        "PLACEOFDEATH": "Wilhermsdorf im Zenngrund"
    },
    {
        "ID": "12791",
        "NAME": "Lynden, Hermann (1547\u20131603), Mundschenk",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1603 Jun 05",
        "PLACEOFBIRTH": "L\u00fcttich",
        "PLACEOFDEATH": "Reckheim"
    },
    {
        "ID": "12792",
        "NAME": "Lynden, Ernst (1583\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "L\u00fcttich",
        "PLACEOFDEATH": "Reckheim"
    },
    {
        "ID": "12793",
        "NAME": "Lynden, Ferdinand (1611\u20131665), K\u00e4mmerer",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1665 Aug 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Reckheim"
    },
    {
        "ID": "12794",
        "NAME": "Lynden, Ferdinand Walprecht (1643\u20131708), K\u00e4mmerer",
        "DATEOFBIRTH": "1643",
        "DATEOFDEATH": "1708 Feb 01",
        "PLACEOFBIRTH": "Reckheim",
        "PLACEOFDEATH": "Reckheim"
    },
    {
        "ID": "12795",
        "NAME": "Dyhrn, Melchior Silvius (1663\u20131726), K\u00e4mmerer",
        "DATEOFBIRTH": "1663 Mar 17",
        "DATEOFDEATH": "1726 Apr 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12796",
        "NAME": "Dyhrn, Christoph (1576\u20131655)",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1655 Apr 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Streitelsdorf"
    },
    {
        "ID": "12797",
        "NAME": "Guyard von Saint Julien, Adam Maximilian (1639\u20131683), Oberstfalkenmeister",
        "DATEOFBIRTH": "1639 Apr 22",
        "DATEOFDEATH": "1683 Feb 19",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "12798",
        "NAME": "Schlick, Georg Friedrich (1595\u20131642), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1642 Mar 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Mansfeld"
    },
    {
        "ID": "12799",
        "NAME": "Gallas, Johann Wenzel (1669\u20131719), K\u00e4mmerer",
        "DATEOFBIRTH": "1669 Mar 23",
        "DATEOFDEATH": "1719 Jul 25",
        "PLACEOFBIRTH": "Horzeniowes",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "12800",
        "NAME": "Jagiello, Lassel (1456\u20131516), K\u00f6nig von B\u00f6hmen",
        "DATEOFBIRTH": "1456 Mar 01",
        "DATEOFDEATH": "1516 Mar 13",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "12801",
        "NAME": "Salm, Julius (1600\u20131654), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1600",
        "DATEOFDEATH": "1654 Mai",
        "PLACEOFBIRTH": "Neuburg am Inn",
        "PLACEOFDEATH": "Tobitschau"
    },
    {
        "ID": "12802",
        "NAME": "Salm, Elisabeth (1599\u20131666)",
        "DATEOFBIRTH": "1599 Nov 14",
        "DATEOFDEATH": "1666 Nov 10",
        "PLACEOFBIRTH": "Neuburg am Inn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12803",
        "NAME": "Schwarzenberg, Erkinger (1362\u20131437)",
        "DATEOFBIRTH": "1362",
        "DATEOFDEATH": "1437 Dez 11",
        "PLACEOFBIRTH": "Seinsheim",
        "PLACEOFDEATH": "Marienbr\u00fcck in Astheim"
    },
    {
        "ID": "12804",
        "NAME": "Schwarzenberg, Michael (1390\u20131469)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1469 Mar 19",
        "PLACEOFBIRTH": "Seinsheim",
        "PLACEOFDEATH": "Marienbr\u00fcck in Astheim"
    },
    {
        "ID": "12805",
        "NAME": "Schwarzenberg, Michael (1420\u20131499)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1499 Sep 10",
        "PLACEOFBIRTH": "Seinsheim",
        "PLACEOFDEATH": "Marienbr\u00fcck in Astheim"
    },
    {
        "ID": "12806",
        "NAME": "Schwarzenberg, Erkinger (1455\u20131518)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1518",
        "PLACEOFBIRTH": "Schwarzenberg in Franken",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12807",
        "NAME": "Schwarzenberg, Wilhelm (1486\u20131526)",
        "DATEOFBIRTH": "1486",
        "DATEOFDEATH": "1526",
        "PLACEOFBIRTH": "Schwarzenberg in Franken",
        "PLACEOFDEATH": "Steenw\u0133k"
    },
    {
        "ID": "12808",
        "NAME": "Schwarzenberg, Wilhelm (1520\u20131557)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1557 Aug 10",
        "PLACEOFBIRTH": "Schwarzenberg in Franken",
        "PLACEOFDEATH": "Saint Quentin"
    },
    {
        "ID": "12809",
        "NAME": "Schwarzenberg, Adolf (1551\u20131600)",
        "DATEOFBIRTH": "1551",
        "DATEOFDEATH": "1600 Jul 29",
        "PLACEOFBIRTH": "Gimborn",
        "PLACEOFDEATH": "P\u00e1pa"
    },
    {
        "ID": "12810",
        "NAME": "Schwarzenberg, Adam (1583\u20131641)",
        "DATEOFBIRTH": "1583 Aug 26",
        "DATEOFDEATH": "1641 Mar 14",
        "PLACEOFBIRTH": "Gimborn",
        "PLACEOFDEATH": "Spandau:Nikolaikirche"
    },
    {
        "ID": "12811",
        "NAME": "Schwarzenberg, Siegmund (1420\u20131502)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1502 Jul 04",
        "PLACEOFBIRTH": "Schwarzenberg in Franken",
        "PLACEOFDEATH": "Landsberg im Steigerwald"
    },
    {
        "ID": "12812",
        "NAME": "Schwarzenberg, Johann (1463\u20131528)",
        "DATEOFBIRTH": "1463 Dez 25",
        "DATEOFDEATH": "1528 Okt 21",
        "PLACEOFBIRTH": "Schwarzenberg in Franken",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "12813",
        "NAME": "Schwarzenberg, Christoph (1488\u20131538)",
        "DATEOFBIRTH": "1488 Jul 28",
        "DATEOFDEATH": "1538 Jan 09",
        "PLACEOFBIRTH": "Lohr am Main",
        "PLACEOFDEATH": "Landsberg im Steigerwald"
    },
    {
        "ID": "12814",
        "NAME": "Schwarzenberg, Wilhelm (1511\u20131552)",
        "DATEOFBIRTH": "1511 Aug 26",
        "DATEOFDEATH": "1552 Jan 11",
        "PLACEOFBIRTH": "Landsberg im Steigerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12815",
        "NAME": "Schwarzenberg, Christoph (1550\u20131596)",
        "DATEOFBIRTH": "1550 Sep 07",
        "DATEOFDEATH": "1596 Jul 06",
        "PLACEOFBIRTH": "Landsberg im Steigerwald",
        "PLACEOFDEATH": "Straubing"
    },
    {
        "ID": "12816",
        "NAME": "Schwarzenberg, Otto Heinrich (1535\u20131590), Obersthofmarschall",
        "DATEOFBIRTH": "1535 Nov 15",
        "DATEOFDEATH": "1590 Aug 11",
        "PLACEOFBIRTH": "Landsberg im Steigerwald",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "12817",
        "NAME": "K\u00f6nigsegg, Georg (1568\u20131622), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1622 Aug 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Blaichach"
    },
    {
        "ID": "12818",
        "NAME": "K\u00f6nigsegg, Johann Georg (1598\u20131666), Obersthofmeister",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1666 Feb 11",
        "PLACEOFBIRTH": "Rothenfels im Allg\u00e4u",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "12819",
        "NAME": "Sulz, Maria Anna (1653\u20131698)",
        "DATEOFBIRTH": "1653 Okt 23",
        "DATEOFDEATH": "1698 Jun 27",
        "PLACEOFBIRTH": "Tiengen im Klettgau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12820",
        "NAME": "Schwarzenberg, Ferdinand (1652\u20131703), Obersthofmeister",
        "DATEOFBIRTH": "1652 Mai 23",
        "DATEOFDEATH": "1703 Okt 22",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "12821",
        "NAME": "Solms, Friedrich (1574\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1574 Nov 30",
        "DATEOFDEATH": "1635 Sep 15",
        "PLACEOFBIRTH": "Laubach im Wettertal",
        "PLACEOFDEATH": "Stra\u00dfburg im Elsass"
    },
    {
        "ID": "12822",
        "NAME": "Blokland van Montfoort, Johann (1567\u20131648), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1648 Sep 30",
        "PLACEOFBIRTH": "Antwerpen",
        "PLACEOFDEATH": "Vilvoorde"
    },
    {
        "ID": "12823",
        "NAME": "Mainburg, Bernhard (1460\u20131516)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1516",
        "PLACEOFBIRTH": "Mainburg im Pielachtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12824",
        "NAME": "Khevenh\u00fcller, Siegmund (1507\u20131552)",
        "DATEOFBIRTH": "1507 Mai 02",
        "DATEOFDEATH": "1552 Sep 17",
        "PLACEOFBIRTH": "Hardegg an der Glan",
        "PLACEOFDEATH": "M\u00f6rtenegg in K\u00e4rnten"
    },
    {
        "ID": "12825",
        "NAME": "Khevenh\u00fcller, Georg (1533\u20131587), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1533 Apr 22",
        "DATEOFDEATH": "1587 Sep 09",
        "PLACEOFBIRTH": "Pittersberg in K\u00e4rnten",
        "PLACEOFDEATH": "Klagenfurt am W\u00f6rthersee"
    },
    {
        "ID": "12826",
        "NAME": "Taaffe von Carlingford, Franz (1639\u20131704), Geheimer Rat",
        "DATEOFBIRTH": "1639",
        "DATEOFDEATH": "1704 Jul 16",
        "PLACEOFBIRTH": "Ballymote",
        "PLACEOFDEATH": "Nancy"
    },
    {
        "ID": "12827",
        "NAME": "Trauttmansdorff, Franz Wenzel (1677\u20131753)",
        "DATEOFBIRTH": "1677 Aug 31",
        "DATEOFDEATH": "1753 Mar 23",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12828",
        "NAME": "Fugger, Georg (1560\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1560 Jul 11",
        "DATEOFDEATH": "1634 Jan 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Riva del Garda"
    },
    {
        "ID": "12829",
        "NAME": "Fugger, Margarita (1592\u20131629)",
        "DATEOFBIRTH": "1592 Feb 03",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Riva del Garda",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12830",
        "NAME": "Fugger, Niklas (1596\u20131676), K\u00e4mmerer",
        "DATEOFBIRTH": "1596 Feb 24",
        "DATEOFDEATH": "1676 Mai 12",
        "PLACEOFBIRTH": "Riva del Garda",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12831",
        "NAME": "Herberstein, Christoph Moritz (1580\u20131635), Obersthofmarschall",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1635~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12832",
        "NAME": "Fugger, Maximilian (1587\u20131629)",
        "DATEOFBIRTH": "1587 Mar 08",
        "DATEOFDEATH": "1629 Mar 02",
        "PLACEOFBIRTH": "Babenhausen in Schwaben",
        "PLACEOFDEATH": "Babenhausen in Schwaben"
    },
    {
        "ID": "12833",
        "NAME": "Fugger, Anton (1563\u20131616)",
        "DATEOFBIRTH": "1563 Apr 01",
        "DATEOFDEATH": "1616 Jul 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "12834",
        "NAME": "Fugger, Maximilian (1608\u20131669), K\u00e4mmerer",
        "DATEOFBIRTH": "1608 Dez 04",
        "DATEOFDEATH": "1669 Jan 12",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "12835",
        "NAME": "Fugger, Otto Heinrich (1592\u20131644), K\u00e4mmerer",
        "DATEOFBIRTH": "1592 Jan 12",
        "DATEOFDEATH": "1644 Okt 12",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "12836",
        "NAME": "Fugger, Sebastian (1620\u20131677)",
        "DATEOFBIRTH": "1620 Dez 07",
        "DATEOFDEATH": "1677 Jul 20",
        "PLACEOFBIRTH": "Mattsies",
        "PLACEOFDEATH": "Augsburg:Ulrichsbasilika"
    },
    {
        "ID": "12837",
        "NAME": "Fugger, Maria Theresia (1657\u20131729)",
        "DATEOFBIRTH": "1657 Dez 30",
        "DATEOFDEATH": "1729 Mai 30",
        "PLACEOFBIRTH": "Mattsies",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12838",
        "NAME": "Fugger, Siegmund Joseph (1654\u20131696), K\u00e4mmerer",
        "DATEOFBIRTH": "1654 Aug 15",
        "DATEOFDEATH": "1696 Jan 30",
        "PLACEOFBIRTH": "Babenhausen in Schwaben",
        "PLACEOFDEATH": "Babenhausen in Schwaben"
    },
    {
        "ID": "12839",
        "NAME": "Fugger, Johann Rudolf (1657\u20131693), K\u00e4mmerer",
        "DATEOFBIRTH": "1657 Apr 09",
        "DATEOFDEATH": "1693 Feb 14",
        "PLACEOFBIRTH": "Babenhausen in Schwaben",
        "PLACEOFDEATH": "Boos in Schwaben"
    },
    {
        "ID": "12840",
        "NAME": "Truchsess von Waldburg, Johanna Katharina (1660\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12841",
        "NAME": "Colloredo, Foppe (1520\u20131579)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12842",
        "NAME": "Colloredo, Niklas (1560\u20131614)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1614",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12843",
        "NAME": "Colloredo, Foppe (1605\u20131660)",
        "DATEOFBIRTH": "1605 Mai 23",
        "DATEOFDEATH": "1660",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12844",
        "NAME": "Colloredo, Ferdinand (1635\u20131689)",
        "DATEOFBIRTH": "1635 Okt 03",
        "DATEOFDEATH": "1689",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12845",
        "NAME": "Colloredo, Hieronym (1674\u20131726), Obersthofmarschall",
        "DATEOFBIRTH": "1674 Mar 12",
        "DATEOFDEATH": "1726 Feb 02",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12846",
        "NAME": "Colloredo, Kamil (1610\u20131664)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12847",
        "NAME": "Colloredo, Kurt (1615\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12848",
        "NAME": "Khevenh\u00fcller, Salomena (1590\u20131650)",
        "DATEOFBIRTH": "1590 Jul 14",
        "DATEOFDEATH": "1650 Jul 07",
        "PLACEOFBIRTH": "Klagenfurt am W\u00f6rthersee",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "12849",
        "NAME": "Khevenh\u00fcller, Katharina (1560\u20131597)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12850",
        "NAME": "Hohenzollern, Albrecht (1490\u20131568), Hochmeister des Deutschen Ordens",
        "DATEOFBIRTH": "1490 Mai 17",
        "DATEOFDEATH": "1568 Mar 20",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Tapiau am Pregel"
    },
    {
        "ID": "12851",
        "NAME": "Hohenzollern, Albrecht Friedrich (1553\u20131618), Herzog in Preu\u00dfen",
        "DATEOFBIRTH": "1553 Apr 29",
        "DATEOFDEATH": "1618 Aug 28",
        "PLACEOFBIRTH": "K\u00f6nigsberg in Preu\u00dfen",
        "PLACEOFDEATH": "Fischhausen im Samland"
    },
    {
        "ID": "12852",
        "NAME": "Solms, Philipp (1468\u20131544)",
        "DATEOFBIRTH": "1468 Aug 15",
        "DATEOFDEATH": "1544 Okt 03",
        "PLACEOFBIRTH": "Lich in der Wetterau",
        "PLACEOFDEATH": "Frankfurt am Main"
    },
    {
        "ID": "12853",
        "NAME": "Solms, Reinhard (1491\u20131562)",
        "DATEOFBIRTH": "1491 Okt 12",
        "DATEOFDEATH": "1562 Sep 23",
        "PLACEOFBIRTH": "Lich in der Wetterau",
        "PLACEOFDEATH": "Lich in der Wetterau"
    },
    {
        "ID": "12854",
        "NAME": "Solms, Ernst (1527\u20131590)",
        "DATEOFBIRTH": "1527 Aug 17",
        "DATEOFDEATH": "1590 Aug 26",
        "PLACEOFBIRTH": "Lich in der Wetterau",
        "PLACEOFDEATH": "Lich in der Wetterau"
    },
    {
        "ID": "12855",
        "NAME": "Solms, Philipp (1569\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1569 Jul 04",
        "DATEOFDEATH": "1631 Feb 13",
        "PLACEOFBIRTH": "Lich in der Wetterau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12856",
        "NAME": "Solms, Otto (1496\u20131522)",
        "DATEOFBIRTH": "1496 Mai 01",
        "DATEOFDEATH": "1522 Mai 14",
        "PLACEOFBIRTH": "Lich in der Wetterau",
        "PLACEOFDEATH": "Lich in der Wetterau"
    },
    {
        "ID": "12857",
        "NAME": "Solms, Friedrich (1521\u20131561)",
        "DATEOFBIRTH": "1521 Okt 01",
        "DATEOFDEATH": "1561 Jan 13",
        "PLACEOFBIRTH": "Lich in der Wetterau",
        "PLACEOFDEATH": "Laubach im Wettertal"
    },
    {
        "ID": "12858",
        "NAME": "Solms, Johann Georg (1591\u20131632)",
        "DATEOFBIRTH": "1591 Nov 19",
        "DATEOFDEATH": "1632 Feb 04",
        "PLACEOFBIRTH": "Laubach im Wettertal",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12859",
        "NAME": "Solms, Heinrich Wilhelm (1583\u20131632)",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1632 Mar 21",
        "PLACEOFBIRTH": "Laubach im Wettertal",
        "PLACEOFDEATH": "Schweinfurt"
    },
    {
        "ID": "12860",
        "NAME": "Hohenzollern, Eitel Friedrich (1601\u20131661)",
        "DATEOFBIRTH": "1601 Jan 16",
        "DATEOFDEATH": "1661 Jul 11",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Budweis in B\u00f6hmen"
    },
    {
        "ID": "12861",
        "NAME": "Harrach, Leonhard (1416\u20131461), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1416",
        "DATEOFDEATH": "1461 Jan 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12862",
        "NAME": "Harrach, Leonhard (1449\u20131518)",
        "DATEOFBIRTH": "1449",
        "DATEOFDEATH": "1518",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12863",
        "NAME": "Harrach, Leonhard (1481\u20131527)",
        "DATEOFBIRTH": "1481",
        "DATEOFDEATH": "1527 Dez 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12864",
        "NAME": "Harrach, Leonhard (1514\u20131590), Obersthofmeister",
        "DATEOFBIRTH": "1514",
        "DATEOFDEATH": "1590 Jun 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "12865",
        "NAME": "Harrach, Leonhard (1542\u20131597), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1597 Feb 05",
        "PLACEOFBIRTH": "Rohrau an der Leitha",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12866",
        "NAME": "Harrach, Leonhard (1568\u20131608), K\u00e4mmerer",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "Rohrau an der Leitha",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12867",
        "NAME": "Harrach, Anna (1564\u20131624)",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1624 Sep 02",
        "PLACEOFBIRTH": "Rohrau an der Leitha",
        "PLACEOFDEATH": "Asparn an der Zaya"
    },
    {
        "ID": "12868",
        "NAME": "Oldenburg, Johann (1455\u20131513), K\u00f6nig von D\u00e4nemark",
        "DATEOFBIRTH": "1455 Jul 08",
        "DATEOFDEATH": "1513 Feb 20",
        "PLACEOFBIRTH": "Aalborg",
        "PLACEOFDEATH": "Aalborg"
    },
    {
        "ID": "12869",
        "NAME": "Oldenburg, Christian (1481\u20131559), K\u00f6nig von D\u00e4nemark",
        "DATEOFBIRTH": "1481 Jul 02",
        "DATEOFDEATH": "1559 Jan 25",
        "PLACEOFBIRTH": "Nyborg",
        "PLACEOFDEATH": "Kalundborg"
    },
    {
        "ID": "12870",
        "NAME": "Montfort, Haug (1595\u20131662), K\u00e4mmerer",
        "DATEOFBIRTH": "1595",
        "DATEOFDEATH": "1662 Jul 02",
        "PLACEOFBIRTH": "Tettnang",
        "PLACEOFDEATH": "Argen im Bodensee"
    },
    {
        "ID": "12871",
        "NAME": "Montfort, Johann (1627\u20131686), K\u00e4mmerer",
        "DATEOFBIRTH": "1627 Nov 25",
        "DATEOFDEATH": "1686 Sep 12",
        "PLACEOFBIRTH": "Tettnang",
        "PLACEOFDEATH": "Argen im Bodensee"
    },
    {
        "ID": "12872",
        "NAME": "Montfort, Anton (1635\u20131706), K\u00e4mmerer",
        "DATEOFBIRTH": "1635 Okt 14",
        "DATEOFDEATH": "1706 Jan 14",
        "PLACEOFBIRTH": "Reichenau im Bodensee",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "12873",
        "NAME": "Lochner von Liebenfels, Konrad (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Liebenfels in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12874",
        "NAME": "Lochner von Liebenfels, Matthias (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Liebenfels in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12875",
        "NAME": "Lochner von Liebenfels, Leonhard (1500\u20131570)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1570 Jan 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12876",
        "NAME": "Auersperg, Weikhard (1533\u20131581), Obersthofmarschall",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1581",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Karlstadt in Kroatien"
    },
    {
        "ID": "12877",
        "NAME": "Montfort, Barbara (1568\u20131599)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1599 Sep 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12878",
        "NAME": "Montfort, Sibylla (1560\u20131600)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1600",
        "PLACEOFBIRTH": "Tettnang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12879",
        "NAME": "Montfort, Katharina (1556\u20131631)",
        "DATEOFBIRTH": "1556",
        "DATEOFDEATH": "1631 Mar 31",
        "PLACEOFBIRTH": "Tettnang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12880",
        "NAME": "Waldeck, Christian (1585\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1585 Dez 25",
        "DATEOFDEATH": "1638 Jan 10",
        "PLACEOFBIRTH": "Eisenberg im Grafschafter Bergland",
        "PLACEOFDEATH": "Waldeck am Edersee"
    },
    {
        "ID": "12881",
        "NAME": "Dietrichstein, Maximilian (1562\u20131611), Oberststallmeister",
        "DATEOFBIRTH": "1562 Jan 16",
        "DATEOFDEATH": "1611 Mar 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Nikolsburg in M\u00e4hren"
    },
    {
        "ID": "12882",
        "NAME": "Cobenzl, Johann (1530\u20131594), Landeshauptmann von Krain",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1594 Aug 16",
        "PLACEOFBIRTH": "Sankt Daniel am Karst",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "12883",
        "NAME": "Windischgr\u00e4tz, Christoph (1490\u20131549)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1549 Feb 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12884",
        "NAME": "Windischgr\u00e4tz, Erasam (1519\u20131573), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1519",
        "DATEOFDEATH": "1573",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12885",
        "NAME": "Windischgr\u00e4tz, Andreas (1560\u20131600)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1600",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12886",
        "NAME": "Windischgr\u00e4tz, Bartlome (1593\u20131633)",
        "DATEOFBIRTH": "1593 Jan 03",
        "DATEOFDEATH": "1633 Nov 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "12887",
        "NAME": "Windischgr\u00e4tz, Pankraz (1525\u20131591)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1591 Okt 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12888",
        "NAME": "Windischgr\u00e4tz, Christoph (1580\u20131628), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1628 Feb 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12889",
        "NAME": "Windischgr\u00e4tz, Jakob (1520\u20131577)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1577 Mar 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Katsch an der Mur"
    },
    {
        "ID": "12890",
        "NAME": "Vaud\u00e9mont, Leopold (1679\u20131729), Herzog von Lothringen",
        "DATEOFBIRTH": "1679 Sep 11",
        "DATEOFDEATH": "1729 Mar 27",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Lun\u00e9ville"
    },
    {
        "ID": "12891",
        "NAME": "Vaud\u00e9mont, Klement (1707\u20131723), Erbprinz von Lothringen",
        "DATEOFBIRTH": "1707 Apr 25",
        "DATEOFDEATH": "1723 Jun 04",
        "PLACEOFBIRTH": "Lun\u00e9ville",
        "PLACEOFDEATH": "Lun\u00e9ville"
    },
    {
        "ID": "12892",
        "NAME": "Kollonitz, Gabriel (1530\u20131590), Mundschenk",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1590~",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12893",
        "NAME": "Starhemberg, Kaspar (1598\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1598 Jul 11",
        "DATEOFDEATH": "1646 Sep 04",
        "PLACEOFBIRTH": "Riedegg im M\u00fchlviertel",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "12894",
        "NAME": "Toerring, Kaspar (1486\u20131560)",
        "DATEOFBIRTH": "1486 Feb 10",
        "DATEOFDEATH": "1560 Mar 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "T\u00fc\u00dfling"
    },
    {
        "ID": "12895",
        "NAME": "Toerring, Johann Veit (1525\u20131582)",
        "DATEOFBIRTH": "1525",
        "DATEOFDEATH": "1582 Mai 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Jettenbach am Inn"
    },
    {
        "ID": "12896",
        "NAME": "Toerring, Johann Siegmund (1582\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1646 Nov 07",
        "PLACEOFBIRTH": "Jettenbach am Inn",
        "PLACEOFDEATH": "Jettenbach am Inn"
    },
    {
        "ID": "12897",
        "NAME": "Toerring, Adam (1527\u20131580)",
        "DATEOFBIRTH": "1527 Jan 19",
        "DATEOFDEATH": "1580 Dez 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "12898",
        "NAME": "Toerring, Lassel Oswald (1566\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1566 Jul 20",
        "DATEOFDEATH": "1638 Dez 12",
        "PLACEOFBIRTH": "Stein an der Traun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12899",
        "NAME": "Toerring, Wolfgang Theoderich (1598\u20131674), K\u00e4mmerer",
        "DATEOFBIRTH": "1598 Jan 03",
        "DATEOFDEATH": "1674 Dez 06",
        "PLACEOFBIRTH": "Stein an der Traun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12900",
        "NAME": "Jagiello, Ludwig (1506\u20131526), K\u00f6nig von Ungarn",
        "DATEOFBIRTH": "1506 Jul 01",
        "DATEOFDEATH": "1526 Aug 29",
        "PLACEOFBIRTH": "Ofen",
        "PLACEOFDEATH": "Moh\u00e1cs"
    },
    {
        "ID": "12901",
        "NAME": "Lippay, Johann (1565\u20131616)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1616 Sep 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12902",
        "NAME": "Lippay, Katharina (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pressburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12903",
        "NAME": "Lippay, Kaspar (1608\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1654",
        "PLACEOFBIRTH": "Pressburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12904",
        "NAME": "Lippay, Johann (1606\u20131666), K\u00e4mmerer",
        "DATEOFBIRTH": "1606 Jul 30",
        "DATEOFDEATH": "1666 Jun 02",
        "PLACEOFBIRTH": "Pressburg",
        "PLACEOFDEATH": "Trentschin im Waagtal"
    },
    {
        "ID": "12905",
        "NAME": "Balogh, Stephan (1600\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1646",
        "PLACEOFBIRTH": "Nebojsza",
        "PLACEOFDEATH": "Totis"
    },
    {
        "ID": "12906",
        "NAME": "Sz\u00e9chy, Margarita (1524\u20131585)",
        "DATEOFBIRTH": "1524",
        "DATEOFDEATH": "1585~",
        "PLACEOFBIRTH": "Sz\u00e9cs an der Rimau",
        "PLACEOFDEATH": "Trentschin im Waagtal"
    },
    {
        "ID": "12907",
        "NAME": "Zr\u00ednyi, Niklas (1489\u20131534)",
        "DATEOFBIRTH": "1489",
        "DATEOFDEATH": "1534",
        "PLACEOFBIRTH": "Zr\u00edn in Slawonien",
        "PLACEOFDEATH": "Zr\u00edn in Slawonien"
    },
    {
        "ID": "12908",
        "NAME": "Zr\u00ednyi, Niklas (1518\u20131566), Ban von Kroatien",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1566 Sep 07",
        "PLACEOFBIRTH": "Zr\u00edn in Slawonien",
        "PLACEOFDEATH": "Szigetv\u00e1r"
    },
    {
        "ID": "12909",
        "NAME": "Zr\u00ednyi, Johann (1565\u20131612), Edelknabe",
        "DATEOFBIRTH": "1565",
        "DATEOFDEATH": "1612 Feb 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hohenfurth an der Moldau"
    },
    {
        "ID": "12910",
        "NAME": "Zr\u00ednyi, Georg (1549\u20131603), Mundschenk",
        "DATEOFBIRTH": "1549 Apr 13",
        "DATEOFDEATH": "1603 Mai 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wettendorf in der G\u00fcnsebene"
    },
    {
        "ID": "12911",
        "NAME": "Zr\u00ednyi, Dorothea (1545\u20131617)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12912",
        "NAME": "Zr\u00ednyi, Ursula (1552\u20131593)",
        "DATEOFBIRTH": "1552 Aug 21",
        "DATEOFDEATH": "1593 Feb 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12913",
        "NAME": "Zr\u00ednyi, Niklas (1570\u20131625)",
        "DATEOFBIRTH": "1570",
        "DATEOFDEATH": "1625 Mar 24",
        "PLACEOFBIRTH": "Trentschin im Waagtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12914",
        "NAME": "Zr\u00ednyi, Adam (1662\u20131691), K\u00e4mmerer",
        "DATEOFBIRTH": "1662 Nov 24",
        "DATEOFDEATH": "1691 Aug 19",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Slankamen"
    },
    {
        "ID": "12915",
        "NAME": "Dersffy von Zerdahely, Niklas (1484\u20131536)",
        "DATEOFBIRTH": "1484",
        "DATEOFDEATH": "1536",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12916",
        "NAME": "Dersffy von Zerdahely, Ursula (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12917",
        "NAME": "Dersffy von Zerdahely, Sophia (1525\u20131569)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12918",
        "NAME": "Dersffy von Zerdahely, Stephan (1520\u20131587)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1587",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12919",
        "NAME": "Dersffy von Zerdahely, Franz (1555\u20131606), Truchsess",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12920",
        "NAME": "Alaghy, Melchior (1587\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1631 Jun 15",
        "PLACEOFBIRTH": "B\u00f6k\u00e9ny an der Thei\u00df",
        "PLACEOFDEATH": "P\u00e1cin"
    },
    {
        "ID": "12921",
        "NAME": "Th\u00f6k\u00f6ly, Sebastian (1540\u20131607)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1607 Feb 03",
        "PLACEOFBIRTH": "Temeschburg",
        "PLACEOFDEATH": "K\u00e4smarkt"
    },
    {
        "ID": "12922",
        "NAME": "Th\u00f6k\u00f6ly, Stephan (1581\u20131651)",
        "DATEOFBIRTH": "1581 Dez 12",
        "DATEOFDEATH": "1651 Nov 08",
        "PLACEOFBIRTH": "K\u00e4smarkt",
        "PLACEOFDEATH": "K\u00e4smarkt"
    },
    {
        "ID": "12923",
        "NAME": "Th\u00f6k\u00f6ly, Stephan (1623\u20131670)",
        "DATEOFBIRTH": "1623 Feb 05",
        "DATEOFDEATH": "1670 Dez 04",
        "PLACEOFBIRTH": "K\u00e4smarkt",
        "PLACEOFDEATH": "Arwaburg"
    },
    {
        "ID": "12924",
        "NAME": "Th\u00f6k\u00f6ly, Emmerich (1657\u20131705), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1657 Sep 25",
        "DATEOFDEATH": "1705 Sep 13",
        "PLACEOFBIRTH": "K\u00e4smarkt",
        "PLACEOFDEATH": "Nikomedia"
    },
    {
        "ID": "12925",
        "NAME": "Th\u00f6k\u00f6ly, Anna (1592\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1592 Nov 09",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "K\u00e4smarkt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12926",
        "NAME": "Th\u00f6k\u00f6ly, Katharina (1655\u20131701)",
        "DATEOFBIRTH": "1655 Apr 18",
        "DATEOFDEATH": "1701 Jan 26",
        "PLACEOFBIRTH": "K\u00e4smarkt",
        "PLACEOFDEATH": "Gattendorf an der Leitha"
    },
    {
        "ID": "12927",
        "NAME": "Th\u00f6k\u00f6ly, Maria (1656\u20131695)",
        "DATEOFBIRTH": "1656 Jun 02",
        "DATEOFDEATH": "1695 Jan 16",
        "PLACEOFBIRTH": "K\u00e4smarkt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12928",
        "NAME": "Th\u00f6k\u00f6ly, Eva (1659\u20131716)",
        "DATEOFBIRTH": "1659 Feb 01",
        "DATEOFDEATH": "1716 Aug 21",
        "PLACEOFBIRTH": "K\u00e4smarkt",
        "PLACEOFDEATH": "Lanzendorf an der Schwechat"
    },
    {
        "ID": "12929",
        "NAME": "Bornemisza von K\u00e1polna, Balthasar (1550\u2013\u00a0\u00a0\u00a0\u00a0), Vorschneider",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12930",
        "NAME": "Zay, Franz (1505\u20131570)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1570 Okt 10",
        "PLACEOFBIRTH": "Cs\u00f6m\u00f6r",
        "PLACEOFDEATH": "Uhrovec"
    },
    {
        "ID": "12931",
        "NAME": "Zay, Lassel (1547\u20131590)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12932",
        "NAME": "Zay, Siegmund (1588\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12933",
        "NAME": "Kendy, Franz (1500\u20131558), F\u00fcrst von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1558 Aug 31",
        "PLACEOFBIRTH": "Szarvaskend in Siebenb\u00fcrgen",
        "PLACEOFDEATH": "Wei\u00dfenburg in Siebenb\u00fcrgen"
    },
    {
        "ID": "12934",
        "NAME": "Kendy, Wolfgang (1553\u20131579), Truchsess",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "Szarvaskend in Siebenb\u00fcrgen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12935",
        "NAME": "Batthy\u00e1ny, Christoph (1637\u20131685), K\u00e4mmerer",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1685 Mar 06",
        "PLACEOFBIRTH": "G\u00fcssing",
        "PLACEOFDEATH": "G\u00fcssing"
    },
    {
        "ID": "12936",
        "NAME": "Cs\u00e1ktornya, Franz Ernst (1480\u20131526), K\u00e4mmerer",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1526",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12937",
        "NAME": "B\u00e1nffy von Losoncz, Siegmund (1478\u20131525)",
        "DATEOFBIRTH": "1478",
        "DATEOFDEATH": "1525",
        "PLACEOFBIRTH": "Klausenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12938",
        "NAME": "B\u00e1nffy von Losoncz, Stephan (1510\u20131552)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1552 Jul 27",
        "PLACEOFBIRTH": "Klausenburg",
        "PLACEOFDEATH": "Temeschburg"
    },
    {
        "ID": "12939",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Barbara (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12940",
        "NAME": "Kollonitz, Johann (1570\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12941",
        "NAME": "Gyulaffy, Stephan (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Radoth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12942",
        "NAME": "Gyulaffy, Lassel (1525\u20131579)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1579 Mai 13",
        "PLACEOFBIRTH": "Radoth",
        "PLACEOFDEATH": "Hofmarkt in Siebenb\u00fcrgen"
    },
    {
        "ID": "12943",
        "NAME": "Gyulaffy, Lassel (1560\u20131605)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1605 Jul 28",
        "PLACEOFBIRTH": "Radoth",
        "PLACEOFDEATH": "K\u00f6pecz"
    },
    {
        "ID": "12944",
        "NAME": "Gyulaffy, Samuel (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Radoth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12945",
        "NAME": "Gyulaffy, Maria (1637\u20131659)",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1659 Nov 19",
        "PLACEOFBIRTH": "Radoth",
        "PLACEOFDEATH": "K\u00e4smarkt"
    },
    {
        "ID": "12946",
        "NAME": "Gyulaffy, Johann (1520\u20131559)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1559",
        "PLACEOFBIRTH": "Radoth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12947",
        "NAME": "Gyulaffy, Georg (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Csob\u00e1nc",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12948",
        "NAME": "Gyulaffy, Eustach (1557\u20131605)",
        "DATEOFBIRTH": "1557 Sep 20",
        "DATEOFDEATH": "1605 Mai 17",
        "PLACEOFBIRTH": "Csob\u00e1nc",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12949",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Katharina (1600\u20131647)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1647",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12950",
        "NAME": "Liechtenstein von Kastelkorn, Karl (1624\u20131695), Bischof von Olm\u00fctz",
        "DATEOFBIRTH": "1624 Apr 08",
        "DATEOFDEATH": "1695 Sep 23",
        "PLACEOFBIRTH": "Glatz",
        "PLACEOFDEATH": "Olm\u00fctz in M\u00e4hren"
    },
    {
        "ID": "12951",
        "NAME": "Kolosv\u00e1ry, Lassel (1550\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12952",
        "NAME": "Forg\u00e1ch, Peter (1580\u20131637), Ungarischer Kronh\u00fcter",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12953",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Michael (1605\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12954",
        "NAME": "B\u00e1nffy von Als\u00f3lendva, Niklas (1445\u20131500)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1500 Okt",
        "PLACEOFBIRTH": "Limbach an der Mur",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12955",
        "NAME": "B\u00e1nffy von Als\u00f3lendva, Johann (1485\u20131534), Palatin von Ungarn",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1534 Jan 30",
        "PLACEOFBIRTH": "Limbach an der Mur",
        "PLACEOFDEATH": "Szaporca"
    },
    {
        "ID": "12956",
        "NAME": "B\u00e1nffy von Als\u00f3lendva, Stephan (1522\u20131568)",
        "DATEOFBIRTH": "1522 Feb 09",
        "DATEOFDEATH": "1568 Jan 28",
        "PLACEOFBIRTH": "Limbach an der Mur",
        "PLACEOFDEATH": "Csernec"
    },
    {
        "ID": "12957",
        "NAME": "B\u00e1nffy von Als\u00f3lendva, Niklas (1547\u20131593), Mundschenk",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1593 Feb 21",
        "PLACEOFBIRTH": "Limbach an der Mur",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12958",
        "NAME": "B\u00e1nffy von Als\u00f3lendva, Christoph (1577\u20131644), K\u00e4mmerer",
        "DATEOFBIRTH": "1577 Mar 12",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "Limbach an der Mur",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12959",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Anna (1536\u20131607)",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1607 Sep 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Eferding"
    },
    {
        "ID": "12960",
        "NAME": "Daun, Wilhelm Anton (1630\u20131706), Hofkriegsrat",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1706 Jun 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "12961",
        "NAME": "Daun, Weirich Philipp (1669\u20131741), K\u00e4mmerer",
        "DATEOFBIRTH": "1669 Okt 19",
        "DATEOFDEATH": "1741 Jul 30",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "12962",
        "NAME": "Daun, Karl Friedrich (1646\u20131727), K\u00e4mmerer",
        "DATEOFBIRTH": "1646",
        "DATEOFDEATH": "1727 Feb 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12963",
        "NAME": "Daun, Philipp Ernst (1600\u20131671)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1671 Jan 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12964",
        "NAME": "Brandis, Veit Bernhard (1606\u20131667), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1667",
        "PLACEOFBIRTH": "Fahlburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12965",
        "NAME": "Brandis, Franz Adam (1639\u20131695)",
        "DATEOFBIRTH": "1639 Jul 18",
        "DATEOFDEATH": "1695 Sep 07",
        "PLACEOFBIRTH": "Fahlburg",
        "PLACEOFDEATH": "Fahlburg"
    },
    {
        "ID": "12966",
        "NAME": "Saurau, Wolfgang (1560\u20131613), K\u00e4mmerer",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1613 Mar 11",
        "PLACEOFBIRTH": "Ligist",
        "PLACEOFDEATH": "Grafenegg im Weinviertel"
    },
    {
        "ID": "12967",
        "NAME": "Saurau, Ehrenreich (1560\u20131626)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Ansbach"
    },
    {
        "ID": "12968",
        "NAME": "Saurau, Benigna (1596\u20131630)",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1630 Mar 12",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "12969",
        "NAME": "Leiningen, Johann Ludwig (1579\u20131625), K\u00e4mmerer",
        "DATEOFBIRTH": "1579 Mai 08",
        "DATEOFDEATH": "1625 Jun 19",
        "PLACEOFBIRTH": "Heidesheim an der Eis",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12970",
        "NAME": "Lynden, Theoderich (1505\u20131560)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1560 Apr 05",
        "PLACEOFBIRTH": "L\u00fcttich",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12971",
        "NAME": "Lynden, Ruprecht (1535\u20131610)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1610 Sep 16",
        "PLACEOFBIRTH": "L\u00fcttich",
        "PLACEOFDEATH": "Theux"
    },
    {
        "ID": "12972",
        "NAME": "Lynden, Karl Ernst (1585\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "L\u00fcttich",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12973",
        "NAME": "Thurn, Hieronym Wenzel (1565\u20131613)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1613 Nov 11",
        "PLACEOFBIRTH": "Lipnitz an der Sasau",
        "PLACEOFDEATH": "Wostitz in M\u00e4hren"
    },
    {
        "ID": "12974",
        "NAME": "Thurn, Veit Heinrich (1590\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "Wostitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12975",
        "NAME": "Khisl von Kaltenbrunn, Karl (1570\u20131632), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "Kaltenbrunn an der Laibach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12976",
        "NAME": "Waldeck, Georg Friedrich (1620\u20131692)",
        "DATEOFBIRTH": "1620 Feb 10",
        "DATEOFDEATH": "1692 Nov 19",
        "PLACEOFBIRTH": "Arolsen",
        "PLACEOFDEATH": "Arolsen"
    },
    {
        "ID": "12977",
        "NAME": "Herberstein, Johann Joseph (1633\u20131689), Gro\u00dfprior des Malteserordens in Ungarn",
        "DATEOFBIRTH": "1633",
        "DATEOFDEATH": "1689 Sep 30",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "12978",
        "NAME": "Herberstein, Johann Ferdinand (1663\u20131721)",
        "DATEOFBIRTH": "1663 Jul 29",
        "DATEOFDEATH": "1721 Mar 15",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "12979",
        "NAME": "Kollonitz, Leopold Karl (1631\u20131707), Erzbischof von Gran",
        "DATEOFBIRTH": "1631 Okt 26",
        "DATEOFDEATH": "1707 Jan 20",
        "PLACEOFBIRTH": "Komorn an der Donau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "12980",
        "NAME": "Zinzendorf, Susanna (1636\u20131709)",
        "DATEOFBIRTH": "1636 Mar 29",
        "DATEOFDEATH": "1709 Jan 29",
        "PLACEOFBIRTH": "Pottendorf",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "12981",
        "NAME": "Fugger, Barbara (1527\u20131573)",
        "DATEOFBIRTH": "1527 Jul 23",
        "DATEOFDEATH": "1573 Dez 12",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12982",
        "NAME": "Kollonitz, Anna (1585\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12983",
        "NAME": "Harrach, Barbara (1505\u20131563)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1563 Dez 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hofkirchen an der Trattnach"
    },
    {
        "ID": "12984",
        "NAME": "Hoyos, Anna Katharina (1625\u20131664)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12985",
        "NAME": "Hohenzollern, Helena (1465\u20131514)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1514 Nov 11",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Wurzach"
    },
    {
        "ID": "12986",
        "NAME": "Salm, Anna (1465\u20131510)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1510 Jun 28",
        "PLACEOFBIRTH": "Salm in den Ardennen",
        "PLACEOFDEATH": "Wolfegg in Schwaben"
    },
    {
        "ID": "12987",
        "NAME": "Per\u00e9nyi, Barbara (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12988",
        "NAME": "Taxis, Elisabeth (1485\u20131524)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1524",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "12989",
        "NAME": "V\u00f6ls, Sidonia (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12990",
        "NAME": "Schlick, Anna Salomena (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12991",
        "NAME": "Batthy\u00e1ny, Katharina (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schlaining",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12992",
        "NAME": "Harrach, Margarita (1546\u20131580)",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1580~",
        "PLACEOFBIRTH": "Rohrau an der Leitha",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12993",
        "NAME": "Annenberg, Maria Maximiliana (1629\u20131664)",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1664 Mar 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Arnsdorf an der Nei\u00dfe"
    },
    {
        "ID": "12994",
        "NAME": "Truchsess von Waldburg, Apollonia (1490\u20131512)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12995",
        "NAME": "J\u00f6rger von Tollet, Justina (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Starhemberg am Hausruck",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12996",
        "NAME": "Sinzendorf, Anna (1545\u20131571)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1571 Sep 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Thunau am Kamp:Pfarrkirche"
    },
    {
        "ID": "12997",
        "NAME": "Dietrichstein, Sophia (1582\u20131612)",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1612 Apr 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neuhaus im Triestingtal"
    },
    {
        "ID": "12998",
        "NAME": "M\u00f6rsperg, Maria Barbara (1615\u20131680)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1680",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "12999",
        "NAME": "Lobkowicz, Katharina Polyxena (1650\u20131709)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1709 Feb 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13000",
        "NAME": "Burgund, Johanna (1479\u20131555), K\u00f6nigin von Kastilien",
        "DATEOFBIRTH": "1479 Nov 06",
        "DATEOFDEATH": "1555 Apr 12",
        "PLACEOFBIRTH": "Toledo",
        "PLACEOFDEATH": "Tordesillas"
    },
    {
        "ID": "13001",
        "NAME": "Attems, Friedrich (1447\u20131521), Statthalter von G\u00f6rz",
        "DATEOFBIRTH": "1447 Nov 25",
        "DATEOFDEATH": "1521",
        "PLACEOFBIRTH": "Attems",
        "PLACEOFDEATH": "G\u00f6rz"
    },
    {
        "ID": "13002",
        "NAME": "Attems, Hieronym (1477\u20131556), Statthalter von Nieder\u00f6sterreich",
        "DATEOFBIRTH": "1477",
        "DATEOFDEATH": "1556 Sep 02",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "G\u00f6rz"
    },
    {
        "ID": "13003",
        "NAME": "Attems, Jakob (1526\u20131590), Obersthofmeister",
        "DATEOFBIRTH": "1526 Nov 29",
        "DATEOFDEATH": "1590 Aug 15",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "Gradisch an der Isnitz"
    },
    {
        "ID": "13004",
        "NAME": "Attems, Hermann (1564\u20131611), Obersthofmeister",
        "DATEOFBIRTH": "1564 Jul 08",
        "DATEOFDEATH": "1611 Jan 23",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "Gradisch an der Isnitz"
    },
    {
        "ID": "13005",
        "NAME": "Attems, Johann Friedrich (1590\u20131663), Oberststallmeister",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1663 Dez 05",
        "PLACEOFBIRTH": "Gradisch an der Isnitz",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "13006",
        "NAME": "Attems, Ferdinand (1593\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1593 Dez 10",
        "DATEOFDEATH": "1636 Dez 29",
        "PLACEOFBIRTH": "Gradisch an der Isnitz",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "13007",
        "NAME": "K\u00f6nigsberg, Ehrenreich (1415\u20131492)",
        "DATEOFBIRTH": "1415~",
        "DATEOFDEATH": "1492",
        "PLACEOFBIRTH": "K\u00f6nigsberg in der Untersteiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13008",
        "NAME": "K\u00f6nigsberg, Georg (1445\u20131514)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1514 Mar 22",
        "PLACEOFBIRTH": "Seebenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13009",
        "NAME": "K\u00f6nigsberg, Georg (1489\u20131556)",
        "DATEOFBIRTH": "1489",
        "DATEOFDEATH": "1556",
        "PLACEOFBIRTH": "Seebenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13010",
        "NAME": "K\u00f6nigsberg, Wolfgang (1524\u20131589), Mundschenk",
        "DATEOFBIRTH": "1524",
        "DATEOFDEATH": "1589 Mar 06",
        "PLACEOFBIRTH": "Seebenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13011",
        "NAME": "K\u00f6nigsberg, Johann (1450\u20131505), Truchsess",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1505",
        "PLACEOFBIRTH": "Seebenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13012",
        "NAME": "Freyberg, Maria (1520\u20131556)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1556",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Seebenstein"
    },
    {
        "ID": "13013",
        "NAME": "K\u00f6nigsberg, Christoph (1542\u20131602), Hofkriegsrat",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1602 Aug 03",
        "PLACEOFBIRTH": "Seebenstein",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13014",
        "NAME": "K\u00f6nigsberg, Erasam (1543\u20131588)",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "Seebenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13015",
        "NAME": "K\u00f6nigsberg, Ulrich (1547\u20131601), Vorschneider",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1601 Sep 21",
        "PLACEOFBIRTH": "Seebenstein",
        "PLACEOFDEATH": "Seebenstein"
    },
    {
        "ID": "13016",
        "NAME": "K\u00f6nigsberg, Ludwig (1577\u20131628), K\u00e4mmerer",
        "DATEOFBIRTH": "1577 Aug 25",
        "DATEOFDEATH": "1628 Mai 09",
        "PLACEOFBIRTH": "Seebenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13017",
        "NAME": "K\u00f6nigsberg, Ehrenreich Christoph (1605\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1646 Dez 20",
        "PLACEOFBIRTH": "Seebenstein",
        "PLACEOFDEATH": "Katzelsdorf an der Leitha"
    },
    {
        "ID": "13018",
        "NAME": "Redern, Melchior (1555\u20131600), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1555 Jan 06",
        "DATEOFDEATH": "1600 Sep 20",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Brod an der Sasau"
    },
    {
        "ID": "13019",
        "NAME": "Ungnad von Weissenwolff, Andreas (1499\u20131557), St\u00e4belmeister",
        "DATEOFBIRTH": "1499 Feb 10",
        "DATEOFDEATH": "1557 Mar 21",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Sonnegg im Jauntal"
    },
    {
        "ID": "13020",
        "NAME": "Leuchtenberg, Georg Ludwig (1563\u20131613), Obersthofmeister",
        "DATEOFBIRTH": "1563 Jul 27",
        "DATEOFDEATH": "1613 Apr 24",
        "PLACEOFBIRTH": "Pfreimd",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13021",
        "NAME": "Losenstein, Bernhard (1368\u20131434)",
        "DATEOFBIRTH": "1368",
        "DATEOFDEATH": "1434",
        "PLACEOFBIRTH": "Leiten im Traunkreis",
        "PLACEOFDEATH": "Leiten im Traunkreis"
    },
    {
        "ID": "13022",
        "NAME": "Losenstein, Rudolf (1400\u20131449)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1449 Nov 23",
        "PLACEOFBIRTH": "Leiten im Traunkreis",
        "PLACEOFDEATH": "Gschwendt an der Krems"
    },
    {
        "ID": "13023",
        "NAME": "Losenstein, Georg (1440\u20131509), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1509",
        "PLACEOFBIRTH": "Gschwendt an der Krems",
        "PLACEOFDEATH": "Eisenstadt im Burgenland"
    },
    {
        "ID": "13024",
        "NAME": "Losenstein, Wolfgang (1480\u20131555)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1555",
        "PLACEOFBIRTH": "Gschwendt an der Krems",
        "PLACEOFDEATH": "Gschwendt an der Krems"
    },
    {
        "ID": "13025",
        "NAME": "Losenstein, Franz Adam (1660\u20131685)",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "1685 Aug 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Gran an der Donau"
    },
    {
        "ID": "13026",
        "NAME": "Losenstein, Maria Theresia (1666\u20131719)",
        "DATEOFBIRTH": "1666 Dez 21",
        "DATEOFDEATH": "1719 Jun 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13027",
        "NAME": "Daun, Beatrix Franziska (1665\u20131701)",
        "DATEOFBIRTH": "1665 Jan 09",
        "DATEOFDEATH": "1701",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13028",
        "NAME": "Berka von der Duba, Adam Gottfried (1594\u20131626), Landeshauptmann von Glatz",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "Reichstadt in B\u00f6hmen",
        "PLACEOFDEATH": "Glatz"
    },
    {
        "ID": "13029",
        "NAME": "Berka von der Duba, Heinrich Wolfgang (1595\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1650~",
        "PLACEOFBIRTH": "Reichstadt in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13030",
        "NAME": "Harant von Polschitz, Christoph (1564\u20131621), K\u00e4mmerer",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1621 Jun 21",
        "PLACEOFBIRTH": "Klenau",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13031",
        "NAME": "Harant von Polschitz, Johann Wilhelm (1610\u20131644)",
        "DATEOFBIRTH": "1610 Sep 29",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "Sosna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13032",
        "NAME": "Harant von Polschitz, Johann Georg (1580\u20131651), K\u00e4mmerer",
        "DATEOFBIRTH": "1580 Jul 24",
        "DATEOFDEATH": "1651",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hof an der Regnitz"
    },
    {
        "ID": "13033",
        "NAME": "Harant von Polschitz, Christoph Wilhelm (1617\u20131691), K\u00e4mmerer",
        "DATEOFBIRTH": "1617 Apr 10",
        "DATEOFDEATH": "1691 Feb 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13034",
        "NAME": "Harant von Polschitz, Leopold Franz (1620\u20131655), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1655~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13035",
        "NAME": "Harant von Polschitz, Wenzel Rudolf (1612\u20131664)",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1664 Sep 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13036",
        "NAME": "Harant von Polschitz, Georg (1521\u20131584)",
        "DATEOFBIRTH": "1521",
        "DATEOFDEATH": "1584 Mai 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13037",
        "NAME": "Stubenberg, Wolfgang (1600\u20131668), K\u00e4mmerer",
        "DATEOFBIRTH": "1600 Jul 22",
        "DATEOFDEATH": "1668 Aug 28",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13038",
        "NAME": "Stubenberg, Wolfgang (1629\u20131676), K\u00e4mmerer",
        "DATEOFBIRTH": "1629 Okt 01",
        "DATEOFDEATH": "1676 Mar 05",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Kapfenberg"
    },
    {
        "ID": "13039",
        "NAME": "Sternberg, Kunigunda Elisabeth (1580\u20131631)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1631",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13040",
        "NAME": "Suys, Ernst (1600\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "L\u00fcttich",
        "PLACEOFDEATH": "Ybbs an der Donau"
    },
    {
        "ID": "13041",
        "NAME": "Losenstein, Florian (1390\u20131452)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1452",
        "PLACEOFBIRTH": "Leiten im Traunkreis",
        "PLACEOFDEATH": "Schallaburg"
    },
    {
        "ID": "13042",
        "NAME": "Losenstein, Wilhelm (1420\u20131509)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1509",
        "PLACEOFBIRTH": "Schallaburg",
        "PLACEOFDEATH": "Schallaburg"
    },
    {
        "ID": "13043",
        "NAME": "Losenstein, Achaz (1452\u20131527)",
        "DATEOFBIRTH": "1452",
        "DATEOFDEATH": "1527 Jul 22",
        "PLACEOFBIRTH": "Schallaburg",
        "PLACEOFDEATH": "Schallaburg"
    },
    {
        "ID": "13044",
        "NAME": "Losenstein, Christoph (1515\u20131558)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1558 Dez 21",
        "PLACEOFBIRTH": "Schallaburg",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13045",
        "NAME": "Liechtenstein von Nikolsburg, Martha (1520\u20131556)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1556 Nov 15",
        "PLACEOFBIRTH": "Nikolsburg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13046",
        "NAME": "Herberstein, Helena (1540\u20131615)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13047",
        "NAME": "Losenstein, Susanna Felizitas (1622\u20131640)",
        "DATEOFBIRTH": "1622",
        "DATEOFDEATH": "1640",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13048",
        "NAME": "Losenstein, Maria Theresia (1628\u20131703), Obersthofmeisterin",
        "DATEOFBIRTH": "1628 Feb 09",
        "DATEOFDEATH": "1703 Apr 27",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13049",
        "NAME": "Herberstein, Maria Theresia (1641\u20131682)",
        "DATEOFBIRTH": "1641 Jun 05",
        "DATEOFDEATH": "1682",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "13050",
        "NAME": "K\u00f6nigsberg, Ehrenreich (1503\u20131560), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1503",
        "DATEOFDEATH": "1560 Apr 19",
        "PLACEOFBIRTH": "Seebenstein",
        "PLACEOFDEATH": "Seebenstein"
    },
    {
        "ID": "13051",
        "NAME": "Welz, Gebhard (1500\u20131577), Reichshofrat",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1577 Mai 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prutzendorf"
    },
    {
        "ID": "13052",
        "NAME": "Teufel von Guntersdorf, Georg (1518\u20131578), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1578 Dez 04",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Thunau am Kamp:Pfarrkirche"
    },
    {
        "ID": "13053",
        "NAME": "Ungnad von Weissenwolff, David (1538\u20131600), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1600 Dez 22",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Kaschau"
    },
    {
        "ID": "13054",
        "NAME": "Ungnad von Weissenwolff, Andreas (1579\u20131643)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Aurich in Ostfriesland"
    },
    {
        "ID": "13055",
        "NAME": "Lisola, Franz (1613\u20131674), Hofkammerrat",
        "DATEOFBIRTH": "1613 Aug 22",
        "DATEOFDEATH": "1674 Dez 19",
        "PLACEOFBIRTH": "Salins in Burgund",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13056",
        "NAME": "Dietrichstein, Theresia (1632\u20131658)",
        "DATEOFBIRTH": "1632",
        "DATEOFDEATH": "1658 Jan 26",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13057",
        "NAME": "Precipiano de Soye, Prosper Ambros (1625\u20131707)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1707",
        "PLACEOFBIRTH": "Rougemont im Sundgau",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "13058",
        "NAME": "Precipiano de Soye, Humprecht Wilhelm (1627\u20131711), Erzbischof von Mechelen",
        "DATEOFBIRTH": "1627 Sep 12",
        "DATEOFDEATH": "1711 Jun 09",
        "PLACEOFBIRTH": "Rougemont im Sundgau",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "13059",
        "NAME": "Precipiano de Soye, Achilles (1590\u20131642), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1642 Nov 02",
        "PLACEOFBIRTH": "Rougemont im Sundgau",
        "PLACEOFDEATH": "Breitenfeld im Lindenthal"
    },
    {
        "ID": "13060",
        "NAME": "Carafa, Anton (1460\u20131528)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1528 Jun 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Stigliano"
    },
    {
        "ID": "13061",
        "NAME": "Carafa, Julius (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13062",
        "NAME": "Castiglioni, Franz (1580\u20131656), Mundschenk",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "Garlasco",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "13063",
        "NAME": "Castiglioni, Ludwig (1615\u20131648), Truchsess",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1648",
        "PLACEOFBIRTH": "Garlasco",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13064",
        "NAME": "Lodron, Paris (1522\u20131566), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "1566",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13065",
        "NAME": "Lodron, Hieronym (1526\u20131579)",
        "DATEOFBIRTH": "1526",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "Concesio",
        "PLACEOFDEATH": "Concesio"
    },
    {
        "ID": "13066",
        "NAME": "Lodron, Niklas (1549\u20131621), Mundschenk",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1621 Nov 10",
        "PLACEOFBIRTH": "Castelnuovo di Noarna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13067",
        "NAME": "Lodron, Christoph (1588\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1588 Jul 05",
        "DATEOFDEATH": "1659 Nov 30",
        "PLACEOFBIRTH": "Castelnuovo di Noarna",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "13068",
        "NAME": "Lodron, Paris (1586\u20131653), Erzbischof von Salzburg",
        "DATEOFBIRTH": "1586 Nov 28",
        "DATEOFDEATH": "1653 Dez 15",
        "PLACEOFBIRTH": "Castelnuovo di Noarna",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "13069",
        "NAME": "Lodron, Hieronym (1580\u20131658), K\u00e4mmerer",
        "DATEOFBIRTH": "1580",
        "DATEOFDEATH": "1658 Aug 13",
        "PLACEOFBIRTH": "Concesio",
        "PLACEOFDEATH": "Concesio"
    },
    {
        "ID": "13070",
        "NAME": "Lodron, Sebastian (1601\u20131643), Bischof von Gurk",
        "DATEOFBIRTH": "1601 Aug 28",
        "DATEOFDEATH": "1643 Sep 04",
        "PLACEOFBIRTH": "Concesio",
        "PLACEOFDEATH": "Concesio"
    },
    {
        "ID": "13071",
        "NAME": "Lodron, Franz (1614\u20131652), Bischof von Gurk",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "1652 Okt 30",
        "PLACEOFBIRTH": "Concesio",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "13072",
        "NAME": "Lodron, Franz Niklas (1634\u20131695), K\u00e4mmerer",
        "DATEOFBIRTH": "1634",
        "DATEOFDEATH": "1695 Jul 27",
        "PLACEOFBIRTH": "Castelnuovo di Noarna",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "13073",
        "NAME": "Lamboy, Wilhelm (1600\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1659 Dez 12",
        "PLACEOFBIRTH": "Cortesheim",
        "PLACEOFDEATH": "Dimokur"
    },
    {
        "ID": "13074",
        "NAME": "Dietrichstein, Margarita (1637\u20131676)",
        "DATEOFBIRTH": "1637 Apr 18",
        "DATEOFDEATH": "1676 Dez 15",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13075",
        "NAME": "Montecuccoli, Elisabeth (1587\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Montespecchio di Montese",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13076",
        "NAME": "Montecuccoli, Leopold Philipp (1662\u20131698), K\u00e4mmerer",
        "DATEOFBIRTH": "1662 Mai 01",
        "DATEOFDEATH": "1698 Jan 09",
        "PLACEOFBIRTH": "Hohenegg im Dunkelsteinerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13077",
        "NAME": "Precipiano de Soye, Philipp Emanuel (1628\u20131678), K\u00e4mmerer",
        "DATEOFBIRTH": "1628",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "Rougemont im Sundgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13078",
        "NAME": "Strozzi, Peter (1626\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1664 Jun 06",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": "Zr\u00ednyiv\u00e1r an der Mur"
    },
    {
        "ID": "13079",
        "NAME": "Strozzi, Jakob (1590\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13080",
        "NAME": "Carafa, Karl (1611\u20131680), Bischof von Aversa",
        "DATEOFBIRTH": "1611 Apr 21",
        "DATEOFDEATH": "1680 Okt 19",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13081",
        "NAME": "Carafa, Hieronym (1564\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1633 Apr 04",
        "PLACEOFBIRTH": "Cusano Mutri",
        "PLACEOFDEATH": "Genova"
    },
    {
        "ID": "13082",
        "NAME": "Carafa, Ludwig (1637\u20131703), K\u00e4mmerer",
        "DATEOFBIRTH": "1637 Feb 18",
        "DATEOFDEATH": "1703 Okt 08",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": "Castel San Lorenzo"
    },
    {
        "ID": "13083",
        "NAME": "Carafa, Johann Georg (1671\u20131743), K\u00e4mmerer",
        "DATEOFBIRTH": "1671",
        "DATEOFDEATH": "1743 Mai 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "13084",
        "NAME": "Carafa, Maria Elisabeth (1680\u20131733)",
        "DATEOFBIRTH": "1680~",
        "DATEOFDEATH": "1733 Okt 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13085",
        "NAME": "Cardona, Katharina (1652\u20131726), Obersthofmeisterin",
        "DATEOFBIRTH": "1652",
        "DATEOFDEATH": "1726 Nov 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13086",
        "NAME": "Carafa, Karl Otto (1700\u20131779), Hofkammerrat",
        "DATEOFBIRTH": "1700~",
        "DATEOFDEATH": "1779 Nov 22",
        "PLACEOFBIRTH": "Stigliano",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13087",
        "NAME": "Carafa, Vinzenz (1543\u20131604), Gro\u00dfprior des Malteserordens in Ungarn",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1604 Mai 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13088",
        "NAME": "Carafa, Ferdinand Karl (1658\u20131732), Hofkammerrat",
        "DATEOFBIRTH": "1658 Apr 18",
        "DATEOFDEATH": "1732 Apr 15",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13089",
        "NAME": "Carafa, Karl (1593\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1593 Mar 12",
        "DATEOFDEATH": "1659 Apr 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "13090",
        "NAME": "K\u00f6nig genannt von Mohr, Franz Peter (1594\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1594 Aug 06",
        "DATEOFDEATH": "1647 Dez 11",
        "PLACEOFBIRTH": "Freiburg im Uechtland",
        "PLACEOFDEATH": "Freiburg im Uechtland"
    },
    {
        "ID": "13091",
        "NAME": "Montecuccoli, Marius (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Modena",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13092",
        "NAME": "Montecuccoli, Furinian (1468\u20131516)",
        "DATEOFBIRTH": "1468",
        "DATEOFDEATH": "1516",
        "PLACEOFBIRTH": "Pavullo nel Frignano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13093",
        "NAME": "Montecuccoli, Galeas (1508\u20131567)",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "Pavullo nel Frignano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13094",
        "NAME": "Montecuccoli, Fabriz (1548\u20131586)",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "Pavullo nel Frignano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13095",
        "NAME": "Montecuccoli, Galeas (1570\u20131619)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1619 Mai 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Brescello"
    },
    {
        "ID": "13096",
        "NAME": "Montecuccoli, Balthasar (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pavullo nel Frignano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13097",
        "NAME": "Montecuccoli, Alfons (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Montespecchio di Montese",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13098",
        "NAME": "Stauding, Georg Friedrich (1590\u20131644), Hofkammerrat",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1644 Sep 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13099",
        "NAME": "Losenstein, Johann Bernhard (1550\u20131589), Mundschenk",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1589 Dez 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "13100",
        "NAME": "Luxemburg, Karl\u00a0IV. (1316\u20131378), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1316 Mai 14",
        "DATEOFDEATH": "1378 Nov 29",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13101",
        "NAME": "Wendt, Johann Karl (1615\u20131656), Truchsess",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1656 Nov 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13102",
        "NAME": "Wendt, Wilhelm Theoderich (1600\u20131666)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1666 Jun 13",
        "PLACEOFBIRTH": "Crassenstein im M\u00fcnsterland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13103",
        "NAME": "Wendt, Johann Adam (1660\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13104",
        "NAME": "Wendt, Franz (1560\u20131606)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "Crassenstein im M\u00fcnsterland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13105",
        "NAME": "Wendt, Johann Baptist (1665\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1665~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13106",
        "NAME": "Galler von Schwanberg, Wilhelm (1535\u20131595)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1595",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Schwanberg in der Steiermark"
    },
    {
        "ID": "13107",
        "NAME": "Galler von Schwanberg, Bernhard (1620\u20131650), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13108",
        "NAME": "Galler von Schwanberg, Johann (1565\u20131616), Hofkammerrat",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1616 Apr 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13109",
        "NAME": "Galler von Schwanberg, Georg (1571\u20131636), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1571 Dez 03",
        "DATEOFDEATH": "1636 Dez 01",
        "PLACEOFBIRTH": "Schwanberg in der Steiermark",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13110",
        "NAME": "Galler von Schwanberg, Johann Wilhelm (1599\u20131650), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1650 Aug 07",
        "PLACEOFBIRTH": "Schwanberg in der Steiermark",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13111",
        "NAME": "Galler von Schwanberg, Siegmund (1505\u20131564)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1564",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13112",
        "NAME": "Galler von Schwanberg, Benigna (1540\u20131623)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1623 Nov 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13113",
        "NAME": "Galler von Schwanberg, Johann Christoph (1591\u20131633)",
        "DATEOFBIRTH": "1591 Jan 24",
        "DATEOFDEATH": "1633 Mai 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "13114",
        "NAME": "Galler von Schwanberg, Georg (1475\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13115",
        "NAME": "Galler von Schwanberg, Peter (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13116",
        "NAME": "Galler von Schwanberg, Christoph (1550\u20131608)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Preding:Pfarrkirche"
    },
    {
        "ID": "13117",
        "NAME": "Galler von Schwanberg, Johann Christian (1620\u20131669), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1669 Nov 17",
        "PLACEOFBIRTH": "Schwanberg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13118",
        "NAME": "Wechsler, Elisabeth (1608\u20131672)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1672 Feb 12",
        "PLACEOFBIRTH": "Radkersburg",
        "PLACEOFDEATH": "Riegersburg in der Steiermark:Martinskirche"
    },
    {
        "ID": "13119",
        "NAME": "Wolkenstein, Friedrich (1345\u20131400)",
        "DATEOFBIRTH": "1345~",
        "DATEOFDEATH": "1400",
        "PLACEOFBIRTH": "Wolkenstein in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13120",
        "NAME": "Wolkenstein, Oswald (1377\u20131445)",
        "DATEOFBIRTH": "1377 Mai 02",
        "DATEOFDEATH": "1445 Aug 02",
        "PLACEOFBIRTH": "Sch\u00f6neck im Pustertal",
        "PLACEOFDEATH": "Hauenstein in Tirol"
    },
    {
        "ID": "13121",
        "NAME": "Saint Hilaire, Giselbrecht (1559\u20131621), K\u00e4mmerer",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13122",
        "NAME": "Saint Hilaire, Karl (1590\u20131647), Hofkriegsrat",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1647 Nov 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13123",
        "NAME": "Saint Hilaire, Giselbrecht (1625\u20131671), Hofkammerrat",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1671 Okt 31",
        "PLACEOFBIRTH": "Gutenbrunn an der Traisen",
        "PLACEOFDEATH": "Kreuzenstein"
    },
    {
        "ID": "13124",
        "NAME": "Mollard, Johann Baptist (1563\u20131619), Hofkriegsratspr\u00e4sident",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "1619 Jul 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13125",
        "NAME": "Richthausen von Chaos, Johann Konrad (1599\u20131663), Hofkammerrat",
        "DATEOFBIRTH": "1599 Nov 27",
        "DATEOFDEATH": "1663 Jul 25",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Schemnitz"
    },
    {
        "ID": "13126",
        "NAME": "Wolkenstein, Adam (1583\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1583 Jun 03",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Hall in Tirol"
    },
    {
        "ID": "13127",
        "NAME": "Wolkenstein, Melchior Hannibal (1537\u20131596)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "13128",
        "NAME": "Bodman, Johann Siegmund (1646\u20131728), Reichshofratspr\u00e4sident",
        "DATEOFBIRTH": "1646 Mar 13",
        "DATEOFDEATH": "1728 Nov 10",
        "PLACEOFBIRTH": "Stei\u00dflingen im Hegau",
        "PLACEOFDEATH": "Kempten im Allg\u00e4u"
    },
    {
        "ID": "13129",
        "NAME": "Wirsberg, Wolfgang Ernst (1530\u20131585), Reichshofrat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1585",
        "PLACEOFBIRTH": "Waldthurn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13130",
        "NAME": "Berg, Wilhelm (1516\u20131592), Herzog von J\u00fclich",
        "DATEOFBIRTH": "1516 Jul 28",
        "DATEOFDEATH": "1592 Jan 05",
        "PLACEOFBIRTH": "D\u00fcsseldorf",
        "PLACEOFDEATH": "D\u00fcsseldorf"
    },
    {
        "ID": "13131",
        "NAME": "Berg, Karl Friedrich (1555\u20131575)",
        "DATEOFBIRTH": "1555 Apr 28",
        "DATEOFDEATH": "1575 Feb 09",
        "PLACEOFBIRTH": "Kleve am Niederrhein",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13132",
        "NAME": "Paradeiser von Neuhaus, Christoph (1560\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neuhaus in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13133",
        "NAME": "Paradeiser von Neuhaus, Heinrich (1590\u2013\u00a0\u00a0\u00a0\u00a0), Hofkriegsrat",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neuhaus in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13134",
        "NAME": "Paradeiser von Neuhaus, Georg Siegmund (1600\u20131648), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1648",
        "PLACEOFBIRTH": "Neuhaus in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13135",
        "NAME": "Wolkenstein, Mark Sittich (1563\u20131619)",
        "DATEOFBIRTH": "1563 Mai 05",
        "DATEOFDEATH": "1619 Okt 31",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": "Rafenstein im Sarntal"
    },
    {
        "ID": "13136",
        "NAME": "Wolkenstein, Christoph Franz (1567\u20131633)",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1633",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13137",
        "NAME": "Wolkenstein, Paul Andreas (1593\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13138",
        "NAME": "Wolkenstein, Oswald (1420\u20131495)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1495 Apr 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13139",
        "NAME": "Wolkenstein, Veit (1455\u20131498), Statthalter von Vorder\u00f6sterreich",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1498",
        "PLACEOFBIRTH": "Rodenegg",
        "PLACEOFDEATH": "Freiburg im Breisgau"
    },
    {
        "ID": "13140",
        "NAME": "Wolkenstein, Michael (1460\u20131518), K\u00e4mmerer",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1518 Apr 15",
        "PLACEOFBIRTH": "Rodenegg",
        "PLACEOFDEATH": "Bruck an der Isel"
    },
    {
        "ID": "13141",
        "NAME": "Wolkenstein, Veit (1506\u20131538)",
        "DATEOFBIRTH": "1506 Nov 12",
        "DATEOFDEATH": "1538 Jul 19",
        "PLACEOFBIRTH": "Bruck an der Isel",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "13142",
        "NAME": "Wolkenstein, Christoph (1530\u20131600)",
        "DATEOFBIRTH": "1530 Nov 08",
        "DATEOFDEATH": "1600 Mai 26",
        "PLACEOFBIRTH": "Rodenegg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13143",
        "NAME": "Wolkenstein, Karl (1557\u20131618)",
        "DATEOFBIRTH": "1557 Jun 28",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "Rodenegg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13144",
        "NAME": "Wolkenstein, Christoph (1560\u20131616)",
        "DATEOFBIRTH": "1560 Okt 12",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Rodenegg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13145",
        "NAME": "Wolkenstein, Siegmund (1554\u20131624)",
        "DATEOFBIRTH": "1554 Okt 22",
        "DATEOFDEATH": "1624 Mar 18",
        "PLACEOFBIRTH": "Rodenegg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13146",
        "NAME": "Wolkenstein, Fortunat (1583\u20131660), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1660",
        "PLACEOFBIRTH": "Rodenegg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13147",
        "NAME": "Wolkenstein, Ulrich (1592\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Rodenegg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13148",
        "NAME": "Wolkenstein, Johann Christoph (1581\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1581 Dez 30",
        "DATEOFDEATH": "1639 Jul 03",
        "PLACEOFBIRTH": "Bruck an der Isel",
        "PLACEOFDEATH": "Bozen"
    },
    {
        "ID": "13149",
        "NAME": "Wolkenstein, Johann Siegmund (1580\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rodenegg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13150",
        "NAME": "Wolkenstein, Mark Oswald (1592\u20131628), K\u00e4mmerer",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13151",
        "NAME": "Rogendorf, Wilhelm (1481\u20131541), Obersthofmeister",
        "DATEOFBIRTH": "1481 Nov 20",
        "DATEOFDEATH": "1541 Aug 22",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": "Sommerein auf der Sch\u00fctt"
    },
    {
        "ID": "13152",
        "NAME": "V\u00f6ls, Leonhard (1497\u20131545), Obersthofmeister",
        "DATEOFBIRTH": "1497",
        "DATEOFDEATH": "1545 Nov 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13153",
        "NAME": "Welz, Siegmund (1450\u20131522)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1522 Nov 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13154",
        "NAME": "Welz, Erasam (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Prutzendorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13155",
        "NAME": "Welz, Gebhard Wilhelm (1573\u20131626), Reichshofrat",
        "DATEOFBIRTH": "1573",
        "DATEOFDEATH": "1626 Dez 26",
        "PLACEOFBIRTH": "Prutzendorf",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13156",
        "NAME": "Mollard, Ferdinand Ernst (1648\u20131716), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1648",
        "DATEOFDEATH": "1716 Aug 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13157",
        "NAME": "Mollard, Peter (1556\u20131604), Geheimer Rat",
        "DATEOFBIRTH": "1556",
        "DATEOFDEATH": "1604 Feb 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13158",
        "NAME": "Mollard, Maria (1555\u20131579)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13159",
        "NAME": "Mollard, Margarita (1560\u20131632)",
        "DATEOFBIRTH": "1560",
        "DATEOFDEATH": "1632 Nov 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13160",
        "NAME": "Preysing, Johann Peter (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13161",
        "NAME": "Preysing, Anna Maria (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13162",
        "NAME": "Preysing, Elisabeth (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13163",
        "NAME": "Wolkenstein, Michael (1390\u20131446), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1446",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13164",
        "NAME": "Wolkenstein, Berthold (1430\u20131491)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1491",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13165",
        "NAME": "Wolkenstein, Wilhelm (1470\u20131522)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1522",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13166",
        "NAME": "Wolkenstein, Wilhelm (1509\u20131577), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1509",
        "DATEOFDEATH": "1577 Mar 13",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": "Trostburg am Eisack"
    },
    {
        "ID": "13167",
        "NAME": "Wolkenstein, Wilhelm (1554\u20131636)",
        "DATEOFBIRTH": "1554",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13168",
        "NAME": "Wolkenstein, Berthold (1584\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1584 Apr 19",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13169",
        "NAME": "Wolkenstein, Berthold (1629\u20131675)",
        "DATEOFBIRTH": "1629 Sep 23",
        "DATEOFDEATH": "1675 Dez 13",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Meran"
    },
    {
        "ID": "13170",
        "NAME": "Wolkenstein, Johann Dominik (1620\u20131675), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1675 Mar 25",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "13171",
        "NAME": "Wolkenstein, Engelhard Theoderich (1566\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "1647 Dez 18",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13172",
        "NAME": "Wolkenstein, Maximilian Karl (1609\u20131677)",
        "DATEOFBIRTH": "1609",
        "DATEOFDEATH": "1677",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13173",
        "NAME": "Henel von Hennenfeld, Niklas (1582\u20131656)",
        "DATEOFBIRTH": "1582 Jan 11",
        "DATEOFDEATH": "1656 Jul 23",
        "PLACEOFBIRTH": "Neustadt in Oberschlesien",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "13174",
        "NAME": "Kratz von Scharfenstein, Johann Philipp (1591\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1635 Jul 06",
        "PLACEOFBIRTH": "Engers am Rhein",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13175",
        "NAME": "Kratz von Scharfenstein, Anton (1560\u20131619)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1619 Jun 24",
        "PLACEOFBIRTH": "Scharfenstein im Rheingau",
        "PLACEOFDEATH": "Engers am Rhein"
    },
    {
        "ID": "13176",
        "NAME": "Kratz von Scharfenstein, Haug Eberhard (1594\u20131663), Bischof von Worms",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1663 Mar 13",
        "PLACEOFBIRTH": "Engers am Rhein",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "13177",
        "NAME": "Arco, Franz (1409\u20131482)",
        "DATEOFBIRTH": "1409",
        "DATEOFDEATH": "1482",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13178",
        "NAME": "Arco, Ulrich (1445\u20131528), Geheimer Rat",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1528 Dez 13",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13179",
        "NAME": "Arco, Niklas (1492\u20131546), K\u00e4mmerer",
        "DATEOFBIRTH": "1492",
        "DATEOFDEATH": "1546 Dez 03",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": "Cavriana"
    },
    {
        "ID": "13180",
        "NAME": "Arco, Maximilian (1530\u20131582)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1582",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13181",
        "NAME": "Arco, Pyrrhus (1570\u20131634)",
        "DATEOFBIRTH": "1570",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13182",
        "NAME": "Arco, Paul (1485\u20131551)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1551",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13183",
        "NAME": "Arco, Karl (1520\u20131554)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1554",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13184",
        "NAME": "Arco, Andreas (1434\u20131507)",
        "DATEOFBIRTH": "1434",
        "DATEOFDEATH": "1507 Apr 21",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": "Arco in Tirol"
    },
    {
        "ID": "13185",
        "NAME": "Arco, Anton (1470\u20131527)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1527",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13186",
        "NAME": "Arco, Siegmund (1500\u20131568)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1568",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13187",
        "NAME": "Arco, Gerhard (1540\u20131579)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Arco in Tirol"
    },
    {
        "ID": "13188",
        "NAME": "Arco, Siegmund (1570\u20131620), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1620",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13189",
        "NAME": "Arco, Franz Leopold (1619\u20131704)",
        "DATEOFBIRTH": "1619 Apr 23",
        "DATEOFDEATH": "1704 Nov 06",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13191",
        "NAME": "Schrattenbach, Pankraz (1510\u20131559)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1559 Dez 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13192",
        "NAME": "Schrattenbach, Maximilian (1537\u20131611), Obersthofmeister",
        "DATEOFBIRTH": "1537 Aug 01",
        "DATEOFDEATH": "1611 Jul 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz:Jesuitenkirche"
    },
    {
        "ID": "13193",
        "NAME": "Schrattenbach, Balthasar (1547\u20131618), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1547 Aug 25",
        "DATEOFDEATH": "1618 Apr 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13194",
        "NAME": "Schrattenbach, Johann Siegmund (1570\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13195",
        "NAME": "Schrattenbach, Felix (1570\u20131624), Hofkriegsrat",
        "DATEOFBIRTH": "1570",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13196",
        "NAME": "Schrattenbach, Karl (1572\u20131612), K\u00e4mmerer",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1612 Feb 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13197",
        "NAME": "Schrattenbach, Gottfried (1575\u20131641), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1641 Jun 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Friesach in K\u00e4rnten"
    },
    {
        "ID": "13198",
        "NAME": "Schrattenbach, Johann Friedrich (1605\u20131657), K\u00e4mmerer",
        "DATEOFBIRTH": "1605 Nov 09",
        "DATEOFDEATH": "1657 Jan 11",
        "PLACEOFBIRTH": "Heggenberg in Krain",
        "PLACEOFDEATH": "Egg in der Krain"
    },
    {
        "ID": "13199",
        "NAME": "Schrattenbach, Helena (1587\u20131623)",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13200",
        "NAME": "Habsburg, Albrecht\u00a0I. (1255\u20131308), K\u00f6nig des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1255 Jul 16",
        "DATEOFDEATH": "1308 Mai 01",
        "PLACEOFBIRTH": "Rheinfelden im Aargau",
        "PLACEOFDEATH": "K\u00f6nigsfelden im Aargau"
    },
    {
        "ID": "13201",
        "NAME": "Salamanca, Ferdinand (1525\u20131570)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1570",
        "PLACEOFBIRTH": "Ortenburg in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13202",
        "NAME": "Salamanca, Johann Baptist (1556\u20131601), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1556",
        "DATEOFDEATH": "1601 Sep 01",
        "PLACEOFBIRTH": "Ortenburg in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13204",
        "NAME": "\u00c1lvarez de Toledo, Peter (1484\u20131553)",
        "DATEOFBIRTH": "1484 Jul 13",
        "DATEOFDEATH": "1553 Feb 21",
        "PLACEOFBIRTH": "Alba de Tormes",
        "PLACEOFDEATH": "Florenz"
    },
    {
        "ID": "13205",
        "NAME": "\u00c1lvarez de Toledo, Bernhard (1514\u20131577)",
        "DATEOFBIRTH": "1514 Aug 29",
        "DATEOFDEATH": "1577 Mai 31",
        "PLACEOFBIRTH": "Villafranca del Bierzo",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "13206",
        "NAME": "Cardenas, Alfons (1520\u20131564)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1564 Dez 06",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13207",
        "NAME": "Cardenas, Karl (1560\u20131635)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1635~",
        "PLACEOFBIRTH": "Laino Bruzio",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13208",
        "NAME": "Cardenas, Alfons (1590\u20131664)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1664 Apr 12",
        "PLACEOFBIRTH": "Laino Bruzio",
        "PLACEOFDEATH": "Acerra"
    },
    {
        "ID": "13209",
        "NAME": "Cardenas, Ferdinand (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Laino Bruzio",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13210",
        "NAME": "Stubenberg, Wolfgang (1495\u20131566)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1566",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13211",
        "NAME": "Stubenberg, Wolfgang (1525\u20131597), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1597 Dez 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13212",
        "NAME": "Stubenberg, Georg (1560\u20131630), K\u00e4mmerer",
        "DATEOFBIRTH": "1560 Okt 25",
        "DATEOFDEATH": "1630 Apr 21",
        "PLACEOFBIRTH": "Kapfenberg",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "13213",
        "NAME": "Stubenberg, Johann (1530\u20131572)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1572",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13214",
        "NAME": "Stubenberg, Georg Hartmann (1565\u20131608)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13215",
        "NAME": "Stubenberg, Georg (1598\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1598 Jun 18",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13216",
        "NAME": "Stubenberg, Georg (1632\u20131703), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1632 Feb 20",
        "DATEOFDEATH": "1703 Feb 19",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13217",
        "NAME": "Stubenberg, Otto (1637\u20131675), K\u00e4mmerer",
        "DATEOFBIRTH": "1637 Jun 09",
        "DATEOFDEATH": "1675",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13218",
        "NAME": "Stubenberg, Franz (1645\u20131713), Landeshauptmann von G\u00f6rz",
        "DATEOFBIRTH": "1645 Jun 23",
        "DATEOFDEATH": "1713 Aug 26",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13219",
        "NAME": "Stubenberg, Leopold (1673\u20131708)",
        "DATEOFBIRTH": "1673 Apr 11",
        "DATEOFDEATH": "1708 Jul 09",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13220",
        "NAME": "Z\u00e4hringen, Christoph (1453\u20131527)",
        "DATEOFBIRTH": "1453 Nov 13",
        "DATEOFDEATH": "1527 Mar 19",
        "PLACEOFBIRTH": "Baden in Baden",
        "PLACEOFDEATH": "Baden in Baden"
    },
    {
        "ID": "13221",
        "NAME": "Z\u00e4hringen, Bernhard (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13222",
        "NAME": "Z\u00e4hringen, Williprecht (1536\u20131569), Markgraf von Baden",
        "DATEOFBIRTH": "1536 Jan 22",
        "DATEOFDEATH": "1569 Okt 03",
        "PLACEOFBIRTH": "Baden in Baden",
        "PLACEOFDEATH": "Moncontour im Poitou"
    },
    {
        "ID": "13223",
        "NAME": "Z\u00e4hringen, Christoph (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13224",
        "NAME": "Z\u00e4hringen, Edward Fortunat (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13225",
        "NAME": "Z\u00e4hringen, Ernst (1482\u20131553)",
        "DATEOFBIRTH": "1482 Okt 07",
        "DATEOFDEATH": "1553 Feb 06",
        "PLACEOFBIRTH": "Pforzheim",
        "PLACEOFDEATH": "Sulzburg im Breisgau"
    },
    {
        "ID": "13226",
        "NAME": "Z\u00e4hringen, Karl (1529\u20131577)",
        "DATEOFBIRTH": "1529 Jul 24",
        "DATEOFDEATH": "1577 Mar 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13227",
        "NAME": "Z\u00e4hringen, Jakob (1562\u20131590), Landesherr von Hachberg",
        "DATEOFBIRTH": "1562 Mai 26",
        "DATEOFDEATH": "1590 Aug 17",
        "PLACEOFBIRTH": "Pforzheim",
        "PLACEOFDEATH": "Emmendingen"
    },
    {
        "ID": "13228",
        "NAME": "Ibarra, Christoph (1550\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1634 Aug 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13229",
        "NAME": "Hoyos, Adam (1587\u20131640), K\u00e4mmerer",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1640 Okt 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "13230",
        "NAME": "Z\u00e4hringen, Wilhelm (1593\u20131677), Markgraf von Baden",
        "DATEOFBIRTH": "1593 Jul 30",
        "DATEOFDEATH": "1677 Mai 22",
        "PLACEOFBIRTH": "Baden in Baden",
        "PLACEOFDEATH": "Baden in Baden"
    },
    {
        "ID": "13231",
        "NAME": "Z\u00e4hringen, Hermann (1628\u20131691), Prinzipalkommissar",
        "DATEOFBIRTH": "1628 Okt 12",
        "DATEOFDEATH": "1691 Okt 02",
        "PLACEOFBIRTH": "Baden in Baden",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "13232",
        "NAME": "Z\u00e4hringen, Ferdinand Maximilian (1625\u20131669)",
        "DATEOFBIRTH": "1625 Sep 23",
        "DATEOFDEATH": "1669 Nov 04",
        "PLACEOFBIRTH": "Baden in Baden",
        "PLACEOFDEATH": "Heidelberg"
    },
    {
        "ID": "13233",
        "NAME": "Z\u00e4hringen, Ludwig Wilhelm (1655\u20131707), Markgraf von Baden",
        "DATEOFBIRTH": "1655 Apr 08",
        "DATEOFDEATH": "1707 Jan 04",
        "PLACEOFBIRTH": "Paris",
        "PLACEOFDEATH": "Rastatt"
    },
    {
        "ID": "13234",
        "NAME": "Savoyen, Thomas (1595\u20131656)",
        "DATEOFBIRTH": "1595 Dez 21",
        "DATEOFDEATH": "1656 Jan 22",
        "PLACEOFBIRTH": "Torino",
        "PLACEOFDEATH": "Torino"
    },
    {
        "ID": "13235",
        "NAME": "Savoyen, Moritz (1635\u20131673)",
        "DATEOFBIRTH": "1635 Mai 03",
        "DATEOFDEATH": "1673 Jun 06",
        "PLACEOFBIRTH": "Chamb\u00e9ry",
        "PLACEOFDEATH": "Unna in Westfalen"
    },
    {
        "ID": "13236",
        "NAME": "Savoyen, Ludwika Christina (1627\u20131689)",
        "DATEOFBIRTH": "1627 Aug 01",
        "DATEOFDEATH": "1689 Jul 08",
        "PLACEOFBIRTH": "Paris",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "13237",
        "NAME": "Savoyen, Karl Emanuel (1562\u20131630), Herzog von Savoyen",
        "DATEOFBIRTH": "1562 Jan 12",
        "DATEOFDEATH": "1630 Jul 26",
        "PLACEOFBIRTH": "Rivoli",
        "PLACEOFDEATH": "Savigliano"
    },
    {
        "ID": "13238",
        "NAME": "Savoyen, Viktor Gottlieb (1587\u20131637), Herzog von Savoyen",
        "DATEOFBIRTH": "1587 Mai 08",
        "DATEOFDEATH": "1637 Okt 07",
        "PLACEOFBIRTH": "Torino",
        "PLACEOFDEATH": "Vercelli:Dom"
    },
    {
        "ID": "13239",
        "NAME": "Savoyen, Adelheid (1636\u20131676)",
        "DATEOFBIRTH": "1636 Nov 06",
        "DATEOFDEATH": "1676 Mar 18",
        "PLACEOFBIRTH": "Torino",
        "PLACEOFDEATH": "M\u00fcnchen:Theatinerkirche"
    },
    {
        "ID": "13240",
        "NAME": "Gersdorff, Philipp (1560\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13241",
        "NAME": "Gersdorff, Johann (1510\u20131573)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1573",
        "PLACEOFBIRTH": "Seichau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13242",
        "NAME": "Gersdorff, Siegmund (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13243",
        "NAME": "Gersdorff, Christoph (1585\u20131623)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "Schwarzau in Niederschlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13244",
        "NAME": "Gersdorff, Rudolf (1590\u20131629)",
        "DATEOFBIRTH": "1590",
        "DATEOFDEATH": "1629 Okt 21",
        "PLACEOFBIRTH": "Schwarzau in Niederschlesien",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "13245",
        "NAME": "Gersdorff, Maximilian (1604\u20131664)",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1664 Sep 19",
        "PLACEOFBIRTH": "Schwarzau in Niederschlesien",
        "PLACEOFDEATH": "Glogau in Niederschlesien"
    },
    {
        "ID": "13246",
        "NAME": "Gersdorff, Adam (1547\u20131615)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13247",
        "NAME": "P\u00f6tting, Urban (1567\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1648 Jun 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "13249",
        "NAME": "P\u00f6tting, Georg (1578\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13250",
        "NAME": "P\u00f6tting, Sebastian (1628\u20131689), Bischof von Passau",
        "DATEOFBIRTH": "1628",
        "DATEOFDEATH": "1689 Mar 16",
        "PLACEOFBIRTH": "Raipoltenbach",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "13251",
        "NAME": "P\u00f6tting, Sebastian (1542\u20131592)",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1592 Jan 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13252",
        "NAME": "P\u00f6tting, Friedrich (1577\u20131642)",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1642 Nov 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13253",
        "NAME": "P\u00f6tting, Franz Euseb (1627\u20131678), Geheimer Rat",
        "DATEOFBIRTH": "1627 Dez 10",
        "DATEOFDEATH": "1678 Dez 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13254",
        "NAME": "P\u00f6tting, Ortlieb (1575\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1654 Jul 17",
        "PLACEOFBIRTH": "Raipoltenbach",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "13255",
        "NAME": "P\u00f6tting, Johann Sebastian (1626\u20131697), K\u00e4mmerer",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1697 Aug 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rabenstein an der Schnella"
    },
    {
        "ID": "13256",
        "NAME": "P\u00f6tting, Wolfgang Sebastian (1629\u20131709), Gro\u00dfprior des Malteserordens in B\u00f6hmen",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1709",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13257",
        "NAME": "Schaffgotsch, Christoph Leopold (1623\u20131703), Landeshauptmann von Schweidnitz und Jauer",
        "DATEOFBIRTH": "1623 Apr 08",
        "DATEOFDEATH": "1703 Jun 30",
        "PLACEOFBIRTH": "Trachenberg in Schlesien",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "13258",
        "NAME": "Myslik von Hirschau, Siegmund (1606\u20131666), Hofkriegsrat",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1666 Nov 03",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13259",
        "NAME": "Althan, Christoph (1529\u20131589), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1589 Dez 10",
        "PLACEOFBIRTH": "Heitzing im Haspelwald",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13260",
        "NAME": "Althan, Quintin (1577\u20131634)",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "Murstetten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13261",
        "NAME": "Althan, Anna Maximiliana (1600\u20131665)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13262",
        "NAME": "Althan, Wolfgang (1487\u20131550)",
        "DATEOFBIRTH": "1487",
        "DATEOFDEATH": "1550~",
        "PLACEOFBIRTH": "Altheim an der Egau",
        "PLACEOFDEATH": "Heitzing im Haspelwald"
    },
    {
        "ID": "13263",
        "NAME": "Stotzingen, Ruprecht (1542\u20131600), Statthalter von Nieder\u00f6sterreich",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1600 Mai 24",
        "PLACEOFBIRTH": "Altenberg in Nordschwaben",
        "PLACEOFDEATH": "Wimpassing an der Leitha"
    },
    {
        "ID": "13264",
        "NAME": "Teufel von Guntersdorf, Elisabeth (1548\u20131636)",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1636 Sep 27",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Murstetten"
    },
    {
        "ID": "13265",
        "NAME": "Teufel von Guntersdorf, Michael (1557\u20131590), K\u00e4mmerer",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1590 Sep 17",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Thunau am Kamp:Pfarrkirche"
    },
    {
        "ID": "13266",
        "NAME": "Teufel von Guntersdorf, Georg (1582\u20131642), Statthalter von Nieder\u00f6sterreich",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1642 Feb 20",
        "PLACEOFBIRTH": "Eckartsau im Marchfeld",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "13267",
        "NAME": "Teufel von Guntersdorf, Otto (1589\u20131673), Oberstfalkenmeister",
        "DATEOFBIRTH": "1589 Jan 10",
        "DATEOFDEATH": "1673 Sep 20",
        "PLACEOFBIRTH": "Eckartsau im Marchfeld",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13268",
        "NAME": "Teufel von Guntersdorf, Wolfgang Matthias (1595\u20131634)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "Guntersdorf im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13269",
        "NAME": "Teufel von Guntersdorf, Andreas (1522\u20131592), Oberststallmeister",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "1592 Jul 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Guntersdorf im Weinviertel"
    },
    {
        "ID": "13270",
        "NAME": "Helfenstein, Anna (1490\u20131527)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1527 Dez 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Amberg in Feldkirch"
    },
    {
        "ID": "13271",
        "NAME": "Habsburg, Dorothea (1516\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1516",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Amberg in Feldkirch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13272",
        "NAME": "Hausner von Stepperg, Margarita (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Stepperg an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13273",
        "NAME": "Askanien, Maria Benigna (1635\u20131701)",
        "DATEOFBIRTH": "1635 Jul 10",
        "DATEOFDEATH": "1701 Dez 01",
        "PLACEOFBIRTH": "Regensburg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13274",
        "NAME": "Askanien, Hedwig Maria (1597\u20131644)",
        "DATEOFBIRTH": "1597 Aug 07",
        "DATEOFDEATH": "1644 Aug 29",
        "PLACEOFBIRTH": "Lauenburg an der Elbe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13275",
        "NAME": "Askanien, Sibylla Augusta (1675\u20131733), Markgr\u00e4fin von Baden",
        "DATEOFBIRTH": "1675 Jan 21",
        "DATEOFDEATH": "1733 Jul 10",
        "PLACEOFBIRTH": "Ratzeburg",
        "PLACEOFDEATH": "Ettlingen im Schwarzwald"
    },
    {
        "ID": "13276",
        "NAME": "Herberstein, Katharina (1570\u20131620)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1620 Dez 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kindberg im M\u00fcrztal"
    },
    {
        "ID": "13277",
        "NAME": "Herberstein, Elisabeth (1415\u20131460)",
        "DATEOFBIRTH": "1415~",
        "DATEOFDEATH": "1460~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13278",
        "NAME": "F\u00fcrstenberg, Konstantia (1577\u20131620)",
        "DATEOFBIRTH": "1577 Apr 02",
        "DATEOFDEATH": "1620",
        "PLACEOFBIRTH": "Heiligenberg im Linzgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13279",
        "NAME": "F\u00fcrstenberg, Eleonora (1578\u20131651)",
        "DATEOFBIRTH": "1578 Mai 13",
        "DATEOFDEATH": "1651 Apr 12",
        "PLACEOFBIRTH": "Heiligenberg im Linzgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13280",
        "NAME": "Sternberg, Eleonora (1656\u20131706)",
        "DATEOFBIRTH": "1656",
        "DATEOFDEATH": "1706 Dez 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13281",
        "NAME": "Arco, Olivia (1550\u20131607)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13282",
        "NAME": "Harant von Polschitz, Magdalena (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13283",
        "NAME": "Sternberg, Katharina (1595\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13284",
        "NAME": "Marschall von Pappenheim, Susanna (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13285",
        "NAME": "Gallas, Maria Viktoria (1639\u20131687)",
        "DATEOFBIRTH": "1639",
        "DATEOFDEATH": "1687 Apr 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13286",
        "NAME": "Zinzendorf, Maximiliana (1610\u20131642)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1642 Nov 25",
        "PLACEOFBIRTH": "Karlsbach im M\u00fchlkreis",
        "PLACEOFDEATH": "Wocking"
    },
    {
        "ID": "13287",
        "NAME": "Dersffy von Zerdahely, Ursula (1583\u20131619)",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1619 Mar 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sohl an der Gran"
    },
    {
        "ID": "13288",
        "NAME": "Dersffy von Zerdahely, Maria (1599\u20131641)",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1641",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13289",
        "NAME": "Przichowitz, Ludmila (1579\u20131632)",
        "DATEOFBIRTH": "1579 Okt 16",
        "DATEOFDEATH": "1632 Apr 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hof an der Regnitz"
    },
    {
        "ID": "13290",
        "NAME": "Rohrbach, Anna Maria (1580\u20131629), Obersthofmeisterin",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13291",
        "NAME": "Formentini, Karl (1583\u20131623), K\u00e4mmerer",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13292",
        "NAME": "Formentini, Elisabeth (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Tolmein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13293",
        "NAME": "Formentini, Aurora (1609\u20131653)",
        "DATEOFBIRTH": "1609 Okt 26",
        "DATEOFDEATH": "1653 Apr 05",
        "PLACEOFBIRTH": "Tolmein",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13294",
        "NAME": "Zehentner von Zehentgrub, Katharina (1616\u20131694)",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1694 Nov 20",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13295",
        "NAME": "Porcia, Julia (1585\u20131650), Obersthofmeisterin",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1650~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13296",
        "NAME": "Leuchtenberg, Wilhelm (1586\u20131634), Mundschenk",
        "DATEOFBIRTH": "1586 Jan 03",
        "DATEOFDEATH": "1634 Mar 20",
        "PLACEOFBIRTH": "Pfreimd",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "13297",
        "NAME": "Formentini, Franz (1537\u20131595), K\u00e4mmerer",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1595",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": "Gradisch an der Isnitz"
    },
    {
        "ID": "13298",
        "NAME": "Formentini, Ludwig (1604\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "Tolmein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13299",
        "NAME": "Gail, Andreas (1526\u20131587), Reichshofrat",
        "DATEOFBIRTH": "1526 Nov 12",
        "DATEOFDEATH": "1587 Dez 11",
        "PLACEOFBIRTH": "K\u00f6ln am Rhein",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "13300",
        "NAME": "Habsburg, Eleonora (1498\u20131558), K\u00f6nigin von Frankreich",
        "DATEOFBIRTH": "1498 Nov 15",
        "DATEOFDEATH": "1558 Feb 18",
        "PLACEOFBIRTH": "L\u00f6wen in Brabant",
        "PLACEOFDEATH": "Talavera de la Reina"
    },
    {
        "ID": "13301",
        "NAME": "Wittelsbach, Georg (1510\u20131596), Freiherr von Hegnenberg",
        "DATEOFBIRTH": "1510",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "Stepperg an der Donau",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "13302",
        "NAME": "Malaspina, Johann Christoph (1590\u20131643), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1643 Nov 15",
        "PLACEOFBIRTH": "Mulazzo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13303",
        "NAME": "Malaspina, Hippolyt (1646\u20131710)",
        "DATEOFBIRTH": "1646",
        "DATEOFDEATH": "1710 Sep 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rassing an der Perschling"
    },
    {
        "ID": "13304",
        "NAME": "Malaspina, Franz Wilhelm (1565\u2013\u00a0\u00a0\u00a0\u00a0), Mundschenk",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Tresana",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13305",
        "NAME": "Arco, Anton (1535\u20131609), St\u00e4belmeister",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13306",
        "NAME": "Arco, Johann Baptist (1650\u20131715)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1715 Mar 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "13307",
        "NAME": "Nogarola, Hieronym (1460\u20131527)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1527",
        "PLACEOFBIRTH": "Verona",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13308",
        "NAME": "Nogarola, Leonhard (1500\u20131546), K\u00e4mmerer",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1546 Feb 19",
        "PLACEOFBIRTH": "Verona",
        "PLACEOFDEATH": "Triest"
    },
    {
        "ID": "13309",
        "NAME": "Nogarola, Georg (1535\u20131609), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1609 Dez 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ehrenfels im Lavanttal"
    },
    {
        "ID": "13310",
        "NAME": "Nogarola, Ferdinand (1540\u20131590), K\u00e4mmerer",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Spaur auf dem Nonsberg"
    },
    {
        "ID": "13311",
        "NAME": "Nogarola, Ferdinand (1585\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1627 Nov 17",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13312",
        "NAME": "Nogarola, Polyxena (1625\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13313",
        "NAME": "Nogarola, Elisabeth (1627\u20131691)",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1691 Feb 10",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "13315",
        "NAME": "Mignanelli, Kurt (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13316",
        "NAME": "Strasoldo, Richard (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Cervignano del Friuli",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13317",
        "NAME": "Borromeo, Johann Baptist (1530\u20131577)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1577 Mar 11",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13318",
        "NAME": "Fabriani, Albrecht Ludemar (1600\u20131644), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "Neuburg an der Donau",
        "PLACEOFDEATH": "Schweinspoint"
    },
    {
        "ID": "13319",
        "NAME": "Caracciolo, Thomas (1572\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1572 Mar 10",
        "DATEOFDEATH": "1631 Dez 05",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "13320",
        "NAME": "Caffarelli, Alexander (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13321",
        "NAME": "Caffarelli, Prosper (1592\u20131659)",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1659 Aug 14",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13322",
        "NAME": "Caffarelli, Franz (1595\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1631 Sep 17",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Breitenfeld im Lindenthal"
    },
    {
        "ID": "13323",
        "NAME": "Caffarelli, Peter (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13324",
        "NAME": "Mattei, Ludwig (1609\u20131665), K\u00e4mmerer",
        "DATEOFBIRTH": "1609 Nov 19",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13325",
        "NAME": "Ricasoli, Benedikt (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13326",
        "NAME": "Ricasoli, Oktavian (1595\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13327",
        "NAME": "Ricasoli, Benedikt (1590\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1627 Okt 15",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Wolfenb\u00fcttel"
    },
    {
        "ID": "13328",
        "NAME": "Ungnad von Weissenwolff, Johann (1465\u20131521)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1521",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Griffen"
    },
    {
        "ID": "13329",
        "NAME": "Spinelli, Karl (1580\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1633 Apr 05",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": "San Giorgio del Sannio"
    },
    {
        "ID": "13330",
        "NAME": "Medici, Kosmas (1519\u20131574), Gro\u00dfherzog der Toskana",
        "DATEOFBIRTH": "1519 Jun 12",
        "DATEOFDEATH": "1574 Apr 21",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Florenz"
    },
    {
        "ID": "13331",
        "NAME": "Medici, Peter (1554\u20131604)",
        "DATEOFBIRTH": "1554 Jun 03",
        "DATEOFDEATH": "1604 Apr 25",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "13332",
        "NAME": "Medici, Peter (1592\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1654",
        "PLACEOFBIRTH": "Madrid",
        "PLACEOFDEATH": "Florenz"
    },
    {
        "ID": "13333",
        "NAME": "Medici, Ferdinand (1549\u20131609), Gro\u00dfherzog der Toskana",
        "DATEOFBIRTH": "1549 Jul 30",
        "DATEOFDEATH": "1609 Feb 07",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Florenz"
    },
    {
        "ID": "13334",
        "NAME": "Medici, Lorenz (1599\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1599 Aug 01",
        "DATEOFDEATH": "1648 Nov 15",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Florenz"
    },
    {
        "ID": "13335",
        "NAME": "Medici, Kosmas (1590\u20131621), Gro\u00dfherzog der Toskana",
        "DATEOFBIRTH": "1590 Mai 12",
        "DATEOFDEATH": "1621 Feb 28",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Florenz"
    },
    {
        "ID": "13336",
        "NAME": "Medici, Ferdinand (1610\u20131670), Gro\u00dfherzog der Toskana",
        "DATEOFBIRTH": "1610 Jul 14",
        "DATEOFDEATH": "1670 Mai 23",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Florenz"
    },
    {
        "ID": "13337",
        "NAME": "Medici, Anna (1616\u20131676)",
        "DATEOFBIRTH": "1616 Jul 21",
        "DATEOFDEATH": "1676 Sep 11",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13338",
        "NAME": "Medici, Klaudia (1604\u20131648), Landesregentin von Tirol",
        "DATEOFBIRTH": "1604 Jun 04",
        "DATEOFDEATH": "1648 Dez 25",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Innsbruck:Jesuitenkirche"
    },
    {
        "ID": "13339",
        "NAME": "Habsburg, Elisabeth Klara (1629\u20131685), Landesregentin von Mantua",
        "DATEOFBIRTH": "1629 Aug 12",
        "DATEOFDEATH": "1685 Feb 24",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "13340",
        "NAME": "Habsburg, Maria Leopoldina (1632\u20131649), Kaiserin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1632 Apr 06",
        "DATEOFDEATH": "1649 Aug 07",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "13341",
        "NAME": "Bentivoglio, Kornel (1520\u20131585)",
        "DATEOFBIRTH": "1520",
        "DATEOFDEATH": "1585 Mai 26",
        "PLACEOFBIRTH": "Ferrara",
        "PLACEOFDEATH": "Ferrara"
    },
    {
        "ID": "13342",
        "NAME": "Frangipane di Veglia, Johann (1330\u20131393), Ban von Kroatien",
        "DATEOFBIRTH": "1330~",
        "DATEOFDEATH": "1393 Nov 29",
        "PLACEOFBIRTH": "Veglia",
        "PLACEOFDEATH": "Zengg:Franziskanerkirche"
    },
    {
        "ID": "13343",
        "NAME": "Frangipane di Veglia, Bartlome (1416\u20131474)",
        "DATEOFBIRTH": "1416",
        "DATEOFDEATH": "1474 Mar 22",
        "PLACEOFBIRTH": "Zengg",
        "PLACEOFDEATH": "Tersat am Flaum:Franziskanerkirche"
    },
    {
        "ID": "13344",
        "NAME": "Frangipane di Veglia, Johann (1458\u20131521)",
        "DATEOFBIRTH": "1458",
        "DATEOFDEATH": "1521",
        "PLACEOFBIRTH": "Tersat am Flaum",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13345",
        "NAME": "Frangipane di Veglia, Christoph (1490\u20131530)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1530",
        "PLACEOFBIRTH": "Tersat am Flaum",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13346",
        "NAME": "Frangipane di Veglia, Niklas (1520\u20131577)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "Tersat am Flaum",
        "PLACEOFDEATH": "Wasseil"
    },
    {
        "ID": "13347",
        "NAME": "Frangipane di Veglia, Kaspar (1550\u20131588)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "Tersat am Flaum",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13348",
        "NAME": "Frangipane di Veglia, Niklas (1584\u20131647), Ban von Kroatien",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1647 Apr 16",
        "PLACEOFBIRTH": "Tersat am Flaum",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13349",
        "NAME": "Strasoldo, Niklas (1535\u20131590)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "Cervignano del Friuli",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13350",
        "NAME": "Strasoldo, Peter (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Cervignano del Friuli",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13351",
        "NAME": "V\u00f6ls, Anselm (1530\u20131598), Hofkammerrat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13352",
        "NAME": "V\u00f6ls, Andreas (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13353",
        "NAME": "V\u00f6ls, Anselm (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13354",
        "NAME": "V\u00f6ls, Christoph (1550\u20131617), K\u00e4mmerer",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13355",
        "NAME": "Frangipane di Veglia, Ferdinand (1485\u20131525)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1525 Dez 10",
        "PLACEOFBIRTH": "Modrus",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13356",
        "NAME": "Frangipane di Veglia, Katharina (1525\u20131562)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1562 Jun 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13357",
        "NAME": "Stadl, Johann (1550\u20131618)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "Riegersburg in der Steiermark",
        "PLACEOFDEATH": "Riegersburg in der Steiermark"
    },
    {
        "ID": "13358",
        "NAME": "Stadl, Karl (1585\u2013\u00a0\u00a0\u00a0\u00a0), Vorschneider",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Riegersburg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13359",
        "NAME": "Cesarini, Peter (1590\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1647",
        "PLACEOFBIRTH": "Civitanova Marche",
        "PLACEOFDEATH": "Heraklion"
    },
    {
        "ID": "13360",
        "NAME": "Negro, Jakob (1580\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13361",
        "NAME": "Malaspina, Alexander (1560\u20131638), Hofkriegsrat",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "Verona",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13362",
        "NAME": "Malaspina, Manfred (1590\u20131642)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1642 Mai 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13363",
        "NAME": "Malaspina, Barnabas (1619\u20131664)",
        "DATEOFBIRTH": "1619",
        "DATEOFDEATH": "1664 Sep 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pisa"
    },
    {
        "ID": "13364",
        "NAME": "Malaspina, Franz Wilhelm (1528\u20131590), Markgraf von Tresana",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "Tresana",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13365",
        "NAME": "Bentivoglio, Heinrich (1575\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1639 Nov 25",
        "PLACEOFBIRTH": "Ferrara",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13366",
        "NAME": "Scotti, Lorenz (1565\u20131615), Mundschenk",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1615~",
        "PLACEOFBIRTH": "Modena",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13367",
        "NAME": "Savignoni, Friedrich (1580\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13368",
        "NAME": "Ruberti, Julius (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13369",
        "NAME": "Conti, Torquat (1591\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1636 Jun 06",
        "PLACEOFBIRTH": "Poli",
        "PLACEOFDEATH": "Ferrara"
    },
    {
        "ID": "13370",
        "NAME": "Frangipane di Veglia, Niklas (1362\u20131432), Ban von Kroatien",
        "DATEOFBIRTH": "1362",
        "DATEOFDEATH": "1432 Jun 26",
        "PLACEOFBIRTH": "Zengg",
        "PLACEOFDEATH": "Zengg:Franziskanerkirche"
    },
    {
        "ID": "13371",
        "NAME": "Frangipane di Veglia, Stephan (1410\u20131481), Ban von Kroatien",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1481",
        "PLACEOFBIRTH": "Zengg",
        "PLACEOFDEATH": "Modrus"
    },
    {
        "ID": "13372",
        "NAME": "Frangipane di Veglia, Bernhard (1453\u20131529)",
        "DATEOFBIRTH": "1453",
        "DATEOFDEATH": "1529 Nov 03",
        "PLACEOFBIRTH": "Modrus",
        "PLACEOFDEATH": "Osail"
    },
    {
        "ID": "13373",
        "NAME": "Frangipane di Veglia, Christoph (1482\u20131527), Ban von Kroatien",
        "DATEOFBIRTH": "1482",
        "DATEOFDEATH": "1527 Sep 27",
        "PLACEOFBIRTH": "Modrus",
        "PLACEOFDEATH": "Warasdin an der Drau"
    },
    {
        "ID": "13374",
        "NAME": "Frangipane di Veglia, Beatrix (1479\u20131510)",
        "DATEOFBIRTH": "1479",
        "DATEOFDEATH": "1510 Mar 27",
        "PLACEOFBIRTH": "Modrus",
        "PLACEOFDEATH": "Julau:Franziskanerkirche"
    },
    {
        "ID": "13375",
        "NAME": "Frangipane, Peter (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Tarcento",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13376",
        "NAME": "Frangipane, Kornel (1508\u20131588)",
        "DATEOFBIRTH": "1508 Sep 08",
        "DATEOFDEATH": "1588 Aug 26",
        "PLACEOFBIRTH": "Tarcento",
        "PLACEOFDEATH": "Tarcento"
    },
    {
        "ID": "13377",
        "NAME": "Frangipane, Hortensius (1525\u20131569)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "Tarcento",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13378",
        "NAME": "Frangipane, Kornel (1553\u20131643), K\u00e4mmerer",
        "DATEOFBIRTH": "1553 Nov 16",
        "DATEOFDEATH": "1643 Mai 30",
        "PLACEOFBIRTH": "Tarcento",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "13379",
        "NAME": "Frangipane, Antigon (1560\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Tarcento",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13380",
        "NAME": "Aldobrandini, Hippolyt (1536\u20131605), Papst Klement\u00a0VIII.",
        "DATEOFBIRTH": "1536 Feb 24",
        "DATEOFDEATH": "1605 Mar 03",
        "PLACEOFBIRTH": "Fano della Fortuna",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13381",
        "NAME": "Aldobrandini, Silvester (1499\u20131558)",
        "DATEOFBIRTH": "1499 Nov 24",
        "DATEOFDEATH": "1558 Jun 06",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13382",
        "NAME": "Aldobrandini, Peter (1535\u20131587)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1587 Feb 11",
        "PLACEOFBIRTH": "Fano della Fortuna",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13383",
        "NAME": "Aldobrandini, Peter (1571\u20131621), Erzbischof von Ravenna",
        "DATEOFBIRTH": "1571 Mar 31",
        "DATEOFDEATH": "1621 Feb 10",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13384",
        "NAME": "Aldobrandini, Olympia (1567\u20131637)",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1637 Apr 28",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13385",
        "NAME": "Aldobrandini, Johann Franz (1545\u20131601)",
        "DATEOFBIRTH": "1545 Mar 11",
        "DATEOFDEATH": "1601 Sep 17",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Warasdin an der Drau"
    },
    {
        "ID": "13386",
        "NAME": "Aldobrandini, Karl (1593\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1634 Sep 06",
        "PLACEOFBIRTH": "Siena",
        "PLACEOFDEATH": "N\u00f6rdlingen im Ries"
    },
    {
        "ID": "13387",
        "NAME": "Savelli, Karolina (1608\u20131692)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1692 Jan 28",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "13388",
        "NAME": "Aldobrandini, Peter (1590\u20131630), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1630",
        "PLACEOFBIRTH": "Siena",
        "PLACEOFDEATH": "Ferrara"
    },
    {
        "ID": "13389",
        "NAME": "Sbrojavacca, Rudolf (1600\u20131661), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1661",
        "PLACEOFBIRTH": "Udine",
        "PLACEOFDEATH": "Portogruaro"
    },
    {
        "ID": "13390",
        "NAME": "Arborio di Gattinara, Merkurin (1465\u20131530)",
        "DATEOFBIRTH": "1465 Jun 10",
        "DATEOFDEATH": "1530 Jun 05",
        "PLACEOFBIRTH": "Gattinara",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "13391",
        "NAME": "Arco, Johann Vinzenz (1575\u20131621), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13392",
        "NAME": "Arco, Johann Baptist (1588\u20131628), K\u00e4mmerer",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13393",
        "NAME": "Arco, Maximilian (1617\u20131683)",
        "DATEOFBIRTH": "1617",
        "DATEOFDEATH": "1683 Apr 26",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13394",
        "NAME": "Arco, Johann Philipp (1652\u20131704)",
        "DATEOFBIRTH": "1652 Mai 11",
        "DATEOFDEATH": "1704 Feb 18",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": "Bregenz"
    },
    {
        "ID": "13395",
        "NAME": "Anguissola, Hotze (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Cremona",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13396",
        "NAME": "Ridolfi di Piazza, Alexander (1580\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Baselice"
    },
    {
        "ID": "13397",
        "NAME": "Domnobono, Donat (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13398",
        "NAME": "Frangipane, Johann Baptist (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Porpetto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13399",
        "NAME": "Frangipane, Julius Anton (1606\u20131656), Hofkriegsrat",
        "DATEOFBIRTH": "1606 Dez 05",
        "DATEOFDEATH": "1656 Aug 19",
        "PLACEOFBIRTH": "Porpetto",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "13400",
        "NAME": "Habsburg, Elisabeth (1501\u20131526), K\u00f6nigin von D\u00e4nemark",
        "DATEOFBIRTH": "1501 Jul 18",
        "DATEOFDEATH": "1526 Jan 19",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Zw\u0133naarde"
    },
    {
        "ID": "13401",
        "NAME": "Helfenstein, Rudolf (1585\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1585 Mar 07",
        "DATEOFDEATH": "1627 Sep 20",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": "Wiesensteig"
    },
    {
        "ID": "13402",
        "NAME": "Arco, Scipio (1521\u20131573), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1521",
        "DATEOFDEATH": "1573",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13403",
        "NAME": "Arco, Prosper (1522\u20131572)",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "1572 Nov 22",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13404",
        "NAME": "Arco, Pyrrhus (1520\u20131567), Mundschenk",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1567 Aug 24",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13405",
        "NAME": "Arco, Johann Baptist (1525\u20131586)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13406",
        "NAME": "Arco, Prosper (1555\u20131607)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13407",
        "NAME": "Capra, Ulrich (1600\u20131654)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1654",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13408",
        "NAME": "Collalto, Hotze (1566\u20131630)",
        "DATEOFBIRTH": "1566 Dez 11",
        "DATEOFDEATH": "1630",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13409",
        "NAME": "Collalto, Viktoria (1599\u20131661)",
        "DATEOFBIRTH": "1599 Mai 13",
        "DATEOFDEATH": "1661",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13410",
        "NAME": "Lodron, Paris (1370\u20131439)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "1439 Mai 10",
        "PLACEOFBIRTH": "Lodrone di Storo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13411",
        "NAME": "Lodron, Georg (1400\u20131461)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1461",
        "PLACEOFBIRTH": "Lodrone di Storo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13412",
        "NAME": "Lodron, Franz (1438\u20131506)",
        "DATEOFBIRTH": "1438",
        "DATEOFDEATH": "1506 Okt 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13413",
        "NAME": "Lodron, Niklas (1475\u20131551)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1551 Mar 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13414",
        "NAME": "Lodron, Peter (1405\u20131485)",
        "DATEOFBIRTH": "1405~",
        "DATEOFDEATH": "1485 Apr 20",
        "PLACEOFBIRTH": "Lodrone di Storo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13415",
        "NAME": "Lodron, Paris (1435\u20131498)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1498",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13416",
        "NAME": "Lodron, Niklas (1475\u20131548)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13417",
        "NAME": "Lodron, Paris (1490\u20131549)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1549 Feb 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13418",
        "NAME": "Lodron, Hieronym (1545\u20131602)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13419",
        "NAME": "Lodron, Paris (1453\u20131505)",
        "DATEOFBIRTH": "1453",
        "DATEOFDEATH": "1505",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13420",
        "NAME": "Lodron, Ludwig (1484\u20131537)",
        "DATEOFBIRTH": "1484",
        "DATEOFDEATH": "1537 Okt 12",
        "PLACEOFBIRTH": "Lodrone di Storo",
        "PLACEOFDEATH": "Esseg an der Drau"
    },
    {
        "ID": "13421",
        "NAME": "Lodron, Kaspar (1520\u20131585), St\u00e4belmeister",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1585 Sep 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13422",
        "NAME": "Lodron, Johann Baptist (1480\u20131555)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1555",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Casale Monferrato"
    },
    {
        "ID": "13423",
        "NAME": "Lodron, Johann Baptist (1585\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1631 Mar 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Coswig an der Elbe"
    },
    {
        "ID": "13424",
        "NAME": "Lodron, Franz (1530\u20131582)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1582",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13425",
        "NAME": "Lodron, Hieronym (1559\u20131619)",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1619 Aug 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13426",
        "NAME": "Lodron, Paris (1605\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1660 Jul 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13427",
        "NAME": "Lodron, Johann Baptist (1653\u20131695), K\u00e4mmerer",
        "DATEOFBIRTH": "1653 Mai 19",
        "DATEOFDEATH": "1695 Jun 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13428",
        "NAME": "Lodron, Maximilian (1576\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1576 Mai 17",
        "DATEOFDEATH": "1635 Mai 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13429",
        "NAME": "Lodron, Paris (1638\u20131702), K\u00e4mmerer",
        "DATEOFBIRTH": "1638",
        "DATEOFDEATH": "1702 Nov 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13430",
        "NAME": "Lodron, Ludwig (1580\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13431",
        "NAME": "Lodron, Niklas (1627\u20131700), K\u00e4mmerer",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1700",
        "PLACEOFBIRTH": "Concesio",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13432",
        "NAME": "Lodron, Ludwig (1666\u20131718), K\u00e4mmerer",
        "DATEOFBIRTH": "1666 Nov 08",
        "DATEOFDEATH": "1718",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13433",
        "NAME": "Lodron, Felix (1630\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13434",
        "NAME": "Lodron, Ludwig (1540\u20131604)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1604",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "13435",
        "NAME": "Lodron, Julius (1475\u20131510)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1510",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13436",
        "NAME": "Lodron, Hieronym (1620\u20131657)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1657",
        "PLACEOFBIRTH": "Concesio",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13437",
        "NAME": "Lodron, Karl (1610\u20131643), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13438",
        "NAME": "Lodron, Karl (1630\u20131666)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1666 Okt 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13439",
        "NAME": "Ungnad von Weissenwolff, Johann (1493\u20131564), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1493 Nov 19",
        "DATEOFDEATH": "1564 Dez 27",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Winteritz in B\u00f6hmen"
    },
    {
        "ID": "13440",
        "NAME": "Bonhomo, Ferdinand (1580\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13441",
        "NAME": "Althan, Eustach (1530\u20131602)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1602 Dez 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13442",
        "NAME": "Althan, Johann Baptist (1568\u20131629)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13443",
        "NAME": "Althan, Johann Eustach (1600\u20131652), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1652 Okt 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13444",
        "NAME": "Zwickel, Christoph (1530\u20131578), Oberstk\u00fcchenmeister",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1578 Mar 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13445",
        "NAME": "Zwickel, Maximilian (1595\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13446",
        "NAME": "Lamberg, Joseph (1489\u20131554), Obersthofmeister",
        "DATEOFBIRTH": "1489",
        "DATEOFDEATH": "1554 Okt 20",
        "PLACEOFBIRTH": "Ortenegg in der Windischen Mark",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "13447",
        "NAME": "Lamberg, Katharina (1541\u20131599)",
        "DATEOFBIRTH": "1541",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "Ottenstein im Waldviertel",
        "PLACEOFDEATH": "Engen im Hegau"
    },
    {
        "ID": "13448",
        "NAME": "Hohenems, Johann Ulrich (1440\u20131508)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1508",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13449",
        "NAME": "Hohenems, Johann (1480\u20131557)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1557",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13450",
        "NAME": "Montrichier, Wilhelm (1500\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rogersberg in der Waadt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13451",
        "NAME": "Montrichier, Johann (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rogersberg in der Waadt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13452",
        "NAME": "Montrichier, Jakob (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rogersberg in der Waadt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13453",
        "NAME": "Montrichier, Johann (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rogersberg in der Waadt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13454",
        "NAME": "Montrichier, Heinrich (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rogersberg in der Waadt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13455",
        "NAME": "Montrichier, Heinrich (1593\u20131648)",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1648 Okt 09",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "13456",
        "NAME": "Montrichier, Ferdinand (1641\u20131703), K\u00e4mmerer",
        "DATEOFBIRTH": "1641",
        "DATEOFDEATH": "1703",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13457",
        "NAME": "Montrichier, Karl Joseph (1682\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1682",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13458",
        "NAME": "Montrichier, Johann (1597\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13459",
        "NAME": "Montrichier, Franziska Elisabeth (1625\u20131668)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1668 Mai 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13460",
        "NAME": "Thuilli\u00e8res, Johann Klaudius (1540\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Montjoie le Ch\u00e2teau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13461",
        "NAME": "Redern, Friedrich (1515\u20131564)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1564 Mar 08",
        "PLACEOFBIRTH": "Ruppersdorf in Schlesien",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "13462",
        "NAME": "Redern, Christoph (1550\u20131591)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1591 Sep 03",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13463",
        "NAME": "Redern, Christoph (1591\u20131642), K\u00e4mmerer",
        "DATEOFBIRTH": "1591 Aug 17",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Friedland in B\u00f6hmen",
        "PLACEOFDEATH": "Hermsdorf an der Warthe"
    },
    {
        "ID": "13464",
        "NAME": "Puchheim, Christoph (1470\u20131527)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1527",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13465",
        "NAME": "Puchheim, Longin (1510\u20131553)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1553",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13466",
        "NAME": "Puchheim, Anton (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13467",
        "NAME": "Puchheim, Erasam (1518\u20131571)",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13468",
        "NAME": "Puchheim, Christoph (1545\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Krumbach in der Buckligen Welt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13469",
        "NAME": "Waldstein, Sidonius (1521\u20131579)",
        "DATEOFBIRTH": "1521",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13470",
        "NAME": "Gonzaga, Johann Franz (1395\u20131444), Markgraf von Mantua",
        "DATEOFBIRTH": "1395 Jun 01",
        "DATEOFDEATH": "1444 Sep 25",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "13471",
        "NAME": "Gonzaga, Karl (1415\u20131456)",
        "DATEOFBIRTH": "1415~",
        "DATEOFDEATH": "1456 Dez 21",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Ferrara"
    },
    {
        "ID": "13472",
        "NAME": "Gonzaga, Z\u00e4zilia (1425\u20131451)",
        "DATEOFBIRTH": "1425",
        "DATEOFDEATH": "1451",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "13473",
        "NAME": "Gonzaga, Z\u00e4zilia (1455\u20131479)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1479 Jul 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Arco in Tirol"
    },
    {
        "ID": "13474",
        "NAME": "Kokorzowa, Adam (1520\u20131584)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13475",
        "NAME": "Kokorzowa, Karl (1552\u20131605)",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "1605 Aug 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13476",
        "NAME": "Kokorzowa, Georg (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13477",
        "NAME": "Kokorzowa, Ferdinand (1650\u20131708), K\u00e4mmerer",
        "DATEOFBIRTH": "1650 Jan 19",
        "DATEOFDEATH": "1708 Dez 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13478",
        "NAME": "Vernier de Rougemont, Matthias (1595\u20131658), Hofkriegsrat",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13479",
        "NAME": "Rottal, Thomas (1420\u20131479)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1479",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13480",
        "NAME": "Rottal, Georg (1458\u20131525)",
        "DATEOFBIRTH": "1458",
        "DATEOFDEATH": "1525 Mar 31",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "13481",
        "NAME": "Rottal, Thomas (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13482",
        "NAME": "Rottal, Wilhelm (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13483",
        "NAME": "Rottal, Johann (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13484",
        "NAME": "Rottal, Johann Jakob (1570\u20131622)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1622",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13485",
        "NAME": "Rottal, Johann Wilhelm (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13486",
        "NAME": "Rottal, Johann Georg (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13487",
        "NAME": "Schauenburg, Hannibal (1582\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1634 Mar 30",
        "PLACEOFBIRTH": "Herlisheim an der Lauch",
        "PLACEOFDEATH": "Freiburg im Breisgau"
    },
    {
        "ID": "13488",
        "NAME": "Marschall von Pappenheim, Konrad (1534\u20131603), Trabantenhauptmann",
        "DATEOFBIRTH": "1534 Apr 10",
        "DATEOFDEATH": "1603 Aug 09",
        "PLACEOFBIRTH": "Rothenstein im Allg\u00e4u",
        "PLACEOFDEATH": "T\u00fcbingen"
    },
    {
        "ID": "13489",
        "NAME": "Losenstein, Georg Theodemar (1595\u20131624), K\u00e4mmerer",
        "DATEOFBIRTH": "1595",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "Gschwendt an der Krems",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13490",
        "NAME": "Rappach, Christoph (1430\u20131485)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1485 Nov 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13491",
        "NAME": "Rappach, Johann (1470\u20131513)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1513 Apr 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13492",
        "NAME": "Rappach, Christoph (1500\u20131551)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1551",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13493",
        "NAME": "Rappach, Christoph (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13494",
        "NAME": "Rappach, Christoph (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13495",
        "NAME": "Rappach, Felizitas (1575\u20131645)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1645 Aug 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13496",
        "NAME": "Rappach, Katharina (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13497",
        "NAME": "Rappach, Magdalena (1542\u20131562)",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1562 Nov 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "13498",
        "NAME": "Kolowrat, Jaroslaus (1577\u20131626)",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "Altsattler B\u00fcrgel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13499",
        "NAME": "Arco, Anna (1550\u20131570)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1570",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trentschin im Waagtal"
    },
    {
        "ID": "13500",
        "NAME": "Habsburg, Maria (1505\u20131558), K\u00f6nigin von Ungarn",
        "DATEOFBIRTH": "1505 Sep 15",
        "DATEOFDEATH": "1558 Okt 18",
        "PLACEOFBIRTH": "Mechelen",
        "PLACEOFDEATH": "Cigales"
    },
    {
        "ID": "13501",
        "NAME": "Strasoldo, Karl (1565\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Cervignano del Friuli",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13502",
        "NAME": "Strasoldo, Martin (1570\u20131643), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1643 Sep 06",
        "PLACEOFBIRTH": "Cervignano del Friuli",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13503",
        "NAME": "Strasoldo, Orpheus (1580\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1649 Jan 26",
        "PLACEOFBIRTH": "Cervignano del Friuli",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "13504",
        "NAME": "Strasoldo, Weikhard (1590\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1631 Sep 17",
        "PLACEOFBIRTH": "Cervignano del Friuli",
        "PLACEOFDEATH": "Breitenfeld im Lindenthal"
    },
    {
        "ID": "13505",
        "NAME": "Strasoldo, Bartlome (1620\u20131647)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1647 Nov",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Iglau in M\u00e4hren"
    },
    {
        "ID": "13506",
        "NAME": "Boccapianola, Franz (1585\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1648",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13507",
        "NAME": "Collalto, Vinciguerra (1440\u20131481)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1481",
        "PLACEOFBIRTH": "Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13508",
        "NAME": "Collalto, Anton (1475\u20131528)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13509",
        "NAME": "Collalto, Reimbald (1506\u20131576)",
        "DATEOFBIRTH": "1506 Nov 15",
        "DATEOFDEATH": "1576 Apr 06",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13510",
        "NAME": "Collalto, Anton (1548\u20131619)",
        "DATEOFBIRTH": "1548 Aug 19",
        "DATEOFDEATH": "1619 Nov 09",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13511",
        "NAME": "Collalto, Niklas (1478\u20131546)",
        "DATEOFBIRTH": "1478",
        "DATEOFDEATH": "1546",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13512",
        "NAME": "Collalto, Scipio (1506\u20131567)",
        "DATEOFBIRTH": "1506 Jan 07",
        "DATEOFDEATH": "1567 Feb 25",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13513",
        "NAME": "Collalto, Hannibal (1536\u20131607)",
        "DATEOFBIRTH": "1536 Feb 20",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13514",
        "NAME": "Collalto, Klaudius (1583\u20131617), K\u00e4mmerer",
        "DATEOFBIRTH": "1583 Jul 31",
        "DATEOFDEATH": "1617 Jun 15",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13515",
        "NAME": "Collalto, Oktavian (1585\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1585 Sep 09",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13516",
        "NAME": "Collalto, Hannibal (1615\u20131658)",
        "DATEOFBIRTH": "1615 Okt 02",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13517",
        "NAME": "Collalto, Johann Baptist (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13518",
        "NAME": "Collalto, Tolbrecht (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13519",
        "NAME": "Hohenems, Mark Sittich (1466\u20131533)",
        "DATEOFBIRTH": "1466",
        "DATEOFDEATH": "1533 Jul 25",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Bregenz"
    },
    {
        "ID": "13520",
        "NAME": "Hohenems, Jakob (1470\u20131512)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1512 Apr 11",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Ravenna"
    },
    {
        "ID": "13521",
        "NAME": "Hohenems, Markward (1495\u20131523)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1523 Mai 20",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13522",
        "NAME": "Hohenems, Mark Sittich (1521\u20131565)",
        "DATEOFBIRTH": "1521",
        "DATEOFDEATH": "1565 Feb 08",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13523",
        "NAME": "Hohenems, Franz Wilhelm (1654\u20131691), Truchsess",
        "DATEOFBIRTH": "1654",
        "DATEOFDEATH": "1691 Aug 27",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Wardein an der Donau"
    },
    {
        "ID": "13524",
        "NAME": "Hohenems, Ferdinand Karl (1650\u20131686), K\u00e4mmerer",
        "DATEOFBIRTH": "1650 Dez 29",
        "DATEOFDEATH": "1686 Feb 18",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Kemnat im Allg\u00e4u"
    },
    {
        "ID": "13525",
        "NAME": "Hohenems, Margarita (1536\u20131592)",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "13526",
        "NAME": "Traun, Johann Christoph (1598\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1654 Feb 19",
        "PLACEOFBIRTH": "Maissau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13527",
        "NAME": "Lodron, Anna (1495\u20131556)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1556 Nov 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13528",
        "NAME": "Collalto, Jakob (1542\u20131621), Mundschenk",
        "DATEOFBIRTH": "1542 Jul 15",
        "DATEOFDEATH": "1621 Dez 29",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13529",
        "NAME": "Medici di Marignano, Bernhard (1465\u20131519)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1519",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "13530",
        "NAME": "Medici di Marignano, Johann Angel (1499\u20131565), Papst Pius\u00a0IV.",
        "DATEOFBIRTH": "1499 Mar 31",
        "DATEOFDEATH": "1565 Dez 09",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13531",
        "NAME": "Medici di Marignano, Klara (1510\u20131560)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1560",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13532",
        "NAME": "Medici, Angela (1608\u20131636)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1636 Mar 02",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13533",
        "NAME": "Medici di Marignano, Johann Jakob (1498\u20131555)",
        "DATEOFBIRTH": "1498 Jan 25",
        "DATEOFDEATH": "1555 Nov 08",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "13534",
        "NAME": "Medici di Marignano, August (1501\u20131570)",
        "DATEOFBIRTH": "1501 Okt 23",
        "DATEOFDEATH": "1570 Okt 19",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Frascarolo"
    },
    {
        "ID": "13535",
        "NAME": "Medici di Marignano, Johann Jakob (1558\u20131599)",
        "DATEOFBIRTH": "1558 Jan 12",
        "DATEOFDEATH": "1599 Sep 01",
        "PLACEOFBIRTH": "Melegnano",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "13536",
        "NAME": "Medici di Marignano, Margarita (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13537",
        "NAME": "Gonzaga, Friedrich (1580\u20131630), Markgraf von Luzzara",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1630",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13538",
        "NAME": "Gonzaga, Eleonora (1607\u20131665)",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13539",
        "NAME": "Collalto, Juliana (1623\u20131647)",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1647",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13540",
        "NAME": "Capece Galeota, Marius (1580\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13541",
        "NAME": "Borromeo, Hortensia (1550\u20131578)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1578 Dez 27",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": "Hohenems"
    },
    {
        "ID": "13542",
        "NAME": "Bracciolini, Julian (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pistoia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13543",
        "NAME": "Bracciolini, Johann Baptist (1600\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13544",
        "NAME": "Bracciolini, Franz Kosmas (1605\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13545",
        "NAME": "Capece Galeota, Foppe (1579\u20131645)",
        "DATEOFBIRTH": "1579 Jul 30",
        "DATEOFDEATH": "1645 Dez 15",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": "Foggia"
    },
    {
        "ID": "13546",
        "NAME": "Fieschi, Haug (1600\u20131675), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1675~",
        "PLACEOFBIRTH": "Lavagna",
        "PLACEOFDEATH": "Genova"
    },
    {
        "ID": "13547",
        "NAME": "Spinola, Maria (1608\u20131649)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13548",
        "NAME": "Nogarola, Fabriz (1588\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13549",
        "NAME": "Ajazza, Lorenz (1590\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1634 Sep 06",
        "PLACEOFBIRTH": "Vercelli",
        "PLACEOFDEATH": "N\u00f6rdlingen im Ries"
    },
    {
        "ID": "13550",
        "NAME": "Habsburg, Christina (1574\u20131621), F\u00fcrstin von Siebenb\u00fcrgen",
        "DATEOFBIRTH": "1574 Nov 10",
        "DATEOFDEATH": "1621 Apr 06",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Hall in Tirol"
    },
    {
        "ID": "13551",
        "NAME": "Castiglioni, Alexander (1520\u20131574)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1574",
        "PLACEOFBIRTH": "Garlasco",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13552",
        "NAME": "Castiglioni, Pompei (1550\u20131603)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "Garlasco",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13553",
        "NAME": "Castiglioni, Alfons (1545\u20131607)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1607 Jul 08",
        "PLACEOFBIRTH": "Garlasco",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13554",
        "NAME": "Castiglioni, Manfred (1570\u20131635)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "Garlasco",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13555",
        "NAME": "Castiglioni, Ferdinand (1595\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "Garlasco",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13556",
        "NAME": "Gonzaga, Prosper (1554\u20131614), Markgraf von Luzzara",
        "DATEOFBIRTH": "1554",
        "DATEOFDEATH": "1614 Sep 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "13557",
        "NAME": "Gonzaga, Ludwig (1587\u20131633), Bischof von Alba",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1633",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13558",
        "NAME": "Gonzaga, Galeas (1590\u2013\u00a0\u00a0\u00a0\u00a0), Mundschenk",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13559",
        "NAME": "Gonzaga, Vinzenz (1595\u2013\u00a0\u00a0\u00a0\u00a0), Edelknabe",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13560",
        "NAME": "Gonzaga, Alfons (1596\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1659",
        "PLACEOFBIRTH": "San Martino dall\u2019Argine",
        "PLACEOFDEATH": "San Martino dall\u2019Argine"
    },
    {
        "ID": "13561",
        "NAME": "Gonzaga, Friedrich (1598\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "San Martino dall\u2019Argine",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13562",
        "NAME": "Gonzaga, Kamil (1600\u20131658), K\u00e4mmerer",
        "DATEOFBIRTH": "1600",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "San Martino dall\u2019Argine",
        "PLACEOFDEATH": "Split"
    },
    {
        "ID": "13563",
        "NAME": "Gonzaga, Johann Franz (1488\u20131524), Markgraf von Luzzara",
        "DATEOFBIRTH": "1488 Feb 02",
        "DATEOFDEATH": "1524 Dez 18",
        "PLACEOFBIRTH": "Luzzara",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "13564",
        "NAME": "Gonzaga, Maximilian (1513\u20131578), Markgraf von Luzzara",
        "DATEOFBIRTH": "1513",
        "DATEOFDEATH": "1578 Mar 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "13565",
        "NAME": "Gonzaga, Johann (1474\u20131525), F\u00fcrst von Vescovado",
        "DATEOFBIRTH": "1474",
        "DATEOFDEATH": "1525 Sep 23",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "13566",
        "NAME": "Gonzaga, Siegmund (1499\u20131530), F\u00fcrst von Vescovado",
        "DATEOFBIRTH": "1499",
        "DATEOFDEATH": "1530 Dez 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13567",
        "NAME": "Gonzaga, Siegmund (1530\u20131567), F\u00fcrst von Vescovado",
        "DATEOFBIRTH": "1530",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "13568",
        "NAME": "Gonzaga, Karl (1551\u20131614), F\u00fcrst von Vescovado",
        "DATEOFBIRTH": "1551 Apr 20",
        "DATEOFDEATH": "1614 Jan 09",
        "PLACEOFBIRTH": "Vescovado",
        "PLACEOFDEATH": "Siena"
    },
    {
        "ID": "13569",
        "NAME": "Gonzaga, Franz (1593\u20131636), F\u00fcrst von Vescovado",
        "DATEOFBIRTH": "1593 Apr 10",
        "DATEOFDEATH": "1636 Aug 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13570",
        "NAME": "Gonzaga, Siegmund (1625\u20131694), F\u00fcrst von Vescovado",
        "DATEOFBIRTH": "1625 Feb 11",
        "DATEOFDEATH": "1694 Dez 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "13571",
        "NAME": "Spinola, Stephan (1460\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13572",
        "NAME": "Spinola, Ambros (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13573",
        "NAME": "Spinola, Philipp (1530\u20131585)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1585",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13574",
        "NAME": "Spinola, Hieronym (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13575",
        "NAME": "Spinola, Christoph (1525\u20131569)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13576",
        "NAME": "Spinola, Andreas (1562\u20131641), Herzog von Genua",
        "DATEOFBIRTH": "1562",
        "DATEOFDEATH": "1641",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": "Genova"
    },
    {
        "ID": "13577",
        "NAME": "Spinola, Philipp (1594\u20131659)",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1659 Aug 08",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "13578",
        "NAME": "Spinola, Paul (1632\u20131699)",
        "DATEOFBIRTH": "1632 Feb 25",
        "DATEOFDEATH": "1699 Dez 23",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "13579",
        "NAME": "Spinola, Albrecht (1580\u20131618)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "Bruay in Artesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13580",
        "NAME": "Molza, Furius (1530\u20131591)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1591",
        "PLACEOFBIRTH": "Modena",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13581",
        "NAME": "Rangoni, Julius (1585\u20131639)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1639 Nov 20",
        "PLACEOFBIRTH": "Modena",
        "PLACEOFDEATH": "Moncalieri"
    },
    {
        "ID": "13582",
        "NAME": "Ariberti, Johann Baptist (1612\u20131707), K\u00e4mmerer",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1707",
        "PLACEOFBIRTH": "Cremona",
        "PLACEOFDEATH": "Cremona"
    },
    {
        "ID": "13583",
        "NAME": "Bertucci, Franz Anton (1560\u20131627)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Lesina",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13584",
        "NAME": "Sacchetti, Johann Baptist (1540\u20131620)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1620 Jan 20",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13585",
        "NAME": "Sacchetti, Julius (1587\u20131663)",
        "DATEOFBIRTH": "1587 Dez 18",
        "DATEOFDEATH": "1663 Jun 28",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13586",
        "NAME": "Sacchetti, Alexander (1589\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1648",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13587",
        "NAME": "Rovere, Stephan (1570\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "Messina",
        "PLACEOFDEATH": "Sankt Veit am Flaum"
    },
    {
        "ID": "13588",
        "NAME": "Carretto, Johann Baptist (1559\u20131616)",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1616 Mar 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13589",
        "NAME": "Carretto, Oktavian (1590\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1659",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13590",
        "NAME": "Gaetani, Gregor (1603\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1603",
        "DATEOFDEATH": "1634 Sep 01",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13591",
        "NAME": "Wolkenstein, Karl (1572\u20131626), K\u00e4mmerer",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13592",
        "NAME": "Spinola, Gottlieb (1280\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1280~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13593",
        "NAME": "Spinola, Niklas (1310\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1310~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13594",
        "NAME": "Spinola, Imperiale (1340\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13595",
        "NAME": "Spinola, Niklas (1370\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13596",
        "NAME": "Spinola, Damian (1400\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13597",
        "NAME": "Cardona, Anton (1500\u20131555), Obersthofmeister",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1555 Apr 11",
        "PLACEOFBIRTH": "Cardona",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13598",
        "NAME": "Sparr, Ernst Georg (1602\u20131666), K\u00e4mmerer",
        "DATEOFBIRTH": "1602 Jan 15",
        "DATEOFDEATH": "1666 Jun 28",
        "PLACEOFBIRTH": "Eberswalde an der Finow",
        "PLACEOFDEATH": "Berlin"
    },
    {
        "ID": "13599",
        "NAME": "Sparr, Otto Christoph (1605\u20131668)",
        "DATEOFBIRTH": "1605 Nov 13",
        "DATEOFDEATH": "1668 Mai 09",
        "PLACEOFBIRTH": "Lichterfelde",
        "PLACEOFDEATH": "Prenden"
    },
    {
        "ID": "13600",
        "NAME": "Habsburg, Albrecht\u00a0II. (1397\u20131439), K\u00f6nig des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1397 Aug 10",
        "DATEOFDEATH": "1439 Okt 27",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Langendorf an der Donau"
    },
    {
        "ID": "13601",
        "NAME": "Schulze von Schwanensee, Tobias (1565\u20131620)",
        "DATEOFBIRTH": "1565 Okt 29",
        "DATEOFDEATH": "1620 Apr 26",
        "PLACEOFBIRTH": "Oschatz",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "13602",
        "NAME": "Kollonitz, Johanna (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13603",
        "NAME": "Walther von Walthersweil, Bernhard (1516\u20131584)",
        "DATEOFBIRTH": "1516",
        "DATEOFDEATH": "1584 Dez 05",
        "PLACEOFBIRTH": "Leipzig",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13604",
        "NAME": "Walther von Walthersweil, Bernhard (1555\u20131624), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1624 Sep 17",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Judenburg im Murtal"
    },
    {
        "ID": "13605",
        "NAME": "Walther von Walthersweil, Stephan (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13606",
        "NAME": "Walther von Walthersweil, Jobst (1435\u20131510)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1510~",
        "PLACEOFBIRTH": "Memmingen",
        "PLACEOFDEATH": "Lindau im Bodensee"
    },
    {
        "ID": "13607",
        "NAME": "Walther von Walthersweil, Hieronym (1475\u20131549)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1549",
        "PLACEOFBIRTH": "Lindau im Bodensee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13608",
        "NAME": "Walther von Walthersweil, Jobst (1515\u20131576)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Leipzig",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "13609",
        "NAME": "Walther von Walthersweil, Hieronym (1500\u20131560)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1560~",
        "PLACEOFBIRTH": "Leipzig",
        "PLACEOFDEATH": "Joachimsthal im Erzgebirge"
    },
    {
        "ID": "13610",
        "NAME": "Walther von Walthersweil, Hieronym (1557\u20131610), K\u00e4mmerer",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1610 Aug 10",
        "PLACEOFBIRTH": "Madrid",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "13611",
        "NAME": "Walther von Walthersweil, Wolfgang (1591\u20131644)",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1644 Apr 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "M\u00fcnster in Westfalen"
    },
    {
        "ID": "13612",
        "NAME": "Walther von Walthersweil, Erhard (1525\u20131568)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1568",
        "PLACEOFBIRTH": "Leipzig",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13613",
        "NAME": "Walther von Walthersweil, Longin (1560\u20131624), Hofkriegsrat",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "13615",
        "NAME": "Walther von Walthersweil, Erhard (1590\u20131666)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1666",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13616",
        "NAME": "Walther von Walthersweil, Maria (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13617",
        "NAME": "Walther von Walthersweil, Jobst (1390\u20131450)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1450~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Memmingen"
    },
    {
        "ID": "13618",
        "NAME": "Walther von Walthersweil, Bernhard (1440\u20131504)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1504 Jun 19",
        "PLACEOFBIRTH": "Memmingen",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "13619",
        "NAME": "Walther von Walthersweil, Georg (1520\u20131582)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1582 Mar 20",
        "PLACEOFBIRTH": "Leipzig",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13620",
        "NAME": "Lodron, Philipp Jakob (1596\u20131671)",
        "DATEOFBIRTH": "1596 Apr 10",
        "DATEOFDEATH": "1671 Sep 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13621",
        "NAME": "Lodron, Dorothea (1619\u20131666)",
        "DATEOFBIRTH": "1619 Jan 22",
        "DATEOFDEATH": "1666 Mai 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kromau in M\u00e4hren"
    },
    {
        "ID": "13622",
        "NAME": "Lodron, Z\u00e4zilia (1622\u20131658)",
        "DATEOFBIRTH": "1622",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13623",
        "NAME": "Lodron, Theresia (1625\u20131675)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1675~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13624",
        "NAME": "Arco, Elisabeth (1607\u20131632)",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13625",
        "NAME": "Arco, Olivia (1610\u20131634)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1634 Mai 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "13626",
        "NAME": "Lodron, Paris (1620\u20131693)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1693",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13627",
        "NAME": "Lodron, Ferdinand Philipp (1660\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13628",
        "NAME": "Serbelloni, Friedrich (1629\u20131667)",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1667 Okt 04",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "13629",
        "NAME": "Jessen, Johann (1566\u20131621), Hofarzt",
        "DATEOFBIRTH": "1566 Dez 27",
        "DATEOFDEATH": "1621 Jun 21",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13630",
        "NAME": "Wratislaw von Mitrowitz, Adam Leopold (1608\u20131658)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1658 Aug 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13631",
        "NAME": "Wratislaw von Mitrowitz, Wenzel Ignaz (1645\u20131727)",
        "DATEOFBIRTH": "1645 Sep 22",
        "DATEOFDEATH": "1727 Mai 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13632",
        "NAME": "Wratislaw von Mitrowitz, Katharina Barbara (1640\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13633",
        "NAME": "Jankovich von Prib\u00e9r, Johann (1600\u20131654)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1654",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Limbach an der Mur"
    },
    {
        "ID": "13634",
        "NAME": "Mikulich von Brukonovcz, Eva (1615\u20131663)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13635",
        "NAME": "Wolski, Stenzel (1523\u20131566)",
        "DATEOFBIRTH": "1523",
        "DATEOFDEATH": "1566 Sep 25",
        "PLACEOFBIRTH": "Podhajce",
        "PLACEOFDEATH": "Warszawa"
    },
    {
        "ID": "13636",
        "NAME": "Wolski, Niklas (1553\u20131630), Mundschenk",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1630 Mar 09",
        "PLACEOFBIRTH": "Podhajce",
        "PLACEOFDEATH": "Przemy\u015bl"
    },
    {
        "ID": "13637",
        "NAME": "W\u00fcrben, Elisabeth (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13638",
        "NAME": "Przehorzowsky von Quassejowitz, Franz Karl (1645\u20131723), Statthalter von B\u00f6hmen",
        "DATEOFBIRTH": "1645",
        "DATEOFDEATH": "1723 Nov 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13639",
        "NAME": "Blarer von Wartensee, Sabina (\u00a0\u00a0\u00a0\u00a0\u20131586)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13640",
        "NAME": "Herberstein, Ruprecht (1545\u20131612), Oberststallmeister",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1612 Okt 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sierndorf in der Stockerau"
    },
    {
        "ID": "13641",
        "NAME": "Herberstein, Leonhard (1581\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1581 Mai 18",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13642",
        "NAME": "Herberstein, Johann Wilhelm (1590\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1659",
        "PLACEOFBIRTH": "Windenau an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13643",
        "NAME": "Herberstein, Ferdinand (1582\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1582 Jan 22",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13644",
        "NAME": "Herberstein, Gotthard (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13645",
        "NAME": "Arco, Vinciguerra (1490\u20131547)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1547",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13646",
        "NAME": "Arco, Vinciguerra (1535\u20131594)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13647",
        "NAME": "Arco, Oliver (1540\u20131586)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13648",
        "NAME": "Arco, Judith (1568\u20131639)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13649",
        "NAME": "Arco, Margarita (1565\u20131620)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1620",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13650",
        "NAME": "Geizkofler von Reifenegg, Zacharias (1560\u20131617), Reichspfennigmeister",
        "DATEOFBIRTH": "1560 Nov 01",
        "DATEOFDEATH": "1617 Mai 08",
        "PLACEOFBIRTH": "Brixen am Eisack",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13651",
        "NAME": "Althan, Michael Johann (1679\u20131722), K\u00e4mmerer",
        "DATEOFBIRTH": "1679 Okt 08",
        "DATEOFDEATH": "1722 Mar 26",
        "PLACEOFBIRTH": "Jaroslavice in M\u00e4hren",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13652",
        "NAME": "Hohenems, Mark Sittich (1533\u20131595), Bischof von Konstanz",
        "DATEOFBIRTH": "1533 Aug 19",
        "DATEOFDEATH": "1595 Feb 15",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13653",
        "NAME": "Hohenems, Ruprecht (1566\u20131586)",
        "DATEOFBIRTH": "1566 Apr 20",
        "DATEOFDEATH": "1586 Nov 03",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13654",
        "NAME": "Hohenems, Johann Angel (1587\u20131620)",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1620 Okt 05",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13655",
        "NAME": "Hohenems, Peter (1607\u20131691), K\u00e4mmerer",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1691 Mar 15",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13656",
        "NAME": "Thanr\u00e4dl, Andreas (1572\u20131625)",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1625 Feb 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Leipzig:Paulinerkirche"
    },
    {
        "ID": "13657",
        "NAME": "Thanr\u00e4dl, Balthasar (1584\u20131638)",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Oedenburg"
    },
    {
        "ID": "13658",
        "NAME": "Thanr\u00e4dl, Georg (1611\u20131665)",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1665 Okt 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "13659",
        "NAME": "Manteuffel genannt Sz\u00f6ge, Eberhard (1590\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1590",
        "DATEOFDEATH": "1637 Dez 24",
        "PLACEOFBIRTH": "Katzdangen in Kurland",
        "PLACEOFDEATH": "K\u00f6nigsberg im Eulengebirge"
    },
    {
        "ID": "13660",
        "NAME": "Unverzagt, Georg (1515\u20131598)",
        "DATEOFBIRTH": "1515",
        "DATEOFDEATH": "1598 Jan 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13661",
        "NAME": "Oldenburg, Adolf (1600\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1600 Sep 15",
        "DATEOFDEATH": "1631 Sep 19",
        "PLACEOFBIRTH": "Gottorf",
        "PLACEOFDEATH": "Eilenburg"
    },
    {
        "ID": "13662",
        "NAME": "Manderscheid, Ferdinand Ludwig (1613\u20131671), K\u00e4mmerer",
        "DATEOFBIRTH": "1613",
        "DATEOFDEATH": "1671",
        "PLACEOFBIRTH": "Gerolstein in der Vulkaneifel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13663",
        "NAME": "Unverzagt, Wolfgang (1545\u20131605), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1605 Mar 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13664",
        "NAME": "Unverzagt, Maria Magdalena (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13665",
        "NAME": "Unverzagt, Johann Christoph (1575\u20131627)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1627 Feb 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13666",
        "NAME": "Unverzagt, Wolfgang Christoph (1600\u20131657), K\u00e4mmerer",
        "DATEOFBIRTH": "1600 Jan 13",
        "DATEOFDEATH": "1657 Jun 26",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13667",
        "NAME": "Unverzagt, Johann Wolfgang (1603\u20131636)",
        "DATEOFBIRTH": "1603 Mar 26",
        "DATEOFDEATH": "1636 Jun 10",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "13668",
        "NAME": "Unverzagt, Maria Elisabeth (1615\u20131679)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1679 Jul 11",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Krems an der Donau"
    },
    {
        "ID": "13669",
        "NAME": "Unverzagt, Klara Maximiliana (1623\u20131668)",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1668 Dez 01",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "13670",
        "NAME": "Teufel von Guntersdorf, Matthias (1485\u20131552)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1552",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Winzendorf am Steinfeld:Pfarrkirche"
    },
    {
        "ID": "13671",
        "NAME": "Teufel von Guntersdorf, Erasam (1515\u20131552)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1552 Aug 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Konstantinopel"
    },
    {
        "ID": "13672",
        "NAME": "Teufel von Guntersdorf, Christoph (1514\u20131570)",
        "DATEOFBIRTH": "1514",
        "DATEOFDEATH": "1570 Apr 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Winzendorf am Steinfeld:Pfarrkirche"
    },
    {
        "ID": "13673",
        "NAME": "Teufel von Guntersdorf, Georg Christoph (1558\u20131608)",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Winzendorf am Steinfeld:Pfarrkirche"
    },
    {
        "ID": "13674",
        "NAME": "Teufel von Guntersdorf, Wolfgang Matthias (1569\u20131587)",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1587 Sep 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Krakau"
    },
    {
        "ID": "13675",
        "NAME": "Payr von Kaldiff, Peter (1530\u2013\u00a0\u00a0\u00a0\u00a0), St\u00e4belmeister",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neumarkt in S\u00fcdtirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13676",
        "NAME": "Ungnad von Weissenwolff, Ludwig (1526\u20131584), Obersthofmarschall",
        "DATEOFBIRTH": "1526",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Klagenfurt am W\u00f6rthersee"
    },
    {
        "ID": "13677",
        "NAME": "Ungnad von Weissenwolff, Christoph (1527\u20131587), Ban von Kroatien",
        "DATEOFBIRTH": "1527",
        "DATEOFDEATH": "1587 Nov 06",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Erlau"
    },
    {
        "ID": "13678",
        "NAME": "Ungnad von Weissenwolff, Karl (1540\u20131599)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Gastein im Pongau"
    },
    {
        "ID": "13679",
        "NAME": "Ungnad von Weissenwolff, Simon (1545\u20131603)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Waldenstein im Lavanttal"
    },
    {
        "ID": "13680",
        "NAME": "Teuffenbach, Jakob (1475\u20131538)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1538 Mai 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Teufenbach im Murtal:Pfarrkirche"
    },
    {
        "ID": "13681",
        "NAME": "Teuffenbach, Franz (1516\u20131579)",
        "DATEOFBIRTH": "1516",
        "DATEOFDEATH": "1579 Jan 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sauerbrunn im Murtal"
    },
    {
        "ID": "13682",
        "NAME": "Teuffenbach, Karl (1560\u20131610)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1610",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13683",
        "NAME": "Manndorff, Johann (1480\u20131535)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1535 Mai 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Spittal an der Drau"
    },
    {
        "ID": "13684",
        "NAME": "Manndorff, Elisabeth (1519\u20131541)",
        "DATEOFBIRTH": "1519 Jun 10",
        "DATEOFDEATH": "1541 Jul 22",
        "PLACEOFBIRTH": "Ortenburg in K\u00e4rnten",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "13685",
        "NAME": "Trauttmansdorff, Georg Christoph (1596\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1659 Feb 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13686",
        "NAME": "Herberstein, Wilhelm (1525\u20131557), K\u00e4mmerer",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1557 Apr 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13687",
        "NAME": "Arco, Gerhard (1611\u20131655), K\u00e4mmerer",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1655",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13688",
        "NAME": "Arco, Maria (1565\u20131607)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1607 Sep 07",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": "Weitra im Waldviertel"
    },
    {
        "ID": "13689",
        "NAME": "Arco, Niklas (1550\u20131595), K\u00e4mmerer",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1595",
        "PLACEOFBIRTH": "Arco in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13690",
        "NAME": "Ampringen, Johann Kaspar (1619\u20131684), K\u00e4mmerer",
        "DATEOFBIRTH": "1619 Jan 19",
        "DATEOFDEATH": "1684 Sep 09",
        "PLACEOFBIRTH": "Kirchhofen im Breisgau",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "13691",
        "NAME": "Dietrichstein, Erasam (1556\u20131583), Truchsess",
        "DATEOFBIRTH": "1556 Dez 06",
        "DATEOFDEATH": "1583 Nov 30",
        "PLACEOFBIRTH": "Hollenburg an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13692",
        "NAME": "Attems, Ludwig (1523\u20131584)",
        "DATEOFBIRTH": "1523",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "G\u00f6rz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13693",
        "NAME": "Hofmann von Gr\u00fcnb\u00fchel, Johann Friedrich (1562\u20131617), Reichshofrat",
        "DATEOFBIRTH": "1562",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "Strechau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13694",
        "NAME": "Zichy, Paul (1640\u20131684), K\u00e4mmerer",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1684",
        "PLACEOFBIRTH": "Wei\u00dfbrunn in Ungarn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13695",
        "NAME": "Losenstein, Johann Wilhelm (1546\u20131601), Obersthofmarschall",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1601",
        "PLACEOFBIRTH": "Schallaburg",
        "PLACEOFDEATH": "Loosdorf"
    },
    {
        "ID": "13696",
        "NAME": "Rogendorf, Christoph (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510 Nov 19",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13697",
        "NAME": "Thun, Johann Jakob (1607\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1607 Okt 08",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13698",
        "NAME": "Thun, Maria (1609\u20131656)",
        "DATEOFBIRTH": "1609 Feb 03",
        "DATEOFDEATH": "1656 Dez 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13699",
        "NAME": "Thun, Maximilian (1610\u20131643)",
        "DATEOFBIRTH": "1610 Dez 12",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13700",
        "NAME": "Habsburg, Lassel (1440\u20131457), K\u00f6nig von Ungarn",
        "DATEOFBIRTH": "1440 Feb 22",
        "DATEOFDEATH": "1457 Nov 23",
        "PLACEOFBIRTH": "Komorn an der Donau",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13701",
        "NAME": "Piastowicz, Joachim Friedrich (1550\u20131602), Herzog in Schlesien",
        "DATEOFBIRTH": "1550 Sep 29",
        "DATEOFDEATH": "1602 Mar 25",
        "PLACEOFBIRTH": "Brieg",
        "PLACEOFDEATH": "Brieg"
    },
    {
        "ID": "13702",
        "NAME": "Piastowicz, Barbara Agnes (1593\u20131631)",
        "DATEOFBIRTH": "1593 Feb 24",
        "DATEOFDEATH": "1631 Jul 24",
        "PLACEOFBIRTH": "Ohlau",
        "PLACEOFDEATH": "Kemnitz im Riesengebirge"
    },
    {
        "ID": "13703",
        "NAME": "Schwendi von Hohenlandsberg, Wilhelm (1440\u20131506)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1506",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13704",
        "NAME": "Schwendi von Hohenlandsberg, Wilhelm (1470\u20131522)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1522 Jun 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13705",
        "NAME": "Schwendi von Hohenlandsberg, Wilhelm (1500\u20131558)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1558",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13706",
        "NAME": "Schwendi von Hohenlandsberg, Karl (1530\u20131589), Reichshofrat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13707",
        "NAME": "Schwendi von Hohenlandsberg, Rudland (1480\u20131525)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1525 Jun 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ulm an der Donau"
    },
    {
        "ID": "13708",
        "NAME": "Schwendi von Hohenlandsberg, Lazar (1522\u20131583)",
        "DATEOFBIRTH": "1522 Dez 17",
        "DATEOFDEATH": "1583 Mai 27",
        "PLACEOFBIRTH": "Biberach am Rotbach",
        "PLACEOFDEATH": "Kirchhofen im Breisgau"
    },
    {
        "ID": "13709",
        "NAME": "Piastowicz, Johann Christian (1591\u20131639), Herzog in Schlesien",
        "DATEOFBIRTH": "1591 Aug 28",
        "DATEOFDEATH": "1639 Dez 25",
        "PLACEOFBIRTH": "Ohlau",
        "PLACEOFDEATH": "Osterode in Preu\u00dfen"
    },
    {
        "ID": "13710",
        "NAME": "Piastowicz, Georg Rudolf (1595\u20131653), Herzog in Schlesien",
        "DATEOFBIRTH": "1595 Feb 01",
        "DATEOFDEATH": "1653 Jan 24",
        "PLACEOFBIRTH": "Ohlau",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "13711",
        "NAME": "Welz, Konrad (1320\u20131371)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "1371",
        "PLACEOFBIRTH": "Feistritz im Katschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13712",
        "NAME": "Welz, Wolfgang (1360\u20131416)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1416",
        "PLACEOFBIRTH": "Feistritz im Katschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13713",
        "NAME": "Welz, Konrad (1410\u20131478)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1478",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13714",
        "NAME": "Welz, Johann (1365\u20131429)",
        "DATEOFBIRTH": "1365~",
        "DATEOFDEATH": "1429",
        "PLACEOFBIRTH": "Feistritz im Katschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13715",
        "NAME": "Welz, Johann (1410\u20131491)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1491",
        "PLACEOFBIRTH": "Feistritz im Katschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13716",
        "NAME": "Welz, Ruprecht (1460\u20131525)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1525 Jul 03",
        "PLACEOFBIRTH": "Feistritz im Katschtal",
        "PLACEOFDEATH": "Schladming"
    },
    {
        "ID": "13717",
        "NAME": "Welz, Johann (1500\u20131557), Landeshauptmann von Krain",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1557",
        "PLACEOFBIRTH": "Spiegelfeld im M\u00fcrztal",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "13718",
        "NAME": "Welz, Ruprecht (1530\u20131574), Oberstj\u00e4germeister",
        "DATEOFBIRTH": "1530 Dez 27",
        "DATEOFDEATH": "1574 Jan 18",
        "PLACEOFBIRTH": "Spiegelfeld im M\u00fcrztal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13719",
        "NAME": "Welz, Ehrenreich (1560\u20131606)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1606 Jul 03",
        "PLACEOFBIRTH": "Spiegelfeld im M\u00fcrztal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13720",
        "NAME": "Welz, Gotthard (1588\u20131630), Truchsess",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1630",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13721",
        "NAME": "Welz, Johann Felix (1623\u20131659)",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1659",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13722",
        "NAME": "Welz, Gotthard Helfried (1654\u20131724), K\u00e4mmerer",
        "DATEOFBIRTH": "1654 Mar 19",
        "DATEOFDEATH": "1724 Aug 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13723",
        "NAME": "Welz, Georg Ruprecht (1565\u20131602)",
        "DATEOFBIRTH": "1565",
        "DATEOFDEATH": "1602 Nov 09",
        "PLACEOFBIRTH": "Spiegelfeld im M\u00fcrztal",
        "PLACEOFDEATH": "Kapfenberg"
    },
    {
        "ID": "13724",
        "NAME": "Welz, Johann (1566\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Spiegelfeld im M\u00fcrztal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13725",
        "NAME": "Welz, Bernhard (1573\u20131636)",
        "DATEOFBIRTH": "1573",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Spiegelfeld im M\u00fcrztal",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "13726",
        "NAME": "Welz, Christoph Reinprecht (1540\u20131577), Mundschenk",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1577 Dez 24",
        "PLACEOFBIRTH": "Spiegelfeld im M\u00fcrztal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13727",
        "NAME": "Welz, Anna (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Spiegelfeld im M\u00fcrztal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13728",
        "NAME": "Salamanca, Bernhard (1560\u20131614), K\u00e4mmerer",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1614",
        "PLACEOFBIRTH": "Ortenburg in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13729",
        "NAME": "Salamanca, Ferdinand (1580\u20131616), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Ortenburg in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13730",
        "NAME": "Teufel von Guntersdorf, Karl (1556\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1556",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "Guntersdorf im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13731",
        "NAME": "Teufel von Guntersdorf, Barbara (1593\u20131634)",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1634 Okt 03",
        "PLACEOFBIRTH": "Guntersdorf im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13732",
        "NAME": "Buttlar, Gotthard Wilhelm (1600\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1660 Jan 18",
        "PLACEOFBIRTH": "Goldingen in Kurland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13733",
        "NAME": "Enckevoirth, Hadrian (1603\u20131663), K\u00e4mmerer",
        "DATEOFBIRTH": "1603 Aug 20",
        "DATEOFDEATH": "1663 Jun 03",
        "PLACEOFBIRTH": "Diest in Brabant",
        "PLACEOFDEATH": "Lede\u010d an der Sasau"
    },
    {
        "ID": "13734",
        "NAME": "Enckevoirth, Ferdinand (1645\u20131710), K\u00e4mmerer",
        "DATEOFBIRTH": "1645",
        "DATEOFDEATH": "1710",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Grafenegg im Weinviertel"
    },
    {
        "ID": "13735",
        "NAME": "Hohenems, Maria Franziska (1649\u20131705)",
        "DATEOFBIRTH": "1649",
        "DATEOFDEATH": "1705 Feb 10",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": "Grafenegg im Weinviertel"
    },
    {
        "ID": "13736",
        "NAME": "Schwendi von Hohenlandsberg, Wilhelm (1557\u20131609)",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1609 Jan 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kientzheim im Elsass"
    },
    {
        "ID": "13737",
        "NAME": "Czeika von Olbramowitz, Johann (1560\u20131623)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "Kolin an der Elbe",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "13738",
        "NAME": "Czeika von Olbramowitz, Georg (1590\u20131618), Truchsess",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "Kolin an der Elbe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13739",
        "NAME": "Welz, Anna Maria (1525\u20131565)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1565 Jan 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13740",
        "NAME": "Attems, Johann Jakob (1592\u20131668), K\u00e4mmerer",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1668",
        "PLACEOFBIRTH": "Gradisch an der Isnitz",
        "PLACEOFDEATH": "Tanzenberg"
    },
    {
        "ID": "13741",
        "NAME": "Thun, Kaspar (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13742",
        "NAME": "Thun, Rudland (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13743",
        "NAME": "Thun, Christoph (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13744",
        "NAME": "Thun, Dorothea (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13745",
        "NAME": "Thun, Maximilian (1638\u20131701), K\u00e4mmerer",
        "DATEOFBIRTH": "1638 Aug 19",
        "DATEOFDEATH": "1701 Jul 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "13746",
        "NAME": "Thun, Johanna Katharina (1635\u20131688)",
        "DATEOFBIRTH": "1635 Sep 05",
        "DATEOFDEATH": "1688 Aug 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13747",
        "NAME": "Thun, Anna Magdalena (1633\u20131702)",
        "DATEOFBIRTH": "1633 Dez 16",
        "DATEOFDEATH": "1702 Feb 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "13748",
        "NAME": "Thun, Franz Siegmund (1639\u20131702), K\u00e4mmerer",
        "DATEOFBIRTH": "1639 Sep 01",
        "DATEOFDEATH": "1702 Mai 02",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Livorno"
    },
    {
        "ID": "13749",
        "NAME": "Thun, Romed Konstantin (1641\u20131700), K\u00e4mmerer",
        "DATEOFBIRTH": "1641 Mar 02",
        "DATEOFDEATH": "1700 Mai 01",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "13750",
        "NAME": "Thun, Johann Ernst (1643\u20131709), Erzbischof von Salzburg",
        "DATEOFBIRTH": "1643 Jul 03",
        "DATEOFDEATH": "1709 Apr 20",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "13751",
        "NAME": "Leyen von Argenschwang, Philipp Niklas (1600\u20131656), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1656 Aug 08",
        "PLACEOFBIRTH": "Argenschwang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13752",
        "NAME": "Gonzaga, Ludwig (1578\u20131626), Markgraf von Palazzolo",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "Palazzolo Vercellese",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13753",
        "NAME": "Losenstein, Georg Christoph (1589\u20131622), K\u00e4mmerer",
        "DATEOFBIRTH": "1589 Jun 19",
        "DATEOFDEATH": "1622",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13754",
        "NAME": "Galler von Schwanberg, Balthasar (1585\u20131638), Statthalter von Inner\u00f6sterreich",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1638 Aug 25",
        "PLACEOFBIRTH": "Schwanberg in der Steiermark",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13755",
        "NAME": "Galler von Schwanberg, Siegmund (1575\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Schwanberg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13756",
        "NAME": "Galler von Schwanberg, Georg Siegmund (1605\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13757",
        "NAME": "Galler von Schwanberg, Johann Jakob (1615\u20131660)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1660 Mai 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13758",
        "NAME": "Galler von Schwanberg, Maximilian Wilhelm (1645\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13759",
        "NAME": "Galler von Schwanberg, Johann Friedrich (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13760",
        "NAME": "Patrizi, Salder (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Siena",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13761",
        "NAME": "Patrizi, Johann (1580\u20131639)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Siena",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13762",
        "NAME": "Patrizi, Marian (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Siena",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13763",
        "NAME": "Patrizi, Salder (1610\u20131649)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "Siena",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13764",
        "NAME": "Castaldo, Karl (1460\u20131504)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1504",
        "PLACEOFBIRTH": "Nocera dei Pagani",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13765",
        "NAME": "Castaldo, Johann Baptist (1493\u20131563)",
        "DATEOFBIRTH": "1493",
        "DATEOFDEATH": "1563 Jan 06",
        "PLACEOFBIRTH": "Cava dei Tirreni",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "13766",
        "NAME": "Castaldo, Ferdinand (1520\u20131569)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "Cava dei Tirreni",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13767",
        "NAME": "Castaldo, Elisabeth (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Cava dei Tirreni",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13768",
        "NAME": "Castaldo, Johann Alfons (1520\u20131589), Trabantenhauptmann",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1589 Dez 31",
        "PLACEOFBIRTH": "Cava dei Tirreni",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "13769",
        "NAME": "Castaldo, Johann Baptist (1545\u20131571)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Cava dei Tirreni",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13770",
        "NAME": "Castaldo, Olivia (1554\u20131609)",
        "DATEOFBIRTH": "1554",
        "DATEOFDEATH": "1609 Aug 26",
        "PLACEOFBIRTH": "Cava dei Tirreni",
        "PLACEOFDEATH": "Vimercate"
    },
    {
        "ID": "13771",
        "NAME": "Antoniano, Franz (1550\u2013\u00a0\u00a0\u00a0\u00a0), Huschier",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13772",
        "NAME": "Lando, Oktavius (1520\u20131580), Hofdiener",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1580~",
        "PLACEOFBIRTH": "Piacenza",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13773",
        "NAME": "Provisionali, Edward (1530\u20131595), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1595~",
        "PLACEOFBIRTH": "Novellara",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13774",
        "NAME": "Olzignano, Terenz (1520\u20131580), Hofdiener",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1580~",
        "PLACEOFBIRTH": "Padua",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13775",
        "NAME": "Quarterio, Franz (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13776",
        "NAME": "Betta, Oktavius (1540\u20131584), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "Rovereid",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13777",
        "NAME": "Cassini, Niklas (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13778",
        "NAME": "Zenobi, Ludwig (1547\u20131602), Hofdiener",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "Ancona",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "13779",
        "NAME": "Detti, Karl (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ferrara",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13780",
        "NAME": "Cortereal, Hieronym (1533\u20131588), Hofdiener",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1588 Nov 16",
        "PLACEOFBIRTH": "Angra do Hero\u00edsmo",
        "PLACEOFDEATH": "\u00c9vora"
    },
    {
        "ID": "13781",
        "NAME": "Balbi, Bartlome (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13782",
        "NAME": "Bentivoglio, Kornel (1606\u20131663), K\u00e4mmerer",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1663 Dez 24",
        "PLACEOFBIRTH": "Ferrara",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13783",
        "NAME": "Crivelli, Julius (1575\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1647",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13784",
        "NAME": "V\u00f6ls, Kaspar (1420\u20131480)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1480",
        "PLACEOFBIRTH": "V\u00f6ls am Schlern",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13785",
        "NAME": "V\u00f6ls, Leonhard (1458\u20131530), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1458",
        "DATEOFDEATH": "1530",
        "PLACEOFBIRTH": "V\u00f6ls am Schlern",
        "PLACEOFDEATH": "Bozen"
    },
    {
        "ID": "13786",
        "NAME": "V\u00f6ls, Melchior (1490\u20131543)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13787",
        "NAME": "V\u00f6ls, Kaspar (1530\u20131577)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "\u017dalmanov"
    },
    {
        "ID": "13788",
        "NAME": "V\u00f6ls, Leonhard (1565\u20131620)",
        "DATEOFBIRTH": "1565",
        "DATEOFDEATH": "1620 Apr 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sitzendorf an der Schmida"
    },
    {
        "ID": "13789",
        "NAME": "V\u00f6ls, Kaspar (1594\u20131666)",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1666 Mar 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Oppeln"
    },
    {
        "ID": "13790",
        "NAME": "V\u00f6ls, Georg Leonhard (1625\u20131684), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1684 Mar 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "13791",
        "NAME": "V\u00f6ls, Friedrich (1575\u20131614)",
        "DATEOFBIRTH": "1575 Jul 25",
        "DATEOFDEATH": "1614 Apr 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Gabhorn"
    },
    {
        "ID": "13792",
        "NAME": "V\u00f6ls, Ferdinand (1520\u20131558)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1558",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13793",
        "NAME": "V\u00f6ls, Michael (1460\u20131528)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "V\u00f6ls am Schlern",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13794",
        "NAME": "V\u00f6ls, Gilg (1500\u20131546)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1546",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13795",
        "NAME": "V\u00f6ls, Karl (\u00a0\u00a0\u00a0\u00a0\u20131585)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "1585",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13796",
        "NAME": "V\u00f6ls, Christoph (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13797",
        "NAME": "V\u00f6ls, Anna (1560\u20131606)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13798",
        "NAME": "V\u00f6ls, Dorothea (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13799",
        "NAME": "V\u00f6ls, Johann Jakob (1505\u20131551), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1551 Feb 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bozen"
    },
    {
        "ID": "13801",
        "NAME": "Orefice, Anton (1506\u20131590)",
        "DATEOFBIRTH": "1506",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "Sorrento",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "13802",
        "NAME": "Orefice, Franz (1540\u20131607), Bischof von Acerno",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "Sorrento",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "13803",
        "NAME": "Orefice, Anton (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sorrento",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13804",
        "NAME": "Orefice, Johann (1608\u20131640), K\u00e4mmerer",
        "DATEOFBIRTH": "1608 Mar 13",
        "DATEOFDEATH": "1640 Jan 12",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "13807",
        "NAME": "Pio di Savoia, Askan (1586\u20131649)",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1649 Sep 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13808",
        "NAME": "Bourbon del Monte, Pompei (1560\u20131606)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "Monte Santa Maria Tiberina",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13809",
        "NAME": "Bourbon del Monte, Eleonora (1595\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Monte Santa Maria Tiberina",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13810",
        "NAME": "Bourbon del Monte, Hotze (1600\u20131629), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1629 Okt 16",
        "PLACEOFBIRTH": "Monte Santa Maria Tiberina",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "13811",
        "NAME": "Gonzaga, Julius (1552\u20131609), F\u00fcrst von Bozzolo",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "1609 Jun 23",
        "PLACEOFBIRTH": "San Martino dall\u2019Argine",
        "PLACEOFDEATH": "Bozzolo"
    },
    {
        "ID": "13812",
        "NAME": "Bergonzi, Arideas (1555\u20131620), St\u00e4belmeister",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1620~",
        "PLACEOFBIRTH": "Parma",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13813",
        "NAME": "Spinola, Vedast (1550\u20131612)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "Palermo",
        "PLACEOFDEATH": "Bruay in Artesien"
    },
    {
        "ID": "13814",
        "NAME": "Spinola, Niklas (1430\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13815",
        "NAME": "Spinola, Damian (1460\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13816",
        "NAME": "Spinola, Johann (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13817",
        "NAME": "Valperga, Widebald (1550\u20131605), K\u00e4mmerer",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1605 Mai 07",
        "PLACEOFBIRTH": "Masino",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "13818",
        "NAME": "Strasoldo, Hieronym (1590\u20131644), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13819",
        "NAME": "Spinola, Audobert (1160\u20131214)",
        "DATEOFBIRTH": "1160~",
        "DATEOFDEATH": "1214",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13820",
        "NAME": "Spinola, Wilhelm (1200\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1200~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13821",
        "NAME": "Spinola, Audobert (1235\u20131291)",
        "DATEOFBIRTH": "1235~",
        "DATEOFDEATH": "1291",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13822",
        "NAME": "Spinola, Edward (1270\u20131310)",
        "DATEOFBIRTH": "1270~",
        "DATEOFDEATH": "1310",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13823",
        "NAME": "Spinola, Galeas (1300\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1300~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13824",
        "NAME": "Spinola, Napoleon (1340\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13825",
        "NAME": "Spinola, Konrad (1380\u20131423)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1423",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13826",
        "NAME": "Spinola, Hektor (1420\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13827",
        "NAME": "Spinola, Philipp (1460\u20131524)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1524",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13828",
        "NAME": "Spinola, Augustin (1490\u20131565)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1565",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13829",
        "NAME": "Spinola, Oktavius (1538\u20131592), K\u00e4mmerer",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13830",
        "NAME": "Spinola, Karl (1564\u20131622)",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1622 Sep 10",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": "Nagasaki"
    },
    {
        "ID": "13831",
        "NAME": "Spinola, Audobert (1130\u20131183)",
        "DATEOFBIRTH": "1130~",
        "DATEOFDEATH": "1183",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13832",
        "NAME": "Spinola, Vedast (1165\u20131225)",
        "DATEOFBIRTH": "1165~",
        "DATEOFDEATH": "1225",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13833",
        "NAME": "Spinola, Lanfrank (1200\u20131249)",
        "DATEOFBIRTH": "1200~",
        "DATEOFDEATH": "1249",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13834",
        "NAME": "Spinola, Vedast (1230\u20131295)",
        "DATEOFBIRTH": "1230~",
        "DATEOFDEATH": "1295",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13835",
        "NAME": "Spinola, Lanfrank (1260\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1260~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13836",
        "NAME": "Spinola, Andreas (1290\u20131337)",
        "DATEOFBIRTH": "1290~",
        "DATEOFDEATH": "1337",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13837",
        "NAME": "Spinola, Friedrich (1320\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13838",
        "NAME": "Spinola, Anton (1350\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1350~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13839",
        "NAME": "Spinola, Ambros (1380\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13840",
        "NAME": "Spinola, Friedrich (1571\u20131603)",
        "DATEOFBIRTH": "1571",
        "DATEOFDEATH": "1603 Mai 26",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": "Sluis"
    },
    {
        "ID": "13841",
        "NAME": "Spinola, Galeas (1390\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13842",
        "NAME": "Spinola, Jakob (1420\u20131459)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1459",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13843",
        "NAME": "Spinola, Napoleon (1452\u20131512)",
        "DATEOFBIRTH": "1452",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13844",
        "NAME": "Spinola, Paul (1490\u20131529)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1529",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13845",
        "NAME": "Spinola, Stephan (1520\u20131579)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13846",
        "NAME": "Spinola, Napoleon (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13847",
        "NAME": "Spinola, Stephan (1580\u20131629)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13848",
        "NAME": "Spinola, Napoleon (1607\u20131672), Markgraf von Roccaforte",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": "Roccaforte Ligure"
    },
    {
        "ID": "13849",
        "NAME": "Spinola, Stephan (1633\u20131687)",
        "DATEOFBIRTH": "1633",
        "DATEOFDEATH": "1687",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13850",
        "NAME": "Spinola, Ambros (1420\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13851",
        "NAME": "Spinola, Anton (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13852",
        "NAME": "Spinola, Georg (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13853",
        "NAME": "Spinola, Mark Anton (1526\u20131604), Graf von Tassarolo",
        "DATEOFBIRTH": "1526",
        "DATEOFDEATH": "1604",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13854",
        "NAME": "Spinola, Augustin (1563\u20131616), Graf von Tassarolo",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13855",
        "NAME": "Spinola, Maximilian (1568\u20131629), Graf von Tassarolo",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13856",
        "NAME": "Spinola, Philipp (1606\u20131688), Graf von Tassarolo",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1688",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13857",
        "NAME": "Spinola, Johann Baptist (1580\u20131639)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13858",
        "NAME": "Spinola, Julius (1612\u20131691), Erzbischof von Laodikeia",
        "DATEOFBIRTH": "1612 Mai 13",
        "DATEOFDEATH": "1691 Mar 12",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13859",
        "NAME": "Spinola, Franz Maria (1615\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13860",
        "NAME": "Spinola, Johann Baptist (1646\u20131719), K\u00e4mmerer",
        "DATEOFBIRTH": "1646 Aug 04",
        "DATEOFDEATH": "1719 Mar 19",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13861",
        "NAME": "Spinola, Gerhard (1310\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1310~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13862",
        "NAME": "Spinola, Lauk (1340\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13863",
        "NAME": "Spinola, Alberich (1385\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1385~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13864",
        "NAME": "Spinola, Paul (1425\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13865",
        "NAME": "Spinola, Johann Anton (1460\u20131512)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13866",
        "NAME": "Spinola, Johann Baptist (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13867",
        "NAME": "Spinola, Johann Angel (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13868",
        "NAME": "Spinola, Julius (1566\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13869",
        "NAME": "Spinola, Philipp (1605\u20131680), Markgraf von Arquata",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1680",
        "PLACEOFBIRTH": "Arquata Scrivia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13870",
        "NAME": "Spinola, Julius (1640\u20131690), Reichshofrat",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1690",
        "PLACEOFBIRTH": "Arquata Scrivia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13871",
        "NAME": "Spinola, Gerhard (1647\u20131726), K\u00e4mmerer",
        "DATEOFBIRTH": "1647",
        "DATEOFDEATH": "1726",
        "PLACEOFBIRTH": "Arquata Scrivia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13872",
        "NAME": "Spinola, Widebald (1170\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1170~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13873",
        "NAME": "Spinola, Johann (1200\u20131268)",
        "DATEOFBIRTH": "1200~",
        "DATEOFDEATH": "1268",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13874",
        "NAME": "Spinola, Widebald (1230\u20131284)",
        "DATEOFBIRTH": "1230~",
        "DATEOFDEATH": "1284",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13875",
        "NAME": "Spinola, Albrecht (1260\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1260~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13876",
        "NAME": "Spinola, Johann (1290\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1290~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13877",
        "NAME": "Spinola, Zyprian (1320\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13878",
        "NAME": "Spinola, Luzian (1360\u20131421)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1421",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13879",
        "NAME": "Spinola, Zyprian (1400\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13880",
        "NAME": "Spinola, Peter (1430\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13881",
        "NAME": "Spinola, Cattaneo (1460\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13882",
        "NAME": "Spinola, Zyprian (1490\u20131563)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1563",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13883",
        "NAME": "Spinola, Hannibal (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Palermo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13884",
        "NAME": "Spinola, Niklas (1240\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1240~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13885",
        "NAME": "Perusi, Ludwig (1590\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1631 Jun 11",
        "PLACEOFBIRTH": "Valletta",
        "PLACEOFDEATH": "Greifswald"
    },
    {
        "ID": "13886",
        "NAME": "Crescenzi, Franz (1585\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1585 Sep 08",
        "DATEOFDEATH": "1648 Jan 24",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "13887",
        "NAME": "Altieri, Lorenz (1560\u20131635)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13888",
        "NAME": "Altieri, Emil (1590\u20131676), Papst Klement\u00a0X.",
        "DATEOFBIRTH": "1590 Jul 13",
        "DATEOFDEATH": "1676 Jul 22",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "13889",
        "NAME": "Altieri, Franz (1595\u20131644), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1644 Mai 07",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Ancona"
    },
    {
        "ID": "13890",
        "NAME": "Ursenbeck, Christoph (1520\u20131583), K\u00e4mmerer",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1583",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13891",
        "NAME": "Ursenbeck, Georg Bernhard (1598\u20131671), K\u00e4mmerer",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1671",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13892",
        "NAME": "Ursenbeck, Christoph David (1632\u2013\u00a0\u00a0\u00a0\u00a0), Geheimer Rat",
        "DATEOFBIRTH": "1632",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13893",
        "NAME": "Ursenbeck, Georg Gottfried (1635\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13894",
        "NAME": "Ursenbeck, Johann Christoph (1577\u20131629), K\u00e4mmerer",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1629 Nov 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "13895",
        "NAME": "Ursenbeck, Markward Christoph (1594\u20131624), K\u00e4mmerer",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13896",
        "NAME": "Ursenbeck, Georg Christoph (1579\u20131634)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Riegersburg in der Steiermark:Martinskirche"
    },
    {
        "ID": "13897",
        "NAME": "Ursenbeck, Georg Bernhard (1608\u20131633), Hofdiener",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1633",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Riegersburg in der Steiermark:Martinskirche"
    },
    {
        "ID": "13898",
        "NAME": "Ursenbeck, Georg Siegmund (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13899",
        "NAME": "Ursenbeck, Adam Gottfried (1605\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13900",
        "NAME": "Habsburg, Ernst (1553\u20131595), Statthalter der Spanischen Niederlande",
        "DATEOFBIRTH": "1553 Jun 15",
        "DATEOFDEATH": "1595 Feb 20",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "13901",
        "NAME": "T\u00e9llez Gir\u00f3n de Osuna, Kaspar (1625\u20131694), Vizek\u00f6nig von Katalonien",
        "DATEOFBIRTH": "1625 Mai 25",
        "DATEOFDEATH": "1694 Jun 02",
        "PLACEOFBIRTH": "Alameda de Osuna",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "13902",
        "NAME": "Salamanca, Johann Georg (1590\u20131639)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1639 Dez 08",
        "PLACEOFBIRTH": "Ortenburg in K\u00e4rnten",
        "PLACEOFDEATH": "Ortenburg in K\u00e4rnten"
    },
    {
        "ID": "13903",
        "NAME": "Salamanca, Bernhard (1530\u20131557)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1557",
        "PLACEOFBIRTH": "Ortenburg in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13904",
        "NAME": "Krusics, Johann (1525\u20131580)",
        "DATEOFBIRTH": "1525",
        "DATEOFDEATH": "1580 Jul 09",
        "PLACEOFBIRTH": "Lindenkogel in der Untersteiermark",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13905",
        "NAME": "Khevenh\u00fcller, Siegmund (1558\u20131594)",
        "DATEOFBIRTH": "1558 Nov 21",
        "DATEOFDEATH": "1594 Jun 01",
        "PLACEOFBIRTH": "Villach in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13906",
        "NAME": "Khevenh\u00fcller, Paul (1593\u20131655)",
        "DATEOFBIRTH": "1593 Apr 23",
        "DATEOFDEATH": "1655 Dez 09",
        "PLACEOFBIRTH": "Wernberg in K\u00e4rnten",
        "PLACEOFDEATH": "Stockholm"
    },
    {
        "ID": "13907",
        "NAME": "Khevenh\u00fcller, Siguna (1537\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1537 Mai 29",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pittersberg in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13908",
        "NAME": "Valencia, Alfons (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13909",
        "NAME": "Barragan, Ruderich (1575\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wasserburg an der G\u00fcnz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13910",
        "NAME": "Marradas, Franz (1563\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Valencia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13911",
        "NAME": "Thun, Barbara (1483\u20131509)",
        "DATEOFBIRTH": "1483",
        "DATEOFDEATH": "1509 Aug 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13912",
        "NAME": "Salm, Lukrezia (1526\u20131585)",
        "DATEOFBIRTH": "1526",
        "DATEOFDEATH": "1585",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13913",
        "NAME": "Salm, Margarita (1517\u20131573)",
        "DATEOFBIRTH": "1517",
        "DATEOFDEATH": "1573 Mar 19",
        "PLACEOFBIRTH": "Marchegg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13914",
        "NAME": "Redern, Anna (1544\u20131588)",
        "DATEOFBIRTH": "1544",
        "DATEOFDEATH": "1588 Aug 26",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Chomutov"
    },
    {
        "ID": "13915",
        "NAME": "Sulz, Elisabeth (1563\u20131601)",
        "DATEOFBIRTH": "1563 Mar 09",
        "DATEOFDEATH": "1601 Apr 24",
        "PLACEOFBIRTH": "Tiengen im Klettgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13916",
        "NAME": "Breunner, Ursula (1568\u20131641), Obersthofmeisterin",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1641",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Heiligenkreuz im Wippachtal"
    },
    {
        "ID": "13917",
        "NAME": "Frangipane, Elisabeth (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13918",
        "NAME": "Teufel von Guntersdorf, Katharina (1559\u20131594)",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1594 Apr 05",
        "PLACEOFBIRTH": "Guntersdorf im Weinviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13919",
        "NAME": "Lodron, Eleonora (1605\u20131655)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1655 Mar 20",
        "PLACEOFBIRTH": "Concesio",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13920",
        "NAME": "Collalto, Hippolyta (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13921",
        "NAME": "Arco, Lukrezia (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13922",
        "NAME": "Arco, Katharina (1585\u20131621)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13923",
        "NAME": "Collalto, Susanna (1460\u20131495)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1495 Sep 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Arco in Tirol"
    },
    {
        "ID": "13924",
        "NAME": "Arco, Drusilla (1490\u20131521)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1521",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13925",
        "NAME": "Schlick, Elisabeth (1560\u20131598)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Neudek an der Rohlau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13926",
        "NAME": "Trautson, Susanna (1560\u20131615)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1615 Apr 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neunkirchen am Steinfeld:Pfarrkirche"
    },
    {
        "ID": "13927",
        "NAME": "Ungnad von Weissenwolff, Judith (1528\u20131572)",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1572 Mar 08",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13928",
        "NAME": "Lochner von Liebenfels, Margarita (1475\u20131528), Obersthofmeisterin",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "Liebenfels in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13929",
        "NAME": "Ungnad von Weissenwolff, Elisabeth (1500\u20131575)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1575",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Radonitz"
    },
    {
        "ID": "13930",
        "NAME": "Barby, Magdalena (1530\u20131565)",
        "DATEOFBIRTH": "1530 Sep 22",
        "DATEOFDEATH": "1565 Nov 16",
        "PLACEOFBIRTH": "M\u00fchlingen an der Elbe",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13931",
        "NAME": "Trauttmansdorff, Eva (1548\u20131592)",
        "DATEOFBIRTH": "1548 Mai 28",
        "DATEOFDEATH": "1592 Mar 08",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Hof im Rosenthal"
    },
    {
        "ID": "13932",
        "NAME": "B\u00e1nffy von Losoncz, Euphrosina (1544\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1544",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Klausenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13933",
        "NAME": "B\u00e1nffy von Losoncz, Anna (1543\u20131595)",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1595 Feb 22",
        "PLACEOFBIRTH": "Klausenburg",
        "PLACEOFDEATH": "Szomolya"
    },
    {
        "ID": "13934",
        "NAME": "Ungnad von Weissenwolff, Anna (1564\u20131611)",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13935",
        "NAME": "Pernstein, Benigna (1517\u20131551)",
        "DATEOFBIRTH": "1517",
        "DATEOFDEATH": "1551",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13936",
        "NAME": "Pernstein, Anna (1525\u20131556)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1556",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13937",
        "NAME": "Sternberg, Eva Johanna (1621\u20131674)",
        "DATEOFBIRTH": "1621",
        "DATEOFDEATH": "1674 Dez 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Teinitz an der Radbusa"
    },
    {
        "ID": "13938",
        "NAME": "Lobkowicz, Maria Elisabeth (1649\u20131719)",
        "DATEOFBIRTH": "1649",
        "DATEOFDEATH": "1719",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13939",
        "NAME": "Lodron, Anna (1504\u20131530)",
        "DATEOFBIRTH": "1504",
        "DATEOFDEATH": "1530~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bleiburg in K\u00e4rnten"
    },
    {
        "ID": "13940",
        "NAME": "Welz, Anna Maria (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Frauenstein in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13941",
        "NAME": "Colloredo, Felizitas (1595\u20131650)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1650 Sep 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13942",
        "NAME": "Dietrichstein, Klara (1626\u20131667)",
        "DATEOFBIRTH": "1626 Sep 07",
        "DATEOFDEATH": "1667 Jan 28",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13943",
        "NAME": "Gall von Gallenstein, Sidonia (1585\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13944",
        "NAME": "Losenstein, Maria Katharina (1635\u20131691)",
        "DATEOFBIRTH": "1635",
        "DATEOFDEATH": "1691",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13945",
        "NAME": "Madrutsch, Ursula (1563\u20131626)",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "Issogne im Aostatal",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "13946",
        "NAME": "Madrutsch, Christina (1563\u20131624)",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "Issogne im Aostatal",
        "PLACEOFDEATH": "Nancy"
    },
    {
        "ID": "13947",
        "NAME": "Rogendorf, Elisabeth (1480\u20131550)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1550 Sep 28",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13948",
        "NAME": "Stadl, Felizitas (1582\u20131628)",
        "DATEOFBIRTH": "1582 Jul 07",
        "DATEOFDEATH": "1628 Mar 01",
        "PLACEOFBIRTH": "Riegersburg in der Steiermark",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13949",
        "NAME": "Stadl, Anna (1580\u20131653)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1653",
        "PLACEOFBIRTH": "Riegersburg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13950",
        "NAME": "Porcia, Anna Magdalena (1635\u20131664)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1664 Apr 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "13951",
        "NAME": "Madrutsch, Brigitta (1510\u20131576)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1576 Apr 27",
        "PLACEOFBIRTH": "Madrutsch",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "13952",
        "NAME": "Madrutsch, Helena (1564\u20131627)",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Issogne im Aostatal",
        "PLACEOFDEATH": "Riva del Garda"
    },
    {
        "ID": "13953",
        "NAME": "Frangipane di Veglia, Helena (1480\u20131525)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1525 Apr 25",
        "PLACEOFBIRTH": "Zengg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13954",
        "NAME": "Thurn, Anna (1505\u20131552)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1552",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13955",
        "NAME": "J\u00f6rger von Tollet, Magdalena (1619\u20131689)",
        "DATEOFBIRTH": "1619",
        "DATEOFDEATH": "1689",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Meran"
    },
    {
        "ID": "13956",
        "NAME": "J\u00f6rger von Tollet, Elisabeth (1610\u20131658)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13957",
        "NAME": "Ungnad von Weissenwolff, Maria Margarita (1633\u20131661)",
        "DATEOFBIRTH": "1633",
        "DATEOFDEATH": "1661",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13958",
        "NAME": "Talmberg, Elisabeth Eusebia (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13959",
        "NAME": "Rumpf, Barbara (1510\u20131569)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "Wullross im Gurktal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13960",
        "NAME": "Ungnad von Weissenwolff, Elisabeth (1603\u20131683)",
        "DATEOFBIRTH": "1603",
        "DATEOFDEATH": "1683",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Varel am Jadebusen"
    },
    {
        "ID": "13961",
        "NAME": "Thannhausen, Regina (1569\u20131624)",
        "DATEOFBIRTH": "1569 Jun 06",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13962",
        "NAME": "P\u00e1lffy, Katharina (1590\u20131639)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Bibersburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13963",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Susanna (1580\u20131608)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13964",
        "NAME": "Hofmann von Gr\u00fcnb\u00fchel, Anna (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gr\u00fcnb\u00fchel in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13965",
        "NAME": "Ungnad von Weissenwolff, Elisabeth (1576\u20131631)",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1631",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Ortenburg im Wolfachtal"
    },
    {
        "ID": "13966",
        "NAME": "Puchheim, Felizitas (1555\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13967",
        "NAME": "Puchheim, Barbara (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00f6llersdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13968",
        "NAME": "Hoyos, Elisabeth (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13969",
        "NAME": "Hoyos, Katharina (1515\u20131572)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1572",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13970",
        "NAME": "Ungnad von Weissenwolff, Polyxena (1510\u20131564)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1564 Dez 02",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "13971",
        "NAME": "Losenstein, Margarita (1520\u20131566)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1566",
        "PLACEOFBIRTH": "Schallaburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13972",
        "NAME": "Schaffgotsch, Ursula (1542\u20131587)",
        "DATEOFBIRTH": "1542 Sep 21",
        "DATEOFDEATH": "1587 Okt 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sorau"
    },
    {
        "ID": "13973",
        "NAME": "Waldstein, Eva (1565\u20131631)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1631 Mai 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Weikersheim im Taubertal"
    },
    {
        "ID": "13974",
        "NAME": "Schlick, Katharina (1564\u20131617)",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1617 Jul 29",
        "PLACEOFBIRTH": "Neudek an der Rohlau",
        "PLACEOFDEATH": "Reichenberg im Isergebirge"
    },
    {
        "ID": "13975",
        "NAME": "Traudisch, Anna Susanna (1625\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13976",
        "NAME": "Traudisch, Helena Maximiliana (1630\u20131700)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1700",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13977",
        "NAME": "Lobkowicz, Benigna (1569\u20131625)",
        "DATEOFBIRTH": "1569 Nov 13",
        "DATEOFDEATH": "1625 Okt 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13978",
        "NAME": "Ungnad von Weissenwolff, Barbara (1505\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13979",
        "NAME": "Lobkowicz, Ursula (1562\u20131600)",
        "DATEOFBIRTH": "1562",
        "DATEOFDEATH": "1600 Mai 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13980",
        "NAME": "Hohenems, Anna (1510\u20131543)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "Hohenems",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13981",
        "NAME": "Teufel von Guntersdorf, Apollonia (1545\u20131578)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1578",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13982",
        "NAME": "Rappach, Margarita (1475\u20131522)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1522 Jul 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "13983",
        "NAME": "Rottal, Maria Anna (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13984",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Maria (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13985",
        "NAME": "Arco, Virginia (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13986",
        "NAME": "Liechtenstein von Kastelkorn, Barbara (1612\u20131671), Obersthofmeisterin",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1671",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "13987",
        "NAME": "Liechtenstein von Kastelkorn, Barbara (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Leifers",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13988",
        "NAME": "Schutzbar genannt Milchling, Maria Magdalena (1575\u20131598)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Wilhermsdorf im Zenngrund",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13989",
        "NAME": "Waldstein, Maria (1535\u20131593)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1593 Mar 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Guntersdorf im Weinviertel"
    },
    {
        "ID": "13990",
        "NAME": "\u00c1lvarez de Toledo, Eleonora (1522\u20131562), Herzogin von Florenz",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "1562 Dez 17",
        "PLACEOFBIRTH": "Alba de Tormes",
        "PLACEOFDEATH": "Pisa"
    },
    {
        "ID": "13991",
        "NAME": "\u00c1lvarez de Toledo, Eleonora (1553\u20131576)",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1576 Jul 09",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": "Cafaggiolo del Mugello"
    },
    {
        "ID": "13992",
        "NAME": "B\u00e1thory, Niklas (1525\u20131584)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1584 Dez 17",
        "PLACEOFBIRTH": "Ecsed",
        "PLACEOFDEATH": "Ecsed"
    },
    {
        "ID": "13993",
        "NAME": "Paradeiser von Neuhaus, Achaz (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neuhaus in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13994",
        "NAME": "Paradeiser von Neuhaus, Siegmund (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neuhaus in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13995",
        "NAME": "Dietrichstein, Moritz (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13996",
        "NAME": "Carvajal, Antonia (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "13997",
        "NAME": "Arciszewski, Elias (1560\u20131630)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1630~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Schmiegel"
    },
    {
        "ID": "13998",
        "NAME": "Arciszewski, Christoph (1592\u20131656)",
        "DATEOFBIRTH": "1592 Dez 09",
        "DATEOFDEATH": "1656 Apr 07",
        "PLACEOFBIRTH": "Rogalin",
        "PLACEOFDEATH": "Danzig"
    },
    {
        "ID": "13999",
        "NAME": "Arciszewski, Elias (1590\u20131655), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1655~",
        "PLACEOFBIRTH": "Rogalin",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14000",
        "NAME": "Habsburg, Friedrich\u00a0III. (1415\u20131493), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1415 Sep 21",
        "DATEOFDEATH": "1493 Aug 19",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "14001",
        "NAME": "Raitenau, Johann Werner (1525\u20131593)",
        "DATEOFBIRTH": "1525",
        "DATEOFDEATH": "1593 Apr 04",
        "PLACEOFBIRTH": "Lochau am Bodensee",
        "PLACEOFDEATH": "Szombor"
    },
    {
        "ID": "14002",
        "NAME": "Raitenau, Wolfgang Theoderich (1559\u20131617), Erzbischof von Salzburg",
        "DATEOFBIRTH": "1559 Mar 26",
        "DATEOFDEATH": "1617 Jan 16",
        "PLACEOFBIRTH": "Lochau am Bodensee",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "14003",
        "NAME": "Raitenau, Johann Rudolf (1575\u20131633)",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1633 Mai 03",
        "PLACEOFBIRTH": "Lochau am Bodensee",
        "PLACEOFDEATH": "Gm\u00fcnd in K\u00e4rnten"
    },
    {
        "ID": "14004",
        "NAME": "Raitenau, Wolfgang Theoderich (1601\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1601",
        "DATEOFDEATH": "1639 Jun 06",
        "PLACEOFBIRTH": "Lochau am Bodensee",
        "PLACEOFDEATH": "Rosegg in K\u00e4rnten"
    },
    {
        "ID": "14005",
        "NAME": "Raitenau, Johann Werner (1571\u20131647)",
        "DATEOFBIRTH": "1571",
        "DATEOFDEATH": "1647 Jan 25",
        "PLACEOFBIRTH": "Lochau am Bodensee",
        "PLACEOFDEATH": "Konstanz im Hegau"
    },
    {
        "ID": "14006",
        "NAME": "Raitenau, Rudolf Hannibal (1632\u20131671)",
        "DATEOFBIRTH": "1632",
        "DATEOFDEATH": "1671 Jan 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Langenstein im Hegau"
    },
    {
        "ID": "14007",
        "NAME": "Raitenau, Klara (1565\u20131612)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1612 Okt 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kientzheim im Elsass"
    },
    {
        "ID": "14008",
        "NAME": "Raitenau, Jakob Hannibal (1563\u20131611), K\u00e4mmerer",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "1611 Jul 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14009",
        "NAME": "Raitenau, Helena (1595\u20131626)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14010",
        "NAME": "Raitenau, Jakobina (1590\u20131663)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14011",
        "NAME": "Welser von Zinnenberg, Franz (1497\u20131572)",
        "DATEOFBIRTH": "1497 Nov 02",
        "DATEOFDEATH": "1572 Okt 29",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Ravensburg im Schussental"
    },
    {
        "ID": "14012",
        "NAME": "Welser von Zinnenberg, Philippina (1530\u20131580)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1580 Apr 24",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Innsbruck:Silberne Kapelle"
    },
    {
        "ID": "14013",
        "NAME": "Cirksena, Eginhard (1462\u20131528)",
        "DATEOFBIRTH": "1462 Jan 16",
        "DATEOFDEATH": "1528 Feb 14",
        "PLACEOFBIRTH": "Greetsiel",
        "PLACEOFDEATH": "Emden in Ostfriesland"
    },
    {
        "ID": "14014",
        "NAME": "Cirksena, Johann (1506\u20131572)",
        "DATEOFBIRTH": "1506",
        "DATEOFDEATH": "1572 Jun 06",
        "PLACEOFBIRTH": "Berum",
        "PLACEOFDEATH": "Falkenburg an der G\u00f6hl"
    },
    {
        "ID": "14015",
        "NAME": "Cirksena, Maximilian (1542\u20131591)",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1591",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14016",
        "NAME": "Cirksena, Dorothea (1570\u20131604)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1604",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14017",
        "NAME": "Cirksena, Eginhard (1505\u20131540)",
        "DATEOFBIRTH": "1505 Aug 12",
        "DATEOFDEATH": "1540 Sep 24",
        "PLACEOFBIRTH": "Greetsiel",
        "PLACEOFDEATH": "Emden in Ostfriesland"
    },
    {
        "ID": "14018",
        "NAME": "Cirksena, Eginhard (1532\u20131599)",
        "DATEOFBIRTH": "1532 Jun 24",
        "DATEOFDEATH": "1599 Mar 01",
        "PLACEOFBIRTH": "Greetsiel",
        "PLACEOFDEATH": "Aurich in Ostfriesland"
    },
    {
        "ID": "14019",
        "NAME": "Cirksena, Johann (1566\u20131625)",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "1625 Jan 23",
        "PLACEOFBIRTH": "Aurich in Ostfriesland",
        "PLACEOFDEATH": "Rietberg:Franziskanerkirche"
    },
    {
        "ID": "14020",
        "NAME": "Freymon von Randeck, Johann Wolfgang (1546\u20131610), Reichsvizekanzler",
        "DATEOFBIRTH": "1546 Mar 14",
        "DATEOFDEATH": "1610 Nov 10",
        "PLACEOFBIRTH": "Ingolstadt",
        "PLACEOFDEATH": "Randeck an der Altm\u00fchl"
    },
    {
        "ID": "14021",
        "NAME": "Stotzingen, Elisabeth (1585\u20131624)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1624 Aug 14",
        "PLACEOFBIRTH": "Wimpassing an der Leitha",
        "PLACEOFDEATH": "Murstetten"
    },
    {
        "ID": "14022",
        "NAME": "Sternberg, Eva Elisabeth (1606\u20131668)",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1668 Mar 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14023",
        "NAME": "P\u00fcchler von Weitenegg, Leonhard (1520\u20131567), Hofkammerrat",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14024",
        "NAME": "P\u00fcchler von Weitenegg, Magdalena (1550\u20131588)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wimpassing an der Leitha"
    },
    {
        "ID": "14025",
        "NAME": "Viehauser, Siegmund (1538\u20131587), Reichsvizekanzler",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1587 Apr 23",
        "PLACEOFBIRTH": "Landau an der Isar",
        "PLACEOFDEATH": "Lauterbach in der Hallertau"
    },
    {
        "ID": "14026",
        "NAME": "Gavre, Jakob (1465\u20131537)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1537 Aug 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Friesen in Brabant"
    },
    {
        "ID": "14027",
        "NAME": "Weber von Retz, Johann Baptist (1526\u20131584), Reichsvizekanzler",
        "DATEOFBIRTH": "1526 Aug 29",
        "DATEOFDEATH": "1584 Apr 23",
        "PLACEOFBIRTH": "Memmingen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14028",
        "NAME": "Weber von Retz, Johann Baptist (1555\u20131591), Reichshofrat",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1591 Mai 08",
        "PLACEOFBIRTH": "Ingolstadt",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14029",
        "NAME": "Weber von Retz, Johann Baptist (1587\u20131643), K\u00e4mmerer",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1643 Mai 23",
        "PLACEOFBIRTH": "Retz im Weinviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14030",
        "NAME": "Gera, Johann Christoph (1550\u20131609), K\u00e4mmerer",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1609 Sep 12",
        "PLACEOFBIRTH": "Arnfels",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "14031",
        "NAME": "Gera, Erasam (1510\u20131567), Hofkammerrat",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1567 Sep 29",
        "PLACEOFBIRTH": "Arnfels",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14032",
        "NAME": "Gera, Karl (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Arnfels",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14033",
        "NAME": "Gera, Erasam (1588\u20131657), K\u00e4mmerer",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1657 Sep 14",
        "PLACEOFBIRTH": "Arnfels",
        "PLACEOFDEATH": "Steyr:Pfarrkirche"
    },
    {
        "ID": "14034",
        "NAME": "Gera, Johann Siegmund (1660\u20131684)",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "1684",
        "PLACEOFBIRTH": "Eschelberg",
        "PLACEOFDEATH": "Neuh\u00e4usel im Donautiefland"
    },
    {
        "ID": "14035",
        "NAME": "Gera, Johann Otto (1675\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1675~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Eschelberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14036",
        "NAME": "Vetterl genannt Putz, Christoph Ulrich (1595\u20131662), Hofquartiermeister",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1662",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Mistelbach an der Zaya"
    },
    {
        "ID": "14037",
        "NAME": "Wenzel von Wenzelsberg, Johann (1570\u20131640), Reichshoffiskal",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1640~",
        "PLACEOFBIRTH": "Witzenhausen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14038",
        "NAME": "Wenzel von Wenzelsberg, Johann Kunibert (1610\u20131684), Hofquartiermeister",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1684",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14039",
        "NAME": "Wonsheim, Jakob (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14040",
        "NAME": "Reifferscheid, Anna Katharina (1624\u20131691)",
        "DATEOFBIRTH": "1624 Nov 04",
        "DATEOFDEATH": "1691 Nov 16",
        "PLACEOFBIRTH": "Reifferscheid in der Eifel",
        "PLACEOFDEATH": "Essen an der Ruhr"
    },
    {
        "ID": "14041",
        "NAME": "Cirksena, Johann (1618\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1618 Mai 31",
        "DATEOFDEATH": "1660 Aug 07",
        "PLACEOFBIRTH": "Esens",
        "PLACEOFDEATH": "Rietberg:Franziskanerkirche"
    },
    {
        "ID": "14042",
        "NAME": "Cirksena, Ferdinand Maximilian (1653\u20131687)",
        "DATEOFBIRTH": "1653 Mai 08",
        "DATEOFDEATH": "1687 Jun 10",
        "PLACEOFBIRTH": "Rietberg",
        "PLACEOFDEATH": "Rietberg:Franziskanerkirche"
    },
    {
        "ID": "14043",
        "NAME": "Cirksena, Maria Ernestina Franziska (1687\u20131758)",
        "DATEOFBIRTH": "1687 Aug 05",
        "DATEOFDEATH": "1758 Jan 01",
        "PLACEOFBIRTH": "Rietberg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14044",
        "NAME": "Kaunitz, Maximilian Ulrich (1679\u20131746), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1679 Mar 27",
        "DATEOFDEATH": "1746 Sep 10",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "14045",
        "NAME": "Rantzau, Heinrich (1590\u20131644)",
        "DATEOFBIRTH": "1590",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "Schmoel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14046",
        "NAME": "Rantzau, Christoph (1623\u20131696), Reichshofrat",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1696 Jan 16",
        "PLACEOFBIRTH": "Schmoel",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "14047",
        "NAME": "Rantzau, Peter (1625\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1672 Jan 29",
        "PLACEOFBIRTH": "Schmoel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14048",
        "NAME": "Khevenh\u00fcller, Franziska (1635\u20131702)",
        "DATEOFBIRTH": "1635 Dez 01",
        "DATEOFDEATH": "1702 Nov 21",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14049",
        "NAME": "Pallingen, Matthias (1600\u20131657), Hofkammerrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1657 Dez 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14050",
        "NAME": "Windischgr\u00e4tz, Ernst Friedrich (1670\u20131727), Reichshofrat",
        "DATEOFBIRTH": "1670 Jun 20",
        "DATEOFDEATH": "1727 Sep 06",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Sankt Peter in der Au"
    },
    {
        "ID": "14051",
        "NAME": "Kaiserstein, Johann (1550\u20131608)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "14052",
        "NAME": "Kaiserstein, Johann Helfried (1580\u20131634)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1634 Sep 06",
        "PLACEOFBIRTH": "Neustadt im Steinfeld",
        "PLACEOFDEATH": "N\u00f6rdlingen im Ries"
    },
    {
        "ID": "14053",
        "NAME": "Kaiserstein, Tobias Helfried (1590\u20131657), Hofkammerrat",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1657 Mai 08",
        "PLACEOFBIRTH": "Neustadt im Steinfeld",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14054",
        "NAME": "Kaiserstein, Johann Paul (1615\u20131696)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1696 Feb 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14055",
        "NAME": "Kaiserstein, Johann Georg (1630\u20131677)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1677 Nov 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14056",
        "NAME": "Kaiserstein, Johann Ignaz (1635\u20131678)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14057",
        "NAME": "Kaiserstein, Franz Ernst (1640\u20131695)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1695",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14058",
        "NAME": "Kaiserstein, Tobias Helfried (1625\u20131689), Mundschenk",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1689 Apr 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14059",
        "NAME": "Kaiserstein, Johann Franz (1620\u20131690)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1690",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14060",
        "NAME": "Kaiserstein, Theresia (1645\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14061",
        "NAME": "Mansfeld, Karl Adam (1629\u20131662), K\u00e4mmerer",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1662 Mai 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hamburg"
    },
    {
        "ID": "14062",
        "NAME": "Mansfeld, Ernst (1479\u20131531)",
        "DATEOFBIRTH": "1479 Dez 06",
        "DATEOFDEATH": "1531 Mai 09",
        "PLACEOFBIRTH": "Heldrungen",
        "PLACEOFDEATH": "Heldrungen"
    },
    {
        "ID": "14063",
        "NAME": "Mansfeld, Philipp (1502\u20131546), Vorschneider",
        "DATEOFBIRTH": "1502",
        "DATEOFDEATH": "1546 Jul 09",
        "PLACEOFBIRTH": "Heldrungen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14064",
        "NAME": "Mansfeld, Bruno (1545\u20131615), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1545 Nov 17",
        "DATEOFDEATH": "1615 Apr 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Eisleben"
    },
    {
        "ID": "14065",
        "NAME": "Mansfeld, Peter Ernst (1517\u20131604)",
        "DATEOFBIRTH": "1517 Aug 12",
        "DATEOFDEATH": "1604 Mai 23",
        "PLACEOFBIRTH": "Heldrungen",
        "PLACEOFDEATH": "Clausen in Luxemburg"
    },
    {
        "ID": "14066",
        "NAME": "Mansfeld, Karl (1543\u20131595), Oberbefehlshaber der Streitkr\u00e4fte",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1595 Aug 24",
        "PLACEOFBIRTH": "Mechelen",
        "PLACEOFDEATH": "Komorn an der Donau"
    },
    {
        "ID": "14067",
        "NAME": "Mansfeld, Dorothea (1562\u20131586)",
        "DATEOFBIRTH": "1562",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Groningen"
    },
    {
        "ID": "14068",
        "NAME": "Mansfeld, Franz Maximilian (1639\u20131692), Obersthofmeister",
        "DATEOFBIRTH": "1639 Nov 22",
        "DATEOFDEATH": "1692 Sep 12",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14069",
        "NAME": "Mansfeld, Heinrich Franz (1640\u20131715), Obersthofmarschall",
        "DATEOFBIRTH": "1640 Nov 21",
        "DATEOFDEATH": "1715 Jun 08",
        "PLACEOFBIRTH": "Bornstedt im Harz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14070",
        "NAME": "Mansfeld, Ernst (1580\u20131626)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1626 Nov 29",
        "PLACEOFBIRTH": "Oberstadt in Luxemburg",
        "PLACEOFDEATH": "Rakovica in Bosnien"
    },
    {
        "ID": "14072",
        "NAME": "Paar, Zeno (1430\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Parre in Val Seriana",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14073",
        "NAME": "Paar, Peter (1465\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14074",
        "NAME": "Paar, Peter (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14075",
        "NAME": "Paar, Peter (1540\u20131582)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1582",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "14076",
        "NAME": "Paar, Karl (1615\u20131661), K\u00e4mmerer",
        "DATEOFBIRTH": "1615 Aug 30",
        "DATEOFDEATH": "1661",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14077",
        "NAME": "Paar, Julius (1567\u20131615), K\u00e4mmerer",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14078",
        "NAME": "Paar, Reimund (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14079",
        "NAME": "Paar, Martin (1500\u20131567), Landespostmeister von Ungarn",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1567 Jun 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kaschau"
    },
    {
        "ID": "14080",
        "NAME": "Schwarzmann von Schwarzenthal, Otto (1571\u20131640), Reichshofrat",
        "DATEOFBIRTH": "1571",
        "DATEOFDEATH": "1640",
        "PLACEOFBIRTH": "Hone an der Wehre",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14081",
        "NAME": "Schellart von Obbendorf, Adam Wilhelm (1594\u20131627)",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1627 Okt 12",
        "PLACEOFBIRTH": "G\u00fcrzenich",
        "PLACEOFDEATH": "Rendsburg"
    },
    {
        "ID": "14082",
        "NAME": "Schellart von Obbendorf, Johann Albrecht (1619\u20131674), K\u00e4mmerer",
        "DATEOFBIRTH": "1619",
        "DATEOFDEATH": "1674",
        "PLACEOFBIRTH": "Obbendorf",
        "PLACEOFDEATH": "Doorwerth"
    },
    {
        "ID": "14083",
        "NAME": "Schellart von Obbendorf, Franz Kaspar (1628\u20131701), K\u00e4mmerer",
        "DATEOFBIRTH": "1628 Feb 05",
        "DATEOFDEATH": "1701 Mar 04",
        "PLACEOFBIRTH": "Obbendorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14084",
        "NAME": "Zimmern, Frowin Christoph (1519\u20131566)",
        "DATEOFBIRTH": "1519 Feb 19",
        "DATEOFDEATH": "1566 Nov 27",
        "PLACEOFBIRTH": "Mespelbrunn im Spessart",
        "PLACEOFDEATH": "Me\u00dfkirch an der Ablach"
    },
    {
        "ID": "14085",
        "NAME": "Zimmern, Wilhelm (1549\u20131594)",
        "DATEOFBIRTH": "1549 Jun 17",
        "DATEOFDEATH": "1594 Okt 09",
        "PLACEOFBIRTH": "Me\u00dfkirch an der Ablach",
        "PLACEOFDEATH": "Padua"
    },
    {
        "ID": "14086",
        "NAME": "Zimmern, Wilhelm Werner (1485\u20131575)",
        "DATEOFBIRTH": "1485 Jan 06",
        "DATEOFDEATH": "1575 Jan 07",
        "PLACEOFBIRTH": "Me\u00dfkirch an der Ablach",
        "PLACEOFDEATH": "Herrenzimmern"
    },
    {
        "ID": "14087",
        "NAME": "Paar, Johann Baptist (1540\u20131592), Landespostmeister von Inner\u00f6sterreich",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hartberg in der Steiermark"
    },
    {
        "ID": "14088",
        "NAME": "Paar, Johann Friedrich (1584\u20131620), K\u00e4mmerer",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1620~",
        "PLACEOFBIRTH": "Hartberg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14089",
        "NAME": "Paar, Peter (1620\u20131689)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1689",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14090",
        "NAME": "Paar, Joseph Ignaz (1660\u20131735), Obersthofmeister",
        "DATEOFBIRTH": "1660 Mai 31",
        "DATEOFDEATH": "1735 Dez 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14091",
        "NAME": "Paar, Vespasian (1591\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1635~",
        "PLACEOFBIRTH": "Hartberg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14092",
        "NAME": "Paar, Franz Ernst (1625\u20131673), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1673",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14093",
        "NAME": "Paar, Johann Christoph (1580\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Hartberg in der Steiermark",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14094",
        "NAME": "Paar, Johann Jakob (1618\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14095",
        "NAME": "Paar, Ferdinand (1616\u20131645), Mundschenk",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14096",
        "NAME": "Wopping, Sebastian Helfried (1599\u20131666), Obersthofmeister",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1666",
        "PLACEOFBIRTH": "Karpfham im Rottal",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14097",
        "NAME": "Wopping, Ferdinand Ludwig (1635\u20131692), Truchsess",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1692",
        "PLACEOFBIRTH": "Karpfham im Rottal",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14098",
        "NAME": "Sinold genannt Sch\u00fctz, Johann Helwig (1623\u20131677), Reichshofrat",
        "DATEOFBIRTH": "1623 Jun 25",
        "DATEOFDEATH": "1677 Jul 30",
        "PLACEOFBIRTH": "Gie\u00dfen an der Lahn",
        "PLACEOFDEATH": "Celle an der Aller"
    },
    {
        "ID": "14099",
        "NAME": "Wazenberg, Wolfgang Vinzenz (1635\u20131681), Truchsess",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1681 Okt 08",
        "PLACEOFBIRTH": "Laibach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14100",
        "NAME": "Rosenberg, Wilhelm (1535\u20131592), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1535 Mar 10",
        "DATEOFDEATH": "1592 Aug 31",
        "PLACEOFBIRTH": "Sitzendorf an der Schmida",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14101",
        "NAME": "Cirksena, Friedrich Wilhelm (1650\u20131677), K\u00e4mmerer",
        "DATEOFBIRTH": "1650 Sep 16",
        "DATEOFDEATH": "1677 Okt 07",
        "PLACEOFBIRTH": "Rietberg",
        "PLACEOFDEATH": "Stra\u00dfburg im Elsass"
    },
    {
        "ID": "14102",
        "NAME": "Paar, Julius (1610\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1654 Apr 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "14103",
        "NAME": "Paar, Peter (1535\u2013\u00a0\u00a0\u00a0\u00a0), Landespostmeister von Ungarn",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14104",
        "NAME": "Paar, Karl Joseph (1654\u20131725), K\u00e4mmerer",
        "DATEOFBIRTH": "1654 Mai 20",
        "DATEOFDEATH": "1725 Mai 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14105",
        "NAME": "Cirksena, Ernst Christoph (1606\u20131640), K\u00e4mmerer",
        "DATEOFBIRTH": "1606 Apr 01",
        "DATEOFDEATH": "1640 Dez 31",
        "PLACEOFBIRTH": "Esens",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "14106",
        "NAME": "Kaunitz, Wilhelm (1599\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14107",
        "NAME": "Liechtenstein von Nikolsburg, Katharina (1572\u20131643)",
        "DATEOFBIRTH": "1572 Nov 25",
        "DATEOFDEATH": "1643 Apr 16",
        "PLACEOFBIRTH": "Feldsberg im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14108",
        "NAME": "Liechtenstein von Nikolsburg, Elisabeth (1483\u20131517)",
        "DATEOFBIRTH": "1483",
        "DATEOFDEATH": "1517 Aug 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14109",
        "NAME": "Liechtenstein von Nikolsburg, Johann (1423\u20131473)",
        "DATEOFBIRTH": "1423",
        "DATEOFDEATH": "1473",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14110",
        "NAME": "Liechtenstein von Nikolsburg, Anna Maria (1597\u20131640)",
        "DATEOFBIRTH": "1597 Dez 07",
        "DATEOFDEATH": "1640 Apr 26",
        "PLACEOFBIRTH": "Feldsberg im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14111",
        "NAME": "Liechtenstein von Nikolsburg, Georg (1390\u20131444)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1444",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14112",
        "NAME": "Liechtenstein von Nikolsburg, Georg (1430\u20131484)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1484",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14113",
        "NAME": "Liechtenstein von Nikolsburg, Hartmann (1475\u20131539)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1539",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14114",
        "NAME": "Liechtenstein von Nikolsburg, Georg (1513\u20131562)",
        "DATEOFBIRTH": "1513",
        "DATEOFDEATH": "1562 Jul 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14115",
        "NAME": "Liechtenstein von Nikolsburg, Heinrich (1435\u20131483)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1483",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14116",
        "NAME": "Liechtenstein von Nikolsburg, Georg (1480\u20131548)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1548 Aug 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14117",
        "NAME": "Liechtenstein von Nikolsburg, Benigna (1510\u20131579)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1579 Sep 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14118",
        "NAME": "Morzin, Blessel (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14119",
        "NAME": "Morzin, Paul (1610\u20131688)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1688 Nov 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14120",
        "NAME": "Kaunitz, Dominik Andreas (1654\u20131705), Reichsvizekanzler",
        "DATEOFBIRTH": "1654 Nov 30",
        "DATEOFDEATH": "1705 Jan 11",
        "PLACEOFBIRTH": "Austerlitz in M\u00e4hren",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14121",
        "NAME": "Kaunitz, Eleonora (1681\u20131723)",
        "DATEOFBIRTH": "1681 Jan 17",
        "DATEOFDEATH": "1723 Mar 28",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14122",
        "NAME": "Hildebrand von Harssens, Meinhold (1560\u20131632), Hofkammerrat",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "Harssens",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14123",
        "NAME": "G\u00fcldenstern, Siegmund (1598\u20131666), K\u00e4mmerer",
        "DATEOFBIRTH": "1598 Okt 29",
        "DATEOFDEATH": "1666 Jun 30",
        "PLACEOFBIRTH": "Kalmar",
        "PLACEOFDEATH": "Danzig"
    },
    {
        "ID": "14124",
        "NAME": "Kuenburg, Johann Jakob (1548\u20131607), Obersthofmarschall",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1607 Jul 07",
        "PLACEOFBIRTH": "Moosham im Lungau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14125",
        "NAME": "Kuenburg, Reinprecht Moritz (1577\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14126",
        "NAME": "Kuenburg, Johann Ferdinand (1600\u20131641), K\u00e4mmerer",
        "DATEOFBIRTH": "1600 Jan 24",
        "DATEOFDEATH": "1641 Sep 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "14127",
        "NAME": "Kuenburg, Siegmund Ludwig (1629\u20131679), K\u00e4mmerer",
        "DATEOFBIRTH": "1629 Aug 03",
        "DATEOFDEATH": "1679 Aug 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14128",
        "NAME": "Kuenburg, Polykarp Wilhelm (1633\u20131675), Bischof von Gurk",
        "DATEOFBIRTH": "1633 Sep 04",
        "DATEOFDEATH": "1675 Jul 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "14129",
        "NAME": "Kuenburg, Johann Jakob (1635\u20131689), K\u00e4mmerer",
        "DATEOFBIRTH": "1635",
        "DATEOFDEATH": "1689",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14130",
        "NAME": "Kuenburg, Maximilian Gandolf (1622\u20131687), Erzbischof von Salzburg",
        "DATEOFBIRTH": "1622 Okt 31",
        "DATEOFDEATH": "1687 Mai 03",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "14131",
        "NAME": "Boyneburg, Heimrad (1340\u20131412)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "1412",
        "PLACEOFBIRTH": "Boyneburg im Ringgau",
        "PLACEOFDEATH": "Cornberg an der Sontra"
    },
    {
        "ID": "14132",
        "NAME": "Boyneburg, Hermann (1375\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1375~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14133",
        "NAME": "Boyneburg, Bernhard (1410\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14134",
        "NAME": "Boyneburg, Reinhard (1450\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14135",
        "NAME": "Boyneburg, Konrad (1494\u20131567), Hofkriegsrat",
        "DATEOFBIRTH": "1494",
        "DATEOFDEATH": "1567 Jun 29",
        "PLACEOFBIRTH": "Bischhausen an der Wehre",
        "PLACEOFDEATH": "Schelklingen"
    },
    {
        "ID": "14136",
        "NAME": "Boyneburg, Konrad (1531\u20131591)",
        "DATEOFBIRTH": "1531",
        "DATEOFDEATH": "1591 Apr 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Troyes"
    },
    {
        "ID": "14137",
        "NAME": "Boyneburg, Konrad (1552\u20131618), K\u00e4mmerer",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "1618 Okt 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wemding"
    },
    {
        "ID": "14138",
        "NAME": "Boyneburg, Johann Baptist (1589\u20131642), M\u00fcnzunternehmer in Langenargen",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Erolzheim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14139",
        "NAME": "Boyneburg, Johann Christian (1622\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1622 Apr 12",
        "DATEOFDEATH": "1672 Dez 08",
        "PLACEOFBIRTH": "Eisenach",
        "PLACEOFDEATH": "Mainz"
    },
    {
        "ID": "14140",
        "NAME": "Boyneburg, Philipp Wilhelm (1656\u20131717), Reichshofrat",
        "DATEOFBIRTH": "1656 Nov 21",
        "DATEOFDEATH": "1717 Feb 24",
        "PLACEOFBIRTH": "Mainz",
        "PLACEOFDEATH": "Erfurt"
    },
    {
        "ID": "14141",
        "NAME": "Boyneburg, Otto (1410\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14142",
        "NAME": "Boyneburg, Hermann (1445\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14143",
        "NAME": "Boyneburg, Rudolf (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14144",
        "NAME": "Boyneburg, Hartmann (1515\u20131558)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1558",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14145",
        "NAME": "Boyneburg, Christoph (1550\u20131614)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1614",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Coburg"
    },
    {
        "ID": "14146",
        "NAME": "Boyneburg, Johann Berthold (1585\u20131641), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1641",
        "PLACEOFBIRTH": "Coburg",
        "PLACEOFDEATH": "Neunburg vor dem Wald"
    },
    {
        "ID": "14147",
        "NAME": "Boyneburg, Karl (1620\u20131666)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1666 Okt 19",
        "PLACEOFBIRTH": "Erolzheim",
        "PLACEOFDEATH": "Erolzheim"
    },
    {
        "ID": "14148",
        "NAME": "Boyneburg, Konrad (1578\u20131626), K\u00e4mmerer",
        "DATEOFBIRTH": "1578 Sep 15",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "Wemding",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14149",
        "NAME": "Boyneburg, Johann Baptist (1617\u20131679), K\u00e4mmerer",
        "DATEOFBIRTH": "1617 Dez 17",
        "DATEOFDEATH": "1679 Okt 27",
        "PLACEOFBIRTH": "Erolzheim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14150",
        "NAME": "Boyneburg, Karl Ludwig (1651\u20131689), K\u00e4mmerer",
        "DATEOFBIRTH": "1651 Okt 18",
        "DATEOFDEATH": "1689 Nov 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "14151",
        "NAME": "Boyneburg, Sibylla (1625\u20131687), Obersthofmeisterin",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1687 Okt 15",
        "PLACEOFBIRTH": "Erolzheim",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14152",
        "NAME": "Boyneburg, Elisabeth (1630\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Erolzheim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14153",
        "NAME": "Elkerhausen genannt Kl\u00fcppel, Georg Wilhelm (1590\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1590",
        "DATEOFDEATH": "1654",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14154",
        "NAME": "Herberstorff, Franz (1515\u20131560)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1560~",
        "PLACEOFBIRTH": "Herberstorf am Waasen",
        "PLACEOFDEATH": "Herberstorf am Waasen:Allerheiligenkirche"
    },
    {
        "ID": "14155",
        "NAME": "Herberstorff, Andreas (1543\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1543 Nov 25",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Herberstorf am Waasen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14156",
        "NAME": "Herberstorff, Karl (1547\u20131606)",
        "DATEOFBIRTH": "1547 Dez 23",
        "DATEOFDEATH": "1606 Okt 05",
        "PLACEOFBIRTH": "Herberstorf am Waasen",
        "PLACEOFDEATH": "Ti\u0161ina"
    },
    {
        "ID": "14157",
        "NAME": "Herberstorff, Otto (1551\u20131601)",
        "DATEOFBIRTH": "1551 Aug 06",
        "DATEOFDEATH": "1601",
        "PLACEOFBIRTH": "Herberstorf am Waasen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14158",
        "NAME": "Herberstorff, Adam (1585\u20131629), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1585 Apr 15",
        "DATEOFDEATH": "1629 Sep 11",
        "PLACEOFBIRTH": "Kalsdorf an der Feistritz",
        "PLACEOFDEATH": "Ort am Traunsee"
    },
    {
        "ID": "14159",
        "NAME": "Herberstorff, Eleonora Katharina (1585\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Herberstorf am Waasen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14160",
        "NAME": "Winneburg, Philipp (1538\u20131583), Reichshofratspr\u00e4sident",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1583",
        "PLACEOFBIRTH": "Winneburg",
        "PLACEOFDEATH": "Speyer"
    },
    {
        "ID": "14161",
        "NAME": "Winneburg, Konrad (1564\u20131605), Reichshofratsvizepr\u00e4sident",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1605~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14162",
        "NAME": "Winneburg, Philipp (1570\u20131634), Reichshofrat",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Alzey"
    },
    {
        "ID": "14163",
        "NAME": "Winneburg, Anna (1565\u20131635)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1635 Sep 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Memmingen"
    },
    {
        "ID": "14164",
        "NAME": "Winneburg, Wilhelm (1575\u20131637)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14165",
        "NAME": "Zott von Pernegg, Christoph Philipp (1530\u20131579), Reichshofrat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1579 Jan 19",
        "PLACEOFBIRTH": "Pernegg an der Mur",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14166",
        "NAME": "Zott von Pernegg, Johann Christoph (1570\u20131611), Reichshofrat",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14167",
        "NAME": "Zimmern, Ursula (1564\u20131595)",
        "DATEOFBIRTH": "1564 Aug 29",
        "DATEOFDEATH": "1595 Mai 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14168",
        "NAME": "Rechberg, Johann Wilhelm (1582\u20131614)",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1614 Jan 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14169",
        "NAME": "Rechberg, Johann Rudolf (1606\u20131660), Propst von Ellwangen",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1660 Apr 06",
        "PLACEOFBIRTH": "Donzdorf",
        "PLACEOFDEATH": "Ellwangen an der Jagst"
    },
    {
        "ID": "14170",
        "NAME": "Gleispach, Siegmund Friedrich (1600\u20131678), Hofkriegsrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14171",
        "NAME": "Beck von Leopoldsdorf, Mark (1491\u20131553)",
        "DATEOFBIRTH": "1491 Apr 26",
        "DATEOFDEATH": "1553 Mar 20",
        "PLACEOFBIRTH": "Mengen in Schwaben",
        "PLACEOFDEATH": "Leopoldsdorf in der Feuchten Ebene"
    },
    {
        "ID": "14172",
        "NAME": "Beck von Leopoldsdorf, Hieronym (1525\u20131596), Hofkammerrat",
        "DATEOFBIRTH": "1525",
        "DATEOFDEATH": "1596 Nov 28",
        "PLACEOFBIRTH": "Leopoldsdorf in der Feuchten Ebene",
        "PLACEOFDEATH": "Ebreichsdorf"
    },
    {
        "ID": "14173",
        "NAME": "Beck von Leopoldsdorf, Mark (1572\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1631 Dez 16",
        "PLACEOFBIRTH": "Leopoldsdorf in der Feuchten Ebene",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14174",
        "NAME": "Salburg, Gottfried (1580\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1633 Sep 11",
        "PLACEOFBIRTH": "Falkenstein an der Ranna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14175",
        "NAME": "Salburg, Heinrich (1544\u20131629)",
        "DATEOFBIRTH": "1544",
        "DATEOFDEATH": "1629 Dez 15",
        "PLACEOFBIRTH": "Falkenstein an der Ranna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14176",
        "NAME": "Salburg, Johann Heinrich (1595\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1633 Mar 09",
        "PLACEOFBIRTH": "Falkenstein an der Ranna",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "14177",
        "NAME": "Salburg, Georg Siegmund (1600\u20131669), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1669 Mai 08",
        "PLACEOFBIRTH": "Falkenstein an der Ranna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14178",
        "NAME": "Salburg, Gotthard Heinrich (1639\u20131707), K\u00e4mmerer",
        "DATEOFBIRTH": "1639",
        "DATEOFDEATH": "1707 Jul 30",
        "PLACEOFBIRTH": "Falkenstein an der Ranna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14179",
        "NAME": "Salburg, Franz Ferdinand (1648\u20131712), K\u00e4mmerer",
        "DATEOFBIRTH": "1648",
        "DATEOFDEATH": "1712",
        "PLACEOFBIRTH": "Falkenstein an der Ranna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14180",
        "NAME": "K\u00f6nigsberg, Wolfgang Matthias (1582\u20131653), Hofkriegsrat",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1653",
        "PLACEOFBIRTH": "Seebenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14181",
        "NAME": "K\u00f6nigsegg, Ernst (1620\u20131660)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1660~",
        "PLACEOFBIRTH": "Aulendorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14182",
        "NAME": "Palant, Florent (1577\u20131639)",
        "DATEOFBIRTH": "1577 Mai 28",
        "DATEOFDEATH": "1639 Jun 02",
        "PLACEOFBIRTH": "Culemborg",
        "PLACEOFDEATH": "Culemborg"
    },
    {
        "ID": "14183",
        "NAME": "Cock, Hieronym (1530\u20131584), Hofsekret\u00e4r",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14184",
        "NAME": "Pottiers, Karl (1550\u20131615)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "Fenffe",
        "PLACEOFDEATH": "Revogne"
    },
    {
        "ID": "14185",
        "NAME": "Pottiers, Anna (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Fenffe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14186",
        "NAME": "Pottiers, Dionys (1590\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1659 Sep 02",
        "PLACEOFBIRTH": "Fenffe",
        "PLACEOFDEATH": "L\u00fcttich"
    },
    {
        "ID": "14187",
        "NAME": "Nassau, Johann (1536\u20131606)",
        "DATEOFBIRTH": "1536 Nov 22",
        "DATEOFDEATH": "1606 Okt 18",
        "PLACEOFBIRTH": "Dillenburg",
        "PLACEOFDEATH": "Dillenburg"
    },
    {
        "ID": "14188",
        "NAME": "Nassau, Johann Ludwig (1590\u20131653), K\u00e4mmerer",
        "DATEOFBIRTH": "1590 Aug 12",
        "DATEOFDEATH": "1653 Mar 06",
        "PLACEOFBIRTH": "Dillenburg",
        "PLACEOFDEATH": "Hadamar"
    },
    {
        "ID": "14189",
        "NAME": "Nassau, Johann (1561\u20131623)",
        "DATEOFBIRTH": "1561 Jun 07",
        "DATEOFDEATH": "1623 Okt 07",
        "PLACEOFBIRTH": "Dillenburg",
        "PLACEOFDEATH": "Siegen:F\u00fcrstengruft"
    },
    {
        "ID": "14190",
        "NAME": "Nassau, Johann (1583\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1583 Okt 09",
        "DATEOFDEATH": "1638 Jul 27",
        "PLACEOFBIRTH": "Dillenburg",
        "PLACEOFDEATH": "Renaix"
    },
    {
        "ID": "14191",
        "NAME": "D\u00f6nhoff, Theoderich (1610\u20131678), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "Drogosze",
        "PLACEOFDEATH": "Warszawa"
    },
    {
        "ID": "14192",
        "NAME": "Boyneburg, Anna Katharina (1615\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14193",
        "NAME": "Husmann von Namedy, Anton (1515\u20131580)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1580",
        "PLACEOFBIRTH": "Namedy",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14194",
        "NAME": "Husmann von Namedy, Johann Ludwig (1545\u20131615)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1615~",
        "PLACEOFBIRTH": "Namedy",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14195",
        "NAME": "Husmann von Namedy, Johann Wilhelm (1579\u20131651)",
        "DATEOFBIRTH": "1579 Jun 14",
        "DATEOFDEATH": "1651 Dez 01",
        "PLACEOFBIRTH": "Namedy",
        "PLACEOFDEATH": "Trier"
    },
    {
        "ID": "14196",
        "NAME": "Husmann von Namedy, Adolf (1560\u20131638)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "Namedy",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14197",
        "NAME": "Husmann von Namedy, Johann Philipp (1590\u20131651), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1651",
        "PLACEOFBIRTH": "Namedy",
        "PLACEOFDEATH": "Tachau an der Mies:Paulanerkirche"
    },
    {
        "ID": "14198",
        "NAME": "Husmann von Namedy, Wilhelm Reinhard (1595\u20131619)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1619 Okt 29",
        "PLACEOFBIRTH": "Namedy",
        "PLACEOFDEATH": "Hainburg an der Donau"
    },
    {
        "ID": "14199",
        "NAME": "Husmann von Namedy, Friedrich Ruprecht (1600\u20131669), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1669",
        "PLACEOFBIRTH": "Namedy",
        "PLACEOFDEATH": "Meran"
    },
    {
        "ID": "14200",
        "NAME": "Luxemburg, Siegmund\u00a0I. (1368\u20131437), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1368 Feb 15",
        "DATEOFDEATH": "1437 Dez 09",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "Znaim"
    },
    {
        "ID": "14201",
        "NAME": "Luxemburg, Elisabeth (1409\u20131442), K\u00f6nigin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1409 Feb 28",
        "DATEOFDEATH": "1442 Dez 19",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "14202",
        "NAME": "Habsburg, Elisabeth (1438\u20131505), K\u00f6nigin von Polen",
        "DATEOFBIRTH": "1438",
        "DATEOFDEATH": "1505 Aug 31",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Krakau"
    },
    {
        "ID": "14203",
        "NAME": "Rosenberger von Lerchenau, Johann Andreas (1600\u20131667)",
        "DATEOFBIRTH": "1600 Sep 07",
        "DATEOFDEATH": "1667 Jan 04",
        "PLACEOFBIRTH": "Sankt Andr\u00e4 im Lavanttal",
        "PLACEOFDEATH": "Klagenfurt am W\u00f6rthersee"
    },
    {
        "ID": "14204",
        "NAME": "Rosenberger von Lerchenau, Wolfgang Andreas (1626\u20131695), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1626 Feb 02",
        "DATEOFDEATH": "1695 Okt 21",
        "PLACEOFBIRTH": "Sankt Andr\u00e4 im Lavanttal",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14205",
        "NAME": "Rosenberger von Lerchenau, Franz Andreas (1653\u20131698), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1653 Apr 05",
        "DATEOFDEATH": "1698 Mar 22",
        "PLACEOFBIRTH": "Klagenfurt am W\u00f6rthersee",
        "PLACEOFDEATH": "Klagenfurt am W\u00f6rthersee"
    },
    {
        "ID": "14206",
        "NAME": "Gavre, Ludwig (1500\u20131560)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1560 Okt 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Friesen in Brabant"
    },
    {
        "ID": "14207",
        "NAME": "Gavre, Ludwig (1532\u20131596), Truchsess",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "Bergen im Hennegau",
        "PLACEOFDEATH": "Aymeries"
    },
    {
        "ID": "14208",
        "NAME": "Gavre, Karl (1536\u20131610)",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1610 Feb 17",
        "PLACEOFBIRTH": "Bergen im Hennegau",
        "PLACEOFDEATH": "Friesen in Brabant"
    },
    {
        "ID": "14209",
        "NAME": "Lucy, Widebald (1555\u20131597), Hofdiener",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "Th\u00e9zey Saint Martin",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14210",
        "NAME": "Enr\u00edquez de Ribera, Katharina (1575\u20131635)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1635 Nov 30",
        "PLACEOFBIRTH": "Sevilla",
        "PLACEOFDEATH": "Osuna in Andalusien"
    },
    {
        "ID": "14211",
        "NAME": "Gambe, Helena (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14212",
        "NAME": "Berka von der Duba, Anna (1591\u20131670)",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1670",
        "PLACEOFBIRTH": "Reichstadt in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14213",
        "NAME": "Lobkowicz, Hedwig (1555\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14214",
        "NAME": "Lobkowicz, Anna (1582\u20131603)",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1603 Apr 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14215",
        "NAME": "Wagen von Wagensperg, Regina (1600\u20131658)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14216",
        "NAME": "Breunner, Eleonora (1621\u20131684)",
        "DATEOFBIRTH": "1621",
        "DATEOFDEATH": "1684",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14217",
        "NAME": "Breunner, Konstantia (1622\u20131675)",
        "DATEOFBIRTH": "1622",
        "DATEOFDEATH": "1675",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14218",
        "NAME": "Rangoni, Julia (1625\u20131687)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1687",
        "PLACEOFBIRTH": "Modena",
        "PLACEOFDEATH": "Cremona"
    },
    {
        "ID": "14219",
        "NAME": "Althan, Anna (1579\u20131637)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "Murstetten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14220",
        "NAME": "Gavre, Johann Karl (1564\u20131629)",
        "DATEOFBIRTH": "1564 Jun 03",
        "DATEOFDEATH": "1629 Okt 04",
        "PLACEOFBIRTH": "Friesen in Brabant",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14221",
        "NAME": "Gavre, Klara Eugenia (1600\u20131676)",
        "DATEOFBIRTH": "1600 Aug 07",
        "DATEOFDEATH": "1676",
        "PLACEOFBIRTH": "Br\u00fcgge",
        "PLACEOFDEATH": "Fraustadt"
    },
    {
        "ID": "14222",
        "NAME": "Lobkowicz, Anna Benigna (1590\u20131639)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "14223",
        "NAME": "L\u00f6bl von Greinburg, Maria Sophia (1630\u20131676)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1676 Aug 23",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14224",
        "NAME": "Salm, Elisabeth (1520\u20131557)",
        "DATEOFBIRTH": "1520",
        "DATEOFDEATH": "1557 Mar 18",
        "PLACEOFBIRTH": "Marchegg",
        "PLACEOFDEATH": "Steyr"
    },
    {
        "ID": "14225",
        "NAME": "Herberstein, Anna (1516\u20131562)",
        "DATEOFBIRTH": "1516 Mai 27",
        "DATEOFDEATH": "1562",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14226",
        "NAME": "Hohenzollern, Anna (1603\u20131652)",
        "DATEOFBIRTH": "1603 Sep 08",
        "DATEOFDEATH": "1652 Aug 23",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "D\u00fcsseldorf"
    },
    {
        "ID": "14227",
        "NAME": "F\u00fcrstenberg, Anna Maria (1634\u20131705)",
        "DATEOFBIRTH": "1634 Sep 12",
        "DATEOFDEATH": "1705 Jan 01",
        "PLACEOFBIRTH": "Konstanz im Hegau",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14228",
        "NAME": "L\u00f6wenstein, Sophia (1664\u20131736)",
        "DATEOFBIRTH": "1664 Sep 26",
        "DATEOFDEATH": "1736 Sep 19",
        "PLACEOFBIRTH": "Wertheim am Main",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "14229",
        "NAME": "Dietrichstein, Ursula (1505\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14230",
        "NAME": "Kazianer von Katzenstein, Felizitas (1589\u20131615)",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1615 Sep 27",
        "PLACEOFBIRTH": "Katzenstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14231",
        "NAME": "Lochner von Liebenfels, Ursula (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14232",
        "NAME": "Attems, Margarita (1570\u20131595)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1595",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14233",
        "NAME": "Thun, Anna Maria (1664\u20131733)",
        "DATEOFBIRTH": "1664 Nov 26",
        "DATEOFDEATH": "1733 Okt 13",
        "PLACEOFBIRTH": "Salzburg",
        "PLACEOFDEATH": "Salzburg:Franziskanerkirche"
    },
    {
        "ID": "14234",
        "NAME": "Firmian, Margarita (1509\u20131548)",
        "DATEOFBIRTH": "1509",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "Kronmetz im Etschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14235",
        "NAME": "Schwendi von Hohenlandsberg, Eleonora (1599\u20131667)",
        "DATEOFBIRTH": "1599 Nov 02",
        "DATEOFDEATH": "1667 Feb 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Freiburg im Breisgau"
    },
    {
        "ID": "14236",
        "NAME": "L\u00f6bl von Greinburg, Maria Euphrosina (1625\u20131693)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1693 Jan 24",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "14237",
        "NAME": "Kokorzowa, Ludmila (1595\u20131661)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1661",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14238",
        "NAME": "Mansfeld, Sophia Agnes (1619\u20131677)",
        "DATEOFBIRTH": "1619 Nov 14",
        "DATEOFDEATH": "1677 Jan 20",
        "PLACEOFBIRTH": "Bornstedt im Harz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14239",
        "NAME": "Nassau, Elisabeth (1584\u20131661)",
        "DATEOFBIRTH": "1584 Nov 08",
        "DATEOFDEATH": "1661 Jul 26",
        "PLACEOFBIRTH": "Dillenburg",
        "PLACEOFDEATH": "Landau an der Watter"
    },
    {
        "ID": "14240",
        "NAME": "Hohenzollern, Sophia (1485\u20131537), Herzogin in Schlesien",
        "DATEOFBIRTH": "1485 Mar 10",
        "DATEOFDEATH": "1537 Mai 24",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "14241",
        "NAME": "Hohenzollern, Sophia (1535\u20131587), Herzogin in Schlesien",
        "DATEOFBIRTH": "1535 Mar 23",
        "DATEOFDEATH": "1587 Feb 22",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "14242",
        "NAME": "Wrzesowitz, Anna (1555\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14243",
        "NAME": "Starhemberg, Anna (1537\u20131597)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1597 Apr 26",
        "PLACEOFBIRTH": "Eferding",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14244",
        "NAME": "Schwindenhamer, Dorothea (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14245",
        "NAME": "Schencking, Elisabeth (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14246",
        "NAME": "R\u00e9vay, Elisabeth (1661\u20131732)",
        "DATEOFBIRTH": "1661",
        "DATEOFDEATH": "1732 Nov 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14247",
        "NAME": "Saurau, Magdalena (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ligist",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14248",
        "NAME": "Trautson, Elisabeth (1558\u20131603)",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1603 Apr 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14249",
        "NAME": "Concini, Gertraud (1578\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14250",
        "NAME": "Meggau, Susanna (1585\u20131648)",
        "DATEOFBIRTH": "1585",
        "DATEOFDEATH": "1648 Jan 13",
        "PLACEOFBIRTH": "Kreuzen im M\u00fchlviertel",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "14251",
        "NAME": "Schrattenbach, Katharina (1608\u20131642)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1642 Okt 16",
        "PLACEOFBIRTH": "Heggenberg in Krain",
        "PLACEOFDEATH": "Spittal an der Drau"
    },
    {
        "ID": "14252",
        "NAME": "Magnis, Anna (1594\u20131625)",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1625 Sep 15",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "14253",
        "NAME": "Borromeo, Hippolyta (1565\u20131598)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Arona am Lago Maggiore",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14254",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Margarita (1495\u20131530)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1530~",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14255",
        "NAME": "Tserclaes von Tilly, Margarita (1570\u20131634)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "Tilly in Brabant",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14256",
        "NAME": "Krusics, Helena (1561\u20131586)",
        "DATEOFBIRTH": "1561 Feb 09",
        "DATEOFDEATH": "1586 Sep 14",
        "PLACEOFBIRTH": "Lindenkogel in der Untersteiermark",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "14257",
        "NAME": "Dietrichstein, Franziska (1621\u20131685)",
        "DATEOFBIRTH": "1621",
        "DATEOFDEATH": "1685 Sep 16",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14258",
        "NAME": "Requesens, Maria (1510\u20131577), Oberstk\u00e4mmerin",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1577 Jan 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14259",
        "NAME": "Liechtenstein von Nikolsburg, Judith (1557\u20131581)",
        "DATEOFBIRTH": "1557 Feb 28",
        "DATEOFDEATH": "1581",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14260",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Anna (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14261",
        "NAME": "Ligne, Ernestina (1594\u20131663)",
        "DATEOFBIRTH": "1594 Nov 02",
        "DATEOFDEATH": "1663 Jan 04",
        "PLACEOFBIRTH": "Renaix",
        "PLACEOFDEATH": "Renaix"
    },
    {
        "ID": "14262",
        "NAME": "Nassau, Klara Maria (1621\u20131695)",
        "DATEOFBIRTH": "1621 Okt 07",
        "DATEOFDEATH": "1695 Sep 02",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Beloeil im Hennegau"
    },
    {
        "ID": "14263",
        "NAME": "Pernstein, Katharina (1534\u20131571)",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1571 Mai 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14264",
        "NAME": "Hoyos, Anna Regina (1620\u20131661)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1661 Nov 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pernegg an der Mur"
    },
    {
        "ID": "14265",
        "NAME": "Hoyos, Anna Maria (1549\u20131572)",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1572 Mar 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14266",
        "NAME": "Teufel von Guntersdorf, Anna Eusebia (1613\u20131644)",
        "DATEOFBIRTH": "1613 Dez 03",
        "DATEOFDEATH": "1644 Jul",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "14267",
        "NAME": "Pr\u00fcschenk von Hardegg, Sidonia (1608\u20131651)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1651 Aug 12",
        "PLACEOFBIRTH": "Wolfpassing am Wagram",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14268",
        "NAME": "Pernstein, Elisabeth (1560\u20131610)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1610 Aug 31",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14269",
        "NAME": "Draskovich, Julia (1640\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Drachenstein in Kroatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14270",
        "NAME": "Draskovich, Barbara (1629\u20131687)",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1687 Feb 26",
        "PLACEOFBIRTH": "Drachenstein in Kroatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14271",
        "NAME": "Thurn, Elisabeth Katharina (1632\u20131691)",
        "DATEOFBIRTH": "1632",
        "DATEOFDEATH": "1691 Feb 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14272",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Elisabeth (1532\u20131574)",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1574",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14273",
        "NAME": "Khevenh\u00fcller, Katharina (1585\u20131619)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "Spittal an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14274",
        "NAME": "Schlick, Walburga (1505\u20131575)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1575 Dez 24",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14275",
        "NAME": "Hofkirchen, Susanna (1580\u20131624)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "V\u00f6sendorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14276",
        "NAME": "Strein von Schwarzenau, Barbara (1490\u20131537)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1537 Mar 08",
        "PLACEOFBIRTH": "Schwarzenau im Waldviertel",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "14277",
        "NAME": "Althan, Justina (1578\u20131636)",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Murstetten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14278",
        "NAME": "Khevenh\u00fcller, Ursula (1536\u20131558)",
        "DATEOFBIRTH": "1536 Okt 12",
        "DATEOFDEATH": "1558 Mar 02",
        "PLACEOFBIRTH": "Spittal an der Drau",
        "PLACEOFDEATH": "Radmannsdorf in Krain"
    },
    {
        "ID": "14279",
        "NAME": "Khevenh\u00fcller, Anna (1541\u20131573)",
        "DATEOFBIRTH": "1541 Jul 16",
        "DATEOFDEATH": "1573 Apr 08",
        "PLACEOFBIRTH": "Neustadt im Steinfeld",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14280",
        "NAME": "Harrach, Barbara (1543\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rohrau an der Leitha",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14281",
        "NAME": "Pinta von Bukowan, Anna Ludmila (1625\u20131646)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1646",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14282",
        "NAME": "Lobkowicz, Maria Magdalena (1569\u20131633)",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1633 Jan 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Swietla an der Sasau"
    },
    {
        "ID": "14283",
        "NAME": "Kolowrat, Sidonia (1605\u20131659)",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1659 Mai 03",
        "PLACEOFBIRTH": "Liebstein in B\u00f6hmen",
        "PLACEOFDEATH": "Toszek"
    },
    {
        "ID": "14284",
        "NAME": "Lobkowicz, Elisabeth (1553\u20131619)",
        "DATEOFBIRTH": "1553 Mar 30",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "\u017dalmanov"
    },
    {
        "ID": "14285",
        "NAME": "Palant, Elisabeth (1567\u20131620)",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1620 Mar 08",
        "PLACEOFBIRTH": "Culemborg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14286",
        "NAME": "Hohenzollern, Kleopatra (1599\u20131685)",
        "DATEOFBIRTH": "1599 Jun 11",
        "DATEOFDEATH": "1685 Feb 26",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": "Me\u00dfkirch an der Ablach"
    },
    {
        "ID": "14287",
        "NAME": "Herberstein, Sidonia (1575\u20131608)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wolfpassing am Wagram"
    },
    {
        "ID": "14288",
        "NAME": "Hundbi\u00df, Johann (1345\u20131429)",
        "DATEOFBIRTH": "1345~",
        "DATEOFDEATH": "1429 Sep 25",
        "PLACEOFBIRTH": "Ravensburg im Schussental",
        "PLACEOFDEATH": "Ravensburg im Schussental:Karmeliterkirche"
    },
    {
        "ID": "14289",
        "NAME": "Promnitz, Eleonora (1576\u20131611)",
        "DATEOFBIRTH": "1576 Sep 28",
        "DATEOFDEATH": "1611 Dez 19",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Greiffenberg in Schlesien"
    },
    {
        "ID": "14290",
        "NAME": "Berg, Sibylla (1557\u20131627), Markgr\u00e4fin von Burgau",
        "DATEOFBIRTH": "1557 Aug 26",
        "DATEOFDEATH": "1627 Dez 16",
        "PLACEOFBIRTH": "Kleve am Niederrhein",
        "PLACEOFDEATH": "G\u00fcnzburg an der Donau"
    },
    {
        "ID": "14291",
        "NAME": "Berg, Eleonora (1550\u20131608)",
        "DATEOFBIRTH": "1550 Jun 16",
        "DATEOFDEATH": "1608 Jun 02",
        "PLACEOFBIRTH": "Kleve am Niederrhein",
        "PLACEOFDEATH": "K\u00f6nigsberg in Preu\u00dfen"
    },
    {
        "ID": "14292",
        "NAME": "Berg, Anna (1552\u20131632)",
        "DATEOFBIRTH": "1552 Mar 01",
        "DATEOFDEATH": "1632 Okt 16",
        "PLACEOFBIRTH": "Kleve am Niederrhein",
        "PLACEOFDEATH": "H\u00f6chst\u00e4dt an der Donau"
    },
    {
        "ID": "14293",
        "NAME": "Berg, Magdalena (1553\u20131633)",
        "DATEOFBIRTH": "1553 Nov 02",
        "DATEOFDEATH": "1633 Aug 30",
        "PLACEOFBIRTH": "Kleve am Niederrhein",
        "PLACEOFDEATH": "Meisenheim"
    },
    {
        "ID": "14294",
        "NAME": "Berg, Johann Wilhelm (1562\u20131609), Bischof von M\u00fcnster",
        "DATEOFBIRTH": "1562 Mai 28",
        "DATEOFDEATH": "1609 Mar 25",
        "PLACEOFBIRTH": "Kleve am Niederrhein",
        "PLACEOFDEATH": "D\u00fcsseldorf"
    },
    {
        "ID": "14295",
        "NAME": "Hohenzollern, Magdalena Sibylla (1587\u20131659), Herzogin zu Sachsen",
        "DATEOFBIRTH": "1587 Jan 09",
        "DATEOFDEATH": "1659 Feb 22",
        "PLACEOFBIRTH": "K\u00f6nigsberg in Preu\u00dfen",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "14296",
        "NAME": "Hohenzollern, Magdalena Sibylla (1612\u20131687), Herzogin zu Sachsen",
        "DATEOFBIRTH": "1612 Nov 01",
        "DATEOFDEATH": "1687 Mar 20",
        "PLACEOFBIRTH": "Bayreuth",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "14297",
        "NAME": "Hohenzollern, Sabina (1529\u20131575)",
        "DATEOFBIRTH": "1529 Mai 12",
        "DATEOFDEATH": "1575 Nov 02",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "K\u00f6lln an der Spree"
    },
    {
        "ID": "14298",
        "NAME": "Hohenzollern, Sophia (1568\u20131622), Herzogin zu Sachsen",
        "DATEOFBIRTH": "1568 Jun 06",
        "DATEOFDEATH": "1622 Dez 17",
        "PLACEOFBIRTH": "Zechlin",
        "PLACEOFDEATH": "Colditz"
    },
    {
        "ID": "14299",
        "NAME": "Hohenzollern, Maria (1579\u20131649)",
        "DATEOFBIRTH": "1579 Jan 22",
        "DATEOFDEATH": "1649 Feb 11",
        "PLACEOFBIRTH": "K\u00f6nigsberg in Preu\u00dfen",
        "PLACEOFDEATH": "Bayreuth:Stadtkirche"
    },
    {
        "ID": "14300",
        "NAME": "Habsburg, Andreas (1558\u20131600), Bischof von Brixen",
        "DATEOFBIRTH": "1558 Jun 15",
        "DATEOFDEATH": "1600 Nov 12",
        "PLACEOFBIRTH": "Bresnitz",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "14301",
        "NAME": "Bredow, Johann Rudolf (1595\u20131640), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1640 Nov 15",
        "PLACEOFBIRTH": "Zeestow",
        "PLACEOFDEATH": "Riebelsdorf"
    },
    {
        "ID": "14302",
        "NAME": "Bredow, Christoph Rudolf (1635\u20131677)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1677",
        "PLACEOFBIRTH": "Zeestow",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14303",
        "NAME": "Schrattenbach, Vinzenz (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14304",
        "NAME": "Schrattenbach, Christoph (1525\u20131571)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14305",
        "NAME": "Schrattenbach, Georg (1540\u20131580)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1580~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14306",
        "NAME": "Schrattenbach, Friedrich (1570\u20131607), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1607 Mar 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14307",
        "NAME": "Stubick von K\u00f6nigstein, Leopold (1580\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Iglau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14308",
        "NAME": "Stubenberg, Rudolf (1559\u20131620), K\u00e4mmerer",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1620 Feb 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ji\u010d\u00edn"
    },
    {
        "ID": "14309",
        "NAME": "Stubenberg, Johann Wilhelm (1619\u20131663)",
        "DATEOFBIRTH": "1619 Apr 22",
        "DATEOFDEATH": "1663 Mar 15",
        "PLACEOFBIRTH": "Neustadt an der Mettau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14310",
        "NAME": "Schurff, Wilhelm (1484\u20131556)",
        "DATEOFBIRTH": "1484",
        "DATEOFDEATH": "1556 Apr 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sch\u00f6nweer in Tirol"
    },
    {
        "ID": "14311",
        "NAME": "Schurff, Johann Jakob (1515\u20131571)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1571 Nov 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Messina"
    },
    {
        "ID": "14312",
        "NAME": "Schurff, Ferdinand (1580\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "Mariastein in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14313",
        "NAME": "Martinitz, Johann (1420\u20131478), Obersthofmeister",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1478",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Smetschna"
    },
    {
        "ID": "14314",
        "NAME": "Martinitz, Wilhelm (1450\u20131496)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1496",
        "PLACEOFBIRTH": "Smetschna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14315",
        "NAME": "Martinitz, Georg (1480\u20131536)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1536",
        "PLACEOFBIRTH": "Smetschna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14316",
        "NAME": "Raidhaupt von Rosenberg, Johann (1540\u20131600)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1600 Mai 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Stra\u00dfburg in K\u00e4rnten"
    },
    {
        "ID": "14317",
        "NAME": "Raidhaupt von Rosenberg, Franz (1570\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14318",
        "NAME": "Raidhaupt von Rosenberg, Georg Siegfried (1595\u20131666)",
        "DATEOFBIRTH": "1595 Apr 29",
        "DATEOFDEATH": "1666 Dez 16",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Stra\u00dfburg in K\u00e4rnten"
    },
    {
        "ID": "14319",
        "NAME": "Raidhaupt von Rosenberg, Wolfgang Theoderich (1600\u20131677)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1677 Apr 19",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Feistritz im Katschtal"
    },
    {
        "ID": "14320",
        "NAME": "Marschall von Pappenheim, Maximilian (1580\u20131639)",
        "DATEOFBIRTH": "1580 Feb 02",
        "DATEOFDEATH": "1639 Feb 14",
        "PLACEOFBIRTH": "St\u00fchlingen",
        "PLACEOFDEATH": "St\u00fchlingen"
    },
    {
        "ID": "14321",
        "NAME": "Marschall von Pappenheim, Maximiliana (1612\u20131635)",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1635 Okt 16",
        "PLACEOFBIRTH": "St\u00fchlingen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14323",
        "NAME": "Dewagky von Adelsberg, Johann Jakob (1600\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "Wippach in der Krain",
        "PLACEOFDEATH": "Marschendorf im Riesengebirge"
    },
    {
        "ID": "14324",
        "NAME": "Dewagky von Adelsberg, Matthias (1605\u20131655)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1655",
        "PLACEOFBIRTH": "Wippach in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14325",
        "NAME": "Dewagky von Adelsberg, Gottfried Matthias (1630\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Marschendorf im Riesengebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14326",
        "NAME": "Dewagky von Adelsberg, Johann Jakob (1660\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Marschendorf im Riesengebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14327",
        "NAME": "Liechtenstein von Nikolsburg, Hartmann (1613\u20131686)",
        "DATEOFBIRTH": "1613 Feb 09",
        "DATEOFDEATH": "1686 Nov 12",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wilfersdorf im Weinviertel"
    },
    {
        "ID": "14328",
        "NAME": "Reifferscheid, Sidonia Elisabeth (1623\u20131688)",
        "DATEOFBIRTH": "1623 Sep 06",
        "DATEOFDEATH": "1688 Sep 23",
        "PLACEOFBIRTH": "Reifferscheid in der Eifel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14329",
        "NAME": "Reifferscheid, Ehrenreich Adolf (1619\u20131673)",
        "DATEOFBIRTH": "1619 Feb 01",
        "DATEOFDEATH": "1673 Jul 16",
        "PLACEOFBIRTH": "Reifferscheid in der Eifel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14330",
        "NAME": "Palant, Werner (1390\u20131456)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1456 Mai 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Breitenbend"
    },
    {
        "ID": "14331",
        "NAME": "Palant, Theoderich (1425\u20131481)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "1481",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14332",
        "NAME": "Palant, Johann (1460\u20131514)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1514 Feb 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14333",
        "NAME": "Palant, Eberhard (1506\u20131540)",
        "DATEOFBIRTH": "1506",
        "DATEOFDEATH": "1540 Okt 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14334",
        "NAME": "Palant, Florent (1539\u20131598)",
        "DATEOFBIRTH": "1539 Jul 25",
        "DATEOFDEATH": "1598 Sep 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Culemborg"
    },
    {
        "ID": "14335",
        "NAME": "Palant, Karsil (1420\u20131475)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1475 Aug 15",
        "PLACEOFBIRTH": "Breitenbend",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14336",
        "NAME": "Palant, Werner (1450\u20131506)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1506 Okt 10",
        "PLACEOFBIRTH": "Breitenbend",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14337",
        "NAME": "Palant, Werner (1490\u20131557)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1557 Mar 01",
        "PLACEOFBIRTH": "Breitenbend",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14338",
        "NAME": "Palant, Theoderich (1530\u20131600)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1600~",
        "PLACEOFBIRTH": "Breitenbend",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14339",
        "NAME": "Palant, Werner (1560\u20131609)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "Breitenbend",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14340",
        "NAME": "Neuhaus von Cormons, Darius (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neuhaus am Karst",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14341",
        "NAME": "Neuhaus von Cormons, Franz (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kremaun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14342",
        "NAME": "Neuhaus von Cormons, Darius (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kremaun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14343",
        "NAME": "Neuhaus von Cormons, Kaspar (1575\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kremaun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14344",
        "NAME": "Neuhaus von Cormons, Julius (1595\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1595 Mar 14",
        "DATEOFDEATH": "1660 Nov 10",
        "PLACEOFBIRTH": "Kremaun",
        "PLACEOFDEATH": "Bladen in Schlesien"
    },
    {
        "ID": "14345",
        "NAME": "Neuhaus von Cormons, Ferdinand (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kremaun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14346",
        "NAME": "Neuhaus von Cormons, Anton (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kremaun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14347",
        "NAME": "Neuhaus von Cormons, Jakob (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sankt Mauro an der Isnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14348",
        "NAME": "Neuhaus von Cormons, Joseph (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sankt Mauro an der Isnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14349",
        "NAME": "Neuhaus von Cormons, Peter (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sankt Mauro an der Isnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14350",
        "NAME": "Neuhaus von Cormons, Leonhard (1610\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sankt Mauro an der Isnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14351",
        "NAME": "Wildenstein, Siegmund (1505\u20131570)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1570 Jul 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wildbach an der La\u00dfnitz"
    },
    {
        "ID": "14352",
        "NAME": "Wildenstein, Christoph (1550\u20131598)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Wildbach an der La\u00dfnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14353",
        "NAME": "Wildenstein, Johann Christoph (1589\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wildbach an der La\u00dfnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14354",
        "NAME": "Wildenstein, Theoderich (1540\u20131594)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1594 Aug 21",
        "PLACEOFBIRTH": "Wildbach an der La\u00dfnitz",
        "PLACEOFDEATH": "Gams am Weinberg"
    },
    {
        "ID": "14355",
        "NAME": "Wildenstein, Georg Siegmund (1581\u20131615)",
        "DATEOFBIRTH": "1581 Dez 12",
        "DATEOFDEATH": "1615 Feb 13",
        "PLACEOFBIRTH": "Wildbach an der La\u00dfnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14356",
        "NAME": "Wildenstein, Johann Franz (1610\u20131678), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1678 Okt 18",
        "PLACEOFBIRTH": "Wildbach an der La\u00dfnitz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "14357",
        "NAME": "Hohenlohe, Georg Friedrich (1569\u20131645), Hofkriegsrat",
        "DATEOFBIRTH": "1569 Sep 05",
        "DATEOFDEATH": "1645 Jul 07",
        "PLACEOFBIRTH": "Neuenstein im Hohenloher Land",
        "PLACEOFDEATH": "Langenburg an der Jagst"
    },
    {
        "ID": "14358",
        "NAME": "Wildberg, Philipp Joachim (1604\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1636 Okt 04",
        "PLACEOFBIRTH": "Wildenburg im Soonwald",
        "PLACEOFDEATH": "Wittstock an der Dosse"
    },
    {
        "ID": "14359",
        "NAME": "Hundbi\u00df, Johann Werner (1590\u20131658), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1658 Sep 14",
        "PLACEOFBIRTH": "K\u00fcnzelsau",
        "PLACEOFDEATH": "Altshausen:Michaelskirche"
    },
    {
        "ID": "14360",
        "NAME": "Ligne, Philipp Karl (1587\u20131640), F\u00fcrst von Arenberg",
        "DATEOFBIRTH": "1587 Okt 18",
        "DATEOFDEATH": "1640 Sep 25",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "14361",
        "NAME": "Ligne, Philipp Franz (1625\u20131674), Herzog von Arenberg",
        "DATEOFBIRTH": "1625 Jul 30",
        "DATEOFDEATH": "1674 Dez 17",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "14362",
        "NAME": "Ligne, Johann (1520\u20131568), Graf von Arenberg",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1568 Mai 23",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": "Heiligerlee"
    },
    {
        "ID": "14363",
        "NAME": "Ligne, Ruprecht (1564\u20131614)",
        "DATEOFBIRTH": "1564 Nov 11",
        "DATEOFDEATH": "1614 Mar 02",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14364",
        "NAME": "Ligne, Albrecht (1600\u20131674)",
        "DATEOFBIRTH": "1600 Jul 22",
        "DATEOFDEATH": "1674 Apr 08",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "14365",
        "NAME": "Ligne, Karl (1550\u20131616), Graf von Arenberg",
        "DATEOFBIRTH": "1550 Feb 22",
        "DATEOFDEATH": "1616 Jan 18",
        "PLACEOFBIRTH": "Vollenhove",
        "PLACEOFDEATH": "Edingen im Hennegau"
    },
    {
        "ID": "14366",
        "NAME": "Wildenstein, Leonhard (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wildbach an der La\u00dfnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14367",
        "NAME": "Wildenstein, Georg (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wildbach an der La\u00dfnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14368",
        "NAME": "Rogendorf, Wolfgang (1483\u20131540)",
        "DATEOFBIRTH": "1483 Jan 29",
        "DATEOFDEATH": "1540",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14369",
        "NAME": "Rogendorf, Anna (1508\u20131562)",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "1562 Sep 05",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": "Krumau in B\u00f6hmen"
    },
    {
        "ID": "14370",
        "NAME": "Brandenstein, Christoph Karl (1593\u20131640), K\u00e4mmerer",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1640 Okt 08",
        "PLACEOFBIRTH": "Oppurg an der Orla",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "14371",
        "NAME": "Rosenberg, Heinrich (1442\u20131507), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1442 Apr 13",
        "DATEOFDEATH": "1507 Jan 17",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14372",
        "NAME": "Rosenberg, Adam (1494\u20131531), Oberstkanzler von B\u00f6hmen",
        "DATEOFBIRTH": "1494 Mai 14",
        "DATEOFDEATH": "1531 Jun 15",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14373",
        "NAME": "Rosenberg, Joachim (1526\u20131565), Oberstkanzler von B\u00f6hmen",
        "DATEOFBIRTH": "1526 Jul 14",
        "DATEOFDEATH": "1565 Dez 12",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14374",
        "NAME": "Rosenberg, Adam (1549\u20131596), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1596 Nov 24",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14375",
        "NAME": "Rosenberg, Joachim Ulrich (1579\u20131604), Burggraf von Karlstein",
        "DATEOFBIRTH": "1579 Jan 24",
        "DATEOFDEATH": "1604 Mai 23",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Neuhaus in B\u00f6hmen"
    },
    {
        "ID": "14376",
        "NAME": "Rosenberg, Zacharias (1527\u20131589), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1527",
        "DATEOFDEATH": "1589 Feb 06",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Teltsch"
    },
    {
        "ID": "14377",
        "NAME": "Rosenberg, Luzia Ottilia (1582\u20131633)",
        "DATEOFBIRTH": "1582 Feb 01",
        "DATEOFDEATH": "1633 Mar 11",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14378",
        "NAME": "Puchheim, Wolfgang Adam (1575\u20131629), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14379",
        "NAME": "Puchheim, Johann Bernhard (1570\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Raabs an der Thaya",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14380",
        "NAME": "Kuenburg, Johann Georg (1570\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "14381",
        "NAME": "Sch\u00f6nburg auf Wesel, Otto Friedrich (1589\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1589 Sep 21",
        "DATEOFDEATH": "1631 Sep 17",
        "PLACEOFBIRTH": "Wesel am Mittelrhein",
        "PLACEOFDEATH": "Breitenfeld im Lindenthal"
    },
    {
        "ID": "14382",
        "NAME": "Windischgr\u00e4tz, Ferdinand Hartwig (1681\u20131706), K\u00e4mmerer",
        "DATEOFBIRTH": "1681 Mar 31",
        "DATEOFDEATH": "1706 Mai 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14383",
        "NAME": "Windischgr\u00e4tz, Erasam (1586\u20131622)",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1622",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14384",
        "NAME": "Windischgr\u00e4tz, Andreas (1615\u20131660)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1660 Dez 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14385",
        "NAME": "Windischgr\u00e4tz, Jakob Ludwig (1650\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14386",
        "NAME": "Hohenlohe, Wolfgang (1546\u20131610)",
        "DATEOFBIRTH": "1546 Jun 14",
        "DATEOFDEATH": "1610 Mar 28",
        "PLACEOFBIRTH": "Waldenburg im Hohenloher Land",
        "PLACEOFDEATH": "Weikersheim im Taubertal"
    },
    {
        "ID": "14387",
        "NAME": "Hohenlohe, Kraft (1582\u20131641)",
        "DATEOFBIRTH": "1582 Nov 14",
        "DATEOFDEATH": "1641 Sep 11",
        "PLACEOFBIRTH": "Langenburg an der Jagst",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "14388",
        "NAME": "Hohenlohe, Wolfgang Julius (1622\u20131698), Hofkriegsrat",
        "DATEOFBIRTH": "1622 Aug 03",
        "DATEOFDEATH": "1698 Dez 26",
        "PLACEOFBIRTH": "Neuenstein im Hohenloher Land",
        "PLACEOFDEATH": "Neuenstein im Hohenloher Land"
    },
    {
        "ID": "14389",
        "NAME": "Hohenlohe, Philipp Ernst (1663\u20131759), K\u00e4mmerer",
        "DATEOFBIRTH": "1663 Dez 29",
        "DATEOFDEATH": "1759 Nov 29",
        "PLACEOFBIRTH": "Schillingsf\u00fcrst in Mittelfranken",
        "PLACEOFDEATH": "Schillingsf\u00fcrst in Mittelfranken"
    },
    {
        "ID": "14390",
        "NAME": "F\u00fcrstenberg, Joachim Alwig (1587\u20131617), K\u00e4mmerer",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1617 Feb 04",
        "PLACEOFBIRTH": "Trochtelfingen im Seckachtal",
        "PLACEOFDEATH": "Schaffhausen"
    },
    {
        "ID": "14391",
        "NAME": "F\u00fcrstenberg, Jakob Ludwig (1592\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1627 Nov 15",
        "PLACEOFBIRTH": "Heiligenberg im Linzgau",
        "PLACEOFDEATH": "Nienburg an der Weser"
    },
    {
        "ID": "14392",
        "NAME": "F\u00fcrstenberg, Wilhelm (1586\u20131618), Reichshofrat",
        "DATEOFBIRTH": "1586 Feb 04",
        "DATEOFDEATH": "1618 Okt 15",
        "PLACEOFBIRTH": "Heiligenberg im Linzgau",
        "PLACEOFDEATH": "Heiligenberg im Linzgau"
    },
    {
        "ID": "14393",
        "NAME": "Palant, Karl Theoderich (1595\u20131642), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1642 Dez 04",
        "PLACEOFBIRTH": "Breitenbend",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14394",
        "NAME": "Palant, Johann Rudolf (1597\u20131633)",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1633 Apr 06",
        "PLACEOFBIRTH": "Breitenbend",
        "PLACEOFDEATH": "Steinefrenz"
    },
    {
        "ID": "14395",
        "NAME": "Hiserle von Chodau, Christoph (1540\u20131608)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14396",
        "NAME": "Hiserle von Chodau, Heinrich (1575\u20131665), K\u00e4mmerer",
        "DATEOFBIRTH": "1575 Jan 10",
        "DATEOFDEATH": "1665 Apr 18",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14397",
        "NAME": "Morzin, Rudolf (1600\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1646",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Hohenelbe"
    },
    {
        "ID": "14398",
        "NAME": "Rothkirch, Stephan (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Panthenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14399",
        "NAME": "Rothkirch, Christoph (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Panthenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14400",
        "NAME": "Jagiello, Lassel (1360\u20131434), K\u00f6nig von Polen",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1434 Jun 01",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": "Grodeck"
    },
    {
        "ID": "14401",
        "NAME": "Jagiello, Lassel (1424\u20131444), K\u00f6nig von Polen",
        "DATEOFBIRTH": "1424 Okt 31",
        "DATEOFDEATH": "1444 Nov 10",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": "Varna"
    },
    {
        "ID": "14406",
        "NAME": "Jagiello, Siegmund (1467\u20131548), K\u00f6nig von Polen",
        "DATEOFBIRTH": "1467 Jan 01",
        "DATEOFDEATH": "1548 Apr 01",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": "Krakau"
    },
    {
        "ID": "14407",
        "NAME": "Jagiello, Katharina (1503\u20131548)",
        "DATEOFBIRTH": "1503",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14408",
        "NAME": "Jagiello, Kasimir (1427\u20131492), K\u00f6nig von Polen",
        "DATEOFBIRTH": "1427 Nov 30",
        "DATEOFDEATH": "1492 Jun 07",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": "Garten an der Memel"
    },
    {
        "ID": "14409",
        "NAME": "Jagiello, Hedwig (1457\u20131502), Herzogin in Bayern",
        "DATEOFBIRTH": "1457 Sep 21",
        "DATEOFDEATH": "1502 Feb 18",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": "Burghausen an der Salzach"
    },
    {
        "ID": "14410",
        "NAME": "Jagiello, Sophia (1464\u20131512)",
        "DATEOFBIRTH": "1464 Mai 06",
        "DATEOFDEATH": "1512 Okt 05",
        "PLACEOFBIRTH": "Krakau",
        "PLACEOFDEATH": "Ansbach"
    },
    {
        "ID": "14411",
        "NAME": "Wagen von Wagensperg, Johann (1500\u20131553)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1553 Apr 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14412",
        "NAME": "Wagen von Wagensperg, Balthasar (1545\u20131595)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1595",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14413",
        "NAME": "Wagen von Wagensperg, Felizian (1575\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14414",
        "NAME": "Wagen von Wagensperg, Erasam (1580\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14415",
        "NAME": "Wagen von Wagensperg, Maximilian (1585\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14416",
        "NAME": "Wagen von Wagensperg, Georg Ehrenreich (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14417",
        "NAME": "Wagen von Wagensperg, Rudolf (1613\u20131679), Hofkammerpr\u00e4sident von Inner\u00f6sterreich",
        "DATEOFBIRTH": "1613 Jan 08",
        "DATEOFDEATH": "1679 Jul 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14418",
        "NAME": "Promnitz, Siegmund (1380\u20131444)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1444",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14419",
        "NAME": "Promnitz, Balthasar (1415\u20131480)",
        "DATEOFBIRTH": "1415~",
        "DATEOFDEATH": "1480~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14420",
        "NAME": "Promnitz, Kaspar (1410\u20131460)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1460~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14421",
        "NAME": "Promnitz, Kaspar (1440\u20131500)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1500~",
        "PLACEOFBIRTH": "Lessendorf in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14422",
        "NAME": "Promnitz, Kaspar (1480\u20131543)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "Lessendorf in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14423",
        "NAME": "Promnitz, Stenzel (1520\u20131568)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1568 Aug 28",
        "PLACEOFBIRTH": "Lessendorf in Schlesien",
        "PLACEOFDEATH": "Ple\u00df in Schlesien"
    },
    {
        "ID": "14424",
        "NAME": "Promnitz, Karl (1525\u20131591)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1591",
        "PLACEOFBIRTH": "Lessendorf in Schlesien",
        "PLACEOFDEATH": "Ple\u00df in Schlesien"
    },
    {
        "ID": "14425",
        "NAME": "Promnitz, Balthasar (1488\u20131562), Bischof von Breslau",
        "DATEOFBIRTH": "1488",
        "DATEOFDEATH": "1562 Jan 20",
        "PLACEOFBIRTH": "Lessendorf in Schlesien",
        "PLACEOFDEATH": "Nei\u00dfe"
    },
    {
        "ID": "14426",
        "NAME": "Promnitz, Abraham (1560\u20131613)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "Lessendorf in Schlesien",
        "PLACEOFDEATH": "Ple\u00df in Schlesien"
    },
    {
        "ID": "14427",
        "NAME": "Promnitz, Kaspar (1445\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Weichau in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14428",
        "NAME": "Promnitz, Heinrich (1475\u20131535)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1535~",
        "PLACEOFBIRTH": "Weichau in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14429",
        "NAME": "Promnitz, Anselm (1505\u20131545)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1545",
        "PLACEOFBIRTH": "Weichau in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14430",
        "NAME": "Promnitz, Siegfried (1534\u20131597), Reichshofrat",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1597 Feb 25",
        "PLACEOFBIRTH": "Weichau in Schlesien",
        "PLACEOFDEATH": "Sorau"
    },
    {
        "ID": "14431",
        "NAME": "Promnitz, Heinrich Anselm (1564\u20131622), K\u00e4mmerer",
        "DATEOFBIRTH": "1564 Nov 26",
        "DATEOFDEATH": "1622 Mar 14",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "L\u00fcbben im Spreewald"
    },
    {
        "ID": "14432",
        "NAME": "Promnitz, Siegfried (1573\u20131623), K\u00e4mmerer",
        "DATEOFBIRTH": "1573 Feb 21",
        "DATEOFDEATH": "1623 Jan 29",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Ple\u00df in Schlesien"
    },
    {
        "ID": "14433",
        "NAME": "Promnitz, Siegmund Siegfried (1595\u20131654), K\u00e4mmerer",
        "DATEOFBIRTH": "1595 Jul 26",
        "DATEOFDEATH": "1654 Jun 30",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Warmbrunn im Riesengebirge"
    },
    {
        "ID": "14434",
        "NAME": "Promnitz, Weikhard (1570\u20131618), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1618 Nov 12",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14435",
        "NAME": "Promnitz, Siegfried (1607\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1650 Dez 19",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "14436",
        "NAME": "Hohberg, Friedrich (1460\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00fcttmannsdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14437",
        "NAME": "Hohberg, Heinrich (1504\u20131569), Hofkammerrat",
        "DATEOFBIRTH": "1504 Mar 02",
        "DATEOFDEATH": "1569 Mar 27",
        "PLACEOFBIRTH": "G\u00fcttmannsdorf",
        "PLACEOFDEATH": "Wildsch\u00fctz an der Weide"
    },
    {
        "ID": "14438",
        "NAME": "Hohberg, Kaspar (1511\u20131587), Obersthofmarschall",
        "DATEOFBIRTH": "1511 Nov 02",
        "DATEOFDEATH": "1587 Jan 04",
        "PLACEOFBIRTH": "G\u00fcttmannsdorf",
        "PLACEOFDEATH": "Znaim"
    },
    {
        "ID": "14439",
        "NAME": "Virmond, Johann (1588\u20131632)",
        "DATEOFBIRTH": "1588 Jul 07",
        "DATEOFDEATH": "1632 Feb 20",
        "PLACEOFBIRTH": "Neersen",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "14440",
        "NAME": "Korecki, Samuel Karl (1612\u20131651), K\u00e4mmerer",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1651 Feb 12",
        "PLACEOFBIRTH": "Korzec",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14441",
        "NAME": "Scherffenberg, Bernhard (1445\u20131513)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1513",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lorch an der Enns:Laurenzkirche"
    },
    {
        "ID": "14442",
        "NAME": "Scherffenberg, Christoph (1475\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14443",
        "NAME": "Scherffenberg, Johann (1509\u20131582), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1509 Dez 21",
        "DATEOFDEATH": "1582 Sep 06",
        "PLACEOFBIRTH": "Neustadt im Steinfeld",
        "PLACEOFDEATH": "Spielberg an der Donau"
    },
    {
        "ID": "14444",
        "NAME": "Scherffenberg, Karl (1550\u20131610)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1610 Jul 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14445",
        "NAME": "Scherffenberg, Friedrich (1542\u20131609)",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14446",
        "NAME": "Scherffenberg, Johann Ernst (1588\u20131662), K\u00e4mmerer",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1662 Jan 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14447",
        "NAME": "Scherffenberg, Wolfgang (1480\u20131530)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1530~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14448",
        "NAME": "Scherffenberg, Ulrich (1518\u20131570)",
        "DATEOFBIRTH": "1518 Apr 26",
        "DATEOFDEATH": "1570 Mar 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14449",
        "NAME": "Scherffenberg, Christoph Ulrich (1568\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1568 Jun 14",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "Trautmannsdorf an der Leitha",
        "PLACEOFDEATH": "G\u00f6rz"
    },
    {
        "ID": "14450",
        "NAME": "Breunner, Philipp Christoph (1643\u20131708), K\u00e4mmerer",
        "DATEOFBIRTH": "1643",
        "DATEOFDEATH": "1708",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Asparn an der Zaya"
    },
    {
        "ID": "14451",
        "NAME": "Breunner, Johann Baptist (1549\u20131594), Reichshofrat",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1594 Mai 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14452",
        "NAME": "Breunner, Johann Philipp (1580\u20131632), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14453",
        "NAME": "Breunner, Franz Albrecht (1620\u20131684), Geheimer Rat",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1684 Okt 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "14454",
        "NAME": "Breunner, Johann Philipp (1630\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14455",
        "NAME": "Breunner, Johann Friedrich (1583\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Olm\u00fctz in M\u00e4hren"
    },
    {
        "ID": "14456",
        "NAME": "Breunner, Johann Gottfried (1585\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14457",
        "NAME": "Breunner, Barbara (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14458",
        "NAME": "Breunner, Friedrich (1542\u20131583), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1583 Aug 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Konstantinopel"
    },
    {
        "ID": "14459",
        "NAME": "Promnitz, Erdmann (1631\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1631 Sep 02",
        "DATEOFDEATH": "1664 Jan 19",
        "PLACEOFBIRTH": "Ple\u00df in Schlesien",
        "PLACEOFDEATH": "Sorau"
    },
    {
        "ID": "14460",
        "NAME": "Raitz von Frentz, Adolf Siegmund (1590\u20131628), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "Klotten an der Mosel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14461",
        "NAME": "Herbrot, Johann Jakob (1525\u20131610), Hofquartiermeister",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1610~",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14462",
        "NAME": "Hager von Allentsteig, Johann (1540\u20131590), Oberstfalkenmeister",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1590 Okt 11",
        "PLACEOFBIRTH": "Allentsteig im Waldviertel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14463",
        "NAME": "Kleinfeld, Theodemar (1530\u20131580), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1580~",
        "PLACEOFBIRTH": "Danzig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14464",
        "NAME": "Sinnich von L\u00f6wenburg, Wolfgang (1550\u20131598), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14465",
        "NAME": "Rehlinger, Daniel (1540\u20131601), Oberstk\u00fcchenmeister",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1601",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14466",
        "NAME": "Rothkirch, Wenzel (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Panthenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14467",
        "NAME": "Rothkirch, Friedrich (1543\u20131612)",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1612 Nov 01",
        "PLACEOFBIRTH": "Panthenau",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "14468",
        "NAME": "Rothkirch, Wolfgang (1573\u20131620), Landeshauptmann von Liegnitz",
        "DATEOFBIRTH": "1573 Aug 25",
        "DATEOFDEATH": "1620 Jan 08",
        "PLACEOFBIRTH": "Wolfsdorf an der Katzbach",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "14469",
        "NAME": "Rothkirch, Wenzel (1550\u20131611), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1611 Mar 08",
        "PLACEOFBIRTH": "Panthenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14470",
        "NAME": "Siebenb\u00fcrger, Johann Baptist (1550\u20131590), Hofdiener",
        "DATEOFBIRTH": "1550",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Seebarn am Wagram"
    },
    {
        "ID": "14471",
        "NAME": "Radziwill, Niklas (1440\u20131509)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1509 Jul 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14472",
        "NAME": "Radziwill, Johann (1474\u20131522)",
        "DATEOFBIRTH": "1474",
        "DATEOFDEATH": "1522",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14473",
        "NAME": "Radziwill, Georg (1480\u20131541)",
        "DATEOFBIRTH": "1480",
        "DATEOFDEATH": "1541 Apr 15",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14474",
        "NAME": "Radziwill, Niklas (1512\u20131584)",
        "DATEOFBIRTH": "1512",
        "DATEOFDEATH": "1584 Apr 27",
        "PLACEOFBIRTH": "Neswisch",
        "PLACEOFDEATH": "Vilnius"
    },
    {
        "ID": "14475",
        "NAME": "Radziwill, Niklas (1515\u20131565)",
        "DATEOFBIRTH": "1515 Feb 04",
        "DATEOFDEATH": "1565 Mai 28",
        "PLACEOFBIRTH": "Neswisch",
        "PLACEOFDEATH": "Vilnius"
    },
    {
        "ID": "14476",
        "NAME": "Radziwill, Niklas Christoph (1549\u20131616)",
        "DATEOFBIRTH": "1549 Aug 02",
        "DATEOFDEATH": "1616 Feb 28",
        "PLACEOFBIRTH": "\u0106miel\u00f3w",
        "PLACEOFDEATH": "Neswisch"
    },
    {
        "ID": "14477",
        "NAME": "Radziwill, Siegmund Karl (1591\u20131642), K\u00e4mmerer",
        "DATEOFBIRTH": "1591 Dez 04",
        "DATEOFDEATH": "1642 Nov 05",
        "PLACEOFBIRTH": "Neswisch",
        "PLACEOFDEATH": "Assisi"
    },
    {
        "ID": "14478",
        "NAME": "Radziwill, Christoph (1547\u20131603)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1603 Nov 20",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": "\u0141oso\u015bna"
    },
    {
        "ID": "14479",
        "NAME": "Radziwill, Johann (1579\u20131620)",
        "DATEOFBIRTH": "1579 Jul 02",
        "DATEOFDEATH": "1620 Dez 03",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": "Czarlin"
    },
    {
        "ID": "14480",
        "NAME": "Radziwill, Albrecht Lassel (1589\u20131636)",
        "DATEOFBIRTH": "1589 Jun 16",
        "DATEOFDEATH": "1636 Jul 20",
        "PLACEOFBIRTH": "Neswisch",
        "PLACEOFDEATH": "Czarnawczyce"
    },
    {
        "ID": "14481",
        "NAME": "Mittrowsky, Bosel (1490\u20131539)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1539",
        "PLACEOFBIRTH": "Nemy\u0161l",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14482",
        "NAME": "Mittrowsky, Georg (1525\u20131561)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1561",
        "PLACEOFBIRTH": "Nemy\u0161l",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14483",
        "NAME": "Mittrowsky, Georg (1560\u20131630)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1630~",
        "PLACEOFBIRTH": "Nemy\u0161l",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14484",
        "NAME": "Ossolin\u0301ski, Johann Sbigneus (1555\u20131623)",
        "DATEOFBIRTH": "1555 Sep 03",
        "DATEOFDEATH": "1623 Okt 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14485",
        "NAME": "Ossolin\u0301ski, Georg (1595\u20131650)",
        "DATEOFBIRTH": "1595 Dez 15",
        "DATEOFDEATH": "1650 Aug 09",
        "PLACEOFBIRTH": "Sandomierz",
        "PLACEOFDEATH": "Warszawa"
    },
    {
        "ID": "14486",
        "NAME": "Ossolin\u0301ski, Christoph (1587\u20131645)",
        "DATEOFBIRTH": "1587 Apr 28",
        "DATEOFDEATH": "1645 Feb 24",
        "PLACEOFBIRTH": "Bukowsko",
        "PLACEOFDEATH": "Krakau"
    },
    {
        "ID": "14487",
        "NAME": "Ossolin\u0301ski, Maximilian (1588\u20131665)",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1665 Jan 28",
        "PLACEOFBIRTH": "Bukowsko",
        "PLACEOFDEATH": "Klimont\u00f3w"
    },
    {
        "ID": "14488",
        "NAME": "Promnitz, Martin (1480\u20131532)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1532",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14489",
        "NAME": "Promnitz, Martin (1510\u20131550)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1550~",
        "PLACEOFBIRTH": "Sch\u00fcttlau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14490",
        "NAME": "Promnitz, Georg (1540\u20131572), St\u00e4belmeister",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1572",
        "PLACEOFBIRTH": "Sch\u00fcttlau",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "14491",
        "NAME": "Bee\u00df, Adam (1470\u20131528)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Karlsmarkt"
    },
    {
        "ID": "14492",
        "NAME": "Bee\u00df, Adam (1510\u20131570)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1570",
        "PLACEOFBIRTH": "Karlsmarkt",
        "PLACEOFDEATH": "Oppeln"
    },
    {
        "ID": "14493",
        "NAME": "Bee\u00df, Adam (1560\u20131594), Truchsess",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "Karlsmarkt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14494",
        "NAME": "Zborowski, Christoph (1535\u20131593), Mundschenk",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1593",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14495",
        "NAME": "Wolski, Kasimir Stenzel (1600\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1645~",
        "PLACEOFBIRTH": "Podhajce",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14496",
        "NAME": "Rueber von Pixendorf, Ferdinand (1610\u20131689)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1689",
        "PLACEOFBIRTH": "Grafenw\u00f6rth an der Donau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14497",
        "NAME": "Rueber von Pixendorf, Johann Baptist (1529\u20131584), K\u00e4mmerer",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1584 Mar 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "S\u00e1rosv\u00e1r"
    },
    {
        "ID": "14498",
        "NAME": "Rueber von Pixendorf, Georg (1570\u20131620)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1620~",
        "PLACEOFBIRTH": "Grafenw\u00f6rth an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14499",
        "NAME": "Rueber von Pixendorf, Johann Baptist (1575\u20131634)",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "Grafenw\u00f6rth an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14500",
        "NAME": "Habsburg, Karl (1560\u20131618), Markgraf von Burgau",
        "DATEOFBIRTH": "1560 Nov 22",
        "DATEOFDEATH": "1618 Okt 31",
        "PLACEOFBIRTH": "P\u00fcrglitz",
        "PLACEOFDEATH": "\u00dcberlingen am Bodensee"
    },
    {
        "ID": "14501",
        "NAME": "Reifenberg, Philipp (1540\u20131582)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1582 Feb 09",
        "PLACEOFBIRTH": "Reifenberg im Taunus",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14502",
        "NAME": "Reifenberg, Johann Heinrich (1575\u20131628), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1628 Mar 04",
        "PLACEOFBIRTH": "Reifenberg im Taunus",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14503",
        "NAME": "Reifenberg, Johann Theoderich (1576\u20131629), Hofkriegsrat",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1629 Dez 15",
        "PLACEOFBIRTH": "Reifenberg im Taunus",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "14504",
        "NAME": "Enenkel von Albrechtsberg, Albrecht (1547\u20131608)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "Albrechtsberg an der Pielach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14505",
        "NAME": "Enenkel von Albrechtsberg, Georg Achaz (1573\u20131620)",
        "DATEOFBIRTH": "1573 Okt 17",
        "DATEOFDEATH": "1620 Mai 01",
        "PLACEOFBIRTH": "Heinrichschlag im M\u00fchlviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14506",
        "NAME": "Enenkel von Albrechtsberg, Hiob Hartmann (1576\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1576 Sep 14",
        "DATEOFDEATH": "1627 Feb 09",
        "PLACEOFBIRTH": "Heinrichschlag im M\u00fchlviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14507",
        "NAME": "Oppersdorff, Friedrich (1471\u20131544)",
        "DATEOFBIRTH": "1471",
        "DATEOFDEATH": "1544",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Brieg"
    },
    {
        "ID": "14508",
        "NAME": "Oppersdorff, Johann (1514\u20131584), Landeshauptmann von Oppeln",
        "DATEOFBIRTH": "1514",
        "DATEOFDEATH": "1584 Jul 03",
        "PLACEOFBIRTH": "Heidau an der Oder",
        "PLACEOFDEATH": "Glogau in Oberschlesien"
    },
    {
        "ID": "14509",
        "NAME": "Oppersdorff, Georg (1516\u20131577), Landeshauptmann von Nei\u00dfe",
        "DATEOFBIRTH": "1516",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "Heidau an der Oder",
        "PLACEOFDEATH": "Nei\u00dfe"
    },
    {
        "ID": "14510",
        "NAME": "Oppersdorff, Wilhelm (1519\u20131588), Oberstm\u00fcnzmeister in B\u00f6hmen",
        "DATEOFBIRTH": "1519 Jun 11",
        "DATEOFDEATH": "1588 Sep 04",
        "PLACEOFBIRTH": "Heidau an der Oder",
        "PLACEOFDEATH": "Landeck in Niederschlesien"
    },
    {
        "ID": "14511",
        "NAME": "Oppersdorff, Friedrich (1547\u20131615), Truchsess",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1615 Feb 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "\u010castolovice"
    },
    {
        "ID": "14512",
        "NAME": "Oppersdorff, Georg (1550\u20131606), Landeshauptmann von Oppeln",
        "DATEOFBIRTH": "1550 Jan 11",
        "DATEOFDEATH": "1606 Dez 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Glogau in Oberschlesien"
    },
    {
        "ID": "14513",
        "NAME": "Oppersdorff, Johann Otto (1585\u20131647)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1647 Jan 06",
        "PLACEOFBIRTH": "Glogau in Oberschlesien",
        "PLACEOFDEATH": "\u010castolovice"
    },
    {
        "ID": "14514",
        "NAME": "Oppersdorff, Johann Friedrich (1590\u20131632), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1632 Mai 18",
        "PLACEOFBIRTH": "Glogau in Oberschlesien",
        "PLACEOFDEATH": "Schambach im Adlergebirge"
    },
    {
        "ID": "14515",
        "NAME": "Oppersdorff, Wenzel Ignaz (1637\u20131676), K\u00e4mmerer",
        "DATEOFBIRTH": "1637 Jan 12",
        "DATEOFDEATH": "1676 Mar 29",
        "PLACEOFBIRTH": "\u010castolovice",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14516",
        "NAME": "Oppersdorff, Georg (1588\u20131651), K\u00e4mmerer",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1651 Mai 16",
        "PLACEOFBIRTH": "Glogau in Oberschlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14517",
        "NAME": "Oppersdorff, Friedrich (1590\u20131636), Landeshauptmann von Oppeln",
        "DATEOFBIRTH": "1590",
        "DATEOFDEATH": "1636 Jul 18",
        "PLACEOFBIRTH": "Glogau in Oberschlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14518",
        "NAME": "Oppersdorff, Wenzel (1592\u20131644), K\u00e4mmerer",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "Glogau in Oberschlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14519",
        "NAME": "Oppersdorff, Franz Euseb (1623\u20131691), Landeshauptmann von Oppeln",
        "DATEOFBIRTH": "1623 Feb 10",
        "DATEOFDEATH": "1691 Mar 17",
        "PLACEOFBIRTH": "Glogau in Oberschlesien",
        "PLACEOFDEATH": "Glogau in Oberschlesien"
    },
    {
        "ID": "14520",
        "NAME": "Traun, Johann (1320\u20131379), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "1379 Jul 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14521",
        "NAME": "Traun, Johann (1360\u20131429)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1429 Mar 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14522",
        "NAME": "Traun, Wolfgang (1400\u20131458)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1458 Sep 16",
        "PLACEOFBIRTH": "Eschelberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14523",
        "NAME": "Traun, Johann (1450\u20131500)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1500 Jun 23",
        "PLACEOFBIRTH": "Eschelberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14524",
        "NAME": "Traun, Christoph (1480\u20131550)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1550",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14525",
        "NAME": "Traun, Otto (1520\u20131572)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1572 Jan 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14526",
        "NAME": "Traun, Otto Bernhard (1550\u20131605)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14527",
        "NAME": "Traun, Adam (1593\u20131632), K\u00e4mmerer",
        "DATEOFBIRTH": "1593 Aug 25",
        "DATEOFDEATH": "1632 Sep 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14528",
        "NAME": "Traun, Otto Maximilian (1597\u20131658)",
        "DATEOFBIRTH": "1597 Apr 29",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14529",
        "NAME": "Traun, Otto Lorenz (1638\u20131695)",
        "DATEOFBIRTH": "1638 Nov 04",
        "DATEOFDEATH": "1695 Apr 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "14530",
        "NAME": "Traun, Otto Ferdinand (1677\u20131748)",
        "DATEOFBIRTH": "1677 Aug 27",
        "DATEOFDEATH": "1748 Feb 18",
        "PLACEOFBIRTH": "Oedenburg",
        "PLACEOFDEATH": "Hermannstadt in Siebenb\u00fcrgen"
    },
    {
        "ID": "14531",
        "NAME": "Traun, Johann Kyriak (1599\u20131652)",
        "DATEOFBIRTH": "1599 Aug 02",
        "DATEOFDEATH": "1652",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14532",
        "NAME": "Traun, Johann Wilhelm (1630\u20131690), K\u00e4mmerer",
        "DATEOFBIRTH": "1630",
        "DATEOFDEATH": "1690 Sep 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14533",
        "NAME": "Traun, Michael (1453\u20131521), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1453",
        "DATEOFDEATH": "1521 Nov 19",
        "PLACEOFBIRTH": "Eschelberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14534",
        "NAME": "Traun, Sebastian (1483\u20131530)",
        "DATEOFBIRTH": "1483",
        "DATEOFDEATH": "1530 Aug 12",
        "PLACEOFBIRTH": "Eschelberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14535",
        "NAME": "Traun, Adam (1516\u20131563)",
        "DATEOFBIRTH": "1516",
        "DATEOFDEATH": "1563",
        "PLACEOFBIRTH": "Eschelberg",
        "PLACEOFDEATH": "Maissau"
    },
    {
        "ID": "14536",
        "NAME": "Traun, Johann Bernhard (1546\u20131583)",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1583 Jul 12",
        "PLACEOFBIRTH": "Eschelberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14537",
        "NAME": "Traun, Ehrenreich (1610\u20131659)",
        "DATEOFBIRTH": "1610 Jul 28",
        "DATEOFDEATH": "1659 Feb 19",
        "PLACEOFBIRTH": "Maissau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14538",
        "NAME": "Traun, Otto Ehrenreich (1644\u20131715), K\u00e4mmerer",
        "DATEOFBIRTH": "1644 Mar 13",
        "DATEOFDEATH": "1715 Sep 08",
        "PLACEOFBIRTH": "Aggstein in der Wachau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14539",
        "NAME": "Traun, Franz Anton (1674\u20131745), K\u00e4mmerer",
        "DATEOFBIRTH": "1674 Jun 04",
        "DATEOFDEATH": "1745 Sep 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14540",
        "NAME": "Traun, Ernst Julius (1646\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1646",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14544",
        "NAME": "Zichy, Adam (1655\u20131701), K\u00e4mmerer",
        "DATEOFBIRTH": "1655~",
        "DATEOFDEATH": "1701",
        "PLACEOFBIRTH": "Wei\u00dfbrunn in Ungarn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14545",
        "NAME": "Burghaus, Niklas (1562\u20131619)",
        "DATEOFBIRTH": "1562 Nov 12",
        "DATEOFDEATH": "1619 Jul 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "14546",
        "NAME": "Burghaus, Johann Niklas (1591\u20131640), K\u00e4mmerer",
        "DATEOFBIRTH": "1591 Jul 13",
        "DATEOFDEATH": "1640 Feb 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14547",
        "NAME": "Hohberg, Karl (1551\u2013\u00a0\u00a0\u00a0\u00a0), Vorschneider",
        "DATEOFBIRTH": "1551 Mar 16",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00fcttmannsdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14548",
        "NAME": "Strogeticky, Johann Heinrich (1600\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1646",
        "PLACEOFBIRTH": "Strojetic",
        "PLACEOFDEATH": "Vejprnice"
    },
    {
        "ID": "14549",
        "NAME": "Hroch, Abraham (1540\u20131596)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "Mezile\u0161ic",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14550",
        "NAME": "Larisch von Ellguth, Niklas (1460\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14551",
        "NAME": "Larisch von Ellguth, Johann (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14552",
        "NAME": "Larisch von Ellguth, Georg (1520\u20131588)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1588 Mai 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14553",
        "NAME": "Larisch von Ellguth, Friedrich (1550\u20131608)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14554",
        "NAME": "Larisch von Ellguth, Heinrich (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14555",
        "NAME": "Larisch von Ellguth, Johann Friedrich (1631\u20131698), Landeshauptmann von Teschen",
        "DATEOFBIRTH": "1631",
        "DATEOFDEATH": "1698",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14556",
        "NAME": "Larisch von Ellguth, Heinrich Ferdinand (1670\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1670~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14557",
        "NAME": "Larisch von Ellguth, Albrecht (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14558",
        "NAME": "Larisch von Ellguth, Johann (1540\u20131589), Panetier",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14559",
        "NAME": "Thurn, Martin (1560\u20131611)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "Lipnitz an der Sasau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14560",
        "NAME": "Gavre, Georg Konrad (1588\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Friesen in Brabant",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14561",
        "NAME": "Gavre, Peter Ernst (1590\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Friesen in Brabant",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14562",
        "NAME": "Merode, Konrad (1573\u20131653)",
        "DATEOFBIRTH": "1573",
        "DATEOFDEATH": "1653",
        "PLACEOFBIRTH": "Weilerswist",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14563",
        "NAME": "Sch\u00f6ning, Johann Adam (1641\u20131696)",
        "DATEOFBIRTH": "1641 Okt 01",
        "DATEOFDEATH": "1696 Aug 28",
        "PLACEOFBIRTH": "Tamsel",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "14564",
        "NAME": "Mosch, Felizian (1560\u20131621)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14565",
        "NAME": "Sfondrati, Franz (1493\u20131550), Bischof von Cremona",
        "DATEOFBIRTH": "1493 Okt 26",
        "DATEOFDEATH": "1550 Jul 31",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Cremona"
    },
    {
        "ID": "14566",
        "NAME": "Sfondrati, Niklas (1535\u20131591), Papst Gregor\u00a0XIV.",
        "DATEOFBIRTH": "1535 Feb 11",
        "DATEOFDEATH": "1591 Okt 16",
        "PLACEOFBIRTH": "Somma Lombardo",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "14567",
        "NAME": "Sfondrati, Paul (1538\u20131587)",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1587 Apr 23",
        "PLACEOFBIRTH": "Somma Lombardo",
        "PLACEOFDEATH": "Torino"
    },
    {
        "ID": "14568",
        "NAME": "Sfondrati, Franz (1570\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14569",
        "NAME": "Sfondrati, Siegmund (1600\u20131652)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1652 Mai 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Grevelingen"
    },
    {
        "ID": "14570",
        "NAME": "Nostitz, Hartwig (1290\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1290~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14571",
        "NAME": "Nostitz, Niklas (1330\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1330~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14572",
        "NAME": "Nostitz, Friedrich (1360\u20131420)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1420~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14573",
        "NAME": "Nostitz, Heinrich (1320\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14574",
        "NAME": "Nostitz, Otto (1350\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1350~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Unw\u00fcrde in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14575",
        "NAME": "Nostitz, Otto (1390\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Unw\u00fcrde in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14576",
        "NAME": "Nostitz, Ulrich (1425\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Unw\u00fcrde in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14577",
        "NAME": "Nostitz, Hartwig (1395\u20131447)",
        "DATEOFBIRTH": "1395~",
        "DATEOFDEATH": "1447",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14578",
        "NAME": "Nostitz, Heinrich (1390\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14579",
        "NAME": "Nostitz, Johann (1400\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14580",
        "NAME": "Nostitz, Otto (1630\u20131689), K\u00e4mmerer",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1689 Jan 21",
        "PLACEOFBIRTH": "Seidenberg in der Lausitz",
        "PLACEOFDEATH": "Reibersdorf in der Lausitz"
    },
    {
        "ID": "14581",
        "NAME": "Nostitz, Johann (1435\u20131479)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1479",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lampersdorf an der Oder"
    },
    {
        "ID": "14582",
        "NAME": "Nostitz, Friedrich (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14583",
        "NAME": "Nostitz, Georg (1485\u20131556), Landeshauptmann von Wohlau",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1556",
        "PLACEOFBIRTH": "Damitsch in Schlesien",
        "PLACEOFDEATH": "Wohlau in Schlesien"
    },
    {
        "ID": "14584",
        "NAME": "Nostitz, Christoph (1530\u20131598)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Ransen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14585",
        "NAME": "Nostitz, Otto (1455\u20131512)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "Tzschocha am Queis",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14586",
        "NAME": "Nostitz, Otto (1490\u20131545)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1545",
        "PLACEOFBIRTH": "Rothenburg in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14587",
        "NAME": "Nostitz, Hieronym (1523\u20131584), Landeshauptmann von G\u00f6rlitz",
        "DATEOFBIRTH": "1523",
        "DATEOFDEATH": "1584 Nov 30",
        "PLACEOFBIRTH": "Neundorf an der Nei\u00dfe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14588",
        "NAME": "Nostitz, Otto (1574\u20131630), Reichshofrat",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1630 Dez 18",
        "PLACEOFBIRTH": "Neundorf an der Nei\u00dfe",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14589",
        "NAME": "Nostitz, Christoph (1575\u20131625), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1625",
        "PLACEOFBIRTH": "Ransen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14590",
        "NAME": "Nostitz, Ulrich (1500\u20131552), Landeshauptmann der Oberlausitz",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1552 Okt 13",
        "PLACEOFBIRTH": "Unw\u00fcrde in der Lausitz",
        "PLACEOFDEATH": "Ruppersdorf in der Lausitz"
    },
    {
        "ID": "14591",
        "NAME": "Nostitz, Hartwig (1536\u20131607)",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1607 Mar 12",
        "PLACEOFBIRTH": "Unw\u00fcrde in der Lausitz",
        "PLACEOFDEATH": "Warnsdorf in B\u00f6hmen"
    },
    {
        "ID": "14592",
        "NAME": "Nostitz, Christian (1584\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1660 Dez 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Seidenberg in der Lausitz"
    },
    {
        "ID": "14593",
        "NAME": "Nostitz, Hartwig (1460\u20131520)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1520",
        "PLACEOFBIRTH": "Unw\u00fcrde in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14594",
        "NAME": "Nostitz, Kaspar (1420\u20131490)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1490",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Tzschocha am Queis"
    },
    {
        "ID": "14595",
        "NAME": "Nostitz, Hartwig (1460\u20131510)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1510",
        "PLACEOFBIRTH": "Tzschocha am Queis",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14596",
        "NAME": "Nostitz, Johann (1495\u20131565)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1565",
        "PLACEOFBIRTH": "Tzschocha am Queis",
        "PLACEOFDEATH": "Rengersdorf am Queis"
    },
    {
        "ID": "14597",
        "NAME": "Nostitz, Abraham (1529\u20131592)",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1592 Aug 06",
        "PLACEOFBIRTH": "Tzschocha am Queis",
        "PLACEOFDEATH": "Tzschocha am Queis"
    },
    {
        "ID": "14598",
        "NAME": "Nostitz, Johann (1562\u20131616)",
        "DATEOFBIRTH": "1562",
        "DATEOFDEATH": "1616 Dez 05",
        "PLACEOFBIRTH": "Tzschocha am Queis",
        "PLACEOFDEATH": "Seifersdorf im Riesengebirge"
    },
    {
        "ID": "14599",
        "NAME": "Nostitz, Otto (1608\u20131666), Landeshauptmann von Schweidnitz und Jauer",
        "DATEOFBIRTH": "1608 Mai 24",
        "DATEOFDEATH": "1666 Mar 03",
        "PLACEOFBIRTH": "Seifersdorf im Riesengebirge",
        "PLACEOFDEATH": "Jauer in Schlesien"
    },
    {
        "ID": "14600",
        "NAME": "Habsburg, Albrecht (1559\u20131621), Statthalter der Spanischen Niederlande",
        "DATEOFBIRTH": "1559 Nov 15",
        "DATEOFDEATH": "1621 Jul 13",
        "PLACEOFBIRTH": "Neustadt im Steinfeld",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "14601",
        "NAME": "Klenau, Adaukt (1545\u20131609), Hofdiener",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "Janowitz an der Angel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14602",
        "NAME": "Klenau, Wilhelm (1592\u20131642), K\u00e4mmerer",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Janowitz an der Angel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14603",
        "NAME": "Klenau, Regina (1555\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Janowitz an der Angel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14604",
        "NAME": "Klenau, Johann (1550\u20131624), K\u00e4mmerer",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "Janowitz an der Angel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14605",
        "NAME": "Klenau, Wilhelm (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14606",
        "NAME": "Sedlnitzky von Choltitz, Johann Wenzel (1590\u20131648)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1648 Okt 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Weigelsdorf in M\u00e4hren"
    },
    {
        "ID": "14607",
        "NAME": "Hase von Hasenburg, Anna (1603\u20131638)",
        "DATEOFBIRTH": "1603",
        "DATEOFDEATH": "1638 Jul 15",
        "PLACEOFBIRTH": "Rade\u0161\u00edn",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14608",
        "NAME": "Zierotin, Bartlome (1515\u20131559)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1559",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14609",
        "NAME": "Zierotin, Johann (1548\u20131582)",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1582",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14610",
        "NAME": "Zierotin, Lassel Valentin (1579\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1579 Dez 07",
        "DATEOFDEATH": "1638 Apr 03",
        "PLACEOFBIRTH": "Lundenburg",
        "PLACEOFDEATH": "Posen"
    },
    {
        "ID": "14611",
        "NAME": "Zierotin, Johann Dionys (1580\u20131616), K\u00e4mmerer",
        "DATEOFBIRTH": "1580",
        "DATEOFDEATH": "1616 Mai 11",
        "PLACEOFBIRTH": "Brandeis an der Adler",
        "PLACEOFDEATH": "Seelowitz"
    },
    {
        "ID": "14612",
        "NAME": "Schlick, Stephan (1487\u20131526)",
        "DATEOFBIRTH": "1487 Dez 24",
        "DATEOFDEATH": "1526 Aug 29",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": "Moh\u00e1cs"
    },
    {
        "ID": "14613",
        "NAME": "Schlick, Sibylla (1522\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14614",
        "NAME": "Nostitz, Sophia (1582\u20131656)",
        "DATEOFBIRTH": "1582 Dez 15",
        "DATEOFDEATH": "1656 Mar 23",
        "PLACEOFBIRTH": "Neundorf an der Nei\u00dfe",
        "PLACEOFDEATH": "Seifersdorf im Riesengebirge"
    },
    {
        "ID": "14615",
        "NAME": "Nostitz, Johann (1505\u20131552)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1552",
        "PLACEOFBIRTH": "Unw\u00fcrde in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14616",
        "NAME": "Nostitz, Niklas (1535\u20131590), Hofkammerrat",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1590 Mar 23",
        "PLACEOFBIRTH": "Cunewalde",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14617",
        "NAME": "Nostitz, Hartwig (1565\u20131625)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1625~",
        "PLACEOFBIRTH": "Tzschocha am Queis",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14618",
        "NAME": "Nostitz, Johann Christoph (1600\u20131641)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1641 Mar 11",
        "PLACEOFBIRTH": "Tzschocha am Queis",
        "PLACEOFDEATH": "Sch\u00f6nberg am Rothwasser"
    },
    {
        "ID": "14619",
        "NAME": "Nostitz, Johann Christoph (1635\u20131680), Reichshofrat",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1680 Feb 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rothenburg in der Lausitz"
    },
    {
        "ID": "14620",
        "NAME": "Nostitz, Anton Johann (1659\u20131736), Geheimer Rat",
        "DATEOFBIRTH": "1659 Jun 13",
        "DATEOFDEATH": "1736 Okt 30",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Falkenau an der Eger"
    },
    {
        "ID": "14621",
        "NAME": "Nostitz, Wenzel Desider (1665\u20131700), K\u00e4mmerer",
        "DATEOFBIRTH": "1665 Mai 24",
        "DATEOFDEATH": "1700 Dez 10",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "T\u00fcrmitz"
    },
    {
        "ID": "14622",
        "NAME": "Nostitz, Christoph Wenzel (1648\u20131712), Landeshauptmann von Glogau",
        "DATEOFBIRTH": "1648 Sep 14",
        "DATEOFDEATH": "1712 Feb 16",
        "PLACEOFBIRTH": "Rokitnitz im Adlergebirge",
        "PLACEOFDEATH": "Lobris"
    },
    {
        "ID": "14623",
        "NAME": "Nostitz, Otto Ferdinand (1654\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1654",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rokitnitz im Adlergebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14624",
        "NAME": "Nostitz, Johann Karl (1673\u20131740), K\u00e4mmerer",
        "DATEOFBIRTH": "1673",
        "DATEOFDEATH": "1740 Apr 17",
        "PLACEOFBIRTH": "Lobris",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14625",
        "NAME": "Nostitz, Otto Wenzel (1674\u20131751), K\u00e4mmerer",
        "DATEOFBIRTH": "1674",
        "DATEOFDEATH": "1751 Apr 16",
        "PLACEOFBIRTH": "Lobris",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14626",
        "NAME": "Nostitz, Heinrich (1495\u20131564)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1564",
        "PLACEOFBIRTH": "Rothenburg in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14627",
        "NAME": "Nostitz, Heinrich (1531\u20131592)",
        "DATEOFBIRTH": "1531",
        "DATEOFDEATH": "1592 Sep 22",
        "PLACEOFBIRTH": "Noes in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14628",
        "NAME": "Nostitz, Johann (1562\u20131619), Landeshauptmann von Wohlau",
        "DATEOFBIRTH": "1562 Mar 08",
        "DATEOFDEATH": "1619 Jul 29",
        "PLACEOFBIRTH": "Noes in der Lausitz",
        "PLACEOFDEATH": "Strenz in Schlesien"
    },
    {
        "ID": "14629",
        "NAME": "Nostitz, Heinrich (1563\u20131629), Truchsess",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Noes in der Lausitz",
        "PLACEOFDEATH": "Lawalde"
    },
    {
        "ID": "14630",
        "NAME": "Rosenberger von Lerchenau, Georg Niklas (1623\u20131695), Geheimer Rat",
        "DATEOFBIRTH": "1623 Dez 06",
        "DATEOFDEATH": "1695 Apr 28",
        "PLACEOFBIRTH": "Sankt Andr\u00e4 im Lavanttal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14631",
        "NAME": "Przichowitz, Georg (1530\u20131596)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14632",
        "NAME": "Przichowitz, Johann (1560\u20131620)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1620~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14633",
        "NAME": "Przichowitz, Georg (1565\u20131620)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1620~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14634",
        "NAME": "Przichowitz, Peter Georg (1595\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14635",
        "NAME": "Przichowitz, Johann Karl (1595\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14636",
        "NAME": "Rosdraszow, Johann (1539\u20131585), Obersthofmeister",
        "DATEOFBIRTH": "1539",
        "DATEOFDEATH": "1585",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Blatn\u00e1"
    },
    {
        "ID": "14637",
        "NAME": "Rosdraszow, Wenzel (1581\u20131625), K\u00e4mmerer",
        "DATEOFBIRTH": "1581",
        "DATEOFDEATH": "1625 Apr 16",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Pomsdorf in Schlesien"
    },
    {
        "ID": "14638",
        "NAME": "Rosdraszow, Franz Ignaz (1620\u20131691), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1691 Mai 20",
        "PLACEOFBIRTH": "Blatn\u00e1",
        "PLACEOFDEATH": "Blatn\u00e1"
    },
    {
        "ID": "14639",
        "NAME": "Klenau, Elisabeth (1625\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Janowitz an der Angel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14640",
        "NAME": "Martinitz, Johann (1515\u20131577), Burggraf von Karlstein",
        "DATEOFBIRTH": "1515",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "Smetschna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14641",
        "NAME": "Martinitz, Sedeslaus (1542\u2013\u00a0\u00a0\u00a0\u00a0), Oberstm\u00fcnzmeister in B\u00f6hmen",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Smetschna",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14642",
        "NAME": "Martinitz, Georg (1546\u20131598), Oberstkanzler von B\u00f6hmen",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1598 Jan 22",
        "PLACEOFBIRTH": "Smetschna",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14643",
        "NAME": "Wrzesowitz, Heinrich (1460\u20131515)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1515",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14644",
        "NAME": "Wrzesowitz, Georg (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Brozany an der Eger",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14645",
        "NAME": "Wrzesowitz, Siegmund (1520\u20131588)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "Brozany an der Eger",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14646",
        "NAME": "Wrzesowitz, Georg (1550\u2013\u00a0\u00a0\u00a0\u00a0), Vorschneider",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Brozany an der Eger",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14647",
        "NAME": "Mittrowsky, Peter (1530\u20131571)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Nemy\u0161l",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14648",
        "NAME": "Mittrowsky, Bosel (1560\u20131608)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "Nemy\u0161l",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14649",
        "NAME": "Mittrowsky, Georg (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Nemy\u0161l",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14650",
        "NAME": "Seebach, Johann Georg (1594\u20131653), K\u00e4mmerer",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1653 Sep 22",
        "PLACEOFBIRTH": "Stra\u00dfburg im Elsass",
        "PLACEOFDEATH": "Girona"
    },
    {
        "ID": "14651",
        "NAME": "Paar, Maximilian (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14652",
        "NAME": "D\u00f6rnberg, Veit Kaspar (1590\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1633",
        "PLACEOFBIRTH": "Hausen am R\u00e4uberswald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14653",
        "NAME": "Beck von Leopoldsdorf, Hannibal (1556\u20131608)",
        "DATEOFBIRTH": "1556",
        "DATEOFDEATH": "1608 Mar",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14654",
        "NAME": "Beck von Leopoldsdorf, Johann Baptist (1566\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14655",
        "NAME": "Beck von Leopoldsdorf, Joachim (1567\u20131605)",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14656",
        "NAME": "Czeika von Olbramowitz, Johann Adam (1600\u20131635), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "Kolin an der Elbe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14657",
        "NAME": "Gilleis von Sonnberg, Wolfgang Georg (1530\u20131593), K\u00e4mmerer",
        "DATEOFBIRTH": "1530",
        "DATEOFDEATH": "1593 Mai 31",
        "PLACEOFBIRTH": "Hartenstein in der Wachau",
        "PLACEOFDEATH": "Sonnberg im Weinviertel"
    },
    {
        "ID": "14658",
        "NAME": "Gilleis von Sonnberg, Andreas (1583\u20131624), K\u00e4mmerer",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1624 Jan 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14659",
        "NAME": "Gilleis von Sonnberg, Wolfgang Georg (1610\u20131651)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1651 Jul 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14660",
        "NAME": "Gilleis von Sonnberg, Georg Julius (1641\u20131700), K\u00e4mmerer",
        "DATEOFBIRTH": "1641 Sep 15",
        "DATEOFDEATH": "1700 Sep 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14661",
        "NAME": "Sedlnitzky von Choltitz, Siegmund (1490\u20131547)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1547 Apr 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Partschendorf"
    },
    {
        "ID": "14662",
        "NAME": "Sedlnitzky von Choltitz, Wenzel (1520\u20131588)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1588 Jun 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Partschendorf"
    },
    {
        "ID": "14663",
        "NAME": "Sedlnitzky von Choltitz, Albrecht (1550\u20131608), Truchsess",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14664",
        "NAME": "Sedlnitzky von Choltitz, Johann (1530\u20131573)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1573 Feb 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sedlnice"
    },
    {
        "ID": "14665",
        "NAME": "Sedlnitzky von Choltitz, Siegmund (1560\u20131606)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1606 Jan 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wagstadt"
    },
    {
        "ID": "14666",
        "NAME": "Mariani, Fabriz (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14667",
        "NAME": "Bergonzi, Aurel (1585\u2013\u00a0\u00a0\u00a0\u00a0), Vorschneider",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Parma",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14668",
        "NAME": "Bordogna, Bonus (1482\u20131560)",
        "DATEOFBIRTH": "1482",
        "DATEOFDEATH": "1560",
        "PLACEOFBIRTH": "Bergamo",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "14669",
        "NAME": "Colloredo, Hermes (1622\u20131692)",
        "DATEOFBIRTH": "1622 Mar 28",
        "DATEOFDEATH": "1692",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14670",
        "NAME": "Geyer von Osterburg, Oswald (1430\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14671",
        "NAME": "Geyer von Osterburg, Adam (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14672",
        "NAME": "Geyer von Osterburg, Johann (1500\u20131553)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1553",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14673",
        "NAME": "Geyer von Osterburg, Christoph (1540\u20131602)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14674",
        "NAME": "Geyer von Osterburg, Johann Adam (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14675",
        "NAME": "Geyer von Osterburg, Johann (1460\u20131525)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1525 Sep 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14676",
        "NAME": "Geyer von Osterburg, Roman (1490\u20131538)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1538",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14677",
        "NAME": "Geyer von Osterburg, Wilhelm (1520\u20131597)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14678",
        "NAME": "Geyer von Osterburg, Ferdinand (1554\u20131594), Truchsess",
        "DATEOFBIRTH": "1554 Apr 02",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "14679",
        "NAME": "Geyer von Osterburg, Bartlome (1400\u20131468)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1468",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "14680",
        "NAME": "Bordogna, Lorenz (1510\u20131559)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1559",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "14681",
        "NAME": "Bordogna, Johann Baptist (1538\u20131593)",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1593 Dez",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "14682",
        "NAME": "Bordogna, Lorenz (1574\u20131612)",
        "DATEOFBIRTH": "1574 Jun 12",
        "DATEOFDEATH": "1612 Mar 21",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "14683",
        "NAME": "Bordogna, Lorenz (1612\u20131651)",
        "DATEOFBIRTH": "1612 Nov 07",
        "DATEOFDEATH": "1651 Aug 12",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "14684",
        "NAME": "Caudir genannt Spiegel, Johann (1510\u20131579), Hofdolmetscher",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1579 Aug 30",
        "PLACEOFBIRTH": "Stroppendorf",
        "PLACEOFDEATH": "Glatz:Augustinerkloster"
    },
    {
        "ID": "14685",
        "NAME": "Rappach, Karl Ferdinand (1620\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1664 Okt 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14686",
        "NAME": "Rappach, Karl Ernst (1649\u20131719), K\u00e4mmerer",
        "DATEOFBIRTH": "1649 Mar 03",
        "DATEOFDEATH": "1719 Jul 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14687",
        "NAME": "Schrepel von Schrepelsperg, Johann Chrysostom (1570\u20131630), Hofdiener",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1630~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14688",
        "NAME": "Pinta von Bukowan, Wenzel (1580\u20131632), Panetier",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14689",
        "NAME": "Prager von Windhaag, Johann Christoph (1542\u20131606), Mundschenk",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "Windhaag im Machland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14690",
        "NAME": "Eppelmann, Peter (1589\u20131648)",
        "DATEOFBIRTH": "1589 Feb 08",
        "DATEOFDEATH": "1648 Mai 17",
        "PLACEOFBIRTH": "Hadamar",
        "PLACEOFDEATH": "Zusmarshausen"
    },
    {
        "ID": "14691",
        "NAME": "Falbenhaupt, Heinrich (1490\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Raipoltenbach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14692",
        "NAME": "Falbenhaupt, Jakob (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Raipoltenbach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14693",
        "NAME": "Falbenhaupt, Johann Jakob (1555\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14694",
        "NAME": "Falbenhaupt, Georg Christoph (1590\u20131646)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1646 Jul 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "14695",
        "NAME": "Falbenhaupt, Bernhard (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14696",
        "NAME": "Falbenhaupt, Gottfried (1595\u2013\u00a0\u00a0\u00a0\u00a0), Hofkriegsrat",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14697",
        "NAME": "Falbenhaupt, Jakob (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14698",
        "NAME": "Falbenhaupt, Georg Siegmund (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14699",
        "NAME": "Falbenhaupt, Georg Ferdinand (1650\u20131720), Geheimer Rat",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1720 Jan",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "14700",
        "NAME": "Habsburg, Katharina (1507\u20131578), K\u00f6nigin von Portugal",
        "DATEOFBIRTH": "1507 Jan 14",
        "DATEOFDEATH": "1578 Feb 12",
        "PLACEOFBIRTH": "Torquemada",
        "PLACEOFDEATH": "Lisboa"
    },
    {
        "ID": "14701",
        "NAME": "Dohna, Karl Hannibal (1588\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1588 Aug 08",
        "DATEOFDEATH": "1633 Feb 21",
        "PLACEOFBIRTH": "Kraschen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14702",
        "NAME": "Dohna, Heinrich (1590\u20131651), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1651 Feb 27",
        "PLACEOFBIRTH": "Kraschen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14703",
        "NAME": "Dohna, Otto Abraham (1618\u20131646)",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1646 Aug 27",
        "PLACEOFBIRTH": "Wartenberg an der Weide",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14704",
        "NAME": "Dohna, Johann Georg (1620\u20131683)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1683",
        "PLACEOFBIRTH": "Wartenberg an der Weide",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14705",
        "NAME": "Dohna, Karl Hannibal (1645\u20131711), K\u00e4mmerer",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "1711 Mai 10",
        "PLACEOFBIRTH": "Wartenberg an der Weide",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "14706",
        "NAME": "Dohna, Eleonora Eusebia (1613\u20131676)",
        "DATEOFBIRTH": "1613",
        "DATEOFDEATH": "1676 Nov 22",
        "PLACEOFBIRTH": "Wartenberg an der Weide",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "14707",
        "NAME": "Dohna, Z\u00e4zilia Renata (1630\u20131690)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1690",
        "PLACEOFBIRTH": "Wartenberg an der Weide",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "14708",
        "NAME": "Concini, Zyprian (\u00a0\u00a0\u00a0\u00a0\u20131621), Hofkriegsrat",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "1621 Mai 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Baden am Gebirge"
    },
    {
        "ID": "14709",
        "NAME": "Concini, Ferdinand (1592\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1639 Apr 23",
        "PLACEOFBIRTH": "Wei\u00dfenburg an der Pielach",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "14710",
        "NAME": "Concini, Anton (1420\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14711",
        "NAME": "Concini, Bartlome (1450\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14712",
        "NAME": "Concini, Siegmund (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14713",
        "NAME": "Concini, Christoph (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14714",
        "NAME": "Concini, Konrad (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14715",
        "NAME": "Concini, Niklas (1455\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14716",
        "NAME": "Concini, Anton (1485\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14717",
        "NAME": "Concini, Christoph (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14718",
        "NAME": "Concini, Ehrenreich (1540\u20131586)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14719",
        "NAME": "Concini, Volkhard (1575\u20131628)",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14720",
        "NAME": "Concini, Ehrenreich Christoph (1605\u20131668), Hofkammerrat",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1668",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14721",
        "NAME": "Concini, Johann Volkhard (1640\u20131713), K\u00e4mmerer",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1713 Jan 25",
        "PLACEOFBIRTH": "Wocking",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14722",
        "NAME": "Concini, Christoph (1550\u20131596), K\u00e4mmerer",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14723",
        "NAME": "Concini, Ferdinand (1552\u20131612), Reichshofrat",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "1612 Jan 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14724",
        "NAME": "Concini, Anna (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14725",
        "NAME": "Concini, Polyxena (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14726",
        "NAME": "Concini, Lukrezia (1560\u20131611)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14727",
        "NAME": "Concini, Christoph Ferdinand (1650\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wocking",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14728",
        "NAME": "Knobelsdorff, Sebastian (1496\u20131568)",
        "DATEOFBIRTH": "1496",
        "DATEOFDEATH": "1568 Sep 08",
        "PLACEOFBIRTH": "R\u00fcckersdorf an der Briesnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14729",
        "NAME": "Knobelsdorff, Maximilian (1539\u20131609), K\u00e4mmerer",
        "DATEOFBIRTH": "1539",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "R\u00fcckersdorf an der Briesnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14730",
        "NAME": "Knobelsdorff, Martin (1596\u20131659)",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1659 Feb 09",
        "PLACEOFBIRTH": "Reichenbach im Eulengebirge",
        "PLACEOFDEATH": "Kammendorf an der Weistritz"
    },
    {
        "ID": "14731",
        "NAME": "Knobelsdorff, Lorenz (1420\u20131480)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1480~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14732",
        "NAME": "Knobelsdorff, Johann (1450\u20131532)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1532",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14733",
        "NAME": "Knobelsdorff, Georg (1520\u20131590)",
        "DATEOFBIRTH": "1520",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14734",
        "NAME": "Knobelsdorff, Johann (1550\u20131620)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1620~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14735",
        "NAME": "Knobelsdorff, Christian Ernst (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14736",
        "NAME": "Knobelsdorff, Friedrich Albrecht (1590\u20131660), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1660~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Alessandria im Piemont"
    },
    {
        "ID": "14737",
        "NAME": "Knobelsdorff, Georg (1440\u20131499)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1499",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14738",
        "NAME": "Knobelsdorff, Johann Georg (1580\u20131637)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14739",
        "NAME": "Knobelsdorff, Kaspar Siegmund (1635\u20131675), Truchsess",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1675",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14740",
        "NAME": "Mettich von Tschetschau, Christoph (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Silbitz in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14741",
        "NAME": "Mettich von Tschetschau, Joachim (1540\u20131612), Landeshauptmann von Oppeln",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "Silbitz in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14742",
        "NAME": "Mettich von Tschetschau, Niklas (1545\u20131589)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "Silbitz in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14743",
        "NAME": "Mettich von Tschetschau, Johann Joachim (1578\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1646 Sep 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Oppeln"
    },
    {
        "ID": "14744",
        "NAME": "Mettich von Tschetschau, Niklas (1580\u20131621), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1621 Jan 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14745",
        "NAME": "Mettich von Tschetschau, Kaspar (1535\u20131603)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "Silbitz in Schlesien",
        "PLACEOFDEATH": "Leipzig"
    },
    {
        "ID": "14746",
        "NAME": "Mettich von Tschetschau, Johann (1565\u20131610), K\u00e4mmerer",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1610 Jun 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14747",
        "NAME": "Mettich von Tschetschau, Christoph (1530\u20131605), Truchsess",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "Silbitz in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14748",
        "NAME": "Mettich von Tschetschau, Karl Joachim (1627\u20131684)",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1684 Sep 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14749",
        "NAME": "Pfeilberg, Johann (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pfeilburg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14750",
        "NAME": "Kottulina, Christoph (1580\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14751",
        "NAME": "Geyer von Osterburg, Johann Ehrenreich (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Inzersdorf am Wienerberge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14752",
        "NAME": "Dohna, Otto (1555\u20131610)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1610 Mar 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14753",
        "NAME": "Dohna, Emilia (1590\u20131643)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1643 Nov 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Tachau an der Mies:Paulanerkirche"
    },
    {
        "ID": "14754",
        "NAME": "Wartenberg, Johann (1480\u20131543), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1480 Mai 01",
        "DATEOFDEATH": "1543 Okt 02",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Zv\u00ed\u0159etice"
    },
    {
        "ID": "14755",
        "NAME": "Wartenberg, Adam (1510\u20131564)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1564",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14756",
        "NAME": "Wartenberg, Karl (1553\u20131612)",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1612 Aug 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Turnov"
    },
    {
        "ID": "14757",
        "NAME": "Wartenberg, Johann Georg (1580\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1647 Jun 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bamberg"
    },
    {
        "ID": "14758",
        "NAME": "Dohna, Heinrich (1520\u20131563)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1563 Okt 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pernau in Livland"
    },
    {
        "ID": "14759",
        "NAME": "Dohna, Beda (1550\u20131586)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14760",
        "NAME": "Dohna, Otto (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14761",
        "NAME": "Dohna, Maria Magdalena (1605\u20131661)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1661 Mai 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trp\u00edsty"
    },
    {
        "ID": "14762",
        "NAME": "Dohna, Anna Maria (1610\u20131655)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1655",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "J\u00e4gerndorf"
    },
    {
        "ID": "14763",
        "NAME": "Dohna, Heinrich (1420\u20131485)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1485~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14764",
        "NAME": "Dohna, Christoph (1460\u20131509)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1509 Aug 14",
        "PLACEOFBIRTH": "Kraschen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14765",
        "NAME": "Dohna, Kaspar (1490\u20131556)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1556",
        "PLACEOFBIRTH": "Kraschen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14766",
        "NAME": "Dohna, Stenzel (1453\u20131504)",
        "DATEOFBIRTH": "1453",
        "DATEOFDEATH": "1504",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14767",
        "NAME": "Dohna, Peter (1482\u20131553)",
        "DATEOFBIRTH": "1482",
        "DATEOFDEATH": "1553 Jan 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14768",
        "NAME": "Dohna, Achaz (1533\u20131601)",
        "DATEOFBIRTH": "1533 Mai 17",
        "DATEOFDEATH": "1601 Okt 18",
        "PLACEOFBIRTH": "Stuhm",
        "PLACEOFDEATH": "Schlobitten"
    },
    {
        "ID": "14769",
        "NAME": "Dohna, Christoph (1583\u20131637), Mundschenk",
        "DATEOFBIRTH": "1583 Jun 27",
        "DATEOFDEATH": "1637 Jul 01",
        "PLACEOFBIRTH": "Mohrungen in Preu\u00dfen",
        "PLACEOFDEATH": "Orange"
    },
    {
        "ID": "14770",
        "NAME": "Danewitz, Balthasar (1520\u20131579)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1579 Apr 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "14771",
        "NAME": "Danewitz, Kaspar (1550\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14772",
        "NAME": "Danewitz, Balthasar (1560\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14773",
        "NAME": "Maltzan, Joachim (1492\u20131556)",
        "DATEOFBIRTH": "1492",
        "DATEOFDEATH": "1556 Jan 20",
        "PLACEOFBIRTH": "Neuburg an der Stepenitz",
        "PLACEOFDEATH": "Penzlin"
    },
    {
        "ID": "14774",
        "NAME": "Maltzan, Johann Bernhard (1526\u20131569), Landeshauptmann von Oppeln",
        "DATEOFBIRTH": "1526",
        "DATEOFDEATH": "1569 Mai 07",
        "PLACEOFBIRTH": "Graupen im Erzgebirge",
        "PLACEOFDEATH": "Lublin"
    },
    {
        "ID": "14775",
        "NAME": "Maltzan, Anna (1552\u20131583)",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "1583 Dez 29",
        "PLACEOFBIRTH": "Wartenberg an der Weide",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "14776",
        "NAME": "Maltzan, Joachim (1559\u20131625), Truchsess",
        "DATEOFBIRTH": "1559 Mai 11",
        "DATEOFDEATH": "1625 Jan 17",
        "PLACEOFBIRTH": "Wartenberg an der Weide",
        "PLACEOFDEATH": "Militsch"
    },
    {
        "ID": "14777",
        "NAME": "Scherffenberg, Georg (1548\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14778",
        "NAME": "Scherffenberg, Gotthard (1584\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1634 Nov 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14779",
        "NAME": "Blauen, Andreas (1554\u20131602), Landeshauptmann der Niederlausitz",
        "DATEOFBIRTH": "1554 Aug 16",
        "DATEOFDEATH": "1602 Feb 07",
        "PLACEOFBIRTH": "Seitwann",
        "PLACEOFDEATH": "Seitwann"
    },
    {
        "ID": "14780",
        "NAME": "Bee\u00df, Niklas (1440\u20131504)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1504",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14781",
        "NAME": "Bee\u00df, Niklas (1475\u20131540)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1540~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hohenwalde in Oberschlesien"
    },
    {
        "ID": "14782",
        "NAME": "Bee\u00df, Christoph (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hohenwalde in Oberschlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14783",
        "NAME": "Bee\u00df, Johann (1545\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hohenwalde in Oberschlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14784",
        "NAME": "Bee\u00df, Joachim (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hohenwalde in Oberschlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14785",
        "NAME": "Bee\u00df, Johann Adam (1595\u20131636)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Hohenwalde in Oberschlesien",
        "PLACEOFDEATH": "Olm\u00fctz in M\u00e4hren"
    },
    {
        "ID": "14786",
        "NAME": "Bee\u00df, Katharina Franziska (1626\u20131675)",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1675",
        "PLACEOFBIRTH": "Hohenwalde in Oberschlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14787",
        "NAME": "Bee\u00df, Anna Susanna (1627\u20131699)",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1699 Feb 12",
        "PLACEOFBIRTH": "Hohenwalde in Oberschlesien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14788",
        "NAME": "Dohna, Elisabeth (1565\u20131611)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1611 Aug 03",
        "PLACEOFBIRTH": "Kraschen",
        "PLACEOFDEATH": "Grafenstein in B\u00f6hmen"
    },
    {
        "ID": "14789",
        "NAME": "Dohna, Anna Maria (1595\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kraschen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14790",
        "NAME": "Sch\u00f6nburg auf Wesel, Simon Rudolf (1551\u20131608)",
        "DATEOFBIRTH": "1551",
        "DATEOFDEATH": "1608 Jan 16",
        "PLACEOFBIRTH": "Sch\u00f6nburg am Rhein",
        "PLACEOFDEATH": "Mont Quintin"
    },
    {
        "ID": "14791",
        "NAME": "Sch\u00f6nburg auf Wesel, Johann Karl (1591\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "Wesel am Mittelrhein",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14792",
        "NAME": "Enzmilner von Windhaag, Joachim (1600\u20131678)",
        "DATEOFBIRTH": "1600 Feb 21",
        "DATEOFDEATH": "1678 Mai 21",
        "PLACEOFBIRTH": "Babenhausen in Schwaben",
        "PLACEOFDEATH": "Windhaag im Machland"
    },
    {
        "ID": "14793",
        "NAME": "Erwitte, Theoderich Ottmar (1590\u20131631), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1631 Sep 17",
        "PLACEOFBIRTH": "Ebbinghausen am Hellweg",
        "PLACEOFDEATH": "Breitenfeld im Lindenthal"
    },
    {
        "ID": "14794",
        "NAME": "Zelking, Paul Wilhelm (1526\u20131567), Hartschierhauptmann",
        "DATEOFBIRTH": "1526 Jan 10",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14795",
        "NAME": "Zelking, Peter Wilhelm (1532\u20131562)",
        "DATEOFBIRTH": "1532 Jun 28",
        "DATEOFDEATH": "1562",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14796",
        "NAME": "Zelking, Johann Wilhelm (1561\u20131627), K\u00e4mmerer",
        "DATEOFBIRTH": "1561",
        "DATEOFDEATH": "1627 Jun 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Zelking im Mostviertel"
    },
    {
        "ID": "14797",
        "NAME": "Zelking, Karl Ludwig (1531\u20131577), K\u00e4mmerer",
        "DATEOFBIRTH": "1531 Jul 09",
        "DATEOFDEATH": "1577 Aug 19",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "14798",
        "NAME": "Zelking, Christoph Wilhelm (1575\u20131631)",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1631 Apr 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14799",
        "NAME": "Zelking, Ludwig Wilhelm (1606\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1606 Jun 15",
        "DATEOFDEATH": "1634 Apr 10",
        "PLACEOFBIRTH": "Sierndorf in der Stockerau",
        "PLACEOFDEATH": "Zelking im Mostviertel:Pfarrkirche"
    },
    {
        "ID": "14800",
        "NAME": "Habsburg, Anna (1585\u20131618), Kaiserin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1585 Okt 04",
        "DATEOFDEATH": "1618 Dez 15",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "14801",
        "NAME": "Wettin, August (1526\u20131586), Herzog zu Sachsen",
        "DATEOFBIRTH": "1526",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14802",
        "NAME": "Wettin, Christian (1560\u20131591), Herzog zu Sachsen",
        "DATEOFBIRTH": "1560",
        "DATEOFDEATH": "1591",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14803",
        "NAME": "Wettin, Christian (1583\u20131611), Herzog zu Sachsen",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14804",
        "NAME": "Wettin, Johann Georg (1585\u20131656), Herzog zu Sachsen",
        "DATEOFBIRTH": "1585 Mar 05",
        "DATEOFDEATH": "1656 Okt 08",
        "PLACEOFBIRTH": "Dresden",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "14805",
        "NAME": "Wettin, Johann Georg (1613\u20131680), Herzog zu Sachsen",
        "DATEOFBIRTH": "1613 Jun 10",
        "DATEOFDEATH": "1680 Sep 01",
        "PLACEOFBIRTH": "Dresden",
        "PLACEOFDEATH": "Freiberg in Sachsen:Dom"
    },
    {
        "ID": "14806",
        "NAME": "Wettin, Johann Georg (1647\u20131691), Herzog zu Sachsen",
        "DATEOFBIRTH": "1647 Jun 30",
        "DATEOFDEATH": "1691 Sep 22",
        "PLACEOFBIRTH": "Dresden",
        "PLACEOFDEATH": "T\u00fcbingen"
    },
    {
        "ID": "14807",
        "NAME": "Wettin, Johann Georg (1668\u20131694), Herzog zu Sachsen",
        "DATEOFBIRTH": "1668 Okt 18",
        "DATEOFDEATH": "1694 Apr 27",
        "PLACEOFBIRTH": "Dresden",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "14808",
        "NAME": "Wettin, Magdalena Sibylla (1617\u20131668)",
        "DATEOFBIRTH": "1617 Dez 23",
        "DATEOFDEATH": "1668 Jan 06",
        "PLACEOFBIRTH": "Dresden",
        "PLACEOFDEATH": "Altenburg in Th\u00fcringen"
    },
    {
        "ID": "14809",
        "NAME": "Wettin, Erdmut Sophia (1644\u20131670)",
        "DATEOFBIRTH": "1644 Feb 25",
        "DATEOFDEATH": "1670 Jun 22",
        "PLACEOFBIRTH": "Dresden",
        "PLACEOFDEATH": "Bayreuth"
    },
    {
        "ID": "14810",
        "NAME": "Liechtenstein von Nikolsburg, Christoph (1440\u20131506)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1506",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14811",
        "NAME": "Liechtenstein von Nikolsburg, Leonhard (1482\u20131534)",
        "DATEOFBIRTH": "1482 Dez 24",
        "DATEOFDEATH": "1534",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14812",
        "NAME": "Liechtenstein von Nikolsburg, Christoph (1520\u20131585), Hofdiener",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1585",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14813",
        "NAME": "Liechtenstein von Kastelkorn, Wilhelm (1380\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Karneid",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14814",
        "NAME": "Liechtenstein von Kastelkorn, Wilhelm (1390\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14815",
        "NAME": "Liechtenstein von Kastelkorn, Balthasar (1420\u20131478)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1478",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Leuchtenburg am Kalterer See"
    },
    {
        "ID": "14816",
        "NAME": "Liechtenstein von Kastelkorn, Ulrich (1450\u20131505), Bischof von Trient",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1505 Sep 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "14817",
        "NAME": "Liechtenstein von Kastelkorn, Georg (1415\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1415~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Karneid",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14818",
        "NAME": "Liechtenstein von Kastelkorn, Bartlome (1420\u20131462)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1462",
        "PLACEOFBIRTH": "Karneid",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14819",
        "NAME": "Liechtenstein von Kastelkorn, Johann (1445\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Karneid",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14820",
        "NAME": "Leibniz, Gottfried Wilhelm (1646\u20131716), Reichshofrat",
        "DATEOFBIRTH": "1646 Jul 01",
        "DATEOFDEATH": "1716 Nov 14",
        "PLACEOFBIRTH": "Leipzig",
        "PLACEOFDEATH": "Hannover"
    },
    {
        "ID": "14821",
        "NAME": "Schultz, Johann (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14822",
        "NAME": "Schultz, Johann Valentin (1630\u20131686)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1686",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14823",
        "NAME": "Scheidt von Leitersdorf, Polykarp (1575\u20131626), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1626 Jan 24",
        "PLACEOFBIRTH": "Leitersdorf im Raabtal",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "14824",
        "NAME": "B\u00fcren, Moritz (1604\u20131661), K\u00e4mmerer",
        "DATEOFBIRTH": "1604 Feb 12",
        "DATEOFDEATH": "1661 Nov 07",
        "PLACEOFBIRTH": "Ringelstein im Almetal",
        "PLACEOFDEATH": "Geist im Dreingau"
    },
    {
        "ID": "14825",
        "NAME": "Concini, Anna (1579\u20131667)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1667 Nov 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Traidendorf"
    },
    {
        "ID": "14826",
        "NAME": "Askanien, Christian (1568\u20131630), F\u00fcrst von Anhalt",
        "DATEOFBIRTH": "1568 Mai 11",
        "DATEOFDEATH": "1630 Apr 17",
        "PLACEOFBIRTH": "Bernburg an der Saale",
        "PLACEOFDEATH": "Bernburg an der Saale"
    },
    {
        "ID": "14827",
        "NAME": "Askanien, Christian (1599\u20131656), K\u00e4mmerer",
        "DATEOFBIRTH": "1599 Aug 10",
        "DATEOFDEATH": "1656 Sep 22",
        "PLACEOFBIRTH": "Amberg in der Oberpfalz",
        "PLACEOFDEATH": "Bernburg an der Saale"
    },
    {
        "ID": "14828",
        "NAME": "Askanien, Johann (1504\u20131551)",
        "DATEOFBIRTH": "1504 Sep 04",
        "DATEOFDEATH": "1551 Feb 04",
        "PLACEOFBIRTH": "Dessau",
        "PLACEOFDEATH": "Zerbst"
    },
    {
        "ID": "14829",
        "NAME": "Askanien, Joachim Ernst (1536\u20131586)",
        "DATEOFBIRTH": "1536 Okt 21",
        "DATEOFDEATH": "1586 Dez 16",
        "PLACEOFBIRTH": "Dessau",
        "PLACEOFDEATH": "Dessau"
    },
    {
        "ID": "14830",
        "NAME": "Rauchenberg, Ernst (1530\u20131591), Obersthofmeister",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1591",
        "PLACEOFBIRTH": "Salzburg",
        "PLACEOFDEATH": "Aschach in Tirol"
    },
    {
        "ID": "14831",
        "NAME": "Wrzesowitz, Johann Wenzel (1575\u20131605)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "Brozany an der Eger",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14832",
        "NAME": "Zippringer, Georg (1545\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14833",
        "NAME": "Preu\u00df von Preu\u00dfendorf, Daniel (1529\u20131611), Hofdiener",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1611 Mai 28",
        "PLACEOFBIRTH": "Grimma im Muldetal",
        "PLACEOFDEATH": "Freystadt in Niederschlesien"
    },
    {
        "ID": "14834",
        "NAME": "Grie\u00dfer, Christoph (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14835",
        "NAME": "Greiffenclau, Georg Friedrich (1573\u20131629), Erzbischof von Mainz",
        "DATEOFBIRTH": "1573 Sep 08",
        "DATEOFDEATH": "1629 Jul 06",
        "PLACEOFBIRTH": "Vollrads im Rheingau",
        "PLACEOFDEATH": "Mainz"
    },
    {
        "ID": "14836",
        "NAME": "Spaur, Franz Vigil (1609\u20131670), Bischof von Chiemsee",
        "DATEOFBIRTH": "1609 Jan 06",
        "DATEOFDEATH": "1670 Jan 09",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": "Spaur auf dem Nonsberg"
    },
    {
        "ID": "14837",
        "NAME": "Widmann, Johann (1570\u20131634)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14838",
        "NAME": "Widmann, Martin (1610\u20131688)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1688",
        "PLACEOFBIRTH": "Venedig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14839",
        "NAME": "Widmann, Ludwig (1614\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Venedig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14840",
        "NAME": "Widmann, Christoph (1617\u20131660)",
        "DATEOFBIRTH": "1617",
        "DATEOFDEATH": "1660 Sep 30",
        "PLACEOFBIRTH": "Venedig",
        "PLACEOFDEATH": "San Martino al Cimino"
    },
    {
        "ID": "14841",
        "NAME": "Lodron, Augustin (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14842",
        "NAME": "Lodron, Augustin (1540\u20131570), Mundschenk",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1570~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14843",
        "NAME": "Lodron, Felix (1537\u20131584)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14844",
        "NAME": "Scheidt von Leitersdorf, Georg (1540\u20131583)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1583 Jan 31",
        "PLACEOFBIRTH": "Leitersdorf im Raabtal",
        "PLACEOFDEATH": "Radkersburg"
    },
    {
        "ID": "14845",
        "NAME": "Scheidt von Leitersdorf, Judith (1569\u20131634)",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1634 Sep 21",
        "PLACEOFBIRTH": "Leitersdorf im Raabtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14846",
        "NAME": "Tschernembl, Christoph (1504\u20131538)",
        "DATEOFBIRTH": "1504 Jan 16",
        "DATEOFDEATH": "1538",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14847",
        "NAME": "Tschernembl, Johann (1536\u20131595), Truchsess",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1595 Aug 15",
        "PLACEOFBIRTH": "Schwertberg im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14848",
        "NAME": "Tschernembl, Georg Erasam (1567\u20131626)",
        "DATEOFBIRTH": "1567 Jan 26",
        "DATEOFDEATH": "1626 Nov 18",
        "PLACEOFBIRTH": "Schwertberg im M\u00fchlviertel",
        "PLACEOFDEATH": "Genf"
    },
    {
        "ID": "14849",
        "NAME": "Tschernembl, Johann Christoph (1565\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schwertberg im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14850",
        "NAME": "Trauttmansdorff, Hiob Hartmann (1540\u20131596)",
        "DATEOFBIRTH": "1540",
        "DATEOFDEATH": "1596 Aug 20",
        "PLACEOFBIRTH": "Totzenbach am Haspelwald",
        "PLACEOFDEATH": "Hatvan"
    },
    {
        "ID": "14851",
        "NAME": "Trauttmansdorff, Wolfgang Christoph (1570\u20131591)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1591 Nov 13",
        "PLACEOFBIRTH": "Totzenbach am Haspelwald",
        "PLACEOFDEATH": "Jena"
    },
    {
        "ID": "14852",
        "NAME": "Trauttmansdorff, Wolfgang Theoderich (1541\u20131594)",
        "DATEOFBIRTH": "1541",
        "DATEOFDEATH": "1594 Jul 02",
        "PLACEOFBIRTH": "Totzenbach am Haspelwald",
        "PLACEOFDEATH": "Leiben im Weitental"
    },
    {
        "ID": "14853",
        "NAME": "Hohenzollern, Friedrich (1430\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14854",
        "NAME": "Welsperg, Christoph (1520\u20131588)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14855",
        "NAME": "Welsperg, Dorothea (1559\u20131615)",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1615 Nov 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14856",
        "NAME": "Welsperg, Siegmund (1552\u20131613)",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14857",
        "NAME": "Welsperg, Jakob Hannibal (1593\u20131620)",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1620",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14858",
        "NAME": "Spaur, Franz (1598\u20131652)",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1652",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14859",
        "NAME": "Liechtenstein von Kastelkorn, Vespasian (1595\u20131657)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1657",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14860",
        "NAME": "Liechtenstein von Murau, Ulrich (1200\u20131275), Truchsess",
        "DATEOFBIRTH": "1200~",
        "DATEOFDEATH": "1275 Jan 26",
        "PLACEOFBIRTH": "Liechtenstein in der Steiermark",
        "PLACEOFDEATH": "Frauenburg in der Steiermark"
    },
    {
        "ID": "14861",
        "NAME": "Liechtenstein von Murau, Otto (1240\u20131311), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1240~",
        "DATEOFDEATH": "1311 Nov 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Murau"
    },
    {
        "ID": "14862",
        "NAME": "Liechtenstein von Murau, Otto (1280\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1280~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Murau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14863",
        "NAME": "Liechtenstein von Murau, Rudolf (1320\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Murau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14864",
        "NAME": "Liechtenstein von Murau, Otto (1360\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Murau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14865",
        "NAME": "Liechtenstein von Murau, Ulrich (1390\u20131476)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1476",
        "PLACEOFBIRTH": "Murau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14866",
        "NAME": "Liechtenstein von Murau, Niklas (1420\u20131495)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1495",
        "PLACEOFBIRTH": "Murau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14867",
        "NAME": "Liechtenstein von Murau, Achaz (1460\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Murau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14868",
        "NAME": "Liechtenstein von Murau, Otto (1500\u20131564)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1564 Mai 01",
        "PLACEOFBIRTH": "Murau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14869",
        "NAME": "Liechtenstein von Murau, Christoph (1530\u20131580)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1580",
        "PLACEOFBIRTH": "Murau",
        "PLACEOFDEATH": "Murau"
    },
    {
        "ID": "14870",
        "NAME": "Hohenlohe, Philipp Ernst (1584\u20131628)",
        "DATEOFBIRTH": "1584 Aug 11",
        "DATEOFDEATH": "1628 Jan 29",
        "PLACEOFBIRTH": "Langenburg an der Jagst",
        "PLACEOFDEATH": "Weikersheim im Taubertal"
    },
    {
        "ID": "14871",
        "NAME": "Landau, Georg (1500\u20131552)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1552 Nov 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "14872",
        "NAME": "Landau, Siegmund (1543\u20131606), Hofkammerrat",
        "DATEOFBIRTH": "1543 Mar 03",
        "DATEOFDEATH": "1606 Dez 13",
        "PLACEOFBIRTH": "Haus im M\u00fchlviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14873",
        "NAME": "Landau, Georg (1570\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rappottenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14874",
        "NAME": "Landau, Erasam (1575\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rappottenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14875",
        "NAME": "Hagek, Thaddai (1525\u20131600)",
        "DATEOFBIRTH": "1525",
        "DATEOFDEATH": "1600 Sep 01",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14876",
        "NAME": "Schwendi von Hohenlandsberg, Theoderich (1535\u20131600), Oberstj\u00e4germeister",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1600 Apr 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14877",
        "NAME": "Schwendi von Hohenlandsberg, Ehrenreich (1562\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1562",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14878",
        "NAME": "Bee\u00df, Johann (1539\u20131615), Hofdiener",
        "DATEOFBIRTH": "1539 Apr 24",
        "DATEOFDEATH": "1615 Sep 28",
        "PLACEOFBIRTH": "Karlsmarkt",
        "PLACEOFDEATH": "L\u00f6wen in Schlesien"
    },
    {
        "ID": "14879",
        "NAME": "Colloredo, Fabriz (1576\u20131645)",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "Colloredo di Monte Albano",
        "PLACEOFDEATH": "Florenz"
    },
    {
        "ID": "14880",
        "NAME": "Widmanstetter, Johann Albrecht (1506\u20131557)",
        "DATEOFBIRTH": "1506",
        "DATEOFDEATH": "1557 Mar 28",
        "PLACEOFBIRTH": "Nellingen auf der Alb",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "14881",
        "NAME": "Castelletti, Pilgram (1440\u20131509)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1509",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14882",
        "NAME": "Castelletti, Peter (1470\u20131525)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1525 Jul 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Numig an der Etsch"
    },
    {
        "ID": "14883",
        "NAME": "Castelletti, Johann (1500\u20131564)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1564",
        "PLACEOFBIRTH": "Numig an der Etsch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14884",
        "NAME": "Castelletti, Darius (1529\u20131606), Mundschenk",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "Numig an der Etsch",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14885",
        "NAME": "Castelletti, Ferdinand (1579\u20131646), Obersthofmeister",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1646 Jul 22",
        "PLACEOFBIRTH": "Numig an der Etsch",
        "PLACEOFDEATH": "Numig an der Etsch"
    },
    {
        "ID": "14886",
        "NAME": "Correggio, Bonaccorso (1450\u20131503)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1503 Dez",
        "PLACEOFBIRTH": "Correggio",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14887",
        "NAME": "Correggio, Manfred (1490\u20131546)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1546 Mar 20",
        "PLACEOFBIRTH": "Correggio",
        "PLACEOFDEATH": "Correggio"
    },
    {
        "ID": "14888",
        "NAME": "Correggio, Kamil (1533\u20131605)",
        "DATEOFBIRTH": "1533 Jun 22",
        "DATEOFDEATH": "1605 Jun 03",
        "PLACEOFBIRTH": "Correggio",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "14889",
        "NAME": "Correggio, Syrus (1590\u20131645)",
        "DATEOFBIRTH": "1590 Aug 13",
        "DATEOFDEATH": "1645 Okt 23",
        "PLACEOFBIRTH": "Correggio",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "14890",
        "NAME": "Correggio, Manfred (1412\u20131476)",
        "DATEOFBIRTH": "1412",
        "DATEOFDEATH": "1476 Feb",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Correggio"
    },
    {
        "ID": "14891",
        "NAME": "Correggio, Giselbrecht (1460\u20131518)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1518 Aug 26",
        "PLACEOFBIRTH": "Correggio",
        "PLACEOFDEATH": "Correggio"
    },
    {
        "ID": "14892",
        "NAME": "Correggio, Hieronym (1511\u20131572), Erzbischof von Tarent",
        "DATEOFBIRTH": "1511 Feb 17",
        "DATEOFDEATH": "1572 Okt 09",
        "PLACEOFBIRTH": "Correggio",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "14893",
        "NAME": "Gatta, Andreas (1635\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14894",
        "NAME": "Gonzaga, Pyrrhus (1540\u20131592), F\u00fcrst von Bozzolo",
        "DATEOFBIRTH": "1540 Mai 03",
        "DATEOFDEATH": "1592 Jun 15",
        "PLACEOFBIRTH": "San Martino dall\u2019Argine",
        "PLACEOFDEATH": "San Martino dall\u2019Argine"
    },
    {
        "ID": "14895",
        "NAME": "Lando, Julius (1549\u20131605), Truchsess",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1605 Nov 16",
        "PLACEOFBIRTH": "Piacenza",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "14896",
        "NAME": "Liechtenstein von Murau, Rudolf (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Murau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14897",
        "NAME": "Moscon, Johann Baptist (1575\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1646",
        "PLACEOFBIRTH": "Gurgfeld an der Save",
        "PLACEOFDEATH": "Rann an der Save"
    },
    {
        "ID": "14898",
        "NAME": "Rena, Rudolf (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14899",
        "NAME": "Bordogna, Christoph (1550\u20131613), Mundschenk",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14900",
        "NAME": "Capet, Karl (1433\u20131477), Herzog von Burgund",
        "DATEOFBIRTH": "1433 Nov 10",
        "DATEOFDEATH": "1477 Jan 05",
        "PLACEOFBIRTH": "Dijon",
        "PLACEOFDEATH": "Nancy"
    },
    {
        "ID": "14901",
        "NAME": "Herbrot, Jakob (1493\u20131564)",
        "DATEOFBIRTH": "1493",
        "DATEOFDEATH": "1564 Apr 21",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Neuburg an der Donau"
    },
    {
        "ID": "14902",
        "NAME": "Crawford, Maria (1500\u20131562)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1562",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14903",
        "NAME": "Herbrot, Maria (1518\u20131582)",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1582",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14904",
        "NAME": "Scheidt von Leitersdorf, Barbara (1610\u20131645)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1645 Dez 31",
        "PLACEOFBIRTH": "Leitersdorf im Raabtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14905",
        "NAME": "Falbenhaupt, Anna Regina (1625\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14906",
        "NAME": "Thurn, Amalia (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Thybein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14907",
        "NAME": "P\u00fcchler von Weitenegg, Anna (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14908",
        "NAME": "Promnitz, Benigna Polyxena (1594\u20131631)",
        "DATEOFBIRTH": "1594 Okt 11",
        "DATEOFDEATH": "1631 Mai 02",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Glogau in Oberschlesien"
    },
    {
        "ID": "14909",
        "NAME": "Enenkel von Albrechtsberg, Susanna (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Heinrichschlag im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14910",
        "NAME": "Damnitz, Juliana (1590\u20131625)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1625",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14911",
        "NAME": "Windischgr\u00e4tz, Katharina (1550\u20131582)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1582 Jul 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14912",
        "NAME": "Windischgr\u00e4tz, Salomena (1620\u20131665)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1665 Mai 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Tobitschau"
    },
    {
        "ID": "14913",
        "NAME": "Palant, Katharina (1570\u20131602)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rheineck im Ahrgau"
    },
    {
        "ID": "14914",
        "NAME": "Gavre, Franziska Konradina (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14915",
        "NAME": "Zinzendorf, Susanna (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14916",
        "NAME": "Traun, Barbara (1585\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1585 Nov 14",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14917",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Anna (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14918",
        "NAME": "Promnitz, Elisabeth (1596\u20131621)",
        "DATEOFBIRTH": "1596 Okt 13",
        "DATEOFDEATH": "1621 Jan 24",
        "PLACEOFBIRTH": "Ple\u00df in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14919",
        "NAME": "Kolowrat, Margarita (1615\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Liebstein in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14920",
        "NAME": "J\u00f6rger von Tollet, Katharina (1506\u20131543)",
        "DATEOFBIRTH": "1506 Dez 01",
        "DATEOFDEATH": "1543 Mar 03",
        "PLACEOFBIRTH": "Tollet an der Trattnach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14921",
        "NAME": "Enzmilner von Windhaag, Eva (1629\u20131700)",
        "DATEOFBIRTH": "1629 Feb 23",
        "DATEOFDEATH": "1700 Jan 03",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": "Windhaag im Machland"
    },
    {
        "ID": "14922",
        "NAME": "Lodron, Beatrix (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14923",
        "NAME": "Lodron, Barbara (1595\u20131660)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1660 Nov 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Nonnberg"
    },
    {
        "ID": "14924",
        "NAME": "Lamberg, Helena (1512\u20131539)",
        "DATEOFBIRTH": "1512",
        "DATEOFDEATH": "1539",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "14925",
        "NAME": "Wittelsbach, Anna (1525\u20131556), Gr\u00e4fin von Leonsberg",
        "DATEOFBIRTH": "1525",
        "DATEOFDEATH": "1556 Mai 18",
        "PLACEOFBIRTH": "Leonsberg an der Isar",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "14926",
        "NAME": "Widmanstetter, Hilaria Justina (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14927",
        "NAME": "Ossolin\u0301ski, Anna (1625\u20131651)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1651",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14928",
        "NAME": "Ligne, Antonia (1557\u20131626)",
        "DATEOFBIRTH": "1557 Mar 01",
        "DATEOFDEATH": "1626 Feb 26",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14929",
        "NAME": "Ligne, Karolina (1606\u20131630)",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1630",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14930",
        "NAME": "Hohenzollern, Maria (1614\u20131670)",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "1670 Mar 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Albi am Tarn"
    },
    {
        "ID": "14931",
        "NAME": "Hohenzollern, Franziska (1458\u20131512)",
        "DATEOFBIRTH": "1458",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Correggio"
    },
    {
        "ID": "14932",
        "NAME": "Hohenzollern, Magdalena (1465\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14933",
        "NAME": "Collalto, Maria (1540\u20131583)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1583",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14934",
        "NAME": "Scherffenberg, Margarita (1516\u20131577)",
        "DATEOFBIRTH": "1516",
        "DATEOFDEATH": "1577 Sep 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14935",
        "NAME": "Liechtenstein von Kastelkorn, Katharina (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Karneid",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14936",
        "NAME": "Erd\u0151dy, Anna (1595\u20131634)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1634 Nov 10",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14937",
        "NAME": "Khisl von Kaltenbrunn, Anna Maria (1581\u20131600)",
        "DATEOFBIRTH": "1581",
        "DATEOFDEATH": "1600~",
        "PLACEOFBIRTH": "Kaltenbrunn an der Laibach",
        "PLACEOFDEATH": "Gurgfeld an der Save"
    },
    {
        "ID": "14938",
        "NAME": "Liechtenstein von Kastelkorn, Ursula (1430\u20131473)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1473",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14939",
        "NAME": "F\u00fcrstenberg, Maria (1579\u20131608)",
        "DATEOFBIRTH": "1579 Okt 27",
        "DATEOFDEATH": "1608 Mar 10",
        "PLACEOFBIRTH": "Blumberg in der Baar",
        "PLACEOFDEATH": "Raudnitz an der Elbe"
    },
    {
        "ID": "14940",
        "NAME": "J\u00f6rger von Tollet, Johann Maximilian (1585\u20131655), Mundschenk",
        "DATEOFBIRTH": "1585 Sep 27",
        "DATEOFDEATH": "1655 Nov 03",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": "Pottenbrunn an der Traisen"
    },
    {
        "ID": "14941",
        "NAME": "Lobkowicz, Ursula (1543\u20131579)",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14942",
        "NAME": "Cardona, Margarita (1535\u20131609)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1609 Feb 23",
        "PLACEOFBIRTH": "Cardona",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "14943",
        "NAME": "Prager von Windhaag, Ursula (1544\u20131592)",
        "DATEOFBIRTH": "1544",
        "DATEOFDEATH": "1592 Nov 28",
        "PLACEOFBIRTH": "Windhaag im Machland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14944",
        "NAME": "Zelking, Anna Apollonia (1608\u20131646)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1646 Mar 26",
        "PLACEOFBIRTH": "Sierndorf in der Stockerau",
        "PLACEOFDEATH": "Ferschnitz:Pfarrkirche"
    },
    {
        "ID": "14945",
        "NAME": "Liechtenstein von Murau, Z\u00e4zilia (1445\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Murau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14946",
        "NAME": "Rogendorf, Anna (1512\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1512",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14947",
        "NAME": "Egg von Hungersbach, Anna (1502\u20131544)",
        "DATEOFBIRTH": "1502",
        "DATEOFDEATH": "1544",
        "PLACEOFBIRTH": "Hungersbach in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14948",
        "NAME": "Schlick, Moritz (1524\u20131578)",
        "DATEOFBIRTH": "1524 Apr 01",
        "DATEOFDEATH": "1578 Nov 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14949",
        "NAME": "Judenhofer, Margarita (1475\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Trautmannsdorf in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14950",
        "NAME": "Foix, Anna (1484\u20131506), K\u00f6nigin von B\u00f6hmen",
        "DATEOFBIRTH": "1484",
        "DATEOFDEATH": "1506 Jul 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "14951",
        "NAME": "Zollner von Ma\u00dfenburg, Gotthard (1595\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "Ma\u00dfenburg",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "14952",
        "NAME": "Freyberg, Johann Christoph (1580\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1633",
        "PLACEOFBIRTH": "Reideben im Lavanttal",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14953",
        "NAME": "Gall von der Burg, Wilhelm (1590\u20131655), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1655 Aug 05",
        "PLACEOFBIRTH": "Gallstown",
        "PLACEOFDEATH": "Gr\u00fc\u00dfau an der Zieder"
    },
    {
        "ID": "14954",
        "NAME": "Kreckwitz, Johann (1520\u20131588)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1588 Jun 29",
        "PLACEOFBIRTH": "Joppendorf",
        "PLACEOFDEATH": "Guhrau"
    },
    {
        "ID": "14955",
        "NAME": "Kreckwitz, Friedrich (1550\u20131593), Reichshofrat",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1593 Nov 28",
        "PLACEOFBIRTH": "Joppendorf",
        "PLACEOFDEATH": "Wei\u00dfenburg in Serbien"
    },
    {
        "ID": "14956",
        "NAME": "Kreckwitz, Johann (1547\u20131597), Vorschneider",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1597 Aug 05",
        "PLACEOFBIRTH": "Joppendorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14957",
        "NAME": "P\u00f6ttickh von Pettenegg, Johann Baptist (1607\u20131683), K\u00e4mmerer",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1683 Jun 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14958",
        "NAME": "Mailgraber von Mailegg, Johann (1570\u20131626), Hofkriegsrat",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ulm an der Donau"
    },
    {
        "ID": "14959",
        "NAME": "Mailgraber von Mailegg, Salomon (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Feistritz an der M\u00fcrz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14960",
        "NAME": "Eitzing, Michael (1468\u20131522)",
        "DATEOFBIRTH": "1468 Mar 25",
        "DATEOFDEATH": "1522 Aug 09",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "14961",
        "NAME": "Eitzing, Christoph (1501\u20131563), Obersthofmeister",
        "DATEOFBIRTH": "1501",
        "DATEOFDEATH": "1563",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14962",
        "NAME": "Eitzing, Michael (1535\u20131598), K\u00e4mmerer",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": "Bonn"
    },
    {
        "ID": "14963",
        "NAME": "Eitzing, Michael (1570\u20131616)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14964",
        "NAME": "Eitzing, Wolfgang (1538\u20131612), Hofkammerrat",
        "DATEOFBIRTH": "1538 Sep 11",
        "DATEOFDEATH": "1612 Feb 16",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": "Schrattenthal im Weinviertel"
    },
    {
        "ID": "14965",
        "NAME": "Eitzing, Georg (1533\u20131587), Mundschenk",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1587",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14966",
        "NAME": "Eitzing, Paul (1546\u20131592)",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14967",
        "NAME": "Eitzing, Ulrich (1499\u20131561), Hofkammerrat",
        "DATEOFBIRTH": "1499",
        "DATEOFDEATH": "1561",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14968",
        "NAME": "Eitzing, Erasam (1505\u20131554)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1554",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14969",
        "NAME": "Eitzing, Oswald (1512\u20131587), Statthalter von Nieder\u00f6sterreich",
        "DATEOFBIRTH": "1512 Dez 03",
        "DATEOFDEATH": "1587",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14970",
        "NAME": "Kirchstetten, Christoph (1565\u20131617), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "Burghausen an der Salzach",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14971",
        "NAME": "Kirchstetten, Maria (1608\u20131659)",
        "DATEOFBIRTH": "1608 Mai 19",
        "DATEOFDEATH": "1659 Mai 30",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Windhaag im Machland"
    },
    {
        "ID": "14972",
        "NAME": "Kirchstetten, Johann (1605\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14973",
        "NAME": "Kirchstetten, Johann Christian (1640\u20131700), Hofkammerrat",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1700 Mai 31",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "14974",
        "NAME": "Kirchstetten, Johann Franz (1644\u20131718), Hofkammerrat",
        "DATEOFBIRTH": "1644",
        "DATEOFDEATH": "1718",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14975",
        "NAME": "Wei\u00df, Wolfgang (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14976",
        "NAME": "Pezzeni von Ulrichskirchen, Michael (1525\u20131576)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Croviana",
        "PLACEOFDEATH": "Croviana"
    },
    {
        "ID": "14977",
        "NAME": "Pezzeni von Ulrichskirchen, Johann Baptist (1567\u20131616)",
        "DATEOFBIRTH": "1567 Apr 17",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Croviana",
        "PLACEOFDEATH": "Spaur auf dem Nonsberg"
    },
    {
        "ID": "14978",
        "NAME": "Pezzeni von Ulrichskirchen, Bartlome (1555\u20131605), Reichshofrat",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1605 Mai 17",
        "PLACEOFBIRTH": "Croviana",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "14979",
        "NAME": "Pezzeni von Ulrichskirchen, Julius (1560\u20131610), Truchsess",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1610~",
        "PLACEOFBIRTH": "Croviana",
        "PLACEOFDEATH": "Spaur auf dem Nonsberg"
    },
    {
        "ID": "14980",
        "NAME": "Schenk von Stauffenberg, Georg (1530\u20131605), Vorschneider",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1605 Sep 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Moosbeuren"
    },
    {
        "ID": "14981",
        "NAME": "Schr\u00f6ttel von Schrottenstein, Georg (1550\u20131627)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kagran im Marchfeld"
    },
    {
        "ID": "14982",
        "NAME": "Windischgr\u00e4tz, Justina (1525\u20131565)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1565 Apr 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Thunau am Kamp:Pfarrkirche"
    },
    {
        "ID": "14983",
        "NAME": "Mainburg, Johanna (1490\u20131521)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1521",
        "PLACEOFBIRTH": "Mainburg im Pielachtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14984",
        "NAME": "Mainburg, Katharina (1505\u20131538)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1538",
        "PLACEOFBIRTH": "Mainburg im Pielachtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14985",
        "NAME": "Puchheim, Theoderich (1540\u20131589)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "Horn im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14986",
        "NAME": "Hofmann von Gr\u00fcnb\u00fchel, Elisabeth (1547\u20131612)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Horn im Waldviertel"
    },
    {
        "ID": "14987",
        "NAME": "Szunyogh, Johann (1598\u20131641)",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1641 Okt 23",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": "Arwaburg"
    },
    {
        "ID": "14988",
        "NAME": "Escluse, Karl (1526\u20131609), Hofdiener",
        "DATEOFBIRTH": "1526 Feb 19",
        "DATEOFDEATH": "1609 Apr 04",
        "PLACEOFBIRTH": "Atrecht",
        "PLACEOFDEATH": "Leiden in Holland"
    },
    {
        "ID": "14989",
        "NAME": "Lackner, Christoph (1571\u20131631), Truchsess",
        "DATEOFBIRTH": "1571 Nov 18",
        "DATEOFDEATH": "1631 Dez 29",
        "PLACEOFBIRTH": "Oedenburg",
        "PLACEOFDEATH": "Oedenburg"
    },
    {
        "ID": "14990",
        "NAME": "Paumgartner von Schwanstein, Johann (1456\u20131527)",
        "DATEOFBIRTH": "1456 Feb 29",
        "DATEOFDEATH": "1527 Okt 19",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "14991",
        "NAME": "Paumgartner von Schwanstein, Johann (1488\u20131549)",
        "DATEOFBIRTH": "1488 Okt 18",
        "DATEOFDEATH": "1549 Sep 20",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Schwanstein"
    },
    {
        "ID": "14992",
        "NAME": "Paumgartner von Schwanstein, Anton (1518\u20131581), Truchsess",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1581 Jun 18",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14993",
        "NAME": "Zehentner von Zehentgrub, Andreas (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14994",
        "NAME": "Zehentner von Zehentgrub, Paul (1550\u20131601), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1601",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Irmatshofen auf dem Wald:Pfarrkirche"
    },
    {
        "ID": "14995",
        "NAME": "Zehentner von Zehentgrub, Ferdinand (1585\u20131647), Hofkammerrat",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1647 Nov 26",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "14996",
        "NAME": "Zehentner von Zehentgrub, Paul (1589\u20131648), Hofprediger",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1648 Sep 14",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Millstatt am See"
    },
    {
        "ID": "14997",
        "NAME": "Zehentner von Zehentgrub, Andreas (1615\u20131688), Hofkammervizepr\u00e4sident",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1688 Feb 03",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "14998",
        "NAME": "Zehentner von Zehentgrub, Ferdinand (1633\u20131719), Hofkriegsrat",
        "DATEOFBIRTH": "1633 Feb 12",
        "DATEOFDEATH": "1719 Okt 25",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "14999",
        "NAME": "Zehentner von Zehentgrub, Karl (1635\u20131686), K\u00e4mmerer",
        "DATEOFBIRTH": "1635 Feb 10",
        "DATEOFDEATH": "1686 Mai 29",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "15000",
        "NAME": "Capet, Maria (1457\u20131482), Herzogin von Burgund",
        "DATEOFBIRTH": "1457 Feb 13",
        "DATEOFDEATH": "1482 Mar 27",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Br\u00fcgge"
    },
    {
        "ID": "15001",
        "NAME": "Burgund, Alfons (1311\u20131350), K\u00f6nig von Kastilien",
        "DATEOFBIRTH": "1311 Sep 27",
        "DATEOFDEATH": "1350 Mar 26",
        "PLACEOFBIRTH": "Salamanca",
        "PLACEOFDEATH": "Gibraltar"
    },
    {
        "ID": "15002",
        "NAME": "Burgund, Heinrich (1334\u20131379), K\u00f6nig von Kastilien",
        "DATEOFBIRTH": "1334 Jan 13",
        "DATEOFDEATH": "1379 Mai 29",
        "PLACEOFBIRTH": "Sevilla",
        "PLACEOFDEATH": "Santo Domingo de la Calzada"
    },
    {
        "ID": "15003",
        "NAME": "Burgund, Johann (1358\u20131390), K\u00f6nig von Kastilien",
        "DATEOFBIRTH": "1358 Aug 20",
        "DATEOFDEATH": "1390 Okt 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Alcal\u00e1 de Henares"
    },
    {
        "ID": "15004",
        "NAME": "Burgund, Heinrich (1379\u20131406), K\u00f6nig von Kastilien",
        "DATEOFBIRTH": "1379 Okt 04",
        "DATEOFDEATH": "1406 Dez 25",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": "Toledo"
    },
    {
        "ID": "15005",
        "NAME": "Burgund, Johann (1405\u20131454), K\u00f6nig von Kastilien",
        "DATEOFBIRTH": "1405 Mar 06",
        "DATEOFDEATH": "1454 Jul 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Valladolid"
    },
    {
        "ID": "15006",
        "NAME": "Burgund, Elisabeth (1451\u20131504), K\u00f6nigin von Kastilien",
        "DATEOFBIRTH": "1451 Apr 22",
        "DATEOFDEATH": "1504 Nov 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15007",
        "NAME": "Burgund, Ferdinand (1380\u20131416), K\u00f6nig von Aragonien",
        "DATEOFBIRTH": "1380 Nov 27",
        "DATEOFDEATH": "1416 Apr 02",
        "PLACEOFBIRTH": "Medina del Campo",
        "PLACEOFDEATH": "Igualada"
    },
    {
        "ID": "15008",
        "NAME": "Burgund, Johann (1398\u20131479), K\u00f6nig von Aragonien",
        "DATEOFBIRTH": "1398 Jun 29",
        "DATEOFDEATH": "1479 Jan 19",
        "PLACEOFBIRTH": "Medina del Campo",
        "PLACEOFDEATH": "Barcelona"
    },
    {
        "ID": "15009",
        "NAME": "Burgund, Ferdinand (1452\u20131516), K\u00f6nig von Aragonien",
        "DATEOFBIRTH": "1452 Mar 10",
        "DATEOFDEATH": "1516 Jan 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15010",
        "NAME": "Burgund, Peter (1334\u20131369), K\u00f6nig von Kastilien",
        "DATEOFBIRTH": "1334 Aug 30",
        "DATEOFDEATH": "1369 Mar 23",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": "Montiel"
    },
    {
        "ID": "15011",
        "NAME": "Burgund, Johann (1355\u20131405)",
        "DATEOFBIRTH": "1355",
        "DATEOFDEATH": "1405",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15012",
        "NAME": "Burgund, Peter (1394\u20131461), Bischof von Palencia",
        "DATEOFBIRTH": "1394",
        "DATEOFDEATH": "1461 Apr 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Valladolid"
    },
    {
        "ID": "15013",
        "NAME": "Burgund, Alfons (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15014",
        "NAME": "Burgund, Peter (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15015",
        "NAME": "Burgund, Johann (1500\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15016",
        "NAME": "Burgund, Johann (1530\u20131581), Mundschenk",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1581",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Nieuwpoort"
    },
    {
        "ID": "15017",
        "NAME": "Burgund, Alfons (1525\u20131543)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15018",
        "NAME": "Capet, Johann (1371\u20131419)",
        "DATEOFBIRTH": "1371",
        "DATEOFDEATH": "1419",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15019",
        "NAME": "Capet, Philipp (1396\u20131467)",
        "DATEOFBIRTH": "1396",
        "DATEOFDEATH": "1467",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15020",
        "NAME": "Capet, Anton (1421\u20131504)",
        "DATEOFBIRTH": "1421",
        "DATEOFDEATH": "1504 Mai 05",
        "PLACEOFBIRTH": "Lizy in der Picardie",
        "PLACEOFDEATH": "Tournehem sur la Hem"
    },
    {
        "ID": "15021",
        "NAME": "Capet, Philipp (1450\u20131498)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1498",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15022",
        "NAME": "Capet, Adolf (1489\u20131540), K\u00e4mmerer",
        "DATEOFBIRTH": "1489",
        "DATEOFDEATH": "1540",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15023",
        "NAME": "Capet, Maximilian (1514\u20131558), K\u00e4mmerer",
        "DATEOFBIRTH": "1514 Jul 28",
        "DATEOFDEATH": "1558 Jun 04",
        "PLACEOFBIRTH": "Bergen op Zoom",
        "PLACEOFDEATH": "Zandenburg"
    },
    {
        "ID": "15024",
        "NAME": "Capet, Philipp (1520\u20131567), K\u00e4mmerer",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15025",
        "NAME": "Burgund, Alfons (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15026",
        "NAME": "Burgund, Ferdinand (1423\u20131494), K\u00f6nig von Neapel",
        "DATEOFBIRTH": "1423 Jun 02",
        "DATEOFDEATH": "1494 Jan 25",
        "PLACEOFBIRTH": "Valencia",
        "PLACEOFDEATH": "Genova"
    },
    {
        "ID": "15027",
        "NAME": "Burgund, Beatrix (1457\u20131508), K\u00f6nigin von Ungarn",
        "DATEOFBIRTH": "1457 Nov 14",
        "DATEOFDEATH": "1508 Sep 23",
        "PLACEOFBIRTH": "Capua",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "15028",
        "NAME": "Burgund, Peter (1430\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15029",
        "NAME": "Burgund, Peter (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15030",
        "NAME": "Burgund, Peter (1501\u20131558), Obersthofmeister",
        "DATEOFBIRTH": "1501",
        "DATEOFDEATH": "1558 Jun 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "15031",
        "NAME": "Burgund, Peter (1535\u20131585)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1585",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "15032",
        "NAME": "Burgund, Franz (1510\u20131571), Obersthofmeister",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1571 Mai 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "15033",
        "NAME": "Burgund, Johann (1550\u20131626)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15034",
        "NAME": "Burgund, Margarita (1542\u20131609)",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15035",
        "NAME": "Burgund, Polyxena (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15061",
        "NAME": "Fern\u00e1ndez de C\u00f3rdoba, Albrecht (1495\u20131546), Truchsess",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1546 Jan 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "15062",
        "NAME": "Fern\u00e1ndez de C\u00f3rdoba, Anton (1534\u20131579)",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1579 Jun 19",
        "PLACEOFBIRTH": "Madrid",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15063",
        "NAME": "Fern\u00e1ndez de C\u00f3rdoba, Anton (1570\u20131642)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1642 Nov 25",
        "PLACEOFBIRTH": "Toledo",
        "PLACEOFDEATH": "Granada"
    },
    {
        "ID": "15064",
        "NAME": "Fern\u00e1ndez de C\u00f3rdoba, Ursula (1610\u20131637)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15065",
        "NAME": "Teves, Kaspar (1608\u20131673)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1673 Jun 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "15066",
        "NAME": "Teves, Kaspar (1635\u20131685), K\u00e4mmerer",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1685 Mai 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "15067",
        "NAME": "Burgund, Eleonora (1425\u2013\u00a0\u00a0\u00a0\u00a0), Herzogin von Squillace",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Valencia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15068",
        "NAME": "Mazuelo, Adelhelm (1525\u2013\u00a0\u00a0\u00a0\u00a0), Hofsekret\u00e4r",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15069",
        "NAME": "Mazuelo, Ferdinand (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofsekret\u00e4r",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Burgos",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15070",
        "NAME": "Habsburg, Margarita (1480\u20131530), Statthalterin der Spanischen Niederlande",
        "DATEOFBIRTH": "1480 Jan 10",
        "DATEOFDEATH": "1530 Nov 30",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Mechelen"
    },
    {
        "ID": "15071",
        "NAME": "Habsburg, Margarita (1498\u20131537)",
        "DATEOFBIRTH": "1498",
        "DATEOFDEATH": "1537",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "L\u00fcttich"
    },
    {
        "ID": "15072",
        "NAME": "Habsburg, Georg (1504\u20131557), Bischof von L\u00fcttich",
        "DATEOFBIRTH": "1504",
        "DATEOFDEATH": "1557 Mai 04",
        "PLACEOFBIRTH": "Gent in Flandern",
        "PLACEOFDEATH": "L\u00fcttich"
    },
    {
        "ID": "15073",
        "NAME": "Habsburg, Friedrich (1511\u20131553)",
        "DATEOFBIRTH": "1511",
        "DATEOFDEATH": "1553 Apr 21",
        "PLACEOFBIRTH": "Amberg in Feldkirch",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "15074",
        "NAME": "Habsburg, Kornel (1507\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1507",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15075",
        "NAME": "Habsburg, Elisabeth (1515\u20131544)",
        "DATEOFBIRTH": "1515",
        "DATEOFDEATH": "1544",
        "PLACEOFBIRTH": "Amberg in Feldkirch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15076",
        "NAME": "Habsburg, Anna (1517\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1517",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Amberg in Feldkirch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15077",
        "NAME": "Helfenstein, Johann (1290\u20131331)",
        "DATEOFBIRTH": "1290~",
        "DATEOFDEATH": "1331",
        "PLACEOFBIRTH": "Helfenstein auf der Steige",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15078",
        "NAME": "Helfenstein, Ulrich (1322\u20131372)",
        "DATEOFBIRTH": "1322",
        "DATEOFDEATH": "1372 Mai 05",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": "Tennenbronn im Schwarzwald"
    },
    {
        "ID": "15079",
        "NAME": "Helfenstein, Friedrich (1360\u20131438)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1438 Aug 20",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15080",
        "NAME": "Helfenstein, Friedrich (1408\u20131483)",
        "DATEOFBIRTH": "1408",
        "DATEOFDEATH": "1483",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15084",
        "NAME": "Hoyos, Johann Albrecht (1632\u20131659), K\u00e4mmerer",
        "DATEOFBIRTH": "1632",
        "DATEOFDEATH": "1659 Apr 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "15085",
        "NAME": "Hoyos, Leopold (1657\u20131699), K\u00e4mmerer",
        "DATEOFBIRTH": "1657",
        "DATEOFDEATH": "1699 Aug 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "15086",
        "NAME": "Z\u00fa\u00f1iga, Felix (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15087",
        "NAME": "Habsburg, Leopold (1513\u20131557), Bischof von C\u00f3rdoba",
        "DATEOFBIRTH": "1513",
        "DATEOFDEATH": "1557 Sep 27",
        "PLACEOFBIRTH": "Amberg in Feldkirch",
        "PLACEOFDEATH": "C\u00f3rdoba"
    },
    {
        "ID": "15088",
        "NAME": "Habsburg, Maximilian (1555\u20131614), Erzbischof von Santiago de Compostela",
        "DATEOFBIRTH": "1555 Jul 25",
        "DATEOFDEATH": "1614 Jul 01",
        "PLACEOFBIRTH": "Ja\u00e9n",
        "PLACEOFDEATH": "Santiago de Compostela"
    },
    {
        "ID": "15089",
        "NAME": "Gamboa, Ferdinand (1520\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15090",
        "NAME": "Egmond, Johann (1438\u20131516)",
        "DATEOFBIRTH": "1438 Apr 03",
        "DATEOFDEATH": "1516 Aug 21",
        "PLACEOFBIRTH": "Hattem",
        "PLACEOFDEATH": "Egmond aan den Hoef"
    },
    {
        "ID": "15091",
        "NAME": "Egmond, Johann (1499\u20131528)",
        "DATEOFBIRTH": "1499",
        "DATEOFDEATH": "1528 Apr 29",
        "PLACEOFBIRTH": "Egmond aan den Hoef",
        "PLACEOFDEATH": "Ferrara"
    },
    {
        "ID": "15092",
        "NAME": "Egmond, Lamoral (1522\u20131568), Statthalter von Flandern",
        "DATEOFBIRTH": "1522 Nov 18",
        "DATEOFDEATH": "1568 Jun 05",
        "PLACEOFBIRTH": "Elzele",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "15093",
        "NAME": "Egmond, Philipp (1558\u20131590), Mundschenk",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1590 Mar 14",
        "PLACEOFBIRTH": "Lahamaide",
        "PLACEOFDEATH": "Ivry la Bataille"
    },
    {
        "ID": "15094",
        "NAME": "Salazar, Peter (1500\u20131576), Hofdiener",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Madrid",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15095",
        "NAME": "Cles, Bernhard (1485\u20131539), Bischof von Trient",
        "DATEOFBIRTH": "1485 Mar 11",
        "DATEOFDEATH": "1539 Jul 30",
        "PLACEOFBIRTH": "Gl\u00f6\u00df im Nonstal",
        "PLACEOFDEATH": "Brixen am Eisack"
    },
    {
        "ID": "15096",
        "NAME": "Gonzaga, Anna (1566\u20131621)",
        "DATEOFBIRTH": "1566 Jan 17",
        "DATEOFDEATH": "1621 Aug 03",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Innsbruck:Servitenkirche"
    },
    {
        "ID": "15097",
        "NAME": "Leiningen, Christoph (1575\u20131635)",
        "DATEOFBIRTH": "1575 Sep 30",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "Westerburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15098",
        "NAME": "Castellalto, Franz (1450\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kastelalt im Suganertal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15099",
        "NAME": "Castellalto, Dorothea (1495\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kastelalt im Suganertal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15190",
        "NAME": "Bocskai, Georg (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rasinja",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15191",
        "NAME": "Bocskai, Simon (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rasinja",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15192",
        "NAME": "Bocskai, Georg (1520\u20131571)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Klausenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15193",
        "NAME": "Bocskai, Elisabeth (1550\u20131581)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1581 Feb 15",
        "PLACEOFBIRTH": "Klausenburg",
        "PLACEOFDEATH": "Wei\u00dfenburg in Siebenb\u00fcrgen"
    },
    {
        "ID": "15194",
        "NAME": "Bocskai, Peter (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rasinja",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15195",
        "NAME": "Bocskai, Stephan (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rasinja",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15196",
        "NAME": "Bocskai, Georg (1530\u20131575), Hofsekret\u00e4r",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1575 Apr 08",
        "PLACEOFBIRTH": "Rasinja",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "15197",
        "NAME": "Scarpone, Ulrich (1281\u20131324), Graf von Pfirt",
        "DATEOFBIRTH": "1281",
        "DATEOFDEATH": "1324 Mar 26",
        "PLACEOFBIRTH": "Pfirt im Sundgau",
        "PLACEOFDEATH": "Basel"
    },
    {
        "ID": "15198",
        "NAME": "Scarpone, Johanna (1310\u20131351), Gr\u00e4fin von Pfirt",
        "DATEOFBIRTH": "1310~",
        "DATEOFDEATH": "1351 Nov 15",
        "PLACEOFBIRTH": "Basel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "15199",
        "NAME": "Scarpone, Ursula (1320\u20131367)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "1367 Feb 09",
        "PLACEOFBIRTH": "Basel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15310",
        "NAME": "Colonna, Lorenz (1365\u20131423)",
        "DATEOFBIRTH": "1365~",
        "DATEOFDEATH": "1423",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15311",
        "NAME": "Colonna, Anton (1408\u20131472)",
        "DATEOFBIRTH": "1408",
        "DATEOFDEATH": "1472 Feb 25",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Genazzano"
    },
    {
        "ID": "15312",
        "NAME": "Colonna, Hieronym (1435\u20131482)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1482 Apr 03",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "15313",
        "NAME": "Colonna, Markel (1465\u20131526)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1526",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15314",
        "NAME": "Colonna, Kamil (1495\u20131558)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1558 Dez 11",
        "PLACEOFBIRTH": "Zagarolo",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "15315",
        "NAME": "Colonna, Pompei (1525\u20131584)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "Zagarolo",
        "PLACEOFDEATH": "Messina"
    },
    {
        "ID": "15316",
        "NAME": "Colonna, Marzius (1555\u20131601)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1601",
        "PLACEOFBIRTH": "Zagarolo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15317",
        "NAME": "Colonna, Peter Franz (1585\u20131633), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1633 Mar 16",
        "PLACEOFBIRTH": "Zagarolo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15318",
        "NAME": "Medici, Johann (1360\u20131429)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1429",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15319",
        "NAME": "Medici, Lorenz (1395\u20131440)",
        "DATEOFBIRTH": "1395~",
        "DATEOFDEATH": "1440",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15320",
        "NAME": "Medici, Peter Franz (1430\u20131476)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1476",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15321",
        "NAME": "Medici, Johann (1467\u20131498)",
        "DATEOFBIRTH": "1467",
        "DATEOFDEATH": "1498",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15322",
        "NAME": "Medici, Johann (1498\u20131526)",
        "DATEOFBIRTH": "1498",
        "DATEOFDEATH": "1526",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15323",
        "NAME": "Medici, Kosmas (1389\u20131464)",
        "DATEOFBIRTH": "1389",
        "DATEOFDEATH": "1464",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15324",
        "NAME": "Medici, Peter (1416\u20131469)",
        "DATEOFBIRTH": "1416",
        "DATEOFDEATH": "1469",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15325",
        "NAME": "Medici, Lorenz (1449\u20131492)",
        "DATEOFBIRTH": "1449",
        "DATEOFDEATH": "1492",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15326",
        "NAME": "Medici, Peter (1472\u20131503)",
        "DATEOFBIRTH": "1472",
        "DATEOFDEATH": "1503",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15327",
        "NAME": "Medici, Lorenz (1492\u20131519)",
        "DATEOFBIRTH": "1492",
        "DATEOFDEATH": "1519",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15328",
        "NAME": "Medici, Alexander (1510\u20131537)",
        "DATEOFBIRTH": "1510",
        "DATEOFDEATH": "1537",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15329",
        "NAME": "Medici, Julius (1532\u20131600)",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1600",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pisa"
    },
    {
        "ID": "15330",
        "NAME": "Medici, Kosmas (1570\u20131630)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1630~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15331",
        "NAME": "Helfenstein, Ludwig (1447\u20131493)",
        "DATEOFBIRTH": "1447 Nov 12",
        "DATEOFDEATH": "1493 Dez 27",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": "Wiesensteig"
    },
    {
        "ID": "15332",
        "NAME": "Helfenstein, Agnes (1484\u20131550)",
        "DATEOFBIRTH": "1484 Sep 21",
        "DATEOFDEATH": "1550",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15333",
        "NAME": "Helfenstein, Ulrich (1486\u20131548), Statthalter von W\u00fcrttemberg",
        "DATEOFBIRTH": "1486 Jul 20",
        "DATEOFDEATH": "1548 Mai 26",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": "Wiesensteig"
    },
    {
        "ID": "15334",
        "NAME": "Helfenstein, Ludwig (1492\u20131525)",
        "DATEOFBIRTH": "1492 Nov 13",
        "DATEOFDEATH": "1525 Apr 16",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": "Weinsberg in Schwaben"
    },
    {
        "ID": "15335",
        "NAME": "Helfenstein, Sebastian (1521\u20131564)",
        "DATEOFBIRTH": "1521 Sep 21",
        "DATEOFDEATH": "1564 Mai 16",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": "Ruck an der Blau"
    },
    {
        "ID": "15336",
        "NAME": "Helfenstein, Maximilian (1523\u20131555)",
        "DATEOFBIRTH": "1523",
        "DATEOFDEATH": "1555 Jun 15",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15337",
        "NAME": "Helfenstein, Rudolf (1513\u20131532)",
        "DATEOFBIRTH": "1513 Jun 15",
        "DATEOFDEATH": "1532 Jan 07",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": "Maulbronn"
    },
    {
        "ID": "15338",
        "NAME": "Helfenstein, Georg (1519\u20131573)",
        "DATEOFBIRTH": "1519",
        "DATEOFDEATH": "1573 Nov 08",
        "PLACEOFBIRTH": "Bamberg",
        "PLACEOFDEATH": "Neufra an der Donau:Schlosskirche"
    },
    {
        "ID": "15339",
        "NAME": "Helfenstein, Schweikhard (1539\u20131599)",
        "DATEOFBIRTH": "1539 Jun 26",
        "DATEOFDEATH": "1599 Okt 23",
        "PLACEOFBIRTH": "Neufra an der Donau",
        "PLACEOFDEATH": "Landsberg am Lech"
    },
    {
        "ID": "15361",
        "NAME": "Schenk von Limpurg, Elisabeth (1466\u20131528)",
        "DATEOFBIRTH": "1466",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "Speckfeld",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15362",
        "NAME": "Ligne, Karl Eugen (1633\u20131681), Herzog von Arenberg",
        "DATEOFBIRTH": "1633 Mai 08",
        "DATEOFDEATH": "1681 Jun 26",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Bergen im Hennegau"
    },
    {
        "ID": "15363",
        "NAME": "Ligne, Philipp Karl (1663\u20131691), Herzog von Arenberg",
        "DATEOFBIRTH": "1663 Mai 10",
        "DATEOFDEATH": "1691 Aug 19",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Slankamen"
    },
    {
        "ID": "15364",
        "NAME": "Ligne, Maria Theresia (1667\u20131716)",
        "DATEOFBIRTH": "1667 Sep 25",
        "DATEOFDEATH": "1716 Mai 28",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "15365",
        "NAME": "Ligne, Klara Elisabeth (1629\u20131670)",
        "DATEOFBIRTH": "1629 Nov 02",
        "DATEOFDEATH": "1670 Sep 07",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Me\u00dfkirch an der Ablach"
    },
    {
        "ID": "15366",
        "NAME": "Ligne, Maria Theresia (1639\u20131705)",
        "DATEOFBIRTH": "1639 Apr 22",
        "DATEOFDEATH": "1705 Jan 18",
        "PLACEOFBIRTH": "Madrid",
        "PLACEOFDEATH": "Me\u00dfkirch an der Ablach"
    },
    {
        "ID": "15367",
        "NAME": "W\u00fcrttemberg, Friedrich (1557\u20131608)",
        "DATEOFBIRTH": "1557 Aug 19",
        "DATEOFDEATH": "1608 Jan 29",
        "PLACEOFBIRTH": "Horburg im Elsass",
        "PLACEOFDEATH": "Stuttgart"
    },
    {
        "ID": "15368",
        "NAME": "W\u00fcrttemberg, Johann Friedrich (1582\u20131628)",
        "DATEOFBIRTH": "1582 Mai 05",
        "DATEOFDEATH": "1628 Jul 18",
        "PLACEOFBIRTH": "M\u00f6mpelgard",
        "PLACEOFDEATH": "Heidenheim an der Brenz"
    },
    {
        "ID": "15369",
        "NAME": "W\u00fcrttemberg, Ulrich (1617\u20131671)",
        "DATEOFBIRTH": "1617 Mai 15",
        "DATEOFDEATH": "1671 Dez 05",
        "PLACEOFBIRTH": "Stuttgart",
        "PLACEOFDEATH": "Stuttgart"
    },
    {
        "ID": "15370",
        "NAME": "Helfenstein, Ulrich (1250\u20131315)",
        "DATEOFBIRTH": "1250~",
        "DATEOFDEATH": "1315",
        "PLACEOFBIRTH": "Helfenstein auf der Steige",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15371",
        "NAME": "Helfenstein, Ulrich (1280\u20131326)",
        "DATEOFBIRTH": "1280~",
        "DATEOFDEATH": "1326",
        "PLACEOFBIRTH": "Helfenstein auf der Steige",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15372",
        "NAME": "Helfenstein, Ulrich (1323\u20131361)",
        "DATEOFBIRTH": "1323",
        "DATEOFDEATH": "1361 Mai 13",
        "PLACEOFBIRTH": "Helfenstein auf der Steige",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15373",
        "NAME": "Helfenstein, Ulrich (1350\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1350~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Helfenstein auf der Steige",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15374",
        "NAME": "Helfenstein, Johann (1380\u20131444)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1444 Apr 16",
        "PLACEOFBIRTH": "Blaubeuren",
        "PLACEOFDEATH": "Blaubeuren"
    },
    {
        "ID": "15375",
        "NAME": "Helfenstein, Konrad (1410\u20131474)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1474 Dez 14",
        "PLACEOFBIRTH": "Blaubeuren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15376",
        "NAME": "Helfenstein, Georg (1450\u20131518)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1518",
        "PLACEOFBIRTH": "Blaubeuren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15377",
        "NAME": "Helfenstein, Ulrich (1524\u20131570)",
        "DATEOFBIRTH": "1524 Feb 08",
        "DATEOFDEATH": "1570 Jan 17",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": "Wiesensteig"
    },
    {
        "ID": "15378",
        "NAME": "Helfenstein, Georg (1571\u20131607)",
        "DATEOFBIRTH": "1571",
        "DATEOFDEATH": "1607 Mar 29",
        "PLACEOFBIRTH": "Neufra an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15379",
        "NAME": "Helfenstein, Frowin (1573\u20131622)",
        "DATEOFBIRTH": "1573",
        "DATEOFDEATH": "1622 Dez 04",
        "PLACEOFBIRTH": "Neufra an der Donau",
        "PLACEOFDEATH": "Ensisheim"
    },
    {
        "ID": "15380",
        "NAME": "Castiglioni, Balthasar (1478\u20131529)",
        "DATEOFBIRTH": "1478 Dez 06",
        "DATEOFDEATH": "1529 Feb 08",
        "PLACEOFBIRTH": "Casatico",
        "PLACEOFDEATH": "Toledo"
    },
    {
        "ID": "15381",
        "NAME": "Baldo, Philipp (1500\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15382",
        "NAME": "Colonna, Prosper (1452\u20131523)",
        "DATEOFBIRTH": "1452",
        "DATEOFDEATH": "1523 Dez 30",
        "PLACEOFBIRTH": "Lanuvio",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "15396",
        "NAME": "F\u00fcrstenberg, Franz Eginhard (1626\u20131682), Bischof von Stra\u00dfburg",
        "DATEOFBIRTH": "1626 Apr 16",
        "DATEOFDEATH": "1682 Apr 01",
        "PLACEOFBIRTH": "Heiligenberg im Linzgau",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "15397",
        "NAME": "F\u00fcrstenberg, Heinrich (1536\u20131596)",
        "DATEOFBIRTH": "1536 Sep 09",
        "DATEOFDEATH": "1596 Okt 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Amtenhausen auf der Baar"
    },
    {
        "ID": "15398",
        "NAME": "F\u00fcrstenberg, Anna (1562\u20131611)",
        "DATEOFBIRTH": "1562 Feb 03",
        "DATEOFDEATH": "1611 Okt 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15399",
        "NAME": "F\u00fcrstenberg, Maria Franziska (1633\u20131702)",
        "DATEOFBIRTH": "1633 Mai 18",
        "DATEOFDEATH": "1702 Mar 07",
        "PLACEOFBIRTH": "Konstanz im Hegau",
        "PLACEOFDEATH": "Lobositz an der Elbe"
    },
    {
        "ID": "15446",
        "NAME": "Khevenh\u00fcller, Franz (1562\u20131607)",
        "DATEOFBIRTH": "1562 Mai 12",
        "DATEOFDEATH": "1607 Mai 01",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Osterwitz in K\u00e4rnten"
    },
    {
        "ID": "15447",
        "NAME": "Khevenh\u00fcller, Siegmund (1597\u20131656)",
        "DATEOFBIRTH": "1597 Sep 04",
        "DATEOFDEATH": "1656 Mai 16",
        "PLACEOFBIRTH": "Klagenfurt am W\u00f6rthersee",
        "PLACEOFDEATH": "Schlaining"
    },
    {
        "ID": "15448",
        "NAME": "Khevenh\u00fcller, Ehrenreich (1635\u20131675)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1675 Apr 12",
        "PLACEOFBIRTH": "Schlaining",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15449",
        "NAME": "Khevenh\u00fcller, Siegmund Friedrich (1666\u20131742), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1666 Sep 17",
        "DATEOFDEATH": "1742 Dez 08",
        "PLACEOFBIRTH": "Klagenfurt am W\u00f6rthersee",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "15450",
        "NAME": "Boskowitz von Schwarzenberg, Albrecht (1535\u20131572)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1572 Aug 07",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": "Schwarzenberg in M\u00e4hren"
    },
    {
        "ID": "15458",
        "NAME": "Schlick, Franz Joseph (1656\u20131740), Geheimer Rat",
        "DATEOFBIRTH": "1656 Jan 19",
        "DATEOFDEATH": "1740 Dez 04",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15459",
        "NAME": "Schlick, Leopold Joseph (1663\u20131723), Geheimer Rat",
        "DATEOFBIRTH": "1663 Jun 10",
        "DATEOFDEATH": "1723 Apr 08",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "15460",
        "NAME": "Myslik von Hirschau, Adam (1520\u20131581)",
        "DATEOFBIRTH": "1520",
        "DATEOFDEATH": "1581 Jan 18",
        "PLACEOFBIRTH": "Hirschau im B\u00f6hmerwald",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "15461",
        "NAME": "Myslik von Hirschau, Johann (1550\u20131599)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15462",
        "NAME": "Myslik von Hirschau, Adam (1580\u20131616), Truchsess",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15463",
        "NAME": "Hofkirchen, Anna Elisabeth (1615\u20131663)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1663 Jul 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Jaispitz in M\u00e4hren"
    },
    {
        "ID": "15464",
        "NAME": "Hofkirchen, Susanna Regina (1620\u20131666)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1666 Mai 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "15465",
        "NAME": "Sickingen, Franz (1481\u20131523)",
        "DATEOFBIRTH": "1481 Mar 02",
        "DATEOFDEATH": "1523 Mai 07",
        "PLACEOFBIRTH": "Ebernburg an der Nahe",
        "PLACEOFDEATH": "Landstuhl in der Pfalz"
    },
    {
        "ID": "15466",
        "NAME": "Sickingen, Schweikhard (1500\u20131562)",
        "DATEOFBIRTH": "1500 Nov 04",
        "DATEOFDEATH": "1562 Nov 01",
        "PLACEOFBIRTH": "Ebernburg an der Nahe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15467",
        "NAME": "Sickingen, Johann (1502\u20131547)",
        "DATEOFBIRTH": "1502 Mar 02",
        "DATEOFDEATH": "1547 Jan 25",
        "PLACEOFBIRTH": "Ebernburg an der Nahe",
        "PLACEOFDEATH": "Sickingen:Pfarrkirche"
    },
    {
        "ID": "15468",
        "NAME": "Sickingen, Konrad (1511\u20131574), Reichshofrat",
        "DATEOFBIRTH": "1511",
        "DATEOFDEATH": "1574 Mai 07",
        "PLACEOFBIRTH": "Ebernburg an der Nahe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15469",
        "NAME": "Sickingen, Franz (1539\u20131597)",
        "DATEOFBIRTH": "1539 Mar 15",
        "DATEOFDEATH": "1597 Mar 18",
        "PLACEOFBIRTH": "Ebernburg an der Nahe",
        "PLACEOFDEATH": "Sickingen:Pfarrkirche"
    },
    {
        "ID": "15470",
        "NAME": "Sickingen, Luzia (1569\u20131603)",
        "DATEOFBIRTH": "1569 Mar 06",
        "DATEOFDEATH": "1603 Jul 12",
        "PLACEOFBIRTH": "Sickingen",
        "PLACEOFDEATH": "Krottorf im Westerwald"
    },
    {
        "ID": "15471",
        "NAME": "Sickingen, Schweikhard (1570\u20131642)",
        "DATEOFBIRTH": "1570 Apr 27",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Sickingen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15472",
        "NAME": "Sickingen, Johann Schweikhard (1592\u20131666)",
        "DATEOFBIRTH": "1592 Dez 09",
        "DATEOFDEATH": "1666",
        "PLACEOFBIRTH": "Sickingen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15473",
        "NAME": "Sickingen, Franz (1629\u20131715), Mundschenk",
        "DATEOFBIRTH": "1629 Feb 08",
        "DATEOFDEATH": "1715 Nov 03",
        "PLACEOFBIRTH": "Sickingen",
        "PLACEOFDEATH": "Mainz"
    },
    {
        "ID": "15474",
        "NAME": "Sickingen, Johann Schweikhard (1542\u20131589), Hofdiener",
        "DATEOFBIRTH": "1542 Jul 05",
        "DATEOFDEATH": "1589 Sep 13",
        "PLACEOFBIRTH": "Ebernburg an der Nahe",
        "PLACEOFDEATH": "Ebernburg an der Nahe"
    },
    {
        "ID": "15475",
        "NAME": "Sickingen, Johann Schweikhard (1584\u20131625)",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1625 Sep 05",
        "PLACEOFBIRTH": "Ebernburg an der Nahe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15476",
        "NAME": "Sickingen, Philipp Heinrich (1625\u20131669), Truchsess",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1669",
        "PLACEOFBIRTH": "Ebernburg an der Nahe",
        "PLACEOFDEATH": "F\u00fcnfkirchen"
    },
    {
        "ID": "15477",
        "NAME": "Sickingen, Friedrich (1544\u20131581)",
        "DATEOFBIRTH": "1544 Sep 24",
        "DATEOFDEATH": "1581 Mai 10",
        "PLACEOFBIRTH": "Heidelberg",
        "PLACEOFDEATH": "Obenheim"
    },
    {
        "ID": "15478",
        "NAME": "Sickingen, Johann Jakob (1571\u20131611)",
        "DATEOFBIRTH": "1571 Nov 25",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "Ebnet im Breisgau",
        "PLACEOFDEATH": "Freiburg im Breisgau"
    },
    {
        "ID": "15479",
        "NAME": "Sickingen, Friedrich Franz (1606\u20131659)",
        "DATEOFBIRTH": "1606 Jan 06",
        "DATEOFDEATH": "1659 Mar 08",
        "PLACEOFBIRTH": "Freiburg im Breisgau",
        "PLACEOFDEATH": "Freiburg im Breisgau"
    },
    {
        "ID": "15480",
        "NAME": "Sickingen, Franz Ferdinand (1638\u20131687)",
        "DATEOFBIRTH": "1638 Okt 20",
        "DATEOFDEATH": "1687 Okt 12",
        "PLACEOFBIRTH": "Freiburg im Breisgau",
        "PLACEOFDEATH": "Ebnet im Breisgau"
    },
    {
        "ID": "15494",
        "NAME": "Lynden, Maria Salomena (1648\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1648",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Reckheim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15495",
        "NAME": "Breunner, Maximilian Ludwig (1643\u20131716), Geheimer Rat",
        "DATEOFBIRTH": "1643 Jun 17",
        "DATEOFDEATH": "1716 Okt 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15496",
        "NAME": "Breunner, Maria Konstantia (1648\u20131687)",
        "DATEOFBIRTH": "1648 Aug 10",
        "DATEOFDEATH": "1687",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15497",
        "NAME": "Hiserle von Chodau, Karl Michael (1606\u20131652)",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1652",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15498",
        "NAME": "Hiserle von Chodau, Franziska Eusebia (1636\u20131669)",
        "DATEOFBIRTH": "1636",
        "DATEOFDEATH": "1669",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15499",
        "NAME": "Sahrer von Sahr, Barbara Eusebia (1635\u20131709)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1709 Mar 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15541",
        "NAME": "Caccia, Benedikt (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pettau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15590",
        "NAME": "Gonzaga, Vinzenz (1605\u20131694), Obersthofmeister",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1694 Nov 23",
        "PLACEOFBIRTH": "Guastalla",
        "PLACEOFDEATH": "Salamanca"
    },
    {
        "ID": "15591",
        "NAME": "Obizzi, Pius Aeneas (1525\u20131589)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "Padua",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15592",
        "NAME": "Obizzi, Ruprecht (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Padua",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15593",
        "NAME": "Obizzi, Pius Aeneas (1592\u20131674)",
        "DATEOFBIRTH": "1592 Aug 04",
        "DATEOFDEATH": "1674 Sep 17",
        "PLACEOFBIRTH": "Cataio sul Padovano",
        "PLACEOFDEATH": "Cataio sul Padovano"
    },
    {
        "ID": "15594",
        "NAME": "Obizzi, Ruprecht (1630\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Cataio sul Padovano",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15595",
        "NAME": "Obizzi, Ferdinand (1640\u20131710), Geheimer Rat",
        "DATEOFBIRTH": "1640",
        "DATEOFDEATH": "1710 Feb 07",
        "PLACEOFBIRTH": "Cataio sul Padovano",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "15596",
        "NAME": "Pallavicino, Simon (1500\u20131552)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1552",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15597",
        "NAME": "Pallavicino, Stephan (1538\u20131599)",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1599 Sep 17",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15598",
        "NAME": "Pallavicino, Felix (1570\u20131629)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1629 Dez 08",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15599",
        "NAME": "Rigamonti, Stephan (1555\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Venedig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15601",
        "NAME": "Medici, Franz (1541\u20131587)",
        "DATEOFBIRTH": "1541",
        "DATEOFDEATH": "1587",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15602",
        "NAME": "Medici, Maria (1575\u20131642)",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15603",
        "NAME": "Medici, Eleonora (1567\u20131611)",
        "DATEOFBIRTH": "1567",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15604",
        "NAME": "Gonzaga, Franz (1586\u20131612), Herzog von Mantua",
        "DATEOFBIRTH": "1586 Mai 07",
        "DATEOFDEATH": "1612 Dez 22",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "15605",
        "NAME": "Gonzaga, Ferdinand (1587\u20131626), Herzog von Mantua",
        "DATEOFBIRTH": "1587 Apr 26",
        "DATEOFDEATH": "1626 Okt 29",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "15606",
        "NAME": "Gonzaga, Margarita (1591\u20131632)",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15607",
        "NAME": "Gonzaga, Vinzenz (1594\u20131624)",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15608",
        "NAME": "Gonzaga, Silvius (1588\u20131612), Markgraf von Cavriana",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "1612 Dez 22",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "15609",
        "NAME": "Gonzaga, Franz (1589\u20131673), Bischof von Nola",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1673 Dez 18",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": "Nola"
    },
    {
        "ID": "15610",
        "NAME": "Carretto, Anna (1595\u20131651)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1651",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15611",
        "NAME": "Colonna, Vespasian (1485\u20131528)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1528 Mar 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Paliano"
    },
    {
        "ID": "15612",
        "NAME": "Colonna, Edward (1405\u20131462)",
        "DATEOFBIRTH": "1405~",
        "DATEOFDEATH": "1462 Sep 09",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15613",
        "NAME": "Colonna, Fabriz (1450\u20131520)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1520 Mar 15",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Aversa"
    },
    {
        "ID": "15614",
        "NAME": "Colonna, Peter (1445\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15615",
        "NAME": "Colonna, Prosper (1530\u20131585), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1585",
        "PLACEOFBIRTH": "Zagarolo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15616",
        "NAME": "Colonna, Mark Anton (1478\u20131522)",
        "DATEOFBIRTH": "1478 Sep 12",
        "DATEOFDEATH": "1522 Mar 09",
        "PLACEOFBIRTH": "Salerno",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "15617",
        "NAME": "Colonna, Askan (1490\u20131557)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1557 Mar 24",
        "PLACEOFBIRTH": "Marino Laziale",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "15618",
        "NAME": "Colonna, Viktoria (1492\u20131547)",
        "DATEOFBIRTH": "1492",
        "DATEOFDEATH": "1547 Feb 25",
        "PLACEOFBIRTH": "Marino Laziale",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "15619",
        "NAME": "Colonna, Mark Anton (1535\u20131584)",
        "DATEOFBIRTH": "1535 Feb 26",
        "DATEOFDEATH": "1584 Aug 01",
        "PLACEOFBIRTH": "Lanuvio",
        "PLACEOFDEATH": "Medinaceli"
    },
    {
        "ID": "15630",
        "NAME": "Frangipane di Veglia, Johann Angel (1390\u20131436)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1436 Nov 20",
        "PLACEOFBIRTH": "Zengg",
        "PLACEOFDEATH": "Klissa in Dalmatien"
    },
    {
        "ID": "15631",
        "NAME": "Frangipane di Veglia, Niklas (1405\u20131458), Ban von Kroatien",
        "DATEOFBIRTH": "1405~",
        "DATEOFDEATH": "1458 Sep 02",
        "PLACEOFBIRTH": "Zengg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15632",
        "NAME": "Frangipane di Veglia, Martin (1415\u20131479)",
        "DATEOFBIRTH": "1415~",
        "DATEOFDEATH": "1479 Okt 04",
        "PLACEOFBIRTH": "Zengg",
        "PLACEOFDEATH": "Tersat am Flaum:Franziskanerkirche"
    },
    {
        "ID": "15633",
        "NAME": "Frangipane di Veglia, Niklas (1450\u20131523)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1523",
        "PLACEOFBIRTH": "Tersat am Flaum",
        "PLACEOFDEATH": "Tersat am Flaum:Franziskanerkirche"
    },
    {
        "ID": "15634",
        "NAME": "Frangipane di Veglia, Wolfgang (1499\u20131546)",
        "DATEOFBIRTH": "1499",
        "DATEOFDEATH": "1546",
        "PLACEOFBIRTH": "Tersat am Flaum",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15635",
        "NAME": "Frangipane di Veglia, Matthias (1478\u20131518)",
        "DATEOFBIRTH": "1478",
        "DATEOFDEATH": "1518",
        "PLACEOFBIRTH": "Modrus",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15636",
        "NAME": "Frangipane di Veglia, Georg (1420\u20131468)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1468",
        "PLACEOFBIRTH": "Cetin",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15637",
        "NAME": "Frangipane di Veglia, Johann (1450\u20131493)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1493 Sep 09",
        "PLACEOFBIRTH": "Cetin",
        "PLACEOFDEATH": "Udbina in der Lika"
    },
    {
        "ID": "15638",
        "NAME": "Frangipane di Veglia, Gregor (1459\u20131523), Erzbischof von Kollotschau",
        "DATEOFBIRTH": "1459",
        "DATEOFDEATH": "1523",
        "PLACEOFBIRTH": "Cetin",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "15639",
        "NAME": "Frangipane di Veglia, Franz (1483\u20131543), Erzbischof von Kollotschau",
        "DATEOFBIRTH": "1483",
        "DATEOFDEATH": "1543 Jan 28",
        "PLACEOFBIRTH": "Cetin",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "15640",
        "NAME": "Frangipane di Veglia, Johann (1424\u20131486)",
        "DATEOFBIRTH": "1424",
        "DATEOFDEATH": "1486 Mar 14",
        "PLACEOFBIRTH": "Zengg",
        "PLACEOFDEATH": "Zakon an der Drau"
    },
    {
        "ID": "15641",
        "NAME": "Bucelleni von Reichenberg, Thomas (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15642",
        "NAME": "Bucelleni von Reichenberg, Bernhard (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15643",
        "NAME": "Bucelleni von Reichenberg, Paul (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15644",
        "NAME": "Bucelleni von Reichenberg, Julius (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15645",
        "NAME": "Bucelleni von Reichenberg, Hotze (1598\u20131664)",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1664 Feb 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "15646",
        "NAME": "Bucelleni von Reichenberg, Julius Friedrich (1640\u20131712), Hofkanzler",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1712 Feb 05",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "15647",
        "NAME": "Bucelleni von Reichenberg, Johann Andreas (1650\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15648",
        "NAME": "Strozzi, Julius (1580\u20131631)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1631 Apr 04",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15649",
        "NAME": "Strozzi, Franziska (1623\u20131668)",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1668",
        "PLACEOFBIRTH": "Bellacqua di Sopra",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "15650",
        "NAME": "Doria, Andreas (1468\u20131560), F\u00fcrst von Melfi",
        "DATEOFBIRTH": "1468 Nov 30",
        "DATEOFDEATH": "1560 Nov 25",
        "PLACEOFBIRTH": "Oneglia",
        "PLACEOFDEATH": "Genova:Chiesa di San Matteo"
    },
    {
        "ID": "15670",
        "NAME": "Sinelli, Emmerich (1622\u20131685), Bischof von Wien",
        "DATEOFBIRTH": "1622 Jun 29",
        "DATEOFDEATH": "1685 Feb 25",
        "PLACEOFBIRTH": "Komorn an der Donau",
        "PLACEOFDEATH": "Wien:Stephansdom"
    },
    {
        "ID": "15671",
        "NAME": "Serego, Bonifaz (1560\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15672",
        "NAME": "Serego, Johann Baptist (1585\u2013\u00a0\u00a0\u00a0\u00a0), Edelknabe",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15673",
        "NAME": "Marzano, Ludwika (1458\u20131494)",
        "DATEOFBIRTH": "1458",
        "DATEOFDEATH": "1494",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15674",
        "NAME": "Gondola, Franz (1560\u20131624)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1624 Apr 27",
        "PLACEOFBIRTH": "Ragusa in Dalmatien",
        "PLACEOFDEATH": "Ragusa in Dalmatien"
    },
    {
        "ID": "15675",
        "NAME": "Gondola, Johann (1589\u20131638)",
        "DATEOFBIRTH": "1589 Jan 09",
        "DATEOFDEATH": "1638 Dez 08",
        "PLACEOFBIRTH": "Ragusa in Dalmatien",
        "PLACEOFDEATH": "Ragusa in Dalmatien:Franziskanerkirche"
    },
    {
        "ID": "15676",
        "NAME": "Gondola, Franz (1630\u20131700), K\u00e4mmerer",
        "DATEOFBIRTH": "1630 Jul 10",
        "DATEOFDEATH": "1700 Aug 16",
        "PLACEOFBIRTH": "Ragusa in Dalmatien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "15677",
        "NAME": "Gondola, Siegmund (1633\u20131682)",
        "DATEOFBIRTH": "1633 Okt 14",
        "DATEOFDEATH": "1682 Sep 22",
        "PLACEOFBIRTH": "Ragusa in Dalmatien",
        "PLACEOFDEATH": "Ragusa in Dalmatien"
    },
    {
        "ID": "15678",
        "NAME": "Gondola, Matthias (1636\u20131684)",
        "DATEOFBIRTH": "1636 Feb 06",
        "DATEOFDEATH": "1684",
        "PLACEOFBIRTH": "Ragusa in Dalmatien",
        "PLACEOFDEATH": "Ragusa in Dalmatien"
    },
    {
        "ID": "15679",
        "NAME": "Nicola, Gregor (1570\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ragusa in Dalmatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15681",
        "NAME": "Ferrari, Williprecht (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Occhieppo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15682",
        "NAME": "Ferrari, Bernhard (1615\u20131691), Obersthofmeister",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1691 Jan 03",
        "PLACEOFBIRTH": "Biella",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "15683",
        "NAME": "Ferrari, Anton (1620\u20131680), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1680~",
        "PLACEOFBIRTH": "Biella",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15684",
        "NAME": "Ferrari, Johann Baptist (1650\u20131715)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1715~",
        "PLACEOFBIRTH": "Biella",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15685",
        "NAME": "Ferrari, Karl Joseph (1681\u20131705), K\u00e4mmerer",
        "DATEOFBIRTH": "1681 Jan 10",
        "DATEOFDEATH": "1705 Jan 22",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "15686",
        "NAME": "Sinzendorf, Johann August (1671\u20131706), K\u00e4mmerer",
        "DATEOFBIRTH": "1671",
        "DATEOFDEATH": "1706",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rottenhof in der Josefstadt"
    },
    {
        "ID": "15687",
        "NAME": "Collalto, Leopold (1674\u20131706), K\u00e4mmerer",
        "DATEOFBIRTH": "1674 Apr 15",
        "DATEOFDEATH": "1706",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rottenhof in der Josefstadt"
    },
    {
        "ID": "15688",
        "NAME": "Pallavicino, Hippolyt (1520\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15689",
        "NAME": "Pallavicino, Hieronym (1565\u2013\u00a0\u00a0\u00a0\u00a0), Edelknabe",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15690",
        "NAME": "Pallavicino, Sforza (1610\u20131663)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1663",
        "PLACEOFBIRTH": "Struppa",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15691",
        "NAME": "Gonzaga, Ludwika (1611\u20131667), K\u00f6nigin von Polen",
        "DATEOFBIRTH": "1611 Aug 18",
        "DATEOFDEATH": "1667 Mai 10",
        "PLACEOFBIRTH": "Paris",
        "PLACEOFDEATH": "Warszawa"
    },
    {
        "ID": "15692",
        "NAME": "Gonzaga, Anna (1616\u20131684)",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1684 Jul 06",
        "PLACEOFBIRTH": "Paris",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "15693",
        "NAME": "Conti, Torquat (1519\u20131572)",
        "DATEOFBIRTH": "1519",
        "DATEOFDEATH": "1572 Sep 03",
        "PLACEOFBIRTH": "Poli",
        "PLACEOFDEATH": "Poli:Stephanskirche"
    },
    {
        "ID": "15694",
        "NAME": "Conti, Appius (1558\u20131593)",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1593 Mar 26",
        "PLACEOFBIRTH": "Poli",
        "PLACEOFDEATH": "Noyon"
    },
    {
        "ID": "15695",
        "NAME": "Conti, Lothar (1560\u20131635)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1635 Okt 08",
        "PLACEOFBIRTH": "Poli",
        "PLACEOFDEATH": "Poli"
    },
    {
        "ID": "15696",
        "NAME": "Conti, Appius (1596\u20131666)",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1666 Aug 07",
        "PLACEOFBIRTH": "Poli",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15697",
        "NAME": "Evoli, Caesar (1532\u20131598), Truchsess",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1598 Jan 20",
        "PLACEOFBIRTH": "Castropignano",
        "PLACEOFDEATH": "Betanzos"
    },
    {
        "ID": "15698",
        "NAME": "Colonna, Elisabeth (1513\u20131570)",
        "DATEOFBIRTH": "1513",
        "DATEOFDEATH": "1570 Apr 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "15699",
        "NAME": "Gonzaga, Julia (1505\u20131566)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1566 Apr 19",
        "PLACEOFBIRTH": "Gazzuolo",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "15701",
        "NAME": "R\u00e9vay, Lassel (1450\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15702",
        "NAME": "R\u00e9vay, Franz (1489\u20131553)",
        "DATEOFBIRTH": "1489",
        "DATEOFDEATH": "1553 Nov 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "15703",
        "NAME": "R\u00e9vay, Franz (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15704",
        "NAME": "R\u00e9vay, Gabriel (1560\u20131598)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Sklabinia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15705",
        "NAME": "R\u00e9vay, Stephan (1485\u20131528)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15706",
        "NAME": "R\u00e9vay, Lassel (1525\u20131592)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15707",
        "NAME": "R\u00e9vay, Stephan (1557\u20131598)",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15708",
        "NAME": "R\u00e9vay, Michael (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15709",
        "NAME": "R\u00e9vay, Peter (1568\u20131622), Ungarischer Kronh\u00fcter",
        "DATEOFBIRTH": "1568 Feb 02",
        "DATEOFDEATH": "1622 Jun 04",
        "PLACEOFBIRTH": "Blatnica in der Turz",
        "PLACEOFDEATH": "Trentschin im Waagtal"
    },
    {
        "ID": "15710",
        "NAME": "R\u00e9vay, Paul (1598\u20131635)",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "Blatnica in der Turz",
        "PLACEOFDEATH": "Hanau am Main"
    },
    {
        "ID": "15711",
        "NAME": "R\u00e9vay, Martin (1565\u20131630)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1630 Sep 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Treboszt\u00f3"
    },
    {
        "ID": "15712",
        "NAME": "R\u00e9vay, Stephan (1602\u20131653)",
        "DATEOFBIRTH": "1602",
        "DATEOFDEATH": "1653",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15713",
        "NAME": "R\u00e9vay, Andreas (1603\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1603",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15714",
        "NAME": "R\u00e9vay, Niklas (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sklabinia",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15715",
        "NAME": "Serbelloni, Gabriel (1450\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15716",
        "NAME": "Serbelloni, Johann Peter (1480\u20131521)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1521",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15717",
        "NAME": "Serbelloni, Z\u00e4zilia (1475\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15718",
        "NAME": "Vasto, Hektor (1545\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Saluzzo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15719",
        "NAME": "Ippoliti di Gazoldo, Anton (1360\u20131433)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1433",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15720",
        "NAME": "Ippoliti di Gazoldo, Jakob (1390\u20131457)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1457 Jul 24",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15721",
        "NAME": "Ippoliti di Gazoldo, Ludwig (1420\u20131482)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1482",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15722",
        "NAME": "Ippoliti di Gazoldo, Anton (1448\u20131504)",
        "DATEOFBIRTH": "1448",
        "DATEOFDEATH": "1504",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15723",
        "NAME": "Ippoliti di Gazoldo, Matthias (1484\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1484",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15724",
        "NAME": "Ippoliti di Gazoldo, Silvester (1510\u20131571)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15725",
        "NAME": "Ippoliti di Gazoldo, Matthias (1540\u20131612)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15726",
        "NAME": "Ippoliti di Gazoldo, Hippolyt (1575\u2013\u00a0\u00a0\u00a0\u00a0), Edelknabe",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15727",
        "NAME": "Ippoliti di Gazoldo, Kamila (1615\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15728",
        "NAME": "Ippoliti di Gazoldo, Albrecht (1485\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15729",
        "NAME": "Ippoliti di Gazoldo, Anton (1515\u20131577)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15730",
        "NAME": "Ippoliti di Gazoldo, Paul (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15731",
        "NAME": "Ippoliti di Gazoldo, Johann Anton (1395\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1395~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15732",
        "NAME": "Ippoliti di Gazoldo, Lanzel (1425\u20131482)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "1482",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15733",
        "NAME": "Ippoliti di Gazoldo, Friedrich (1455\u20131530)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1530",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15734",
        "NAME": "Ippoliti di Gazoldo, Lanzel (1485\u20131554)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1554",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15735",
        "NAME": "Ippoliti di Gazoldo, Friedrich (1515\u20131561)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1561 Feb 08",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15736",
        "NAME": "Ippoliti di Gazoldo, Hannibal (1545\u20131587), Hofdiener",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1587",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15737",
        "NAME": "Ippoliti di Gazoldo, Franz (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15738",
        "NAME": "Ippoliti di Gazoldo, Franz (1605\u20131666)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1666 Dez 23",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15739",
        "NAME": "Ippoliti di Gazoldo, Hannibal (1635\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15740",
        "NAME": "Ippoliti di Gazoldo, Maximilian (1550\u20131616)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15741",
        "NAME": "Ippoliti di Gazoldo, Friedrich (1580\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1638 Jan 09",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15742",
        "NAME": "Ippoliti di Gazoldo, Herkules (1545\u20131609)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "Mantova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15743",
        "NAME": "Ippoliti di Gazoldo, Rudolf (1575\u20131642)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Frassino",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15744",
        "NAME": "Ippoliti di Gazoldo, Silvester (1610\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Frassino",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15745",
        "NAME": "Ippoliti di Gazoldo, Paul (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Frassino",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15746",
        "NAME": "Ippoliti di Gazoldo, Hektor (1635\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Frassino",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15747",
        "NAME": "Ippoliti di Gazoldo, Diana (1636\u20131687)",
        "DATEOFBIRTH": "1636 Sep 02",
        "DATEOFDEATH": "1687 Sep 22",
        "PLACEOFBIRTH": "Frassino",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "15748",
        "NAME": "Myslik von Hirschau, Susanna (1644\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1644 Nov 01",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15749",
        "NAME": "Castiglioni, Anna (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15750",
        "NAME": "Wittelsbach, Joseph Klement (1671\u20131723), Erzbischof von K\u00f6ln",
        "DATEOFBIRTH": "1671 Dez 05",
        "DATEOFDEATH": "1723 Nov 12",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Bonn"
    },
    {
        "ID": "15751",
        "NAME": "Sz\u00e9kely von K\u00f6vend, Blessel (1410\u20131449)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1449 Sep 05",
        "PLACEOFBIRTH": "K\u00f6vend",
        "PLACEOFDEATH": "Kaschau"
    },
    {
        "ID": "15752",
        "NAME": "Sz\u00e9kely von K\u00f6vend, Jakob (1445\u20131504), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1504 Aug 27",
        "PLACEOFBIRTH": "K\u00f6vend",
        "PLACEOFDEATH": "Olsnitz an der Mur"
    },
    {
        "ID": "15754",
        "NAME": "Sz\u00e9kely von K\u00f6vend, Lauk (1500\u20131575)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1575 Feb 08",
        "PLACEOFBIRTH": "Friedau an der Drau",
        "PLACEOFDEATH": "Friedau an der Drau"
    },
    {
        "ID": "15755",
        "NAME": "Sz\u00e9kely von K\u00f6vend, Katharina (1535\u20131578)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1578",
        "PLACEOFBIRTH": "Friedau an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15756",
        "NAME": "Batthy\u00e1ny, Balthasar (1450\u20131520)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1520",
        "PLACEOFBIRTH": "Schlaining",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15757",
        "NAME": "Batthy\u00e1ny, Balthasar (1480\u20131528)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "Schlaining",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15758",
        "NAME": "Batthy\u00e1ny, Christoph (1510\u20131570)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1570 Feb 04",
        "PLACEOFBIRTH": "Schlaining",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15759",
        "NAME": "Batthy\u00e1ny, Franz (1497\u20131566), Ban von Kroatien",
        "DATEOFBIRTH": "1497 Okt 28",
        "DATEOFDEATH": "1566 Nov 28",
        "PLACEOFBIRTH": "Schlaining",
        "PLACEOFDEATH": "G\u00fcssing"
    },
    {
        "ID": "15760",
        "NAME": "Bruxelles, Williprecht (1505\u20131570)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1570 Okt 21",
        "PLACEOFBIRTH": "Mechelen",
        "PLACEOFDEATH": "Antwerpen"
    },
    {
        "ID": "15761",
        "NAME": "Bruxelles, Williprecht (1546\u20131580), Truchsess",
        "DATEOFBIRTH": "1546 Aug 09",
        "DATEOFDEATH": "1580 Dez 03",
        "PLACEOFBIRTH": "Mechelen",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "15762",
        "NAME": "Rym, Gerhard (1503\u20131570)",
        "DATEOFBIRTH": "1503 Nov 25",
        "DATEOFDEATH": "1570 Dez 03",
        "PLACEOFBIRTH": "Eekenbeke",
        "PLACEOFDEATH": "Gent in Flandern:Michaelskirche"
    },
    {
        "ID": "15763",
        "NAME": "Rym, Karl (1533\u20131584), Reichshofrat",
        "DATEOFBIRTH": "1533 Sep 11",
        "DATEOFDEATH": "1584 Apr 13",
        "PLACEOFBIRTH": "Eekenbeke",
        "PLACEOFDEATH": "Bellem"
    },
    {
        "ID": "15764",
        "NAME": "Rym, Williprecht (1567\u20131634)",
        "DATEOFBIRTH": "1567 Mai 11",
        "DATEOFDEATH": "1634 Jan 06",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Gent in Flandern"
    },
    {
        "ID": "15765",
        "NAME": "Rym, Karl (1601\u20131671)",
        "DATEOFBIRTH": "1601 Jul 15",
        "DATEOFDEATH": "1671",
        "PLACEOFBIRTH": "Gent in Flandern",
        "PLACEOFDEATH": "Gent in Flandern"
    },
    {
        "ID": "15766",
        "NAME": "Rym, Franz (1539\u20131612)",
        "DATEOFBIRTH": "1539 Apr 26",
        "DATEOFDEATH": "1612 Sep 03",
        "PLACEOFBIRTH": "Eekenbeke",
        "PLACEOFDEATH": "Gent in Flandern"
    },
    {
        "ID": "15767",
        "NAME": "Rym, Karl (1575\u20131635), Vorschneider",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1635",
        "PLACEOFBIRTH": "Gent in Flandern",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15768",
        "NAME": "Biglia, Balthasar (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Saronno",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15769",
        "NAME": "Biglia, Anton (1580\u20131643), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1643 Jan 25",
        "PLACEOFBIRTH": "Saronno",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15770",
        "NAME": "Biglia, Magdalena (1585\u20131654)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1654 Mar 27",
        "PLACEOFBIRTH": "Saronno",
        "PLACEOFDEATH": "Gratzen in B\u00f6hmen"
    },
    {
        "ID": "15772",
        "NAME": "Bakics, Paul (1485\u20131537)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1537 Sep 20",
        "PLACEOFBIRTH": "Ven\u010dac",
        "PLACEOFDEATH": "Diakov\u00e1r"
    },
    {
        "ID": "15773",
        "NAME": "Bakics, Peter (1488\u20131552)",
        "DATEOFBIRTH": "1488",
        "DATEOFDEATH": "1552",
        "PLACEOFBIRTH": "Ven\u010dac",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15774",
        "NAME": "Bakics, Michael (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ven\u010dac",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15775",
        "NAME": "Bakics, Paul (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Lak in der Schomodei",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15776",
        "NAME": "Bakics, Michael (1530\u20131597), Truchsess",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "Lak in der Schomodei",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15777",
        "NAME": "Frangipane di Veglia, Klara (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15778",
        "NAME": "Frangipane di Veglia, Michael (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sluin",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15779",
        "NAME": "Frangipane di Veglia, Dorothea (1505\u20131575)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1575",
        "PLACEOFBIRTH": "Sluin",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15780",
        "NAME": "Frundsberg, Ulrich (1425\u20131501)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "1501 Aug 11",
        "PLACEOFBIRTH": "Freundsberg in Tirol",
        "PLACEOFDEATH": "Mindelheim"
    },
    {
        "ID": "15781",
        "NAME": "Frundsberg, Ulrich (1460\u20131493), Bischof von Trient",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1493 Aug 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "15782",
        "NAME": "Frundsberg, Georg (1473\u20131528)",
        "DATEOFBIRTH": "1473 Sep 24",
        "DATEOFDEATH": "1528 Aug 20",
        "PLACEOFBIRTH": "Mindelheim",
        "PLACEOFDEATH": "Mindelheim"
    },
    {
        "ID": "15783",
        "NAME": "Frundsberg, Kaspar (1501\u20131536)",
        "DATEOFBIRTH": "1501 Jul 05",
        "DATEOFDEATH": "1536 Aug 31",
        "PLACEOFBIRTH": "Mindelheim",
        "PLACEOFDEATH": "Mindelheim"
    },
    {
        "ID": "15784",
        "NAME": "Frundsberg, Balthasar (1506\u20131531), Mundschenk",
        "DATEOFBIRTH": "1506",
        "DATEOFDEATH": "1531",
        "PLACEOFBIRTH": "Mindelheim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15785",
        "NAME": "Frundsberg, Georg (1533\u20131586), Hofdiener",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1586 Nov 01",
        "PLACEOFBIRTH": "Mindelheim",
        "PLACEOFDEATH": "Mindelheim"
    },
    {
        "ID": "15786",
        "NAME": "Auersperg, Andreas (1556\u20131593), Hofkriegsrat",
        "DATEOFBIRTH": "1556 Apr 09",
        "DATEOFDEATH": "1593 Sep 05",
        "PLACEOFBIRTH": "Seisenberg in der Krain",
        "PLACEOFDEATH": "Karlstadt in Kroatien"
    },
    {
        "ID": "15787",
        "NAME": "Salm, Johann (1458\u20131505)",
        "DATEOFBIRTH": "1458",
        "DATEOFDEATH": "1505 Apr 11",
        "PLACEOFBIRTH": "Salm in den Ardennen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15788",
        "NAME": "Salm, Johann (1495\u20131548)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "Salm in den Ardennen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15789",
        "NAME": "Salm, Johann (1528\u20131600)",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1600 Jan 14",
        "PLACEOFBIRTH": "Salm in den Ardennen",
        "PLACEOFDEATH": "Nancy"
    },
    {
        "ID": "15790",
        "NAME": "Orsini von Blagay, Stephan (1490\u20131548)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "Blagay an der Sana",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15791",
        "NAME": "Orsini von Blagay, Franz (1525\u20131576), Hofdiener",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1576 Aug 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15792",
        "NAME": "Orsini von Blagay, Georg (1555\u20131588)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "Gottschee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15793",
        "NAME": "Orsini von Blagay, Stephan (1560\u20131598)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Gottschee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15794",
        "NAME": "Orsini von Blagay, Niklas (1565\u20131606), Edelknabe",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "Gottschee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15795",
        "NAME": "Orsini von Blagay, Johann Weikhard (1585\u20131618)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "Gottschee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15796",
        "NAME": "Per\u00e9nyi, Michael (1518\u20131557)",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1557 Dez 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Plankenburg in den Karpaten"
    },
    {
        "ID": "15797",
        "NAME": "Bakics, Anna (1540\u20131588)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "Lak in der Schomodei",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15798",
        "NAME": "Hunyadi, Johann (1400\u20131456)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1456 Aug 11",
        "PLACEOFBIRTH": "Eisenmarkt in Siebenb\u00fcrgen",
        "PLACEOFDEATH": "Wei\u00dfenburg in Serbien"
    },
    {
        "ID": "15799",
        "NAME": "Szil\u00e1gyi von Horogszeg, Elisabeth (1410\u20131483)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1483 Apr 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15800",
        "NAME": "Hunyadi, Matthias (1443\u20131490), K\u00f6nig von Ungarn",
        "DATEOFBIRTH": "1443 Feb 23",
        "DATEOFDEATH": "1490 Apr 06",
        "PLACEOFBIRTH": "Klausenburg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "15801",
        "NAME": "Hunyadi, Johann (1473\u20131504), Ban von Kroatien",
        "DATEOFBIRTH": "1473 Apr 02",
        "DATEOFDEATH": "1504 Okt 12",
        "PLACEOFBIRTH": "Ofen",
        "PLACEOFDEATH": "Krapina"
    },
    {
        "ID": "15802",
        "NAME": "Castellalto, Franz (1480\u20131554)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1554 Nov 29",
        "PLACEOFBIRTH": "Kastelalt im Suganertal",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "15803",
        "NAME": "Oettingen, Ludwig (1486\u20131557)",
        "DATEOFBIRTH": "1486 Apr 25",
        "DATEOFDEATH": "1557 Mar 24",
        "PLACEOFBIRTH": "Oettingen im Ries",
        "PLACEOFDEATH": "Alerheim im Ries"
    },
    {
        "ID": "15804",
        "NAME": "Oettingen, Ludwig (1508\u20131569)",
        "DATEOFBIRTH": "1508 Jul 02",
        "DATEOFDEATH": "1569 Okt 01",
        "PLACEOFBIRTH": "Harburg in Schwaben",
        "PLACEOFDEATH": "Harburg in Schwaben"
    },
    {
        "ID": "15805",
        "NAME": "Oettingen, Gottfried (1554\u20131622)",
        "DATEOFBIRTH": "1554 Jun 08",
        "DATEOFDEATH": "1622 Sep 07",
        "PLACEOFBIRTH": "Bietigheim",
        "PLACEOFDEATH": "Oettingen im Ries"
    },
    {
        "ID": "15806",
        "NAME": "Oettingen, Ludwig Eberhard (1577\u20131634)",
        "DATEOFBIRTH": "1577 Jun 09",
        "DATEOFDEATH": "1634 Jun 24",
        "PLACEOFBIRTH": "Oettingen im Ries",
        "PLACEOFDEATH": "Heidenheim an der Brenz"
    },
    {
        "ID": "15807",
        "NAME": "Oettingen, Joachim Ernst (1612\u20131659)",
        "DATEOFBIRTH": "1612 Mar 31",
        "DATEOFDEATH": "1659 Aug 08",
        "PLACEOFBIRTH": "Oettingen im Ries",
        "PLACEOFDEATH": "Harburg in Schwaben"
    },
    {
        "ID": "15808",
        "NAME": "Oettingen, Hedwig Augusta (1652\u20131724)",
        "DATEOFBIRTH": "1652 Dez 09",
        "DATEOFDEATH": "1724 Mar 10",
        "PLACEOFBIRTH": "Oettingen im Ries",
        "PLACEOFDEATH": "Kornberg in der Steiermark"
    },
    {
        "ID": "15809",
        "NAME": "Oettingen, Friedrich (1516\u20131579)",
        "DATEOFBIRTH": "1516 Nov 06",
        "DATEOFDEATH": "1579 Feb 02",
        "PLACEOFBIRTH": "Harburg in Schwaben",
        "PLACEOFDEATH": "Wallerstein"
    },
    {
        "ID": "15810",
        "NAME": "Oettingen, Friedrich (1556\u20131615), Reichshofrat",
        "DATEOFBIRTH": "1556 Feb 20",
        "DATEOFDEATH": "1615 Jun 20",
        "PLACEOFBIRTH": "Wallerstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15820",
        "NAME": "Wittelsbach, Albrecht (1601\u20131620), Graf von Wartenberg",
        "DATEOFBIRTH": "1601 Mai 03",
        "DATEOFDEATH": "1620 Dez 06",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "15821",
        "NAME": "Wittelsbach, Ernst Bernhard (1604\u20131666), Graf von Wartenberg",
        "DATEOFBIRTH": "1604 Feb 13",
        "DATEOFDEATH": "1666 Mar 08",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Erding am Moos"
    },
    {
        "ID": "15822",
        "NAME": "Wittelsbach, Ferdinand Lorenz (1606\u20131666), Graf von Wartenberg",
        "DATEOFBIRTH": "1606 Aug 09",
        "DATEOFDEATH": "1666 Mar 18",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Burghausen an der Salzach"
    },
    {
        "ID": "15823",
        "NAME": "Wittelsbach, Ferdinand Ernst (1630\u20131675), Graf von Wartenberg",
        "DATEOFBIRTH": "1630 Mai 20",
        "DATEOFDEATH": "1675 Sep 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "15824",
        "NAME": "Wittelsbach, Ferdinand Markward (1673\u20131730), Graf von Wartenberg",
        "DATEOFBIRTH": "1673 Mai 25",
        "DATEOFDEATH": "1730 Apr 04",
        "PLACEOFBIRTH": "Regensburg",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "15865",
        "NAME": "Vaud\u00e9mont, Anton (1489\u20131544), Herzog von Lothringen",
        "DATEOFBIRTH": "1489 Jun 04",
        "DATEOFDEATH": "1544 Jun 14",
        "PLACEOFBIRTH": "Bar sur Ornain",
        "PLACEOFDEATH": "Bar sur Ornain"
    },
    {
        "ID": "15866",
        "NAME": "Vaud\u00e9mont, Franz (1517\u20131545), Herzog von Lothringen",
        "DATEOFBIRTH": "1517 Aug 23",
        "DATEOFDEATH": "1545 Jun 12",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": "Remiremont"
    },
    {
        "ID": "15867",
        "NAME": "Vaud\u00e9mont, Renata (1544\u20131602), Herzogin in Bayern",
        "DATEOFBIRTH": "1544 Apr 20",
        "DATEOFDEATH": "1602 Mai 22",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": "M\u00fcnchen:Michaelskirche"
    },
    {
        "ID": "15868",
        "NAME": "Vaud\u00e9mont, Karl (1543\u20131608), Herzog von Lothringen",
        "DATEOFBIRTH": "1543 Feb 18",
        "DATEOFDEATH": "1608 Mai 14",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": "Nancy"
    },
    {
        "ID": "15869",
        "NAME": "Vaud\u00e9mont, Elisabeth (1574\u20131635)",
        "DATEOFBIRTH": "1574 Okt 09",
        "DATEOFDEATH": "1635 Jan 04",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": "Braunau am Inn"
    },
    {
        "ID": "15870",
        "NAME": "Istv\u00e1nffy, Niklas (1538\u20131615), Hofsekret\u00e4r",
        "DATEOFBIRTH": "1538 Dez 08",
        "DATEOFDEATH": "1615 Apr 01",
        "PLACEOFBIRTH": "Frauendorf in der Branau",
        "PLACEOFDEATH": "Vinica in Kroatien"
    },
    {
        "ID": "15871",
        "NAME": "Istv\u00e1nffy, Eva (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Vinica in Kroatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15872",
        "NAME": "Montfort, Anton (1670\u20131733)",
        "DATEOFBIRTH": "1670 Nov 26",
        "DATEOFDEATH": "1733 Dez 12",
        "PLACEOFBIRTH": "Tettnang",
        "PLACEOFDEATH": "Salzburg:Franziskanerkirche"
    },
    {
        "ID": "15873",
        "NAME": "Salm, Franziska (1545\u20131587)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1587",
        "PLACEOFBIRTH": "Salm in den Ardennen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15874",
        "NAME": "Salm, Eginhard (1527\u20131575), K\u00e4mmerer",
        "DATEOFBIRTH": "1527",
        "DATEOFDEATH": "1575 Jul 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "15875",
        "NAME": "Salm, Wolfgang (1509\u20131555), Bischof von Passau",
        "DATEOFBIRTH": "1509",
        "DATEOFDEATH": "1555 Dez 05",
        "PLACEOFBIRTH": "Marchegg",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "15876",
        "NAME": "Salm, Paul (1535\u20131586)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "Salm in den Ardennen",
        "PLACEOFDEATH": "Badonviller im Wasgenwald"
    },
    {
        "ID": "15877",
        "NAME": "Salm, Anton (1530\u20131560), Abt von Hornbach",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1560~",
        "PLACEOFBIRTH": "Salm in den Ardennen",
        "PLACEOFDEATH": "Speyer"
    },
    {
        "ID": "15878",
        "NAME": "Salm, Christina (1575\u20131627), Herzogin von Lothringen",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1627 Dez 31",
        "PLACEOFBIRTH": "Salm in den Ardennen",
        "PLACEOFDEATH": "Badonviller im Wasgenwald"
    },
    {
        "ID": "15879",
        "NAME": "Salm, Klaudius (1540\u20131583)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1583 Okt 22",
        "PLACEOFBIRTH": "Salm in den Ardennen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15880",
        "NAME": "Vaud\u00e9mont, Franz (1572\u20131632), Herzog von Lothringen",
        "DATEOFBIRTH": "1572 Feb 27",
        "DATEOFDEATH": "1632 Okt 14",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": "Badonviller im Wasgenwald"
    },
    {
        "ID": "15881",
        "NAME": "Madrutsch, Katharina (1509\u20131551)",
        "DATEOFBIRTH": "1509",
        "DATEOFDEATH": "1551 Nov 16",
        "PLACEOFBIRTH": "Madrutsch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15888",
        "NAME": "Sobieski, Johann (1629\u20131696), K\u00f6nig von Polen",
        "DATEOFBIRTH": "1629 Aug 17",
        "DATEOFDEATH": "1696 Jun 17",
        "PLACEOFBIRTH": "Olesko",
        "PLACEOFDEATH": "Wilan\u00f3w"
    },
    {
        "ID": "15889",
        "NAME": "Sobieski, Theresa Kunigunda (1676\u20131730), Herzogin in Bayern",
        "DATEOFBIRTH": "1676 Mar 04",
        "DATEOFDEATH": "1730 Mar 10",
        "PLACEOFBIRTH": "Warszawa",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "15890",
        "NAME": "Vaud\u00e9mont, Karl (1604\u20131675), Herzog von Lothringen",
        "DATEOFBIRTH": "1604 Apr 05",
        "DATEOFDEATH": "1675 Sep 18",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": "Allenbach im Hunsr\u00fcck"
    },
    {
        "ID": "15971",
        "NAME": "Biglia, Kaspar (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "15972",
        "NAME": "Biglia, Anton (1650\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16000",
        "NAME": "Vaud\u00e9mont, Franz\u00a0I. (1708\u20131765), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1708 Dez 08",
        "DATEOFDEATH": "1765 Aug 18",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "16001",
        "NAME": "Habsburg, Rudolf (1282\u20131307), K\u00f6nig von B\u00f6hmen",
        "DATEOFBIRTH": "1282",
        "DATEOFDEATH": "1307 Jul 04",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16002",
        "NAME": "Habsburg, Albrecht (1298\u20131358)",
        "DATEOFBIRTH": "1298 Dez 12",
        "DATEOFDEATH": "1358 Jul 20",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "16003",
        "NAME": "Habsburg, Albrecht (1349\u20131395)",
        "DATEOFBIRTH": "1349 Apr 19",
        "DATEOFDEATH": "1395 Aug 28",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Laxenburg"
    },
    {
        "ID": "16004",
        "NAME": "Habsburg, Albrecht (1377\u20131404)",
        "DATEOFBIRTH": "1377 Sep 20",
        "DATEOFDEATH": "1404 Sep 14",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Znaim"
    },
    {
        "ID": "16005",
        "NAME": "Habsburg, Friedrich (1286\u20131330), K\u00f6nig des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1286",
        "DATEOFDEATH": "1330 Jan 13",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Gutenstein an der Piesting"
    },
    {
        "ID": "16006",
        "NAME": "Habsburg, Leopold (1290\u20131326)",
        "DATEOFBIRTH": "1290 Aug 04",
        "DATEOFDEATH": "1326 Feb 28",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Stra\u00dfburg im Elsass"
    },
    {
        "ID": "16007",
        "NAME": "Habsburg, Heinrich (1298\u20131327)",
        "DATEOFBIRTH": "1298 Dez 12",
        "DATEOFDEATH": "1327 Feb 03",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Bruck an der Mur"
    },
    {
        "ID": "16008",
        "NAME": "Habsburg, Otto (1301\u20131339)",
        "DATEOFBIRTH": "1301 Jul 23",
        "DATEOFDEATH": "1339 Feb 17",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Neuberg an der M\u00fcrz"
    },
    {
        "ID": "16009",
        "NAME": "Habsburg, Rudolf (1260\u20131290)",
        "DATEOFBIRTH": "1260~",
        "DATEOFDEATH": "1290 Mai 10",
        "PLACEOFBIRTH": "Rheinfelden im Aargau",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "16010",
        "NAME": "Habsburg, Anna (1573\u20131598), K\u00f6nigin von Polen",
        "DATEOFBIRTH": "1573 Aug 16",
        "DATEOFDEATH": "1598 Feb 10",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Warszawa"
    },
    {
        "ID": "16011",
        "NAME": "Habsburg, Konstantia (1588\u20131631), K\u00f6nigin von Polen",
        "DATEOFBIRTH": "1588 Dez 24",
        "DATEOFDEATH": "1631 Jul 10",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Warszawa"
    },
    {
        "ID": "16012",
        "NAME": "Habsburg, Margarita (1584\u20131611), K\u00f6nigin von Spanien",
        "DATEOFBIRTH": "1584 Dez 25",
        "DATEOFDEATH": "1611 Okt 03",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "San Lorenzo de El Escorial"
    },
    {
        "ID": "16013",
        "NAME": "Habsburg, Maximilian (1583\u20131616)",
        "DATEOFBIRTH": "1583 Nov 17",
        "DATEOFDEATH": "1616 Feb 18",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "16020",
        "NAME": "Habsburg, Rudolf (1339\u20131365)",
        "DATEOFBIRTH": "1339 Nov 01",
        "DATEOFDEATH": "1365 Jul 27",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "16021",
        "NAME": "Habsburg, Leopold (1351\u20131386)",
        "DATEOFBIRTH": "1351 Nov 01",
        "DATEOFDEATH": "1386 Jul 09",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Sempach"
    },
    {
        "ID": "16022",
        "NAME": "Habsburg, Leopold (1371\u20131411)",
        "DATEOFBIRTH": "1371",
        "DATEOFDEATH": "1411 Jun 03",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "16023",
        "NAME": "Habsburg, Wilhelm (1372\u20131406)",
        "DATEOFBIRTH": "1372",
        "DATEOFDEATH": "1406 Jul 15",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "16024",
        "NAME": "Habsburg, Ernst (1377\u20131424)",
        "DATEOFBIRTH": "1377",
        "DATEOFDEATH": "1424 Jun 10",
        "PLACEOFBIRTH": "Bruck an der Mur",
        "PLACEOFDEATH": "Bruck an der Mur"
    },
    {
        "ID": "16025",
        "NAME": "Habsburg, Friedrich (1382\u20131439), Landesherr von Tirol",
        "DATEOFBIRTH": "1382",
        "DATEOFDEATH": "1439 Jun 24",
        "PLACEOFBIRTH": "Bruck an der Mur",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "16026",
        "NAME": "Sch\u00f6nborn, Friedrich Georg (1574\u20131615)",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1615 Apr 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16027",
        "NAME": "Sch\u00f6nborn, Johann Philipp (1605\u20131673), Erzbischof von Mainz",
        "DATEOFBIRTH": "1605 Aug 06",
        "DATEOFDEATH": "1673 Feb 12",
        "PLACEOFBIRTH": "Eschbach im Westerwald",
        "PLACEOFDEATH": "W\u00fcrzburg"
    },
    {
        "ID": "16028",
        "NAME": "Sch\u00f6nborn, Philipp Erwin (1607\u20131668)",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1668 Nov 04",
        "PLACEOFBIRTH": "Eschbach im Westerwald",
        "PLACEOFDEATH": "Geisenheim im Rheingau"
    },
    {
        "ID": "16029",
        "NAME": "Sch\u00f6nborn, Lothar Franz (1655\u20131729), Erzbischof von Mainz",
        "DATEOFBIRTH": "1655 Okt 04",
        "DATEOFDEATH": "1729 Jan 30",
        "PLACEOFBIRTH": "Steinheim am Main",
        "PLACEOFDEATH": "Mainz"
    },
    {
        "ID": "16030",
        "NAME": "Sch\u00f6nborn, Melchior Friedrich (1644\u20131717), Geheimer Rat",
        "DATEOFBIRTH": "1644 Mar 16",
        "DATEOFDEATH": "1717 Mai 19",
        "PLACEOFBIRTH": "Steinheim am Main",
        "PLACEOFDEATH": "Frankfurt am Main"
    },
    {
        "ID": "16031",
        "NAME": "Sch\u00f6nborn, Johann Philipp (1673\u20131724), Bischof von W\u00fcrzburg",
        "DATEOFBIRTH": "1673 Feb 15",
        "DATEOFDEATH": "1724 Aug 18",
        "PLACEOFBIRTH": "W\u00fcrzburg",
        "PLACEOFDEATH": "Mergentheim im Taubertal"
    },
    {
        "ID": "16032",
        "NAME": "Sch\u00f6nborn, Friedrich Karl (1674\u20131746), Bischof von W\u00fcrzburg",
        "DATEOFBIRTH": "1674 Mar 03",
        "DATEOFDEATH": "1746 Jul 25",
        "PLACEOFBIRTH": "Mainz",
        "PLACEOFDEATH": "W\u00fcrzburg"
    },
    {
        "ID": "16033",
        "NAME": "Sch\u00f6nborn, Damian Haug (1676\u20131743), Bischof von Speyer",
        "DATEOFBIRTH": "1676 Sep 19",
        "DATEOFDEATH": "1743 Aug 19",
        "PLACEOFBIRTH": "Mainz",
        "PLACEOFDEATH": "Bruchsal:Peterskirche"
    },
    {
        "ID": "16034",
        "NAME": "Sch\u00f6nborn, Rudolf Franz (1677\u20131754), K\u00e4mmerer",
        "DATEOFBIRTH": "1677 Okt 23",
        "DATEOFDEATH": "1754 Sep 22",
        "PLACEOFBIRTH": "Mainz",
        "PLACEOFDEATH": "Gaibach in Franken"
    },
    {
        "ID": "16035",
        "NAME": "Sch\u00f6nborn, Franz Georg (1682\u20131756), Erzbischof von Trier",
        "DATEOFBIRTH": "1682 Jun 15",
        "DATEOFDEATH": "1756 Jan 18",
        "PLACEOFBIRTH": "Mainz",
        "PLACEOFDEATH": "Ehrenbreitstein"
    },
    {
        "ID": "16036",
        "NAME": "Sch\u00f6nborn, Melchior Friedrich (1711\u20131754), Propst von Sankt Alban",
        "DATEOFBIRTH": "1711 Mar 15",
        "DATEOFDEATH": "1754 Feb 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wiesentheid"
    },
    {
        "ID": "16037",
        "NAME": "Sch\u00f6nborn, Anna Barbara (1648\u20131721)",
        "DATEOFBIRTH": "1648 Dez 18",
        "DATEOFDEATH": "1721 Mar 06",
        "PLACEOFBIRTH": "Steinheim am Main",
        "PLACEOFDEATH": "Mainz"
    },
    {
        "ID": "16038",
        "NAME": "Hohenberg, Burkhard (1190\u20131253)",
        "DATEOFBIRTH": "1190~",
        "DATEOFDEATH": "1253 Jul 14",
        "PLACEOFBIRTH": "Hohenberg im Zollernalbkreis",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16039",
        "NAME": "Hohenberg, Albrecht (1235\u20131298), Graf von Haigerloch",
        "DATEOFBIRTH": "1235~",
        "DATEOFDEATH": "1298 Apr 17",
        "PLACEOFBIRTH": "Hohenberg im Zollernalbkreis",
        "PLACEOFDEATH": "Leinstetten an der Glatt"
    },
    {
        "ID": "16040",
        "NAME": "Hohenberg, Anna (1230\u20131281), K\u00f6nigin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1230~",
        "DATEOFDEATH": "1281 Feb 16",
        "PLACEOFBIRTH": "Hohenberg im Zollernalbkreis",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "16041",
        "NAME": "Leiningen, Emmerich (1498\u20131541)",
        "DATEOFBIRTH": "1498",
        "DATEOFDEATH": "1541 Jan 10",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16042",
        "NAME": "Leiningen, Emmerich (1540\u20131593)",
        "DATEOFBIRTH": "1540 Dez 15",
        "DATEOFDEATH": "1593 Mar 13",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16043",
        "NAME": "Leiningen, Johann Philipp (1539\u20131562)",
        "DATEOFBIRTH": "1539 Dez 25",
        "DATEOFDEATH": "1562 Sep 08",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16044",
        "NAME": "Leiningen, Emmerich (1562\u20131607)",
        "DATEOFBIRTH": "1562 Nov 04",
        "DATEOFDEATH": "1607 Nov 24",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": "Darmstadt"
    },
    {
        "ID": "16045",
        "NAME": "Leiningen, Friedrich (1593\u20131651), K\u00e4mmerer",
        "DATEOFBIRTH": "1593 Feb 08",
        "DATEOFDEATH": "1651 Apr 29",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16046",
        "NAME": "Leiningen, Maria Ursula (1590\u20131649)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1649 Aug 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16070",
        "NAME": "Marschall von Pappenheim, Konrad (1410\u20131482)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1482 Apr 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pappenheim an der Altm\u00fchl"
    },
    {
        "ID": "16071",
        "NAME": "Marschall von Pappenheim, Georg (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wespenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16072",
        "NAME": "Marschall von Pappenheim, Sebastian (1470\u20131536)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1536",
        "PLACEOFBIRTH": "Wespenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16073",
        "NAME": "Marschall von Pappenheim, Achaz (1510\u20131561)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1561 Feb 22",
        "PLACEOFBIRTH": "Wespenstein",
        "PLACEOFDEATH": "Gr\u00e4fenthal in Th\u00fcringen:Marienkirche"
    },
    {
        "ID": "16074",
        "NAME": "Marschall von Pappenheim, Christoph Ulrich (1546\u20131599), Truchsess",
        "DATEOFBIRTH": "1546 Apr 15",
        "DATEOFDEATH": "1599 Dez 11",
        "PLACEOFBIRTH": "Wespenstein",
        "PLACEOFDEATH": "Gr\u00e4fenthal in Th\u00fcringen:Marienkirche"
    },
    {
        "ID": "16075",
        "NAME": "Habsburg, Siegmund (1427\u20131496), Landesherr von Tirol",
        "DATEOFBIRTH": "1427 Okt 26",
        "DATEOFDEATH": "1496 Mar 04",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "16076",
        "NAME": "Wettin, Katharina (1468\u20131524)",
        "DATEOFBIRTH": "1468 Jul 24",
        "DATEOFDEATH": "1524 Feb 10",
        "PLACEOFBIRTH": "Grimma im Muldetal",
        "PLACEOFDEATH": "Calenberg an der Leine"
    },
    {
        "ID": "16084",
        "NAME": "Habsburg, Margarita (1417\u20131486)",
        "DATEOFBIRTH": "1417",
        "DATEOFDEATH": "1486 Feb 12",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Altenburg in Th\u00fcringen"
    },
    {
        "ID": "16085",
        "NAME": "Habsburg, Klaudia Felizitas (1653\u20131676), Kaiserin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1653 Mai 30",
        "DATEOFDEATH": "1676 Apr 08",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Wien:Dominikanerkirche"
    },
    {
        "ID": "16086",
        "NAME": "Trivulzio, Johann Jakob (1375\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1375~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16087",
        "NAME": "Trivulzio, Peter (1420\u20131473)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1473 Dez 01",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Tortona"
    },
    {
        "ID": "16088",
        "NAME": "Trivulzio, Theoderich (1456\u20131532)",
        "DATEOFBIRTH": "1456",
        "DATEOFDEATH": "1532",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Lyon"
    },
    {
        "ID": "16089",
        "NAME": "Trivulzio, Theoderich (1534\u20131622)",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1622",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16090",
        "NAME": "Trivulzio, Johann Firmin (1430\u20131491)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1491 Jan 27",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16091",
        "NAME": "Trivulzio, Scharmutz (1465\u20131527), Bischof von Como",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1527 Aug 03",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "16092",
        "NAME": "Trivulzio, Theoderich (1470\u20131524)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1524",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Lodi"
    },
    {
        "ID": "16093",
        "NAME": "Trivulzio, Theoderich (1520\u20131577)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Melzo"
    },
    {
        "ID": "16094",
        "NAME": "Trivulzio, Theoderich (1564\u20131605)",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1605 Okt 09",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16095",
        "NAME": "Trivulzio, Theoderich (1597\u20131656)",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1656 Aug 03",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "16096",
        "NAME": "Trivulzio, Oktavia (1618\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16097",
        "NAME": "Trivulzio, Georg (1460\u20131512)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16098",
        "NAME": "Trivulzio, Johann Firmin (1501\u20131556)",
        "DATEOFBIRTH": "1501",
        "DATEOFDEATH": "1556 Dez 03",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16099",
        "NAME": "Trivulzio, Hotze (1540\u20131573), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1573",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16119",
        "NAME": "Croy, Johann (1365\u20131415)",
        "DATEOFBIRTH": "1365~",
        "DATEOFDEATH": "1415 Okt 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Agincourt"
    },
    {
        "ID": "16120",
        "NAME": "Croy, Anton (1402\u20131475)",
        "DATEOFBIRTH": "1402",
        "DATEOFDEATH": "1475 Okt 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16121",
        "NAME": "Croy, Johann (1403\u20131473)",
        "DATEOFBIRTH": "1403",
        "DATEOFDEATH": "1473 Mar 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Valenciennes"
    },
    {
        "ID": "16122",
        "NAME": "Croy, Johann (1436\u20131505)",
        "DATEOFBIRTH": "1436",
        "DATEOFDEATH": "1505",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16123",
        "NAME": "Croy, Friedrich (1465\u20131524), Obersthofmeister",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1524 Jun 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Saint Omer"
    },
    {
        "ID": "16124",
        "NAME": "Croy, Hadrian (1492\u20131553)",
        "DATEOFBIRTH": "1492",
        "DATEOFDEATH": "1553 Jun 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Terenburg"
    },
    {
        "ID": "16125",
        "NAME": "Croy, Philipp (1430\u20131482)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1482 Sep 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Br\u00fcgge"
    },
    {
        "ID": "16126",
        "NAME": "Croy, Anton (1470\u20131546)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1546",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Solre le Ch\u00e2teau"
    },
    {
        "ID": "16127",
        "NAME": "Croy, Jakob (1508\u20131587), Mundschenk",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "1587 Feb 07",
        "PLACEOFBIRTH": "Solre le Ch\u00e2teau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16128",
        "NAME": "Croy, Philipp (1562\u20131612)",
        "DATEOFBIRTH": "1562",
        "DATEOFDEATH": "1612 Feb 04",
        "PLACEOFBIRTH": "Solre le Ch\u00e2teau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16129",
        "NAME": "Croy, Johann (1588\u20131638), K\u00e4mmerer",
        "DATEOFBIRTH": "1588 Feb 14",
        "DATEOFDEATH": "1638 Mai 09",
        "PLACEOFBIRTH": "Solre le Ch\u00e2teau",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "16130",
        "NAME": "Croy, Karl (1460\u20131527)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1527 Sep 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Beaumont im Hennegau"
    },
    {
        "ID": "16131",
        "NAME": "Croy, Philipp (1433\u20131511)",
        "DATEOFBIRTH": "1433",
        "DATEOFDEATH": "1511",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16132",
        "NAME": "Croy, Heinrich (1456\u20131514)",
        "DATEOFBIRTH": "1456",
        "DATEOFDEATH": "1514",
        "PLACEOFBIRTH": "Chi\u00e8vres",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16133",
        "NAME": "Croy, Wilhelm (1458\u20131521)",
        "DATEOFBIRTH": "1458",
        "DATEOFDEATH": "1521 Mai 28",
        "PLACEOFBIRTH": "Chi\u00e8vres",
        "PLACEOFDEATH": "Worms"
    },
    {
        "ID": "16134",
        "NAME": "Croy, Ruprecht (1505\u20131556), Bischof von Cambrai",
        "DATEOFBIRTH": "1505",
        "DATEOFDEATH": "1556 Aug 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Cambrai:Kathedrale"
    },
    {
        "ID": "16135",
        "NAME": "Croy, Philipp (1491\u20131549)",
        "DATEOFBIRTH": "1491",
        "DATEOFDEATH": "1549",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "16136",
        "NAME": "Croy, Wilhelm (1497\u20131521), Erzbischof von Toledo",
        "DATEOFBIRTH": "1497",
        "DATEOFDEATH": "1521 Jan 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Worms"
    },
    {
        "ID": "16137",
        "NAME": "Croy, Karl (1522\u20131551)",
        "DATEOFBIRTH": "1522 Jul 31",
        "DATEOFDEATH": "1551 Jun 24",
        "PLACEOFBIRTH": "Valenciennes",
        "PLACEOFDEATH": "Qui\u00e9vrain"
    },
    {
        "ID": "16138",
        "NAME": "Croy, Philipp (1526\u20131595)",
        "DATEOFBIRTH": "1526 Jul 10",
        "DATEOFDEATH": "1595 Dez 11",
        "PLACEOFBIRTH": "Valenciennes",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "16139",
        "NAME": "Croy, Wilhelm (1527\u20131565)",
        "DATEOFBIRTH": "1527 Dez 01",
        "DATEOFDEATH": "1565 Aug 01",
        "PLACEOFBIRTH": "Valenciennes",
        "PLACEOFDEATH": "Renty"
    },
    {
        "ID": "16140",
        "NAME": "Croy, Karl (1558\u20131612), Hofdiener",
        "DATEOFBIRTH": "1558 Nov 07",
        "DATEOFDEATH": "1612 Jun 13",
        "PLACEOFBIRTH": "Beaumont im Hennegau",
        "PLACEOFDEATH": "Beaumont im Hennegau"
    },
    {
        "ID": "16141",
        "NAME": "Ligne, Michael (1410\u20131470)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1470",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16142",
        "NAME": "Ligne, Johann (1440\u20131491)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1491 Mai 15",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": "Beloeil im Hennegau"
    },
    {
        "ID": "16143",
        "NAME": "Ligne, Anton (1474\u20131532)",
        "DATEOFBIRTH": "1474",
        "DATEOFDEATH": "1532",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16144",
        "NAME": "Ligne, Jakob (1505\u20131552)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1552",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Beloeil im Hennegau"
    },
    {
        "ID": "16145",
        "NAME": "Ligne, Philipp (1533\u20131583)",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1583",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16146",
        "NAME": "Ligne, Lamoral (1563\u20131624)",
        "DATEOFBIRTH": "1563 Jul 19",
        "DATEOFDEATH": "1624 Feb 05",
        "PLACEOFBIRTH": "Beloeil im Hennegau",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "16147",
        "NAME": "Ligne, Florent (1588\u20131622)",
        "DATEOFBIRTH": "1588 Aug 13",
        "DATEOFDEATH": "1622 Apr 17",
        "PLACEOFBIRTH": "Beloeil im Hennegau",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "16148",
        "NAME": "Ligne, Albrecht Heinrich (1615\u20131641)",
        "DATEOFBIRTH": "1615 Dez 27",
        "DATEOFDEATH": "1641 Mai 01",
        "PLACEOFBIRTH": "Antoing",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16149",
        "NAME": "Ligne, Klaudius Lamoral (1618\u20131679)",
        "DATEOFBIRTH": "1618 Nov 08",
        "DATEOFDEATH": "1679 Dez 21",
        "PLACEOFBIRTH": "Antoing",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "16150",
        "NAME": "Ligne, Heinrich Ernst (1644\u20131702)",
        "DATEOFBIRTH": "1644 Feb 02",
        "DATEOFDEATH": "1702 Feb 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Beloeil im Hennegau"
    },
    {
        "ID": "16190",
        "NAME": "Ongnies, Johann (1585\u20131618)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1618 Aug 17",
        "PLACEOFBIRTH": "Philom\u00e9s",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16191",
        "NAME": "Ongnies, Karl (1450\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Beaurepaire sur Sambre",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16192",
        "NAME": "Ongnies, Jakob (1485\u20131526)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1526",
        "PLACEOFBIRTH": "Beaurepaire sur Sambre",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16193",
        "NAME": "Ongnies, Klaudius (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Estr\u00e9es du Nord",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16194",
        "NAME": "Ongnies, Franz (1545\u20131578), Mundschenk",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1578",
        "PLACEOFBIRTH": "Coupigny in Artesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16195",
        "NAME": "Ongnies, Franz (1494\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1494",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Beaurepaire sur Sambre",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16196",
        "NAME": "Ongnies, Franz (1530\u20131590)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "Beaurepaire sur Sambre",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16197",
        "NAME": "Ongnies, Maximilian (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Beaurepaire sur Sambre",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16198",
        "NAME": "Ongnies, Hadrian (1525\u20131603)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1603 Apr 19",
        "PLACEOFBIRTH": "Willerval in Artesien",
        "PLACEOFDEATH": "Ressaix"
    },
    {
        "ID": "16199",
        "NAME": "Ongnies, Ruprecht (1555\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Philom\u00e9s",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16200",
        "NAME": "Capet, Franz (1494\u20131547), K\u00f6nig von Frankreich",
        "DATEOFBIRTH": "1494 Sep 12",
        "DATEOFDEATH": "1547 Mar 31",
        "PLACEOFBIRTH": "Cognac",
        "PLACEOFDEATH": "Rambouillet"
    },
    {
        "ID": "16300",
        "NAME": "Capet, Ludwig (1601\u20131643), K\u00f6nig von Frankreich",
        "DATEOFBIRTH": "1601 Sep 27",
        "DATEOFDEATH": "1643 Mai 14",
        "PLACEOFBIRTH": "Fontainebleau",
        "PLACEOFDEATH": "Saint Germain en Laye"
    },
    {
        "ID": "16301",
        "NAME": "Habsburg, Anna (1601\u20131666), K\u00f6nigin von Frankreich",
        "DATEOFBIRTH": "1601 Sep 22",
        "DATEOFDEATH": "1666 Jan 20",
        "PLACEOFBIRTH": "Valladolid",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "16310",
        "NAME": "Wittelsbach, Elisabeth (1442\u20131484), Herzogin zu Sachsen",
        "DATEOFBIRTH": "1442 Feb 23",
        "DATEOFDEATH": "1484 Mar 05",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Leipzig"
    },
    {
        "ID": "16356",
        "NAME": "Haslang, Georg (1500\u20131565)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1565 Mar 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "16357",
        "NAME": "Haslang, Heimeran (1535\u20131577), Hofdiener",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16358",
        "NAME": "Haslang, Rudolf (1530\u20131593)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1593 Okt 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16359",
        "NAME": "Haslang, Heinrich (1568\u20131606)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1606 Jan 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "16360",
        "NAME": "Haslang, Georg Christoph (1602\u20131684)",
        "DATEOFBIRTH": "1602 Sep 25",
        "DATEOFDEATH": "1684 Apr 15",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Hohenkammer"
    },
    {
        "ID": "16361",
        "NAME": "Haslang, Maria Theresia (1642\u20131692)",
        "DATEOFBIRTH": "1642",
        "DATEOFDEATH": "1692 Okt 10",
        "PLACEOFBIRTH": "Hohenkammer",
        "PLACEOFDEATH": "Holnstein im Tal der Wei\u00dfen Laaber"
    },
    {
        "ID": "16362",
        "NAME": "Tserclaes von Tilly, Ferdinand Lorenz (1666\u20131724)",
        "DATEOFBIRTH": "1666 Aug 11",
        "DATEOFDEATH": "1724 Jan 09",
        "PLACEOFBIRTH": "Holnstein im Tal der Wei\u00dfen Laaber",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "16363",
        "NAME": "Mansfeld, Johann Georg (1515\u20131579)",
        "DATEOFBIRTH": "1515",
        "DATEOFDEATH": "1579 Aug 14",
        "PLACEOFBIRTH": "Heldrungen",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "16364",
        "NAME": "Mansfeld, Anna (1542\u20131621)",
        "DATEOFBIRTH": "1542",
        "DATEOFDEATH": "1621 Jun 06",
        "PLACEOFBIRTH": "Heldrungen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16365",
        "NAME": "Trivulzio, Anton (1405\u20131454)",
        "DATEOFBIRTH": "1405~",
        "DATEOFDEATH": "1454 Jun 05",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16366",
        "NAME": "Trivulzio, Johann Jakob (1442\u20131518), Markgraf von Vigevano",
        "DATEOFBIRTH": "1442 Jun 24",
        "DATEOFDEATH": "1518 Dez 05",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Chartres"
    },
    {
        "ID": "16367",
        "NAME": "Trivulzio, Johann Niklas (1479\u20131512), Markgraf von Vigevano",
        "DATEOFBIRTH": "1479",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Torino"
    },
    {
        "ID": "16368",
        "NAME": "Trivulzio, Johann Franz (1509\u20131573), Markgraf von Vigevano",
        "DATEOFBIRTH": "1509",
        "DATEOFDEATH": "1573 Jul 14",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "16369",
        "NAME": "Gonzaga, Laura (1528\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16376",
        "NAME": "Waldstein, Johann Karl (1617\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1617 Jul 25",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16377",
        "NAME": "Waldstein, Ernst Karl (1650\u20131680), K\u00e4mmerer",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1680~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16378",
        "NAME": "Truchsess von Waldburg, Christoph (1613\u20131672)",
        "DATEOFBIRTH": "1613 Aug 24",
        "DATEOFDEATH": "1672 Mar 28",
        "PLACEOFBIRTH": "Ulm an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16379",
        "NAME": "Truchsess von Waldburg, Franz Euseb (1645\u20131678), K\u00e4mmerer",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "16391",
        "NAME": "Breunner, Ferdinand Ernst (1630\u20131673)",
        "DATEOFBIRTH": "1630 Apr 09",
        "DATEOFDEATH": "1673",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16392",
        "NAME": "Breunner, Karl Weikhard (1666\u20131729), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1666 Jan 19",
        "DATEOFDEATH": "1729 Dez 11",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "16393",
        "NAME": "Tserclaes von Tilly, Maria Katharina (1670\u20131744)",
        "DATEOFBIRTH": "1670~",
        "DATEOFDEATH": "1744 Jul 21",
        "PLACEOFBIRTH": "Holnstein im Tal der Wei\u00dfen Laaber",
        "PLACEOFDEATH": "Breitenbrunn im Tal der Wei\u00dfen Laaber"
    },
    {
        "ID": "16394",
        "NAME": "Ligne, Maria (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Beloeil im Hennegau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16395",
        "NAME": "Centurione, Barnabas (1550\u20131621), Markgraf von Morsasco",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16396",
        "NAME": "Centurione, Ludwig (1580\u20131653), Markgraf von Morsasco",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1653",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16397",
        "NAME": "Centurione, Barnabas (1610\u20131671), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1671",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16398",
        "NAME": "Centurione, Karl (1614\u20131663), Markgraf von Campi",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "1663 Aug 04",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": "Genova"
    },
    {
        "ID": "16399",
        "NAME": "Centurione, Johann Baptist (1644\u20131715), Markgraf von Campi",
        "DATEOFBIRTH": "1644 Dez 16",
        "DATEOFDEATH": "1715 Sep 18",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": "Genova"
    },
    {
        "ID": "16400",
        "NAME": "Capet, Ludwig (1638\u20131715), K\u00f6nig von Frankreich",
        "DATEOFBIRTH": "1638 Sep 05",
        "DATEOFDEATH": "1715 Sep 01",
        "PLACEOFBIRTH": "Saint Germain en Laye",
        "PLACEOFDEATH": "Versailles"
    },
    {
        "ID": "16404",
        "NAME": "Courcillon, Ludwig (1600\u20131658)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "Bouthonvilliers",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16405",
        "NAME": "Courcillon, Philipp (1638\u20131720)",
        "DATEOFBIRTH": "1638 Sep 21",
        "DATEOFDEATH": "1720 Sep 09",
        "PLACEOFBIRTH": "Bouthonvilliers",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "16406",
        "NAME": "Courcillon, Ludwig (1643\u20131723)",
        "DATEOFBIRTH": "1643",
        "DATEOFDEATH": "1723 Jan 04",
        "PLACEOFBIRTH": "Bouthonvilliers",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "16450",
        "NAME": "Melun, Heinrich (1620\u20131664)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16451",
        "NAME": "Melun, Philipp (1630\u20131690)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1690 Feb 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16452",
        "NAME": "Melun, Maria (1684\u20131754), Gr\u00e4fin von Wartenberg",
        "DATEOFBIRTH": "1684",
        "DATEOFDEATH": "1754 Nov 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pfaffst\u00e4tt im Innviertel"
    },
    {
        "ID": "16470",
        "NAME": "Ratuit de Souches, Johann Ludwig (1608\u20131682), Geheimer Rat",
        "DATEOFBIRTH": "1608 Aug 16",
        "DATEOFDEATH": "1682 Aug 12",
        "PLACEOFBIRTH": "Rochelle am Atlantik",
        "PLACEOFDEATH": "Jaispitz in M\u00e4hren"
    },
    {
        "ID": "16471",
        "NAME": "Ratuit de Souches, Johann Ludwig (1640\u20131717), K\u00e4mmerer",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1717",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16472",
        "NAME": "Ratuit de Souches, Karl Ludwig (1645\u20131691), K\u00e4mmerer",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "1691 Aug 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Slankamen"
    },
    {
        "ID": "16473",
        "NAME": "Ratuit de Souches, Anna Dorothea (1653\u20131724)",
        "DATEOFBIRTH": "1653",
        "DATEOFDEATH": "1724 Feb 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "16475",
        "NAME": "Grammont, Wilhelm (1535\u20131571), Hofdiener",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16490",
        "NAME": "Rabutin de Bussy, Rudger (1618\u20131693)",
        "DATEOFBIRTH": "1618 Apr 03",
        "DATEOFDEATH": "1693 Apr 09",
        "PLACEOFBIRTH": "\u00c9piry dans le Morvan",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16491",
        "NAME": "Rabutin de Bussy, Ludwig (1642\u20131716), K\u00e4mmerer",
        "DATEOFBIRTH": "1642",
        "DATEOFDEATH": "1716 Nov 20",
        "PLACEOFBIRTH": "Paris",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "16492",
        "NAME": "Raigecourt, Philipp (1545\u20131606)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16493",
        "NAME": "Raigecourt, Bernhard (1595\u20131656)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sierck an der Mosel"
    },
    {
        "ID": "16494",
        "NAME": "Raigecourt, Anna (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16495",
        "NAME": "Fontaine, Paul Bernhard (1576\u20131643)",
        "DATEOFBIRTH": "1576 Dez 02",
        "DATEOFDEATH": "1643 Mai 19",
        "PLACEOFBIRTH": "R\u00e9mer\u00e9ville",
        "PLACEOFDEATH": "Rocroi"
    },
    {
        "ID": "16496",
        "NAME": "Raigecourt, Paul Bernhard (1625\u20131686), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1686 Sep 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "16497",
        "NAME": "Bouteille, Anton (1530\u2013\u00a0\u00a0\u00a0\u00a0), Huschier",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Valence",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16498",
        "NAME": "Ruschell, Peter (1540\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16499",
        "NAME": "Garnier, Johann Heinrich (1614\u20131664)",
        "DATEOFBIRTH": "1614 Feb 02",
        "DATEOFDEATH": "1664 Aug 09",
        "PLACEOFBIRTH": "Ensisheim",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "16527",
        "NAME": "Waldstein, Lassel (1646\u20131718), K\u00e4mmerer",
        "DATEOFBIRTH": "1646",
        "DATEOFDEATH": "1718 Mar 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16528",
        "NAME": "Croy, Karl Philipp (1595\u20131640)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1640 Nov 23",
        "PLACEOFBIRTH": "Solre le Ch\u00e2teau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16529",
        "NAME": "Croy, Philipp Franz (1610\u20131650)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1650 Jun 19",
        "PLACEOFBIRTH": "Solre le Ch\u00e2teau",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "16537",
        "NAME": "Walderdorff, Wilderich (1617\u20131680), Bischof von Wien",
        "DATEOFBIRTH": "1617 Jan 14",
        "DATEOFDEATH": "1680 Sep 04",
        "PLACEOFBIRTH": "Limburg an der Lahn",
        "PLACEOFDEATH": "Wien:Stephansdom"
    },
    {
        "ID": "16538",
        "NAME": "Hohenberg, Rudolf (1275\u20131336)",
        "DATEOFBIRTH": "1275~",
        "DATEOFDEATH": "1336 Jan 11",
        "PLACEOFBIRTH": "Rottenburg am Neckar",
        "PLACEOFDEATH": "Rottenburg am Neckar:Stiftskirche"
    },
    {
        "ID": "16539",
        "NAME": "Hohenberg, Haug (1310\u20131354)",
        "DATEOFBIRTH": "1310~",
        "DATEOFDEATH": "1354 Sep 14",
        "PLACEOFBIRTH": "Rottenburg am Neckar",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16540",
        "NAME": "Hohenberg, Albrecht (1303\u20131359), Bischof von Freising",
        "DATEOFBIRTH": "1303",
        "DATEOFDEATH": "1359 Apr 25",
        "PLACEOFBIRTH": "Rottenburg am Neckar",
        "PLACEOFDEATH": "Stein am Rhein"
    },
    {
        "ID": "16541",
        "NAME": "Hohenberg, Ursula (1352\u20131380)",
        "DATEOFBIRTH": "1352 Aug 24",
        "DATEOFDEATH": "1380",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16699",
        "NAME": "Schwarzburg, Wilhelm (1534\u20131598), Mundschenk",
        "DATEOFBIRTH": "1534 Okt 04",
        "DATEOFDEATH": "1598 Sep 30",
        "PLACEOFBIRTH": "Sondershausen in Th\u00fcringen",
        "PLACEOFDEATH": "Strau\u00dfberg in Th\u00fcringen"
    },
    {
        "ID": "16701",
        "NAME": "Wasa, Gustav (1496\u20131560)",
        "DATEOFBIRTH": "1496 Mai 12",
        "DATEOFDEATH": "1560 Sep 29",
        "PLACEOFBIRTH": "Rydboholm",
        "PLACEOFDEATH": "Stockholm"
    },
    {
        "ID": "16702",
        "NAME": "Wasa, Erich (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16703",
        "NAME": "Wasa, Johann (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16704",
        "NAME": "Wasa, Katharina (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16705",
        "NAME": "Wasa, Z\u00e4zilia (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16706",
        "NAME": "Wasa, Anna (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16707",
        "NAME": "Wasa, Sophia (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16708",
        "NAME": "Wasa, Elisabeth (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16709",
        "NAME": "Wasa, Karl (1550\u20131611), K\u00f6nig von Schweden",
        "DATEOFBIRTH": "1550 Okt 04",
        "DATEOFDEATH": "1611 Okt 30",
        "PLACEOFBIRTH": "Stockholm",
        "PLACEOFDEATH": "Nyk\u00f6ping"
    },
    {
        "ID": "16710",
        "NAME": "Wasa, Siegmund (1566\u20131632), K\u00f6nig von Polen",
        "DATEOFBIRTH": "1566 Jun 20",
        "DATEOFDEATH": "1632 Apr 30",
        "PLACEOFBIRTH": "Gripsholm",
        "PLACEOFDEATH": "Warszawa"
    },
    {
        "ID": "16711",
        "NAME": "Wasa, Anna (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16712",
        "NAME": "Wasa, Lassel (1595\u20131648), K\u00f6nig von Polen",
        "DATEOFBIRTH": "1595 Jun 09",
        "DATEOFDEATH": "1648 Mai 20",
        "PLACEOFBIRTH": "\u0141obz\u00f3w",
        "PLACEOFDEATH": "Merkin\u0117"
    },
    {
        "ID": "16713",
        "NAME": "Wasa, Johann Kasimir (1609\u20131672)",
        "DATEOFBIRTH": "1609 Mar 21",
        "DATEOFDEATH": "1672 Dez 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16714",
        "NAME": "Wasa, Johann Albrecht (1612\u20131634)",
        "DATEOFBIRTH": "1612 Jun 25",
        "DATEOFDEATH": "1634 Dez 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16715",
        "NAME": "Wasa, Karl Ferdinand (1613\u20131655)",
        "DATEOFBIRTH": "1613 Okt 13",
        "DATEOFDEATH": "1655 Mai 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16716",
        "NAME": "Wasa, Anna Katharina (1619\u20131651)",
        "DATEOFBIRTH": "1619 Aug 07",
        "DATEOFDEATH": "1651 Okt 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16719",
        "NAME": "Wasa, Katharina (1584\u20131638)",
        "DATEOFBIRTH": "1584 Nov 10",
        "DATEOFDEATH": "1638 Dez 13",
        "PLACEOFBIRTH": "Nyk\u00f6ping",
        "PLACEOFDEATH": "V\u00e4ster\u00e5s"
    },
    {
        "ID": "16720",
        "NAME": "Wasa, Gustav Adolf (1594\u20131632), K\u00f6nig von Schweden",
        "DATEOFBIRTH": "1594 Dez 19",
        "DATEOFDEATH": "1632 Nov 16",
        "PLACEOFBIRTH": "Stockholm",
        "PLACEOFDEATH": "L\u00fctzen"
    },
    {
        "ID": "16721",
        "NAME": "Wasa, Gustav (1616\u20131653), Administrator von Osnabr\u00fcck",
        "DATEOFBIRTH": "1616 Apr 24",
        "DATEOFDEATH": "1653 Okt 25",
        "PLACEOFBIRTH": "Stockholm",
        "PLACEOFDEATH": "Wildeshausen an der Hunte"
    },
    {
        "ID": "16722",
        "NAME": "Wasa, Christina (1626\u20131689), K\u00f6nigin von Schweden",
        "DATEOFBIRTH": "1626 Dez 18",
        "DATEOFDEATH": "1689 Apr 19",
        "PLACEOFBIRTH": "Stockholm",
        "PLACEOFDEATH": "Rom:Petersdom"
    },
    {
        "ID": "16723",
        "NAME": "Mercy, Peter Ernst (1565\u20131619)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16724",
        "NAME": "Mercy, Heinrich (1596\u20131659)",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1659 Dez 24",
        "PLACEOFBIRTH": "Longwy",
        "PLACEOFDEATH": "Ch\u00e2tillon sous les C\u00f4tes:Martinskirche"
    },
    {
        "ID": "16725",
        "NAME": "Mercy, Franz (1597\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1645 Aug 03",
        "PLACEOFBIRTH": "Longwy",
        "PLACEOFDEATH": "Alerheim im Ries"
    },
    {
        "ID": "16726",
        "NAME": "Mercy, Kaspar (1600\u20131644)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1644 Aug 05",
        "PLACEOFBIRTH": "Longwy",
        "PLACEOFDEATH": "Freiburg im Breisgau"
    },
    {
        "ID": "16727",
        "NAME": "Mercy, Ludwig (1614\u20131633)",
        "DATEOFBIRTH": "1614",
        "DATEOFDEATH": "1633 Okt 06",
        "PLACEOFBIRTH": "Longwy",
        "PLACEOFDEATH": "Konstanz im Hegau:M\u00fcnster"
    },
    {
        "ID": "16728",
        "NAME": "Mercy, Peter Ernst (1635\u20131686), K\u00e4mmerer",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1686 Okt 05",
        "PLACEOFBIRTH": "Longwy",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "16729",
        "NAME": "Mercy, Klaudius Flormund (1666\u20131734)",
        "DATEOFBIRTH": "1666 Mai 10",
        "DATEOFDEATH": "1734 Jun 29",
        "PLACEOFBIRTH": "Martinfontaine",
        "PLACEOFDEATH": "Crocetta di Parma"
    },
    {
        "ID": "16730",
        "NAME": "Croy, Ludwika (1524\u20131585)",
        "DATEOFBIRTH": "1524 Mar 08",
        "DATEOFDEATH": "1585",
        "PLACEOFBIRTH": "Valenciennes",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16731",
        "NAME": "Croy, Jakobina (1450\u20131486)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1486 Okt 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16732",
        "NAME": "Croy, Johanna (1435\u20131504)",
        "DATEOFBIRTH": "1435",
        "DATEOFDEATH": "1504 Jun 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Meisenheim"
    },
    {
        "ID": "16733",
        "NAME": "Croy, Anna (1564\u20131635)",
        "DATEOFBIRTH": "1564 Jan 04",
        "DATEOFDEATH": "1635 Feb 26",
        "PLACEOFBIRTH": "Beaumont im Hennegau",
        "PLACEOFDEATH": "Edingen im Hennegau"
    },
    {
        "ID": "16734",
        "NAME": "Croy, Margarita (1568\u20131614)",
        "DATEOFBIRTH": "1568 Okt 11",
        "DATEOFDEATH": "1614",
        "PLACEOFBIRTH": "Beaumont im Hennegau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16735",
        "NAME": "Redwitz, Heinrich (1450\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Redwitz an der Rodach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16736",
        "NAME": "Redwitz, Weigand (1476\u20131556), Bischof von Bamberg",
        "DATEOFBIRTH": "1476",
        "DATEOFDEATH": "1556 Mai 20",
        "PLACEOFBIRTH": "T\u00fcschnitz",
        "PLACEOFDEATH": "Kronach"
    },
    {
        "ID": "16737",
        "NAME": "Redwitz, Anna (1495\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16738",
        "NAME": "W\u00fcrtzburg, Hieronym (1485\u20131540)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1540",
        "PLACEOFBIRTH": "Rothenkirchen im Frankenwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16739",
        "NAME": "W\u00fcrtzburg, Anna (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rothenkirchen im Frankenwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16740",
        "NAME": "W\u00fcrtzburg, Veit (1519\u20131577), Bischof von Bamberg",
        "DATEOFBIRTH": "1519 Jun 15",
        "DATEOFDEATH": "1577 Jul 08",
        "PLACEOFBIRTH": "Rothenkirchen im Frankenwald",
        "PLACEOFDEATH": "Bamberg"
    },
    {
        "ID": "16741",
        "NAME": "Sz\u00e9chy, Niklas (1340\u20131387), Palatin von Ungarn",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "1387",
        "PLACEOFBIRTH": "Limbach auf dem Berg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16742",
        "NAME": "Sz\u00e9chy, Niklas (1375\u20131432)",
        "DATEOFBIRTH": "1375~",
        "DATEOFDEATH": "1432 Apr 27",
        "PLACEOFBIRTH": "Limbach auf dem Berg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16743",
        "NAME": "Sz\u00e9chy, Niklas (1405\u20131457)",
        "DATEOFBIRTH": "1405~",
        "DATEOFDEATH": "1457",
        "PLACEOFBIRTH": "Limbach auf dem Berg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16744",
        "NAME": "Sz\u00e9chy, Niklas (1435\u20131494)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1494",
        "PLACEOFBIRTH": "Limbach auf dem Berg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16745",
        "NAME": "Sz\u00e9chy, Thomas (1475\u20131526)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1526 Aug 29",
        "PLACEOFBIRTH": "Limbach auf dem Berg",
        "PLACEOFDEATH": "Moh\u00e1cs"
    },
    {
        "ID": "16746",
        "NAME": "Sz\u00e9chy, Margarita (1465\u20131505)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1505",
        "PLACEOFBIRTH": "Limbach auf dem Berg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16747",
        "NAME": "Sz\u00e9chy, Johann (1410\u20131459)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1459",
        "PLACEOFBIRTH": "Limbach auf dem Berg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16748",
        "NAME": "Sz\u00e9chy, Dorothea (1440\u20131495)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1495",
        "PLACEOFBIRTH": "Limbach auf dem Berg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16749",
        "NAME": "Sz\u00e9chy, Eva (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sz\u00e9cs an der Rimau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16751",
        "NAME": "Sz\u00e9kely von K\u00f6vend, Johann (1400\u20131448)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1448 Okt 19",
        "PLACEOFBIRTH": "K\u00f6vend",
        "PLACEOFDEATH": "Pristina im Amselfeld"
    },
    {
        "ID": "16752",
        "NAME": "Sz\u00e9kely von K\u00f6vend, Niklas (1448\u20131517)",
        "DATEOFBIRTH": "1448",
        "DATEOFDEATH": "1517 Sep 29",
        "PLACEOFBIRTH": "K\u00f6vend",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16753",
        "NAME": "Sz\u00e9kely von K\u00f6vend, Magdalena (1500\u20131556)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1556",
        "PLACEOFBIRTH": "Friedau an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16754",
        "NAME": "Sz\u00e9kely von K\u00f6vend, Klara (1510\u20131550)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1550~",
        "PLACEOFBIRTH": "Friedau an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16755",
        "NAME": "Orsz\u00e1gh, Lassel (1500\u20131540)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1540",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16756",
        "NAME": "Orsz\u00e1gh, Helena (1537\u20131569)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1569 Mai 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trebischau"
    },
    {
        "ID": "16757",
        "NAME": "Orsz\u00e1gh, Barbara (1535\u20131581)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1581",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16758",
        "NAME": "Orsz\u00e1gh, Christoph (1530\u20131567)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1567 Okt 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sch\u00e4chtitz"
    },
    {
        "ID": "16759",
        "NAME": "Zr\u00ednyi, Helena (1546\u20131570)",
        "DATEOFBIRTH": "1546 Feb 11",
        "DATEOFDEATH": "1570 Jul 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16760",
        "NAME": "Per\u00e9nyi, Urban (1270\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1270~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16761",
        "NAME": "Per\u00e9nyi, Stephan (1310\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1310~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16762",
        "NAME": "Per\u00e9nyi, Peter (1340\u20131388)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "1388 Mar 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16763",
        "NAME": "Per\u00e9nyi, Emmerich (1370\u20131418)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "1418 Jul 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16764",
        "NAME": "Per\u00e9nyi, Johann (1400\u20131458)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1458 Jun 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Trebischau:Paulinenkloster"
    },
    {
        "ID": "16765",
        "NAME": "Per\u00e9nyi, Stephan (1430\u20131483)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1483",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16766",
        "NAME": "Per\u00e9nyi, Johann (1300\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1300~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16767",
        "NAME": "Per\u00e9nyi, Simon (1330\u20131378)",
        "DATEOFBIRTH": "1330~",
        "DATEOFDEATH": "1378",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16768",
        "NAME": "Per\u00e9nyi, Peter (1360\u20131423)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1423",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16769",
        "NAME": "Per\u00e9nyi, Johann (1400\u20131453)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1453",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16770",
        "NAME": "Per\u00e9nyi, Johann (1440\u20131494)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1494",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16771",
        "NAME": "Per\u00e9nyi, Stephan (1480\u20131523)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1523",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16772",
        "NAME": "Per\u00e9nyi, Franz (1520\u20131570)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1570~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16773",
        "NAME": "Per\u00e9nyi, Georg (1548\u20131596)",
        "DATEOFBIRTH": "1548 Apr 21",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16774",
        "NAME": "Per\u00e9nyi, Georg (1580\u20131638)",
        "DATEOFBIRTH": "1580",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16775",
        "NAME": "Per\u00e9nyi, Franz (1610\u20131651)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1651",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16776",
        "NAME": "Per\u00e9nyi, Gabriel (1470\u20131526)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1526 Aug 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Moh\u00e1cs"
    },
    {
        "ID": "16777",
        "NAME": "Per\u00e9nyi, Johann (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16778",
        "NAME": "Per\u00e9nyi, Stephan (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16779",
        "NAME": "Forg\u00e1ch, Johann (1573\u20131601)",
        "DATEOFBIRTH": "1573",
        "DATEOFDEATH": "1601",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16780",
        "NAME": "Forg\u00e1ch, Stephan (1605\u20131651)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1651 Mar 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "R\u00e1d"
    },
    {
        "ID": "16781",
        "NAME": "Esterh\u00e1zy, Johann (1625\u20131692)",
        "DATEOFBIRTH": "1625 Jan 27",
        "DATEOFDEATH": "1692 Jun 22",
        "PLACEOFBIRTH": "Eisenstadt im Burgenland",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "16782",
        "NAME": "Esterh\u00e1zy, Thomas (1625\u20131652)",
        "DATEOFBIRTH": "1625 Dez 20",
        "DATEOFDEATH": "1652 Aug 26",
        "PLACEOFBIRTH": "Bolondv\u00e1r an der Waag",
        "PLACEOFDEATH": "Vezek\u00e9ny"
    },
    {
        "ID": "16783",
        "NAME": "Esterh\u00e1zy, Siegmund (1626\u20131692)",
        "DATEOFBIRTH": "1626 Dez 30",
        "DATEOFDEATH": "1692",
        "PLACEOFBIRTH": "Eisenstadt im Burgenland",
        "PLACEOFDEATH": "Tyrnau"
    },
    {
        "ID": "16784",
        "NAME": "Esterh\u00e1zy, Kaspar (1628\u20131652)",
        "DATEOFBIRTH": "1628 Jan 13",
        "DATEOFDEATH": "1652 Aug 26",
        "PLACEOFBIRTH": "Bolondv\u00e1r an der Waag",
        "PLACEOFDEATH": "Vezek\u00e9ny"
    },
    {
        "ID": "16785",
        "NAME": "Esterh\u00e1zy, Michael (1629\u20131686)",
        "DATEOFBIRTH": "1629 Feb 28",
        "DATEOFDEATH": "1686 Jul 27",
        "PLACEOFBIRTH": "Gallandau",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "16786",
        "NAME": "Esterh\u00e1zy, Georg (1630\u20131663)",
        "DATEOFBIRTH": "1630 Mar 25",
        "DATEOFDEATH": "1663 Aug 09",
        "PLACEOFBIRTH": "Gallandau",
        "PLACEOFDEATH": "Gockern"
    },
    {
        "ID": "16787",
        "NAME": "Esterh\u00e1zy, Franz (1617\u20131652)",
        "DATEOFBIRTH": "1617",
        "DATEOFDEATH": "1652 Aug 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Vezek\u00e9ny"
    },
    {
        "ID": "16788",
        "NAME": "Esterh\u00e1zy, Ursula (1641\u20131682)",
        "DATEOFBIRTH": "1641 Mar 07",
        "DATEOFDEATH": "1682 Mar 31",
        "PLACEOFBIRTH": "Lackenbach im Burgenland",
        "PLACEOFDEATH": "Eisenstadt im Burgenland"
    },
    {
        "ID": "16789",
        "NAME": "Ill\u00e9sh\u00e1zy, Katharina (1645\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16790",
        "NAME": "Ill\u00e9sh\u00e1zy, Sophia (1547\u20131599)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1599 Mar 12",
        "PLACEOFBIRTH": "Pressburg",
        "PLACEOFDEATH": "Gallandau"
    },
    {
        "ID": "16791",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Emmerich (1598\u20131621)",
        "DATEOFBIRTH": "1598 Sep 11",
        "DATEOFDEATH": "1621 Okt 19",
        "PLACEOFBIRTH": "Bitscha an der Waag",
        "PLACEOFDEATH": "Nikolsburg in M\u00e4hren"
    },
    {
        "ID": "16792",
        "NAME": "N\u00e1dasdy, Christina (1646\u20131682)",
        "DATEOFBIRTH": "1646",
        "DATEOFDEATH": "1682 Mar 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16793",
        "NAME": "N\u00e1dasdy, Magdalena (1647\u20131718)",
        "DATEOFBIRTH": "1646",
        "DATEOFDEATH": "1718",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16794",
        "NAME": "N\u00e1dasdy, Franz (1655\u20131723)",
        "DATEOFBIRTH": "1655~",
        "DATEOFDEATH": "1723",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16795",
        "NAME": "Frangipane di Veglia, Katharina (1490\u20131540)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1540~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16796",
        "NAME": "Per\u00e9nyi, Gabriel (1532\u20131567)",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1567 Jun 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16797",
        "NAME": "Pekry, Johann (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16798",
        "NAME": "Pekry, Ludwig (1500\u20131552)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1552",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16799",
        "NAME": "Pekry, Anna (1510\u20131560)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1560~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16800",
        "NAME": "Habsburg, Karl (1590\u20131624), Hochmeister des Deutschen Ordens",
        "DATEOFBIRTH": "1590 Aug 07",
        "DATEOFDEATH": "1624 Dez 28",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "16801",
        "NAME": "Gryfita, Johann Friedrich (1542\u20131600), Herzog in Pommern",
        "DATEOFBIRTH": "1542 Aug 27",
        "DATEOFDEATH": "1600 Feb 09",
        "PLACEOFBIRTH": "Wolgast",
        "PLACEOFDEATH": "Wolgast"
    },
    {
        "ID": "16810",
        "NAME": "Gryfita, Bosel (1454\u20131523), Herzog in Pommern",
        "DATEOFBIRTH": "1454 Mai 28",
        "DATEOFDEATH": "1523 Okt 05",
        "PLACEOFBIRTH": "R\u00fcgenwalde",
        "PLACEOFDEATH": "Stettin"
    },
    {
        "ID": "16811",
        "NAME": "Gryfita, Georg (1493\u20131531), Herzog in Pommern",
        "DATEOFBIRTH": "1493 Apr 11",
        "DATEOFDEATH": "1531 Mai 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Stettin"
    },
    {
        "ID": "16812",
        "NAME": "Gryfita, Philipp (1515\u20131560), Herzog in Pommern",
        "DATEOFBIRTH": "1515 Jul 14",
        "DATEOFDEATH": "1560 Feb 14",
        "PLACEOFBIRTH": "Stettin",
        "PLACEOFDEATH": "Wolgast"
    },
    {
        "ID": "16813",
        "NAME": "Gryfita, Bosel (1544\u20131606), Herzog in Pommern",
        "DATEOFBIRTH": "1544 Aug 09",
        "DATEOFDEATH": "1606 Mar 07",
        "PLACEOFBIRTH": "Wolgast",
        "PLACEOFDEATH": "Stettin"
    },
    {
        "ID": "16814",
        "NAME": "Gryfita, Bosel (1580\u20131637), Bischof von Cammin",
        "DATEOFBIRTH": "1580 Mar 31",
        "DATEOFDEATH": "1637 Mar 10",
        "PLACEOFBIRTH": "Barth in Pommern",
        "PLACEOFDEATH": "Stettin"
    },
    {
        "ID": "16815",
        "NAME": "Gryfita, Philipp (1573\u20131618), Herzog in Pommern",
        "DATEOFBIRTH": "1573 Jul 29",
        "DATEOFDEATH": "1618 Feb 13",
        "PLACEOFBIRTH": "Franzburg im Rosengarten",
        "PLACEOFDEATH": "Stettin"
    },
    {
        "ID": "16816",
        "NAME": "Gryfita, Anna (1590\u20131660)",
        "DATEOFBIRTH": "1590 Okt 03",
        "DATEOFDEATH": "1660 Jul 07",
        "PLACEOFBIRTH": "Barth in Pommern",
        "PLACEOFDEATH": "Stolp in Pommern"
    },
    {
        "ID": "16822",
        "NAME": "Salm, Karl (1604\u20131662)",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1662",
        "PLACEOFBIRTH": "Neuburg am Inn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16823",
        "NAME": "Salm, Elisabeth (1646\u20131698)",
        "DATEOFBIRTH": "1646",
        "DATEOFDEATH": "1698 Feb 02",
        "PLACEOFBIRTH": "Neuburg am Inn",
        "PLACEOFDEATH": "T\u00fc\u00dfling"
    },
    {
        "ID": "16864",
        "NAME": "Castell, Friedrich Mang (1646\u20131717), K\u00e4mmerer",
        "DATEOFBIRTH": "1646 Okt 06",
        "DATEOFDEATH": "1717 Apr 17",
        "PLACEOFBIRTH": "Remlingen in Franken",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "16865",
        "NAME": "Oettingen, Susanna Johanna (1643\u20131713)",
        "DATEOFBIRTH": "1643 Sep 16",
        "DATEOFDEATH": "1713 Nov 28",
        "PLACEOFBIRTH": "Oettingen im Ries",
        "PLACEOFDEATH": "Remlingen in Franken"
    },
    {
        "ID": "16866",
        "NAME": "Oettingen, Wilhelm (1632\u20131692), Geheimer Rat",
        "DATEOFBIRTH": "1632",
        "DATEOFDEATH": "1692 Dez 13",
        "PLACEOFBIRTH": "Wallerstein",
        "PLACEOFDEATH": "Deinzendorf an der Pulkau"
    },
    {
        "ID": "16867",
        "NAME": "Oettingen, Sophia Margarita (1634\u20131664)",
        "DATEOFBIRTH": "1634 Dez 19",
        "DATEOFDEATH": "1664 Aug 05",
        "PLACEOFBIRTH": "Oettingen im Ries",
        "PLACEOFDEATH": "Ansbach"
    },
    {
        "ID": "16868",
        "NAME": "Trivulzio, Theoderich (1620\u20131664)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Lodi"
    },
    {
        "ID": "16869",
        "NAME": "Trivulzio, Theoderich (1645\u20131678)",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "1678 Jul 26",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "16870",
        "NAME": "Vaud\u00e9mont, Franz (1609\u20131670)",
        "DATEOFBIRTH": "1609 Dez 06",
        "DATEOFDEATH": "1670 Jan 27",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": "Nancy"
    },
    {
        "ID": "16871",
        "NAME": "Bassompierre, Franz (1503\u20131552), K\u00e4mmerer",
        "DATEOFBIRTH": "1503 Jun 06",
        "DATEOFDEATH": "1552",
        "PLACEOFBIRTH": "Bassompierre",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16872",
        "NAME": "Bassompierre, Bernhard (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Harouel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16873",
        "NAME": "Bassompierre, Christoph (1535\u20131596)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1596 Apr 22",
        "PLACEOFBIRTH": "Harouel",
        "PLACEOFDEATH": "Nancy"
    },
    {
        "ID": "16874",
        "NAME": "Bassompierre, Georg (1587\u20131632)",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1632 Jan",
        "PLACEOFBIRTH": "Harouel",
        "PLACEOFDEATH": "Removille"
    },
    {
        "ID": "16875",
        "NAME": "Bassompierre, Franz (1579\u20131646), Marschall von Frankreich",
        "DATEOFBIRTH": "1579 Apr 12",
        "DATEOFDEATH": "1646 Okt 12",
        "PLACEOFBIRTH": "Harouel",
        "PLACEOFDEATH": "Vitry sur Seine"
    },
    {
        "ID": "16876",
        "NAME": "Bassompierre, Karl (1615\u20131665)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "Removille",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "16877",
        "NAME": "Bassompierre, Vedast (1626\u20131696)",
        "DATEOFBIRTH": "1626 Mai 13",
        "DATEOFDEATH": "1696 Feb 26",
        "PLACEOFBIRTH": "Removille",
        "PLACEOFDEATH": "Savigny im Wasgenwald"
    },
    {
        "ID": "16878",
        "NAME": "Bassompierre, Karl Ludwig (1645\u20131689)",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "1689 Dez 22",
        "PLACEOFBIRTH": "Removille",
        "PLACEOFDEATH": "Nancy"
    },
    {
        "ID": "16879",
        "NAME": "Bassompierre, Anna Franz (1650\u20131698)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1698",
        "PLACEOFBIRTH": "Removille",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16890",
        "NAME": "Wittelsbach, Johann Wilhelm (1658\u20131716), Pfalzgraf bei Rhein",
        "DATEOFBIRTH": "1658 Apr 19",
        "DATEOFDEATH": "1716 Jun 08",
        "PLACEOFBIRTH": "D\u00fcsseldorf",
        "PLACEOFDEATH": "D\u00fcsseldorf"
    },
    {
        "ID": "16900",
        "NAME": "Habsburg, Karl Joseph (1649\u20131664), Hochmeister des Deutschen Ordens",
        "DATEOFBIRTH": "1649 Aug 07",
        "DATEOFDEATH": "1664 Jan 27",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "16909",
        "NAME": "Oldenburg, Johann (1545\u20131622)",
        "DATEOFBIRTH": "1545 Mar 25",
        "DATEOFDEATH": "1622 Okt 09",
        "PLACEOFBIRTH": "Hadersleben",
        "PLACEOFDEATH": "Gl\u00fccksburg"
    },
    {
        "ID": "16910",
        "NAME": "Oldenburg, Alexander (1573\u20131627)",
        "DATEOFBIRTH": "1573 Jan 20",
        "DATEOFDEATH": "1627 Mai 13",
        "PLACEOFBIRTH": "Sonderburg",
        "PLACEOFDEATH": "Sonderburg"
    },
    {
        "ID": "16911",
        "NAME": "Oldenburg, Sophia (1617\u20131696)",
        "DATEOFBIRTH": "1617 Jun 28",
        "DATEOFDEATH": "1696 Nov 22",
        "PLACEOFBIRTH": "Beck im Werretal",
        "PLACEOFDEATH": "Neuenburg in der Friesischen Wehde"
    },
    {
        "ID": "16912",
        "NAME": "Oldenburg, Philipp (1620\u20131689)",
        "DATEOFBIRTH": "1620 Okt 27",
        "DATEOFDEATH": "1689 Mar 10",
        "PLACEOFBIRTH": "Beck im Werretal",
        "PLACEOFDEATH": "Schneeberg im Erzgebirge"
    },
    {
        "ID": "16913",
        "NAME": "Oldenburg, Elisabeth (1645\u20131725)",
        "DATEOFBIRTH": "1645 Mar 15",
        "DATEOFDEATH": "1725 Jan 07",
        "PLACEOFBIRTH": "Paderborn",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "16935",
        "NAME": "Ligne, Ernestina (1589\u20131653)",
        "DATEOFBIRTH": "1589 Okt 31",
        "DATEOFDEATH": "1653 Jun 12",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Abbeville sur Somme"
    },
    {
        "ID": "16936",
        "NAME": "Ligne, Alexander (1590\u20131629)",
        "DATEOFBIRTH": "1590 Sep 15",
        "DATEOFDEATH": "1629 Aug 16",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Wesel am Niederrhein"
    },
    {
        "ID": "16937",
        "NAME": "Ligne, Philipp (1619\u20131675)",
        "DATEOFBIRTH": "1619 Mai 08",
        "DATEOFDEATH": "1675 Jan 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16938",
        "NAME": "Leyen von Gondorf, Bartlome (1480\u20131539)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1539 Aug 21",
        "PLACEOFBIRTH": "Leyen an der Mosel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16939",
        "NAME": "Leyen von Gondorf, Michael (1530\u20131587)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1587 Nov 27",
        "PLACEOFBIRTH": "Leyen an der Mosel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16940",
        "NAME": "Leyen von Gondorf, Johann (1510\u20131567), Erzbischof von Trier",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1567 Feb 10",
        "PLACEOFBIRTH": "Leyen an der Mosel",
        "PLACEOFDEATH": "Koblenz am Rhein"
    },
    {
        "ID": "16941",
        "NAME": "Leyen von Gondorf, Damian (1583\u20131636), K\u00e4mmerer",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1636 Mar 17",
        "PLACEOFBIRTH": "Leyen an der Mosel",
        "PLACEOFDEATH": "Ahrweiler"
    },
    {
        "ID": "16942",
        "NAME": "Leyen von Gondorf, Karl Kaspar (1618\u20131676), Erzbischof von Trier",
        "DATEOFBIRTH": "1618 Dez 18",
        "DATEOFDEATH": "1676 Jun 01",
        "PLACEOFBIRTH": "Leyen an der Mosel",
        "PLACEOFDEATH": "Ehrenbreitstein"
    },
    {
        "ID": "16943",
        "NAME": "Leyen von Gondorf, Damian Hartrad (1624\u20131678), Erzbischof von Mainz",
        "DATEOFBIRTH": "1624 Mar 02",
        "DATEOFDEATH": "1678 Dez 06",
        "PLACEOFBIRTH": "Leyen an der Mosel",
        "PLACEOFDEATH": "Mainz"
    },
    {
        "ID": "16944",
        "NAME": "Gonzaga, Alfons (1541\u20131592), Markgraf von Castel Goffredo",
        "DATEOFBIRTH": "1541 Nov 15",
        "DATEOFDEATH": "1592 Mai 07",
        "PLACEOFBIRTH": "Castel Goffredo",
        "PLACEOFDEATH": "Gambaredolo"
    },
    {
        "ID": "16945",
        "NAME": "Gonzaga, Hotze (1545\u20131587), Markgraf von Solferino",
        "DATEOFBIRTH": "1545",
        "DATEOFDEATH": "1587 Jan 13",
        "PLACEOFBIRTH": "Castel Goffredo",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "16946",
        "NAME": "Gonzaga, Katharina (1574\u20131615)",
        "DATEOFBIRTH": "1574 Feb 14",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "Castel Goffredo",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "16947",
        "NAME": "Dietrichstein, Franz Anton (1643\u20131721)",
        "DATEOFBIRTH": "1643",
        "DATEOFDEATH": "1721 Feb 22",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "16948",
        "NAME": "Mengersdorf, Otto Eberhard (1520\u20131580)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1580",
        "PLACEOFBIRTH": "Mengersdorf im Mistelgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16949",
        "NAME": "Mengersdorf, Pankraz (1560\u2013\u00a0\u00a0\u00a0\u00a0), Edelknabe",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bamberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16950",
        "NAME": "Mengersdorf, Ernst (1554\u20131591), Bischof von Bamberg",
        "DATEOFBIRTH": "1554 Okt 23",
        "DATEOFDEATH": "1591 Okt 21",
        "PLACEOFBIRTH": "Bamberg",
        "PLACEOFDEATH": "Bamberg:Dom"
    },
    {
        "ID": "16951",
        "NAME": "Wettin, Emilia (1516\u20131591)",
        "DATEOFBIRTH": "1516 Jul 26",
        "DATEOFDEATH": "1591 Apr 09",
        "PLACEOFBIRTH": "Freiberg in Sachsen",
        "PLACEOFDEATH": "Ansbach"
    },
    {
        "ID": "16952",
        "NAME": "Doria, Anton (1503\u20131577), Hofdiener",
        "DATEOFBIRTH": "1503",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "Santo Stefano d\u2019Aveto",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "16953",
        "NAME": "Trivulzio, Alexander (1550\u20131589)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16954",
        "NAME": "Trivulzio, Georg (1585\u20131648)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1648 Sep 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "16955",
        "NAME": "Trivulzio, Alexander (1616\u20131693), Markgraf von Sesto Ulteriano",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1693 Aug 07",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Mailand"
    },
    {
        "ID": "16956",
        "NAME": "Trivulzio, Viktoria (1659\u20131726)",
        "DATEOFBIRTH": "1659",
        "DATEOFDEATH": "1726 Aug 22",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "16959",
        "NAME": "Haslang, Alexander (1560\u20131620)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1620 Nov 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rakonitz"
    },
    {
        "ID": "16960",
        "NAME": "Solms, Johann Friedrich (1625\u20131696)",
        "DATEOFBIRTH": "1625 Mar 01",
        "DATEOFDEATH": "1696 Dez 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Laubach im Wettertal"
    },
    {
        "ID": "16961",
        "NAME": "Solms, Friedrich Ernst (1671\u20131723), Reichshofrat",
        "DATEOFBIRTH": "1671 Mar 26",
        "DATEOFDEATH": "1723 Jan 26",
        "PLACEOFBIRTH": "Wildenfels im Erzgebirge",
        "PLACEOFDEATH": "Laubach im Wettertal"
    },
    {
        "ID": "16962",
        "NAME": "Daun, Karl (1556\u20131620)",
        "DATEOFBIRTH": "1556",
        "DATEOFDEATH": "1620",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16963",
        "NAME": "Daun, Johann Jakob (1595\u20131663), Oberststallmeister",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1663 Apr 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16964",
        "NAME": "Velen, Alexandra (1628\u20131656)",
        "DATEOFBIRTH": "1628",
        "DATEOFDEATH": "1656 Jul 10",
        "PLACEOFBIRTH": "Raesfeld",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16965",
        "NAME": "Velen, Elisabeth (1625\u20131692)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1692 Feb 27",
        "PLACEOFBIRTH": "Raesfeld",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "16969",
        "NAME": "Vaud\u00e9mont, Heinrich (1563\u20131624), Herzog von Lothringen",
        "DATEOFBIRTH": "1563 Nov 08",
        "DATEOFDEATH": "1624 Jul 31",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": "Nancy"
    },
    {
        "ID": "16970",
        "NAME": "Wettin, Sibylla (1515\u20131592)",
        "DATEOFBIRTH": "1515 Mai 02",
        "DATEOFDEATH": "1592 Jul 18",
        "PLACEOFBIRTH": "Freiberg in Sachsen",
        "PLACEOFDEATH": "Buxtehude"
    },
    {
        "ID": "16971",
        "NAME": "Per\u00e9nyi, Elisabeth (1555\u20131575)",
        "DATEOFBIRTH": "1555 Aug 14",
        "DATEOFDEATH": "1575 Jul 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ida"
    },
    {
        "ID": "16972",
        "NAME": "Zr\u00ednyi, Katharina (1548\u20131585)",
        "DATEOFBIRTH": "1548 Apr 30",
        "DATEOFDEATH": "1585 Apr 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bitscha an der Waag"
    },
    {
        "ID": "16973",
        "NAME": "Askanien, Sidonia (1549\u20131594)",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "Ratzeburg",
        "PLACEOFDEATH": "Teschen"
    },
    {
        "ID": "16974",
        "NAME": "Waldeck, Josias (1554\u20131588)",
        "DATEOFBIRTH": "1554 Mar 18",
        "DATEOFDEATH": "1588 Aug 06",
        "PLACEOFBIRTH": "Eisenberg im Grafschafter Bergland",
        "PLACEOFDEATH": "Eisenberg im Grafschafter Bergland"
    },
    {
        "ID": "16975",
        "NAME": "Waldeck, Walrad (1588\u20131640)",
        "DATEOFBIRTH": "1588 Jul 07",
        "DATEOFDEATH": "1640 Okt 06",
        "PLACEOFBIRTH": "Eisenberg im Grafschafter Bergland",
        "PLACEOFDEATH": "Arolsen"
    },
    {
        "ID": "16976",
        "NAME": "Waldeck, Philipp Theoderich (1614\u20131645)",
        "DATEOFBIRTH": "1614 Nov 02",
        "DATEOFDEATH": "1645 Dez 07",
        "PLACEOFBIRTH": "Arolsen",
        "PLACEOFDEATH": "Korbach:Nikolaikirche"
    },
    {
        "ID": "16977",
        "NAME": "Waldeck, Philipp (1613\u20131645)",
        "DATEOFBIRTH": "1613 Nov 25",
        "DATEOFDEATH": "1645 Mar 06",
        "PLACEOFBIRTH": "Wildungen",
        "PLACEOFDEATH": "Jankau in Mittelb\u00f6hmen"
    },
    {
        "ID": "16978",
        "NAME": "Waldeck, Johann (1623\u20131668)",
        "DATEOFBIRTH": "1623 Nov 07",
        "DATEOFDEATH": "1668 Okt 10",
        "PLACEOFBIRTH": "Wildungen",
        "PLACEOFDEATH": "Landau an der Watter"
    },
    {
        "ID": "16979",
        "NAME": "Waldeck, Katharina (1612\u20131649)",
        "DATEOFBIRTH": "1612 Okt 20",
        "DATEOFDEATH": "1649 Nov 24",
        "PLACEOFBIRTH": "Wildungen",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "16994",
        "NAME": "Mansfeld, Elisabeth (1516\u20131541)",
        "DATEOFBIRTH": "1516",
        "DATEOFDEATH": "1541",
        "PLACEOFBIRTH": "Heldrungen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17001",
        "NAME": "Sponheim, Sebastian (1439\u20131490), Landesherr von Ortenburg im Wolfachtal",
        "DATEOFBIRTH": "1439",
        "DATEOFDEATH": "1490 Nov 11",
        "PLACEOFBIRTH": "Ortenburg im Wolfachtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17002",
        "NAME": "Sponheim, Christoph (1480\u20131551), Landesherr von Ortenburg im Wolfachtal",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1551 Apr 22",
        "PLACEOFBIRTH": "Ortenburg im Wolfachtal",
        "PLACEOFDEATH": "Mattighofen"
    },
    {
        "ID": "17003",
        "NAME": "Sponheim, Ulrich (1470\u20131524), Landesherr von Ortenburg im Wolfachtal",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1524 Mar 07",
        "PLACEOFBIRTH": "Ortenburg im Wolfachtal",
        "PLACEOFDEATH": "S\u00f6ldenau im Wolfachtal"
    },
    {
        "ID": "17004",
        "NAME": "Sponheim, Karl (1501\u20131552)",
        "DATEOFBIRTH": "1501",
        "DATEOFDEATH": "1552 Nov 15",
        "PLACEOFBIRTH": "Ortenburg im Wolfachtal",
        "PLACEOFDEATH": "S\u00f6ldenau im Wolfachtal"
    },
    {
        "ID": "17005",
        "NAME": "Sponheim, Sidonia (1515\u20131563)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1563 Mar 12",
        "PLACEOFBIRTH": "Ortenburg im Wolfachtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17006",
        "NAME": "Sponheim, Anna (1547\u20131601)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1601 Dez 16",
        "PLACEOFBIRTH": "Ortenburg im Wolfachtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17007",
        "NAME": "Sponheim, Joachim (1530\u20131600), Landesherr von Ortenburg im Wolfachtal",
        "DATEOFBIRTH": "1530 Sep 06",
        "DATEOFDEATH": "1600 Mar 19",
        "PLACEOFBIRTH": "Mattighofen",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "17008",
        "NAME": "Sponheim, Heinrich (1400\u20131451)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1451",
        "PLACEOFBIRTH": "Ortenburg im Wolfachtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17009",
        "NAME": "Sponheim, Magdalena (1445\u20131508)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1508",
        "PLACEOFBIRTH": "Ortenburg im Wolfachtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17010",
        "NAME": "Gymnich, Adam (1550\u20131633), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1633 Jul 30",
        "PLACEOFBIRTH": "Gymnich",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "17011",
        "NAME": "Fugger, Ursula (1530\u20131570)",
        "DATEOFBIRTH": "1530 Apr 21",
        "DATEOFDEATH": "1570 Sep 07",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Ortenburg im Wolfachtal"
    },
    {
        "ID": "17012",
        "NAME": "Sponheim, Anton (1550\u20131573), Reichshofrat",
        "DATEOFBIRTH": "1550 Sep 05",
        "DATEOFDEATH": "1573 Mai 23",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Kelheim an der Donau"
    },
    {
        "ID": "17013",
        "NAME": "Thun, Simon (1360\u20131418)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1418",
        "PLACEOFBIRTH": "Bragher",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17014",
        "NAME": "Thun, Anton (1390\u20131448)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1448 Jul 17",
        "PLACEOFBIRTH": "Bragher",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "17015",
        "NAME": "Thun, Viktor (1430\u20131487), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1487 Aug 15",
        "PLACEOFBIRTH": "Stein am Ritten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17016",
        "NAME": "Thun, Katharina (1480\u20131509)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1509",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17017",
        "NAME": "Thun, Siegmund (1392\u20131467)",
        "DATEOFBIRTH": "1392",
        "DATEOFDEATH": "1467 Jan 24",
        "PLACEOFBIRTH": "Bragher",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17018",
        "NAME": "Thun, Jakob (1420\u20131492)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1492",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17019",
        "NAME": "Cirksena, Eginhard (1563\u20131625)",
        "DATEOFBIRTH": "1563 Sep 30",
        "DATEOFDEATH": "1625 Aug 19",
        "PLACEOFBIRTH": "Aurich in Ostfriesland",
        "PLACEOFDEATH": "Leer in Ostfriesland"
    },
    {
        "ID": "17020",
        "NAME": "Rosenberg, Widukind (1120\u20131194)",
        "DATEOFBIRTH": "1120~",
        "DATEOFDEATH": "1194",
        "PLACEOFBIRTH": "Purschitz",
        "PLACEOFDEATH": "Prachin"
    },
    {
        "ID": "17021",
        "NAME": "Rosenberg, Widukind (1170\u20131256)",
        "DATEOFBIRTH": "1170~",
        "DATEOFDEATH": "1256 Jun 04",
        "PLACEOFBIRTH": "Purschitz",
        "PLACEOFDEATH": "Sankt Florian an der Enns"
    },
    {
        "ID": "17022",
        "NAME": "Rosenberg, Heinrich (1160\u20131237)",
        "DATEOFBIRTH": "1160~",
        "DATEOFDEATH": "1237",
        "PLACEOFBIRTH": "Purschitz",
        "PLACEOFDEATH": "Velehrad in M\u00e4hren"
    },
    {
        "ID": "17023",
        "NAME": "Rosenberg, Widukind (1200\u20131259)",
        "DATEOFBIRTH": "1200~",
        "DATEOFDEATH": "1259",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17024",
        "NAME": "Rosenberg, Ulrich (1230\u20131282)",
        "DATEOFBIRTH": "1230~",
        "DATEOFDEATH": "1282",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Neuhaus in B\u00f6hmen"
    },
    {
        "ID": "17025",
        "NAME": "Rosenberg, Ulrich (1260\u20131312)",
        "DATEOFBIRTH": "1260~",
        "DATEOFDEATH": "1312",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17026",
        "NAME": "Rosenberg, Ulrich (1290\u20131348)",
        "DATEOFBIRTH": "1290~",
        "DATEOFDEATH": "1348",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17027",
        "NAME": "Rosenberg, Heinrich (1320\u20131363)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "1363 Jul 15",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Neuhaus in B\u00f6hmen"
    },
    {
        "ID": "17028",
        "NAME": "Rosenberg, Heinrich (1350\u20131398), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1350~",
        "DATEOFDEATH": "1398",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17029",
        "NAME": "Rosenberg, Johann (1380\u20131420)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1420 Nov 02",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17030",
        "NAME": "Rosenberg, Johann (1410\u20131452)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1452",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Teltsch"
    },
    {
        "ID": "17031",
        "NAME": "Rosenberg, Ulrich (1325\u20131383)",
        "DATEOFBIRTH": "1325~",
        "DATEOFDEATH": "1383",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17032",
        "NAME": "Rosenberg, Johann (1360\u20131417)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1417",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17033",
        "NAME": "Rosenberg, Meinhard (1391\u20131449), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1391",
        "DATEOFDEATH": "1449 Feb 03",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Ritschan in B\u00f6hmen"
    },
    {
        "ID": "17034",
        "NAME": "Rosenberg, Ulrich (1420\u20131453)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1453",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17035",
        "NAME": "Rosenberg, Ulrich (1375\u20131421), Oberstm\u00fcnzmeister in B\u00f6hmen",
        "DATEOFBIRTH": "1375~",
        "DATEOFDEATH": "1421 Sep 22",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Kuttenberg"
    },
    {
        "ID": "17036",
        "NAME": "Rosenberg, Meinhard (1329\u20131362), Bischof von Trient",
        "DATEOFBIRTH": "1329",
        "DATEOFDEATH": "1362",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "17037",
        "NAME": "Sternberg, Kunigunda (1422\u20131449)",
        "DATEOFBIRTH": "1422",
        "DATEOFDEATH": "1449 Nov 19",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": "Podiebrad"
    },
    {
        "ID": "17038",
        "NAME": "Sternberg, Ulrich (1510\u20131567)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17039",
        "NAME": "Sternberg, Odoaker (1540\u20131589)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17040",
        "NAME": "Piastowicz, Friedrich (1480\u20131547), Herzog in Schlesien",
        "DATEOFBIRTH": "1480 Feb 12",
        "DATEOFDEATH": "1547 Sep 17",
        "PLACEOFBIRTH": "Liegnitz",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "17041",
        "NAME": "Piastowicz, Friedrich (1520\u20131570), Herzog in Schlesien",
        "DATEOFBIRTH": "1520 Feb 22",
        "DATEOFDEATH": "1570 Dez 15",
        "PLACEOFBIRTH": "Liegnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17042",
        "NAME": "Piastowicz, Heinrich (1539\u20131588), Herzog in Schlesien",
        "DATEOFBIRTH": "1539 Feb 23",
        "DATEOFDEATH": "1588 Mar 03",
        "PLACEOFBIRTH": "Liegnitz",
        "PLACEOFDEATH": "Krakau"
    },
    {
        "ID": "17043",
        "NAME": "Haugwitz, Wenzel (1510\u20131571)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Reichwaldau in M\u00e4hren",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17044",
        "NAME": "Haugwitz, Joachim (1560\u20131607), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1607",
        "PLACEOFBIRTH": "Reichwaldau in M\u00e4hren",
        "PLACEOFDEATH": "Olm\u00fctz in M\u00e4hren"
    },
    {
        "ID": "17045",
        "NAME": "Haugwitz, Eusebia (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Reichwaldau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17046",
        "NAME": "Rosenberg, Sezima (1430\u20131487)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1487 Dez 30",
        "PLACEOFBIRTH": "Aust an der Lainsitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17047",
        "NAME": "Rosenberg, Johann (1470\u20131537)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1537",
        "PLACEOFBIRTH": "Aust an der Lainsitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17048",
        "NAME": "Rosenberg, Georg (1520\u20131575)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1575",
        "PLACEOFBIRTH": "Aust an der Lainsitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17049",
        "NAME": "Rosenberg, Anna (1600\u20131664)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1664 Aug 17",
        "PLACEOFBIRTH": "Aust an der Lainsitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17050",
        "NAME": "L\u00f6bl von Greinburg, Johann (1490\u20131534), Hofpfennigmeister",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1534",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17051",
        "NAME": "Czettritz, Georg (1550\u2013\u00a0\u00a0\u00a0\u00a0), Vorschneider",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "K\u00f6nigsberg im Eulengebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17052",
        "NAME": "Trauttmansdorff, Johann Joachim (1575\u20131636)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1636 Aug 08",
        "PLACEOFBIRTH": "Totzenbach am Haspelwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17053",
        "NAME": "Trauttmansdorff, Amalia (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17054",
        "NAME": "Paradis, Johann (1560\u2013\u00a0\u00a0\u00a0\u00a0), Kammerdiener",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17055",
        "NAME": "L\u00f6bl von Greinburg, Johann Jakob (1520\u20131560)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1560 Mai 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17056",
        "NAME": "Carretto, Jakob (1220\u20131272)",
        "DATEOFBIRTH": "1220~",
        "DATEOFDEATH": "1272 Okt 21",
        "PLACEOFBIRTH": "Finale",
        "PLACEOFDEATH": "Finale"
    },
    {
        "ID": "17057",
        "NAME": "Carretto, Konrad (1250\u20131316)",
        "DATEOFBIRTH": "1250~",
        "DATEOFDEATH": "1316",
        "PLACEOFBIRTH": "Finale",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17058",
        "NAME": "Carretto, Franz (1280\u20131330)",
        "DATEOFBIRTH": "1280~",
        "DATEOFDEATH": "1330~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17059",
        "NAME": "Carretto, Bonifaz (1315\u20131345)",
        "DATEOFBIRTH": "1315~",
        "DATEOFDEATH": "1345 Aug 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17060",
        "NAME": "Carretto, Anton (1260\u20131313)",
        "DATEOFBIRTH": "1260~",
        "DATEOFDEATH": "1313",
        "PLACEOFBIRTH": "Finale",
        "PLACEOFDEATH": "Finale"
    },
    {
        "ID": "17061",
        "NAME": "Carretto, Georg (1290\u20131359)",
        "DATEOFBIRTH": "1290~",
        "DATEOFDEATH": "1359",
        "PLACEOFBIRTH": "Finale",
        "PLACEOFDEATH": "Finale"
    },
    {
        "ID": "17062",
        "NAME": "Carretto, Karl (1340\u20131421)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "1421",
        "PLACEOFBIRTH": "Finale",
        "PLACEOFDEATH": "Zuccarello"
    },
    {
        "ID": "17063",
        "NAME": "Carretto, Heinrich (1377\u20131431)",
        "DATEOFBIRTH": "1377",
        "DATEOFDEATH": "1431",
        "PLACEOFBIRTH": "Zuccarello",
        "PLACEOFDEATH": "Zuccarello"
    },
    {
        "ID": "17064",
        "NAME": "Carretto, Karl (1420\u20131488)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1488 Jan 06",
        "PLACEOFBIRTH": "Zuccarello",
        "PLACEOFDEATH": "Zuccarello"
    },
    {
        "ID": "17065",
        "NAME": "Carretto, Anton (1450\u20131519)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1519",
        "PLACEOFBIRTH": "Zuccarello",
        "PLACEOFDEATH": "Zuccarello"
    },
    {
        "ID": "17066",
        "NAME": "Carretto, Bartlome (1485\u20131554)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1554 Jul 21",
        "PLACEOFBIRTH": "Zuccarello",
        "PLACEOFDEATH": "Albenga"
    },
    {
        "ID": "17067",
        "NAME": "Carretto, Williprecht (1523\u20131574)",
        "DATEOFBIRTH": "1523",
        "DATEOFDEATH": "1574 Apr 07",
        "PLACEOFBIRTH": "Zuccarello",
        "PLACEOFDEATH": "Zuccarello"
    },
    {
        "ID": "17068",
        "NAME": "Carretto, Scipio (1550\u20131605)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "Zuccarello",
        "PLACEOFDEATH": "Mondov\u00ec"
    },
    {
        "ID": "17069",
        "NAME": "Carretto, Williprecht (1585\u20131658), Mundschenk",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1658 Jul 15",
        "PLACEOFBIRTH": "Zuccarello",
        "PLACEOFDEATH": "Torino"
    },
    {
        "ID": "17070",
        "NAME": "Carretto, Klaudius (1585\u2013\u00a0\u00a0\u00a0\u00a0), Mundschenk",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17071",
        "NAME": "Kolowrat, Ferdinand Ludwig (1621\u20131701), Gro\u00dfprior des Malteserordens in B\u00f6hmen",
        "DATEOFBIRTH": "1621 Dez 12",
        "DATEOFDEATH": "1701 Sep 30",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Heideburg in B\u00f6hmen"
    },
    {
        "ID": "17072",
        "NAME": "Kolowrat, Johann Wilhelm (1625\u20131668), Erzbischof von Prag",
        "DATEOFBIRTH": "1625 Sep 16",
        "DATEOFDEATH": "1668 Mai 31",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "17073",
        "NAME": "Kolowrat, Leopold Ulrich (1635\u20131690), K\u00e4mmerer",
        "DATEOFBIRTH": "1635 Feb 02",
        "DATEOFDEATH": "1690 Mai 04",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17074",
        "NAME": "Hornberg, Christoph (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hornburg in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17075",
        "NAME": "Hornberg, Georg Christoph (1550\u20131597), K\u00e4mmerer",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1597 Okt 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "17076",
        "NAME": "Hornberg, Johann Christoph (1590\u20131629), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17077",
        "NAME": "Hornberg, Andreas Hermann (1560\u20131601), Mundschenk",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1601 Nov 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17078",
        "NAME": "Hornberg, Siegmund Leopold (1585\u2013\u00a0\u00a0\u00a0\u00a0), Panetier",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17079",
        "NAME": "Hornberg, Georg Siegmund (1615\u20131667), K\u00e4mmerer",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1667",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17080",
        "NAME": "Paravicino, Oktavius (1552\u20131611), Bischof von Alessandria",
        "DATEOFBIRTH": "1552 Jul 11",
        "DATEOFDEATH": "1611 Feb 03",
        "PLACEOFBIRTH": "Rom",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "17081",
        "NAME": "Paravicino, Bartlome (1540\u20131605)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1605~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17082",
        "NAME": "Paravicino, Ulixes (1580\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sondrio",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17083",
        "NAME": "Kellner von Zinnendorf, Wilhelm (1545\u20131606)",
        "DATEOFBIRTH": "1545",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "17084",
        "NAME": "Kellner von Zinnendorf, Wilhelm (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17085",
        "NAME": "Lamberg, Andreas (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ortenegg in der Windischen Mark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17086",
        "NAME": "Lamberg, Gregor (1480\u20131565)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1565",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17087",
        "NAME": "Lamberg, Katharina (1520\u20131569)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17088",
        "NAME": "Volkenstorf, Wolfgang Wilhelm (1567\u20131616), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1567 Dez 19",
        "DATEOFDEATH": "1616 Sep 12",
        "PLACEOFBIRTH": "Volkenstorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17089",
        "NAME": "Erd\u0151dy, Johann (1587\u20131626), Bischof von Erlau",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1626 Apr 03",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17090",
        "NAME": "Erd\u0151dy, Stephan (1586\u20131638), Bischof von Syrmien",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1638 Jul 06",
        "PLACEOFBIRTH": "Eberau im Burgenland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17091",
        "NAME": "Salm, Johann (1380\u20131431)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1431 Jul 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bulgn\u00e9ville"
    },
    {
        "ID": "17092",
        "NAME": "Salm, Simon (1408\u20131459)",
        "DATEOFBIRTH": "1408",
        "DATEOFDEATH": "1459",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17093",
        "NAME": "Rheingraf zum Stein, Johann (1436\u20131495)",
        "DATEOFBIRTH": "1436 Nov 17",
        "DATEOFDEATH": "1495 Sep 02",
        "PLACEOFBIRTH": "Dhaun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17094",
        "NAME": "Rheingraf zum Stein, Johann (1460\u20131499)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1499 Dez 25",
        "PLACEOFBIRTH": "Dhaun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17095",
        "NAME": "Rheingraf zum Stein, Philipp (1492\u20131521)",
        "DATEOFBIRTH": "1492 Sep 08",
        "DATEOFDEATH": "1521 Aug 27",
        "PLACEOFBIRTH": "Dhaun",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17096",
        "NAME": "Rheingraf zum Stein, Philipp Franz (1518\u20131561)",
        "DATEOFBIRTH": "1518 Aug 04",
        "DATEOFDEATH": "1561 Jan 28",
        "PLACEOFBIRTH": "Dhaun",
        "PLACEOFDEATH": "Naumburg an der Saale"
    },
    {
        "ID": "17097",
        "NAME": "Rheingraf zum Stein, Friedrich (1547\u20131608)",
        "DATEOFBIRTH": "1547 Feb 03",
        "DATEOFDEATH": "1608 Nov 05",
        "PLACEOFBIRTH": "Neuviller an der Mosel",
        "PLACEOFDEATH": "Finstingen"
    },
    {
        "ID": "17098",
        "NAME": "Rheingraf zum Stein, Philipp Otto (1575\u20131634), Hofkriegsrat",
        "DATEOFBIRTH": "1575 Mai 22",
        "DATEOFDEATH": "1634 Nov 23",
        "PLACEOFBIRTH": "Neuviller an der Mosel",
        "PLACEOFDEATH": "Neuviller an der Mosel"
    },
    {
        "ID": "17099",
        "NAME": "Leuchtenberg, Amalia (1469\u20131538)",
        "DATEOFBIRTH": "1469 Jun 23",
        "DATEOFDEATH": "1538 Jan 30",
        "PLACEOFBIRTH": "Pfreimd",
        "PLACEOFDEATH": "Rottweil"
    },
    {
        "ID": "17101",
        "NAME": "Salis, Herkules (1503\u20131578)",
        "DATEOFBIRTH": "1503",
        "DATEOFDEATH": "1578",
        "PLACEOFBIRTH": "Soglio im Bergell",
        "PLACEOFDEATH": "Soglio im Bergell"
    },
    {
        "ID": "17102",
        "NAME": "Salis, Rudolf (1529\u20131600), Hofdiener",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1600 Mar 31",
        "PLACEOFBIRTH": "Soglio im Bergell",
        "PLACEOFDEATH": "Basel"
    },
    {
        "ID": "17103",
        "NAME": "Salis, Abund (1534\u20131567)",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "Soglio im Bergell",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17104",
        "NAME": "Salis, Albrecht (1548\u20131597)",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1597 Dez 03",
        "PLACEOFBIRTH": "Chur in Graub\u00fcnden",
        "PLACEOFDEATH": "Amberg in der Oberpfalz"
    },
    {
        "ID": "17105",
        "NAME": "Salis, Johann Wolfgang (1597\u20131640)",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1640 Apr 06",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Wismar"
    },
    {
        "ID": "17106",
        "NAME": "Salis, Anton (1500\u20131558)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1558",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17107",
        "NAME": "Salis, Kaspar (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Soglio im Bergell",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17108",
        "NAME": "Thurn, Johann (1430\u20131506)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1506",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17109",
        "NAME": "Thurn, Georg (1460\u20131512)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1512 Mar 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sanabor"
    },
    {
        "ID": "17110",
        "NAME": "Prager von Windhaag, Lassel (1460\u20131514), K\u00e4mmerer",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1514 Nov 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Windhaag im Machland"
    },
    {
        "ID": "17111",
        "NAME": "Prager von Windhaag, Johann (1507\u20131572), Vorschneider",
        "DATEOFBIRTH": "1507",
        "DATEOFDEATH": "1572",
        "PLACEOFBIRTH": "Windhaag im Machland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17112",
        "NAME": "Prager von Windhaag, Lassel (1508\u20131558), Truchsess",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "1558",
        "PLACEOFBIRTH": "Windhaag im Machland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17113",
        "NAME": "Prager von Windhaag, Andreas (1510\u20131569)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "Windhaag im Machland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17114",
        "NAME": "Prager von Windhaag, Friedrich (1545\u20131600)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1600",
        "PLACEOFBIRTH": "Windhaag im Machland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17115",
        "NAME": "Prager von Windhaag, Margarita (1585\u20131669)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1669",
        "PLACEOFBIRTH": "Windhaag im Machland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17116",
        "NAME": "Liechtenstein von Nikolsburg, Erasam (1547\u20131591), K\u00e4mmerer",
        "DATEOFBIRTH": "1547 Jan 02",
        "DATEOFDEATH": "1591 Mai 29",
        "PLACEOFBIRTH": "Feldsberg im Weinviertel",
        "PLACEOFDEATH": "Jauer an der Raab"
    },
    {
        "ID": "17117",
        "NAME": "M\u00e9rey, Michael (1500\u20131572)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1572 Feb 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17118",
        "NAME": "M\u00e9rey, Emmerich (1540\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17119",
        "NAME": "Berg von Herrndorf, Joachim (1526\u20131602), Reichshofrat",
        "DATEOFBIRTH": "1526 Mar 23",
        "DATEOFDEATH": "1602 Mar 05",
        "PLACEOFBIRTH": "Herrndorf in Niederschlesien",
        "PLACEOFDEATH": "Sprottau"
    },
    {
        "ID": "17120",
        "NAME": "Kuenburg, Michael (1514\u20131560), Erzbischof von Salzburg",
        "DATEOFBIRTH": "1514 Okt 10",
        "DATEOFDEATH": "1560 Nov 17",
        "PLACEOFBIRTH": "Sachsenburg an der Drau",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "17121",
        "NAME": "Kuenburg, Christoph (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17122",
        "NAME": "Kuenburg, Christoph (1510\u20131584)",
        "DATEOFBIRTH": "1510 Jul 01",
        "DATEOFDEATH": "1584 Jul 26",
        "PLACEOFBIRTH": "Sachsenburg an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17123",
        "NAME": "Kuenburg, Erasam (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sachsenburg an der Drau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17124",
        "NAME": "Kuenburg, Elisabeth (1546\u20131602)",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1602 Mar 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Gurnitz"
    },
    {
        "ID": "17125",
        "NAME": "Kuenburg, Georg (1542\u20131587), Erzbischof von Salzburg",
        "DATEOFBIRTH": "1542 Mai 22",
        "DATEOFDEATH": "1587 Jan 25",
        "PLACEOFBIRTH": "Moosham im Lungau",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "17126",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Bernhard (1500\u20131551)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1551 Dez 04",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Grafenegg im Weinviertel"
    },
    {
        "ID": "17127",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Bernhard (1535\u20131594), Truchsess",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17128",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Barbara (1534\u20131597)",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17129",
        "NAME": "Thurz\u00f3 von Bethlenfalva, Elisabeth (1621\u20131642)",
        "DATEOFBIRTH": "1621 Feb 20",
        "DATEOFDEATH": "1642 Jul 04",
        "PLACEOFBIRTH": "Bitscha an der Waag",
        "PLACEOFDEATH": "Lackenbach im Burgenland"
    },
    {
        "ID": "17130",
        "NAME": "Rehlinger, Bernhard (1440\u20131484)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1484",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17131",
        "NAME": "Rehlinger, Johann (1483\u20131552)",
        "DATEOFBIRTH": "1483",
        "DATEOFDEATH": "1552 Mai 06",
        "PLACEOFBIRTH": "Horgau an der Roth",
        "PLACEOFDEATH": "F\u00fcssen im Allg\u00e4u"
    },
    {
        "ID": "17132",
        "NAME": "Rehlinger, Anna (1505\u20131548)",
        "DATEOFBIRTH": "1505 Nov 03",
        "DATEOFDEATH": "1548 Mar 25",
        "PLACEOFBIRTH": "Horgau an der Roth",
        "PLACEOFDEATH": "Schwaz in Tirol"
    },
    {
        "ID": "17133",
        "NAME": "Rehlinger, Bernhard (1477\u20131537)",
        "DATEOFBIRTH": "1477",
        "DATEOFDEATH": "1537",
        "PLACEOFBIRTH": "Horgau an der Roth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17134",
        "NAME": "Rehlinger, Bernhard (1504\u20131572)",
        "DATEOFBIRTH": "1504",
        "DATEOFDEATH": "1572",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17135",
        "NAME": "Rehlinger, Christoph (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Horgau an der Roth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17136",
        "NAME": "Rehlinger, Anna (1576\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Horgau an der Roth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17137",
        "NAME": "Mattioli, Christoph Andreas (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17138",
        "NAME": "Wendenstein von Prandtenberg, Johann (1589\u20131629), Hofkammerrat",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17139",
        "NAME": "Sch\u00f6nberg, Wolfgang (1518\u20131584)",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1584 Jan 29",
        "PLACEOFBIRTH": "Schneeberg im Erzgebirge",
        "PLACEOFDEATH": "Nauensorge"
    },
    {
        "ID": "17140",
        "NAME": "Sinzendorf, Friedrich (1537\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Feyregg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17141",
        "NAME": "Drugeth von Homonna, Johann (1465\u20131512)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "Homenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17142",
        "NAME": "Drugeth von Homonna, Georg (1495\u20131548)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "Homenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17143",
        "NAME": "Drugeth von Homonna, Franz (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Homenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17144",
        "NAME": "Drugeth von Homonna, Gabriel (1505\u20131551)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1551",
        "PLACEOFBIRTH": "Homenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17145",
        "NAME": "Drugeth von Homonna, Stephan (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Homenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17146",
        "NAME": "Szunyogh, Moses (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17147",
        "NAME": "Szunyogh, Johann (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17148",
        "NAME": "Szunyogh, Stephan (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17149",
        "NAME": "Szunyogh, Georg (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17150",
        "NAME": "Dieskau, Jakob (1546\u20131597), K\u00e4mmerer",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "Finsterwalde in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17151",
        "NAME": "Sch\u00f6nberg, Johann (1470\u20131524)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1524 Dez 15",
        "PLACEOFBIRTH": "Sachsenburg an der Zschopau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17152",
        "NAME": "Sch\u00f6nberg, Wolfgang (1505\u20131568)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1568 Jan 16",
        "PLACEOFBIRTH": "B\u00f6rnichen in Mittelsachsen",
        "PLACEOFDEATH": "Sch\u00f6nau in Mittelsachsen"
    },
    {
        "ID": "17153",
        "NAME": "Sch\u00f6nberg, Johann Wolfgang (1539\u20131603)",
        "DATEOFBIRTH": "1539 Mai 04",
        "DATEOFDEATH": "1603 Dez 08",
        "PLACEOFBIRTH": "Sch\u00f6nau in Mittelsachsen",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "17154",
        "NAME": "Sch\u00f6nberg, Wolfgang Georg (1567\u20131619)",
        "DATEOFBIRTH": "1567 Feb 09",
        "DATEOFDEATH": "1619 Nov 16",
        "PLACEOFBIRTH": "Dresden",
        "PLACEOFDEATH": "Pulsnitz"
    },
    {
        "ID": "17155",
        "NAME": "Sch\u00f6nberg, Moritz (1522\u20131595)",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "1595 Jun 25",
        "PLACEOFBIRTH": "B\u00f6rnichen in Mittelsachsen",
        "PLACEOFDEATH": "Sch\u00f6nau in Mittelsachsen"
    },
    {
        "ID": "17156",
        "NAME": "Sch\u00f6nberg, Johann Georg (1549\u20131618), Hofdiener",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1618 Jan 27",
        "PLACEOFBIRTH": "B\u00f6rnichen in Mittelsachsen",
        "PLACEOFDEATH": "W\u00fcnschendorf im Elstertal"
    },
    {
        "ID": "17157",
        "NAME": "Sch\u00f6nberg, Georg (1559\u20131578)",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1578 Apr 27",
        "PLACEOFBIRTH": "Sch\u00f6nau in Mittelsachsen",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "17158",
        "NAME": "Sch\u00f6nberg, Kaspar (1540\u20131599)",
        "DATEOFBIRTH": "1540",
        "DATEOFDEATH": "1599 Mar 17",
        "PLACEOFBIRTH": "Sch\u00f6nau in Mittelsachsen",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "17159",
        "NAME": "Sch\u00f6nberg, Heinrich (1575\u20131632), Marschall von Frankreich",
        "DATEOFBIRTH": "1575 Aug 14",
        "DATEOFDEATH": "1632 Nov 17",
        "PLACEOFBIRTH": "Paris",
        "PLACEOFDEATH": "Bordeaux"
    },
    {
        "ID": "17160",
        "NAME": "Sch\u00f6nberg, Karl (1601\u20131656), Marschall von Frankreich",
        "DATEOFBIRTH": "1601 Feb 16",
        "DATEOFDEATH": "1656 Jun 06",
        "PLACEOFBIRTH": "Nanteuil le Haudouin",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "17161",
        "NAME": "Tattenbach, Veit (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17162",
        "NAME": "Tattenbach, Johann (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17163",
        "NAME": "Tattenbach, Gottfried (1510\u20131567)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1567 Jan 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17164",
        "NAME": "Tattenbach, Veit (1540\u20131590)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Konstantinopel"
    },
    {
        "ID": "17165",
        "NAME": "Tattenbach, Johann Rudolf (1578\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1647 Aug 04",
        "PLACEOFBIRTH": "Sankt Martin im Innkreis",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17166",
        "NAME": "Carretto, Pyrrhus (1476\u20131553)",
        "DATEOFBIRTH": "1476",
        "DATEOFDEATH": "1553 Mar 16",
        "PLACEOFBIRTH": "Zuccarello",
        "PLACEOFDEATH": "Balestrino"
    },
    {
        "ID": "17167",
        "NAME": "Carretto, Anton (1497\u20131574)",
        "DATEOFBIRTH": "1497",
        "DATEOFDEATH": "1574 Jul 30",
        "PLACEOFBIRTH": "Balestrino",
        "PLACEOFDEATH": "Balestrino"
    },
    {
        "ID": "17168",
        "NAME": "Carretto, Heinrich (1535\u20131610)",
        "DATEOFBIRTH": "1535",
        "DATEOFDEATH": "1610",
        "PLACEOFBIRTH": "Balestrino",
        "PLACEOFDEATH": "Albenga"
    },
    {
        "ID": "17169",
        "NAME": "Carretto, Hadrian (1574\u20131613), Vorschneider",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "Balestrino",
        "PLACEOFDEATH": "Marseille"
    },
    {
        "ID": "17170",
        "NAME": "Herzan von Harras, Wenzel (1460\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17171",
        "NAME": "Herzan von Harras, Adam (1490\u20131533)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1533",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17172",
        "NAME": "Herzan von Harras, Wenzel (1530\u20131570)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1570",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17173",
        "NAME": "Herzan von Harras, Adam Felix (1560\u20131598)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17174",
        "NAME": "Herzan von Harras, Niklas (1520\u20131565)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1565",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17175",
        "NAME": "Herzan von Harras, Adam (1550\u20131619)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1619 Jan 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rothenhaus im Erzgebirge"
    },
    {
        "ID": "17176",
        "NAME": "Herzan von Harras, Tobias (1510\u20131570)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1570 Jun 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17177",
        "NAME": "Herzan von Harras, Wenzel (1540\u20131584)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17178",
        "NAME": "Herzan von Harras, Niklas (1578\u20131617)",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17179",
        "NAME": "Herzan von Harras, Sedeslaus (1579\u20131642)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17180",
        "NAME": "Herzan von Harras, Adam Tobias (1580\u2013\u00a0\u00a0\u00a0\u00a0), Panetier",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17181",
        "NAME": "Herzan von Harras, Johann (1500\u20131561)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1561 Apr 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17182",
        "NAME": "Tattenbach, Wilhelm (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17183",
        "NAME": "Tattenbach, Johann (1510\u20131567)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17184",
        "NAME": "Tattenbach, Siegmund (1540\u20131594)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17185",
        "NAME": "Szunyogh, Moses (1565\u20131621), K\u00e4mmerer",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17186",
        "NAME": "Szunyogh, Andreas (1600\u20131657)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1657",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17187",
        "NAME": "Proskau, Johann (1450\u20131510)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1510",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17188",
        "NAME": "Kochtizky, Johann (1543\u20131591)",
        "DATEOFBIRTH": "1543 Mai 15",
        "DATEOFDEATH": "1591 Jan 01",
        "PLACEOFBIRTH": "Lublinitz",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "17189",
        "NAME": "Kochtizky, Niklas (1570\u20131622), Landeshauptmann von Nei\u00dfe",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1622",
        "PLACEOFBIRTH": "Lublinitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17190",
        "NAME": "Kochtizky, Andreas (1568\u20131634), Landeshauptmann von Oppeln",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "Lublinitz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17191",
        "NAME": "Polheim, Reinprecht (1400\u20131466)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1466 Mai 29",
        "PLACEOFBIRTH": "Lichtenegg im Hausruckviertel",
        "PLACEOFDEATH": "Wels:Minoritenkloster"
    },
    {
        "ID": "17192",
        "NAME": "Polheim, Andreas (1440\u20131496), K\u00e4mmerer",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1496",
        "PLACEOFBIRTH": "Lichtenegg im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17193",
        "NAME": "Polheim, Martin (1450\u20131498)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1498 Jun 02",
        "PLACEOFBIRTH": "Lichtenegg im Hausruckviertel",
        "PLACEOFDEATH": "Steyr"
    },
    {
        "ID": "17194",
        "NAME": "Polheim, Siegmund (1494\u20131544)",
        "DATEOFBIRTH": "1494",
        "DATEOFDEATH": "1544 Jun 14",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Gastein im Pongau"
    },
    {
        "ID": "17195",
        "NAME": "Polheim, Andreas (1528\u20131589)",
        "DATEOFBIRTH": "1528 Jan 15",
        "DATEOFDEATH": "1589 Aug 21",
        "PLACEOFBIRTH": "Lichtenegg im Hausruckviertel",
        "PLACEOFDEATH": "Wels"
    },
    {
        "ID": "17196",
        "NAME": "Polheim, Maximilian (1572\u20131616), Truchsess",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1616 Mai 15",
        "PLACEOFBIRTH": "Ottenschlag im Waldviertel",
        "PLACEOFDEATH": "Gobelsburg im Kamptal"
    },
    {
        "ID": "17197",
        "NAME": "Polheim, Ludwig (1529\u20131608)",
        "DATEOFBIRTH": "1529 Okt 13",
        "DATEOFDEATH": "1608 Jan 16",
        "PLACEOFBIRTH": "Lichtenegg im Hausruckviertel",
        "PLACEOFDEATH": "Wels"
    },
    {
        "ID": "17198",
        "NAME": "Polheim, Gottfried (1572\u20131629), Truchsess",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Lichtenegg im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17199",
        "NAME": "Polheim, Reinprecht (1571\u20131615)",
        "DATEOFBIRTH": "1571 Sep 30",
        "DATEOFDEATH": "1615 Mai 15",
        "PLACEOFBIRTH": "Lichtenegg im Hausruckviertel",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "17201",
        "NAME": "Thannhausen, Balthasar (1450\u20131516)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1516",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Friesach in K\u00e4rnten"
    },
    {
        "ID": "17202",
        "NAME": "Thannhausen, Balthasar (1485\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17203",
        "NAME": "Thannhausen, Balthasar (1520\u20131560)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1560~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17204",
        "NAME": "Thannhausen, Franz (1490\u20131548)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17205",
        "NAME": "Thannhausen, Jakob (1530\u20131560)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1560 Sep 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Friesach in K\u00e4rnten"
    },
    {
        "ID": "17206",
        "NAME": "Herzan von Harras, Johann Adam (1590\u20131655)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1655 Sep 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rothenhaus im Erzgebirge"
    },
    {
        "ID": "17207",
        "NAME": "Kellner von Zinnendorf, Johann Jakob (1600\u20131674)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1674 Jan 08",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17208",
        "NAME": "Enenkel von Albrechtsberg, Christoph (1480\u20131538)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1538 Jul 02",
        "PLACEOFBIRTH": "Albrechtsberg an der Pielach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17209",
        "NAME": "Enenkel von Albrechtsberg, Achaz (1513\u20131574)",
        "DATEOFBIRTH": "1513 Mai 26",
        "DATEOFDEATH": "1574 Mar 23",
        "PLACEOFBIRTH": "Albrechtsberg an der Pielach",
        "PLACEOFDEATH": "Maria Laach am Jauerling"
    },
    {
        "ID": "17210",
        "NAME": "Rosenberg, Wolfgang (1218\u20131262), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1218",
        "DATEOFDEATH": "1262 Jun 03",
        "PLACEOFBIRTH": "Rosenberg in B\u00f6hmen",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "17211",
        "NAME": "Rosenberg, Heinrich (1250\u20131310)",
        "DATEOFBIRTH": "1250~",
        "DATEOFDEATH": "1310 Jul 04",
        "PLACEOFBIRTH": "Rosenberg in B\u00f6hmen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17212",
        "NAME": "Rosenberg, Peter (1282\u20131347)",
        "DATEOFBIRTH": "1282",
        "DATEOFDEATH": "1347 Okt 14",
        "PLACEOFBIRTH": "Rosenberg in B\u00f6hmen",
        "PLACEOFDEATH": "Krumau in B\u00f6hmen"
    },
    {
        "ID": "17213",
        "NAME": "Rosenberg, Ulrich (1325\u20131390)",
        "DATEOFBIRTH": "1325~",
        "DATEOFDEATH": "1390 Sep 28",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17214",
        "NAME": "Rosenberg, Heinrich (1361\u20131412), Oberstburggraf von Prag",
        "DATEOFBIRTH": "1361",
        "DATEOFDEATH": "1412 Jul 28",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17215",
        "NAME": "Rosenberg, Ulrich (1403\u20131462), Statthalter von B\u00f6hmen",
        "DATEOFBIRTH": "1403 Jan 13",
        "DATEOFDEATH": "1462 Apr 28",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": "Krumau in B\u00f6hmen"
    },
    {
        "ID": "17216",
        "NAME": "Rosenberg, Perchta (1429\u20131476)",
        "DATEOFBIRTH": "1429",
        "DATEOFDEATH": "1476 Mai 02",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17217",
        "NAME": "Rosenberg, Ludmila (1432\u20131456)",
        "DATEOFBIRTH": "1432",
        "DATEOFDEATH": "1456",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17218",
        "NAME": "Rosenberg, Agnes (1435\u20131488)",
        "DATEOFBIRTH": "1435",
        "DATEOFDEATH": "1488 Jul 25",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": "Wittingau"
    },
    {
        "ID": "17219",
        "NAME": "Rosenberg, Elisabeth (1466\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1466 Feb 14",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17220",
        "NAME": "Magno, Karl (1550\u20131620), Hofpostmeister",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1620",
        "PLACEOFBIRTH": "Murowitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17221",
        "NAME": "Magno, Johann Jakob (1580\u2013\u00a0\u00a0\u00a0\u00a0), Hofpostmeister",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Murowitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17222",
        "NAME": "F\u00fcrstenberg, Friedrich (1602\u20131655), Reichshofrat",
        "DATEOFBIRTH": "1602 Apr 23",
        "DATEOFDEATH": "1655 Okt 26",
        "PLACEOFBIRTH": "Blumberg in der Baar",
        "PLACEOFDEATH": "Datschitz in M\u00e4hren"
    },
    {
        "ID": "17223",
        "NAME": "F\u00fcrstenberg, Maximilian Franz (1634\u20131681), K\u00e4mmerer",
        "DATEOFBIRTH": "1634 Mai 12",
        "DATEOFDEATH": "1681 Okt 24",
        "PLACEOFBIRTH": "St\u00fchlingen",
        "PLACEOFDEATH": "Stra\u00dfburg im Elsass"
    },
    {
        "ID": "17230",
        "NAME": "Firmian, Niklas (1451\u20131509), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1451",
        "DATEOFDEATH": "1509 Mai 10",
        "PLACEOFBIRTH": "Bozen",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "17231",
        "NAME": "Firmian, Georg (1479\u20131540), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1479",
        "DATEOFDEATH": "1540 Jan 11",
        "PLACEOFBIRTH": "Kronmetz im Etschtal",
        "PLACEOFDEATH": "Sankt Pauls in Eppan"
    },
    {
        "ID": "17232",
        "NAME": "Firmian, Franz (1535\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kronmetz im Etschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17233",
        "NAME": "Firmian, Georg (1538\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kronmetz im Etschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17234",
        "NAME": "Firmian, Anna (1505\u20131543)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1543 Apr 16",
        "PLACEOFBIRTH": "Kronmetz im Etschtal",
        "PLACEOFDEATH": "Mattighofen"
    },
    {
        "ID": "17235",
        "NAME": "Firmian, Niklas (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kronmetz im Etschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17239",
        "NAME": "Firmian, Franz Wilhelm (1636\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1636 Okt 06",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kronmetz im Etschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17240",
        "NAME": "Firmian, Leopold Anton (1679\u20131744), Erzbischof von Salzburg",
        "DATEOFBIRTH": "1679 Mai 27",
        "DATEOFDEATH": "1744 Okt 22",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Salzburg:Dom"
    },
    {
        "ID": "17241",
        "NAME": "Thun, Georg Vigil (1630\u20131692), K\u00e4mmerer",
        "DATEOFBIRTH": "1630 Mai 05",
        "DATEOFDEATH": "1692",
        "PLACEOFBIRTH": "Kastelpfund",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "17242",
        "NAME": "Thun, Jakob Maximilian (1681\u20131741), Bischof von Gurk",
        "DATEOFBIRTH": "1681 Jul 23",
        "DATEOFDEATH": "1741 Jul 26",
        "PLACEOFBIRTH": "Maleit im Sulztal",
        "PLACEOFDEATH": "Stra\u00dfburg in K\u00e4rnten"
    },
    {
        "ID": "17243",
        "NAME": "Wengersky, Stenzel (1615\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17244",
        "NAME": "Starczynowski, Stenzel (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17245",
        "NAME": "Falkenhayn, Friedrich (1550\u2013\u00a0\u00a0\u00a0\u00a0), Mundschenk",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17246",
        "NAME": "Rost, Dionys (1529\u20131586), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1586 Sep 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17247",
        "NAME": "Polheim, Matthias (1608\u20131673)",
        "DATEOFBIRTH": "1608 Jul 13",
        "DATEOFDEATH": "1673 Jun 03",
        "PLACEOFBIRTH": "Lichtenegg im Hausruckviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17248",
        "NAME": "Zborowski, Martin (1492\u20131565)",
        "DATEOFBIRTH": "1492",
        "DATEOFDEATH": "1565 Feb 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17249",
        "NAME": "Zborowski, Christina (1540\u20131588)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17250",
        "NAME": "Wittelsbach, Klement August (1700\u20131761), Erzbischof von K\u00f6ln",
        "DATEOFBIRTH": "1700 Aug 16",
        "DATEOFDEATH": "1761 Feb 06",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Ehrenbreitstein"
    },
    {
        "ID": "17251",
        "NAME": "Wittelsbach, Ferdinand Maria (1699\u20131738)",
        "DATEOFBIRTH": "1699 Aug 05",
        "DATEOFDEATH": "1738 Dez 09",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "M\u00fcnchen:Theatinerkirche"
    },
    {
        "ID": "17252",
        "NAME": "Wittelsbach, Johann Theodor (1703\u20131763), Bischof von L\u00fcttich",
        "DATEOFBIRTH": "1703 Sep 03",
        "DATEOFDEATH": "1763 Jan 27",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "L\u00fcttich"
    },
    {
        "ID": "17253",
        "NAME": "Wittelsbach, Philipp Moritz (1698\u20131719)",
        "DATEOFBIRTH": "1698 Aug 05",
        "DATEOFDEATH": "1719 Mar 12",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Rom"
    },
    {
        "ID": "17261",
        "NAME": "Praschma von Bilkau, Niklas (1475\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17262",
        "NAME": "Praschma von Bilkau, Peter (1510\u20131559)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1559",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17263",
        "NAME": "Praschma von Bilkau, Peter (1545\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17264",
        "NAME": "Mirkovics, Mark (1600\u20131650)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1650~",
        "PLACEOFBIRTH": "Baag in Dalmatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17269",
        "NAME": "Sapieha, Leonhard (1557\u20131633)",
        "DATEOFBIRTH": "1557 Apr 02",
        "DATEOFDEATH": "1633 Jul 07",
        "PLACEOFBIRTH": "Ostrowno",
        "PLACEOFDEATH": "Vilnius"
    },
    {
        "ID": "17270",
        "NAME": "Chodkiewicz, Alexander (1475\u20131549)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1549 Mai 28",
        "PLACEOFBIRTH": "Nowogr\u00f3dek",
        "PLACEOFDEATH": "Supra\u015bl"
    },
    {
        "ID": "17271",
        "NAME": "Chodkiewicz, Gregor (1514\u20131572)",
        "DATEOFBIRTH": "1514",
        "DATEOFDEATH": "1572 Nov 12",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": "Supra\u015bl"
    },
    {
        "ID": "17272",
        "NAME": "Chodkiewicz, Andreas (1549\u20131575), Truchsess",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1575",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": "Supra\u015bl"
    },
    {
        "ID": "17273",
        "NAME": "Chodkiewicz, Alexander (1550\u20131578), Hofdiener",
        "DATEOFBIRTH": "1550",
        "DATEOFDEATH": "1578",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": "Supra\u015bl"
    },
    {
        "ID": "17274",
        "NAME": "Chodkiewicz, Hieronym (1515\u20131561)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1561",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": "Vilnius"
    },
    {
        "ID": "17275",
        "NAME": "Chodkiewicz, Johann (1537\u20131579)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1579 Aug 04",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": "Vilnius"
    },
    {
        "ID": "17276",
        "NAME": "Chodkiewicz, Johann Karl (1560\u20131621)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1621 Sep 24",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": "Chotyn"
    },
    {
        "ID": "17277",
        "NAME": "Pflugk, Kaspar (1547\u20131578), Truchsess",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1578",
        "PLACEOFBIRTH": "Eythra",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17278",
        "NAME": "Tschirnhaus, Michael (1540\u20131607)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1607 Jul 19",
        "PLACEOFBIRTH": "Mittelwalde in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17279",
        "NAME": "Tschirnhaus, Johann (1570\u20131631), Hofkriegsrat",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1631",
        "PLACEOFBIRTH": "Mittelwalde in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17280",
        "NAME": "Hildprandt von Ottenhausen, Simon (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17281",
        "NAME": "Hildprandt von Ottenhausen, Johann Reinhard (1570\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17282",
        "NAME": "Lindegg, Friedrich (1360\u20131412)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1412",
        "PLACEOFBIRTH": "Lindegg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17283",
        "NAME": "Lindegg, Johann (1395\u20131467)",
        "DATEOFBIRTH": "1395~",
        "DATEOFDEATH": "1467",
        "PLACEOFBIRTH": "Lindegg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17284",
        "NAME": "Lindegg, Ludwig (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Lindegg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17285",
        "NAME": "Lindegg, Georg (1485\u20131542)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1542",
        "PLACEOFBIRTH": "Lindegg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17286",
        "NAME": "Lindegg, Achaz (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Lindegg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17287",
        "NAME": "Lindegg, Dominik (1435\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Lindegg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17288",
        "NAME": "Lindegg, Niklas (1478\u20131578)",
        "DATEOFBIRTH": "1478",
        "DATEOFDEATH": "1578 Feb 08",
        "PLACEOFBIRTH": "Lindegg in der Krain",
        "PLACEOFDEATH": "Rovereid"
    },
    {
        "ID": "17289",
        "NAME": "Lindegg, Johann (1475\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Lindegg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17290",
        "NAME": "Lindegg, Kaspar (1512\u20131588), Reichshofratssekret\u00e4r",
        "DATEOFBIRTH": "1512",
        "DATEOFDEATH": "1588 Nov 14",
        "PLACEOFBIRTH": "Rovereid",
        "PLACEOFDEATH": "Mollenburg"
    },
    {
        "ID": "17291",
        "NAME": "Kollonitz, Siegfried (1550\u20131594), Panetier",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1594 Jul 20",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": "Jedenspeigen an der March"
    },
    {
        "ID": "17292",
        "NAME": "Kollonitz, Johann Bartlome (1535\u20131587), Truchsess",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1587",
        "PLACEOFBIRTH": "Schleinitz in der Krain",
        "PLACEOFDEATH": "Kaschau"
    },
    {
        "ID": "17293",
        "NAME": "Lobkowicz, Georg (1500\u20131534)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1534 Mar 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17294",
        "NAME": "Lobkowicz, Heinrich (1532\u20131576)",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17295",
        "NAME": "Lobkowicz, Eva (1568\u20131631)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1631 Jan 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Militsch"
    },
    {
        "ID": "17296",
        "NAME": "Lindegg, Christoph (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Lindegg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17297",
        "NAME": "Lindegg, Christina (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Lindegg in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17298",
        "NAME": "Schrott von Kindberg, Johann Christoph (1510\u20131572)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1572 Apr 05",
        "PLACEOFBIRTH": "Kindberg im M\u00fcrztal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17299",
        "NAME": "Schrott von Kindberg, Sophia (1540\u20131580)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1580 Jan 14",
        "PLACEOFBIRTH": "Kindberg im M\u00fcrztal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17301",
        "NAME": "Praschma von Bilkau, Johann (1535\u20131599)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17302",
        "NAME": "Praschma von Bilkau, Johann Bernhard (1635\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17303",
        "NAME": "Praschma von Bilkau, Johann Moritz (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17304",
        "NAME": "Praschma von Bilkau, Karl (1580\u20131625)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1625~",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17305",
        "NAME": "Praschma von Bilkau, Benedikt (1565\u20131626)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17306",
        "NAME": "Praschma von Bilkau, Niklas (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17307",
        "NAME": "Praschma von Bilkau, Franz Wilhelm (1602\u20131666)",
        "DATEOFBIRTH": "1602",
        "DATEOFDEATH": "1666 Jun 08",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17308",
        "NAME": "Praschma von Bilkau, Karl Stephan (1654\u20131694), K\u00e4mmerer",
        "DATEOFBIRTH": "1654",
        "DATEOFDEATH": "1694",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17309",
        "NAME": "Praschma von Bilkau, Franz Joseph (1675\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1675~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17310",
        "NAME": "Redern, Christoph (1480\u20131533)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1533",
        "PLACEOFBIRTH": "Ruppersdorf in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17311",
        "NAME": "Redern, Georg (1510\u20131557)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1557",
        "PLACEOFBIRTH": "Ruppersdorf in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17312",
        "NAME": "Redern, Georg (1545\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17313",
        "NAME": "Waldstein, Heinrich (1517\u20131579), Hofdiener",
        "DATEOFBIRTH": "1517 Feb 22",
        "DATEOFDEATH": "1579 Dez 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Dobrovice"
    },
    {
        "ID": "17314",
        "NAME": "Schlick, Albin (1585\u20131618)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1618 Jun 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17315",
        "NAME": "Wratislaw von Mitrowitz, Johann (1500\u20131546)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1546",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17316",
        "NAME": "Wratislaw von Mitrowitz, Georg (1540\u20131612)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17317",
        "NAME": "Wratislaw von Mitrowitz, Albrecht (1580\u20131615), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1615~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17318",
        "NAME": "Schlick, Niklas (1450\u20131522)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1522",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Falkenau an der Eger"
    },
    {
        "ID": "17319",
        "NAME": "Schlick, Albin (1490\u20131551)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1551",
        "PLACEOFBIRTH": "Falkenau an der Eger",
        "PLACEOFDEATH": "Wandersleben"
    },
    {
        "ID": "17320",
        "NAME": "Schlick, Christoph (1543\u20131615)",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1615 Mai 18",
        "PLACEOFBIRTH": "Falkenau an der Eger",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17321",
        "NAME": "Schlick, Johann Albin (1579\u20131640)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1640",
        "PLACEOFBIRTH": "Falkenau an der Eger",
        "PLACEOFDEATH": "Zwickau"
    },
    {
        "ID": "17322",
        "NAME": "Schlick, Christoph Karl (1611\u20131633)",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1633 Feb 28",
        "PLACEOFBIRTH": "Falkenau an der Eger",
        "PLACEOFDEATH": "H\u00f6chstadt an der Aisch"
    },
    {
        "ID": "17323",
        "NAME": "Waldstein, Heinrich (1568\u20131623)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1623 Mai 01",
        "PLACEOFBIRTH": "Dobrovice",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "17324",
        "NAME": "Waldstein, Heinrich (1310\u20131368)",
        "DATEOFBIRTH": "1310~",
        "DATEOFDEATH": "1368",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17325",
        "NAME": "Waldstein, Ignaz (1350\u20131402)",
        "DATEOFBIRTH": "1350~",
        "DATEOFDEATH": "1402",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Iglau in M\u00e4hren"
    },
    {
        "ID": "17326",
        "NAME": "Waldstein, Sidonius (1390\u20131466)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1466",
        "PLACEOFBIRTH": "Pirnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17327",
        "NAME": "Waldstein, Ignaz (1430\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pirnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17328",
        "NAME": "Waldstein, Burian (1480\u20131544)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1544",
        "PLACEOFBIRTH": "Pirnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17329",
        "NAME": "Waldstein, Sidonius (1515\u20131561)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1561 Okt 04",
        "PLACEOFBIRTH": "Pirnitz",
        "PLACEOFDEATH": "Pirnitz"
    },
    {
        "ID": "17330",
        "NAME": "Waldstein, Ignaz (1548\u20131596), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "Pirnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17331",
        "NAME": "Waldstein, Heinrich (1555\u20131589)",
        "DATEOFBIRTH": "1555 Aug 15",
        "DATEOFDEATH": "1589 Sep 07",
        "PLACEOFBIRTH": "Pirnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17332",
        "NAME": "Waldstein, Sidonius (1581\u20131623)",
        "DATEOFBIRTH": "1581 Mai 12",
        "DATEOFDEATH": "1623 Jun 24",
        "PLACEOFBIRTH": "Pirnitz",
        "PLACEOFDEATH": "Spielberg in M\u00e4hren"
    },
    {
        "ID": "17333",
        "NAME": "Wertema von Adlersberg, Georg (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Vertemate",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17334",
        "NAME": "Wertema von Adlersberg, Julius (1550\u2013\u00a0\u00a0\u00a0\u00a0), Vorschneider",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17335",
        "NAME": "Grangia, Peter Paul (1560\u20131612), Oberstfalkenmeister",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "Torino",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17336",
        "NAME": "Lindegg, Matthias (1550\u20131601)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1601 Mar 20",
        "PLACEOFBIRTH": "Lizzana",
        "PLACEOFDEATH": "G\u00f6ttweig"
    },
    {
        "ID": "17337",
        "NAME": "Lindegg, Christoph (1555\u20131602)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "Lizzana",
        "PLACEOFDEATH": "Mollenburg"
    },
    {
        "ID": "17338",
        "NAME": "Waldstein, Johann (1470\u20131530)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1530~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17339",
        "NAME": "Waldstein, Bernhardina (1505\u20131575)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1575 Dez 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17340",
        "NAME": "Spaur, Ulrich (1495\u20131549)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1549 Apr 17",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": "Trient"
    },
    {
        "ID": "17341",
        "NAME": "Spaur, Johann Thomas (1528\u20131591), Bischof von Brixen",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1591 Feb 25",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": "Brixen am Eisack"
    },
    {
        "ID": "17342",
        "NAME": "Spaur, Maria Christina (1530\u20131580)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1580~",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": "Laibach"
    },
    {
        "ID": "17343",
        "NAME": "Spaur, Christoph Andreas (1543\u20131613), Bischof von Brixen",
        "DATEOFBIRTH": "1543 Nov 30",
        "DATEOFDEATH": "1613 Jan 10",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": "Brixen am Eisack"
    },
    {
        "ID": "17344",
        "NAME": "Hohberg, Melchior (1506\u20131566), Hofkammerrat",
        "DATEOFBIRTH": "1506 Jan 16",
        "DATEOFDEATH": "1566",
        "PLACEOFBIRTH": "G\u00fcttmannsdorf",
        "PLACEOFDEATH": "Ottenschlag im Waldviertel:Pfarrkirche"
    },
    {
        "ID": "17345",
        "NAME": "Hohberg, Balthasar (1501\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1501 Mar 13",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00fcttmannsdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17346",
        "NAME": "Hohberg, Johann (1539\u2013\u00a0\u00a0\u00a0\u00a0), Vorschneider",
        "DATEOFBIRTH": "1539 Aug 15",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "G\u00fcttmannsdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17347",
        "NAME": "Hohberg, Heinrich (1552\u20131606)",
        "DATEOFBIRTH": "1552 Jun 22",
        "DATEOFDEATH": "1606 Dez 06",
        "PLACEOFBIRTH": "G\u00fcttmannsdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17348",
        "NAME": "Thurn, Magdalena (1585\u20131617)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1617 Okt 02",
        "PLACEOFBIRTH": "Lipnitz an der Sasau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17349",
        "NAME": "Thurn, Elisabeth (1595\u20131622)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1622",
        "PLACEOFBIRTH": "Lipnitz an der Sasau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17350",
        "NAME": "Thurn, Heinrich Wenzel (1590\u20131642)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Lipnitz an der Sasau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17351",
        "NAME": "Scala, Johann (1440\u20131490)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1490 Nov 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "17352",
        "NAME": "Scala, Johann (1471\u20131547)",
        "DATEOFBIRTH": "1471",
        "DATEOFDEATH": "1547 Sep 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "17353",
        "NAME": "Scala, Johann Christoph (1505\u20131544)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1544 Apr 14",
        "PLACEOFBIRTH": "Amerang im Chiemgau",
        "PLACEOFDEATH": "Ceresole Alba"
    },
    {
        "ID": "17354",
        "NAME": "Scala, Johann Warmund (1540\u20131592)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1592 Mai 24",
        "PLACEOFBIRTH": "Amerang im Chiemgau",
        "PLACEOFDEATH": "Amerang im Chiemgau"
    },
    {
        "ID": "17355",
        "NAME": "Scala, Johanna (1574\u20131644)",
        "DATEOFBIRTH": "1574 Mai 02",
        "DATEOFDEATH": "1644 Aug 17",
        "PLACEOFBIRTH": "Amerang im Chiemgau",
        "PLACEOFDEATH": "Tittmoning an der Salzach"
    },
    {
        "ID": "17356",
        "NAME": "Geizkofler von Reifenegg, Johann (1498\u20131563)",
        "DATEOFBIRTH": "1498",
        "DATEOFDEATH": "1563 Jul 29",
        "PLACEOFBIRTH": "Sterzing",
        "PLACEOFDEATH": "Sterzing"
    },
    {
        "ID": "17357",
        "NAME": "Geizkofler von Reifenegg, Kaspar (1531\u20131575), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1531",
        "DATEOFDEATH": "1575 Dez 15",
        "PLACEOFBIRTH": "Sterzing",
        "PLACEOFDEATH": "Karlsbad"
    },
    {
        "ID": "17358",
        "NAME": "Geizkofler von Reifenegg, Georg (1526\u20131577), M\u00fcnzmeister in Joachimsthal",
        "DATEOFBIRTH": "1526 Okt 02",
        "DATEOFDEATH": "1577 Jul 14",
        "PLACEOFBIRTH": "Sterzing",
        "PLACEOFDEATH": "Joachimsthal im Erzgebirge"
    },
    {
        "ID": "17359",
        "NAME": "Geizkofler von Reifenegg, Johann (1530\u20131581), M\u00fcnzmeister in Salzburg",
        "DATEOFBIRTH": "1530 Mar 23",
        "DATEOFDEATH": "1581 Dez 04",
        "PLACEOFBIRTH": "Sterzing",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "17360",
        "NAME": "Gienger, Damian (1470\u20131556)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1556 Jun 08",
        "PLACEOFBIRTH": "Ulm an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17361",
        "NAME": "Gienger, Georg (1497\u20131577), Obersthofmarschall",
        "DATEOFBIRTH": "1497",
        "DATEOFDEATH": "1577 Jan 14",
        "PLACEOFBIRTH": "Langenau an der Donau",
        "PLACEOFDEATH": "Lorch an der Enns:Minoritenkirche"
    },
    {
        "ID": "17362",
        "NAME": "Gienger, Johann (1505\u20131569)",
        "DATEOFBIRTH": "1505",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "Langenau an der Donau",
        "PLACEOFDEATH": "Montfort im Rheintal"
    },
    {
        "ID": "17363",
        "NAME": "Gienger, Jakob (1510\u20131578), Hofkammerrat",
        "DATEOFBIRTH": "1510 Aug 09",
        "DATEOFDEATH": "1578 Nov 29",
        "PLACEOFBIRTH": "Langenau an der Donau",
        "PLACEOFDEATH": "Gr\u00fcnbichl im Mostviertel"
    },
    {
        "ID": "17364",
        "NAME": "Gienger, Anton (1513\u20131574), Hofkammerrat",
        "DATEOFBIRTH": "1513 Aug 28",
        "DATEOFDEATH": "1574 Dez 10",
        "PLACEOFBIRTH": "Langenau an der Donau",
        "PLACEOFDEATH": "Wien:Stephansdom"
    },
    {
        "ID": "17365",
        "NAME": "Gienger, Leonhard (1514\u20131588), Obersthofmeister",
        "DATEOFBIRTH": "1514 Dez 25",
        "DATEOFDEATH": "1588 Nov 27",
        "PLACEOFBIRTH": "Langenau an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17366",
        "NAME": "Gienger, Kosmas (1516\u20131592)",
        "DATEOFBIRTH": "1516 Apr 23",
        "DATEOFDEATH": "1592 Aug 26",
        "PLACEOFBIRTH": "Langenau an der Donau",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "17367",
        "NAME": "Gienger, Wilhelm (1519\u20131586), Hofkammerrat",
        "DATEOFBIRTH": "1519",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "Langenau an der Donau",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "17368",
        "NAME": "Gienger, Niklas (1556\u20131636)",
        "DATEOFBIRTH": "1556 Dez 02",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "Gr\u00fcnbichl im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17369",
        "NAME": "Gienger, Ferdinand Pankraz (1588\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1588",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gr\u00fcnbichl im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17370",
        "NAME": "Frangipane di Veglia, Trajan (1420\u20131487)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1487 Sep 14",
        "PLACEOFBIRTH": "Zengg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17371",
        "NAME": "Frangipane di Veglia, Anna (1460\u20131498)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1498",
        "PLACEOFBIRTH": "Sluin",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17372",
        "NAME": "Geizkofler von Reifenegg, Ferdinand (1592\u20131653)",
        "DATEOFBIRTH": "1592 Jun 19",
        "DATEOFDEATH": "1653 Feb 02",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "17373",
        "NAME": "Schaffgotsch, Balthasar (1555\u20131595)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1595 Aug 16",
        "PLACEOFBIRTH": "Langenau im Riesengebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17374",
        "NAME": "Proskau, Johann (1480\u20131538)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1538",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17375",
        "NAME": "Spiller von Mitterberg, Mark (1510\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mitterberg im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17376",
        "NAME": "Spiller von Mitterberg, Blessel (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerrat",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mitterberg im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17377",
        "NAME": "Zaruba von Hustirzan, Wenzel (1490\u20131543)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "Hust\u00ed\u0159an",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17378",
        "NAME": "Zaruba von Hustirzan, Johann (1520\u20131567)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "Hust\u00ed\u0159an",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17379",
        "NAME": "Zaruba von Hustirzan, Anna (1540\u20131581)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1581",
        "PLACEOFBIRTH": "Hust\u00ed\u0159an",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17380",
        "NAME": "Kolowrat, Herbert (1365\u20131427)",
        "DATEOFBIRTH": "1365~",
        "DATEOFDEATH": "1427",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17381",
        "NAME": "Kolowrat, Johann (1390\u20131450)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1450~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17382",
        "NAME": "Kolowrat, Johann (1430\u20131483), Administrator von Prag",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1483 Sep 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17383",
        "NAME": "Kolowrat, Albrecht (1463\u20131510), Burggraf von Karlstein",
        "DATEOFBIRTH": "1463",
        "DATEOFDEATH": "1510 Mai 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17384",
        "NAME": "Kolowrat, Benedikt (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17385",
        "NAME": "Kolowrat, Jaroslaus (1530\u20131581)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1581 Okt 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17386",
        "NAME": "Kolowrat, Alexander (1360\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17387",
        "NAME": "Trauttmansdorff, Esther (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Leutschach an der Weinstra\u00dfe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17388",
        "NAME": "Fugger, Hieronym (1584\u20131633)",
        "DATEOFBIRTH": "1584 Jul 17",
        "DATEOFDEATH": "1633 Mai 08",
        "PLACEOFBIRTH": "Babenhausen in Schwaben",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17389",
        "NAME": "Fugger, Leopold (1620\u20131662), Oberststallmeister",
        "DATEOFBIRTH": "1620 Nov 15",
        "DATEOFDEATH": "1662 Aug 14",
        "PLACEOFBIRTH": "Babenhausen in Schwaben",
        "PLACEOFDEATH": "Wasserburg am Bodensee:Georgskirche"
    },
    {
        "ID": "17390",
        "NAME": "Kirchberger von Kirchberg, Siegmund (1400\u20131476)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1476",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17391",
        "NAME": "Kirchberger von Kirchberg, Georg (1440\u20131493)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1493",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17392",
        "NAME": "Kirchberger von Kirchberg, Bernhard (1470\u20131531)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1531 Nov 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Viehofen an der Traisen"
    },
    {
        "ID": "17393",
        "NAME": "Kirchberger von Kirchberg, Leonhard (1510\u20131561)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1561",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17394",
        "NAME": "Kirchberger von Kirchberg, Ludwig (1520\u20131563)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1563 Mar 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hohenegg im Dunkelsteinerwald"
    },
    {
        "ID": "17395",
        "NAME": "Kirchberger von Kirchberg, Wolfgang (1430\u20131498)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1498",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17396",
        "NAME": "Kirchberger von Kirchberg, Andreas (1460\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17397",
        "NAME": "Kirchberger von Kirchberg, Georg (1490\u20131541)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1541",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rottenburg am Neckar"
    },
    {
        "ID": "17398",
        "NAME": "Kirchberger von Kirchberg, Andreas (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rottenburg am Neckar",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17399",
        "NAME": "Kirchberger von Kirchberg, Georg (1550\u20131594)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "Rottenburg am Neckar",
        "PLACEOFDEATH": "Ehingen am Neckar"
    },
    {
        "ID": "17401",
        "NAME": "Kolowrat, Franz Wilhelm (1653\u20131715), K\u00e4mmerer",
        "DATEOFBIRTH": "1653 Okt 03",
        "DATEOFDEATH": "1715 Jun 04",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17402",
        "NAME": "Kolowrat, Norbert Leopold (1655\u20131716), Reichshofrat",
        "DATEOFBIRTH": "1655 Mar 09",
        "DATEOFDEATH": "1716 Apr 17",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Reichenau an der Knieschna"
    },
    {
        "ID": "17403",
        "NAME": "Kolowrat, Ferdinand Lorenz (1668\u20131694), K\u00e4mmerer",
        "DATEOFBIRTH": "1668 Aug 10",
        "DATEOFDEATH": "1694 Sep 23",
        "PLACEOFBIRTH": "Br\u00fcnn in M\u00e4hren",
        "PLACEOFDEATH": "Wardein an der Donau"
    },
    {
        "ID": "17404",
        "NAME": "Stain von Rechtenstein, Siegfried (1530\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Konstanz im Hegau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17405",
        "NAME": "Kuefstein, Lorenz (1496\u20131547)",
        "DATEOFBIRTH": "1496",
        "DATEOFDEATH": "1547 Apr 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "R\u00f6hrenbach im Waldviertel"
    },
    {
        "ID": "17406",
        "NAME": "Breunner, Helfried (1545\u20131580), Mundschenk",
        "DATEOFBIRTH": "1545",
        "DATEOFDEATH": "1580",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17407",
        "NAME": "Breunner, Elisabeth (1580\u20131611)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1611 Mai 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17408",
        "NAME": "Friedensberg, Karl Maria (1635\u20131701), K\u00e4mmerer",
        "DATEOFBIRTH": "1635 Jul 15",
        "DATEOFDEATH": "1701 Mar 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "17409",
        "NAME": "Zehmen, Fabian (1540\u20131605), Vorschneider",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1605 Aug 22",
        "PLACEOFBIRTH": "Christburg",
        "PLACEOFDEATH": "Marienburg in Preu\u00dfen"
    },
    {
        "ID": "17410",
        "NAME": "Czernowicz, Michael (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17411",
        "NAME": "Czernowicz, Maria (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17412",
        "NAME": "Bibran, Heinrich (1597\u20131644), K\u00e4mmerer",
        "DATEOFBIRTH": "1597",
        "DATEOFDEATH": "1644 Jul 18",
        "PLACEOFBIRTH": "Modlau in Schlesien",
        "PLACEOFDEATH": "Bojanowo"
    },
    {
        "ID": "17413",
        "NAME": "Bibran, Niklas Alexander (1626\u20131680)",
        "DATEOFBIRTH": "1626 Jun 15",
        "DATEOFDEATH": "1680 Apr 25",
        "PLACEOFBIRTH": "Liegnitz",
        "PLACEOFDEATH": "Schweidnitz"
    },
    {
        "ID": "17414",
        "NAME": "Bibran, Siegmund Heinrich (1640\u20131693)",
        "DATEOFBIRTH": "1640 Feb 26",
        "DATEOFDEATH": "1693 Sep 14",
        "PLACEOFBIRTH": "Liegnitz",
        "PLACEOFDEATH": "Reisicht in Schlesien"
    },
    {
        "ID": "17415",
        "NAME": "K\u00f6lnp\u00f6ck von Salaberg, Niklas (1500\u20131570)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1570",
        "PLACEOFBIRTH": "Steyr",
        "PLACEOFDEATH": "Salaberg im Mostviertel"
    },
    {
        "ID": "17416",
        "NAME": "Gr\u00fcnthal, Wolfgang (1500\u20131576)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Kremsegg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17417",
        "NAME": "Gr\u00fcnthal, Wolfgang Niklas (1565\u20131630), Reichshofrat",
        "DATEOFBIRTH": "1565",
        "DATEOFDEATH": "1630 Dez 06",
        "PLACEOFBIRTH": "Kremsegg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17418",
        "NAME": "Gr\u00fcnthal, Johann Jakob (1570\u20131626)",
        "DATEOFBIRTH": "1570",
        "DATEOFDEATH": "1626 Aug 05",
        "PLACEOFBIRTH": "Kremsegg",
        "PLACEOFDEATH": "Voigtstedt"
    },
    {
        "ID": "17419",
        "NAME": "Gr\u00fcnthal, Johann Nimrod (1594\u20131662), Truchsess",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "1662",
        "PLACEOFBIRTH": "Kremsegg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17420",
        "NAME": "Strein von Schwarzenau, Wolfgang (1380\u20131424)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1424",
        "PLACEOFBIRTH": "Schwarzenau im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17421",
        "NAME": "Strein von Schwarzenau, Heinrich (1422\u20131490)",
        "DATEOFBIRTH": "1422",
        "DATEOFDEATH": "1490",
        "PLACEOFBIRTH": "Schwarzenau im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17422",
        "NAME": "Strein von Schwarzenau, Johann (1450\u20131499)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1499",
        "PLACEOFBIRTH": "Hartenstein in der Wachau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17423",
        "NAME": "Strein von Schwarzenau, Wolfhard (1490\u20131562)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1562 Aug 01",
        "PLACEOFBIRTH": "Hartenstein in der Wachau",
        "PLACEOFDEATH": "Haselbach im Waldviertel"
    },
    {
        "ID": "17424",
        "NAME": "Strein von Schwarzenau, Johann (1420\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schwarzenau im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17425",
        "NAME": "Strein von Schwarzenau, Wolfgang (1460\u20131505)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1505 Sep 12",
        "PLACEOFBIRTH": "Schwarzenau im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17426",
        "NAME": "Asseburg, Johann (1512\u20131567)",
        "DATEOFBIRTH": "1512",
        "DATEOFDEATH": "1567 Mai 17",
        "PLACEOFBIRTH": "Neindorf an der Bode",
        "PLACEOFDEATH": "Kaschau"
    },
    {
        "ID": "17427",
        "NAME": "Asseburg, Askan (1548\u20131580), Hofdiener",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1580 Okt 07",
        "PLACEOFBIRTH": "Neindorf an der Bode",
        "PLACEOFDEATH": "Schermcke an der Bode"
    },
    {
        "ID": "17428",
        "NAME": "Stadl, Johanna (1565\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Riegersburg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17429",
        "NAME": "Firmian, Sekunda Regina (1592\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kronmetz im Etschtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17431",
        "NAME": "Thoman von Frankenberg, Kaspar (1598\u20131637)",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1637 Aug 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17432",
        "NAME": "Radibrati, Ludwig (1560\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ragusa in Dalmatien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17433",
        "NAME": "Herberstein, Wolfgang Siegmund (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gutenhag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17434",
        "NAME": "Herberstein, Johann Christoph (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17435",
        "NAME": "Herberstein, Katharina (1640\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17436",
        "NAME": "J\u00f6rger von Tollet, Georg Wilhelm (1580\u20131617), Hofkammerrat",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "Tollet an der Trattnach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17437",
        "NAME": "Stadl, Bernhard (1460\u20131512)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "Stadl an der Raab",
        "PLACEOFDEATH": "Sankt Ruprecht an der Raab"
    },
    {
        "ID": "17438",
        "NAME": "Stadl, Christoph (1500\u20131552)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1552 Jan 12",
        "PLACEOFBIRTH": "Stadl an der Raab",
        "PLACEOFDEATH": "Sankt Ruprecht an der Raab"
    },
    {
        "ID": "17439",
        "NAME": "Stadl, Karl (1530\u20131576)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1576 Mar 14",
        "PLACEOFBIRTH": "Stadl an der Raab",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17440",
        "NAME": "Geymann, Ortolf (1360\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17441",
        "NAME": "Geymann, Christoph (1400\u20131452)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1452",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17442",
        "NAME": "Geymann, Stephan (1390\u20131465)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1465~",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17443",
        "NAME": "Geymann, Bartlome (1420\u20131468)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1468",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17444",
        "NAME": "Geymann, Johann (1450\u20131494)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1494",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17445",
        "NAME": "Geymann, Ortolf (1430\u20131476), K\u00e4mmerer",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1476",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17446",
        "NAME": "Geymann, Balthasar (1465\u20131522)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1522",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": "Gallspach im Hausruckviertel"
    },
    {
        "ID": "17447",
        "NAME": "Geymann, Johann Heinrich (1500\u20131566)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1566 Jul 13",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": "Gallspach im Hausruckviertel"
    },
    {
        "ID": "17448",
        "NAME": "Geymann, Johann Christoph (1544\u20131600)",
        "DATEOFBIRTH": "1544",
        "DATEOFDEATH": "1600 Feb 22",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": "Gallspach im Hausruckviertel"
    },
    {
        "ID": "17449",
        "NAME": "Geymann, Johann Ludwig (1580\u20131638), Vorschneider",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17450",
        "NAME": "Geymann, Johann (1480\u20131533)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1533 Dez 23",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": "Gm\u00fcnd in K\u00e4rnten"
    },
    {
        "ID": "17451",
        "NAME": "Geymann, Anna (1478\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1478",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17452",
        "NAME": "Geymann, Johann Paul (1578\u20131655)",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1655",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17453",
        "NAME": "Geymann, Johann Balthasar (1575\u20131590)",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": "Jena"
    },
    {
        "ID": "17454",
        "NAME": "Geymann, Johann Ortolf (1576\u20131620)",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1620 Nov 08",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17455",
        "NAME": "Stadl, Andreas (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Stadl an der Raab",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17456",
        "NAME": "Stadl, Franz (1520\u20131580)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1580 Jun 25",
        "PLACEOFBIRTH": "Stadl an der Raab",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17457",
        "NAME": "Stadl, Johann Andreas (1550\u20131620)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1620",
        "PLACEOFBIRTH": "Riegersburg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17458",
        "NAME": "Stadl, Ferdinand (1595\u20131655), Hofkriegsrat",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1655 Aug 14",
        "PLACEOFBIRTH": "Kornberg in der Steiermark",
        "PLACEOFDEATH": "Baden am Gebirge"
    },
    {
        "ID": "17459",
        "NAME": "Stadl, Johann Rudolf (1640\u20131696), K\u00e4mmerer",
        "DATEOFBIRTH": "1640 Apr 14",
        "DATEOFDEATH": "1696 Mai 28",
        "PLACEOFBIRTH": "Kornberg in der Steiermark",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "17460",
        "NAME": "Stadl, Ferdinand (1643\u20131694), K\u00e4mmerer",
        "DATEOFBIRTH": "1643 Mar 14",
        "DATEOFDEATH": "1694 Apr 29",
        "PLACEOFBIRTH": "Kornberg in der Steiermark",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "17461",
        "NAME": "Pruckhen, Andreas (1530\u20131584), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Rosenegg im Traunviertel"
    },
    {
        "ID": "17462",
        "NAME": "Strein von Schwarzenau, Johann Wolfhard (1534\u20131614)",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1614 Mar 08",
        "PLACEOFBIRTH": "Hartenstein in der Wachau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17463",
        "NAME": "Maltzan, Johann Bernhard (1597\u20131667)",
        "DATEOFBIRTH": "1597 Jul 26",
        "DATEOFDEATH": "1667 Dez 10",
        "PLACEOFBIRTH": "Br\u00fcnn in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17464",
        "NAME": "Capliers, Sedeslaus (1520\u20131565)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1565",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17465",
        "NAME": "Rehlinger, Maximilian (1570\u20131628), Hofdiener",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17466",
        "NAME": "Lampl von Fronsburg, Jakob (1576\u20131624)",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1624 Nov 01",
        "PLACEOFBIRTH": "Fronsburg im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17467",
        "NAME": "Lampl von Fronsburg, Regina (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Fronsburg im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17468",
        "NAME": "Lampl von Fronsburg, Adam (1609\u20131679)",
        "DATEOFBIRTH": "1609",
        "DATEOFDEATH": "1679 Jun 05",
        "PLACEOFBIRTH": "Fronsburg im Waldviertel",
        "PLACEOFDEATH": "Krems an der Donau"
    },
    {
        "ID": "17469",
        "NAME": "Dorn, Adam (1580\u20131654), Hofdiener",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1654",
        "PLACEOFBIRTH": "Ain\u00f6dt an der Gurk",
        "PLACEOFDEATH": "Moskau"
    },
    {
        "ID": "17470",
        "NAME": "Villinger von Sch\u00f6nenberg, Jakob (1480\u20131529), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1529",
        "PLACEOFBIRTH": "Schlettstadt",
        "PLACEOFDEATH": "Freiburg im Breisgau"
    },
    {
        "ID": "17471",
        "NAME": "Villinger von Sch\u00f6nenberg, Karl (1513\u20131571)",
        "DATEOFBIRTH": "1513",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17472",
        "NAME": "Villinger von Sch\u00f6nenberg, Jakob (1539\u20131597)",
        "DATEOFBIRTH": "1539",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17473",
        "NAME": "Villinger von Sch\u00f6nenberg, Karl (1570\u20131631), Edelknabe",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1631",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17474",
        "NAME": "Villinger von Sch\u00f6nenberg, Ferdinand (1600\u20131641)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1641 Mar 11",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "T\u00fcbingen"
    },
    {
        "ID": "17475",
        "NAME": "Breunner, Gottfried (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerrat",
        "DATEOFBIRTH": "1540",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17476",
        "NAME": "Breunner, Kaspar (1570\u20131616)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17477",
        "NAME": "Maltzan, Elisabeth (1560\u20131606)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1606 Jan 12",
        "PLACEOFBIRTH": "Wartenberg an der Weide",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17478",
        "NAME": "Lindegg, Adam (1585\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Lizzana",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17479",
        "NAME": "Tschernembl, Johann Wilhelm (1570\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schwertberg im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17480",
        "NAME": "Notthafft, Heinrich (1370\u20131440)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "1440 Jan 28",
        "PLACEOFBIRTH": "Wernberg in der Oberpfalz",
        "PLACEOFDEATH": "Straubing:Karmelitenkirche"
    },
    {
        "ID": "17481",
        "NAME": "Henckel von Donnersmarck, Konrad (1486\u20131542)",
        "DATEOFBIRTH": "1486 Aug 01",
        "DATEOFDEATH": "1542 Nov 16",
        "PLACEOFBIRTH": "Leutschau in der Zips",
        "PLACEOFDEATH": "G\u00f6llnitz in der Zips"
    },
    {
        "ID": "17482",
        "NAME": "Henckel von Donnersmarck, Johann (1513\u20131565), K\u00e4mmerer",
        "DATEOFBIRTH": "1513 Jun 25",
        "DATEOFDEATH": "1565 Feb 14",
        "PLACEOFBIRTH": "Leutschau in der Zips",
        "PLACEOFDEATH": "Leutschau in der Zips"
    },
    {
        "ID": "17483",
        "NAME": "Henckel von Donnersmarck, Sebastian (1530\u20131596)",
        "DATEOFBIRTH": "1530 Dez 28",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "Leutschau in der Zips",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17484",
        "NAME": "Henckel von Donnersmarck, Jakob (1560\u20131617), Hofdiener",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1617 Feb 16",
        "PLACEOFBIRTH": "Leutschau in der Zips",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17485",
        "NAME": "Henckel von Donnersmarck, Lazar (1551\u20131624)",
        "DATEOFBIRTH": "1551 Okt 29",
        "DATEOFDEATH": "1624 Jul 13",
        "PLACEOFBIRTH": "Leutschau in der Zips",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17486",
        "NAME": "Henckel von Donnersmarck, Lazar (1585\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1664 Okt 01",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Tarnowitz"
    },
    {
        "ID": "17487",
        "NAME": "Henckel von Donnersmarck, Georg (1587\u20131638)",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1638 Aug 09",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Krems an der Donau"
    },
    {
        "ID": "17488",
        "NAME": "Teubrecht, Georg (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17489",
        "NAME": "Tschirnhaus, David Heinrich (1580\u20131642), Landeshauptmann von Glatz",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Mittelwalde in Schlesien",
        "PLACEOFDEATH": "Peitz im Spreewald"
    },
    {
        "ID": "17490",
        "NAME": "Rorif von Rainau, Servas (1530\u20131593)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1593 Jul 26",
        "PLACEOFBIRTH": "Rorive an der Maas",
        "PLACEOFDEATH": "Neustift am Eisack"
    },
    {
        "ID": "17491",
        "NAME": "Rorif von Rainau, Andreas (1565\u20131620), Huschier",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1620~",
        "PLACEOFBIRTH": "Rorive an der Maas",
        "PLACEOFDEATH": "Rain in der H\u00f6ttinger Au"
    },
    {
        "ID": "17492",
        "NAME": "Berka von der Duba, Lassel (1560\u20131614), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1614 Jun 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17493",
        "NAME": "Gienger, Katharina (1520\u20131556)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1556 Sep 14",
        "PLACEOFBIRTH": "Langenau an der Donau",
        "PLACEOFDEATH": "Sankt Peter in der Au"
    },
    {
        "ID": "17494",
        "NAME": "Rheingraf zum Stein, Johann (1493\u20131531)",
        "DATEOFBIRTH": "1493",
        "DATEOFDEATH": "1531 Dez 11",
        "PLACEOFBIRTH": "Dhaun",
        "PLACEOFDEATH": "Kyrburg"
    },
    {
        "ID": "17495",
        "NAME": "Rheingraf zum Stein, Johann (1522\u20131548)",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "Kyrburg",
        "PLACEOFDEATH": "Finstingen"
    },
    {
        "ID": "17496",
        "NAME": "Rheingraf zum Stein, Otto (1545\u20131607)",
        "DATEOFBIRTH": "1545 Aug 15",
        "DATEOFDEATH": "1607 Jun 07",
        "PLACEOFBIRTH": "Kyrburg",
        "PLACEOFDEATH": "Kyrburg"
    },
    {
        "ID": "17497",
        "NAME": "Rheingraf zum Stein, Johann (1575\u20131623)",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "Kyrburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17498",
        "NAME": "Rheingraf zum Stein, Otto Ludwig (1597\u20131634)",
        "DATEOFBIRTH": "1597 Okt 13",
        "DATEOFDEATH": "1634 Okt 16",
        "PLACEOFBIRTH": "Kyrburg",
        "PLACEOFDEATH": "Speyer"
    },
    {
        "ID": "17499",
        "NAME": "Rheingraf zum Stein, Johann (1635\u20131688)",
        "DATEOFBIRTH": "1635 Apr 17",
        "DATEOFDEATH": "1688 Nov 16",
        "PLACEOFBIRTH": "Kyrburg",
        "PLACEOFDEATH": "Flonheim"
    },
    {
        "ID": "17501",
        "NAME": "Salm, Jakob (1435\u20131475)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1475 Feb 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17502",
        "NAME": "Salm, Johanna (1440\u20131496)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1496",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17503",
        "NAME": "Lamberg, Sabina (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17504",
        "NAME": "Hase von Hasenburg, Hedwig (1533\u20131592)",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1592 Mar 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "N\u00e1chod"
    },
    {
        "ID": "17505",
        "NAME": "Lamberg, Eleonora (1575\u20131608)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "Ottenstein im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17506",
        "NAME": "Wolkenstein, Elisabeth (1604\u20131655)",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1655 Mar 09",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "17507",
        "NAME": "Trauttmansdorff, Anna (1575\u20131610)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1610",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17508",
        "NAME": "Trauttmansdorff, Sidonia (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Totzenbach am Haspelwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17509",
        "NAME": "Trauttmansdorff, Sophia (1539\u20131571)",
        "DATEOFBIRTH": "1539",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Totzenbach am Haspelwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17510",
        "NAME": "Waldstein, Johanna (1500\u20131522)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1522",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17511",
        "NAME": "Lamberg, Maria Elisabeth (1638\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1638",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17512",
        "NAME": "Waldstein, Maximiliana (1635\u20131654)",
        "DATEOFBIRTH": "1635",
        "DATEOFDEATH": "1654 Apr 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17513",
        "NAME": "Draperio, Jakob (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Genova",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17514",
        "NAME": "Fugger, Georg (1518\u20131569)",
        "DATEOFBIRTH": "1518 Jan 01",
        "DATEOFDEATH": "1569 Aug 25",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17515",
        "NAME": "Fugger, Anton (1552\u20131616)",
        "DATEOFBIRTH": "1552 Aug 09",
        "DATEOFDEATH": "1616 Apr 13",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Gm\u00fcnd im Remstal"
    },
    {
        "ID": "17516",
        "NAME": "Schwihau, Ferdinand Wenzel (1605\u20131658)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1658 Feb 18",
        "PLACEOFBIRTH": "Ellischau",
        "PLACEOFDEATH": "Hrade\u0161ice"
    },
    {
        "ID": "17517",
        "NAME": "Schwihau, Anna Ludmila (1635\u20131660)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1660 Nov 20",
        "PLACEOFBIRTH": "Ellischau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17518",
        "NAME": "Mansfeld, Susanna Polyxena (1640\u20131693)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1693",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17519",
        "NAME": "Cirksena, Agnes (1584\u20131616)",
        "DATEOFBIRTH": "1584 Jan 01",
        "DATEOFDEATH": "1616 Feb 24",
        "PLACEOFBIRTH": "Aurich in Ostfriesland",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17520",
        "NAME": "Rosenberg, Anna (1375\u20131428)",
        "DATEOFBIRTH": "1375~",
        "DATEOFDEATH": "1428",
        "PLACEOFBIRTH": "Neuhaus in B\u00f6hmen",
        "PLACEOFDEATH": "Bregenz"
    },
    {
        "ID": "17521",
        "NAME": "Herzan von Harras, Katharina (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17522",
        "NAME": "Herzan von Harras, Anna Katharina (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17523",
        "NAME": "Piastowicz, Margarita (1465\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sagan",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17524",
        "NAME": "Lobkowicz, Ludmila (1590\u20131629)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17525",
        "NAME": "Berka von der Duba, Anna (1613\u20131674)",
        "DATEOFBIRTH": "1613",
        "DATEOFDEATH": "1674 Jul 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Feldbach in der Steiermark:Franziskanerkirche"
    },
    {
        "ID": "17526",
        "NAME": "Rheingraf zum Stein, Franziska (1578\u20131619)",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1619 Dez 14",
        "PLACEOFBIRTH": "Neuviller an der Mosel",
        "PLACEOFDEATH": "Hechingen"
    },
    {
        "ID": "17527",
        "NAME": "Dohna, Hedwig (1590\u20131668)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1668",
        "PLACEOFBIRTH": "Kraschen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17528",
        "NAME": "Kokorzowa, Griselda (1598\u20131624)",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17529",
        "NAME": "Trauttmansdorff, Eva Barbara (1605\u20131628)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1628 Nov 19",
        "PLACEOFBIRTH": "Trautmannsdorf in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17530",
        "NAME": "Harrach, Eleonora (1623\u20131693)",
        "DATEOFBIRTH": "1623 Mai 03",
        "DATEOFDEATH": "1693 Dez 01",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17531",
        "NAME": "Czeika von Olbramowitz, Veronika (1595\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kolin an der Elbe",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17532",
        "NAME": "Ilsung, Magdalena (1505\u20131561)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1561 Mai 23",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "17533",
        "NAME": "K\u00f6lnp\u00f6ck von Salaberg, Barbara (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Salaberg im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17534",
        "NAME": "K\u00f6lnp\u00f6ck von Salaberg, Ursula (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Salaberg im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17535",
        "NAME": "Fugger, Elisabeth (1543\u20131601)",
        "DATEOFBIRTH": "1543 Nov 28",
        "DATEOFDEATH": "1601 Aug 31",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17536",
        "NAME": "Chodkiewicz, Anna (1604\u20131625)",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1625 Mar 10",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17537",
        "NAME": "Kirchberger von Kirchberg, Regina (1550\u20131609)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Totzenbach am Haspelwald:Pfarrkirche"
    },
    {
        "ID": "17538",
        "NAME": "Kirchberger von Kirchberg, Elisabeth (1552\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17539",
        "NAME": "Kirchberger von Kirchberg, Katharina (1557\u20131608)",
        "DATEOFBIRTH": "1557 Jun 14",
        "DATEOFDEATH": "1608 Nov 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Peuerbach im Hausruckviertel"
    },
    {
        "ID": "17540",
        "NAME": "Harrach, Anna (1510\u20131571)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Goggitsch im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17541",
        "NAME": "Rueber von Pixendorf, Maria (1565\u20131594)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1594 Nov 21",
        "PLACEOFBIRTH": "Grafenw\u00f6rth an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17542",
        "NAME": "Strein von Schwarzenau, Katharina (1590\u20131656)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "Hartenstein in der Wachau",
        "PLACEOFDEATH": "Murstetten"
    },
    {
        "ID": "17543",
        "NAME": "Strein von Schwarzenau, Susanna (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hartenstein in der Wachau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17544",
        "NAME": "Strein von Schwarzenau, Agnes (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hartenstein in der Wachau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17545",
        "NAME": "Kielmann von Kielmansegg, Andreas (1530\u20131590), Hofkriegsrat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17546",
        "NAME": "Kielmann von Kielmansegg, Andreas (1570\u20131616)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17547",
        "NAME": "Kielmann von Kielmansegg, Anna (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17548",
        "NAME": "Dietrichstein, Paul (1583\u20131620)",
        "DATEOFBIRTH": "1583 Jan 24",
        "DATEOFDEATH": "1620 Dez 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17549",
        "NAME": "Herberstein, Leopold (1532\u20131606), Hofkriegsrat",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1606",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17550",
        "NAME": "Herberstein, Hannibal (1565\u20131615)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17551",
        "NAME": "Herberstein, Siegmund Friedrich (1595\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17552",
        "NAME": "Herberstein, Georg Siegmund (1625\u20131696), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1696 Apr 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "17553",
        "NAME": "Trauttmansdorff, Maria Margarita (1635\u20131692)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1692 Sep 14",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "17554",
        "NAME": "Plateis von Plattenstein, Johann (1555\u20131619), Hofsekret\u00e4r",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17555",
        "NAME": "Plateis von Plattenstein, Johann Ernst (1586\u20131637), Bischof von Olm\u00fctz",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1637 Aug 21",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Orechau im Wisowitzer Bergland"
    },
    {
        "ID": "17556",
        "NAME": "Stadl, Christoph (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Riegersburg in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17557",
        "NAME": "Prack von Asch, Paul (1545\u2013\u00a0\u00a0\u00a0\u00a0), Panetier",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17558",
        "NAME": "Boyde, Jeremias (1530\u20131587), Hofquartiermeister",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1587 Feb 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "17559",
        "NAME": "Teufel von Guntersdorf, Rudolf (1570\u20131643)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Guntersdorf im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17560",
        "NAME": "Kittlitz, Balthasar (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schweinitz in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17561",
        "NAME": "Colaus genannt Watzler, Georg (1500\u20131556), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1556 Okt 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Starkenberg in Tirol"
    },
    {
        "ID": "17562",
        "NAME": "Colaus genannt Watzler, Georg (1535\u20131595), K\u00e4mmerer",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1595 Apr 28",
        "PLACEOFBIRTH": "Starkenberg in Tirol",
        "PLACEOFDEATH": "Pettau:Georgskirche"
    },
    {
        "ID": "17563",
        "NAME": "Colaus genannt Watzler, Ferdinand (1540\u2013\u00a0\u00a0\u00a0\u00a0), Oberstfalkenmeister",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Starkenberg in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17564",
        "NAME": "Colaus genannt Watzler, Sidonia (1537\u20131573)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1573 Aug 19",
        "PLACEOFBIRTH": "Starkenberg in Tirol",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "17565",
        "NAME": "Liechtenstein von Murau, Konrad (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17566",
        "NAME": "Liechtenstein von Murau, Elisabeth (1591\u20131657)",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1657 Dez 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "N\u00fcrnberg:Johanniskirche"
    },
    {
        "ID": "17567",
        "NAME": "Minckwitz, Kaspar (1482\u20131537)",
        "DATEOFBIRTH": "1482",
        "DATEOFDEATH": "1537",
        "PLACEOFBIRTH": "Drehna in der Lausitz",
        "PLACEOFDEATH": "Frohburg in Sachsen"
    },
    {
        "ID": "17568",
        "NAME": "Minckwitz, Kaspar (1511\u20131569)",
        "DATEOFBIRTH": "1511",
        "DATEOFDEATH": "1569 Mai 22",
        "PLACEOFBIRTH": "Drehna in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17569",
        "NAME": "Minckwitz, Kaspar (1545\u20131586), Hofkammerrat",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1586 Nov 02",
        "PLACEOFBIRTH": "Spremberg in der Lausitz",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17570",
        "NAME": "Minckwitz, Ehrenfried (1550\u20131613), Reichshofrat",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "Drehna in der Lausitz",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17571",
        "NAME": "Trczka von Leipa, Jaroslaus (1530\u20131588)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1588 Jun 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17572",
        "NAME": "Trczka von Leipa, Wilhelm (1560\u20131597)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wei\u00dfenburg in Serbien"
    },
    {
        "ID": "17573",
        "NAME": "Trczka von Leipa, Jaroslaus (1565\u20131601)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1601 Okt 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17574",
        "NAME": "Landau, Luzi (1541\u20131597), Hofdiener",
        "DATEOFBIRTH": "1541 Aug 30",
        "DATEOFDEATH": "1597 Jan 19",
        "PLACEOFBIRTH": "Haus im M\u00fchlviertel",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "17575",
        "NAME": "Croy, Karl Philipp (1549\u20131613)",
        "DATEOFBIRTH": "1549 Sep 01",
        "DATEOFDEATH": "1613 Nov 25",
        "PLACEOFBIRTH": "Br\u00fcssel",
        "PLACEOFDEATH": "Finstingen"
    },
    {
        "ID": "17576",
        "NAME": "Croy, Karl Alexander (1581\u20131624), K\u00e4mmerer",
        "DATEOFBIRTH": "1581 Mar 11",
        "DATEOFDEATH": "1624 Nov 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Br\u00fcssel:Kapellenkirche"
    },
    {
        "ID": "17577",
        "NAME": "Croy, Ernst (1583\u20131620)",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1620 Okt 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Oppenheim am Rhein"
    },
    {
        "ID": "17578",
        "NAME": "Croy, Ernst Bosel (1620\u20131684), Bischof von Cammin",
        "DATEOFBIRTH": "1620 Aug 26",
        "DATEOFDEATH": "1684 Feb 07",
        "PLACEOFBIRTH": "Finstingen",
        "PLACEOFDEATH": "K\u00f6nigsberg in Preu\u00dfen"
    },
    {
        "ID": "17579",
        "NAME": "Croy, Christina (1591\u20131664)",
        "DATEOFBIRTH": "1591",
        "DATEOFDEATH": "1664 Jan 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neuviller an der Mosel"
    },
    {
        "ID": "17580",
        "NAME": "Desfours, Ludwig (1543\u20131613)",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "Athienville",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17581",
        "NAME": "Desfours, Johann (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Athienville",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17582",
        "NAME": "Desfours, Johann Jakob (1610\u20131643)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1643 Jun 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17583",
        "NAME": "Thurn, Anna (1540\u20131597)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1597 Aug 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17584",
        "NAME": "Thurn, Ludwika (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Thybein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17585",
        "NAME": "Donat, Heinrich (1535\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pohlom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17586",
        "NAME": "Donat, Melchior (1565\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pohlom",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17587",
        "NAME": "Redern, Sebastian (1553\u20131579), Truchsess",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17588",
        "NAME": "Thannhausen, Christoph (1520\u20131565), Landeshauptmann von K\u00e4rnten",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1565 Mar 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17589",
        "NAME": "Fugger, Bonaventura (1619\u20131693)",
        "DATEOFBIRTH": "1619 Jan 30",
        "DATEOFDEATH": "1693 Dez 13",
        "PLACEOFBIRTH": "Mattsies",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "17590",
        "NAME": "Fugger, Paul (1637\u20131701), Reichshofrat",
        "DATEOFBIRTH": "1637 Okt 13",
        "DATEOFDEATH": "1701 Apr 27",
        "PLACEOFBIRTH": "Mattsies",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "17591",
        "NAME": "Grei\u00df zum Wald, Wilhelm (1460\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17592",
        "NAME": "Grei\u00df zum Wald, Wilhelm (1490\u20131533), Oberstj\u00e4germeister",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1533 Nov 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pyhra im Mostviertel:Pfarrkirche"
    },
    {
        "ID": "17593",
        "NAME": "Grei\u00df zum Wald, Johann (1520\u20131557)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1557",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": "Gm\u00fcnd im Waldviertel"
    },
    {
        "ID": "17594",
        "NAME": "Grei\u00df zum Wald, Christoph (1525\u20131576)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1576 Feb 19",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": "Sitzenberg"
    },
    {
        "ID": "17595",
        "NAME": "Grei\u00df zum Wald, Christoph (1563\u20131617)",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "1617 Nov 19",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": "Pyhra im Mostviertel:Pfarrkirche"
    },
    {
        "ID": "17596",
        "NAME": "Grei\u00df zum Wald, Johann Siegmund (1565\u20131598), Vorschneider",
        "DATEOFBIRTH": "1565",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17597",
        "NAME": "Grei\u00df zum Wald, Johann Jakob (1553\u20131592)",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1592 Jun 29",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": "Pyhra im Mostviertel:Pfarrkirche"
    },
    {
        "ID": "17598",
        "NAME": "Grei\u00df zum Wald, Sebastian (1564\u20131623), Mundschenk",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17599",
        "NAME": "Grei\u00df zum Wald, Johann Rudolf (1600\u20131659)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1659",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17601",
        "NAME": "Hohenfeld, Ludwig (1576\u20131644)",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1644 Okt 06",
        "PLACEOFBIRTH": "Aistersheim",
        "PLACEOFDEATH": "Esslingen am Neckar"
    },
    {
        "ID": "17602",
        "NAME": "Hohenfeld, Achaz (1610\u20131672), Reichspfennigmeister",
        "DATEOFBIRTH": "1610",
        "DATEOFDEATH": "1672 Dez 03",
        "PLACEOFBIRTH": "Aistersheim",
        "PLACEOFDEATH": "Camberg im Taunus"
    },
    {
        "ID": "17603",
        "NAME": "Hohenfeld, Wilhelm Lothar (1651\u20131710), Reichspfennigmeister",
        "DATEOFBIRTH": "1651",
        "DATEOFDEATH": "1710",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17604",
        "NAME": "Hohenfeld, Otto Heinrich (1645\u20131719), K\u00e4mmerer",
        "DATEOFBIRTH": "1645",
        "DATEOFDEATH": "1719 Feb 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17605",
        "NAME": "Hohenfeld, Otto Ferdinand (1648\u20131713), K\u00e4mmerer",
        "DATEOFBIRTH": "1648",
        "DATEOFDEATH": "1713 Mar 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17606",
        "NAME": "Betta, Johann (1500\u20131565), Bischof von Triest",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1565 Apr 24",
        "PLACEOFBIRTH": "Rovereid",
        "PLACEOFDEATH": "Triest"
    },
    {
        "ID": "17607",
        "NAME": "Schleinitz, Theoderich (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schleinitz in Sachsen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17608",
        "NAME": "Zierotin, Bernhard (1530\u20131602), Mundschenk",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "Stra\u00dfnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17609",
        "NAME": "Zierotin, Johann Wilhelm (1570\u20131608)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17610",
        "NAME": "Piastowicz, Helena (1547\u20131583)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1583 Apr 06",
        "PLACEOFBIRTH": "Liegnitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17611",
        "NAME": "Kurzbach, Siegmund (1450\u20131513)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1513 Sep 29",
        "PLACEOFBIRTH": "Witkowo",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "17612",
        "NAME": "Kurzbach, Johann (1480\u20131549)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1549 Mai 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Militsch"
    },
    {
        "ID": "17613",
        "NAME": "Kurzbach, Siegmund (1547\u20131579), Truchsess",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1579 Dez 31",
        "PLACEOFBIRTH": "Militsch",
        "PLACEOFDEATH": "Lingen an der Ems"
    },
    {
        "ID": "17614",
        "NAME": "Kurzbach, Heinrich (1490\u20131533)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1533 Jun 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "17615",
        "NAME": "Kurzbach, Heinrich (1530\u20131590), Oberstm\u00fcnzmeister in B\u00f6hmen",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1590 Jun 22",
        "PLACEOFBIRTH": "Trachenberg in Schlesien",
        "PLACEOFDEATH": "Militsch"
    },
    {
        "ID": "17616",
        "NAME": "Kurzbach, Wilhelm (1525\u20131567)",
        "DATEOFBIRTH": "1525 Sep 15",
        "DATEOFDEATH": "1567 Feb 01",
        "PLACEOFBIRTH": "Trachenberg in Schlesien",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "17617",
        "NAME": "Kurzbach, Heinrich (1555\u20131618), Truchsess",
        "DATEOFBIRTH": "1555 Mar 20",
        "DATEOFDEATH": "1618 Mar 22",
        "PLACEOFBIRTH": "Trachenberg in Schlesien",
        "PLACEOFDEATH": "Prausnitz"
    },
    {
        "ID": "17618",
        "NAME": "Kurzbach, Sophia (1572\u20131605)",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17619",
        "NAME": "Kurzbach, Andreas (1620\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Lissa in Posen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17620",
        "NAME": "Schwanberg, Ignaz (1450\u20131489)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1489 Jul 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17621",
        "NAME": "Schwanberg, Johann (1480\u20131533)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1533",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Haid im B\u00f6hmerwald"
    },
    {
        "ID": "17622",
        "NAME": "Schwanberg, Johann Erasam (1524\u20131580), Oberstm\u00fcnzmeister in B\u00f6hmen",
        "DATEOFBIRTH": "1524 Nov 24",
        "DATEOFDEATH": "1580 Mai 10",
        "PLACEOFBIRTH": "Haid im B\u00f6hmerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17623",
        "NAME": "Schwanberg, Peter (1520\u20131575)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1575 Jun 24",
        "PLACEOFBIRTH": "Haid im B\u00f6hmerwald",
        "PLACEOFDEATH": "Ronsperg im B\u00f6hmerwald"
    },
    {
        "ID": "17624",
        "NAME": "Schwanberg, Johann Georg (1548\u20131617)",
        "DATEOFBIRTH": "1548 Aug 30",
        "DATEOFDEATH": "1617 Apr 15",
        "PLACEOFBIRTH": "Ronsperg im B\u00f6hmerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17625",
        "NAME": "Schwanberg, Peter (1580\u20131620)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1620 Mai 24",
        "PLACEOFBIRTH": "Ronsperg im B\u00f6hmerwald",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17626",
        "NAME": "Schwanberg, Adam (1595\u20131664)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1664 Dez 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17627",
        "NAME": "Schwanberg, Bartlome (1523\u20131560)",
        "DATEOFBIRTH": "1523 Jul 14",
        "DATEOFDEATH": "1560",
        "PLACEOFBIRTH": "Haid im B\u00f6hmerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17628",
        "NAME": "Schwanberg, Johann Wilhelm (1555\u20131590)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17629",
        "NAME": "Schwanberg, Georg Ehrenreich (1580\u20131614)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1614",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17630",
        "NAME": "Schwanberg, Johann Wilhelm (1605\u20131651)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1651 Jun 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "P\u00edsek an der Otava:Dominikanerkloster"
    },
    {
        "ID": "17631",
        "NAME": "Barbitz von Fernemont, Maria Lamberta (1635\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Fernelmont",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17632",
        "NAME": "Kochtizky, Juliana (1605\u20131664)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "Lublinitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17633",
        "NAME": "Proskau, Anna Maria (1630\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17634",
        "NAME": "Tschernembl, Regina (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schwertberg im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17635",
        "NAME": "Lang von Wellenburg, Elisabeth (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17636",
        "NAME": "Schwarzenberg, Anna (1430\u20131459)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1459",
        "PLACEOFBIRTH": "Seinsheim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17637",
        "NAME": "Drugeth von Homonna, Maria (1590\u20131643)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Homenau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17638",
        "NAME": "Harrach, Agnes (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17639",
        "NAME": "Sternberg, Dorothea (1570\u20131633)",
        "DATEOFBIRTH": "1570",
        "DATEOFDEATH": "1633 Jun 12",
        "PLACEOFBIRTH": "Sternberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17640",
        "NAME": "Piastowicz, Johanna Elisabeth (1634\u20131673)",
        "DATEOFBIRTH": "1634 Jun 08",
        "DATEOFDEATH": "1673 Okt 30",
        "PLACEOFBIRTH": "Thorn an der Weichsel",
        "PLACEOFDEATH": "Schwentnig im Eulengebirge"
    },
    {
        "ID": "17641",
        "NAME": "Schober von Tachenstein, Georg (1470\u20131547)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1547 Mar 19",
        "PLACEOFBIRTH": "Ingolstadt",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "17642",
        "NAME": "Schober von Tachenstein, Kaspar (1504\u20131532)",
        "DATEOFBIRTH": "1504",
        "DATEOFDEATH": "1532 Nov 20",
        "PLACEOFBIRTH": "Ingolstadt",
        "PLACEOFDEATH": "Speyer:Dom"
    },
    {
        "ID": "17643",
        "NAME": "Schober von Tachenstein, Thomas (1518\u20131572), Reichshofrat",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1572 Mar 26",
        "PLACEOFBIRTH": "Ingolstadt",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17644",
        "NAME": "Schober von Tachenstein, Anna (1498\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1498",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ingolstadt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17645",
        "NAME": "Schober von Tachenstein, Margarita (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17646",
        "NAME": "Schwarz, Stephan (1510\u20131575), Reichshofrat",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1575",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17647",
        "NAME": "Fr\u00f6schel, Benedikt (1480\u20131547)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1547 Apr 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "17648",
        "NAME": "Fr\u00f6schel, Benedikt (1517\u20131574)",
        "DATEOFBIRTH": "1517",
        "DATEOFDEATH": "1574 Jan 19",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "17649",
        "NAME": "Fr\u00f6schel, Hieronym (1527\u20131602)",
        "DATEOFBIRTH": "1527 Sep 15",
        "DATEOFDEATH": "1602 Nov 28",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "17650",
        "NAME": "Fr\u00f6schel, Daniel (1563\u20131613), Hofantiquar",
        "DATEOFBIRTH": "1563 Mai 07",
        "DATEOFDEATH": "1613 Okt 15",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17651",
        "NAME": "Rehlinger, Barbara (1515\u20131593)",
        "DATEOFBIRTH": "1515 Mar 07",
        "DATEOFDEATH": "1593",
        "PLACEOFBIRTH": "Horgau an der Roth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17652",
        "NAME": "T\u00e4nzl von Trazberg, Anna Maria (1580\u20131629)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wildungsmauer"
    },
    {
        "ID": "17653",
        "NAME": "Herberstein, Anna (1540\u20131576)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1576 Nov 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "H\u00f6pfigheim an der Murr:Georgskirche"
    },
    {
        "ID": "17654",
        "NAME": "Kittlitz, Sabina (1576\u20131610)",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1610 Aug 16",
        "PLACEOFBIRTH": "Schweinitz in Schlesien",
        "PLACEOFDEATH": "Logau in Schlesien"
    },
    {
        "ID": "17655",
        "NAME": "Galler von Schwanberg, Justina (1605\u20131675)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1675",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17656",
        "NAME": "Gienger, Magdalena (1529\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gr\u00fcnbichl im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17657",
        "NAME": "Gienger, Konstantia (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gr\u00fcnbichl im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17658",
        "NAME": "Gienger, Katharina (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gr\u00fcnbichl im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17659",
        "NAME": "Gienger, Ursula (1538\u20131575)",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1575~",
        "PLACEOFBIRTH": "Gr\u00fcnbichl im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17660",
        "NAME": "Harrach, Susanna (1558\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rohrau an der Leitha",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17661",
        "NAME": "Villinger von Sch\u00f6nenberg, Eleonora (1540\u20131603)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17662",
        "NAME": "Scala, Maria (1576\u20131617)",
        "DATEOFBIRTH": "1576 Jul 16",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "Amerang im Chiemgau",
        "PLACEOFDEATH": "Planegg an der W\u00fcrm"
    },
    {
        "ID": "17663",
        "NAME": "Pernstein, Maria (1523\u20131566)",
        "DATEOFBIRTH": "1523",
        "DATEOFDEATH": "1566 Nov 19",
        "PLACEOFBIRTH": "Kromau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17664",
        "NAME": "Herberstein, Maria Sidonia (1630\u20131701)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1701",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Klagenfurt am W\u00f6rthersee"
    },
    {
        "ID": "17665",
        "NAME": "L\u00f6wenstein, Amalia (1659\u20131701)",
        "DATEOFBIRTH": "1659 Jan 19",
        "DATEOFDEATH": "1701 Feb 05",
        "PLACEOFBIRTH": "Wertheim am Main",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17666",
        "NAME": "Starhemberg, Eva Regina (1599\u20131663)",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1663 Sep 24",
        "PLACEOFBIRTH": "Eferding",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "17667",
        "NAME": "Geymann, Anna Maria (1590\u20131621)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1621 Dez 27",
        "PLACEOFBIRTH": "Gallspach im Hausruckviertel",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "17668",
        "NAME": "Fugger, Konstantia (1568\u20131594)",
        "DATEOFBIRTH": "1568 Jul 02",
        "DATEOFDEATH": "1594 Mar 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17669",
        "NAME": "Herberstein, Maria Renata (1589\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1589 Mai 29",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17670",
        "NAME": "P\u00fcckler, Niklas (1480\u20131543)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17671",
        "NAME": "P\u00fcckler, Kaspar (1515\u20131584), Oberstfalkenmeister",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1584 Jun 04",
        "PLACEOFBIRTH": "Groditz",
        "PLACEOFDEATH": "Falkenberg in Oberschlesien"
    },
    {
        "ID": "17672",
        "NAME": "P\u00fcckler, Balthasar (1543\u20131591), Truchsess",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1591 Aug 14",
        "PLACEOFBIRTH": "Schedlau",
        "PLACEOFDEATH": "Falkenberg in Oberschlesien"
    },
    {
        "ID": "17673",
        "NAME": "P\u00fcckler, Niklas (1550\u20131579), Vorschneider",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "Schedlau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17674",
        "NAME": "Nechern, Siegfried (1470\u2013\u00a0\u00a0\u00a0\u00a0), Landeshauptmann von Sagan",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kunzendorf in der Niederlausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17675",
        "NAME": "Nechern, Siegfried (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kunzendorf in der Niederlausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17676",
        "NAME": "Nechern, Franz (1510\u2013\u00a0\u00a0\u00a0\u00a0), Landeshauptmann von Sagan",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kunzendorf in der Niederlausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17677",
        "NAME": "Nechern, Gravis (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kunzendorf in der Niederlausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17678",
        "NAME": "Nechern, Gravis (1575\u2013\u00a0\u00a0\u00a0\u00a0), Landeshauptmann von Sagan",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Koppitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17679",
        "NAME": "Nechern, Polyxena (1560\u20131609)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17680",
        "NAME": "Piastowicz, Konrad (1448\u20131503), Herzog von Masowien",
        "DATEOFBIRTH": "1448",
        "DATEOFDEATH": "1503 Okt 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Osieck in Masowien"
    },
    {
        "ID": "17681",
        "NAME": "Rogendorf, Wilhelm (1509\u20131543)",
        "DATEOFBIRTH": "1509 Aug 18",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17682",
        "NAME": "Rogendorf, Johann Wilhelm (1535\u20131590), Geheimer Rat",
        "DATEOFBIRTH": "1535 Jul 04",
        "DATEOFDEATH": "1590 Sep 23",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": "Baden am Gebirge"
    },
    {
        "ID": "17683",
        "NAME": "Rogendorf, Johann Hermann (1571\u20131612), K\u00e4mmerer",
        "DATEOFBIRTH": "1571",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17684",
        "NAME": "Khuen von Belasi, Magdalena (1530\u20131572)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1572 Jul 17",
        "PLACEOFBIRTH": "Lichtenberg im Pinzgau",
        "PLACEOFDEATH": "Sitzenberg"
    },
    {
        "ID": "17685",
        "NAME": "Zimmern, Apollonia (1547\u20131604)",
        "DATEOFBIRTH": "1547 Mar 04",
        "DATEOFDEATH": "1604 Jul 31",
        "PLACEOFBIRTH": "Wildenstein im Donautal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17686",
        "NAME": "Ursenbeck, Katharina (1555\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17687",
        "NAME": "Lobkowicz, Katharina (1566\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17688",
        "NAME": "Khuen von Belasi, Anna (1580\u20131628)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "Lichtenberg im Pinzgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17689",
        "NAME": "Sapieha, Anna (1600\u20131627)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1627 Jun 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neswisch"
    },
    {
        "ID": "17690",
        "NAME": "Dieskau, Margarita (1580\u20131641)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1641 Aug 04",
        "PLACEOFBIRTH": "Finsterwalde in der Lausitz",
        "PLACEOFDEATH": "Kamenz in der Lausitz"
    },
    {
        "ID": "17691",
        "NAME": "Minckwitz, Anna (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Drehna in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17692",
        "NAME": "Trauttmansdorff, Anna (1580\u20131642)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Trautmannsdorf in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17693",
        "NAME": "Hohenzollern, Ursula (1607\u20131667)",
        "DATEOFBIRTH": "1607 Feb 16",
        "DATEOFDEATH": "1667 Dez 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17694",
        "NAME": "Sternberg, Maria (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Beneschau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17695",
        "NAME": "Capliers, Anna (1555\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17696",
        "NAME": "Wrzesowitz, Sabina (1595\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17697",
        "NAME": "Lobkowicz, Margarita Katharina (1612\u20131669)",
        "DATEOFBIRTH": "1612 Mai 11",
        "DATEOFDEATH": "1669 Okt 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17698",
        "NAME": "L\u00f6bl von Greinburg, Susanna Katharina (1620\u20131666)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1666 Feb 04",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "17699",
        "NAME": "Ungnad von Weissenwolff, Anna (1573\u20131605)",
        "DATEOFBIRTH": "1573 Mar 29",
        "DATEOFDEATH": "1605 Aug 08",
        "PLACEOFBIRTH": "Waldenstein im Lavanttal",
        "PLACEOFDEATH": "Bernsdorf im Vogtland"
    },
    {
        "ID": "17701",
        "NAME": "Smirzicz, Siegmund (1480\u20131548)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1548",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17702",
        "NAME": "Smirzicz, Albrecht (1528\u20131566)",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1566 Dez 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "N\u00e1chod"
    },
    {
        "ID": "17703",
        "NAME": "Smirzicz, Margarita (1557\u20131593)",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1593 Jul 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hermanitz an der Elbe"
    },
    {
        "ID": "17704",
        "NAME": "Smirzicz, Salomena (1560\u20131620)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1620~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17705",
        "NAME": "Smirzicz, Heinrich (1530\u20131569)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17706",
        "NAME": "Smirzicz, Siegmund (1558\u20131608), Mundschenk",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1608 Mai 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17707",
        "NAME": "Smirzicz, Wenzel (1564\u20131593)",
        "DATEOFBIRTH": "1564",
        "DATEOFDEATH": "1593 Aug 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "N\u00e1chod"
    },
    {
        "ID": "17708",
        "NAME": "Bollweiler, Niklas (1525\u20131588)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1588 Mar 18",
        "PLACEOFBIRTH": "Bollwiller im Elsass",
        "PLACEOFDEATH": "Hagenau"
    },
    {
        "ID": "17709",
        "NAME": "Bollweiler, Rudolf (1555\u20131616)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1616 Mai 16",
        "PLACEOFBIRTH": "Bollwiller im Elsass",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17710",
        "NAME": "Bollweiler, Margarita (1595\u20131658)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1658 Apr 23",
        "PLACEOFBIRTH": "Bollwiller im Elsass",
        "PLACEOFDEATH": "Hilgartsberg"
    },
    {
        "ID": "17711",
        "NAME": "Lang von Wellenburg, Lauk (1470\u20131535)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1535",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17712",
        "NAME": "Lang von Wellenburg, Lauk (1515\u20131559)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1559 Mai 02",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17713",
        "NAME": "Lang von Wellenburg, Eva (1555\u20131594)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1594 Okt 02",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Horn im Waldviertel"
    },
    {
        "ID": "17714",
        "NAME": "Everstein, Georg (1481\u20131553)",
        "DATEOFBIRTH": "1481",
        "DATEOFDEATH": "1553 Feb 18",
        "PLACEOFBIRTH": "Naugard in Pommern",
        "PLACEOFDEATH": "Massow in Pommern"
    },
    {
        "ID": "17715",
        "NAME": "Everstein, Wolfgang (1538\u20131592), Mundschenk",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1592 Mar 15",
        "PLACEOFBIRTH": "Naugard in Pommern",
        "PLACEOFDEATH": "Stettin"
    },
    {
        "ID": "17716",
        "NAME": "Schellendorf, Christoph (1530\u20131583)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1583",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "K\u00f6nigsbr\u00fcck in der Lausitz"
    },
    {
        "ID": "17717",
        "NAME": "Schellendorf, Karl Mang (1562\u20131621), Truchsess",
        "DATEOFBIRTH": "1562 Jan 25",
        "DATEOFDEATH": "1621 Feb 12",
        "PLACEOFBIRTH": "K\u00f6nigsbr\u00fcck in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17718",
        "NAME": "Schellendorf, Christoph (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "K\u00f6nigsbr\u00fcck in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17719",
        "NAME": "Slavata, Albrecht (1553\u20131600)",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1600 Jan 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17720",
        "NAME": "Linsmayr von Greiffenberg, Johann Baptist (1545\u20131609), Hofkammerrat",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1609 Mar 24",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Seisenegg im Mostviertel"
    },
    {
        "ID": "17721",
        "NAME": "Linsmayr von Greiffenberg, Johann Gottfried (1575\u20131641)",
        "DATEOFBIRTH": "1575",
        "DATEOFDEATH": "1641",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Seisenegg im Mostviertel"
    },
    {
        "ID": "17722",
        "NAME": "Linsmayr von Greiffenberg, Johann Rudolf (1608\u20131675)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1675",
        "PLACEOFBIRTH": "Seisenegg im Mostviertel",
        "PLACEOFDEATH": "Steinb\u00fchl am Reichswald"
    },
    {
        "ID": "17723",
        "NAME": "Dohna, Heinrich (1230\u20131273)",
        "DATEOFBIRTH": "1230~",
        "DATEOFDEATH": "1273",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17724",
        "NAME": "Dohna, Otto (1265\u20131330)",
        "DATEOFBIRTH": "1265~",
        "DATEOFDEATH": "1330~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17725",
        "NAME": "Dohna, Johann (1300\u20131347)",
        "DATEOFBIRTH": "1300~",
        "DATEOFDEATH": "1347",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17726",
        "NAME": "Dohna, Beda (1340\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17727",
        "NAME": "Dohna, Heinrich (1375\u20131430)",
        "DATEOFBIRTH": "1375~",
        "DATEOFDEATH": "1430~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17728",
        "NAME": "Keglevich, Franz (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bu\u017eim",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17729",
        "NAME": "Wacker von Wackenfels, Johann Matthias (1550\u20131619), Reichshofrat",
        "DATEOFBIRTH": "1550 Mar 15",
        "DATEOFDEATH": "1619 Sep 07",
        "PLACEOFBIRTH": "Konstanz im Hegau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17730",
        "NAME": "Troilo, Johann Franz (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rovereid",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17731",
        "NAME": "Troilo, Niklas (1582\u20131640)",
        "DATEOFBIRTH": "1582 Jan 25",
        "DATEOFDEATH": "1640 Dez 03",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Breslau:Dom"
    },
    {
        "ID": "17732",
        "NAME": "Troilo, Franz Gottfried (1583\u20131648), Hofdiener",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1648",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17733",
        "NAME": "Berchtold, Johann Anton (1520\u20131593)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1593",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17734",
        "NAME": "Berchtold, Johann Baptist (1545\u20131588), Kammerdiener",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1588 Jun",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17735",
        "NAME": "Berchtold, Matthias (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17736",
        "NAME": "Berchtold, Maximilian (1570\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerrat",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Sachsengang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17737",
        "NAME": "Berchtold, Johann Baptist (1575\u20131629), Kammerdiener",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1629 Jun 15",
        "PLACEOFBIRTH": "Sachsengang",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "17738",
        "NAME": "Berchtold, Matthias Ernst (1632\u20131678)",
        "DATEOFBIRTH": "1632 Feb 26",
        "DATEOFDEATH": "1678 Jul 07",
        "PLACEOFBIRTH": "Ungarschitz in M\u00e4hren",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17739",
        "NAME": "Berchtold, Jakob Philipp (1634\u20131679)",
        "DATEOFBIRTH": "1634 Apr 08",
        "DATEOFDEATH": "1679",
        "PLACEOFBIRTH": "Ungarschitz in M\u00e4hren",
        "PLACEOFDEATH": "Merklin"
    },
    {
        "ID": "17740",
        "NAME": "Dohna, Otto (1190\u20131239)",
        "DATEOFBIRTH": "1190~",
        "DATEOFDEATH": "1239",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17741",
        "NAME": "Dohna, Otto (1220\u20131287)",
        "DATEOFBIRTH": "1220~",
        "DATEOFDEATH": "1287 Apr 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17742",
        "NAME": "Dohna, Otto (1260\u20131321)",
        "DATEOFBIRTH": "1260~",
        "DATEOFDEATH": "1321 Dez 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17743",
        "NAME": "Dohna, Otto (1290\u20131336)",
        "DATEOFBIRTH": "1290~",
        "DATEOFDEATH": "1336",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17744",
        "NAME": "Dohna, Otto (1320\u20131385)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "1385",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17745",
        "NAME": "Dohna, Johann (1350\u20131403)",
        "DATEOFBIRTH": "1350~",
        "DATEOFDEATH": "1403",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "17746",
        "NAME": "Dohna, Johann (1380\u20131423)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1423",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Mei\u00dfen"
    },
    {
        "ID": "17747",
        "NAME": "Dohna, Friedrich (1410\u20131457)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1457",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17748",
        "NAME": "Dohna, Johann (1450\u20131516)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1516",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17749",
        "NAME": "Dohna, Friedrich (1482\u20131547)",
        "DATEOFBIRTH": "1482",
        "DATEOFDEATH": "1547 Sep",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17750",
        "NAME": "Neuhaus von Greifenfels, Siegmund (1450\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17751",
        "NAME": "Neuhaus von Greifenfels, Wolfgang (1502\u20131561)",
        "DATEOFBIRTH": "1502",
        "DATEOFDEATH": "1561",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17752",
        "NAME": "Neuhaus von Greifenfels, Georg (1480\u20131542)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1542 Jul 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17753",
        "NAME": "Neuhaus von Greifenfels, Johann (1505\u20131586)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17754",
        "NAME": "Neuhaus von Greifenfels, Christoph (1530\u20131574)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1574",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17755",
        "NAME": "Neuhaus von Greifenfels, Franz (1536\u20131596)",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1596",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17756",
        "NAME": "Neuhaus von Greifenfels, Wilhelm (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17757",
        "NAME": "Neuhaus von Greifenfels, Andreas (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17758",
        "NAME": "Neuhaus von Greifenfels, Georg Siegmund (1534\u20131600)",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1600 Jan 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Gurnitz"
    },
    {
        "ID": "17759",
        "NAME": "Neuhaus von Greifenfels, Katharina (1582\u20131626)",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1626 Dez 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Klagenfurt am W\u00f6rthersee"
    },
    {
        "ID": "17760",
        "NAME": "K\u00e4mmerer von Worms genannt Dalberg, Wolfgang Friedrich (1563\u20131621)",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "1621 Jan 09",
        "PLACEOFBIRTH": "Worms",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17761",
        "NAME": "Eitzing, Christina (1515\u20131582)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1582 Dez 20",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": "Spielberg an der Donau"
    },
    {
        "ID": "17762",
        "NAME": "Scherffenberg, Margarita (1535\u20131552)",
        "DATEOFBIRTH": "1535",
        "DATEOFDEATH": "1552 Okt 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Zeillern"
    },
    {
        "ID": "17763",
        "NAME": "Tschernembl, Barbara (1535\u20131588)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1588 Mai 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17764",
        "NAME": "Rosenberg, Eva (1537\u20131591)",
        "DATEOFBIRTH": "1537 Apr 12",
        "DATEOFDEATH": "1591 Aug 15",
        "PLACEOFBIRTH": "Krumau in B\u00f6hmen",
        "PLACEOFDEATH": "Mantova"
    },
    {
        "ID": "17765",
        "NAME": "Zr\u00ednyi, Peter (1435\u20131493)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1493 Sep 09",
        "PLACEOFBIRTH": "Zr\u00edn in Slawonien",
        "PLACEOFDEATH": "Udbina in der Lika"
    },
    {
        "ID": "17766",
        "NAME": "Zr\u00ednyi, Helena (1485\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Zr\u00edn in Slawonien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17767",
        "NAME": "Frangipane di Veglia, Dorothea (1455\u20131508)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1508",
        "PLACEOFBIRTH": "Tersat am Flaum",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17768",
        "NAME": "Torquato di Corbavia, Johann (1478\u20131531), Ban von Kroatien",
        "DATEOFBIRTH": "1478",
        "DATEOFDEATH": "1531 Aug 09",
        "PLACEOFBIRTH": "Udbina in der Lika",
        "PLACEOFDEATH": "Medvedgrad"
    },
    {
        "ID": "17769",
        "NAME": "Torquato di Corbavia, Klara (1490\u20131541)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1541 Okt 28",
        "PLACEOFBIRTH": "Udbina in der Lika",
        "PLACEOFDEATH": "Zeillern"
    },
    {
        "ID": "17770",
        "NAME": "Kuzal von Lappitz, Andreas (1435\u20131506)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1506",
        "PLACEOFBIRTH": "Udbina in der Lika",
        "PLACEOFDEATH": "Amstetten im Mostviertel"
    },
    {
        "ID": "17771",
        "NAME": "Kuzal von Lappitz, Johann Baptist (1480\u20131536)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1536 Jan 06",
        "PLACEOFBIRTH": "Steyr",
        "PLACEOFDEATH": "Zeillern"
    },
    {
        "ID": "17772",
        "NAME": "Kuzal von Lappitz, Amalia (1519\u20131577)",
        "DATEOFBIRTH": "1519",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "Seisenegg im Mostviertel",
        "PLACEOFDEATH": "Totzenbach am Haspelwald"
    },
    {
        "ID": "17773",
        "NAME": "Kuzal von Lappitz, Kornel (1523\u20131567)",
        "DATEOFBIRTH": "1523",
        "DATEOFDEATH": "1567 Okt 22",
        "PLACEOFBIRTH": "Seisenegg im Mostviertel",
        "PLACEOFDEATH": "Zeillern"
    },
    {
        "ID": "17774",
        "NAME": "Kuzal von Lappitz, Katharina (1520\u20131569)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1569 Nov 08",
        "PLACEOFBIRTH": "Seisenegg im Mostviertel",
        "PLACEOFDEATH": "Albrechtsberg an der Gro\u00dfen Krems"
    },
    {
        "ID": "17775",
        "NAME": "Kuzal von Lappitz, Susanna (1522\u20131564)",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "1564 Aug 24",
        "PLACEOFBIRTH": "Seisenegg im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17776",
        "NAME": "Kuzal von Lappitz, Anna (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Seisenegg im Mostviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17777",
        "NAME": "Kuzal von Lappitz, Christina (1551\u20131600)",
        "DATEOFBIRTH": "1551 Jan 05",
        "DATEOFDEATH": "1600",
        "PLACEOFBIRTH": "Zeillern",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17778",
        "NAME": "Kuzal von Lappitz, Margarita (1560\u20131614)",
        "DATEOFBIRTH": "1560 Dez 27",
        "DATEOFDEATH": "1614 Feb 03",
        "PLACEOFBIRTH": "Zeillern",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17779",
        "NAME": "Kuzal von Lappitz, Elisabeth (1485\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Steyr",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17780",
        "NAME": "Kuzal von Lappitz, Ulrich (1490\u20131550)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1550~",
        "PLACEOFBIRTH": "Steyr",
        "PLACEOFDEATH": "Seisenegg im Mostviertel"
    },
    {
        "ID": "17781",
        "NAME": "Praschma von Bilkau, Niklas (1505\u20131555)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1555",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17782",
        "NAME": "Praschma von Bilkau, Bernhard (1540\u20131600), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1600~",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17783",
        "NAME": "Praschma von Bilkau, Benedikt (1545\u20131582)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1582",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17784",
        "NAME": "Praschma von Bilkau, Schebor (1577\u20131623)",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "Bilkau in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17785",
        "NAME": "Volkra, Wolfgang (1480\u20131531), Obersthofmarschall",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1531 Aug 11",
        "PLACEOFBIRTH": "Dornach im Feistritztal",
        "PLACEOFDEATH": "Budweis in B\u00f6hmen"
    },
    {
        "ID": "17786",
        "NAME": "Volkra, Andreas (1520\u20131562)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1562 Mar 14",
        "PLACEOFBIRTH": "Steinabrunn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17787",
        "NAME": "Volkra, Joachim (1515\u20131559)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1559",
        "PLACEOFBIRTH": "Steinabrunn",
        "PLACEOFDEATH": "Leiben im Weitental"
    },
    {
        "ID": "17788",
        "NAME": "Volkra, Christina (1547\u20131590)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1590",
        "PLACEOFBIRTH": "Steinabrunn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17789",
        "NAME": "Volkra, Susanna (1551\u20131613)",
        "DATEOFBIRTH": "1551",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "Steinabrunn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17790",
        "NAME": "Dohna, Boris (1520\u20131571), Hofdiener",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17791",
        "NAME": "Dohna, Magdalena (1560\u20131603)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1603 Jun 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "\u010castolovice"
    },
    {
        "ID": "17792",
        "NAME": "Troilo, Katharina (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17793",
        "NAME": "Rogendorf, Klara (1537\u20131582)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1582",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17794",
        "NAME": "Rabenhaupt, Ernst (1570\u20131627)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Lichtenburg im Eisengebirge",
        "PLACEOFDEATH": "Ronow an der Daubrawa"
    },
    {
        "ID": "17795",
        "NAME": "Rabenhaupt, Magdalena (1600\u20131644)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1644 Mar 23",
        "PLACEOFBIRTH": "Ronow an der Daubrawa",
        "PLACEOFDEATH": "\u010castolovice"
    },
    {
        "ID": "17796",
        "NAME": "Gienger, Bartlome (1522\u2013\u00a0\u00a0\u00a0\u00a0), Oberstfalkenmeister",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Langenau an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17797",
        "NAME": "Gienger, Johann Georg (1561\u20131592), Truchsess",
        "DATEOFBIRTH": "1561 Apr 19",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17798",
        "NAME": "Gienger, Johann Adam (1558\u20131623)",
        "DATEOFBIRTH": "1558 Nov 19",
        "DATEOFDEATH": "1623 Apr 03",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": "Wolfsegg am Hausruck"
    },
    {
        "ID": "17799",
        "NAME": "Linsmayr von Greiffenberg, Katharina Regina (1633\u20131694)",
        "DATEOFBIRTH": "1633 Sep 07",
        "DATEOFDEATH": "1694 Apr 18",
        "PLACEOFBIRTH": "Seisenegg im Mostviertel",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "17801",
        "NAME": "Haidenreich von Bidenegg, Erasam (1500\u20131579), Hofkammerrat",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "Bideneck in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17802",
        "NAME": "Haidenreich von Bidenegg, Katharina (1535\u20131582)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1582 Apr 05",
        "PLACEOFBIRTH": "Bideneck in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17803",
        "NAME": "Haidenreich von Bidenegg, Elias (1540\u2013\u00a0\u00a0\u00a0\u00a0), Panetier",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bideneck in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17804",
        "NAME": "Waletzky von Mirow, Georg (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mi\u00dflitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17805",
        "NAME": "Truchsess von Wetzhausen, Johann (1566\u20131635)",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "1635 Okt 31",
        "PLACEOFBIRTH": "K\u00f6nigsberg in Preu\u00dfen",
        "PLACEOFDEATH": "K\u00f6nigsberg in Preu\u00dfen"
    },
    {
        "ID": "17806",
        "NAME": "Truchsess von Wetzhausen, Johann Anselm (1605\u20131647), K\u00e4mmerer",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1647",
        "PLACEOFBIRTH": "K\u00f6nigsberg in Preu\u00dfen",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "17807",
        "NAME": "Truchsess von Wetzhausen, Wilhelm (1611\u20131647)",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1647",
        "PLACEOFBIRTH": "K\u00f6nigsberg in Preu\u00dfen",
        "PLACEOFDEATH": "Krakau"
    },
    {
        "ID": "17808",
        "NAME": "Waldstein, Christoph (1525\u20131576)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17809",
        "NAME": "Waldstein, Johann Albrecht (1575\u20131618), Vorschneider",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17810",
        "NAME": "B\u00fcnau, Rudolf (1468\u20131543)",
        "DATEOFBIRTH": "1468",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "Weesenstein im M\u00fcglitztal",
        "PLACEOFDEATH": "Tetschen"
    },
    {
        "ID": "17811",
        "NAME": "B\u00fcnau, Gundaker (1520\u20131576), Hofdiener",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1576 Nov 17",
        "PLACEOFBIRTH": "Weesenstein im M\u00fcglitztal",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "17812",
        "NAME": "B\u00fcnau, Gundaker (1557\u20131619)",
        "DATEOFBIRTH": "1557 Okt 09",
        "DATEOFDEATH": "1619 Mai 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lauenstein im M\u00fcglitztal"
    },
    {
        "ID": "17813",
        "NAME": "B\u00fcnau, Rudolf (1509\u20131549)",
        "DATEOFBIRTH": "1509",
        "DATEOFDEATH": "1549",
        "PLACEOFBIRTH": "Weesenstein im M\u00fcglitztal",
        "PLACEOFDEATH": "Tetschen"
    },
    {
        "ID": "17814",
        "NAME": "B\u00fcnau, Rudolf (1546\u20131627)",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1627 Nov 04",
        "PLACEOFBIRTH": "Tetschen",
        "PLACEOFDEATH": "Burkhardswalde im M\u00fcglitztal"
    },
    {
        "ID": "17815",
        "NAME": "B\u00fcnau, Heinrich (1504\u20131570), Hofdiener",
        "DATEOFBIRTH": "1504",
        "DATEOFDEATH": "1570",
        "PLACEOFBIRTH": "Weesenstein im M\u00fcglitztal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17816",
        "NAME": "B\u00fcnau, Rudolf (1547\u20131622), Truchsess",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1622 Jan 29",
        "PLACEOFBIRTH": "Weesenstein im M\u00fcglitztal",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "17817",
        "NAME": "Moscon, Johann Jakob (1621\u20131661)",
        "DATEOFBIRTH": "1621",
        "DATEOFDEATH": "1661",
        "PLACEOFBIRTH": "Gurgfeld an der Save",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17818",
        "NAME": "Moscon, Jobst Joseph (1600\u20131673)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1673",
        "PLACEOFBIRTH": "Gurgfeld an der Save",
        "PLACEOFDEATH": "Rann an der Save"
    },
    {
        "ID": "17819",
        "NAME": "Moscon, Johann Baptist (1650\u20131674)",
        "DATEOFBIRTH": "1650 Feb 04",
        "DATEOFDEATH": "1674 Mai 03",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Rann an der Save"
    },
    {
        "ID": "17820",
        "NAME": "Lindegg, Anna (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Plankenstein an der Drann",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17821",
        "NAME": "Trauttmansdorff, Ulrich (1380\u20131448)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1448",
        "PLACEOFBIRTH": "Trautmannsdorf in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17822",
        "NAME": "Trauttmansdorff, Andreas (1412\u20131466)",
        "DATEOFBIRTH": "1412",
        "DATEOFDEATH": "1466",
        "PLACEOFBIRTH": "Kirchberg am Walde",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17823",
        "NAME": "Trauttmansdorff, Wolfgang (1444\u20131499)",
        "DATEOFBIRTH": "1444",
        "DATEOFDEATH": "1499",
        "PLACEOFBIRTH": "Wolkenstein in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17824",
        "NAME": "Trauttmansdorff, Sebastian (1470\u20131519)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1519",
        "PLACEOFBIRTH": "Trautmannsdorf in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17825",
        "NAME": "Trauttmansdorff, Mechthard (1505\u20131563)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1563",
        "PLACEOFBIRTH": "Trautmannsdorf in der Steiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17826",
        "NAME": "Trauttmansdorff, Christoph (1418\u20131480), Bischof von Seckau",
        "DATEOFBIRTH": "1418",
        "DATEOFDEATH": "1480 Nov 16",
        "PLACEOFBIRTH": "Kirchberg am Walde",
        "PLACEOFDEATH": "Seckau im Murtal"
    },
    {
        "ID": "17827",
        "NAME": "Trauttmansdorff, Ferdinand (1406\u20131460)",
        "DATEOFBIRTH": "1406",
        "DATEOFDEATH": "1460",
        "PLACEOFBIRTH": "Kirchberg am Walde",
        "PLACEOFDEATH": "Trautmannsdorf in der Steiermark"
    },
    {
        "ID": "17828",
        "NAME": "Trauttmansdorff, Wilhelm (1435\u20131504)",
        "DATEOFBIRTH": "1435",
        "DATEOFDEATH": "1504 Aug 28",
        "PLACEOFBIRTH": "Kirchberg am Walde",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17829",
        "NAME": "Trauttmansdorff, Andreas (1470\u20131525)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1525",
        "PLACEOFBIRTH": "Kirchberg am Walde",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "17830",
        "NAME": "Moscon, Anna Elisabeth (1632\u20131694)",
        "DATEOFBIRTH": "1632",
        "DATEOFDEATH": "1694",
        "PLACEOFBIRTH": "Gurgfeld an der Save",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17831",
        "NAME": "Trauttmansdorff, Leopold (1450\u20131510)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1510",
        "PLACEOFBIRTH": "Kirchberg am Walde",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17832",
        "NAME": "Trauttmansdorff, Niklas (1490\u20131562)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1562 Mai 15",
        "PLACEOFBIRTH": "Kirchberg am Walde",
        "PLACEOFDEATH": "Kastelalt im Suganertal"
    },
    {
        "ID": "17833",
        "NAME": "Saurau, Z\u00e4zilia (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ligist",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17834",
        "NAME": "Trauttmansdorff, Magdalena (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Totzenbach am Haspelwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17835",
        "NAME": "Trauttmansdorff, Adam Maximilian (1621\u20131670)",
        "DATEOFBIRTH": "1621 Mar 15",
        "DATEOFDEATH": "1670 Jul 11",
        "PLACEOFBIRTH": "Totzenbach am Haspelwald",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17836",
        "NAME": "Trauttmansdorff, Ferdinand Ernst (1637\u20131692), K\u00e4mmerer",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1692 Jan 24",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "17837",
        "NAME": "Trauttmansdorff, Georg Siegmund (1638\u20131708), K\u00e4mmerer",
        "DATEOFBIRTH": "1638 Aug 22",
        "DATEOFDEATH": "1708 Dez 26",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "17838",
        "NAME": "Trauttmansdorff, Siegmund Joachim (1641\u20131706), K\u00e4mmerer",
        "DATEOFBIRTH": "1641",
        "DATEOFDEATH": "1706 Apr 01",
        "PLACEOFBIRTH": "Totzenbach am Haspelwald",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "17839",
        "NAME": "Trauttmansdorff, Margarita (1460\u20131495)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1495",
        "PLACEOFBIRTH": "Kammern im Liesingtal",
        "PLACEOFDEATH": "Gallspach im Hausruckviertel"
    },
    {
        "ID": "17840",
        "NAME": "Kraft von Kraftheim, Johann (1519\u20131585), Hofarzt",
        "DATEOFBIRTH": "1519 Nov 22",
        "DATEOFDEATH": "1585 Okt 19",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "17841",
        "NAME": "Kraft von Kraftheim, Johann Baptist (1555\u20131592), Truchsess",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1592 Aug 20",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "R\u00fcckers in Schlesien"
    },
    {
        "ID": "17842",
        "NAME": "Biese, Niklas (1516\u20131573), Hofarzt",
        "DATEOFBIRTH": "1516 Mar 27",
        "DATEOFDEATH": "1573 Apr 15",
        "PLACEOFBIRTH": "Gent in Flandern",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17843",
        "NAME": "Frangipane di Veglia, Georg (1500\u20131553)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1553",
        "PLACEOFBIRTH": "Sluin",
        "PLACEOFDEATH": "Sluin:Franziskanerkirche"
    },
    {
        "ID": "17844",
        "NAME": "Frangipane di Veglia, Franz (1536\u20131572), Ban von Kroatien",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1572 Dez 02",
        "PLACEOFBIRTH": "Sluin",
        "PLACEOFDEATH": "Warasdin an der Drau"
    },
    {
        "ID": "17845",
        "NAME": "Proskau, Georg (1525\u20131584), K\u00e4mmerer",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1584 Feb 23",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17846",
        "NAME": "Proskau, Valentin (1505\u20131557)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1557 Dez 22",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": "Glogau in Oberschlesien"
    },
    {
        "ID": "17847",
        "NAME": "Proskau, Kaspar (1543\u20131603), Hofdiener",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17848",
        "NAME": "Proskau, Johann (1529\u20131590), Landeshauptmann von Oppeln",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1590 Okt 17",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17849",
        "NAME": "Proskau, Ulrich Desider (1570\u20131618), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1618 Feb 16",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17850",
        "NAME": "Zasy von Rabenstein, Ulrich (1461\u20131535)",
        "DATEOFBIRTH": "1461",
        "DATEOFDEATH": "1535 Nov 24",
        "PLACEOFBIRTH": "Konstanz im Hegau",
        "PLACEOFDEATH": "Freiburg im Breisgau:M\u00fcnster"
    },
    {
        "ID": "17851",
        "NAME": "Zasy von Rabenstein, Johann Ulrich (1521\u20131570), Reichsvizekanzler",
        "DATEOFBIRTH": "1521",
        "DATEOFDEATH": "1570 Apr 21",
        "PLACEOFBIRTH": "Freiburg im Breisgau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17852",
        "NAME": "Lang von Wellenburg, Helena (1557\u20131585)",
        "DATEOFBIRTH": "1557",
        "DATEOFDEATH": "1585 Sep 01",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17853",
        "NAME": "Notthafft, Heinrich (1410\u20131471)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1471",
        "PLACEOFBIRTH": "Wernberg in der Oberpfalz",
        "PLACEOFDEATH": "Straubing:Karmelitenkirche"
    },
    {
        "ID": "17854",
        "NAME": "Notthafft, Heinrich (1445\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17855",
        "NAME": "Notthafft, Kaspar (1475\u20131520)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1520",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Straubing:Karmelitenkirche"
    },
    {
        "ID": "17856",
        "NAME": "Notthafft, Albrecht (1422\u20131468)",
        "DATEOFBIRTH": "1422",
        "DATEOFDEATH": "1468",
        "PLACEOFBIRTH": "Wernberg in der Oberpfalz",
        "PLACEOFDEATH": "Straubing:Karmelitenkirche"
    },
    {
        "ID": "17857",
        "NAME": "Notthafft, Heinrich (1450\u20131508)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1508",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17858",
        "NAME": "Notthafft, Heinrich (1480\u20131533)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1533",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Chamm\u00fcnster"
    },
    {
        "ID": "17859",
        "NAME": "Notthafft, Albrecht (1513\u20131580)",
        "DATEOFBIRTH": "1513 Mai 10",
        "DATEOFDEATH": "1580 Jun 14",
        "PLACEOFBIRTH": "Randsberg",
        "PLACEOFDEATH": "Chamm\u00fcnster"
    },
    {
        "ID": "17860",
        "NAME": "Harrach, Bernhard (1380\u20131433)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1433 Aug 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Geras im Waldviertel"
    },
    {
        "ID": "17861",
        "NAME": "Harrach, Johann (1420\u20131480)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1480 Jun 10",
        "PLACEOFBIRTH": "Goggitsch im Waldviertel",
        "PLACEOFDEATH": "Trautmannsdorf im Waldviertel"
    },
    {
        "ID": "17862",
        "NAME": "Harrach, Friedrich (1450\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Goggitsch im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17863",
        "NAME": "Harrach, Johann (1480\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Goggitsch im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17864",
        "NAME": "Khuepach von Haselburg, Christoph (1512\u20131576), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1512",
        "DATEOFDEATH": "1576 Aug 06",
        "PLACEOFBIRTH": "Bozen",
        "PLACEOFDEATH": "Ried im Sarntal"
    },
    {
        "ID": "17865",
        "NAME": "Khuepach von Haselburg, Ferdinand (1549\u20131613)",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1613 Jul 31",
        "PLACEOFBIRTH": "Ried im Sarntal",
        "PLACEOFDEATH": "Zimmerlehen"
    },
    {
        "ID": "17866",
        "NAME": "Strein von Schwarzenau, Ulrich (1538\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hartenstein in der Wachau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17867",
        "NAME": "Plawen, Johann (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Plawen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17868",
        "NAME": "Plawen, Andreas (1500\u20131568), Hofarzt",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1568",
        "PLACEOFBIRTH": "Plawen",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "17869",
        "NAME": "Plawen, Oswald (1510\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerrat",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Plawen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17870",
        "NAME": "Landau, Johann (1450\u20131513), Hofkammerrat",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1513",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Blumberg in der Baar"
    },
    {
        "ID": "17871",
        "NAME": "Landau, Johann (1535\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Haus im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17872",
        "NAME": "P\u00e1lffy, Magdalena (1546\u20131623)",
        "DATEOFBIRTH": "1546 Jul 14",
        "DATEOFDEATH": "1623 Feb 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17873",
        "NAME": "Khuen von Belasi, Johann Euseb (1574\u20131622), Geheimer Rat",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1622 Nov 06",
        "PLACEOFBIRTH": "Lichtenberg im Pinzgau",
        "PLACEOFDEATH": "Swietlau in M\u00e4hren"
    },
    {
        "ID": "17874",
        "NAME": "Khuen von Belasi, Franziska (1610\u20131672)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1672 Mai 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17875",
        "NAME": "Proskau, Georg (1490\u20131557)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1557 Okt 10",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": "Esseg an der Drau"
    },
    {
        "ID": "17876",
        "NAME": "Proskau, Johann (1510\u20131564)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1564 Sep 22",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17877",
        "NAME": "Proskau, Valentin (1535\u20131558), Truchsess",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1558 Aug 15",
        "PLACEOFBIRTH": "Proskau",
        "PLACEOFDEATH": "Nei\u00dfe"
    },
    {
        "ID": "17878",
        "NAME": "P\u00fcckler, Anna (1585\u20131616)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Falkenberg in Oberschlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17879",
        "NAME": "P\u00fcckler, Polyxena (1583\u20131617)",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "Falkenberg in Oberschlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17880",
        "NAME": "Saavedra, Jakob (1584\u20131648)",
        "DATEOFBIRTH": "1584 Mai 06",
        "DATEOFDEATH": "1648 Aug 24",
        "PLACEOFBIRTH": "Algezares",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "17881",
        "NAME": "Rechenberg, Kaspar (1390\u20131448)",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1448",
        "PLACEOFBIRTH": "Borau in Schlesien",
        "PLACEOFDEATH": "Borau in Schlesien"
    },
    {
        "ID": "17882",
        "NAME": "Rechenberg, Melchior (1427\u20131482)",
        "DATEOFBIRTH": "1427",
        "DATEOFDEATH": "1482 Jan 29",
        "PLACEOFBIRTH": "Borau in Schlesien",
        "PLACEOFDEATH": "G\u00f6rlitz an der Nei\u00dfe:Franziskanerkirche"
    },
    {
        "ID": "17883",
        "NAME": "Rechenberg, Melchior (1460\u20131497)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1497",
        "PLACEOFBIRTH": "Borau in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17884",
        "NAME": "Rechenberg, Klement (1470\u20131536)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1536",
        "PLACEOFBIRTH": "Borau in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17885",
        "NAME": "Rechenberg, Johann (1475\u20131537), Hofkriegsrat",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1537 Nov 09",
        "PLACEOFBIRTH": "Borau in Schlesien",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17886",
        "NAME": "Rechenberg, Niklas (1425\u20131477)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "1477",
        "PLACEOFBIRTH": "Borau in Schlesien",
        "PLACEOFDEATH": "Klitschdorf am Queis"
    },
    {
        "ID": "17887",
        "NAME": "Rechenberg, Balthasar (1506\u20131567)",
        "DATEOFBIRTH": "1506",
        "DATEOFDEATH": "1567",
        "PLACEOFBIRTH": "Schlawa am See",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17888",
        "NAME": "Rechenberg, Melchior (1549\u20131625), Landeshauptmann von Glatz",
        "DATEOFBIRTH": "1549 Mai 23",
        "DATEOFDEATH": "1625",
        "PLACEOFBIRTH": "Schlawa am See",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17889",
        "NAME": "Rechenberg, Johann (1588\u20131646), K\u00e4mmerer",
        "DATEOFBIRTH": "1588 Aug 22",
        "DATEOFDEATH": "1646",
        "PLACEOFBIRTH": "Schlawa am See",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17890",
        "NAME": "Rechenberg, Kaspar (1465\u20131531)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1531",
        "PLACEOFBIRTH": "Klitschdorf am Queis",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17891",
        "NAME": "Rechenberg, Georg (1500\u20131557)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1557",
        "PLACEOFBIRTH": "Klitschdorf am Queis",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17892",
        "NAME": "Rechenberg, Kaspar (1545\u20131588)",
        "DATEOFBIRTH": "1545",
        "DATEOFDEATH": "1588 Aug 21",
        "PLACEOFBIRTH": "Klitschdorf am Queis",
        "PLACEOFDEATH": "Klitschdorf am Queis"
    },
    {
        "ID": "17893",
        "NAME": "Rechenberg, Kaspar (1573\u20131612), Landeshauptmann von Schweidnitz und Jauer",
        "DATEOFBIRTH": "1573 Mai 06",
        "DATEOFDEATH": "1612 Jan 25",
        "PLACEOFBIRTH": "Klitschdorf am Queis",
        "PLACEOFDEATH": "Klitschdorf am Queis"
    },
    {
        "ID": "17894",
        "NAME": "Rechenberg, Georg (1490\u20131559)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1559 Mai 03",
        "PLACEOFBIRTH": "Borau in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17895",
        "NAME": "Rechenberg, Georg (1520\u20131552)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1552",
        "PLACEOFBIRTH": "Wartenberg an der Ochel",
        "PLACEOFDEATH": "Wartenberg an der Ochel"
    },
    {
        "ID": "17896",
        "NAME": "Rechenberg, Johann (1550\u20131598), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1598 Apr 16",
        "PLACEOFBIRTH": "Wartenberg an der Ochel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17897",
        "NAME": "Rechenberg, Melchior (1525\u20131562)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1562",
        "PLACEOFBIRTH": "Wartenberg an der Ochel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17898",
        "NAME": "Rechenberg, Johann Georg (1581\u20131610)",
        "DATEOFBIRTH": "1581",
        "DATEOFDEATH": "1610 Feb 03",
        "PLACEOFBIRTH": "Wartenberg an der Ochel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17899",
        "NAME": "Khuepach, Christoph Jakob (1575\u20131624), Hofdiener",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17901",
        "NAME": "Zelking, Christoph (1435\u20131491)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1491 Aug 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kefermarkt im M\u00fchlviertel:Pfarrkirche"
    },
    {
        "ID": "17902",
        "NAME": "Zelking, Johann (1467\u20131525), Truchsess",
        "DATEOFBIRTH": "1467",
        "DATEOFDEATH": "1525 Jul 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ulrichskirchen:Pfarrkirche"
    },
    {
        "ID": "17903",
        "NAME": "Zelking, Veit (1480\u20131559)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1559 Mai 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kefermarkt im M\u00fchlviertel:Pfarrkirche"
    },
    {
        "ID": "17904",
        "NAME": "Zelking, Wilhelm (1482\u20131541), Obersthofmeister",
        "DATEOFBIRTH": "1482",
        "DATEOFDEATH": "1541 Aug 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sierndorf in der Stockerau"
    },
    {
        "ID": "17905",
        "NAME": "Zelking, Wolfgang (1485\u20131518)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1518 Dez 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sierndorf in der Stockerau"
    },
    {
        "ID": "17906",
        "NAME": "Zelking, Heinrich (1525\u20131580)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1580 Okt 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kefermarkt im M\u00fchlviertel:Pfarrkirche"
    },
    {
        "ID": "17907",
        "NAME": "Zelking, Georg Wilhelm (1518\u20131565)",
        "DATEOFBIRTH": "1518 Okt 10",
        "DATEOFDEATH": "1565",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17908",
        "NAME": "Zelking, Wolfgang Wilhelm (1529\u20131573)",
        "DATEOFBIRTH": "1529 Feb 13",
        "DATEOFDEATH": "1573 Nov 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17909",
        "NAME": "Zelking, Christoph (1500\u20131554)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1554",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ulrichskirchen"
    },
    {
        "ID": "17910",
        "NAME": "Zelking, Johann Christoph (1543\u20131580), Reichshofrat",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1580 Okt 28",
        "PLACEOFBIRTH": "Ulrichskirchen",
        "PLACEOFDEATH": "Kefermarkt im M\u00fchlviertel:Pfarrkirche"
    },
    {
        "ID": "17911",
        "NAME": "Kirchberger von Kirchberg, Johann (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17912",
        "NAME": "Kirchberger von Kirchberg, Wilhelm (1530\u20131573)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1573",
        "PLACEOFBIRTH": "Seisenburg im Traunviertel",
        "PLACEOFDEATH": "Kirchberg an der Pielach"
    },
    {
        "ID": "17913",
        "NAME": "Kirchberger von Kirchberg, Otto Joseph (1580\u20131639), K\u00e4mmerer",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1639 Mai 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17914",
        "NAME": "Kirchberger von Kirchberg, Karl (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17915",
        "NAME": "Kirchberger von Kirchberg, Christoph Siegmund (1610\u20131678), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17916",
        "NAME": "Kirchberger von Kirchberg, Otto Ludwig (1615\u20131647)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1647 Jul 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lorch an der Enns:Kirche Maria Anger"
    },
    {
        "ID": "17917",
        "NAME": "Waldstein, Magdalena (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17918",
        "NAME": "Wildenfels, Friedrich (1550\u20131602)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1602 Feb 26",
        "PLACEOFBIRTH": "Wildenfels im Erzgebirge",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "17919",
        "NAME": "Wildenfels, Johanna (1579\u20131631)",
        "DATEOFBIRTH": "1579 Feb 27",
        "DATEOFDEATH": "1631",
        "PLACEOFBIRTH": "Wildenfels im Erzgebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17920",
        "NAME": "K\u00f6nneritz, Heinrich (1483\u20131551), M\u00fcnzmeister in Joachimsthal",
        "DATEOFBIRTH": "1483",
        "DATEOFDEATH": "1551 Mar 15",
        "PLACEOFBIRTH": "K\u00f6nderitz in der Elsteraue",
        "PLACEOFDEATH": "Lobst\u00e4dt"
    },
    {
        "ID": "17921",
        "NAME": "K\u00f6nneritz, Andreas (1510\u20131553)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1553",
        "PLACEOFBIRTH": "Lobst\u00e4dt",
        "PLACEOFDEATH": "Freiburg im Breisgau"
    },
    {
        "ID": "17922",
        "NAME": "K\u00f6nneritz, Christoph (1512\u20131557), Hofkammerrat",
        "DATEOFBIRTH": "1512",
        "DATEOFDEATH": "1557 Aug 14",
        "PLACEOFBIRTH": "Lobst\u00e4dt",
        "PLACEOFDEATH": "Bistritz an der Gran"
    },
    {
        "ID": "17923",
        "NAME": "K\u00f6nneritz, Johann Heinrich (1550\u20131603), Hofkammerrat",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "Hagenberg im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17924",
        "NAME": "K\u00f6nneritz, Wolfgang Jakob (1560\u20131610)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1610~",
        "PLACEOFBIRTH": "Hagenberg im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17925",
        "NAME": "K\u00f6nneritz, Heinrich Balthasar (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hagenberg im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17926",
        "NAME": "K\u00f6nneritz, Christoph Florian (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hagenberg im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17927",
        "NAME": "K\u00f6nneritz, Heinrich Christoph (1630\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hagenberg im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17928",
        "NAME": "K\u00f6nneritz, Erasam (1515\u20131563)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1563 Nov 29",
        "PLACEOFBIRTH": "Lobst\u00e4dt",
        "PLACEOFDEATH": "Leipzig"
    },
    {
        "ID": "17929",
        "NAME": "K\u00f6nneritz, Niklas (1518\u20131551), Truchsess",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "1551 Sep 20",
        "PLACEOFBIRTH": "Lobst\u00e4dt",
        "PLACEOFDEATH": "Ferrara"
    },
    {
        "ID": "17930",
        "NAME": "Vaud\u00e9mont, Karl (1680\u20131715), Erzbischof von Trier",
        "DATEOFBIRTH": "1680 Nov 24",
        "DATEOFDEATH": "1715 Dez 04",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17931",
        "NAME": "Paur, Jakob (1575\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17932",
        "NAME": "Trauttmansdorff, Maximiliana Christina (1660\u20131729)",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "1729",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17933",
        "NAME": "Kerecs\u00e9nyi von Kanyaf\u00f6ld, Lassel (1510\u20131566)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1566",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wei\u00dfenburg in Serbien"
    },
    {
        "ID": "17934",
        "NAME": "Kerecs\u00e9nyi von Kanyaf\u00f6ld, Christoph (1540\u20131575), Truchsess",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1575",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17935",
        "NAME": "Aitzema, Schelte (1540\u20131609)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1609 Sep 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Aalsum in Friesland"
    },
    {
        "ID": "17936",
        "NAME": "Aitzema, Meinhard (1567\u20131640)",
        "DATEOFBIRTH": "1567 Mai 16",
        "DATEOFDEATH": "1640 Sep 02",
        "PLACEOFBIRTH": "Leer in Ostfriesland",
        "PLACEOFDEATH": "Aalsum in Friesland"
    },
    {
        "ID": "17937",
        "NAME": "Aitzema, Julius (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Leer in Ostfriesland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17938",
        "NAME": "Aitzema, Foppe (1580\u20131637)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1637 Okt 16",
        "PLACEOFBIRTH": "Midlum in Friesland",
        "PLACEOFDEATH": "Wien:Dominikanerkirche"
    },
    {
        "ID": "17939",
        "NAME": "Aitzema, Friedrich Ludwig (1615\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Aalsum in Friesland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17940",
        "NAME": "Aitzema, Leonhard (1600\u20131669)",
        "DATEOFBIRTH": "1600 Nov 19",
        "DATEOFDEATH": "1669 Feb 23",
        "PLACEOFBIRTH": "Aalsum in Friesland",
        "PLACEOFDEATH": "Haag in Holland"
    },
    {
        "ID": "17941",
        "NAME": "Hoditz, Georg (1560\u20131612), K\u00e4mmerer",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1612 Sep 04",
        "PLACEOFBIRTH": "Wolframitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17942",
        "NAME": "Speth von Zwiefalten, Eberhard (1500\u20131538)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1538 Nov 23",
        "PLACEOFBIRTH": "H\u00f6pfigheim an der Murr",
        "PLACEOFDEATH": "H\u00f6pfigheim an der Murr:Georgskirche"
    },
    {
        "ID": "17943",
        "NAME": "Speth von Zwiefalten, Johann Ludwig (1535\u20131583), Mundschenk",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1583 Jun 30",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "H\u00f6pfigheim an der Murr:Georgskirche"
    },
    {
        "ID": "17944",
        "NAME": "Schober von Tachenstein, Katharina (1510\u20131546)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1546",
        "PLACEOFBIRTH": "Ingolstadt",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "17945",
        "NAME": "Leyen von Argenschwang, Wolfgang Friedrich (1615\u20131681)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1681",
        "PLACEOFBIRTH": "Argenschwang",
        "PLACEOFDEATH": "Ehrenbreitstein"
    },
    {
        "ID": "17946",
        "NAME": "Leyen von Argenschwang, Johann Eberhard (1660\u20131717), K\u00e4mmerer",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "1717",
        "PLACEOFBIRTH": "Argenschwang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17947",
        "NAME": "Leyen von Gondorf, Hugo Ernst (1617\u20131665)",
        "DATEOFBIRTH": "1617",
        "DATEOFDEATH": "1665 Mai 01",
        "PLACEOFBIRTH": "Leyen an der Mosel",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "17948",
        "NAME": "Leyen von Gondorf, Karl Kaspar (1655\u20131739), Geheimer Rat",
        "DATEOFBIRTH": "1655 Jul 19",
        "DATEOFDEATH": "1739 Nov 30",
        "PLACEOFBIRTH": "Adendorf",
        "PLACEOFDEATH": "Koblenz am Rhein"
    },
    {
        "ID": "17949",
        "NAME": "Riederer von Paar, Elisabeth (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17950",
        "NAME": "B\u00e1nffy von Als\u00f3lendva, Stephan (1400\u20131448)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1448 Okt 18",
        "PLACEOFBIRTH": "Limbach an der Mur",
        "PLACEOFDEATH": "Pristina im Amselfeld"
    },
    {
        "ID": "17951",
        "NAME": "B\u00e1nffy von Als\u00f3lendva, Jakob (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Limbach an der Mur",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17952",
        "NAME": "B\u00e1nffy von Als\u00f3lendva, Franz (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Limbach an der Mur",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17953",
        "NAME": "B\u00e1nffy von Als\u00f3lendva, Lassel (1510\u20131583)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1583 Okt 30",
        "PLACEOFBIRTH": "Limbach an der Mur",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17954",
        "NAME": "B\u00e1nffy von Als\u00f3lendva, Paul (1540\u20131576), Truchsess",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Limbach an der Mur",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17955",
        "NAME": "Everaerts, Niklas (1462\u20131532)",
        "DATEOFBIRTH": "1462",
        "DATEOFDEATH": "1532 Aug 09",
        "PLACEOFBIRTH": "Middelburg auf Zeeland",
        "PLACEOFDEATH": "Mechelen"
    },
    {
        "ID": "17956",
        "NAME": "Everaerts, Eberhard (1498\u20131561)",
        "DATEOFBIRTH": "1498",
        "DATEOFDEATH": "1561",
        "PLACEOFBIRTH": "L\u00f6wen in Brabant",
        "PLACEOFDEATH": "Mechelen"
    },
    {
        "ID": "17957",
        "NAME": "Everaerts, Niklas (1504\u20131572)",
        "DATEOFBIRTH": "1504 Dez 20",
        "DATEOFDEATH": "1572",
        "PLACEOFBIRTH": "L\u00f6wen in Brabant",
        "PLACEOFDEATH": "Venedig"
    },
    {
        "ID": "17958",
        "NAME": "Everaerts, Hadrian (1509\u20131568)",
        "DATEOFBIRTH": "1509 Sep 08",
        "DATEOFDEATH": "1568 Mar 19",
        "PLACEOFBIRTH": "Mechelen",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "17959",
        "NAME": "Everaerts, Johann (1511\u20131536)",
        "DATEOFBIRTH": "1511 Nov 23",
        "DATEOFDEATH": "1536 Sep 24",
        "PLACEOFBIRTH": "Haag in Holland",
        "PLACEOFDEATH": "Saint Amand les Eaux"
    },
    {
        "ID": "17960",
        "NAME": "Everaerts, Niklas (1495\u20131570)",
        "DATEOFBIRTH": "1495 Aug 09",
        "DATEOFDEATH": "1570 Jul 21",
        "PLACEOFBIRTH": "Amsterdam",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "17961",
        "NAME": "Everaerts, Niklas (1537\u20131586)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1586",
        "PLACEOFBIRTH": "Speyer",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "17962",
        "NAME": "Everaerts, Georg (1543\u20131585)",
        "DATEOFBIRTH": "1543 Feb 14",
        "DATEOFDEATH": "1585 Nov 18",
        "PLACEOFBIRTH": "Ingolstadt",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "17963",
        "NAME": "Serbelloni, Alexander (1545\u20131605)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17964",
        "NAME": "Serbelloni, Anna (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17965",
        "NAME": "B\u00e1thory, Elisabeth (1525\u20131562)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1562",
        "PLACEOFBIRTH": "Schomlenmarkt",
        "PLACEOFDEATH": "Julau"
    },
    {
        "ID": "17966",
        "NAME": "Kirchberger von Kirchberg, Anna (1559\u20131615)",
        "DATEOFBIRTH": "1559 Jul 16",
        "DATEOFDEATH": "1615 Feb 17",
        "PLACEOFBIRTH": "Seisenburg im Traunviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17967",
        "NAME": "K\u00f6nneritz, Agnes (1580\u20131643)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Hagenberg im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17968",
        "NAME": "Scala, Magdalena (1475\u20131534)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1534 Mar 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ulrichskirchen:Pfarrkirche"
    },
    {
        "ID": "17969",
        "NAME": "Questenberg, Konstantia (1624\u20131687)",
        "DATEOFBIRTH": "1624 Mar 25",
        "DATEOFDEATH": "1687 Jun 17",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "17970",
        "NAME": "Pr\u00f6sing, Balthasar (1500\u20131559), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1559 Mai 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Linz an der Donau:Minoritenkirche"
    },
    {
        "ID": "17971",
        "NAME": "Pr\u00f6sing, Franz (1530\u20131604), K\u00e4mmerer",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1604",
        "PLACEOFBIRTH": "Stein im Jauntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17972",
        "NAME": "Pr\u00f6sing, Johann (1535\u20131602)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "Stein im Jauntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17973",
        "NAME": "Pr\u00f6sing, Balthasar (1540\u20131580), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1580~",
        "PLACEOFBIRTH": "Stein im Jauntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17974",
        "NAME": "Pr\u00f6sing, Joseph (1545\u20131614)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1614",
        "PLACEOFBIRTH": "Stein im Jauntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17975",
        "NAME": "Pr\u00f6sing, Johann Heinrich (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Stein im Jauntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17976",
        "NAME": "Dohna, Elisabeth (1550\u20131592)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "Kraschen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17977",
        "NAME": "N\u00e1chod, Gottlob Jaroslaus (1575\u20131615), Mundschenk",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17978",
        "NAME": "Redern, Margarita (1585\u20131638)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1638 Mai 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Strehlitz in Oberschlesien"
    },
    {
        "ID": "17979",
        "NAME": "Kolowrat, Magdalena (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17980",
        "NAME": "Carretto, Johann Ignaz (1675\u20131736), K\u00e4mmerer",
        "DATEOFBIRTH": "1675~",
        "DATEOFDEATH": "1736",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17981",
        "NAME": "Lassota, Christoph (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Leobsch\u00fctz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17982",
        "NAME": "Leszczy\u0144ski, Raphael (1526\u20131592), Hofdiener",
        "DATEOFBIRTH": "1526",
        "DATEOFDEATH": "1592 Sep 17",
        "PLACEOFBIRTH": "Lissa in Posen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17983",
        "NAME": "Leszczy\u0144ski, Johann (1555\u20131589), Truchsess",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1589",
        "PLACEOFBIRTH": "Lissa in Posen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17984",
        "NAME": "Leszczy\u0144ski, Andreas (1559\u20131606)",
        "DATEOFBIRTH": "1559",
        "DATEOFDEATH": "1606 Jul 24",
        "PLACEOFBIRTH": "Lissa in Posen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17985",
        "NAME": "Leszczy\u0144ski, Raphael (1579\u20131636)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1636 Mar 29",
        "PLACEOFBIRTH": "Lissa in Posen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17986",
        "NAME": "Leszczy\u0144ski, Bosel (1612\u20131659)",
        "DATEOFBIRTH": "1612",
        "DATEOFDEATH": "1659 Sep 21",
        "PLACEOFBIRTH": "Lissa in Posen",
        "PLACEOFDEATH": "Warszawa"
    },
    {
        "ID": "17987",
        "NAME": "Leszczy\u0144ski, Raphael (1645\u20131703)",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "1703 Jan 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17988",
        "NAME": "Leszczy\u0144ski, Stenzel (1677\u20131766), Herzog von Lothringen",
        "DATEOFBIRTH": "1677 Okt 20",
        "DATEOFDEATH": "1766 Feb 23",
        "PLACEOFBIRTH": "Lemberg in Galizien",
        "PLACEOFDEATH": "Lun\u00e9ville"
    },
    {
        "ID": "17989",
        "NAME": "V\u00f6ls, Elisabeth (1571\u20131616)",
        "DATEOFBIRTH": "1571 Mar 15",
        "DATEOFDEATH": "1616 Jan 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Worlik an der Moldau"
    },
    {
        "ID": "17990",
        "NAME": "Radziwill, Alexander Ludwig (1594\u20131654)",
        "DATEOFBIRTH": "1594 Aug 04",
        "DATEOFDEATH": "1654 Mar 30",
        "PLACEOFBIRTH": "Neswisch",
        "PLACEOFDEATH": "Bologna"
    },
    {
        "ID": "17991",
        "NAME": "Radziwill, Sophia (1478\u20131512)",
        "DATEOFBIRTH": "1478",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17992",
        "NAME": "Radziwill, Anna (1476\u20131522)",
        "DATEOFBIRTH": "1476",
        "DATEOFDEATH": "1522 Mar 15",
        "PLACEOFBIRTH": "Vilnius",
        "PLACEOFDEATH": "Liw in Masowien"
    },
    {
        "ID": "17993",
        "NAME": "Piastowicz, Sophia (1497\u20131542)",
        "DATEOFBIRTH": "1497",
        "DATEOFDEATH": "1542",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17994",
        "NAME": "Carretto, Maria Heinrika (1671\u20131744)",
        "DATEOFBIRTH": "1671 Sep 20",
        "DATEOFDEATH": "1744 Feb 23",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Drogenbosch"
    },
    {
        "ID": "17995",
        "NAME": "Carretto, Maria Gabriela (1675\u20131718)",
        "DATEOFBIRTH": "1675",
        "DATEOFDEATH": "1718 Dez 30",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "17996",
        "NAME": "Zwickel, Eva (1635\u20131655)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1655 Dez 31",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "17997",
        "NAME": "Zwickel, Elisabeth (1637\u20131691)",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1691 Mar 20",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "17998",
        "NAME": "Zwickel, Johann Jakob (1640\u20131691), K\u00e4mmerer",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1691",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "17999",
        "NAME": "Zwickel, Anna (1643\u20131703)",
        "DATEOFBIRTH": "1643 Dez 14",
        "DATEOFDEATH": "1703 Sep 17",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "18364",
        "NAME": "Mansfeld, Agnes (1551\u20131615)",
        "DATEOFBIRTH": "1551",
        "DATEOFDEATH": "1615",
        "PLACEOFBIRTH": "Heldrungen",
        "PLACEOFDEATH": "Sulzbach im Lautertal"
    },
    {
        "ID": "18365",
        "NAME": "Truchsess von Waldburg, Gebhard (1547\u20131601), Erzbischof von K\u00f6ln",
        "DATEOFBIRTH": "1547 Nov 10",
        "DATEOFDEATH": "1601 Mai 31",
        "PLACEOFBIRTH": "Heiligenberg im Linzgau",
        "PLACEOFDEATH": "Stra\u00dfburg im Elsass:Liebfrauenm\u00fcnster"
    },
    {
        "ID": "18366",
        "NAME": "Truchsess von Waldburg, Karl (1548\u20131593), Mundschenk",
        "DATEOFBIRTH": "1548 Aug 07",
        "DATEOFDEATH": "1593 Jun 28",
        "PLACEOFBIRTH": "Heiligenberg im Linzgau",
        "PLACEOFDEATH": "Stra\u00dfburg im Elsass:Liebfrauenm\u00fcnster"
    },
    {
        "ID": "18367",
        "NAME": "Szil\u00e1gyi von Horogszeg, Lassel (1380\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18368",
        "NAME": "Szil\u00e1gyi von Horogszeg, Michael (1415\u20131461), Ban von Kroatien",
        "DATEOFBIRTH": "1415~",
        "DATEOFDEATH": "1461",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Konstantinopel"
    },
    {
        "ID": "18369",
        "NAME": "Szil\u00e1gyi von Horogszeg, Sophia (1420\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18370",
        "NAME": "Ger\u00e9b, Johann (1410\u20131472)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1472",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18371",
        "NAME": "Ger\u00e9b, Peter (1447\u20131503), Palatin von Ungarn",
        "DATEOFBIRTH": "1447",
        "DATEOFDEATH": "1503 Jun 10",
        "PLACEOFBIRTH": "Weingartskirchen",
        "PLACEOFDEATH": "Walpach in der Branau"
    },
    {
        "ID": "18617",
        "NAME": "Schwarzenberg, Edmund (1500\u20131553)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1553 Mar 16",
        "PLACEOFBIRTH": "Schwarzenberg in Franken",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18618",
        "NAME": "Schwarzenberg, Edmund (1545\u20131620)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1620 Okt 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18619",
        "NAME": "Korybut, Jeremias Michael (1612\u20131651)",
        "DATEOFBIRTH": "1612 Aug 17",
        "DATEOFDEATH": "1651 Aug 20",
        "PLACEOFBIRTH": "Wi\u015bniowiec",
        "PLACEOFDEATH": "Pawo\u0142ocz"
    },
    {
        "ID": "18620",
        "NAME": "Montfort, Haug (1357\u20131423), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1357",
        "DATEOFDEATH": "1423 Apr 05",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": "Bruck an der Mur:Minoritenkirche"
    },
    {
        "ID": "18621",
        "NAME": "Montfort, Wilhelm (1340\u20131368)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "1368",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "18622",
        "NAME": "Montfort, Konrad (1346\u20131387)",
        "DATEOFBIRTH": "1346",
        "DATEOFDEATH": "1387",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18623",
        "NAME": "Montfort, Haug (1380\u20131444), Gro\u00dfprior des Malteserordens in Deutschland",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1444 Apr 10",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": "Leuggern"
    },
    {
        "ID": "18624",
        "NAME": "Montfort, Hermann (1405\u20131435)",
        "DATEOFBIRTH": "1405~",
        "DATEOFDEATH": "1435~",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18625",
        "NAME": "Montfort, Hermann (1434\u20131480)",
        "DATEOFBIRTH": "1434",
        "DATEOFDEATH": "1480 Sep 10",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18626",
        "NAME": "Montfort, Georg (1475\u20131544)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1544 Mai 30",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": "Bruck an der Mur"
    },
    {
        "ID": "18627",
        "NAME": "Montfort, Stephan (1403\u20131437)",
        "DATEOFBIRTH": "1403 Okt 04",
        "DATEOFDEATH": "1437 Aug 14",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18628",
        "NAME": "Montfort, Haug (1462\u20131536)",
        "DATEOFBIRTH": "1462",
        "DATEOFDEATH": "1536 Jul 22",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": "H\u00f6chst\u00e4dt an der Donau:Pfarrkirche"
    },
    {
        "ID": "18629",
        "NAME": "Montfort, Christina (1525\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18630",
        "NAME": "Montfort, Ulrich (1380\u20131419)",
        "DATEOFBIRTH": "1380~",
        "DATEOFDEATH": "1419",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18631",
        "NAME": "Montfort, Haug (1160\u20131228)",
        "DATEOFBIRTH": "1160~",
        "DATEOFDEATH": "1228",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Feldkirch in Vorarlberg"
    },
    {
        "ID": "18632",
        "NAME": "Montfort, Haug (1200\u20131260)",
        "DATEOFBIRTH": "1200~",
        "DATEOFDEATH": "1260",
        "PLACEOFBIRTH": "Montfort im Rheintal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18633",
        "NAME": "Montfort, Haug (1240\u20131309)",
        "DATEOFBIRTH": "1240~",
        "DATEOFDEATH": "1309",
        "PLACEOFBIRTH": "Montfort im Rheintal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18634",
        "NAME": "Montfort, Wilhelm (1280\u20131354)",
        "DATEOFBIRTH": "1280~",
        "DATEOFDEATH": "1354 Okt 08",
        "PLACEOFBIRTH": "Montfort im Rheintal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18635",
        "NAME": "Montfort, Wilhelm (1310\u20131373)",
        "DATEOFBIRTH": "1310~",
        "DATEOFDEATH": "1373 Okt 19",
        "PLACEOFBIRTH": "Montfort im Rheintal",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "18636",
        "NAME": "Montfort, Heinrich (1330\u20131408)",
        "DATEOFBIRTH": "1330~",
        "DATEOFDEATH": "1408 Jul 15",
        "PLACEOFBIRTH": "Montfort im Rheintal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18637",
        "NAME": "Montfort, Wilhelm (1375\u20131439)",
        "DATEOFBIRTH": "1375~",
        "DATEOFDEATH": "1439 Jun 26",
        "PLACEOFBIRTH": "Tettnang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18638",
        "NAME": "Montfort, Haug (1420\u20131491)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1491 Okt 13",
        "PLACEOFBIRTH": "Tettnang",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18639",
        "NAME": "Montfort, Haug (1460\u20131519)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1519 Apr 24",
        "PLACEOFBIRTH": "Wasserburg am Bodensee",
        "PLACEOFDEATH": "Langnau im Argental"
    },
    {
        "ID": "18640",
        "NAME": "Montfort, Wolfgang (1489\u20131540)",
        "DATEOFBIRTH": "1489",
        "DATEOFDEATH": "1540 Mar 21",
        "PLACEOFBIRTH": "Wasserburg am Bodensee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18641",
        "NAME": "Montfort, Haug (1506\u20131564)",
        "DATEOFBIRTH": "1506",
        "DATEOFDEATH": "1564 Nov 21",
        "PLACEOFBIRTH": "Wasserburg am Bodensee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18642",
        "NAME": "Montfort, Johann (1490\u20131547), K\u00e4mmerer",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1547",
        "PLACEOFBIRTH": "Wasserburg am Bodensee",
        "PLACEOFDEATH": "Neufra an der Donau"
    },
    {
        "ID": "18643",
        "NAME": "Montfort, Wilhelm (1370\u20131422)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "1422 Mar 06",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18644",
        "NAME": "Montfort, Elisabeth (1395\u20131457)",
        "DATEOFBIRTH": "1395~",
        "DATEOFDEATH": "1457 Jun 07",
        "PLACEOFBIRTH": "Bregenz",
        "PLACEOFDEATH": "Konstanz im Hegau:M\u00fcnster"
    },
    {
        "ID": "18645",
        "NAME": "Montfort, Barbara (1535\u20131592)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1592 Dez 02",
        "PLACEOFBIRTH": "Wasserburg am Bodensee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18646",
        "NAME": "Montfort, Ulrich (1529\u20131574), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1574 Apr 16",
        "PLACEOFBIRTH": "Wasserburg am Bodensee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18660",
        "NAME": "Dietrichstein, Franz Adam (1642\u20131702), Geheimer Rat",
        "DATEOFBIRTH": "1642 Mar 30",
        "DATEOFDEATH": "1702 Jul 20",
        "PLACEOFBIRTH": "Hollenburg an der Drau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "18677",
        "NAME": "Volkra, Agapit (1525\u2013\u00a0\u00a0\u00a0\u00a0), Oberstk\u00fcchenmeister",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Steinabrunn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18769",
        "NAME": "Schulenburg, Jakob (1515\u20131576), Hofdiener",
        "DATEOFBIRTH": "1515 Mar 25",
        "DATEOFDEATH": "1576 Apr 22",
        "PLACEOFBIRTH": "Beetzendorf in der Altmark",
        "PLACEOFDEATH": "Magdeburg"
    },
    {
        "ID": "18770",
        "NAME": "Hundbi\u00df, Eitel (1340\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ravensburg im Schussental",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18771",
        "NAME": "Hundbi\u00df, Jobst (1379\u20131454)",
        "DATEOFBIRTH": "1379",
        "DATEOFDEATH": "1454 Jul 01",
        "PLACEOFBIRTH": "Ravensburg im Schussental",
        "PLACEOFDEATH": "Ravensburg im Schussental"
    },
    {
        "ID": "18772",
        "NAME": "Hundbi\u00df, Friedrich (1370\u20131434)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "1434",
        "PLACEOFBIRTH": "Ravensburg im Schussental",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18773",
        "NAME": "Hundbi\u00df, Eitel (1405\u20131472)",
        "DATEOFBIRTH": "1405~",
        "DATEOFDEATH": "1472",
        "PLACEOFBIRTH": "Ravensburg im Schussental",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18774",
        "NAME": "Hundbi\u00df, Friedrich (1450\u20131506)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1506",
        "PLACEOFBIRTH": "Ravensburg im Schussental",
        "PLACEOFDEATH": "Waltrams"
    },
    {
        "ID": "18775",
        "NAME": "Hundbi\u00df, Friedrich (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Waltrams",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18776",
        "NAME": "Hundbi\u00df, Friedrich (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Waltrams",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18777",
        "NAME": "Spaur, Lazar (1560\u20131626)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18778",
        "NAME": "Spaur, Elisabeth (1613\u20131655)",
        "DATEOFBIRTH": "1613",
        "DATEOFDEATH": "1655",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18779",
        "NAME": "Spaur, Paul (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18780",
        "NAME": "Moles, Franz (1640\u20131713), Herzog von Parete",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1713 Dez 26",
        "PLACEOFBIRTH": "Neapel",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "18781",
        "NAME": "Cs\u00f3ron, Johann (1515\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Devecser",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18782",
        "NAME": "Podiebrad, Viktorin (1443\u20131500)",
        "DATEOFBIRTH": "1443 Mai 29",
        "DATEOFDEATH": "1500 Aug 30",
        "PLACEOFBIRTH": "Podiebrad",
        "PLACEOFDEATH": "Teschen"
    },
    {
        "ID": "18783",
        "NAME": "Podiebrad, Barbara (1446\u20131474)",
        "DATEOFBIRTH": "1446",
        "DATEOFDEATH": "1474 Sep 20",
        "PLACEOFBIRTH": "Podiebrad",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18784",
        "NAME": "Podiebrad, Katharina (1449\u20131464), K\u00f6nigin von Ungarn",
        "DATEOFBIRTH": "1449 Nov 11",
        "DATEOFDEATH": "1464 Mar 08",
        "PLACEOFBIRTH": "Podiebrad",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "18785",
        "NAME": "Podiebrad, Karl Friedrich (1593\u20131647)",
        "DATEOFBIRTH": "1593 Okt 18",
        "DATEOFDEATH": "1647 Mai 31",
        "PLACEOFBIRTH": "Oels",
        "PLACEOFDEATH": "Oels"
    },
    {
        "ID": "18786",
        "NAME": "Podiebrad, Georg (1512\u20131553)",
        "DATEOFBIRTH": "1512 Apr 30",
        "DATEOFDEATH": "1553 Jan 13",
        "PLACEOFBIRTH": "Oels",
        "PLACEOFDEATH": "Oels"
    },
    {
        "ID": "18787",
        "NAME": "Podiebrad, Johann (1509\u20131565), Herzog von M\u00fcnsterberg",
        "DATEOFBIRTH": "1509 Nov 04",
        "DATEOFDEATH": "1565 Feb 28",
        "PLACEOFBIRTH": "Oels",
        "PLACEOFDEATH": "Oels"
    },
    {
        "ID": "18788",
        "NAME": "Podiebrad, Karl Christoph (1545\u20131569), Mundschenk",
        "DATEOFBIRTH": "1545 Mai 22",
        "DATEOFDEATH": "1569 Mar 17",
        "PLACEOFBIRTH": "Oels",
        "PLACEOFDEATH": "Oels"
    },
    {
        "ID": "18789",
        "NAME": "Podiebrad, Ignaz (1452\u20131492)",
        "DATEOFBIRTH": "1452 Mai 18",
        "DATEOFDEATH": "1492 Jul 11",
        "PLACEOFBIRTH": "Podiebrad",
        "PLACEOFDEATH": "Podiebrad"
    },
    {
        "ID": "18790",
        "NAME": "Swetkowitz, Adam (1475\u20131522)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1522 Nov 19",
        "PLACEOFBIRTH": "Pettau",
        "PLACEOFDEATH": "Wien:Stephansdom"
    },
    {
        "ID": "18791",
        "NAME": "Swetkowitz, Lassel (1508\u20131541), Hofdiener",
        "DATEOFBIRTH": "1508",
        "DATEOFDEATH": "1541 Okt 08",
        "PLACEOFBIRTH": "Salzburg",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "18792",
        "NAME": "Swetkowitz, Karl (1520\u20131552)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1552 Sep 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "18793",
        "NAME": "Swetkowitz, Adam (1515\u20131573), Nieder\u00f6sterreichischer Kammerpr\u00e4sident",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1573",
        "PLACEOFBIRTH": "Plankenstein an der Drann",
        "PLACEOFDEATH": "Mitterburg in Istrien"
    },
    {
        "ID": "18794",
        "NAME": "Kotromanics, Stephan (1242\u20131314)",
        "DATEOFBIRTH": "1242",
        "DATEOFDEATH": "1314",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18795",
        "NAME": "Kotromanics, Stephan (1292\u20131353)",
        "DATEOFBIRTH": "1292",
        "DATEOFDEATH": "1353",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18796",
        "NAME": "Kotromanics, Lassel (1295\u20131354)",
        "DATEOFBIRTH": "1295",
        "DATEOFDEATH": "1354",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18797",
        "NAME": "Kotromanics, Stephan (1328\u20131391), K\u00f6nig von Bosnien",
        "DATEOFBIRTH": "1328",
        "DATEOFDEATH": "1391 Mar 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18798",
        "NAME": "Kotromanics, Maria (1335\u20131403)",
        "DATEOFBIRTH": "1335~",
        "DATEOFDEATH": "1403 Apr 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "B\u00fchringen"
    },
    {
        "ID": "18799",
        "NAME": "Kotromanics, Katharina (1340\u20131396)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "1396",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18801",
        "NAME": "Wittelsbach, Ruprecht (1325\u20131398)",
        "DATEOFBIRTH": "1325",
        "DATEOFDEATH": "1398",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18802",
        "NAME": "Wittelsbach, Ruprecht (1352\u20131410)",
        "DATEOFBIRTH": "1352",
        "DATEOFDEATH": "1410",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18803",
        "NAME": "Wittelsbach, Stephan (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18804",
        "NAME": "Wittelsbach, Ludwig (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18805",
        "NAME": "Wittelsbach, Alexander (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18806",
        "NAME": "Wittelsbach, Ludwig (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18807",
        "NAME": "Wittelsbach, Wolfgang (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18808",
        "NAME": "Wittelsbach, Johann (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18809",
        "NAME": "Wittelsbach, Kasimir (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18810",
        "NAME": "Wittelsbach, Karl (1622\u20131660), K\u00f6nig von Schweden",
        "DATEOFBIRTH": "1622 Nov 18",
        "DATEOFDEATH": "1660 Feb 23",
        "PLACEOFBIRTH": "Nyk\u00f6ping",
        "PLACEOFDEATH": "G\u00f6teborg"
    },
    {
        "ID": "18811",
        "NAME": "Wittelsbach, Karl (1655\u20131697), K\u00f6nig von Schweden",
        "DATEOFBIRTH": "1655 Dez 04",
        "DATEOFDEATH": "1697 Apr 15",
        "PLACEOFBIRTH": "Stockholm",
        "PLACEOFDEATH": "Stockholm:Ritterholmskirche"
    },
    {
        "ID": "18812",
        "NAME": "Wittelsbach, Karl (1682\u20131718), K\u00f6nig von Schweden",
        "DATEOFBIRTH": "1682 Jun 27",
        "DATEOFDEATH": "1718 Dez 11",
        "PLACEOFBIRTH": "Stockholm",
        "PLACEOFDEATH": "Friedrichshall am Swinsund"
    },
    {
        "ID": "18820",
        "NAME": "Wittelsbach, Philipp Ludwig (1547\u20131614), Pfalzgraf bei Rhein",
        "DATEOFBIRTH": "1547 Okt 02",
        "DATEOFDEATH": "1614 Aug 22",
        "PLACEOFBIRTH": "Zweibr\u00fccken",
        "PLACEOFDEATH": "Neuburg an der Donau"
    },
    {
        "ID": "18901",
        "NAME": "Ny\u00e1ry von Bedegh, Gall (1440\u20131485)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1485~",
        "PLACEOFBIRTH": "Bedegk\u00e9r",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18902",
        "NAME": "Ny\u00e1ry von Bedegh, Peter (1480\u20131537)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1537",
        "PLACEOFBIRTH": "Bedegk\u00e9r",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18903",
        "NAME": "Ny\u00e1ry von Bedegh, Lorenz (1517\u20131559)",
        "DATEOFBIRTH": "1517",
        "DATEOFDEATH": "1559",
        "PLACEOFBIRTH": "Bedegk\u00e9r",
        "PLACEOFDEATH": "Szucs\u00e1ny"
    },
    {
        "ID": "18904",
        "NAME": "Ny\u00e1ry von Bedegh, Stephan (1550\u20131582), Panetier",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1582 Dez 12",
        "PLACEOFBIRTH": "Bedegk\u00e9r",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "18905",
        "NAME": "Ny\u00e1ry von Bedegh, Paul (1555\u20131607)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1607 Dez 15",
        "PLACEOFBIRTH": "Bedegk\u00e9r",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18906",
        "NAME": "Ny\u00e1ry von Bedegh, Stephan (1585\u20131643)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1643 Mar 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kaschau"
    },
    {
        "ID": "18907",
        "NAME": "Ny\u00e1ry von Bedegh, Niklas (1587\u20131642)",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18908",
        "NAME": "Ny\u00e1ry von Bedegh, Bernhard (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Bedegk\u00e9r",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18909",
        "NAME": "Ny\u00e1ry von Bedegh, Franz (1500\u20131551)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1551",
        "PLACEOFBIRTH": "Bedegk\u00e9r",
        "PLACEOFDEATH": "Bucs\u00e1ny"
    },
    {
        "ID": "18910",
        "NAME": "Hunyadi, Lassel (1433\u20131457), Ban von Kroatien",
        "DATEOFBIRTH": "1433",
        "DATEOFDEATH": "1457 Mar 16",
        "PLACEOFBIRTH": "Eisenmarkt in Siebenb\u00fcrgen",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "18911",
        "NAME": "Hundbi\u00df, Friedrich (1565\u20131628)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "Waltrams",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18912",
        "NAME": "Hundbi\u00df, Johann Konrad (1607\u20131670)",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1670",
        "PLACEOFBIRTH": "Waltrams",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18913",
        "NAME": "Hundbi\u00df, Maria Klaudia (1635\u20131702)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1702",
        "PLACEOFBIRTH": "Waltrams",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "18935",
        "NAME": "Boskowitz von Schwarzenberg, Wenzel (1360\u20131438)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1438",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18936",
        "NAME": "Boskowitz von Schwarzenberg, Benedikt (1400\u20131473)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1473",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18937",
        "NAME": "Boskowitz von Schwarzenberg, Protas (1430\u20131482), Bischof von Olm\u00fctz",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1482 Aug 25",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": "Wischau"
    },
    {
        "ID": "18938",
        "NAME": "Boskowitz von Schwarzenberg, Tobias (1440\u20131493)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1493 Dez 20",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "18939",
        "NAME": "Boskowitz von Schwarzenberg, Wenzel (1390\u20131466), Landeshauptmann von M\u00e4hren",
        "DATEOFBIRTH": "1390~",
        "DATEOFDEATH": "1466",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18940",
        "NAME": "Boskowitz von Schwarzenberg, Wenzel (1420\u20131482)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1482",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren:Minoritenkloster"
    },
    {
        "ID": "18941",
        "NAME": "Boskowitz von Schwarzenberg, Ulrich (1460\u20131500)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1500",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18942",
        "NAME": "Boskowitz von Schwarzenberg, Wenzel (1495\u20131554)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1554 Okt 26",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren:Minoritenkloster"
    },
    {
        "ID": "18943",
        "NAME": "Boskowitz von Schwarzenberg, Lassel (1455\u20131520)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1520 Jul 08",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": "Letowitz in M\u00e4hren"
    },
    {
        "ID": "18944",
        "NAME": "Boskowitz von Schwarzenberg, Christoph (1485\u20131550)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1550 Sep 13",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "18945",
        "NAME": "Boskowitz von Schwarzenberg, Lassel Valentin (1512\u20131551)",
        "DATEOFBIRTH": "1512",
        "DATEOFDEATH": "1551",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18946",
        "NAME": "Boskowitz von Schwarzenberg, Wenzel (1539\u20131571), Mundschenk",
        "DATEOFBIRTH": "1539",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18947",
        "NAME": "Boskowitz von Schwarzenberg, Johann (1543\u20131589)",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1589 Aug 01",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18948",
        "NAME": "Boskowitz von Schwarzenberg, Jaroslaus (1450\u20131485)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1485 Dez 10",
        "PLACEOFBIRTH": "Schwarzenberg in M\u00e4hren",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "18949",
        "NAME": "Fugger, Maria (1594\u20131635)",
        "DATEOFBIRTH": "1594 Jul 17",
        "DATEOFDEATH": "1635 Mar 22",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18990",
        "NAME": "Erd\u0151dy, Georg (1647\u20131712), Geheimer Rat",
        "DATEOFBIRTH": "1647",
        "DATEOFDEATH": "1712 Dez 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18991",
        "NAME": "Jaksich, Balthasar (1545\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18997",
        "NAME": "V\u00e1rday, Michael (1530\u20131583), Mundschenk",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1583 Dez 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "18999",
        "NAME": "R\u00e9vay, Judith (1603\u20131643)",
        "DATEOFBIRTH": "1603",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Blatnica in der Turz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19001",
        "NAME": "Leuchtenberg, Friedrich (1437\u20131487)",
        "DATEOFBIRTH": "1437",
        "DATEOFDEATH": "1487 Mai 19",
        "PLACEOFBIRTH": "Amberg in der Oberpfalz",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "19002",
        "NAME": "Leuchtenberg, Johann (1470\u20131531)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1531 Sep 01",
        "PLACEOFBIRTH": "Pfreimd",
        "PLACEOFDEATH": "Gr\u00fcnsfeld"
    },
    {
        "ID": "19003",
        "NAME": "Leuchtenberg, Georg (1502\u20131555)",
        "DATEOFBIRTH": "1502 Dez 13",
        "DATEOFDEATH": "1555 Mai 21",
        "PLACEOFBIRTH": "Gr\u00fcnsfeld",
        "PLACEOFDEATH": "Gr\u00fcnsfeld"
    },
    {
        "ID": "19004",
        "NAME": "Leuchtenberg, Ludwig Heinrich (1529\u20131567)",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1567 Jun 05",
        "PLACEOFBIRTH": "Pfreimd",
        "PLACEOFDEATH": "Pfreimd"
    },
    {
        "ID": "19005",
        "NAME": "Leuchtenberg, Elisabeth (1537\u20131579)",
        "DATEOFBIRTH": "1537 Mar 01",
        "DATEOFDEATH": "1579 Jul 06",
        "PLACEOFBIRTH": "Pfreimd",
        "PLACEOFDEATH": "Dillenburg"
    },
    {
        "ID": "19006",
        "NAME": "Attems, Maximilian (1598\u20131665), K\u00e4mmerer",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "19007",
        "NAME": "Attems, Maximilian Franz (1626\u20131663), K\u00e4mmerer",
        "DATEOFBIRTH": "1626",
        "DATEOFDEATH": "1663 Okt 07",
        "PLACEOFBIRTH": "Gradisch an der Isnitz",
        "PLACEOFDEATH": "G\u00f6rz"
    },
    {
        "ID": "19008",
        "NAME": "Aachen, Johann (1552\u20131615)",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "1615 Mar 04",
        "PLACEOFBIRTH": "K\u00f6ln am Rhein",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19009",
        "NAME": "Harrach, Otto Friedrich (1610\u20131648), K\u00e4mmerer",
        "DATEOFBIRTH": "1610 Sep 02",
        "DATEOFDEATH": "1648",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19010",
        "NAME": "Auersperg, Theobald (1362\u20131428)",
        "DATEOFBIRTH": "1362",
        "DATEOFDEATH": "1428 Okt 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19011",
        "NAME": "Auersperg, Volkhard (1401\u20131461)",
        "DATEOFBIRTH": "1401",
        "DATEOFDEATH": "1461",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19012",
        "NAME": "Auersperg, Georg (1440\u20131488)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1488",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19013",
        "NAME": "Auersperg, Johann (1470\u20131529)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1529",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19014",
        "NAME": "Auersperg, Wolfgang Engelbrecht (1500\u20131557)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1557",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19015",
        "NAME": "Auersperg, Johann (1530\u20131580)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1580",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19016",
        "NAME": "Kuefstein, Johann Lorenz (1578\u20131628), Hofkriegsrat",
        "DATEOFBIRTH": "1578",
        "DATEOFDEATH": "1628 Mai 02",
        "PLACEOFBIRTH": "Greillenstein",
        "PLACEOFDEATH": "Maria Laach am Jauerling"
    },
    {
        "ID": "19017",
        "NAME": "Kuefstein, Jakob Ludwig (1610\u20131645), K\u00e4mmerer",
        "DATEOFBIRTH": "1610 Mar 12",
        "DATEOFDEATH": "1645 Mai 06",
        "PLACEOFBIRTH": "Greillenstein",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19018",
        "NAME": "Schwarzenberg, Anna Maria (1583\u20131637)",
        "DATEOFBIRTH": "1583 Jan 23",
        "DATEOFDEATH": "1637 Dez 21",
        "PLACEOFBIRTH": "Straubing",
        "PLACEOFDEATH": "Zaitzkofen"
    },
    {
        "ID": "19019",
        "NAME": "Schwarzenberg, Anna (1574\u20131619)",
        "DATEOFBIRTH": "1574 Sep 13",
        "DATEOFDEATH": "1619 Feb 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19020",
        "NAME": "Pr\u00fcschenk von Hardegg, Stephan (1420\u20131488)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1488",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19021",
        "NAME": "Pr\u00fcschenk von Hardegg, Siegmund (1450\u20131502)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1502",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19022",
        "NAME": "Pr\u00fcschenk von Hardegg, Heinrich (1455\u20131513)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1513",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19023",
        "NAME": "Pr\u00fcschenk von Hardegg, Johann (1485\u20131533)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1533 Jul 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Liegnitz"
    },
    {
        "ID": "19024",
        "NAME": "Pr\u00fcschenk von Hardegg, Wolfgang Theoderich (1525\u20131564)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1564 Dez 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Letowitz in M\u00e4hren"
    },
    {
        "ID": "19025",
        "NAME": "Pr\u00fcschenk von Hardegg, Johann Georg (1507\u20131530)",
        "DATEOFBIRTH": "1507",
        "DATEOFDEATH": "1530",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neutra"
    },
    {
        "ID": "19026",
        "NAME": "Pr\u00fcschenk von Hardegg, Johann Friedrich (1520\u20131587)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1587",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Letowitz in M\u00e4hren"
    },
    {
        "ID": "19027",
        "NAME": "Pr\u00fcschenk von Hardegg, Johann (1555\u20131594), Vorschneider",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1594",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Letowitz in M\u00e4hren"
    },
    {
        "ID": "19028",
        "NAME": "Unterholzer von Kranichberg, Maria (1600\u20131642)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Kranichberg am Wechsel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19029",
        "NAME": "Unterholzer von Kranichberg, Eva (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kranichberg am Wechsel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19030",
        "NAME": "Pr\u00f6sing, Josias (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Stein im Jauntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19031",
        "NAME": "Chiesa, Johann Baptist (1590\u20131632), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1632",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19032",
        "NAME": "Sch\u00f6naich, Johann (1450\u20131529)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1529",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19033",
        "NAME": "Sch\u00f6naich, Georg (1479\u20131556)",
        "DATEOFBIRTH": "1479",
        "DATEOFDEATH": "1556 Feb 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19034",
        "NAME": "Sch\u00f6naich, Philipp (1485\u20131555)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1555 Jan 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19035",
        "NAME": "Sch\u00f6naich, Fabian (1509\u20131591), Hofkriegsrat",
        "DATEOFBIRTH": "1509 Feb 19",
        "DATEOFDEATH": "1591 Sep 23",
        "PLACEOFBIRTH": "Linderode in der Lausitz",
        "PLACEOFDEATH": "Beuthen an der Oder"
    },
    {
        "ID": "19036",
        "NAME": "Sch\u00f6naich, Sebastian (1509\u20131557), Mundschenk",
        "DATEOFBIRTH": "1509 Feb 19",
        "DATEOFDEATH": "1557 Mar 17",
        "PLACEOFBIRTH": "Linderode in der Lausitz",
        "PLACEOFDEATH": "Glogau in Niederschlesien"
    },
    {
        "ID": "19037",
        "NAME": "Sch\u00f6naich, Johann (1525\u20131603)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1603 Aug 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Beuthen an der Oder"
    },
    {
        "ID": "19038",
        "NAME": "Sch\u00f6naich, Georg (1557\u20131619)",
        "DATEOFBIRTH": "1557 Okt 09",
        "DATEOFDEATH": "1619 Feb 25",
        "PLACEOFBIRTH": "Tzschecheln in der Niederlausitz",
        "PLACEOFDEATH": "Carolath in Schlesien"
    },
    {
        "ID": "19039",
        "NAME": "Zelking, Richard Wilhelm (1590\u20131606)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1606 Okt 27",
        "PLACEOFBIRTH": "Weinberg im M\u00fchlviertel",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "19040",
        "NAME": "Heigel von Pollogwitz, Lorenz (1449\u20131513)",
        "DATEOFBIRTH": "1449 Feb 25",
        "DATEOFDEATH": "1513 Jun 28",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "Breslau:Elisabethkirche"
    },
    {
        "ID": "19041",
        "NAME": "Heigel von Pollogwitz, Johann (1495\u20131549)",
        "DATEOFBIRTH": "1495 Feb 17",
        "DATEOFDEATH": "1549 Jul 27",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Breslau:Elisabethkirche"
    },
    {
        "ID": "19042",
        "NAME": "Heigel von Pollogwitz, Sebastian (1537\u20131593), Geheimer Rat",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1593 Aug 26",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Bettlern in Schlesien"
    },
    {
        "ID": "19043",
        "NAME": "Heigel von Pollogwitz, Lazar (1491\u20131562), Hofdiener",
        "DATEOFBIRTH": "1491 Mai 03",
        "DATEOFDEATH": "1562 Feb 06",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Breslau:Elisabethkirche"
    },
    {
        "ID": "19044",
        "NAME": "Heigel von Pollogwitz, Johann (1525\u20131553), Truchsess",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1553 Apr 25",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Breslau:Elisabethkirche"
    },
    {
        "ID": "19045",
        "NAME": "Heigel von Pollogwitz, Lazar (1530\u20131575)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1575 Apr 28",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Breslau:Elisabethkirche"
    },
    {
        "ID": "19046",
        "NAME": "Heigel von Pollogwitz, Johann (1560\u20131616), Truchsess",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1616 Jan 09",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "R\u00fcckers in Schlesien"
    },
    {
        "ID": "19047",
        "NAME": "Heigel von Pollogwitz, Anna (1564\u20131631)",
        "DATEOFBIRTH": "1564 Aug 04",
        "DATEOFDEATH": "1631 Sep 23",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Breslau:Elisabethkirche"
    },
    {
        "ID": "19048",
        "NAME": "Jenkwitz, Abraham (1538\u20131606)",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "1606 Sep 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19049",
        "NAME": "Krausenegg, Paul (1560\u20131617), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19085",
        "NAME": "Wettin, Moritz (1619\u20131681), Administrator von Naumburg",
        "DATEOFBIRTH": "1619 Mar 28",
        "DATEOFDEATH": "1681 Dez 04",
        "PLACEOFBIRTH": "Dresden",
        "PLACEOFDEATH": "Zeitz an der Elster"
    },
    {
        "ID": "19086",
        "NAME": "Wettin, Moritz Wilhelm (1664\u20131718), Administrator von Naumburg",
        "DATEOFBIRTH": "1664 Mar 12",
        "DATEOFDEATH": "1718 Nov 15",
        "PLACEOFBIRTH": "Zeitz an der Elster",
        "PLACEOFDEATH": "Osterburg im Vogtland"
    },
    {
        "ID": "19087",
        "NAME": "Esterh\u00e1zy, Sophia (1578\u20131620)",
        "DATEOFBIRTH": "1578 Okt 29",
        "DATEOFDEATH": "1620 Mai 07",
        "PLACEOFBIRTH": "Gallandau",
        "PLACEOFDEATH": "Treboszt\u00f3"
    },
    {
        "ID": "19088",
        "NAME": "Esterh\u00e1zy, Anna (1590\u20131638)",
        "DATEOFBIRTH": "1590 Mai 22",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "Gallandau",
        "PLACEOFDEATH": "K\u00f6nigsdorf im Burgenland"
    },
    {
        "ID": "19089",
        "NAME": "Esterh\u00e1zy, Niklas (1634\u20131688)",
        "DATEOFBIRTH": "1634",
        "DATEOFDEATH": "1688 Aug 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sohl an der Gran"
    },
    {
        "ID": "19090",
        "NAME": "Harrach, Ferdinand Bonaventura (1637\u20131706), Obersthofmeister",
        "DATEOFBIRTH": "1637 Jul 14",
        "DATEOFDEATH": "1706 Jun 15",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Karlsbad"
    },
    {
        "ID": "19091",
        "NAME": "Orsz\u00e1gh, Michael (1410\u20131484), Palatin von Ungarn",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1484",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19092",
        "NAME": "Orsz\u00e1gh, Lassel (1440\u20131492)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1492",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19093",
        "NAME": "Orsz\u00e1gh, Michael (1470\u20131524)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1524",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19094",
        "NAME": "Scherffenberg, Susanna (1555\u20131600)",
        "DATEOFBIRTH": "1555 Jan 18",
        "DATEOFDEATH": "1600 Dez 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wildenfels im Erzgebirge"
    },
    {
        "ID": "19095",
        "NAME": "Scherffenberg, Katharina (1541\u20131582)",
        "DATEOFBIRTH": "1541",
        "DATEOFDEATH": "1582 Nov 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19096",
        "NAME": "Scherffenberg, Polyxena (1617\u20131658)",
        "DATEOFBIRTH": "1617 Aug 31",
        "DATEOFDEATH": "1658 Feb 15",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19097",
        "NAME": "Scherffenberg, Johann Christoph (1583\u20131666)",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1666",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19098",
        "NAME": "Scherffenberg, Karl Franz (1636\u20131667), K\u00e4mmerer",
        "DATEOFBIRTH": "1636",
        "DATEOFDEATH": "1667",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19099",
        "NAME": "Scherffenberg, Friedrich Siegmund (1644\u20131688), K\u00e4mmerer",
        "DATEOFBIRTH": "1644",
        "DATEOFDEATH": "1688 Sep 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wei\u00dfenburg in Serbien"
    },
    {
        "ID": "19101",
        "NAME": "Pr\u00fcschenk von Hardegg, Julius (1501\u20131557), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1501",
        "DATEOFDEATH": "1557 Jan 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19102",
        "NAME": "Pr\u00fcschenk von Hardegg, Bernhard (1535\u20131584), K\u00e4mmerer",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1584 Aug 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19103",
        "NAME": "Pr\u00fcschenk von Hardegg, Siegmund (1539\u20131599), Panetier",
        "DATEOFBIRTH": "1539",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19104",
        "NAME": "Pr\u00fcschenk von Hardegg, Ferdinand (1549\u20131595), Hofkriegsrat",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1595 Jun 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19105",
        "NAME": "Pr\u00fcschenk von Hardegg, August (1578\u20131620), K\u00e4mmerer",
        "DATEOFBIRTH": "1578 Aug 27",
        "DATEOFDEATH": "1620",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19106",
        "NAME": "Pr\u00fcschenk von Hardegg, Johann Wilhelm (1572\u20131636), Mundschenk",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1636",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19107",
        "NAME": "Rheingraf zum Stein, Otto (1578\u20131637)",
        "DATEOFBIRTH": "1578 Sep 05",
        "DATEOFDEATH": "1637 Apr 13",
        "PLACEOFBIRTH": "Kyrburg",
        "PLACEOFDEATH": "Stra\u00dfburg im Elsass"
    },
    {
        "ID": "19108",
        "NAME": "Fraunberg, Leonhard (1468\u20131511)",
        "DATEOFBIRTH": "1468",
        "DATEOFDEATH": "1511 Sep 27",
        "PLACEOFBIRTH": "Haag am Inn",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19109",
        "NAME": "Fraunberg, Lassel (1505\u20131566)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1566 Mai 31",
        "PLACEOFBIRTH": "Haag am Inn",
        "PLACEOFDEATH": "Haag am Inn"
    },
    {
        "ID": "19110",
        "NAME": "Ungnad von Weissenwolff, Wolfgang (1375\u20131428)",
        "DATEOFBIRTH": "1375~",
        "DATEOFDEATH": "1428",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19111",
        "NAME": "Ungnad von Weissenwolff, Johann (1405\u20131468), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1405~",
        "DATEOFDEATH": "1468 Jan 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sonnegg im Jauntal"
    },
    {
        "ID": "19112",
        "NAME": "Ungnad von Weissenwolff, Wolfgang (1410\u20131453), K\u00e4mmerer",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "1453",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neustadt im Steinfeld"
    },
    {
        "ID": "19113",
        "NAME": "Ungnad von Weissenwolff, Georg (1415\u20131461)",
        "DATEOFBIRTH": "1415~",
        "DATEOFDEATH": "1461",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19114",
        "NAME": "Ungnad von Weissenwolff, Christoph (1425\u20131482)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "1482 Jan 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Eberndorf im Jauntal"
    },
    {
        "ID": "19115",
        "NAME": "Fraunberg, Johann (1412\u20131477)",
        "DATEOFBIRTH": "1412",
        "DATEOFDEATH": "1477 Aug 04",
        "PLACEOFBIRTH": "Haag am Inn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19116",
        "NAME": "Ungnad von Weissenwolff, Adam (1530\u20131571)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1571",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": "Schintau an der Waag"
    },
    {
        "ID": "19117",
        "NAME": "Ungnad von Weissenwolff, Anna (1535\u20131560)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1560~",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19118",
        "NAME": "Harrach, Maria (1551\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1551",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Rohrau an der Leitha",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19119",
        "NAME": "Teuffenbach, Barbara (1584\u20131620)",
        "DATEOFBIRTH": "1584",
        "DATEOFDEATH": "1620 Jan 23",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19120",
        "NAME": "F\u00fcnfkirchen, Johann (1512\u20131571)",
        "DATEOFBIRTH": "1512",
        "DATEOFDEATH": "1571 Nov",
        "PLACEOFBIRTH": "Poysbrunn im Weinviertel",
        "PLACEOFDEATH": "Poysbrunn im Weinviertel"
    },
    {
        "ID": "19121",
        "NAME": "F\u00fcnfkirchen, Johann Bernhard (1560\u20131626), Hofkammerrat",
        "DATEOFBIRTH": "1560",
        "DATEOFDEATH": "1626 Okt 05",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Zbiroh"
    },
    {
        "ID": "19122",
        "NAME": "F\u00fcnfkirchen, Johann Christoph (1604\u20131629), Mundschenk",
        "DATEOFBIRTH": "1604",
        "DATEOFDEATH": "1629 Feb 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "19123",
        "NAME": "F\u00fcnfkirchen, Johann Siegmund (1605\u20131650), K\u00e4mmerer",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1650 Apr 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19124",
        "NAME": "F\u00fcnfkirchen, Johann Rudolf (1610\u20131634)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Eichhorn in M\u00e4hren"
    },
    {
        "ID": "19125",
        "NAME": "F\u00fcnfkirchen, Johann Karl (1613\u20131645)",
        "DATEOFBIRTH": "1613",
        "DATEOFDEATH": "1645",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19126",
        "NAME": "F\u00fcnfkirchen, Johann Ernst (1634\u20131684), K\u00e4mmerer",
        "DATEOFBIRTH": "1634",
        "DATEOFDEATH": "1684",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19127",
        "NAME": "F\u00fcnfkirchen, Johann Karl (1640\u20131694), K\u00e4mmerer",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1694",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19128",
        "NAME": "F\u00fcnfkirchen, Johann Bernhard (1644\u20131700), K\u00e4mmerer",
        "DATEOFBIRTH": "1644",
        "DATEOFDEATH": "1700 Mar 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "19129",
        "NAME": "Ayhin, Simon (1561\u20131637), Reichshofrat",
        "DATEOFBIRTH": "1561",
        "DATEOFDEATH": "1637 Mar 21",
        "PLACEOFBIRTH": "Vaihingen an der Enz",
        "PLACEOFDEATH": "T\u00fcbingen"
    },
    {
        "ID": "19130",
        "NAME": "Leiningen, Friedrich (1240\u20131316)",
        "DATEOFBIRTH": "1240~",
        "DATEOFDEATH": "1316",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19131",
        "NAME": "Leiningen, Friedrich (1269\u20131328)",
        "DATEOFBIRTH": "1269",
        "DATEOFDEATH": "1328",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19132",
        "NAME": "Leiningen, Friedrich (1294\u20131342)",
        "DATEOFBIRTH": "1294",
        "DATEOFDEATH": "1342 Jul 21",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19133",
        "NAME": "Leiningen, Friedrich (1320\u20131397)",
        "DATEOFBIRTH": "1320~",
        "DATEOFDEATH": "1397",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19134",
        "NAME": "Leiningen, Friedrich (1370\u20131434)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "1434",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19135",
        "NAME": "Leiningen, Margarita (1405\u20131470)",
        "DATEOFBIRTH": "1405~",
        "DATEOFDEATH": "1470",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": "Westerburg"
    },
    {
        "ID": "19136",
        "NAME": "Leiningen, Konrad (1425\u20131459)",
        "DATEOFBIRTH": "1425 Okt 23",
        "DATEOFDEATH": "1459 Sep 30",
        "PLACEOFBIRTH": "Westerburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19137",
        "NAME": "Leiningen, Reinhard (1453\u20131522)",
        "DATEOFBIRTH": "1453 Aug 28",
        "DATEOFDEATH": "1522 Feb 12",
        "PLACEOFBIRTH": "Westerburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19138",
        "NAME": "Leiningen, Konrad (1487\u20131547)",
        "DATEOFBIRTH": "1487 Sep 27",
        "DATEOFDEATH": "1547 Nov 23",
        "PLACEOFBIRTH": "Westerburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19139",
        "NAME": "Leiningen, Philipp (1527\u20131597)",
        "DATEOFBIRTH": "1527 Nov 10",
        "DATEOFDEATH": "1597 Sep 27",
        "PLACEOFBIRTH": "Westerburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19140",
        "NAME": "Leiningen, Ludwig (1557\u20131622)",
        "DATEOFBIRTH": "1557 Aug 10",
        "DATEOFDEATH": "1622 Aug 21",
        "PLACEOFBIRTH": "Westerburg",
        "PLACEOFDEATH": "Rixingen"
    },
    {
        "ID": "19141",
        "NAME": "Leiningen, Gottfried (1285\u20131343)",
        "DATEOFBIRTH": "1285~",
        "DATEOFDEATH": "1343",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19142",
        "NAME": "Leiningen, Emmerich (1322\u20131381)",
        "DATEOFBIRTH": "1322",
        "DATEOFDEATH": "1381 Feb 17",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19143",
        "NAME": "Leiningen, Emmerich (1355\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1355~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19144",
        "NAME": "Leiningen, Emmerich (1386\u20131452)",
        "DATEOFBIRTH": "1386",
        "DATEOFDEATH": "1452",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19145",
        "NAME": "Leiningen, Emmerich (1428\u20131495)",
        "DATEOFBIRTH": "1428",
        "DATEOFDEATH": "1495 Mar 30",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19146",
        "NAME": "Leiningen, Emmerich (1466\u20131535)",
        "DATEOFBIRTH": "1466 Jan 14",
        "DATEOFDEATH": "1535 Feb 18",
        "PLACEOFBIRTH": "Hardenburg",
        "PLACEOFDEATH": "D\u00fcrkheim"
    },
    {
        "ID": "19147",
        "NAME": "Leiningen, Georg (1533\u20131586)",
        "DATEOFBIRTH": "1533 Apr 23",
        "DATEOFDEATH": "1586 Apr 09",
        "PLACEOFBIRTH": "Westerburg",
        "PLACEOFDEATH": "Westerburg"
    },
    {
        "ID": "19148",
        "NAME": "Ligne, Wilhelm (1450\u20131519)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1519",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19149",
        "NAME": "Ligne, Ludwig (1480\u20131540)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1540",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19150",
        "NAME": "Heigel von Pollogwitz, Heinrich (1545\u20131575), K\u00e4mmerer",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1575~",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Tarnowitz"
    },
    {
        "ID": "19151",
        "NAME": "Notthafft, Jeremias (1545\u20131605)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "1605 Sep 15",
        "PLACEOFBIRTH": "Randsberg",
        "PLACEOFDEATH": "Grub am Regen"
    },
    {
        "ID": "19152",
        "NAME": "Notthafft, Wolfgang Albrecht (1575\u20131621)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1621 Okt 07",
        "PLACEOFBIRTH": "Grub am Regen",
        "PLACEOFDEATH": "Cham am Regenbogen"
    },
    {
        "ID": "19153",
        "NAME": "Notthafft, Christoph Joachim (1505\u20131547)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1547 Jul 23",
        "PLACEOFBIRTH": "Aholming in der Isarau",
        "PLACEOFDEATH": "Straubing:Karmelitenkirche"
    },
    {
        "ID": "19154",
        "NAME": "Notthafft, Kaspar (1535\u20131590)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1590 Nov 10",
        "PLACEOFBIRTH": "Aholming in der Isarau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19155",
        "NAME": "Berka von der Duba, Sbigneus (1551\u20131606), Erzbischof von Prag",
        "DATEOFBIRTH": "1551",
        "DATEOFDEATH": "1606 Mar 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag:Veitsdom"
    },
    {
        "ID": "19156",
        "NAME": "Kainach, Johann (1475\u20131534), K\u00e4mmerer",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1534",
        "PLACEOFBIRTH": "Kainach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19157",
        "NAME": "Kainach, Helfrich (1515\u20131569), Truchsess",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1569",
        "PLACEOFBIRTH": "Kainach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19158",
        "NAME": "Kainach, Matthias (1525\u20131590)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1590~",
        "PLACEOFBIRTH": "Kainach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19159",
        "NAME": "Kainach, Ehrenreich (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kainach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19160",
        "NAME": "Ligne, Karl Joseph (1661\u20131713)",
        "DATEOFBIRTH": "1661 Aug 20",
        "DATEOFDEATH": "1713 Jan 20",
        "PLACEOFBIRTH": "Baudour",
        "PLACEOFDEATH": "Padua"
    },
    {
        "ID": "19161",
        "NAME": "Holtz, Georg Friedrich (1597\u20131666)",
        "DATEOFBIRTH": "1597 Nov 01",
        "DATEOFDEATH": "1666 Aug 11",
        "PLACEOFBIRTH": "Waldenstein im Wieslauftal",
        "PLACEOFDEATH": "Alfdorf im Leintal"
    },
    {
        "ID": "19162",
        "NAME": "Sporck, Johann (1601\u20131679)",
        "DATEOFBIRTH": "1601",
        "DATEOFDEATH": "1679 Aug 06",
        "PLACEOFBIRTH": "Sch\u00f6ning in Delbr\u00fcck",
        "PLACEOFDEATH": "Hermannst\u00e4dtel"
    },
    {
        "ID": "19163",
        "NAME": "Vogt von Hunolstein, Johann Wilhelm (1599\u20131664)",
        "DATEOFBIRTH": "1599 Apr 24",
        "DATEOFDEATH": "1664 Sep 29",
        "PLACEOFBIRTH": "D\u00fcrkastel",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "19164",
        "NAME": "Kolb von Raindorf, Andreas (1595\u20131666)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1666 Apr 13",
        "PLACEOFBIRTH": "Raindorf am Blauberg",
        "PLACEOFDEATH": "Reichenberg im Rottal"
    },
    {
        "ID": "19165",
        "NAME": "Reuschenberg, Johann (1603\u20131660), Hofkriegsrat",
        "DATEOFBIRTH": "1603 Mar 29",
        "DATEOFDEATH": "1660 Mar 31",
        "PLACEOFBIRTH": "Setterich",
        "PLACEOFDEATH": "K\u00f6ln am Rhein"
    },
    {
        "ID": "19166",
        "NAME": "Marimont, Karl (1605\u20131668)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1668 Nov 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19167",
        "NAME": "Zinzendorf, Otto (1567\u20131605)",
        "DATEOFBIRTH": "1567 Jun 29",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19168",
        "NAME": "Zinzendorf, Georg Ehrenreich (1576\u20131643)",
        "DATEOFBIRTH": "1576 Jan 15",
        "DATEOFDEATH": "1643 Jun 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19169",
        "NAME": "Zinzendorf, Maria Eleonora (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610 Jun 22",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Schwarzenbach in der Buckligen Welt",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19170",
        "NAME": "Krenberg, Ulrich (1550\u20131616), Geheimer Rat",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19171",
        "NAME": "Krenberg, Viktoria (1585\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19172",
        "NAME": "Prager von Windhaag, Lassel (1575\u20131613)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "Windhaag im Machland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19173",
        "NAME": "Peukham, Erasam (1450\u20131512)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1512",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19174",
        "NAME": "Peukham, Erasam (1480\u20131553)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1553 Sep 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Albrechtsberg an der Gro\u00dfen Krems"
    },
    {
        "ID": "19175",
        "NAME": "Peth\u0151 von Gerse, Kaspar (1520\u20131561)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1561",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19176",
        "NAME": "Peth\u0151 von Gerse, Christoph (1550\u20131600), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1600 Sep 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Bolondv\u00e1r an der Waag"
    },
    {
        "ID": "19177",
        "NAME": "Peth\u0151 von Gerse, Johann (1560\u20131616)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1616 Dez 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ivanec"
    },
    {
        "ID": "19178",
        "NAME": "Peth\u0151 von Gerse, Kaspar (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19179",
        "NAME": "Ghislieri, Theoderich (1600\u20131647)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1647 Aug 22",
        "PLACEOFBIRTH": "Bologna",
        "PLACEOFDEATH": "Triebl am Wolfsberg"
    },
    {
        "ID": "19180",
        "NAME": "Globitz, Johann (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19181",
        "NAME": "Globitz, Wolfgang (1590\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19182",
        "NAME": "Globitz, Georg Christoph (1630\u20131701), Hofkriegsrat",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1701",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19187",
        "NAME": "Husmann von Namedy, Maria Klaudia (1648\u20131684)",
        "DATEOFBIRTH": "1648",
        "DATEOFDEATH": "1684 Aug 12",
        "PLACEOFBIRTH": "Tachau an der Mies",
        "PLACEOFDEATH": "Mickhausen"
    },
    {
        "ID": "19188",
        "NAME": "Mercy, Klaudia Franziska (1630\u20131708)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1708 Mai 05",
        "PLACEOFBIRTH": "Longwy",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19189",
        "NAME": "Wolkenstein, Johann (1450\u20131494)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1494",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19190",
        "NAME": "Wolkenstein, Oswald (1480\u20131533)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1533",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19191",
        "NAME": "Pr\u00fcschenk von Hardegg, Heinrich (1532\u20131577)",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1577 Apr 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hautzental im Weinviertel"
    },
    {
        "ID": "19192",
        "NAME": "Pr\u00fcschenk von Hardegg, Julius (1547\u20131593)",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1593",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Stetteldorf am Wagram"
    },
    {
        "ID": "19193",
        "NAME": "Sparnberg genannt Tau\u00dfdorf, Kaspar (1540\u20131572), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1572 Jul 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Schweidnitz"
    },
    {
        "ID": "19194",
        "NAME": "Stubenberg, Wolfgang (1555\u20131588), Reichshofrat",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "Kapfenberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19195",
        "NAME": "Heigel von Pollogwitz, Albrecht (1540\u20131597)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1597 Nov 15",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "N\u00fcrnberg:Johannisfriedhof"
    },
    {
        "ID": "19196",
        "NAME": "Heigel von Pollogwitz, Paul (1577\u20131634)",
        "DATEOFBIRTH": "1577 Apr 16",
        "DATEOFDEATH": "1634 Sep 02",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "19197",
        "NAME": "Heigel von Pollogwitz, Paul (1611\u20131669)",
        "DATEOFBIRTH": "1611 Okt 28",
        "DATEOFDEATH": "1669 Apr 14",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "Sulzbach in der Oberpfalz"
    },
    {
        "ID": "19198",
        "NAME": "Heigel von Pollogwitz, Paul (1640\u20131690)",
        "DATEOFBIRTH": "1640 Mar 16",
        "DATEOFDEATH": "1690 Sep 18",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "Helmstedt"
    },
    {
        "ID": "19199",
        "NAME": "Rochow, Moritz August (1609\u20131653)",
        "DATEOFBIRTH": "1609 Jun 28",
        "DATEOFDEATH": "1653 Aug 25",
        "PLACEOFBIRTH": "Golzow in der Mittelmark",
        "PLACEOFDEATH": "K\u00f6nigsberg im Eulengebirge"
    },
    {
        "ID": "19207",
        "NAME": "Hiserle von Chodau, Franz Michael (1649\u20131709), K\u00e4mmerer",
        "DATEOFBIRTH": "1649",
        "DATEOFDEATH": "1709",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19208",
        "NAME": "Leslie, Jakob (1636\u20131694), K\u00e4mmerer",
        "DATEOFBIRTH": "1636",
        "DATEOFDEATH": "1694 Dez 12",
        "PLACEOFBIRTH": "Balquhain",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19209",
        "NAME": "Enenkel von Albrechtsberg, Johann (1520\u20131566)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1566",
        "PLACEOFBIRTH": "Albrechtsberg an der Pielach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19210",
        "NAME": "Hohenzollern, Maximilian (1636\u20131689), K\u00e4mmerer",
        "DATEOFBIRTH": "1636 Jan 20",
        "DATEOFDEATH": "1689 Aug 13",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Sigmaringen"
    },
    {
        "ID": "19238",
        "NAME": "Hohenzollern, Maximiliana (1610\u20131639)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1639 Apr 10",
        "PLACEOFBIRTH": "Hechingen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19239",
        "NAME": "Hohenzollern, Erdmut (1561\u20131623), Herzogin in Pommern",
        "DATEOFBIRTH": "1561 Jan 26",
        "DATEOFDEATH": "1623 Nov 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19240",
        "NAME": "Fugger, Franz Ernst (1648\u20131711), Geheimer Rat",
        "DATEOFBIRTH": "1648 Sep 13",
        "DATEOFDEATH": "1711 Mar 14",
        "PLACEOFBIRTH": "Gl\u00f6tt in Schwaben",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "19241",
        "NAME": "Michalowicz, Bosel (1505\u20131580)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1580~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19242",
        "NAME": "Michalowicz, Bosel (1535\u20131590)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1590~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19243",
        "NAME": "Michalowicz, Johann (1540\u20131572)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1572 Mar 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19244",
        "NAME": "Michalowicz, Dionys (1565\u20131608), Truchsess",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19245",
        "NAME": "Michalowicz, Bosel (1565\u20131621)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1621 Jun 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19246",
        "NAME": "Podstatzky von Prusinowitz, Christoph Karl (1575\u20131645)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1645 Mai 17",
        "PLACEOFBIRTH": "Bodenstadt",
        "PLACEOFDEATH": "Wesselitzko in M\u00e4hren"
    },
    {
        "ID": "19247",
        "NAME": "Podstatzky von Prusinowitz, Christoph Karl (1605\u20131655)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1655",
        "PLACEOFBIRTH": "Wesselitzko in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19248",
        "NAME": "Podstatzky von Prusinowitz, Julius Karl (1635\u20131693), Truchsess",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1693",
        "PLACEOFBIRTH": "Wesselitzko in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19249",
        "NAME": "Berka von der Duba, Franz Anton (1649\u20131706), Geheimer Rat",
        "DATEOFBIRTH": "1649",
        "DATEOFDEATH": "1706 Apr 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19268",
        "NAME": "Lobkowicz, Ferdinand Wilhelm (1647\u20131708), K\u00e4mmerer",
        "DATEOFBIRTH": "1647 Aug 16",
        "DATEOFDEATH": "1708 Jan 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19269",
        "NAME": "Lobkowicz, Wenzel Ferdinand (1654\u20131697), K\u00e4mmerer",
        "DATEOFBIRTH": "1654 Dez 16",
        "DATEOFDEATH": "1697 Okt 08",
        "PLACEOFBIRTH": "Teplitz im Erzgebirge",
        "PLACEOFDEATH": "Monteortone di Abano"
    },
    {
        "ID": "19270",
        "NAME": "Saurau, Siegmund Friedrich (1625\u20131668), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1668",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19271",
        "NAME": "Wolkenstein, Paris Dominik (1650\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19276",
        "NAME": "Eggenberg, Johann Anton (1669\u20131716), Landeshauptmann von Krain",
        "DATEOFBIRTH": "1669 Jan 06",
        "DATEOFDEATH": "1716 Jun 09",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19277",
        "NAME": "Podstatzky von Prusinowitz, Georg Valerian (1613\u20131688), K\u00e4mmerer",
        "DATEOFBIRTH": "1613",
        "DATEOFDEATH": "1688",
        "PLACEOFBIRTH": "Wesselitzko in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19278",
        "NAME": "Podstatzky von Prusinowitz, Franz Dominik (1649\u20131721), Geheimer Rat",
        "DATEOFBIRTH": "1649",
        "DATEOFDEATH": "1721",
        "PLACEOFBIRTH": "Wesselitzko in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19279",
        "NAME": "Rheingraf zum Stein, Leopold Philipp (1616\u20131663)",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1663 Dez 15",
        "PLACEOFBIRTH": "Neuviller an der Mosel",
        "PLACEOFDEATH": "Anholt in Westfalen"
    },
    {
        "ID": "19280",
        "NAME": "Rheingraf zum Stein, Karl Theoderich (1645\u20131710), Obersthofmeister",
        "DATEOFBIRTH": "1645 Jul 27",
        "DATEOFDEATH": "1710 Nov 10",
        "PLACEOFBIRTH": "Anholt in Westfalen",
        "PLACEOFDEATH": "Aachen"
    },
    {
        "ID": "19281",
        "NAME": "Stubenberg, Sophia (1558\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kapfenberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19282",
        "NAME": "Madrutsch, Julia (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Trient",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19283",
        "NAME": "Lobkowicz, Bosel (1543\u20131595), Truchsess",
        "DATEOFBIRTH": "1543",
        "DATEOFDEATH": "1595 Jul 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Fl\u00f6hau am Goldbach"
    },
    {
        "ID": "19284",
        "NAME": "Barbitz von Fernemont, Johann Alexander (1630\u20131683), K\u00e4mmerer",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1683",
        "PLACEOFBIRTH": "Fernelmont",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19285",
        "NAME": "Barbitz von Fernemont, Johann Wenzel (1640\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Fernelmont",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19286",
        "NAME": "Barbitz von Fernemont, Johann Wenzel (1659\u20131722)",
        "DATEOFBIRTH": "1659 Jul 06",
        "DATEOFDEATH": "1722 Feb 22",
        "PLACEOFBIRTH": "Glogau in Niederschlesien",
        "PLACEOFDEATH": "Glogau in Niederschlesien"
    },
    {
        "ID": "19287",
        "NAME": "Liechtenstein von Nikolsburg, Maximilian (1641\u20131709), K\u00e4mmerer",
        "DATEOFBIRTH": "1641 Jul 25",
        "DATEOFDEATH": "1709 Apr 21",
        "PLACEOFBIRTH": "Wilfersdorf im Weinviertel",
        "PLACEOFDEATH": "Kromau in M\u00e4hren"
    },
    {
        "ID": "19288",
        "NAME": "Liechtenstein von Nikolsburg, Anton Florian (1656\u20131721), Obersthofmeister",
        "DATEOFBIRTH": "1656 Mai 28",
        "DATEOFDEATH": "1721 Okt 11",
        "PLACEOFBIRTH": "Wilfersdorf im Weinviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19289",
        "NAME": "Liechtenstein von Nikolsburg, Philipp (1664\u20131704), K\u00e4mmerer",
        "DATEOFBIRTH": "1664 Sep 11",
        "DATEOFDEATH": "1704 Jan 13",
        "PLACEOFBIRTH": "Wilfersdorf im Weinviertel",
        "PLACEOFDEATH": "Castelnuovo Bormida"
    },
    {
        "ID": "19340",
        "NAME": "Warkotsch, Georg (1500\u20131543)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1543",
        "PLACEOFBIRTH": "Neobsch\u00fctz",
        "PLACEOFDEATH": "Wei\u00dfenburg in Ungarn"
    },
    {
        "ID": "19341",
        "NAME": "Warkotsch, Paul (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neobsch\u00fctz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19342",
        "NAME": "Warkotsch, Niklas (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neobsch\u00fctz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19343",
        "NAME": "Warkotsch, Christoph (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neobsch\u00fctz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19344",
        "NAME": "Warkotsch, Wolfgang (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neobsch\u00fctz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19345",
        "NAME": "Thanr\u00e4dl, Heinrich (1576\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19354",
        "NAME": "Warnsdorf, Niklas (1530\u2013\u00a0\u00a0\u00a0\u00a0), Reichshofrat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Warnsdorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19355",
        "NAME": "Hatzfeldt, Maria Eleonora (1679\u20131718)",
        "DATEOFBIRTH": "1679 Sep 06",
        "DATEOFDEATH": "1718 Apr 26",
        "PLACEOFBIRTH": "Sch\u00fcpf an der Umpfer",
        "PLACEOFDEATH": "Wiesentheid"
    },
    {
        "ID": "19356",
        "NAME": "Batthy\u00e1ny, Adam (1662\u20131703), Ban von Kroatien",
        "DATEOFBIRTH": "1662 Sep 13",
        "DATEOFDEATH": "1703 Aug 26",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19357",
        "NAME": "Trauttmansdorff, Esther Susanna (1634\u20131694)",
        "DATEOFBIRTH": "1634",
        "DATEOFDEATH": "1694 Feb 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19358",
        "NAME": "Carretto, Eleonora Margarita (1634\u20131674)",
        "DATEOFBIRTH": "1634 Jul 28",
        "DATEOFDEATH": "1674 Apr 22",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19359",
        "NAME": "Ungnad von Weissenwolff, Margarita (1529\u20131572)",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1572 Mar 18",
        "PLACEOFBIRTH": "Sonnegg im Jauntal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19360",
        "NAME": "Botsch, Christoph (1420\u20131478), Landeshauptmann von Tirol",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1478 Jul 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19361",
        "NAME": "Botsch, Gaudenz (1455\u20131528)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1528",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19362",
        "NAME": "Botsch, Simon (1486\u20131585), Obersthofmeister",
        "DATEOFBIRTH": "1486",
        "DATEOFDEATH": "1585 Okt 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19363",
        "NAME": "Botsch, Georg (1460\u20131531)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1531 Mar 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19364",
        "NAME": "Botsch, Valentin (1490\u20131537)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1537 Jan 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19365",
        "NAME": "Botsch, Johann Gaudenz (1526\u20131591), Truchsess",
        "DATEOFBIRTH": "1526",
        "DATEOFDEATH": "1591 Jan 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19366",
        "NAME": "Botsch, Christoph (1520\u20131589)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1589 Apr 29",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19367",
        "NAME": "Botsch, Gaudenz (1560\u20131630)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1630 Aug 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19368",
        "NAME": "Botsch, Maximilian (1550\u20131598), Vorschneider",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1598 Sep 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19369",
        "NAME": "Botsch, Johann Gaudenz (1595\u20131639)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19370",
        "NAME": "Kainacher, Leopold (1540\u20131611), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "Raipoltenbach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19371",
        "NAME": "Waldstein, Sidonius (1340\u20131400)",
        "DATEOFBIRTH": "1340~",
        "DATEOFDEATH": "1400",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19372",
        "NAME": "Waldstein, Heinrich (1370\u20131418)",
        "DATEOFBIRTH": "1370~",
        "DATEOFDEATH": "1418",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19373",
        "NAME": "Letowitz, Johann (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Letowitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19374",
        "NAME": "Reichenbach, Katharina (1560\u20131605)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1605 Jan 27",
        "PLACEOFBIRTH": "Rudelsdorf im Eulengebirge",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "19375",
        "NAME": "Berka von der Duba, Peter (1465\u20131520)",
        "DATEOFBIRTH": "1465~",
        "DATEOFDEATH": "1520",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19376",
        "NAME": "Reuschenberg, Edmund (1560\u20131620)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1620 Feb 21",
        "PLACEOFBIRTH": "Setterich",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19377",
        "NAME": "Reuschenberg, Edmund (1595\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Setterich",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19378",
        "NAME": "Reuschenberg, Jobst Edmund (1625\u20131685)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1685",
        "PLACEOFBIRTH": "Setterich",
        "PLACEOFDEATH": "Aachen"
    },
    {
        "ID": "19379",
        "NAME": "Virmond, Katharina (1625\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neersen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19411",
        "NAME": "Saurau, Johann Karl (1646\u20131685), K\u00e4mmerer",
        "DATEOFBIRTH": "1646 Jun 11",
        "DATEOFDEATH": "1685",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19416",
        "NAME": "Collalto, Peter (1555\u2013\u00a0\u00a0\u00a0\u00a0), Mundschenk",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "San Salvatore di Collalto",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19417",
        "NAME": "Goltstein, Johann Wilhelm (1610\u20131663)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1663 Dez 04",
        "PLACEOFBIRTH": "Breill im Wurmgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19418",
        "NAME": "Goltstein, Friedrich Gerhard (1647\u20131713), K\u00e4mmerer",
        "DATEOFBIRTH": "1647",
        "DATEOFDEATH": "1713",
        "PLACEOFBIRTH": "Breill im Wurmgau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19419",
        "NAME": "Goltstein, Heinrich Theobald (1649\u20131719), Geheimer Rat",
        "DATEOFBIRTH": "1649",
        "DATEOFDEATH": "1719 Jul 12",
        "PLACEOFBIRTH": "Breill im Wurmgau",
        "PLACEOFDEATH": "Mergentheim im Taubertal"
    },
    {
        "ID": "19420",
        "NAME": "Hundbi\u00df, Jobst (1420\u20131482)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1482 Jun 26",
        "PLACEOFBIRTH": "Ravensburg im Schussental",
        "PLACEOFDEATH": "Ravensburg im Schussental"
    },
    {
        "ID": "19421",
        "NAME": "Hundbi\u00df, Jakob (1460\u20131502)",
        "DATEOFBIRTH": "1460~",
        "DATEOFDEATH": "1502 Feb 12",
        "PLACEOFBIRTH": "Ravensburg im Schussental",
        "PLACEOFDEATH": "Ratzenried im Allg\u00e4u"
    },
    {
        "ID": "19422",
        "NAME": "Hundbi\u00df, Sebastian (1500\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Ratzenried im Allg\u00e4u",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19423",
        "NAME": "Hundbi\u00df, Johann Jakob (1530\u20131603)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "Ratzenried im Allg\u00e4u",
        "PLACEOFDEATH": "Ratzenried im Allg\u00e4u:Pfarrkirche"
    },
    {
        "ID": "19424",
        "NAME": "Hundbi\u00df, Georg (1560\u20131605)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1605",
        "PLACEOFBIRTH": "Ratzenried im Allg\u00e4u",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19425",
        "NAME": "Hundbi\u00df, Jobst Ludwig (1590\u20131644), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1644 Jul 31",
        "PLACEOFBIRTH": "Ratzenried im Allg\u00e4u",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19426",
        "NAME": "Hundbi\u00df, Jobst (1470\u20131523)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1523 Feb 11",
        "PLACEOFBIRTH": "Ravensburg im Schussental",
        "PLACEOFDEATH": "Ratzenried im Allg\u00e4u:Pfarrkirche"
    },
    {
        "ID": "19427",
        "NAME": "Hundbi\u00df, Jobst (1505\u20131556)",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1556 Jan 23",
        "PLACEOFBIRTH": "Ratzenried im Allg\u00e4u",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19428",
        "NAME": "Hundbi\u00df, Jobst Ludwig (1548\u20131611)",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1611",
        "PLACEOFBIRTH": "Ratzenried im Allg\u00e4u",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19429",
        "NAME": "Hundbi\u00df, Wolfgang Maximilian (1575\u20131636), Mundschenk",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1636 Nov 15",
        "PLACEOFBIRTH": "Ratzenried im Allg\u00e4u",
        "PLACEOFDEATH": "Efrizweiler"
    },
    {
        "ID": "19430",
        "NAME": "Czernin von Zaborze, Hippolyt (1510\u2013\u00a0\u00a0\u00a0\u00a0), Landeshauptmann von Breslau",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19431",
        "NAME": "Czernin von Zaborze, Hippolyt (1550\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Fuchswinkel am Wei\u00dfbach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19432",
        "NAME": "Czernin von Zaborze, Joachim (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Fuchswinkel am Wei\u00dfbach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19433",
        "NAME": "Promnitz, Benigna (1648\u20131702)",
        "DATEOFBIRTH": "1648 Mar 24",
        "DATEOFDEATH": "1702 Nov 09",
        "PLACEOFBIRTH": "Sorau",
        "PLACEOFDEATH": "Laubach im Wettertal"
    },
    {
        "ID": "19434",
        "NAME": "Paar, Anna (1580\u20131624)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1624 Aug 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sankt Veit am Flaum"
    },
    {
        "ID": "19435",
        "NAME": "Thurn, Laura (1590\u20131646)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1646",
        "PLACEOFBIRTH": "Thybein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19436",
        "NAME": "Thurn, Franz Bernhard (1592\u20131628)",
        "DATEOFBIRTH": "1592 Jul 10",
        "DATEOFDEATH": "1628 Okt 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Stra\u00dfburg an der Drewenz"
    },
    {
        "ID": "19437",
        "NAME": "Thurn, Heinrich (1627\u20131656)",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1656 Aug 29",
        "PLACEOFBIRTH": "Leeuwarden",
        "PLACEOFDEATH": "Riga:Petrikirche"
    },
    {
        "ID": "19438",
        "NAME": "Wrzesowitz, Jakob (1455\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wrzesowitz in M\u00e4hren",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19439",
        "NAME": "Wrzesowitz, Jaroslaus (1487\u20131530)",
        "DATEOFBIRTH": "1487",
        "DATEOFDEATH": "1530",
        "PLACEOFBIRTH": "Kostenblatt am Donnersberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19440",
        "NAME": "Wrzesowitz, Johann (1520\u20131570)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1570",
        "PLACEOFBIRTH": "Kostenblatt am Donnersberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19441",
        "NAME": "Wrzesowitz, Wenzel (1555\u20131592)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "Kostenblatt am Donnersberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19442",
        "NAME": "Wrzesowitz, Magdalena (1585\u20131639)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "Kostenblatt am Donnersberg",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "19443",
        "NAME": "Gierlikowski, Johann (1545\u2013\u00a0\u00a0\u00a0\u00a0), Hartschierhauptmann",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19444",
        "NAME": "Gierlikowski, Johann (1585\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19445",
        "NAME": "Dernbach, Peter (1520\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Dernbach im Hinterland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19446",
        "NAME": "Dernbach, Balthasar (1547\u20131606), Abt von Fulda",
        "DATEOFBIRTH": "1547",
        "DATEOFDEATH": "1606 Mar 15",
        "PLACEOFBIRTH": "Wiesenfeld am Burgwald",
        "PLACEOFDEATH": "Fulda:Dom"
    },
    {
        "ID": "19447",
        "NAME": "Dernbach, Melchior (1570\u20131627)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "Wiesenfeld am Burgwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19448",
        "NAME": "Dernbach, Otto Wilhelm (1611\u20131670)",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1670",
        "PLACEOFBIRTH": "Geisa in der Rh\u00f6n",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19449",
        "NAME": "Dernbach, Hermann Heinrich (1617\u20131644), Truchsess",
        "DATEOFBIRTH": "1617",
        "DATEOFDEATH": "1644",
        "PLACEOFBIRTH": "Geisa in der Rh\u00f6n",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19450",
        "NAME": "Dernbach, Peter Philipp (1619\u20131683), Bischof von W\u00fcrzburg",
        "DATEOFBIRTH": "1619 Jul 01",
        "DATEOFDEATH": "1683 Apr 22",
        "PLACEOFBIRTH": "Geisa in der Rh\u00f6n",
        "PLACEOFDEATH": "W\u00fcrzburg"
    },
    {
        "ID": "19451",
        "NAME": "Hatzfeldt, Luzia (1605\u20131670)",
        "DATEOFBIRTH": "1605 Jun 06",
        "DATEOFDEATH": "1670 Mai 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19452",
        "NAME": "Myslik von Hirschau, Katharina (1577\u20131640)",
        "DATEOFBIRTH": "1577",
        "DATEOFDEATH": "1640 Apr 11",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19453",
        "NAME": "Ligne, Heinrich (1540\u20131593)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1593 Nov 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ciney"
    },
    {
        "ID": "19454",
        "NAME": "Ligne, Eberhard (1570\u20131608)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1608 Dez 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19455",
        "NAME": "Ligne, Maria (1602\u20131679)",
        "DATEOFBIRTH": "1602 Apr 20",
        "DATEOFDEATH": "1679",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19456",
        "NAME": "Zinzendorf, Georg Hartmann (1603\u20131632)",
        "DATEOFBIRTH": "1603",
        "DATEOFDEATH": "1632 Aug 24",
        "PLACEOFBIRTH": "Karlsbach im M\u00fchlkreis",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "19457",
        "NAME": "Zinzendorf, Johann Ferdinand (1628\u20131686)",
        "DATEOFBIRTH": "1628 Aug 03",
        "DATEOFDEATH": "1686 Jul 11",
        "PLACEOFBIRTH": "Karlsbach im M\u00fchlkreis",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19458",
        "NAME": "Zinzendorf, Dorothea (1668\u20131749)",
        "DATEOFBIRTH": "1668 Sep 24",
        "DATEOFDEATH": "1749 Mar 01",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Kattau im Waldviertel"
    },
    {
        "ID": "19459",
        "NAME": "Thun, Alfons Franz (1623\u20131688)",
        "DATEOFBIRTH": "1623 Nov 27",
        "DATEOFDEATH": "1688 Aug 24",
        "PLACEOFBIRTH": "Bragher",
        "PLACEOFDEATH": "Padua"
    },
    {
        "ID": "19460",
        "NAME": "Betz von Betzek, Jakob (1540\u20131573), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1573",
        "PLACEOFBIRTH": "Stuttgart",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19461",
        "NAME": "Rogendorf, Siegmund (1478\u20131507)",
        "DATEOFBIRTH": "1478",
        "DATEOFDEATH": "1507",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19462",
        "NAME": "Rogendorf, Georg (1485\u20131537)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1537",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19463",
        "NAME": "J\u00f6rger von Tollet, Anna Regina (1615\u20131660)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1660",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Passau"
    },
    {
        "ID": "19464",
        "NAME": "Brandis, Anna Maximiliana (1605\u20131637)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19465",
        "NAME": "Maschwander von Schwanau, Elisabeth (1570\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kranichberg am Wechsel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19466",
        "NAME": "Maschwander von Schwanau, Ferdinand (1575\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kranichberg am Wechsel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19467",
        "NAME": "Sch\u00f6naich, Salomena (1520\u20131556)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1556 Dez 07",
        "PLACEOFBIRTH": "Linderode in der Lausitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19468",
        "NAME": "Niedbruck, Kaspar (1525\u20131557), Hofdiener",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1557 Sep 26",
        "PLACEOFBIRTH": "Bolchen im Niedgau",
        "PLACEOFDEATH": "Br\u00fcssel"
    },
    {
        "ID": "19469",
        "NAME": "Hoditz, Sidonius (1600\u20131641)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1641 Jul 29",
        "PLACEOFBIRTH": "Wolframitz in M\u00e4hren",
        "PLACEOFDEATH": "Hildesheim"
    },
    {
        "ID": "19470",
        "NAME": "Thun, Martin (1479\u20131536)",
        "DATEOFBIRTH": "1479 Nov 08",
        "DATEOFDEATH": "1536 Sep 30",
        "PLACEOFBIRTH": "Thun in Tirol",
        "PLACEOFDEATH": "Fragenstein"
    },
    {
        "ID": "19471",
        "NAME": "Vetter von Burgfeistritz, Johann (1540\u20131594)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1594 Mai 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19472",
        "NAME": "Vetter von Burgfeistritz, Friedrich (1572\u20131635)",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1635~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19473",
        "NAME": "Vetter von Burgfeistritz, Johann Balthasar (1600\u20131661)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1661 Sep 27",
        "PLACEOFBIRTH": "Feistritz in der Untersteiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19474",
        "NAME": "Verda von Verdenberg, Maria Z\u00e4zilia (1618\u20131636)",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1636 Jun 16",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "19475",
        "NAME": "Per\u00e9nyi, Sophia (1575\u20131606)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1606 Feb 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19476",
        "NAME": "Per\u00e9nyi, Agnes (1640\u20131680)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1680~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sohl an der Gran"
    },
    {
        "ID": "19477",
        "NAME": "Frangipane di Veglia, Elisabeth (1492\u20131545)",
        "DATEOFBIRTH": "1492 Jan 22",
        "DATEOFDEATH": "1545 Sep 13",
        "PLACEOFBIRTH": "Modrus",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19478",
        "NAME": "Perl, Dorothea (1486\u20131537)",
        "DATEOFBIRTH": "1486",
        "DATEOFDEATH": "1537 Mai 06",
        "PLACEOFBIRTH": "Hall in Tirol",
        "PLACEOFDEATH": "Fragenstein"
    },
    {
        "ID": "19479",
        "NAME": "Szunyogh, Wenzel (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wardein an der Schnellen Kreisch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19480",
        "NAME": "Rottal, Christoph (1450\u20131492)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1492",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19481",
        "NAME": "Nimptsch, Friedrich (1520\u20131578)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1578 Mai 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "R\u00f6versdorf an der Katzbach"
    },
    {
        "ID": "19482",
        "NAME": "Nimptsch, Friedrich (1552\u20131619)",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "1619 Aug 12",
        "PLACEOFBIRTH": "R\u00f6versdorf an der Katzbach",
        "PLACEOFDEATH": "Falkenhain am Tscherbeneyer Wasser"
    },
    {
        "ID": "19483",
        "NAME": "Nimptsch, Konrad (1555\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "R\u00f6versdorf an der Katzbach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19484",
        "NAME": "Nimptsch, Johann (1585\u20131651)",
        "DATEOFBIRTH": "1585 Sep 25",
        "DATEOFDEATH": "1651 Jul 17",
        "PLACEOFBIRTH": "Falkenhain am Tscherbeneyer Wasser",
        "PLACEOFDEATH": "Oelse"
    },
    {
        "ID": "19485",
        "NAME": "Nimptsch, Johann Friedrich (1629\u20131692), Landeshauptmann von Schweidnitz und Jauer",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1692 Apr 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19486",
        "NAME": "Nimptsch, Johann Heinrich (1660\u20131726), Geheimer Rat",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "1726 Mar 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Glogau in Oberschlesien"
    },
    {
        "ID": "19487",
        "NAME": "Nimptsch, Karl Friedrich (1665\u20131723), K\u00e4mmerer",
        "DATEOFBIRTH": "1665~",
        "DATEOFDEATH": "1723",
        "PLACEOFBIRTH": "Stephanshain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19488",
        "NAME": "Dernbach, Johann Otto (1648\u20131697), Geheimer Rat",
        "DATEOFBIRTH": "1648",
        "DATEOFDEATH": "1697 Mai 29",
        "PLACEOFBIRTH": "Arnstein im Spessart",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19489",
        "NAME": "Montard de Noyrell, Niklas (1605\u20131642)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1642 Nov 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Breitenfeld im Lindenthal"
    },
    {
        "ID": "19490",
        "NAME": "Knoll, Katharina (1485\u20131536)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1536",
        "PLACEOFBIRTH": "Salzburg",
        "PLACEOFDEATH": "Grafenegg im Weinviertel"
    },
    {
        "ID": "19491",
        "NAME": "K\u00f6nigsegg, Anna Eusebia (1630\u20131656)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1656 Apr 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Argen im Bodensee"
    },
    {
        "ID": "19492",
        "NAME": "Sulz, Katharina (1630\u20131686)",
        "DATEOFBIRTH": "1630 Jun 16",
        "DATEOFDEATH": "1686 Dez 03",
        "PLACEOFBIRTH": "Tiengen im Klettgau",
        "PLACEOFDEATH": "Argen im Bodensee"
    },
    {
        "ID": "19493",
        "NAME": "Rueber von Pixendorf, Christoph (1480\u20131550)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1550~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19494",
        "NAME": "Rueber von Pixendorf, Wolfgang (1515\u20131555)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1555 Mai 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Grafenegg im Weinviertel"
    },
    {
        "ID": "19495",
        "NAME": "Rueber von Pixendorf, Leopold (1520\u20131556), Abt von G\u00f6ttweig",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1556 Aug 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "G\u00f6ttweig"
    },
    {
        "ID": "19496",
        "NAME": "Rueber von Pixendorf, Ferdinand (1530\u20131602), Truchsess",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Minoritenkirche"
    },
    {
        "ID": "19497",
        "NAME": "Rueber von Pixendorf, Christoph (1510\u20131581)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1581",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19498",
        "NAME": "Kunowitz, Theoderich (1520\u20131582)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1582 Sep 04",
        "PLACEOFBIRTH": "Brod an der Olsawa",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "19499",
        "NAME": "Kunowitz, Johann (1550\u20131579), Mundschenk",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1579",
        "PLACEOFBIRTH": "Brod an der Olsawa",
        "PLACEOFDEATH": "Nimwegen"
    },
    {
        "ID": "19501",
        "NAME": "Schilling von Canstatt, Heinrich (1455\u20131533)",
        "DATEOFBIRTH": "1455~",
        "DATEOFDEATH": "1533 Jan 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Neuffen"
    },
    {
        "ID": "19502",
        "NAME": "Schilling von Canstatt, Georg (1487\u20131554), Gro\u00dfprior des Malteserordens in Deutschland",
        "DATEOFBIRTH": "1487",
        "DATEOFDEATH": "1554 Feb 02",
        "PLACEOFBIRTH": "Neuffen",
        "PLACEOFDEATH": "Heitersheim im Breisgau"
    },
    {
        "ID": "19503",
        "NAME": "Schilling von Canstatt, Anna (1485\u20131546)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1546 Feb 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pforzheim"
    },
    {
        "ID": "19504",
        "NAME": "Clary, Joseph (1540\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Florenz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19505",
        "NAME": "Clary, Franz (1575\u20131625)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1625~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19506",
        "NAME": "Clary, Hieronym (1605\u20131671)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1671",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19507",
        "NAME": "Aldringen, Leonhard (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Diedenhofen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19508",
        "NAME": "Aldringen, Mark (1592\u20131664), Bischof von Seckau",
        "DATEOFBIRTH": "1592 Nov 05",
        "DATEOFDEATH": "1664 Feb 03",
        "PLACEOFBIRTH": "Diedenhofen",
        "PLACEOFDEATH": "Seckau im Murtal"
    },
    {
        "ID": "19509",
        "NAME": "Schilling, Ludwig (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19510",
        "NAME": "Swetkowitz, Lassel (1435\u20131491)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1491",
        "PLACEOFBIRTH": "Pettau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19511",
        "NAME": "Swetkowitz, Johann (1470\u20131518)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1518",
        "PLACEOFBIRTH": "Pettau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19512",
        "NAME": "Swetkowitz, Eleonora (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Mitterburg in Istrien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19513",
        "NAME": "Bombast von Hohenheim, Johann (1400\u20131456)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1456",
        "PLACEOFBIRTH": "Hohenheim auf den Fildern",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19514",
        "NAME": "Bombast von Hohenheim, Wilhelm (1435\u20131491)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1491",
        "PLACEOFBIRTH": "Hohenheim auf den Fildern",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19515",
        "NAME": "Bombast von Hohenheim, Friedrich (1470\u20131540)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "1540~",
        "PLACEOFBIRTH": "Hohenheim auf den Fildern",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19516",
        "NAME": "Bombast von Hohenheim, Georg (1505\u20131566), Gro\u00dfprior des Malteserordens in Deutschland",
        "DATEOFBIRTH": "1505~",
        "DATEOFDEATH": "1566 Dez 10",
        "PLACEOFBIRTH": "Hohenheim auf den Fildern",
        "PLACEOFDEATH": "Heitersheim im Breisgau"
    },
    {
        "ID": "19517",
        "NAME": "Bombast von Hohenheim, Anna (1515\u20131574)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1574 Jun 06",
        "PLACEOFBIRTH": "Hohenheim auf den Fildern",
        "PLACEOFDEATH": "Sulzburg im Breisgau:Schlosskirche"
    },
    {
        "ID": "19518",
        "NAME": "Bombast von Hohenheim, Georg (1430\u20131499)",
        "DATEOFBIRTH": "1430~",
        "DATEOFDEATH": "1499",
        "PLACEOFBIRTH": "Hohenheim auf den Fildern",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19519",
        "NAME": "Bombast von Hohenheim, Wilhelm (1457\u20131534)",
        "DATEOFBIRTH": "1457",
        "DATEOFDEATH": "1534 Sep 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Villach in K\u00e4rnten"
    },
    {
        "ID": "19520",
        "NAME": "Bombast von Hohenheim, Theophrast (1493\u20131541)",
        "DATEOFBIRTH": "1493 Nov 26",
        "DATEOFDEATH": "1541 Sep 24",
        "PLACEOFBIRTH": "Egg an der Sihl",
        "PLACEOFDEATH": "Salzburg"
    },
    {
        "ID": "19521",
        "NAME": "Ruppau, Johann (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19522",
        "NAME": "Ruppau, Wilhelm (1580\u20131641)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1641 Sep 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Leitmeritz"
    },
    {
        "ID": "19523",
        "NAME": "Rheingraf zum Stein, Johann Philipp (1545\u20131569)",
        "DATEOFBIRTH": "1545 Sep 30",
        "DATEOFDEATH": "1569 Okt 03",
        "PLACEOFBIRTH": "Neuviller an der Mosel",
        "PLACEOFDEATH": "Moncontour im Poitou"
    },
    {
        "ID": "19524",
        "NAME": "Rheingraf zum Stein, Claudia (1569\u20131632)",
        "DATEOFBIRTH": "1569 Nov 12",
        "DATEOFDEATH": "1632 Feb 15",
        "PLACEOFBIRTH": "Neuviller an der Mosel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19525",
        "NAME": "Ligne, Elisabeth (1623\u20131678)",
        "DATEOFBIRTH": "1623",
        "DATEOFDEATH": "1678 Aug 17",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "19526",
        "NAME": "Ligne, Oktavius (1633\u20131693)",
        "DATEOFBIRTH": "1633 Mar 12",
        "DATEOFDEATH": "1693 Jul 29",
        "PLACEOFBIRTH": "Barben\u00e7on",
        "PLACEOFDEATH": "Neerwinden"
    },
    {
        "ID": "19527",
        "NAME": "Auer, Johann (1550\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19528",
        "NAME": "Hohenzollern, Eleonora (1551\u20131605)",
        "DATEOFBIRTH": "1551 Feb 15",
        "DATEOFDEATH": "1605 Apr 02",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19529",
        "NAME": "Hohenzollern, Maria (1544\u20131611)",
        "DATEOFBIRTH": "1544 Aug 28",
        "DATEOFDEATH": "1611 Dez 15",
        "PLACEOFBIRTH": "Sigmaringen",
        "PLACEOFDEATH": "Landsberg am Lech"
    },
    {
        "ID": "19530",
        "NAME": "Wolfstein, Albrecht (1420\u20131470)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1470 Aug 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ramallah"
    },
    {
        "ID": "19531",
        "NAME": "Wolfstein, Albrecht (1466\u20131532), Truchsess",
        "DATEOFBIRTH": "1466 Jul 04",
        "DATEOFDEATH": "1532",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19532",
        "NAME": "Wolfstein, Wilhelm (1453\u20131518)",
        "DATEOFBIRTH": "1453 Apr 08",
        "DATEOFDEATH": "1518 Mar 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Seligenporten:Klosterkirche"
    },
    {
        "ID": "19533",
        "NAME": "Wolfstein, Johann (1501\u20131558)",
        "DATEOFBIRTH": "1501 Jul 08",
        "DATEOFDEATH": "1558 Feb 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pyrbaum:Pfarrkirche"
    },
    {
        "ID": "19534",
        "NAME": "Wolfstein, Adam (1495\u20131547)",
        "DATEOFBIRTH": "1495~",
        "DATEOFDEATH": "1547",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19535",
        "NAME": "Wolfstein, Johann Andreas (1541\u20131585)",
        "DATEOFBIRTH": "1541 Feb 19",
        "DATEOFDEATH": "1585 Okt 19",
        "PLACEOFBIRTH": "Pyrbaum",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19536",
        "NAME": "Wolfstein, Johann Adam (1573\u20131617)",
        "DATEOFBIRTH": "1573 Dez 10",
        "DATEOFDEATH": "1617 Nov 12",
        "PLACEOFBIRTH": "Pyrbaum",
        "PLACEOFDEATH": "M\u00fchlhausen im Sulztal:Schlosskirche"
    },
    {
        "ID": "19537",
        "NAME": "Wolfstein, Georg Albrecht (1600\u20131658)",
        "DATEOFBIRTH": "1600 Mai 06",
        "DATEOFDEATH": "1658 Apr 02",
        "PLACEOFBIRTH": "Pyrbaum",
        "PLACEOFDEATH": "M\u00fchlhausen im Sulztal:Schlosskirche"
    },
    {
        "ID": "19538",
        "NAME": "Wolfstein, Johann Friedrich (1604\u20131650)",
        "DATEOFBIRTH": "1604 Nov 02",
        "DATEOFDEATH": "1650 Mai 07",
        "PLACEOFBIRTH": "Pyrbaum",
        "PLACEOFDEATH": "Pyrbaum:Pfarrkirche"
    },
    {
        "ID": "19539",
        "NAME": "Wolfstein, Albrecht Friedrich (1644\u20131693)",
        "DATEOFBIRTH": "1644 Mai 13",
        "DATEOFDEATH": "1693 Nov 06",
        "PLACEOFBIRTH": "Pyrbaum",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19540",
        "NAME": "Wolfstein, Johann Albrecht (1574\u20131620)",
        "DATEOFBIRTH": "1574 Nov 03",
        "DATEOFDEATH": "1620 Jun 06",
        "PLACEOFBIRTH": "Pyrbaum",
        "PLACEOFDEATH": "Crailsheim:Pfarrkirche"
    },
    {
        "ID": "19541",
        "NAME": "Nesselrode, Bertram (1592\u20131678)",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1678 Jun 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Herten"
    },
    {
        "ID": "19542",
        "NAME": "Nesselrode, Bertram (1620\u20131701)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1701",
        "PLACEOFBIRTH": "Ehreshoven",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19543",
        "NAME": "Nesselrode, Wilhelm Franz (1652\u20131732), Bischof von F\u00fcnfkirchen",
        "DATEOFBIRTH": "1652 Jun 26",
        "DATEOFDEATH": "1732 Sep 29",
        "PLACEOFBIRTH": "D\u00fcsseldorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19544",
        "NAME": "Nesselrode, Philipp Wilhelm (1650\u20131704)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1704",
        "PLACEOFBIRTH": "D\u00fcsseldorf",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19545",
        "NAME": "Nesselrode, Franz (1635\u20131707), K\u00e4mmerer",
        "DATEOFBIRTH": "1635 Jun 23",
        "DATEOFDEATH": "1707 Dez 05",
        "PLACEOFBIRTH": "Herten",
        "PLACEOFDEATH": "Herten"
    },
    {
        "ID": "19546",
        "NAME": "Verda von Verdenberg, Jakob (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19547",
        "NAME": "Verda von Verdenberg, Johann Peter (1590\u20131635)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1635 Jun 22",
        "PLACEOFBIRTH": "Campione am Luganersee",
        "PLACEOFDEATH": "Judenau im Tullnerfeld"
    },
    {
        "ID": "19548",
        "NAME": "Verda von Verdenberg, Alexander (1625\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1672",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19549",
        "NAME": "Verda von Verdenberg, Johann Philipp (1660\u20131733), K\u00e4mmerer",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "1733 Apr 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Br\u00fcnn in M\u00e4hren"
    },
    {
        "ID": "19550",
        "NAME": "Rottal, Margarita (1480\u20131518)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1518 Okt 14",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Lankowitz:Franziskanerkirche"
    },
    {
        "ID": "19556",
        "NAME": "Purgstall, Adam (1535\u20131597)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19557",
        "NAME": "Purgstall, Georg Christoph (1570\u20131619)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19558",
        "NAME": "Purgstall, Johann Georg (1608\u20131638)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19559",
        "NAME": "Purgstall, Johann Ernst (1637\u20131695), Geheimer Rat",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1695 Mar 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19560",
        "NAME": "M\u00f6rsperg, Georg Friedrich (1627\u20131690), Geheimer Rat",
        "DATEOFBIRTH": "1627 Apr 02",
        "DATEOFDEATH": "1690 Feb 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19561",
        "NAME": "Rogendorf, Georg (1536\u20131589)",
        "DATEOFBIRTH": "1536",
        "DATEOFDEATH": "1589 Sep 13",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19562",
        "NAME": "Rogendorf, Kaspar (1565\u20131597)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19563",
        "NAME": "Rogendorf, Susanna (1573\u20131616)",
        "DATEOFBIRTH": "1573",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19564",
        "NAME": "Rogendorf, Wilhelm (1568\u20131603)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1603 Okt 04",
        "PLACEOFBIRTH": "P\u00f6ggstall im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19565",
        "NAME": "Zahradek, Johann (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19566",
        "NAME": "Zahradek, Ernst (1525\u20131598)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19567",
        "NAME": "Zahradek, Wenzel (1555\u20131610)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1610",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19568",
        "NAME": "Zahradek, Johann (1560\u20131613)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1613 Feb 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19569",
        "NAME": "Zahradek, Georg (1565\u20131629)",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Rottowitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19570",
        "NAME": "Zahradek, Ulrich (1520\u20131588)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19571",
        "NAME": "Zahradek, Johann (1550\u20131608)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19572",
        "NAME": "Zahradek, Karl (1590\u20131658), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19573",
        "NAME": "Zahradek, Heinrich (1580\u20131627)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19574",
        "NAME": "Landau, Katharina (1585\u20131618)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "Haus im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19575",
        "NAME": "Polheim, Siegmund Ludwig (1565\u20131622), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1565 Nov 26",
        "DATEOFDEATH": "1622",
        "PLACEOFBIRTH": "Lichtenegg im Hausruckviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19576",
        "NAME": "Starhemberg, Margarita (1573\u20131620)",
        "DATEOFBIRTH": "1573",
        "DATEOFDEATH": "1620 Jan 29",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "19577",
        "NAME": "Wratislaw von Mitrowitz, Margarita (1615\u20131681)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1681 Mar 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19578",
        "NAME": "Lazansky von Bukowa, Ferdinand Rudolf (1600\u20131657)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1657 Aug 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19579",
        "NAME": "Lazansky von Bukowa, Franz Adam (1635\u20131662), Mundschenk",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1662",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19580",
        "NAME": "Lazansky von Bukowa, Karl Maximilian (1639\u20131695), Geheimer Rat",
        "DATEOFBIRTH": "1639",
        "DATEOFDEATH": "1695 Mai 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19581",
        "NAME": "Liechtenstein von Nikolsburg, Karl Euseb (1611\u20131684)",
        "DATEOFBIRTH": "1611 Sep 12",
        "DATEOFDEATH": "1684 Apr 05",
        "PLACEOFBIRTH": "Feldsberg im Weinviertel",
        "PLACEOFDEATH": "Kosteletz im Schwarzenwald"
    },
    {
        "ID": "19582",
        "NAME": "Liechtenstein von Nikolsburg, Johann Adam (1656\u20131712), Geheimer Rat",
        "DATEOFBIRTH": "1656 Nov 30",
        "DATEOFDEATH": "1712 Jun 16",
        "PLACEOFBIRTH": "Br\u00fcnn in M\u00e4hren",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19583",
        "NAME": "Fugger, Johann Otto (1631\u20131687), K\u00e4mmerer",
        "DATEOFBIRTH": "1631 Aug 15",
        "DATEOFDEATH": "1687 Jul 26",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "Hambach in der Eifel"
    },
    {
        "ID": "19584",
        "NAME": "Trautson, Elisabeth (1687\u20131766)",
        "DATEOFBIRTH": "1687 Jun 14",
        "DATEOFDEATH": "1766 Apr 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "19585",
        "NAME": "Fugger, Anton Ernst (1681\u20131745)",
        "DATEOFBIRTH": "1681 Mai 15",
        "DATEOFDEATH": "1745 Mai 25",
        "PLACEOFBIRTH": "Gl\u00f6tt in Schwaben",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "19586",
        "NAME": "Veterani, Friedrich (1643\u20131695), Geheimer Rat",
        "DATEOFBIRTH": "1643",
        "DATEOFDEATH": "1695 Sep 21",
        "PLACEOFBIRTH": "Urbino",
        "PLACEOFDEATH": "Lugosch im Banat"
    },
    {
        "ID": "19587",
        "NAME": "Zahradek, Euseb (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19599",
        "NAME": "Sparwein, Jakob (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19605",
        "NAME": "Forg\u00e1ch, Margarita (1572\u20131624)",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1624",
        "PLACEOFBIRTH": "Hertnecht",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19606",
        "NAME": "Zahradek, Karl Deodat (1610\u20131651)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1651 Aug 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19607",
        "NAME": "Aldringen, Anna (1608\u20131661)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1661 Dez 15",
        "PLACEOFBIRTH": "Diedenhofen",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19608",
        "NAME": "Clary, Johann Mark Georg (1638\u20131700), Reichshofrat",
        "DATEOFBIRTH": "1638 Mar 04",
        "DATEOFDEATH": "1700 Apr 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19609",
        "NAME": "Bertoldi di Denno, Bartlome (1640\u20131683), Geheimer Rat",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1683",
        "PLACEOFBIRTH": "Thenn im Nonstal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19612",
        "NAME": "Herberstein, Esther (1595\u20131639)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19613",
        "NAME": "Herberstein, Johann Georg (1660\u20131686), K\u00e4mmerer",
        "DATEOFBIRTH": "1660 Mai 08",
        "DATEOFDEATH": "1686 Jul 13",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "19614",
        "NAME": "Herberstein, Christoph (1520\u20131541), Edelknabe",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1541",
        "PLACEOFBIRTH": "Neuberg am Ringkogel",
        "PLACEOFDEATH": "Ofen"
    },
    {
        "ID": "19615",
        "NAME": "Herberstein, Johann Gregor (1525\u20131548), Truchsess",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1548 Apr 05",
        "PLACEOFBIRTH": "Neuberg am Ringkogel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19616",
        "NAME": "Herberstein, Johann (1440\u20131480)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1480~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Herberstein an der Feistritz:Johanneskirche"
    },
    {
        "ID": "19617",
        "NAME": "Herberstein, Erhard (1450\u20131494), Truchsess",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1494",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Herberstein an der Feistritz:Johanneskirche"
    },
    {
        "ID": "19618",
        "NAME": "Herberstein, Georg (1435\u20131491), Truchsess",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1491",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "M\u00e4hrenfels in Istrien"
    },
    {
        "ID": "19619",
        "NAME": "Herberstein, Johann Franz (1635\u20131664), K\u00e4mmerer",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": "F\u00fcnfkirchen"
    },
    {
        "ID": "19620",
        "NAME": "Herberstein, Anton (1445\u20131496), K\u00e4mmerer",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1496",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Schottenkirche"
    },
    {
        "ID": "19621",
        "NAME": "Herberstein, Wolfgang Siegmund (1590\u20131640)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1640~",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Pyrbaum"
    },
    {
        "ID": "19622",
        "NAME": "Herberstein, Siegmund Ferdinand (1625\u20131678), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19623",
        "NAME": "Herberstein, Maximilian (1609\u20131688)",
        "DATEOFBIRTH": "1609 Okt 10",
        "DATEOFDEATH": "1688",
        "PLACEOFBIRTH": "Windenau an der Drau",
        "PLACEOFDEATH": "Waltershausen"
    },
    {
        "ID": "19624",
        "NAME": "Herberstein, Benigna (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19625",
        "NAME": "Herberstein, Magdalena (1552\u20131618)",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "1618 Dez 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19626",
        "NAME": "Herberstein, Erasam Friedrich (1631\u20131691), K\u00e4mmerer",
        "DATEOFBIRTH": "1631",
        "DATEOFDEATH": "1691 Feb 06",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Gutenhag"
    },
    {
        "ID": "19627",
        "NAME": "Herberstein, Johann Jakob (1590\u20131643)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "Gutenhag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19628",
        "NAME": "Herberstein, Johann Gotthard (1620\u20131681), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1681",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19629",
        "NAME": "Herberstein, Johann Anton (1625\u20131678), K\u00e4mmerer",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1678",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19630",
        "NAME": "Herberstein, Johann Georg (1591\u20131663), Bischof von Regensburg",
        "DATEOFBIRTH": "1591 Aug 19",
        "DATEOFDEATH": "1663 Jun 12",
        "PLACEOFBIRTH": "Salzburg",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "19631",
        "NAME": "Herberstein, Johann Friedrich (1590\u20131657), K\u00e4mmerer",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1657",
        "PLACEOFBIRTH": "Salzburg",
        "PLACEOFDEATH": "Glatz"
    },
    {
        "ID": "19632",
        "NAME": "Herberstein, Siegmund Christoph (1644\u20131716), Bischof von Laibach",
        "DATEOFBIRTH": "1644 Feb 13",
        "DATEOFDEATH": "1716 Jul 20",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Perugia"
    },
    {
        "ID": "19633",
        "NAME": "Starhemberg, Erasam (1595\u20131664)",
        "DATEOFBIRTH": "1595 Mai 13",
        "DATEOFDEATH": "1664 Apr 02",
        "PLACEOFBIRTH": "Riedegg im M\u00fchlviertel",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "19634",
        "NAME": "Herberstein, Leopold Christoph (1594\u20131667)",
        "DATEOFBIRTH": "1594 Okt 16",
        "DATEOFDEATH": "1667 Nov 16",
        "PLACEOFBIRTH": "Judenburg im Murtal",
        "PLACEOFDEATH": "Seefeld im Pulkautal"
    },
    {
        "ID": "19635",
        "NAME": "Herberstein, Ruprecht (1509\u20131539)",
        "DATEOFBIRTH": "1509",
        "DATEOFDEATH": "1539",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19636",
        "NAME": "Herberstein, Johann Friedrich (1570\u20131604), K\u00e4mmerer",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1604",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Konstantinopel"
    },
    {
        "ID": "19637",
        "NAME": "Herberstein, Adolf Friedrich (1625\u20131683)",
        "DATEOFBIRTH": "1625~",
        "DATEOFDEATH": "1683",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19638",
        "NAME": "Marschall von Pappenheim, Wolfgang (1535\u20131585)",
        "DATEOFBIRTH": "1535 Nov 27",
        "DATEOFDEATH": "1585 Mar 06",
        "PLACEOFBIRTH": "Rothenstein im Allg\u00e4u",
        "PLACEOFDEATH": "Pappenheim an der Altm\u00fchl:Marienkirche"
    },
    {
        "ID": "19639",
        "NAME": "Katzensteiner von Katzenstein, Johann Baptist (1560\u2013\u00a0\u00a0\u00a0\u00a0), Hofkriegsratssekret\u00e4r",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Stra\u00dfburg in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19640",
        "NAME": "D\u00f6nhoff, Hermann (1520\u20131567)",
        "DATEOFBIRTH": "1520~",
        "DATEOFDEATH": "1567 Sep 15",
        "PLACEOFBIRTH": "Strasden",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19641",
        "NAME": "D\u00f6nhoff, Otto (1550\u20131609)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1609",
        "PLACEOFBIRTH": "Strasden",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19642",
        "NAME": "D\u00f6nhoff, Heinrich (1580\u20131626)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "Drogosze",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19643",
        "NAME": "D\u00f6nhoff, Gerhard (1554\u20131602)",
        "DATEOFBIRTH": "1554",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "Strasden",
        "PLACEOFDEATH": "Tartu"
    },
    {
        "ID": "19644",
        "NAME": "D\u00f6nhoff, Kaspar (1588\u20131645)",
        "DATEOFBIRTH": "1588 Jan 01",
        "DATEOFDEATH": "1645 Jul 04",
        "PLACEOFBIRTH": "Tartu",
        "PLACEOFDEATH": "Warszawa"
    },
    {
        "ID": "19645",
        "NAME": "D\u00f6nhoff, Anna (1620\u20131656)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "Tartu",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19646",
        "NAME": "Vetter von Burgfeistritz, Johann Weikhard (1605\u20131675), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1675",
        "PLACEOFBIRTH": "Feistritz in der Untersteiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19647",
        "NAME": "Vetter von Burgfeistritz, Michael Weikhard (1635\u20131695), K\u00e4mmerer",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1695 Feb 06",
        "PLACEOFBIRTH": "Feistritz in der Untersteiermark",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19648",
        "NAME": "Grei\u00df zum Wald, Wolfgang Theoderich (1568\u20131608)",
        "DATEOFBIRTH": "1568",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19649",
        "NAME": "Swarowa, Karl (1585\u20131628), Edelknabe",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "Suchomasty",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19650",
        "NAME": "Pettenbeck, Maria (1574\u20131619)",
        "DATEOFBIRTH": "1574 Feb 05",
        "DATEOFDEATH": "1619 Dez 05",
        "PLACEOFBIRTH": "M\u00fcnchen",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "19651",
        "NAME": "Herberstein, Johann Georg (1605\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19652",
        "NAME": "Herberstein, Johann Ferdinand (1608\u20131673)",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1673 Jan 22",
        "PLACEOFBIRTH": "Herberstein an der Feistritz",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19653",
        "NAME": "Herberstein, Ferdinand Ehrenreich (1619\u20131692), Reichshofrat",
        "DATEOFBIRTH": "1619",
        "DATEOFDEATH": "1692 Jun 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19654",
        "NAME": "Hohenzollern, Barbara (1495\u20131552)",
        "DATEOFBIRTH": "1495",
        "DATEOFDEATH": "1552 Sep 24",
        "PLACEOFBIRTH": "Ansbach",
        "PLACEOFDEATH": "Elbogen an der Eger"
    },
    {
        "ID": "19655",
        "NAME": "Herberstein, Julius (1539\u20131605), Hofdiener",
        "DATEOFBIRTH": "1539",
        "DATEOFDEATH": "1605 Apr 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Dorotheerkirche"
    },
    {
        "ID": "19656",
        "NAME": "Hofkirchen, Johann Leonhard (1556\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1556",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kollmitz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19657",
        "NAME": "Kurtz von Senftenau, Maria Eleonora (1637\u20131687)",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1687 Feb 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19658",
        "NAME": "Rechenberg, Helena (1585\u20131628)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1628",
        "PLACEOFBIRTH": "Wartenberg an der Ochel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19659",
        "NAME": "Khevenh\u00fcller, Elisabeth (1569\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1569 Nov 01",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19660",
        "NAME": "Khevenh\u00fcller, Anna Maria (1585\u20131629)",
        "DATEOFBIRTH": "1585 Jun 21",
        "DATEOFDEATH": "1629",
        "PLACEOFBIRTH": "Klagenfurt am W\u00f6rthersee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19664",
        "NAME": "Dernbach, Margarita (1555\u20131613)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1613 Mai 16",
        "PLACEOFBIRTH": "Wiesenfeld am Burgwald",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19665",
        "NAME": "Ny\u00e1ry von Bedegh, Christina (1604\u20131641)",
        "DATEOFBIRTH": "1604 Okt 31",
        "DATEOFDEATH": "1641 Feb 17",
        "PLACEOFBIRTH": "Wardein an der Thei\u00df",
        "PLACEOFDEATH": "Schintau an der Waag"
    },
    {
        "ID": "19666",
        "NAME": "Argote, Agnes (1570\u20131646)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1646 Mar 08",
        "PLACEOFBIRTH": "Aversa",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19667",
        "NAME": "Eitzing, Pudenziana (1560\u20131619)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1619 Dez 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19668",
        "NAME": "Eitzing, Judith (1570\u20131618)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19669",
        "NAME": "Eitzing, Polyxena (1580\u20131648)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1648",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19670",
        "NAME": "Volkra, Polyxena (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Steinabrunn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19671",
        "NAME": "Swetkowitz, Katharina (1507\u20131575)",
        "DATEOFBIRTH": "1507",
        "DATEOFDEATH": "1575 Apr 21",
        "PLACEOFBIRTH": "Salzburg",
        "PLACEOFDEATH": "G\u00fcssing"
    },
    {
        "ID": "19672",
        "NAME": "Swetkowitz, Elisabeth (1517\u20131571)",
        "DATEOFBIRTH": "1517",
        "DATEOFDEATH": "1571 Mar 04",
        "PLACEOFBIRTH": "Plankenstein an der Drann",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19673",
        "NAME": "Swetkowitz, Anna (1518\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1518",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Plankenstein an der Drann",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19674",
        "NAME": "Swetkowitz, Maria (1521\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1521",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19675",
        "NAME": "Swetkowitz, Klara (1522\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19676",
        "NAME": "Starhemberg, Susanna (1568\u20131617)",
        "DATEOFBIRTH": "1568 Jul 09",
        "DATEOFDEATH": "1617 Jan 24",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Weinberg im M\u00fchlviertel"
    },
    {
        "ID": "19677",
        "NAME": "Zelking, Justina (1593\u20131632)",
        "DATEOFBIRTH": "1593",
        "DATEOFDEATH": "1632 Sep 20",
        "PLACEOFBIRTH": "Weinberg im M\u00fchlviertel",
        "PLACEOFDEATH": "Pirna an der Elbe"
    },
    {
        "ID": "19678",
        "NAME": "Smirzicz, Katharina (1590\u20131612)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19679",
        "NAME": "Kinsky, Katharina (1569\u20131643)",
        "DATEOFBIRTH": "1569",
        "DATEOFDEATH": "1643 Okt 31",
        "PLACEOFBIRTH": "Eger in B\u00f6hmen",
        "PLACEOFDEATH": "Dresden"
    },
    {
        "ID": "19680",
        "NAME": "Helfenstein, Eleonora (1606\u20131629)",
        "DATEOFBIRTH": "1606 Okt 18",
        "DATEOFDEATH": "1629 Jul 28",
        "PLACEOFBIRTH": "Neufra an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19681",
        "NAME": "Renesse, Florentina (1620\u20131665)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1665 Feb 24",
        "PLACEOFBIRTH": "Warfus\u00e9e",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19682",
        "NAME": "Renesse, Eleonora (1615\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Warfus\u00e9e",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19683",
        "NAME": "Herberstein, Maria Magdalena (1592\u20131659)",
        "DATEOFBIRTH": "1592",
        "DATEOFDEATH": "1659 Mai 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "N\u00fcrnberg:Johannisfriedhof"
    },
    {
        "ID": "19684",
        "NAME": "Rosenberger von Lerchenau, Johann Friedrich (1654\u20131723), Geheimer Rat",
        "DATEOFBIRTH": "1654 Sep 07",
        "DATEOFDEATH": "1723 Nov 18",
        "PLACEOFBIRTH": "Klagenfurt am W\u00f6rthersee",
        "PLACEOFDEATH": "Klagenfurt am W\u00f6rthersee"
    },
    {
        "ID": "19685",
        "NAME": "Zahradek, Elisabeth (1610\u20131665)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19686",
        "NAME": "Breunner, Maria Eleonora (1629\u20131649)",
        "DATEOFBIRTH": "1629 Aug 30",
        "DATEOFDEATH": "1649 Mar 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19687",
        "NAME": "Pr\u00fcschenk von Hardegg, Magdalena (1600\u20131651)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1651 Aug 30",
        "PLACEOFBIRTH": "Wolfpassing am Wagram",
        "PLACEOFDEATH": "Pernau in Livland"
    },
    {
        "ID": "19688",
        "NAME": "Khevenh\u00fcller, Katharina (1633\u20131714)",
        "DATEOFBIRTH": "1633",
        "DATEOFDEATH": "1714 Jan 03",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19689",
        "NAME": "Kuefstein, Susanna (1633\u20131697)",
        "DATEOFBIRTH": "1633",
        "DATEOFDEATH": "1697 Jan 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Benatek an der Iser"
    },
    {
        "ID": "19690",
        "NAME": "Vaud\u00e9mont, Klaudia (1612\u20131648)",
        "DATEOFBIRTH": "1612 Okt 06",
        "DATEOFDEATH": "1648 Aug 02",
        "PLACEOFBIRTH": "Nancy",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19691",
        "NAME": "Vetter von Burgfeistritz, Katharina Susanna (1646\u20131727)",
        "DATEOFBIRTH": "1646",
        "DATEOFDEATH": "1727 Apr 04",
        "PLACEOFBIRTH": "Feistritz in der Untersteiermark",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19695",
        "NAME": "Cavriani, Elisabeth (1635\u20131705)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "1705",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19696",
        "NAME": "Thurn, Polyxena (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19697",
        "NAME": "Desfours, Anna (1615\u20131673)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1673",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Besan\u00e7on"
    },
    {
        "ID": "19698",
        "NAME": "Wolkenstein, Maximiliana (1595\u20131623)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1623 Apr 24",
        "PLACEOFBIRTH": "Trostburg am Eisack",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "19699",
        "NAME": "Marschall von Pappenheim, Magdalena (1549\u20131602)",
        "DATEOFBIRTH": "1549",
        "DATEOFDEATH": "1602 Jun 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Jebenhausen"
    },
    {
        "ID": "19701",
        "NAME": "Sulz, Maria Barbara (1588\u20131625)",
        "DATEOFBIRTH": "1588 Dez 13",
        "DATEOFDEATH": "1625 Mar 01",
        "PLACEOFBIRTH": "Vaduz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19702",
        "NAME": "Leiningen, Polyxena (1617\u20131668)",
        "DATEOFBIRTH": "1617",
        "DATEOFDEATH": "1668 Jan 08",
        "PLACEOFBIRTH": "Heidesheim an der Eis",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19703",
        "NAME": "Pernegg, Richarda (1415\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1415~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Pernegg an der Mur",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19704",
        "NAME": "Fraunberg, Maximiliana (1510\u20131559)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1559 Sep 14",
        "PLACEOFBIRTH": "Haag am Inn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19705",
        "NAME": "Marschall von Pappenheim, Anna (1420\u20131464)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1464",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19706",
        "NAME": "Fraunberg, Anna (1440\u20131498)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "1498",
        "PLACEOFBIRTH": "Haag am Inn",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19707",
        "NAME": "Ungnad von Weissenwolff, Anna (1437\u20131460)",
        "DATEOFBIRTH": "1437",
        "DATEOFDEATH": "1460 Nov 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19708",
        "NAME": "Rheingraf zum Stein, Anna Amalia (1610\u20131676)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1676",
        "PLACEOFBIRTH": "Kyrburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19709",
        "NAME": "K\u00e4mmerer von Worms genannt Dalberg, Katharina (1600\u20131634)",
        "DATEOFBIRTH": "1600",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "Worms",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19710",
        "NAME": "Sch\u00f6nborn, Katharina Elisabeth (1652\u20131707)",
        "DATEOFBIRTH": "1652 Mai 01",
        "DATEOFDEATH": "1707",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19711",
        "NAME": "Trczka von Leipa, Johanna (1607\u20131651)",
        "DATEOFBIRTH": "1607",
        "DATEOFDEATH": "1651 Okt 05",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "P\u00edsek an der Otava:Dominikanerkloster"
    },
    {
        "ID": "19712",
        "NAME": "Berka von der Duba, Ludmila (1515\u20131558)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1558 Okt 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19713",
        "NAME": "Schlick, Barbara (1537\u20131581)",
        "DATEOFBIRTH": "1537",
        "DATEOFDEATH": "1581",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19714",
        "NAME": "Truchsess von Waldburg, Johanna Euphrosina (1599\u20131651)",
        "DATEOFBIRTH": "1599 Apr 05",
        "DATEOFDEATH": "1651 Sep 09",
        "PLACEOFBIRTH": "Wolfegg in Schwaben",
        "PLACEOFDEATH": "Langnau im Argental"
    },
    {
        "ID": "19715",
        "NAME": "Schlick, Anna (1562\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1562",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neudek an der Rohlau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19716",
        "NAME": "Schlick, Lukrezia (1576\u20131613)",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1613 Mar 04",
        "PLACEOFBIRTH": "Neudek an der Rohlau",
        "PLACEOFDEATH": "Welckersdorf in Schlesien"
    },
    {
        "ID": "19717",
        "NAME": "Ungnad von Weissenwolff, Anna (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19718",
        "NAME": "L\u00f6sch, Anna Jakobina (1550\u20131580)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1580",
        "PLACEOFBIRTH": "Hilgertshausen",
        "PLACEOFDEATH": "Aholming in der Isarau"
    },
    {
        "ID": "19719",
        "NAME": "Harrach, Ursula (1522\u20131554)",
        "DATEOFBIRTH": "1522",
        "DATEOFDEATH": "1554 Sep 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "19720",
        "NAME": "Leiningen, Ursula (1583\u20131638)",
        "DATEOFBIRTH": "1583 Feb 14",
        "DATEOFDEATH": "1638 Jan 19",
        "PLACEOFBIRTH": "Westerburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19721",
        "NAME": "Helfenstein, Margarita (1489\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1489 Jul 26",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19722",
        "NAME": "Helfenstein, Margarita (1530\u20131589)",
        "DATEOFBIRTH": "1530 Apr 17",
        "DATEOFDEATH": "1589 Sep 17",
        "PLACEOFBIRTH": "Wiesensteig",
        "PLACEOFDEATH": "Wilten in Tirol"
    },
    {
        "ID": "19723",
        "NAME": "Fugger, Emilia (1564\u20131611)",
        "DATEOFBIRTH": "1564 Nov 03",
        "DATEOFDEATH": "1611 Apr 13",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19724",
        "NAME": "Sandizell, Margarita (1493\u20131549)",
        "DATEOFBIRTH": "1493",
        "DATEOFDEATH": "1549 Dez 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sierndorf in der Stockerau"
    },
    {
        "ID": "19725",
        "NAME": "Truchsess von Waldburg, Maria Elisabeth (1600\u20131660)",
        "DATEOFBIRTH": "1600",
        "DATEOFDEATH": "1660 Jul 22",
        "PLACEOFBIRTH": "Zeil in Schwaben",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "19726",
        "NAME": "Mollard, Felizitas (1595\u20131623)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19727",
        "NAME": "Wacker von Wackenfels, Amalia Katharina (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19728",
        "NAME": "Salamanca, Anna (1558\u20131602)",
        "DATEOFBIRTH": "1558",
        "DATEOFDEATH": "1602",
        "PLACEOFBIRTH": "Ortenburg in K\u00e4rnten",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19729",
        "NAME": "Harrach, Eleonora (1586\u20131645)",
        "DATEOFBIRTH": "1586",
        "DATEOFDEATH": "1645 Dez 30",
        "PLACEOFBIRTH": "Rohrau an der Leitha",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19730",
        "NAME": "Fugger, Siguna (1541\u20131576)",
        "DATEOFBIRTH": "1541 Jul 12",
        "DATEOFDEATH": "1576 Feb 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19731",
        "NAME": "Lamberg, Sibylla (1560\u20131621)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1621 Okt 28",
        "PLACEOFBIRTH": "Ottenstein im Waldviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19732",
        "NAME": "Meggau, Anna (1560\u20131599)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "Kreuzen im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19733",
        "NAME": "Harrach, Anna (1548\u20131610)",
        "DATEOFBIRTH": "1548",
        "DATEOFDEATH": "1610",
        "PLACEOFBIRTH": "Rohrau an der Leitha",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19734",
        "NAME": "Rogendorf, Elisabeth (1600\u20131664)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19735",
        "NAME": "Galler von Schwanberg, Regina (1642\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1642",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19736",
        "NAME": "Ursenbeck, Maria Veronika (1582\u20131639)",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1639 Dez 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19737",
        "NAME": "Lamberg, Katharina (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19738",
        "NAME": "Solms, Sabina (1606\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1606 Jul 09",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Braunfels im Westerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19739",
        "NAME": "Thun, Anna Barbara (1657\u20131729)",
        "DATEOFBIRTH": "1657 Apr 24",
        "DATEOFDEATH": "1729 Dez 31",
        "PLACEOFBIRTH": "Maleit im Sulztal",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "19740",
        "NAME": "Montecuccoli, Anna Ludwika (1658\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1658",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Hohenegg im Dunkelsteinerwald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19741",
        "NAME": "Schrattenbach, Johann Maximilian (1610\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19742",
        "NAME": "Schrattenbach, Siegmund Rudolf (1648\u2013\u00a0\u00a0\u00a0\u00a0), Geheimer Rat",
        "DATEOFBIRTH": "1648",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19743",
        "NAME": "Rindsmaul, Theresia (1645\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1645~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19744",
        "NAME": "Ongnies, Bona (1550\u20131601)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1601 Nov 12",
        "PLACEOFBIRTH": "Coupigny in Artesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19745",
        "NAME": "Cirksena, Ludwika (1575\u20131607)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1607 Okt 23",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19746",
        "NAME": "Wratislaw von Mitrowitz, Elisabeth Dorothea (1630\u20131679)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1679 Sep 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Znaim"
    },
    {
        "ID": "19747",
        "NAME": "Eitzing, Anna (1550\u20131590)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1590 Okt 12",
        "PLACEOFBIRTH": "Schrattenthal im Weinviertel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19748",
        "NAME": "Truchsess von Waldburg, Elisabeth (1595\u20131630)",
        "DATEOFBIRTH": "1595 Jul 27",
        "DATEOFDEATH": "1630 Nov 20",
        "PLACEOFBIRTH": "Scheer an der Donau",
        "PLACEOFDEATH": "Trauchburg"
    },
    {
        "ID": "19749",
        "NAME": "Landskron, Elisabeth (1560\u20131614)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1614 Dez 02",
        "PLACEOFBIRTH": "Obsendorf in Schlesien",
        "PLACEOFDEATH": "Carolath in Schlesien"
    },
    {
        "ID": "19750",
        "NAME": "Lamberg, Johann Jakob (1561\u20131630), Bischof von Gurk",
        "DATEOFBIRTH": "1561 Mar 27",
        "DATEOFDEATH": "1630 Feb 07",
        "PLACEOFBIRTH": "Ottenstein im Waldviertel",
        "PLACEOFDEATH": "Stra\u00dfburg in K\u00e4rnten"
    },
    {
        "ID": "19751",
        "NAME": "Rieneck, Dorothea (1450\u20131503)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1503 Mar 24",
        "PLACEOFBIRTH": "Gr\u00fcnsfeld",
        "PLACEOFDEATH": "Gr\u00fcnsfeld"
    },
    {
        "ID": "19752",
        "NAME": "P\u00e1lffy, Maria (1619\u20131648)",
        "DATEOFBIRTH": "1619",
        "DATEOFDEATH": "1648 Mar 18",
        "PLACEOFBIRTH": "Pressburg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19753",
        "NAME": "Zahradek, Katharina (1600\u20131682)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1682",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Slawietin an der Eger"
    },
    {
        "ID": "19754",
        "NAME": "Khuen von Belasi, Sidonia (1610\u20131671)",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1671 Jan 26",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19755",
        "NAME": "Ligne, Jolanda (1585\u20131611)",
        "DATEOFBIRTH": "1585 Mar 18",
        "DATEOFDEATH": "1611 Aug 25",
        "PLACEOFBIRTH": "Beloeil im Hennegau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19756",
        "NAME": "Croy, Maria Klara (1605\u20131664)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1664 Sep 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Nancy"
    },
    {
        "ID": "19757",
        "NAME": "Wolfstein, Dorothea (1579\u20131619)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1619",
        "PLACEOFBIRTH": "Pyrbaum",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19758",
        "NAME": "Teufel von Guntersdorf, Barbara (1620\u20131644)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1644 Jun 09",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Pyrbaum:Pfarrkirche"
    },
    {
        "ID": "19759",
        "NAME": "Fugger, Regina (1537\u20131584)",
        "DATEOFBIRTH": "1537 Feb 28",
        "DATEOFDEATH": "1584",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Letowitz in M\u00e4hren"
    },
    {
        "ID": "19760",
        "NAME": "Bruxelles, Katharina (1543\u20131567)",
        "DATEOFBIRTH": "1543 Sep 19",
        "DATEOFDEATH": "1567 Mai 18",
        "PLACEOFBIRTH": "Mechelen",
        "PLACEOFDEATH": "Br\u00fcssel:Kathedrale"
    },
    {
        "ID": "19761",
        "NAME": "Spaur, Maria Viktoria (1650\u20131688)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1688 Mai 16",
        "PLACEOFBIRTH": "Spaur auf dem Nonsberg",
        "PLACEOFDEATH": "Ingolstadt"
    },
    {
        "ID": "19762",
        "NAME": "Minckwitz, Sidonia (1575\u20131638)",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1638",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19763",
        "NAME": "Viehauser, Elisabeth (1580\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Lauterbach in der Hallertau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19764",
        "NAME": "J\u00f6rger von Tollet, Johann Septim (1596\u20131662)",
        "DATEOFBIRTH": "1596 Mar 03",
        "DATEOFDEATH": "1662",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": "N\u00fcrnberg:Johannisfriedhof"
    },
    {
        "ID": "19765",
        "NAME": "J\u00f6rger von Tollet, Esther Susanna (1627\u20131683)",
        "DATEOFBIRTH": "1627",
        "DATEOFDEATH": "1683 Sep 07",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "N\u00fcrnberg:Johannisfriedhof"
    },
    {
        "ID": "19766",
        "NAME": "J\u00f6rger von Tollet, Anna Maria (1617\u20131687)",
        "DATEOFBIRTH": "1617",
        "DATEOFDEATH": "1687 Mar 18",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19767",
        "NAME": "Schlick, Elisabeth (1572\u20131605)",
        "DATEOFBIRTH": "1572",
        "DATEOFDEATH": "1605~",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19768",
        "NAME": "Schlick, Elisabeth (1552\u20131590)",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "1590 Nov 23",
        "PLACEOFBIRTH": "Schlackenwerth",
        "PLACEOFDEATH": "Frankenhausen in Th\u00fcringen:Pfarrkirche"
    },
    {
        "ID": "19769",
        "NAME": "Schlick, Dorothea (1530\u20131599)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1599",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19771",
        "NAME": "Dohna, Boris (1452\u20131508)",
        "DATEOFBIRTH": "1452",
        "DATEOFDEATH": "1508",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19772",
        "NAME": "Dohna, Johann (1490\u20131556)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1556",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19773",
        "NAME": "Dohna, Wenzel (1534\u20131598), Mundschenk",
        "DATEOFBIRTH": "1534",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19774",
        "NAME": "Dohna, Lassel (1580\u20131642)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Muskau"
    },
    {
        "ID": "19775",
        "NAME": "Dohna, Friedrich (1574\u20131634)",
        "DATEOFBIRTH": "1574",
        "DATEOFDEATH": "1634",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19776",
        "NAME": "Dohna, Wilhelm (1553\u20131606)",
        "DATEOFBIRTH": "1553",
        "DATEOFDEATH": "1606 Okt 24",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Muskau"
    },
    {
        "ID": "19777",
        "NAME": "Dohna, Karl Christoph (1590\u20131625)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1625 Jan 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Muskau"
    },
    {
        "ID": "19778",
        "NAME": "Sprinzenstein, Emilia Katharina (1635\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neuhaus im M\u00fchlviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19779",
        "NAME": "Sprinzenstein, Katharina Eleonora (1660\u20131704)",
        "DATEOFBIRTH": "1660",
        "DATEOFDEATH": "1704 Nov 28",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19780",
        "NAME": "Lamberg, Karl (1563\u20131612), Erzbischof von Prag",
        "DATEOFBIRTH": "1563",
        "DATEOFDEATH": "1612 Sep 18",
        "PLACEOFBIRTH": "Ottenstein im Waldviertel",
        "PLACEOFDEATH": "Ossegg im Erzgebirge"
    },
    {
        "ID": "19781",
        "NAME": "Haugwitz, Katharina (1525\u20131577)",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1577",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19782",
        "NAME": "Berka von der Duba, Veronika (1580\u20131616)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1616 Okt 17",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19783",
        "NAME": "Questenberg, Katharina (1625\u20131657)",
        "DATEOFBIRTH": "1625 Nov 25",
        "DATEOFDEATH": "1657",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19784",
        "NAME": "Globitz, Maria (1580\u20131604)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1604 Apr 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Lengenfeld im Naabtal:Stadtkirche"
    },
    {
        "ID": "19785",
        "NAME": "P\u00e1lffy, Theresia (1650\u20131684)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1684 Nov 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19786",
        "NAME": "Collaert, Anna (1605\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19787",
        "NAME": "Radziwill, Katharina (1637\u20131665)",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1665",
        "PLACEOFBIRTH": "Neswisch",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19788",
        "NAME": "Leszczy\u0144ski, Maria (1703\u20131768), K\u00f6nigin von Frankreich",
        "DATEOFBIRTH": "1703 Jun 23",
        "DATEOFDEATH": "1768 Jun 24",
        "PLACEOFBIRTH": "Trebnitz in Schlesien",
        "PLACEOFDEATH": "Versailles"
    },
    {
        "ID": "19789",
        "NAME": "Kainach, Magdalena (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kainach",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19790",
        "NAME": "Lamberg, Franz Anton (1678\u20131759), Landgraf von Leuchtenberg",
        "DATEOFBIRTH": "1678 Sep 30",
        "DATEOFDEATH": "1759 Aug 23",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19791",
        "NAME": "Lamberg, Magdalena (1538\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1538",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19792",
        "NAME": "Auersperg, Felizitas (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19793",
        "NAME": "Auersperg, Elisabeth (1576\u20131613)",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1613",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19794",
        "NAME": "Auersperg, Kunigunda (1490\u20131535)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "1535",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Albrechtsberg an der Gro\u00dfen Krems"
    },
    {
        "ID": "19795",
        "NAME": "Berka von der Duba, Anna (1556\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1556",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19796",
        "NAME": "Berka von der Duba, Katharina (1590\u20131633)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1633 Mar 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19797",
        "NAME": "Hohenzollern, Helena (1615\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1615 Feb 01",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "K\u00f6nigsberg im Eulengebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19798",
        "NAME": "Hohenzollern, Katharina (1618\u20131670)",
        "DATEOFBIRTH": "1618 Mai 14",
        "DATEOFDEATH": "1670 Feb 15",
        "PLACEOFBIRTH": "K\u00f6nigsberg im Eulengebirge",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19799",
        "NAME": "Montecuccoli, Karolina Polyxena (1660\u20131733)",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "1733",
        "PLACEOFBIRTH": "Hohenegg im Dunkelsteinerwald",
        "PLACEOFDEATH": "Sankt P\u00f6lten"
    },
    {
        "ID": "19801",
        "NAME": "Querfurt, Michael (1400\u20131483), Burggraf von Magdeburg",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1483 Mar 24",
        "PLACEOFBIRTH": "Hardegg an der Thaya",
        "PLACEOFDEATH": "Wien:Augustinerkirche"
    },
    {
        "ID": "19802",
        "NAME": "Metternich, Ursula (1630\u20131675)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1675",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Camberg im Taunus"
    },
    {
        "ID": "19828",
        "NAME": "Limburg, Adolf Ernst (1620\u20131657)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1657 Okt 04",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kattarp"
    },
    {
        "ID": "19829",
        "NAME": "Limburg, Hermann Otto (1646\u20131704), Geheimer Rat",
        "DATEOFBIRTH": "1646 Apr 01",
        "DATEOFDEATH": "1704 Jul 09",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Donauw\u00f6rth"
    },
    {
        "ID": "19830",
        "NAME": "Hallwyl, Burkhard (1400\u20131466)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1466",
        "PLACEOFBIRTH": "Hallwyl im Aargau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19831",
        "NAME": "Hallwyl, Johann (1433\u20131504)",
        "DATEOFBIRTH": "1433",
        "DATEOFDEATH": "1504 Mar 19",
        "PLACEOFBIRTH": "Hallwyl im Aargau",
        "PLACEOFDEATH": "Trostburg im Teufenthal"
    },
    {
        "ID": "19832",
        "NAME": "Hallwyl, Walter (1435\u20131513)",
        "DATEOFBIRTH": "1435~",
        "DATEOFDEATH": "1513",
        "PLACEOFBIRTH": "Hallwyl im Aargau",
        "PLACEOFDEATH": "Kappel am Albis"
    },
    {
        "ID": "19833",
        "NAME": "Hallwyl, Theoderich (1445\u20131509)",
        "DATEOFBIRTH": "1445~",
        "DATEOFDEATH": "1509",
        "PLACEOFBIRTH": "Hallwyl im Aargau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19834",
        "NAME": "Hallwyl, Kaspar (1485\u20131566)",
        "DATEOFBIRTH": "1485~",
        "DATEOFDEATH": "1566 Feb 25",
        "PLACEOFBIRTH": "Bern im Uechtland",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19835",
        "NAME": "Hallwyl, Theoderich (1514\u20131573)",
        "DATEOFBIRTH": "1514",
        "DATEOFDEATH": "1573 Jun 16",
        "PLACEOFBIRTH": "Hallwyl im Aargau",
        "PLACEOFDEATH": "Hegi"
    },
    {
        "ID": "19836",
        "NAME": "Hallwyl, Johann Georg (1555\u20131604), Bischof von Konstanz",
        "DATEOFBIRTH": "1555",
        "DATEOFDEATH": "1604 Jan 11",
        "PLACEOFBIRTH": "Bernhausen auf den Fildern",
        "PLACEOFDEATH": "Meersburg am Bodensee"
    },
    {
        "ID": "19837",
        "NAME": "Hallwyl, Haug (1519\u20131587)",
        "DATEOFBIRTH": "1519",
        "DATEOFDEATH": "1587 Nov 23",
        "PLACEOFBIRTH": "Hallwyl im Aargau",
        "PLACEOFDEATH": "Trostburg im Teufenthal"
    },
    {
        "ID": "19838",
        "NAME": "Hallwyl, Johann Theoderich (1550\u20131580)",
        "DATEOFBIRTH": "1550",
        "DATEOFDEATH": "1580~",
        "PLACEOFBIRTH": "Hallwyl im Aargau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19839",
        "NAME": "Hallwyl, Haug (1576\u20131649), Oberstk\u00e4mmerer",
        "DATEOFBIRTH": "1576 Jul 08",
        "DATEOFDEATH": "1649 Dez 23",
        "PLACEOFBIRTH": "Trostburg im Teufenthal",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19840",
        "NAME": "Hallwyl, Johann Sebastian (1622\u20131700), K\u00e4mmerer",
        "DATEOFBIRTH": "1622 Jan 14",
        "DATEOFDEATH": "1700 Mai 16",
        "PLACEOFBIRTH": "Innsbruck",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19841",
        "NAME": "Hallwyl, Jakob Leopold (1629\u20131691), K\u00e4mmerer",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1691 Dez 13",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19842",
        "NAME": "Hallwyl, Franz Anton (1652\u20131711), K\u00e4mmerer",
        "DATEOFBIRTH": "1652 Mai 11",
        "DATEOFDEATH": "1711 Jun 28",
        "PLACEOFBIRTH": "K\u0159ivsoudov",
        "PLACEOFDEATH": "Pischel an der Sasau"
    },
    {
        "ID": "19843",
        "NAME": "Hallwyl, Ferdinand Leopold (1649\u20131696), K\u00e4mmerer",
        "DATEOFBIRTH": "1649",
        "DATEOFDEATH": "1696 Aug 10",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Gablitz im Riedertal"
    },
    {
        "ID": "19844",
        "NAME": "Heister, Gottfried (1609\u20131679), Hofkriegsrat",
        "DATEOFBIRTH": "1609",
        "DATEOFDEATH": "1679 Feb 08",
        "PLACEOFBIRTH": "Sollstedt im Wippertal",
        "PLACEOFDEATH": "Liebenburg am Harz"
    },
    {
        "ID": "19845",
        "NAME": "Heister, Simprecht (1648\u20131718), Geheimer Rat",
        "DATEOFBIRTH": "1648 Nov 12",
        "DATEOFDEATH": "1718 Feb 22",
        "PLACEOFBIRTH": "Sollstedt im Wippertal",
        "PLACEOFDEATH": "Kirchberg an der Raab"
    },
    {
        "ID": "19846",
        "NAME": "Heister, Hannibal (1650\u20131719), K\u00e4mmerer",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1719",
        "PLACEOFBIRTH": "Sollstedt im Wippertal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19848",
        "NAME": "Muschlitz, Johann Urban (1600\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19849",
        "NAME": "Muschlitz, Stephan (1605\u2013\u00a0\u00a0\u00a0\u00a0), Kammerdiener",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19850",
        "NAME": "Dietrichstein, Georg Siegfried (1645\u20131714), Landeshauptmann der Steiermark",
        "DATEOFBIRTH": "1645 Nov 17",
        "DATEOFDEATH": "1714 Dez 27",
        "PLACEOFBIRTH": "Hollenburg an der Drau",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "19856",
        "NAME": "Verda von Verdenberg, Johann Baptist (1629\u20131696)",
        "DATEOFBIRTH": "1629",
        "DATEOFDEATH": "1696 Mai 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Michaelerkirche"
    },
    {
        "ID": "19857",
        "NAME": "Verda von Verdenberg, Johann Peter (1662\u20131710)",
        "DATEOFBIRTH": "1662",
        "DATEOFDEATH": "1710 Mar 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Odrau"
    },
    {
        "ID": "19858",
        "NAME": "Hallwyl, Anna Franziska (1670\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1670~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19859",
        "NAME": "Fugger, Renata (1630\u20131669)",
        "DATEOFBIRTH": "1630 Jul 31",
        "DATEOFDEATH": "1669 Sep 23",
        "PLACEOFBIRTH": "Mattsies",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19860",
        "NAME": "Strattmann, Theoderich (1637\u20131693), Hofkanzler",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1693 Okt 25",
        "PLACEOFBIRTH": "Kleve am Niederrhein",
        "PLACEOFDEATH": "Wien:Dominikanerkirche"
    },
    {
        "ID": "19861",
        "NAME": "Strattmann, Johann Heinrich (1662\u20131707), Geheimer Rat",
        "DATEOFBIRTH": "1662 Jun 10",
        "DATEOFDEATH": "1707 Feb 03",
        "PLACEOFBIRTH": "D\u00fcsseldorf",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19862",
        "NAME": "Strattmann, Eleonora Magdalena (1672\u20131741)",
        "DATEOFBIRTH": "1672 Mai 29",
        "DATEOFDEATH": "1741 Nov 24",
        "PLACEOFBIRTH": "D\u00fcsseldorf",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19863",
        "NAME": "Strattmann, Anton Franz (1674\u20131718), K\u00e4mmerer",
        "DATEOFBIRTH": "1674 Okt 02",
        "DATEOFDEATH": "1718 Dez 27",
        "PLACEOFBIRTH": "D\u00fcsseldorf",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19864",
        "NAME": "Strattmann, Gerhard Wilhelm (1664\u20131726), Landeshauptmann von Breslau",
        "DATEOFBIRTH": "1664 Jan 10",
        "DATEOFDEATH": "1726 Mar 20",
        "PLACEOFBIRTH": "D\u00fcsseldorf",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "19865",
        "NAME": "Teufel von Guntersdorf, Matthias (1550\u20131608), Vorschneider",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1608 Apr 23",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Thunau am Kamp:Pfarrkirche"
    },
    {
        "ID": "19866",
        "NAME": "Teufel von Guntersdorf, Rudolf (1610\u20131637), K\u00e4mmerer",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1637",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19867",
        "NAME": "Teufel von Guntersdorf, Otto Christoph (1624\u20131690)",
        "DATEOFBIRTH": "1624 Dez 15",
        "DATEOFDEATH": "1690 Aug 27",
        "PLACEOFBIRTH": "Eckartsau im Marchfeld",
        "PLACEOFDEATH": "Dresden:Sophienkirche"
    },
    {
        "ID": "19868",
        "NAME": "Teufel von Guntersdorf, Judith (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19869",
        "NAME": "Teufel von Guntersdorf, Barbara (1615\u20131665)",
        "DATEOFBIRTH": "1615~",
        "DATEOFDEATH": "1665 Jun 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wolfpassing am Wagram"
    },
    {
        "ID": "19870",
        "NAME": "Zoppel von Haus, Christoph (1515\u20131582)",
        "DATEOFBIRTH": "1515~",
        "DATEOFDEATH": "1582 Jan 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Raggendorf"
    },
    {
        "ID": "19871",
        "NAME": "Zoppel von Haus, Ulrich Christoph (1545\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19872",
        "NAME": "Zelking, Ludwika (1550\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19873",
        "NAME": "Kolowrat, Lassel (1510\u20131575)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1575 Apr 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "\u010cernovi\u010dky"
    },
    {
        "ID": "19874",
        "NAME": "Kolowrat, Elisabeth (1550\u20131586)",
        "DATEOFBIRTH": "1550",
        "DATEOFDEATH": "1586 Okt 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19875",
        "NAME": "Grei\u00df zum Wald, Johann Theoderich (1590\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19876",
        "NAME": "Grei\u00df zum Wald, Johann Wilhelm (1580\u20131631)",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1631",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19877",
        "NAME": "Grei\u00df zum Wald, Siegfried (1590\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19878",
        "NAME": "Grei\u00df zum Wald, Rudolf (1566\u20131588)",
        "DATEOFBIRTH": "1566",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "Wald an der Perschling",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19879",
        "NAME": "Brandis, Johann Jakob (1620\u20131658)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "1658 Aug 08",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "19880",
        "NAME": "Brandis, Maria Theresia (1630\u20131687)",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1687 Jun 05",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19899",
        "NAME": "Kotromanics, Elisabeth (1335\u20131387), K\u00f6nigin von Ungarn",
        "DATEOFBIRTH": "1335~",
        "DATEOFDEATH": "1387 Jan 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Novigrad an der Draga"
    },
    {
        "ID": "19900",
        "NAME": "Este, Albrecht (1009\u20131097), Markgraf von Mailand",
        "DATEOFBIRTH": "1009 Jul 10",
        "DATEOFDEATH": "1097 Aug 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Vangadizza del Polesine:Kamaldulenserkloster"
    },
    {
        "ID": "19901",
        "NAME": "Este, Volkhard (1055\u20131128), Markgraf von Mailand",
        "DATEOFBIRTH": "1055~",
        "DATEOFDEATH": "1128 Dez 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19902",
        "NAME": "Este, Haubald (1090\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1090~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19903",
        "NAME": "Este, Albrecht (1130\u20131193)",
        "DATEOFBIRTH": "1130~",
        "DATEOFDEATH": "1193 Dez 25",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19904",
        "NAME": "Este, Albrecht (1160\u20131212)",
        "DATEOFBIRTH": "1160~",
        "DATEOFDEATH": "1212 Nov 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19905",
        "NAME": "Este, Albrecht (1208\u20131264)",
        "DATEOFBIRTH": "1208",
        "DATEOFDEATH": "1264",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19906",
        "NAME": "Este, Reinhold (\u00a0\u00a0\u00a0\u00a0\u20131251)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "1251",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19907",
        "NAME": "Este, Haubald (1247\u20131293)",
        "DATEOFBIRTH": "1247",
        "DATEOFDEATH": "1293 Feb 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19908",
        "NAME": "Este, Hildebrand (1270\u20131326)",
        "DATEOFBIRTH": "1270~",
        "DATEOFDEATH": "1326",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19909",
        "NAME": "Este, Haubald (1294\u20131352)",
        "DATEOFBIRTH": "1294",
        "DATEOFDEATH": "1352",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19910",
        "NAME": "Este, Albrecht (1347\u20131393)",
        "DATEOFBIRTH": "1347",
        "DATEOFDEATH": "1393",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19911",
        "NAME": "Este, Hildebrand (1190\u20131235)",
        "DATEOFBIRTH": "1190",
        "DATEOFDEATH": "1235",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19912",
        "NAME": "Este, Beatrix (1215\u20131245)",
        "DATEOFBIRTH": "1215",
        "DATEOFDEATH": "1245",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19913",
        "NAME": "Este, Niklas (1383\u20131441)",
        "DATEOFBIRTH": "1383",
        "DATEOFDEATH": "1441",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19914",
        "NAME": "Este, Leonhard (\u00a0\u00a0\u00a0\u00a0\u20131450)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "1450",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19915",
        "NAME": "Este, Bonaccorso (\u00a0\u00a0\u00a0\u00a0\u20131471)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "1471",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19916",
        "NAME": "Este, Herkules (1431\u20131505)",
        "DATEOFBIRTH": "1431",
        "DATEOFDEATH": "1505",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19917",
        "NAME": "Este, Alfons (1476\u20131534)",
        "DATEOFBIRTH": "1476",
        "DATEOFDEATH": "1534",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19918",
        "NAME": "Este, Herkules (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19919",
        "NAME": "Este, Alfons (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19920",
        "NAME": "Este, Elisabeth (1425\u20131456)",
        "DATEOFBIRTH": "1425 Apr 27",
        "DATEOFDEATH": "1456 Jan 26",
        "PLACEOFBIRTH": "Ferrara",
        "PLACEOFDEATH": "Zengg:Franziskanerkirche"
    },
    {
        "ID": "19921",
        "NAME": "Este, Wolfgang (1035\u20131101), Herzog in Bayern",
        "DATEOFBIRTH": "1035~",
        "DATEOFDEATH": "1101 Nov 08",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Paphos"
    },
    {
        "ID": "19922",
        "NAME": "Este, Heinrich (1075\u20131126)",
        "DATEOFBIRTH": "1075~",
        "DATEOFDEATH": "1126 Dez 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Ravensburg im Schussental"
    },
    {
        "ID": "19923",
        "NAME": "Este, Heinrich (1102\u20131139)",
        "DATEOFBIRTH": "1102",
        "DATEOFDEATH": "1139",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19924",
        "NAME": "Este, Heinrich (1129\u20131195)",
        "DATEOFBIRTH": "1129",
        "DATEOFDEATH": "1195",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19925",
        "NAME": "Este, Otto IV. (1176\u20131218), Kaiser des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1176",
        "DATEOFDEATH": "1218 Mai 19",
        "PLACEOFBIRTH": "Braunschweig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19926",
        "NAME": "Este, Wilhelm (1184\u20131213)",
        "DATEOFBIRTH": "1184",
        "DATEOFDEATH": "1213",
        "PLACEOFBIRTH": "Braunschweig",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19927",
        "NAME": "Este, Otto (1204\u20131252)",
        "DATEOFBIRTH": "1204",
        "DATEOFDEATH": "1252",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19928",
        "NAME": "Este, Albrecht (1236\u20131279)",
        "DATEOFBIRTH": "1236",
        "DATEOFDEATH": "1279",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19929",
        "NAME": "Este, Albrecht (1268\u20131318)",
        "DATEOFBIRTH": "1268",
        "DATEOFDEATH": "1318",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19930",
        "NAME": "Este, Mang (1304\u20131369)",
        "DATEOFBIRTH": "1304",
        "DATEOFDEATH": "1369",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19931",
        "NAME": "Este, Mang (1328\u20131373)",
        "DATEOFBIRTH": "1328",
        "DATEOFDEATH": "1373",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19932",
        "NAME": "Este, Heinrich (1360\u20131416)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "1416",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19933",
        "NAME": "Este, Wilhelm (1400\u20131482)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "1482",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19934",
        "NAME": "Este, Wilhelm (1426\u20131503)",
        "DATEOFBIRTH": "1426",
        "DATEOFDEATH": "1503",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19935",
        "NAME": "Este, Heinrich (1463\u20131514)",
        "DATEOFBIRTH": "1463",
        "DATEOFDEATH": "1514",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19936",
        "NAME": "Este, Heinrich (1489\u20131568)",
        "DATEOFBIRTH": "1489 Nov 10",
        "DATEOFDEATH": "1568 Jun 11",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19937",
        "NAME": "Este, Julius (1528\u20131589)",
        "DATEOFBIRTH": "1528 Jun 29",
        "DATEOFDEATH": "1589 Mai 13",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19938",
        "NAME": "Este, Heinrich Julius (1564\u20131613), Geheimer Rat",
        "DATEOFBIRTH": "1564 Okt 15",
        "DATEOFDEATH": "1613 Jul 20",
        "PLACEOFBIRTH": "Wolfenb\u00fcttel",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "19939",
        "NAME": "Este, Friedrich Ulrich (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19940",
        "NAME": "Este, Christian (1599\u20131626)",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1626",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19941",
        "NAME": "Este, Maria (1566\u20131626)",
        "DATEOFBIRTH": "1566 Jan 13",
        "DATEOFDEATH": "1626 Aug 13",
        "PLACEOFBIRTH": "Wolfenb\u00fcttel",
        "PLACEOFDEATH": "Lauenburg an der Elbe:Stadtkirche"
    },
    {
        "ID": "19969",
        "NAME": "Este, Bernhard (1365\u20131434)",
        "DATEOFBIRTH": "1365",
        "DATEOFDEATH": "1434",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19970",
        "NAME": "Este, Friedrich (1400\u20131478)",
        "DATEOFBIRTH": "1400",
        "DATEOFDEATH": "1478",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19971",
        "NAME": "Este, Otto (1439\u20131471)",
        "DATEOFBIRTH": "1439",
        "DATEOFDEATH": "1471",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19972",
        "NAME": "Este, Heinrich (1468\u20131532)",
        "DATEOFBIRTH": "1468",
        "DATEOFDEATH": "1532",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19973",
        "NAME": "Este, Ernst (1497\u20131546)",
        "DATEOFBIRTH": "1497",
        "DATEOFDEATH": "1546",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19974",
        "NAME": "Este, Franz (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19975",
        "NAME": "Este, Wilhelm (1535\u20131592), Landesherr von L\u00fcneburg",
        "DATEOFBIRTH": "1535 Jul 04",
        "DATEOFDEATH": "1592 Aug 20",
        "PLACEOFBIRTH": "Celle an der Aller",
        "PLACEOFDEATH": "Celle an der Aller"
    },
    {
        "ID": "19976",
        "NAME": "Este, Sophia (1563\u20131639)",
        "DATEOFBIRTH": "1563 Okt 30",
        "DATEOFDEATH": "1639 Jan 14",
        "PLACEOFBIRTH": "Celle an der Aller",
        "PLACEOFDEATH": "N\u00fcrnberg:Lorenzkirche"
    },
    {
        "ID": "19977",
        "NAME": "Este, Ernst (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19978",
        "NAME": "Este, Elisabeth (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19979",
        "NAME": "Este, Christina (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19980",
        "NAME": "Este, August (1568\u20131636), Landesherr von L\u00fcneburg",
        "DATEOFBIRTH": "1568 Nov 18",
        "DATEOFDEATH": "1636 Okt 01",
        "PLACEOFBIRTH": "Celle an der Aller",
        "PLACEOFDEATH": "Celle an der Aller"
    },
    {
        "ID": "19981",
        "NAME": "Este, Dorothea (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19982",
        "NAME": "Este, Klara (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19983",
        "NAME": "Este, Margarita (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19984",
        "NAME": "Este, Friedrich (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19985",
        "NAME": "Este, Sibylla (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19986",
        "NAME": "Este, Georg (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19987",
        "NAME": "Este, Christian Ludwig (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19988",
        "NAME": "Este, Georg Wilhelm (\u00a0\u00a0\u00a0\u00a0\u20131705)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "1705",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19989",
        "NAME": "Este, Johann Friedrich (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19990",
        "NAME": "Este, Wilhelmina Amalia (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0), Kaiserin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19991",
        "NAME": "Este, Sophia Amalia (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19992",
        "NAME": "Este, Ernst August (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19993",
        "NAME": "Este, Heinrich (1533\u20131598)",
        "DATEOFBIRTH": "1533",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19994",
        "NAME": "Este, August (1579\u20131666)",
        "DATEOFBIRTH": "1579",
        "DATEOFDEATH": "1666",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19995",
        "NAME": "Este, Rudolf August (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19996",
        "NAME": "Este, Anton Ulrich (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19997",
        "NAME": "Este, August Wilhelm (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19998",
        "NAME": "Este, Ludwig Rudolf (\u00a0\u00a0\u00a0\u00a0\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "19999",
        "NAME": "Este, Elisabeth Christina (1691\u20131750), Kaiserin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1691 Sep 07",
        "DATEOFDEATH": "1750 Dez 21",
        "PLACEOFBIRTH": "Braunschweig",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "20000",
        "NAME": "Habsburg, Maria Theresia (1717\u20131780), Kaiserin des Heiligen R\u00f6mischen Reiches",
        "DATEOFBIRTH": "1717 Mai 13",
        "DATEOFDEATH": "1780 Nov 29",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien:Kapuzinergruft"
    },
    {
        "ID": "20540",
        "NAME": "Wolfstein, Christian Albrecht (1672\u20131740)",
        "DATEOFBIRTH": "1672 Jun 14",
        "DATEOFDEATH": "1740 Apr 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "20541",
        "NAME": "Wolfstein, Friedrich August (1716\u20131728)",
        "DATEOFBIRTH": "1716 Mar 29",
        "DATEOFDEATH": "1728 Mai 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "M\u00fchlhausen im Sulztal:Schlosskirche"
    },
    {
        "ID": "20691",
        "NAME": "Th\u00fcrheim, Johann Christoph (1589\u20131634), K\u00e4mmerer",
        "DATEOFBIRTH": "1589 Nov 02",
        "DATEOFDEATH": "1634 Aug 14",
        "PLACEOFBIRTH": "Biberachzell",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "20692",
        "NAME": "Th\u00fcrheim, Franz Leopold (1624\u20131700), K\u00e4mmerer",
        "DATEOFBIRTH": "1624 Apr 23",
        "DATEOFDEATH": "1700 Nov 12",
        "PLACEOFBIRTH": "Ebelsberg im Traunviertel",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "20693",
        "NAME": "Th\u00fcrheim, Christoph Leopold (1629\u20131689), K\u00e4mmerer",
        "DATEOFBIRTH": "1629 Dez 10",
        "DATEOFDEATH": "1689 Aug 09",
        "PLACEOFBIRTH": "Ebelsberg im Traunviertel",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "20694",
        "NAME": "Th\u00fcrheim, Philipp Jakob (1631\u20131672), K\u00e4mmerer",
        "DATEOFBIRTH": "1631 Mai 01",
        "DATEOFDEATH": "1672 Sep 25",
        "PLACEOFBIRTH": "Ebelsberg im Traunviertel",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "20695",
        "NAME": "Th\u00fcrheim, Franz Sebastian (1665\u20131726), K\u00e4mmerer",
        "DATEOFBIRTH": "1665 Feb 02",
        "DATEOFDEATH": "1726 Apr 10",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "20696",
        "NAME": "Th\u00fcrheim, Karl Joseph (1683\u20131709), K\u00e4mmerer",
        "DATEOFBIRTH": "1683",
        "DATEOFDEATH": "1709",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "20697",
        "NAME": "Th\u00fcrheim, Franz Gottlieb (1673\u20131748), K\u00e4mmerer",
        "DATEOFBIRTH": "1673 Apr 21",
        "DATEOFDEATH": "1748",
        "PLACEOFBIRTH": "Linz an der Donau",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "20698",
        "NAME": "Th\u00fcrheim, Christoph Wilhelm (1661\u20131738), Landeshauptmann von Ober\u00f6sterreich",
        "DATEOFBIRTH": "1661 Mar 13",
        "DATEOFDEATH": "1738 Jan 08",
        "PLACEOFBIRTH": "Salaberg im Mostviertel",
        "PLACEOFDEATH": "Linz an der Donau"
    },
    {
        "ID": "20699",
        "NAME": "Th\u00fcrheim, Georg Siegmund (1666\u20131738), K\u00e4mmerer",
        "DATEOFBIRTH": "1666 Okt 22",
        "DATEOFDEATH": "1738 Nov 27",
        "PLACEOFBIRTH": "Weinberg im M\u00fchlviertel",
        "PLACEOFDEATH": "M\u00fcnchen"
    },
    {
        "ID": "20950",
        "NAME": "P\u00e1lffy, Niklas (1657\u20131732), Palatin von Ungarn",
        "DATEOFBIRTH": "1657 Mai 01",
        "DATEOFDEATH": "1732 Feb 20",
        "PLACEOFBIRTH": "Bibersburg",
        "PLACEOFDEATH": "Pressburg"
    },
    {
        "ID": "20951",
        "NAME": "P\u00e1lffy, Franz (1660\u20131687), K\u00e4mmerer",
        "DATEOFBIRTH": "1660 Aug 03",
        "DATEOFDEATH": "1687 Sep 29",
        "PLACEOFBIRTH": "Bibersburg",
        "PLACEOFDEATH": "Esseg an der Drau"
    },
    {
        "ID": "20952",
        "NAME": "P\u00e1lffy, Johann (1664\u20131751), Palatin von Ungarn",
        "DATEOFBIRTH": "1664 Aug 20",
        "DATEOFDEATH": "1751 Mar 24",
        "PLACEOFBIRTH": "Bibersburg",
        "PLACEOFDEATH": "Pressburg:Martinsdom"
    },
    {
        "ID": "21006",
        "NAME": "Attems, Ignaz Maria (1652\u20131732), Geheimer Rat",
        "DATEOFBIRTH": "1652 Aug 15",
        "DATEOFDEATH": "1732 Dez 11",
        "PLACEOFBIRTH": "Laibach",
        "PLACEOFDEATH": "Graz"
    },
    {
        "ID": "21021",
        "NAME": "Lengheim, Johann Andreas (1600\u20131649), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "21022",
        "NAME": "Lengheim, Johann Andreas (1643\u20131722), Geheimer Rat",
        "DATEOFBIRTH": "1643 Jan 11",
        "DATEOFDEATH": "1722",
        "PLACEOFBIRTH": "Kapfenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "21023",
        "NAME": "Lengheim, Georg Adam (1635\u2013\u00a0\u00a0\u00a0\u00a0), Geheimer Rat",
        "DATEOFBIRTH": "1635~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kapfenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "21024",
        "NAME": "Lengheim, Maximilian Adam (1665\u2013\u00a0\u00a0\u00a0\u00a0), Geheimer Rat",
        "DATEOFBIRTH": "1665~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kapfenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "21025",
        "NAME": "Lengheim, Johann Andreas (1675\u20131743)",
        "DATEOFBIRTH": "1675~",
        "DATEOFDEATH": "1743",
        "PLACEOFBIRTH": "Kapfenstein",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "21078",
        "NAME": "Iselin von Lanans, Hyazinth (1685\u20131746)",
        "DATEOFBIRTH": "1685~",
        "DATEOFDEATH": "1746 Apr 10",
        "PLACEOFBIRTH": "Roulans",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "21079",
        "NAME": "Iselin von Lanans, Thedel Franz (1733\u20131809)",
        "DATEOFBIRTH": "1733 Sep 04",
        "DATEOFDEATH": "1809 Aug 25",
        "PLACEOFBIRTH": "Baume les Dames",
        "PLACEOFDEATH": "Freising"
    },
    {
        "ID": "21080",
        "NAME": "Iselin von Lanans, Ludwig Maximilian (1736\u20131821)",
        "DATEOFBIRTH": "1736",
        "DATEOFDEATH": "1821",
        "PLACEOFBIRTH": "Baume les Dames",
        "PLACEOFDEATH": "Freiburg im Breisgau"
    },
    {
        "ID": "21500",
        "NAME": "Capet, Ludwig (1710\u20131774), K\u00f6nig von Frankreich",
        "DATEOFBIRTH": "1710 Feb 15",
        "DATEOFDEATH": "1774 Mai 10",
        "PLACEOFBIRTH": "Versailles",
        "PLACEOFDEATH": "Versailles"
    },
    {
        "ID": "21600",
        "NAME": "Capet, Ludwig (1754\u20131793), K\u00f6nig von Frankreich",
        "DATEOFBIRTH": "1754 Aug 23",
        "DATEOFDEATH": "1793 Jan 21",
        "PLACEOFBIRTH": "Versailles",
        "PLACEOFDEATH": "Paris"
    },
    {
        "ID": "21962",
        "NAME": "Solms, Christian August (1714\u20131784)",
        "DATEOFBIRTH": "1714 Aug 01",
        "DATEOFDEATH": "1784 Feb 20",
        "PLACEOFBIRTH": "Wetzlar",
        "PLACEOFDEATH": "Laubach im Wettertal"
    },
    {
        "ID": "21991",
        "NAME": "Wallis, Richard (1583\u20131632)",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1632 Nov 16",
        "PLACEOFBIRTH": "Karighmain",
        "PLACEOFDEATH": "L\u00fctzen"
    },
    {
        "ID": "21992",
        "NAME": "Wallis, Oliver (1606\u20131667), K\u00e4mmerer",
        "DATEOFBIRTH": "1606",
        "DATEOFDEATH": "1667 Jun 21",
        "PLACEOFBIRTH": "Karighmain",
        "PLACEOFDEATH": "Sathmar"
    },
    {
        "ID": "21993",
        "NAME": "Wallis, Georg (1637\u20131689), K\u00e4mmerer",
        "DATEOFBIRTH": "1637",
        "DATEOFDEATH": "1689 Sep 06",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Mainz"
    },
    {
        "ID": "21994",
        "NAME": "Wallis, Franz (1640\u20131702)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1702 Dez 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "21995",
        "NAME": "Wallis, Georg Oliver (1673\u20131744), K\u00e4mmerer",
        "DATEOFBIRTH": "1673 Feb 08",
        "DATEOFDEATH": "1744 Dez 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "21996",
        "NAME": "Wallis, Franz Paul (1678\u20131737)",
        "DATEOFBIRTH": "1678 Jan 04",
        "DATEOFDEATH": "1737 Okt 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Hermannstadt in Siebenb\u00fcrgen"
    },
    {
        "ID": "21997",
        "NAME": "Wallis, Franz Wenzel (1696\u20131774)",
        "DATEOFBIRTH": "1696 Okt 04",
        "DATEOFDEATH": "1774 Jan 14",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "24000",
        "NAME": "Kaunitz, Wenzel Anton (1711\u20131794), Obersthofmeister",
        "DATEOFBIRTH": "1711 Feb 02",
        "DATEOFDEATH": "1794 Jun 27",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "24640",
        "NAME": "Martinitz, Georg Adam (1652\u20131714), Vizek\u00f6nig von Neapel",
        "DATEOFBIRTH": "1652",
        "DATEOFDEATH": "1714 Jul 24",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Prag:Veitsdom"
    },
    {
        "ID": "24641",
        "NAME": "Martinitz, Maximilian Widebald (1664\u20131733), Obersthofmeister",
        "DATEOFBIRTH": "1664 Mar 16",
        "DATEOFDEATH": "1733 Jun 30",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "24660",
        "NAME": "Khevenh\u00fcller, Johann Joseph (1706\u20131776), Obersthofmeister",
        "DATEOFBIRTH": "1706 Jul 03",
        "DATEOFDEATH": "1776 Apr 18",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "29597",
        "NAME": "Obizzi, Thomas (1660\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Padua",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "29598",
        "NAME": "Obizzi, Ferdinand (1701\u20131768)",
        "DATEOFBIRTH": "1701 Sep 09",
        "DATEOFDEATH": "1768 Okt 25",
        "PLACEOFBIRTH": "Padua",
        "PLACEOFDEATH": "Cataio sul Padovano"
    },
    {
        "ID": "29599",
        "NAME": "Obizzi, Thomas (1750\u20131803)",
        "DATEOFBIRTH": "1750",
        "DATEOFDEATH": "1803 Jun 03",
        "PLACEOFBIRTH": "Padua",
        "PLACEOFDEATH": "Cataio sul Padovano"
    },
    {
        "ID": "31021",
        "NAME": "Butzlin, Valentin (1523\u20131574)",
        "DATEOFBIRTH": "1523",
        "DATEOFDEATH": "1574 Dez 11",
        "PLACEOFBIRTH": "Wangen am Untersee",
        "PLACEOFDEATH": "\u00dcberlingen am Bodensee"
    },
    {
        "ID": "31022",
        "NAME": "Butzlin, Johann Jakob (1561\u20131617)",
        "DATEOFBIRTH": "1561 Apr 01",
        "DATEOFDEATH": "1617 Nov 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Kreuzlingen im Thurgau"
    },
    {
        "ID": "31023",
        "NAME": "Butzlin, Gabriel (1599\u20131681)",
        "DATEOFBIRTH": "1599 Dez 27",
        "DATEOFDEATH": "1681 Jun 09",
        "PLACEOFBIRTH": "Diessenhofen im Thurgau",
        "PLACEOFDEATH": "Weingarten auf dem Martinsberg"
    },
    {
        "ID": "31025",
        "NAME": "Butzlin, Benedikt (1605\u20131652), Reichshofrat",
        "DATEOFBIRTH": "1605",
        "DATEOFDEATH": "1652 Apr 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31058",
        "NAME": "Coraduz, Rudolf (1560\u20131618), Reichsvizekanzler",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1618",
        "PLACEOFBIRTH": "Triest",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31059",
        "NAME": "Rousson, Franz (1580\u20131645), Reichshofrat",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1645 Jun 10",
        "PLACEOFBIRTH": "Tull in Lothringen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31060",
        "NAME": "Bentheim, Thomas (1560\u20131617), Reichshofrat",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1617",
        "PLACEOFBIRTH": "K\u00f6ln am Rhein",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "31063",
        "NAME": "L\u00fctzow, Konrad (1610\u20131670), Reichshofrat",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1670",
        "PLACEOFBIRTH": "Goldenbow",
        "PLACEOFDEATH": "Marsow"
    },
    {
        "ID": "31069",
        "NAME": "Volmar von Rieden, Isaak (1582\u20131662), Geheimer Rat",
        "DATEOFBIRTH": "1582",
        "DATEOFDEATH": "1662 Okt 23",
        "PLACEOFBIRTH": "Steu\u00dflingen im Schmiechtal",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "31080",
        "NAME": "Arnoldin von Klarstein, Matthias (1575\u20131649), Reichshofrat",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1649 Jan 21",
        "PLACEOFBIRTH": "Lutzerath",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "31086",
        "NAME": "Oudegherst, Johann (1511\u20131559)",
        "DATEOFBIRTH": "1511 Nov 25",
        "DATEOFDEATH": "1559 Apr 21",
        "PLACEOFBIRTH": "Heusden",
        "PLACEOFDEATH": "Mechelen"
    },
    {
        "ID": "31087",
        "NAME": "Oudegherst, Peter (1540\u20131592), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1592",
        "PLACEOFBIRTH": "Lille",
        "PLACEOFDEATH": "Madrid"
    },
    {
        "ID": "31088",
        "NAME": "Partini, Franz (1501\u20131569), Hofarzt",
        "DATEOFBIRTH": "1501",
        "DATEOFDEATH": "1569 Jul 24",
        "PLACEOFBIRTH": "Rovereid",
        "PLACEOFDEATH": "Rovereid"
    },
    {
        "ID": "31089",
        "NAME": "Partini, Melchior (1532\u20131569), Reichshofrat",
        "DATEOFBIRTH": "1532",
        "DATEOFDEATH": "1569 Jul 28",
        "PLACEOFBIRTH": "Rovereid",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31090",
        "NAME": "Erstenberger von Freyenthurn, Andreas (1528\u20131592), Reichshofrat",
        "DATEOFBIRTH": "1528",
        "DATEOFDEATH": "1592 Jul 06",
        "PLACEOFBIRTH": "Bischofsheim an der Tauber",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "31091",
        "NAME": "Erstenberger von Freyenthurn, Peter (1560\u20131617)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1617 Mai 21",
        "PLACEOFBIRTH": "Freyenthurn am W\u00f6rthersee",
        "PLACEOFDEATH": "Wien:Kirche Maria am Gestade"
    },
    {
        "ID": "31092",
        "NAME": "Erstenberger von Freyenthurn, Georg (1590\u20131650), Hofkammerrat",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "Freyenthurn am W\u00f6rthersee",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31094",
        "NAME": "Hanniwald von Eckersdorf, Simon (1529\u20131599)",
        "DATEOFBIRTH": "1529",
        "DATEOFDEATH": "1599 Nov 04",
        "PLACEOFBIRTH": "Eckersdorf in Schlesien",
        "PLACEOFDEATH": "Roths\u00fcrben"
    },
    {
        "ID": "31095",
        "NAME": "Hanniwald von Eckersdorf, Andreas (1560\u20131623), Reichshofrat",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1623",
        "PLACEOFBIRTH": "Bunzlau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31096",
        "NAME": "Hanniwald von Eckersdorf, Adam (1567\u20131621)",
        "DATEOFBIRTH": "1567 Nov 03",
        "DATEOFDEATH": "1621 Jul 18",
        "PLACEOFBIRTH": "Bunzlau",
        "PLACEOFDEATH": "Roths\u00fcrben"
    },
    {
        "ID": "31097",
        "NAME": "Hanniwald von Eckersdorf, Bartlome (1530\u20131571), Reichskanzleisekret\u00e4r",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1571 Aug 10",
        "PLACEOFBIRTH": "Eckersdorf in Schlesien",
        "PLACEOFDEATH": "Konstantinopel"
    },
    {
        "ID": "31098",
        "NAME": "Hanniwald von Eckersdorf, Paul (1535\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Eckersdorf in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31099",
        "NAME": "Hanniwald von Eckersdorf, Philipp (1540\u20131600), Mundschenk",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1600~",
        "PLACEOFBIRTH": "Eckersdorf in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31101",
        "NAME": "Aichpichl, Johann Karl (1600\u20131658), Hofkammerrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1658 Jan 16",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31102",
        "NAME": "Aichpichl, Karl Gottlieb (1640\u20131706), Hofkammerrat",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "1706",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31103",
        "NAME": "Albmayr, Theoderich (1610\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerkonzipist",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31104",
        "NAME": "Allmer, Adam (1610\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerkonzipist",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31105",
        "NAME": "Braun von Wartenberg, Georg (1530\u20131585), Hofkammerrat",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "1585",
        "PLACEOFBIRTH": "Ottendorf in Schlesien",
        "PLACEOFDEATH": "Wartenberg an der Weide"
    },
    {
        "ID": "31106",
        "NAME": "Brombeer, Christoph (1630\u20131664), Hofkammerkonzipist",
        "DATEOFBIRTH": "1630~",
        "DATEOFDEATH": "1664",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31107",
        "NAME": "Creeft, Michael Adolf (1610\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerkonzipist",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31108",
        "NAME": "Constante von Vestenburg, Johann Leopold (1616\u20131688), Hofkammerrat",
        "DATEOFBIRTH": "1616",
        "DATEOFDEATH": "1688",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31109",
        "NAME": "Conens, Johann (1600\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerrat",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31110",
        "NAME": "Ettmannsdorf, Niklas (1550\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31111",
        "NAME": "Garnich, Georg Adolf (1570\u20131639), Oberstmustermeister",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1639 Sep 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31112",
        "NAME": "Garnich, Johann Georg (1608\u20131673), Hofkammerrat",
        "DATEOFBIRTH": "1608",
        "DATEOFDEATH": "1673",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "M\u00fchlfeld auf der Wieden"
    },
    {
        "ID": "31113",
        "NAME": "Gassoldt, Samuel (1550\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerdiener",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31114",
        "NAME": "Geinitz, Ludwig (1610\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerkonzipist",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31115",
        "NAME": "Guett, Helfrich (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammerrat",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31121",
        "NAME": "Schidenitz, Franz (1580\u20131649), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1649",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31122",
        "NAME": "Schidenitz, Gregor (1610\u20131678), Hofkammerrat",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1678 Mai 15",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31123",
        "NAME": "Geldricher, Michael (1535\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31124",
        "NAME": "Kraft von Lamersdorf, Pankraz (1560\u20131616)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1616",
        "PLACEOFBIRTH": "Lamersdorf an der Inde",
        "PLACEOFDEATH": "Aachen"
    },
    {
        "ID": "31125",
        "NAME": "Kraft von Lamersdorf, Johann (1596\u20131650), Reichshofrat",
        "DATEOFBIRTH": "1596",
        "DATEOFDEATH": "1650 Jul 16",
        "PLACEOFBIRTH": "Aachen",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31126",
        "NAME": "Kraft von Lamersdorf, Wilhelm (1594\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1594",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Aachen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31127",
        "NAME": "Kraft von Lamersdorf, Heinrich (1598\u20131656)",
        "DATEOFBIRTH": "1598",
        "DATEOFDEATH": "1656",
        "PLACEOFBIRTH": "Aachen",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31128",
        "NAME": "Reisacher, Bernhard (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofkriegsratssekret\u00e4r",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31129",
        "NAME": "Nickhardt, Heinrich (1550\u2013\u00a0\u00a0\u00a0\u00a0), Hofkriegsratssekret\u00e4r",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31130",
        "NAME": "Bonacina, Hieronym (1585\u20131638), Hofkammerrat",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1638 Okt 23",
        "PLACEOFBIRTH": "Mailand",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31132",
        "NAME": "Wettstein von Westersheim, Franz Leopold (1666\u20131715), Hofkriegsratssekret\u00e4r",
        "DATEOFBIRTH": "1666",
        "DATEOFDEATH": "1715",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31146",
        "NAME": "Gabelhofen, Christoph (1531\u20131608)",
        "DATEOFBIRTH": "1531",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31147",
        "NAME": "Gabelhofen, Severin Amand (1575\u20131614), Hofdiener",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "1614",
        "PLACEOFBIRTH": "Graz",
        "PLACEOFDEATH": "Gabelhofen im Aichfeld"
    },
    {
        "ID": "31148",
        "NAME": "Rexius, Johann (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31149",
        "NAME": "Schitter, Lorenz (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofpfennigmeister",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31150",
        "NAME": "Gattermayr von Gatterburg, Gilg (1540\u20131598), Hofkriegszahlmeister",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1598",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sch\u00f6nbrunn"
    },
    {
        "ID": "31151",
        "NAME": "Gattermayr von Gatterburg, Gilg (1587\u20131641)",
        "DATEOFBIRTH": "1587",
        "DATEOFDEATH": "1641 Jun 12",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "31152",
        "NAME": "Gattermayr von Gatterburg, Karl Ludwig (1613\u20131678), Hofkammerrat",
        "DATEOFBIRTH": "1613 Jan 26",
        "DATEOFDEATH": "1678 Dez 20",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Stephansdom"
    },
    {
        "ID": "31153",
        "NAME": "Gattermayr von Gatterburg, Maximilian Ernst (1616\u20131688), Hofzahlmeister",
        "DATEOFBIRTH": "1616 Sep 23",
        "DATEOFDEATH": "1688 Mai 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Franziskanerkirche"
    },
    {
        "ID": "31154",
        "NAME": "Gattermayr von Gatterburg, Franz Elias (1622\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1622 Mai 10",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31155",
        "NAME": "Igelshofer, Franz (1505\u20131576), Nieder\u00f6sterreichischer Kammersekret\u00e4r",
        "DATEOFBIRTH": "1505",
        "DATEOFDEATH": "1576",
        "PLACEOFBIRTH": "Neustadt im Steinfeld",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31156",
        "NAME": "Igelshofer, Johann (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31157",
        "NAME": "Timpel, Franz (1545\u2013\u00a0\u00a0\u00a0\u00a0), Hofbuchhalter",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31158",
        "NAME": "Seld, Georg (1425\u20131497)",
        "DATEOFBIRTH": "1425~",
        "DATEOFDEATH": "1497",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "31159",
        "NAME": "Seld, Georg (1454\u20131527)",
        "DATEOFBIRTH": "1454",
        "DATEOFDEATH": "1527",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Augsburg"
    },
    {
        "ID": "31160",
        "NAME": "Seld, Georg Siegmund (1516\u20131565), Reichsvizekanzler",
        "DATEOFBIRTH": "1516 Jan 21",
        "DATEOFDEATH": "1565 Mai 26",
        "PLACEOFBIRTH": "Augsburg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31161",
        "NAME": "Eder von Kainbach, Adam (1545\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Stainz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31162",
        "NAME": "Eder von Kainbach, Andreas (1576\u20131652), Hofkammervizepr\u00e4sident",
        "DATEOFBIRTH": "1576",
        "DATEOFDEATH": "1652 Dez 20",
        "PLACEOFBIRTH": "Stainz",
        "PLACEOFDEATH": "Kainbach"
    },
    {
        "ID": "31163",
        "NAME": "Eder von Kainbach, Thomas (1583\u20131660), Hofzahlmeister",
        "DATEOFBIRTH": "1583",
        "DATEOFDEATH": "1660 Jul 18",
        "PLACEOFBIRTH": "Stainz",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31164",
        "NAME": "Eder von Kainbach, Paul (1585\u20131638)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1638 Mar 03",
        "PLACEOFBIRTH": "Stainz",
        "PLACEOFDEATH": "Rheinfelden im Aargau"
    },
    {
        "ID": "31165",
        "NAME": "Eder von Kainbach, Johann Adam (1618\u20131684), Hofkammerrat",
        "DATEOFBIRTH": "1618",
        "DATEOFDEATH": "1684",
        "PLACEOFBIRTH": "Stainz",
        "PLACEOFDEATH": "Kainbach"
    },
    {
        "ID": "31166",
        "NAME": "Eder von Kainbach, Leopold Ignaz (1619\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1619",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Stainz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31167",
        "NAME": "Wisendo von Wiesenburg, Johann Georg (1622\u20131666), Hofkammerkonzipist",
        "DATEOFBIRTH": "1622",
        "DATEOFDEATH": "1666",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31168",
        "NAME": "Mau\u00df, Thomas (1575\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1575~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31169",
        "NAME": "Offenburg, Jonas (1546\u20131597), Hofdiener",
        "DATEOFBIRTH": "1546",
        "DATEOFDEATH": "1597",
        "PLACEOFBIRTH": "Basel",
        "PLACEOFDEATH": "Innsbruck"
    },
    {
        "ID": "31173",
        "NAME": "Hohenwart, Adam (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gerlachstein in der Krain",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31174",
        "NAME": "Henion, Ferdinand (1530\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31176",
        "NAME": "Gr\u00fcnberg, Zacharias (1535\u20131581)",
        "DATEOFBIRTH": "1535~",
        "DATEOFDEATH": "1581 Sep 29",
        "PLACEOFBIRTH": "Gr\u00fcnberg in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31177",
        "NAME": "Gr\u00fcnberg, Abraham (1540\u20131610)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1610~",
        "PLACEOFBIRTH": "Gr\u00fcnberg in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31178",
        "NAME": "Gr\u00fcnberg, Johann Christoph (1570\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gr\u00fcnberg in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31179",
        "NAME": "Gr\u00fcnberg, Johann Wilhelm (1580\u2013\u00a0\u00a0\u00a0\u00a0), Truchsess",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gr\u00fcnberg in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31180",
        "NAME": "Gr\u00fcnberg, Elias (1545\u2013\u00a0\u00a0\u00a0\u00a0), Reichshofrat",
        "DATEOFBIRTH": "1545~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Gr\u00fcnberg in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31181",
        "NAME": "Kr\u00e4mer, Michael (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31201",
        "NAME": "Abele von Lilienberg, Christoph (1590\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31202",
        "NAME": "Abele von Lilienberg, Christoph (1627\u20131685), Hofkammerpr\u00e4sident",
        "DATEOFBIRTH": "1627 Jul 22",
        "DATEOFDEATH": "1685 Okt 12",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31203",
        "NAME": "Abele von Lilienberg, Matthias (1618\u20131677), Hofhistoriker",
        "DATEOFBIRTH": "1618 Feb 17",
        "DATEOFDEATH": "1677 Nov 14",
        "PLACEOFBIRTH": "Steyr",
        "PLACEOFDEATH": "Steyr"
    },
    {
        "ID": "31204",
        "NAME": "Abele von Lilienberg, Johann Christoph (1660\u20131728), Hofkammerrat",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "1728",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31209",
        "NAME": "Hueber, Joachim (1560\u2013\u00a0\u00a0\u00a0\u00a0), Hofzahlmeister",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31210",
        "NAME": "Haller von Hallerstein, Peter (1500\u20131563), Hofpfennigmeister",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1563",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "Wien:Stephansdom"
    },
    {
        "ID": "31221",
        "NAME": "K\u00f6ferl, Johann (1490\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1490~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Kemnath in der Oberpfalz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31222",
        "NAME": "K\u00f6ferl, Kaspar (1525\u20131585), Hofkontrolleur",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1585 Dez 21",
        "PLACEOFBIRTH": "Eschenbach in der Oberpfalz",
        "PLACEOFDEATH": "Regensburg"
    },
    {
        "ID": "31223",
        "NAME": "K\u00f6ferl, Thomas (1530\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Eschenbach in der Oberpfalz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31224",
        "NAME": "K\u00f6ferl, Johann Thomas (1565\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1565~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Eschenbach in der Oberpfalz",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31301",
        "NAME": "Scholz, Jakob (1560\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31302",
        "NAME": "Scholz, Helena (1600\u20131639)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1639",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31317",
        "NAME": "B\u00f6cklin von B\u00f6cklinsau, Wolfgang Ludwig (1600\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Stra\u00dfburg im Elsass",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31318",
        "NAME": "Diede zum F\u00fcrstenstein, Christoph Wilhelm (1590\u20131643)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1643",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31319",
        "NAME": "Diede zum F\u00fcrstenstein, Johann Eitel (1624\u20131685), Burggraf von Friedberg",
        "DATEOFBIRTH": "1624 Okt 16",
        "DATEOFDEATH": "1685 Feb 12",
        "PLACEOFBIRTH": "Wellingerode an der Sontra",
        "PLACEOFDEATH": "Friedberg in der Wetterau"
    },
    {
        "ID": "31320",
        "NAME": "Hocher von Hohenkr\u00e4hen, Johann Paul (1616\u20131683), Hofkanzler",
        "DATEOFBIRTH": "1616 Aug 12",
        "DATEOFDEATH": "1683 Feb 28",
        "PLACEOFBIRTH": "Freiburg im Breisgau",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31321",
        "NAME": "Hocher von Hohenkr\u00e4hen, Anna Franziska (1650\u20131722)",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1722 Nov 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31488",
        "NAME": "Poppendorf, Franz (1525\u20131583), Hofkriegsrat",
        "DATEOFBIRTH": "1525~",
        "DATEOFDEATH": "1583 Jun 18",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Palmburg"
    },
    {
        "ID": "31489",
        "NAME": "Graswein zum Weyer, Wilhelm (1530\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1530~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Weyer im Murtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31490",
        "NAME": "Wolzogen, Lorenz (1474\u20131524)",
        "DATEOFBIRTH": "1474",
        "DATEOFDEATH": "1524 Dez 23",
        "PLACEOFBIRTH": "Strengberg",
        "PLACEOFDEATH": "Strengberg"
    },
    {
        "ID": "31491",
        "NAME": "Wolzogen, Christian (1502\u20131570)",
        "DATEOFBIRTH": "1502",
        "DATEOFDEATH": "1570 Sep 18",
        "PLACEOFBIRTH": "Strengberg",
        "PLACEOFDEATH": "Strengberg"
    },
    {
        "ID": "31492",
        "NAME": "Wolzogen, Paul (1503\u20131575), Hofpostmeister",
        "DATEOFBIRTH": "1503 Dez 18",
        "DATEOFDEATH": "1575 Mai 28",
        "PLACEOFBIRTH": "Strengberg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31493",
        "NAME": "Wolzogen, Johann Christoph (1557\u20131620), Hofpostmeister",
        "DATEOFBIRTH": "1557 Mar 17",
        "DATEOFDEATH": "1620 Jan 26",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Gutenbrunn am Gebirge"
    },
    {
        "ID": "31494",
        "NAME": "Wolzogen, Andreas (1540\u20131600)",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1600~",
        "PLACEOFBIRTH": "Strengberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31495",
        "NAME": "Wolzogen, Michael (1554\u20131580)",
        "DATEOFBIRTH": "1554 Sep 07",
        "DATEOFDEATH": "1580~",
        "PLACEOFBIRTH": "Strengberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31496",
        "NAME": "Wolzogen, Johann Baptist (1540\u20131588), Hofpostmeister",
        "DATEOFBIRTH": "1540 Nov 10",
        "DATEOFDEATH": "1588 Mai 16",
        "PLACEOFBIRTH": "Strengberg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31497",
        "NAME": "Wolzogen, Paul (1546\u2013\u00a0\u00a0\u00a0\u00a0), Hofkammersekret\u00e4r",
        "DATEOFBIRTH": "1546 Nov 11",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Strengberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31498",
        "NAME": "Wolzogen, Regina (1609\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1609 Jul 13",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Neuhaus im Triestingtal",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31558",
        "NAME": "Steger von Ladendorf, Wolfgang Siegmund (1605\u20131658), K\u00e4mmerer",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1658",
        "PLACEOFBIRTH": "Ladendorf im Weinviertel",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31559",
        "NAME": "Fuchsmagen, Siegmund (1420\u20131485)",
        "DATEOFBIRTH": "1420~",
        "DATEOFDEATH": "1485",
        "PLACEOFBIRTH": "Hall in Tirol",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31560",
        "NAME": "Fuchsmagen, Johann (1450\u20131510)",
        "DATEOFBIRTH": "1450~",
        "DATEOFDEATH": "1510 Mai 03",
        "PLACEOFBIRTH": "Hall in Tirol",
        "PLACEOFDEATH": "Melk an der Donau"
    },
    {
        "ID": "31561",
        "NAME": "Thavonat, Jakob (1603\u20131665), Nieder\u00f6sterreichischer Regimentskanzler",
        "DATEOFBIRTH": "1603",
        "DATEOFDEATH": "1665 Jan 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31571",
        "NAME": "Arz von Vasegg, Georg Christoph (1620\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Vasio di Fondo",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31573",
        "NAME": "Churschwand, Christoph (1620\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1620~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Dietzdorf in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31574",
        "NAME": "Churschwand, Johann Heinrich (1650\u20131703), Landeshauptmann von Breslau",
        "DATEOFBIRTH": "1650~",
        "DATEOFDEATH": "1703",
        "PLACEOFBIRTH": "Dietzdorf in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31575",
        "NAME": "Churschwand, Ludwig Leopold (1660\u2013\u00a0\u00a0\u00a0\u00a0), K\u00e4mmerer",
        "DATEOFBIRTH": "1660~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Dietzdorf in Schlesien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31577",
        "NAME": "Sachs von L\u00f6wenheim, Tobias (1589\u20131667)",
        "DATEOFBIRTH": "1589",
        "DATEOFDEATH": "1667",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31578",
        "NAME": "Sachs von L\u00f6wenheim, Jesaias (1585\u2013\u00a0\u00a0\u00a0\u00a0), Hofarzt",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31579",
        "NAME": "Sachs von L\u00f6wenheim, Philipp Jakob (1627\u20131672)",
        "DATEOFBIRTH": "1627 Aug 26",
        "DATEOFDEATH": "1672 Jan 07",
        "PLACEOFBIRTH": "Breslau",
        "PLACEOFDEATH": "Breslau"
    },
    {
        "ID": "31580",
        "NAME": "Rechberger von Rechberg, Wilhelm (1580\u20131657), Hofarzt",
        "DATEOFBIRTH": "1580~",
        "DATEOFDEATH": "1657",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31581",
        "NAME": "Juncker, Johann Wilhelm (1600\u20131660), Hofarzt",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1660",
        "PLACEOFBIRTH": "Bamberg",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "31582",
        "NAME": "Lesch, Jesaias (1590\u20131650), Hofarzt",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1650",
        "PLACEOFBIRTH": "Guhrau",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31686",
        "NAME": "K\u00fcttner von Kunitz, Johann Baptist (1600\u20131667)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1667",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31689",
        "NAME": "Richtersberg, Leonhard (1600\u20131649)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1649 Nov 01",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien:Stephansdom"
    },
    {
        "ID": "31690",
        "NAME": "Ploben, Andreas (1480\u20131539)",
        "DATEOFBIRTH": "1480~",
        "DATEOFDEATH": "1539",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "Blauenthal im Erzgebirge"
    },
    {
        "ID": "31691",
        "NAME": "Ploben, Andreas (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31692",
        "NAME": "Ploben, Sebald (1540\u20131588), Hofkammerdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "1588",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "Nei\u00dfe"
    },
    {
        "ID": "31693",
        "NAME": "Lentersheim, Christoph (1507\u20131541), Hofdiener",
        "DATEOFBIRTH": "1507",
        "DATEOFDEATH": "1541",
        "PLACEOFBIRTH": "Muhr am See",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31911",
        "NAME": "Erstenberger von Freyenthurn, Katharina (1570\u20131608)",
        "DATEOFBIRTH": "1570~",
        "DATEOFDEATH": "1608",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31981",
        "NAME": "Mayer von Taudlowitz, Anna (1585\u20131627)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1627",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "31982",
        "NAME": "Arnoldin von Klarstein, Dorothea Elisabeth (1605\u20131666)",
        "DATEOFBIRTH": "1605~",
        "DATEOFDEATH": "1666 Jul 22",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32200",
        "NAME": "Nieva, Magdalena (1611\u20131662)",
        "DATEOFBIRTH": "1611",
        "DATEOFDEATH": "1662 Okt 02",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "32281",
        "NAME": "Seemann von Mangern, Johann (1360\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1360~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32282",
        "NAME": "Seemann von Mangern, Johann (1410\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1410~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32283",
        "NAME": "Seemann von Mangern, Siegmund (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32284",
        "NAME": "Seemann von Mangern, Johann Siegmund (1475\u20131520)",
        "DATEOFBIRTH": "1475~",
        "DATEOFDEATH": "1520",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32285",
        "NAME": "Seemann von Mangern, Georg (1510\u20131554)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "1554",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sankt Peter in der Au"
    },
    {
        "ID": "32286",
        "NAME": "Seemann von Mangern, Wilhelm (1552\u20131621), Hofkammerrat",
        "DATEOFBIRTH": "1552",
        "DATEOFDEATH": "1621",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sankt Peter in der Au"
    },
    {
        "ID": "32287",
        "NAME": "Seemann von Mangern, Anna Susanna (1585\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32288",
        "NAME": "Seemann von Mangern, Anna Katharina (1599\u20131624)",
        "DATEOFBIRTH": "1599",
        "DATEOFDEATH": "1624 Nov 21",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Sankt Peter in der Au"
    },
    {
        "ID": "32289",
        "NAME": "Seemann von Mangern, Georg Wilhelm (1600\u20131620)",
        "DATEOFBIRTH": "1600~",
        "DATEOFDEATH": "1620 Jul 10",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Stra\u00dfburg im Elsass"
    },
    {
        "ID": "32291",
        "NAME": "Seemann von Mangern, Georg (1400\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1400~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32292",
        "NAME": "Seemann von Mangern, Johann (1440\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1440~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32293",
        "NAME": "Seemann von Mangern, Peter (1470\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1470~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32294",
        "NAME": "Seemann von Mangern, Franz (1510\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1510~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32295",
        "NAME": "Seemann von Mangern, Gotthard (1550\u20131603)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1603",
        "PLACEOFBIRTH": "Brixen am Eisack",
        "PLACEOFDEATH": "Brixen am Eisack"
    },
    {
        "ID": "32296",
        "NAME": "Seemann von Mangern, Samuel (1555\u20131610)",
        "DATEOFBIRTH": "1555~",
        "DATEOFDEATH": "1610~",
        "PLACEOFBIRTH": "Brixen am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32297",
        "NAME": "Seemann von Mangern, Christoph Samuel (1595\u20131649)",
        "DATEOFBIRTH": "1595~",
        "DATEOFDEATH": "1649 Mar 05",
        "PLACEOFBIRTH": "Brixen am Eisack",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "32298",
        "NAME": "Seemann von Mangern, Johann Georg (1585\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Brixen am Eisack",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "32299",
        "NAME": "Seemann von Mangern, Johann Jakob (1585\u20131654)",
        "DATEOFBIRTH": "1585~",
        "DATEOFDEATH": "1654 Sep 05",
        "PLACEOFBIRTH": "Brixen am Eisack",
        "PLACEOFDEATH": "Montan in Tirol"
    },
    {
        "ID": "33720",
        "NAME": "Ventimiglia, Johann (1686\u20131748), Markgraf von Geraci",
        "DATEOFBIRTH": "1686",
        "DATEOFDEATH": "1748 Sep 01",
        "PLACEOFBIRTH": "Geraci",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "33730",
        "NAME": "Pignatelli, Anton (1700\u20131746), F\u00fcrst von Belmonte",
        "DATEOFBIRTH": "1700 Okt 27",
        "DATEOFDEATH": "1746 Okt 18",
        "PLACEOFBIRTH": "Madrid",
        "PLACEOFDEATH": "Neapel"
    },
    {
        "ID": "34370",
        "NAME": "Ladner von Ladenburg, Johann Georg (1610\u20131686), Kammerdiener",
        "DATEOFBIRTH": "1610~",
        "DATEOFDEATH": "1686 Jul 29",
        "PLACEOFBIRTH": "Ladenburg am Neckar",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "34371",
        "NAME": "Ladner von Ladenburg, Maximilian (1640\u2013\u00a0\u00a0\u00a0\u00a0)",
        "DATEOFBIRTH": "1640~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "34389",
        "NAME": "Birckel, Georg (1550\u20131622)",
        "DATEOFBIRTH": "1550~",
        "DATEOFDEATH": "1622",
        "PLACEOFBIRTH": "R\u00f6tz im Wald",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "34390",
        "NAME": "Haiden, Sebald (1499\u20131561)",
        "DATEOFBIRTH": "1499 Dez 08",
        "DATEOFDEATH": "1561 Jul 09",
        "PLACEOFBIRTH": "Bruck an der Regnitz",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "34391",
        "NAME": "Haiden, Christian (1526\u20131576)",
        "DATEOFBIRTH": "1526 Mai 02",
        "DATEOFDEATH": "1576 Feb 09",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "N\u00fcrnberg"
    },
    {
        "ID": "34392",
        "NAME": "Haiden, Johann Paul (1560\u20131610), Kammerdiener",
        "DATEOFBIRTH": "1560~",
        "DATEOFDEATH": "1610",
        "PLACEOFBIRTH": "N\u00fcrnberg",
        "PLACEOFDEATH": "Prag"
    },
    {
        "ID": "34577",
        "NAME": "Amerighi, Stenzel (1674\u20131731), Edelknabe",
        "DATEOFBIRTH": "1674",
        "DATEOFDEATH": "1731 Sep 17",
        "PLACEOFBIRTH": "Siena",
        "PLACEOFDEATH": "Lucera"
    },
    {
        "ID": "34578",
        "NAME": "Bosso, Maximilian (1590\u20131640), Kammerdiener",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1640 Apr 19",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Wien"
    },
    {
        "ID": "34579",
        "NAME": "Papazzoni, Johann Bonaventura (1590\u20131642), Kammerdiener",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1642",
        "PLACEOFBIRTH": "Mirandola",
        "PLACEOFDEATH": "Slawietin an der Eger"
    },
    {
        "ID": "34676",
        "NAME": "Hirsch, Andreas (1500\u20131567)",
        "DATEOFBIRTH": "1500~",
        "DATEOFDEATH": "1567 Mar 03",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "34677",
        "NAME": "Hirsch, Andreas (1540\u2013\u00a0\u00a0\u00a0\u00a0), Hofdiener",
        "DATEOFBIRTH": "1540~",
        "DATEOFDEATH": "",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "34678",
        "NAME": "Hirsch, Kaspar (1538\u20131612)",
        "DATEOFBIRTH": "1538 Jan 05",
        "DATEOFDEATH": "1612",
        "PLACEOFBIRTH": "Wien",
        "PLACEOFDEATH": "Eferding"
    },
    {
        "ID": "34679",
        "NAME": "Hirsch, Siegfried (1602\u20131652), Kammerdiener",
        "DATEOFBIRTH": "1602 Jul 07",
        "DATEOFDEATH": "1652",
        "PLACEOFBIRTH": "Eferding",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "34981",
        "NAME": "Hartmann von Hartenfels, Theodor (1590\u20131662)",
        "DATEOFBIRTH": "1590~",
        "DATEOFDEATH": "1662 Nov 27",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": "Schlan"
    },
    {
        "ID": "34982",
        "NAME": "Hartmann von Hartenfels, Franz Christoph (1628\u20131665)",
        "DATEOFBIRTH": "1628 Aug 16",
        "DATEOFDEATH": "1665 Dez 31",
        "PLACEOFBIRTH": "",
        "PLACEOFDEATH": ""
    },
    {
        "ID": "34983",
        "NAME": "Hartmann von Hartenfels, Franz Maximilian (1662\u20131725), K\u00e4mmerer",
        "DATEOFBIRTH": "1662 Apr 15",
        "DATEOFDEATH": "1725 Aug 10",
        "PLACEOFBIRTH": "Prag",
        "PLACEOFDEATH": ""
    }
    ]
